import React, { PureComponent, Component, createElement, Suspense as Suspense$1, lazy, createRef } from 'react';
import require$$0 from 'crypto';
import _reactDom from 'react-dom';
import DixaIcon from '@dixa/dixa-modern-icons';
import { noop as noop$1, isEmpty, isString as isString$1, omit, isEqual, uniqueId, isElement as isElement$3 } from 'lodash';
import padStart from 'lodash/padStart';
import moment$1 from 'moment-timezone';
import _propTypes from 'prop-types';
import require$$7 from 'lodash/throttle';
import uuid from 'uuid/v4';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import juiceClient from 'juice/client';
import sanitizeHtml from 'sanitize-html';
import escapeRegExp from 'lodash/escapeRegExp';
import { Link } from 'react-router';

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var interopRequireDefault = _interopRequireDefault;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (target) {
	throw new Error('Could not dynamically require "' + target + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$2 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$2.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$3 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$3.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice$1.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice$1.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice$1.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = commonjsGlobal.Symbol;


var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined$1;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$2 = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
var generatorFunction =  undefined$1;
var asyncFunction =  undefined$1;
var asyncGenFunction =  undefined$1;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%':  undefined$1,
	'%AsyncGenerator%':  undefined$1,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%':  undefined$1,
	'%AsyncIteratorPrototype%':  undefined$1,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined$1 : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%':  undefined$1,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%':  undefined$1,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined$1 : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined$1 : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined$1 : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined$1 : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined$1 : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined$1 : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
	'%SymbolPrototype%': hasSymbols$2 ? Symbol.prototype : undefined$1,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined$1,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet.prototype
};


var $replace = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

var GetIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

var callBind = function callBind() {
	return functionBind.apply($call, arguments);
};

var apply = function applyBind() {
	return functionBind.apply($apply, arguments);
};
callBind.apply = apply;

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}
});

var inherits = createCommonjsModule(function (module) {
try {
  var util$1 = util;
  if (typeof util$1.inherits !== 'function') throw '';
  module.exports = util$1.inherits;
} catch (e) {
  module.exports = inherits_browser;
}
});

var util = createCommonjsModule(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function(prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = inherits;

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
};

exports.promisify.custom = kCustomPromisifiedSymbol;

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret); },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb); });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;
});

var util_inspect = util.inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' ? Symbol.prototype.toString : null;
var isEnumerable$1 = Object.prototype.propertyIsEnumerable;

var inspectCustom = util_inspect.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean') {
        throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = symToString.call(obj);
        return typeof obj === 'object' ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        if (ys.length === 0) { return '{}'; }
        if (indent) {
            return '{' + indentedJoin(ys, indent) + '}';
        }
        return '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr$4(obj) === '[object Array]'; }
function isDate(obj) { return toStr$4(obj) === '[object Date]'; }
function isRegExp(obj) { return toStr$4(obj) === '[object RegExp]'; }
function isError(obj) { return toStr$4(obj) === '[object Error]'; }
function isSymbol(obj) { return toStr$4(obj) === '[object Symbol]'; }
function isString(obj) { return toStr$4(obj) === '[object String]'; }
function isNumber(obj) { return toStr$4(obj) === '[object Number]'; }
function isBigInt(obj) { return toStr$4(obj) === '[object BigInt]'; }
function isBoolean(obj) { return toStr$4(obj) === '[object Boolean]'; }

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$4(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        var syms = gOPS(obj);
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable$1.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://www.ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

// https://www.ecma-international.org/ecma-262/5.1/#sec-8

var Type = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-tostring

var Type$1 = function Type$1(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	return Type(x);
};

var $TypeError$1 = GetIntrinsic('%TypeError%');






/**
 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
 * 1. Assert: Type(O) is Object.
 * 2. Assert: IsPropertyKey(P) is true.
 * 3. Return O.[[Get]](P, O).
 */

var Get = function Get(O, P) {
	// 7.3.1.1
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$1('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$1('Assertion failed: IsPropertyKey(P) is not true, got ' + objectInspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$5 = !$Array.isArray && callBound('Object.prototype.toString');

// https://www.ecma-international.org/ecma-262/6.0/#sec-isarray

var IsArray = $Array.isArray || function IsArray(argument) {
	return toStr$5(argument) === '[object Array]';
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-isconstructor

var IsConstructor = function IsConstructor(argument) {
	return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };

var $Math = GetIntrinsic('%Math%');

var $floor = $Math.floor;
var $abs = $Math.abs;




// https://www.ecma-international.org/ecma-262/6.0/#sec-isinteger

var IsInteger = function IsInteger(argument) {
	if (typeof argument !== 'number' || _isNaN(argument) || !_isFinite(argument)) {
		return false;
	}
	var abs = $abs(argument);
	return $floor(abs) === abs;
};

var $Array$1 = GetIntrinsic('%Array%');
var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError$2 = GetIntrinsic('%TypeError%');







// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate

var ArraySpeciesCreate = function ArraySpeciesCreate(originalArray, length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError$2('Assertion failed: length must be an integer >= 0');
	}
	var len = length === 0 ? 0 : length;
	var C;
	var isArray = IsArray(originalArray);
	if (isArray) {
		C = Get(originalArray, 'constructor');
		// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
		// if (IsConstructor(C)) {
		// 	if C is another realm's Array, C = undefined
		// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
		// }
		if ($species && Type$1(C) === 'Object') {
			C = Get(C, $species);
			if (C === null) {
				C = void 0;
			}
		}
	}
	if (typeof C === 'undefined') {
		return $Array$1(len);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$2('C must be a constructor');
	}
	return new C(len); // Construct(C, len);
};

var $Math$1 = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

var maxSafeInteger = $Number.MAX_SAFE_INTEGER || $Math$1.pow(2, 53) - 1;

var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$6 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isCallable = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr$6.call(value);
	return strClass === fnClass || strClass === genClass;
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.11

var IsCallable = isCallable;

var $TypeError$3 = GetIntrinsic('%TypeError%');





// https://www.ecma-international.org/ecma-262/6.0/#sec-call

var Call = function Call(F, V) {
	var args = arguments.length > 2 ? arguments[2] : [];
	if (!IsCallable(F)) {
		throw new $TypeError$3(objectInspect(F) + ' is not a function');
	}
	return F.apply(V, args);
};

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var $TypeError$4 = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');



var predicates = {
	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$4('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

var assertRecord = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError$4(argumentName + ' must be a ' + recordType);
	}
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};

var $gOPD$1 = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var getOwnPropertyDescriptor = $gOPD$1;

var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr$7 = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag$1 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isRegex = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag$1) {
		return toStr$7.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && src(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.2

var ToBoolean = function ToBoolean(value) { return !!value; };

var $match = GetIntrinsic('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $TypeError$5 = GetIntrinsic('%TypeError%');





// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5

var ToPropertyDescriptor = function ToPropertyDescriptor(Obj) {
	if (Type$1(Obj) !== 'Object') {
		throw new $TypeError$5('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$5('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$5('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var $TypeError$6 = GetIntrinsic('%TypeError%');



var $isEnumerable$1 = callBound('Object.prototype.propertyIsEnumerable');









// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty = function OrdinaryGetOwnProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$6('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$6('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!getOwnPropertyDescriptor) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable$1(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor(getOwnPropertyDescriptor(O, P));
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var $Object = GetIntrinsic('%Object%');



var $preventExtensions = $Object.preventExtensions;
var $isExtensible = $Object.isExtensible;

// https://www.ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.12

var SameValue = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return _isNaN(x) && _isNaN(y);
};

var $TypeError$7 = GetIntrinsic('%TypeError%');











// https://www.ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty = function CreateDataProperty(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$7('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$7('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var immutable = oldDesc && (!oldDesc['[[Writable]]'] || !oldDesc['[[Configurable]]']);
	if (immutable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var $TypeError$8 = GetIntrinsic('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$8('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$8('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$8('unable to create data property');
	}
	return success;
};

var $TypeError$9 = GetIntrinsic('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty = function HasProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$9('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$9('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.3

var ToNumber = function ToNumber(value) {
	return +value; // eslint-disable-line no-implicit-coercion
};

var sign = function sign(number) {
	return number >= 0 ? 1 : -1;
};

var $Math$2 = GetIntrinsic('%Math%');






var $floor$1 = $Math$2.floor;
var $abs$1 = $Math$2.abs;

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.4

var ToInteger = function ToInteger(value) {
	var number = ToNumber(value);
	if (_isNaN(number)) { return 0; }
	if (number === 0 || !_isFinite(number)) { return number; }
	return sign(number) * $floor$1($abs$1(number));
};

var $test = GetIntrinsic('RegExp.prototype.test');



var regexTester = function regexTester(regex) {
	return callBind($test, regex);
};

var isPrimitive$1 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$8 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$2 ? tryDateObject(value) : toStr$8.call(value) === dateClass;
};

var isSymbol$1 = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols = hasSymbols$1();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive$1(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive$1(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols$3) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol$1(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive$1(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol$1(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var $TypeError$a = GetIntrinsic('%TypeError%');
var $Number$1 = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');





var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace$1 = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace$1(value, trimRegex, '');
};



// https://www.ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber$1 = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number$1);
	if (typeof value === 'symbol') {
		throw new $TypeError$a('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		} else {
			var trimmed = $trim(value);
			if (trimmed !== value) {
				return ToNumber(trimmed);
			}
		}
	}
	return $Number$1(value);
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-tointeger

var ToInteger$1 = function ToInteger$1(value) {
	var number = ToNumber$1(value);
	return ToInteger(number);
};

var ToLength = function ToLength(argument) {
	var len = ToInteger$1(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > maxSafeInteger) { return maxSafeInteger; }
	return len;
};

var $String = GetIntrinsic('%String%');
var $TypeError$b = GetIntrinsic('%TypeError%');

// https://www.ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$b('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var $TypeError$c = GetIntrinsic('%TypeError%');











// https://ecma-international.org/ecma-262/10.0/#sec-flattenintoarray

// eslint-disable-next-line max-params, max-statements
var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError$c('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = ToLength(Get(element, 'length'));
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= maxSafeInteger) {
					throw new $TypeError$c('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

var $TypeError$d = GetIntrinsic('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$d(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible = CheckObjectCoercible;

var $Object$1 = GetIntrinsic('%Object%');



// https://www.ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object$1(value);
};

var implementation$2 = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToInteger$1(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill = function getPolyfill() {
	return Array.prototype.flat || implementation$2;
};

var shim = function shimFlat() {
	var polyfill$1 = polyfill();
	defineProperties_1(
		Array.prototype,
		{ flat: polyfill$1 },
		{ flat: function () { return Array.prototype.flat !== polyfill$1; } }
	);
	return polyfill$1;
};

var polyfill$1 = polyfill();


var boundFlat = callBind(polyfill$1);

defineProperties_1(boundFlat, {
	getPolyfill: polyfill,
	implementation: implementation$2,
	shim: shim
});

var array_prototype_flat = boundFlat;

var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties
if (typeof Symbol === 'function' && isSymbol$1(Symbol('foo')) && typeof Symbol['for'] === 'function') {
	// eslint-disable-next-line no-restricted-properties
	globalKey = Symbol['for'](globalKey);
}

var trueThunk = function () {
	return true;
};

var ensureCache = function ensureCache() {
	if (!commonjsGlobal[globalKey]) {
		var properties = {};
		properties[globalKey] = {};
		var predicates = {};
		predicates[globalKey] = trueThunk;
		defineProperties_1(commonjsGlobal, properties, predicates);
	}
	return commonjsGlobal[globalKey];
};

var cache = ensureCache();

var isPrimitive$2 = function isPrimitive(val) {
	return val === null || (typeof val !== 'object' && typeof val !== 'function');
};

var getPrimitiveKey = function getPrimitiveKey(val) {
	if (isSymbol$1(val)) {
		return Symbol.prototype.valueOf.call(val);
	}
	return typeof val + ' | ' + String(val);
};

var requirePrimitiveKey = function requirePrimitiveKey(val) {
	if (!isPrimitive$2(val)) {
		throw new TypeError('key must not be an object');
	}
};

var globalCache = {
	clear: function clear() {
		delete commonjsGlobal[globalKey];
		cache = ensureCache();
	},

	'delete': function deleteKey(key) {
		requirePrimitiveKey(key);
		delete cache[getPrimitiveKey(key)];
		return !globalCache.has(key);
	},

	get: function get(key) {
		requirePrimitiveKey(key);
		return cache[getPrimitiveKey(key)];
	},

	has: function has(key) {
		requirePrimitiveKey(key);
		return getPrimitiveKey(key) in cache;
	},

	set: function set(key, value) {
		requirePrimitiveKey(key);
		var primitiveKey = getPrimitiveKey(key);
		var props = {};
		props[primitiveKey] = value;
		var predicates = {};
		predicates[primitiveKey] = trueThunk;
		defineProperties_1(cache, props, predicates);
		return globalCache.has(key);
	},

	setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
		if (globalCache.has(key)) {
			return globalCache.get(key);
		}
		var item = valueThunk();
		globalCache.set(key, item);
		return item;
	}
};

var globalCache_1 = globalCache;

var constants = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_SPECIFICITY = exports.GLOBAL_CACHE_KEY = void 0;
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
var MAX_SPECIFICITY = 20;
exports.MAX_SPECIFICITY = MAX_SPECIFICITY;
});

var getClassName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getClassName;

/**
 * Construct a class name.
 *
 * namespace {String} Used to construct unique class names.
 * styleName {String} Name identifying the specific style.
 *
 * Return the class name.
 */
function getClassName(namespace, styleName) {
  var namespaceSegment = namespace.length > 0 ? "".concat(namespace, "__") : '';
  return "".concat(namespaceSegment).concat(styleName);
}
});

var separateStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// This function takes an array of styles and separates them into styles that
// are handled by Aphrodite and inline styles.
function separateStyles(stylesArray) {
  var classNames = []; // Since determining if an Object is empty requires collecting all of its
  // keys, and we want the best performance in this code because we are in the
  // render path, we are going to do a little bookkeeping ourselves.

  var hasInlineStyles = false;
  var inlineStyles = {}; // This is run on potentially every node in the tree when rendering, where
  // performance is critical. Normally we would prefer using `forEach`, but
  // old-fashioned for loops are faster so that's what we have chosen here.

  for (var i = 0; i < stylesArray.length; i++) {
    // eslint-disable-line no-plusplus
    var style = stylesArray[i]; // If this  style is falsy, we just want to disregard it. This allows for
    // syntax like:
    //
    //   css(isFoo && styles.foo)

    if (style) {
      if (typeof style === 'string') {
        classNames.push(style);
      } else {
        Object.assign(inlineStyles, style);
        hasInlineStyles = true;
      }
    }
  }

  return {
    classNames: classNames,
    hasInlineStyles: hasInlineStyles,
    inlineStyles: inlineStyles
  };
}

var _default = separateStyles;
exports["default"] = _default;
});

var dist = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = interopRequireDefault(array_prototype_flat);

var _globalCache = interopRequireDefault(globalCache_1);



var _getClassName = interopRequireDefault(getClassName_1);

var _separateStyles2 = interopRequireDefault(separateStyles_1);

/**
 * Function required as part of the react-with-styles interface. Parses the styles provided by
 * react-with-styles to produce class names based on the style name and optionally the namespace if
 * available.
 *
 * stylesObject {Object} The styles object passed to withStyles.
 *
 * Return an object mapping style names to class names.
 */
function create(stylesObject) {
  var stylesToClasses = {};
  var styleNames = Object.keys(stylesObject);
  var sharedState = _globalCache["default"].get(constants.GLOBAL_CACHE_KEY) || {};
  var _sharedState$namespac = sharedState.namespace,
      namespace = _sharedState$namespac === void 0 ? '' : _sharedState$namespac;
  styleNames.forEach(function (styleName) {
    var className = (0, _getClassName["default"])(namespace, styleName);
    stylesToClasses[styleName] = className;
  });
  return stylesToClasses;
}
/**
 * Process styles to be consumed by a component.
 *
 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
 * representing inline styles, or arrays thereof.
 *
 * Return an object with optional className and style properties to be spread on a component.
 */


function resolve(stylesArray) {
  var flattenedStyles = (0, _arrayPrototype["default"])(stylesArray, Infinity);

  var _separateStyles = (0, _separateStyles2["default"])(flattenedStyles),
      classNames = _separateStyles.classNames,
      hasInlineStyles = _separateStyles.hasInlineStyles,
      inlineStyles = _separateStyles.inlineStyles;

  var specificClassNames = classNames.map(function (name, index) {
    return "".concat(name, " ").concat(name, "_").concat(index + 1);
  });
  var className = specificClassNames.join(' ');
  var result = {
    className: className
  };
  if (hasInlineStyles) result.style = inlineStyles;
  return result;
}

var _default = {
  create: create,
  resolve: resolve
};
exports["default"] = _default;
});

// eslint-disable-next-line import/no-unresolved
var reactWithStylesInterfaceCss = dist.default;

var ThemedStyleSheet = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._getInterface = _getInterface;
exports._getTheme = get;
exports["default"] = void 0;
var styleInterface;
var styleTheme;
var START_MARK = 'react-with-styles.resolve.start';
var END_MARK = 'react-with-styles.resolve.end';
var MEASURE_MARK = "\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]";

function registerTheme(theme) {
  styleTheme = theme;
}

function registerInterface(interfaceToRegister) {
  styleInterface = interfaceToRegister;
}

function create(makeFromTheme, createWithDirection) {
  var styles = createWithDirection(makeFromTheme(styleTheme));
  return function () {
    return styles;
  };
}

function createLTR(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
}

function createRTL(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
}

function get() {
  return styleTheme;
}

function resolve() {
  if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(START_MARK);
    performance.mark(START_MARK);
  }

  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var result = styleInterface.resolve(styles);

  if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(END_MARK);
    performance.mark(END_MARK);
    performance.measure(MEASURE_MARK, START_MARK, END_MARK);
    performance.clearMarks(MEASURE_MARK);
  }

  return result;
}

function resolveLTR() {
  for (var _len2 = arguments.length, styles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  if (styleInterface.resolveLTR) {
    return styleInterface.resolveLTR(styles);
  }

  return resolve(styles);
}

function resolveRTL() {
  for (var _len3 = arguments.length, styles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    styles[_key3] = arguments[_key3];
  }

  if (styleInterface.resolveRTL) {
    return styleInterface.resolveRTL(styles);
  }

  return resolve(styles);
}

function flush() {
  if (styleInterface.flush) {
    styleInterface.flush();
  }
} // Exported until we deprecate this API completely
// eslint-disable-next-line no-underscore-dangle


function _getInterface() {
  return styleInterface;
} // Exported until we deprecate this API completely


var _default = {
  registerTheme: registerTheme,
  registerInterface: registerInterface,
  create: createLTR,
  createLTR: createLTR,
  createRTL: createRTL,
  get: get,
  resolve: resolveLTR,
  resolveLTR: resolveLTR,
  resolveRTL: resolveRTL,
  flush: flush
};
exports["default"] = _default;
});

var DefaultTheme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var core = {
  white: '#fff',
  gray: '#484848',
  grayLight: '#82888a',
  grayLighter: '#cacccd',
  grayLightest: '#f2f2f2',
  borderMedium: '#c4c4c4',
  border: '#dbdbdb',
  borderLight: '#e4e7e7',
  borderLighter: '#eceeee',
  borderBright: '#f4f5f5',
  primary: '#00a699',
  primaryShade_1: '#33dacd',
  primaryShade_2: '#66e2da',
  primaryShade_3: '#80e8e0',
  primaryShade_4: '#b2f1ec',
  primary_dark: '#008489',
  secondary: '#007a87',
  yellow: '#ffe8bc',
  yellow_dark: '#ffce71'
};
var _default = {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: '2px solid transparent',
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: "2px solid ".concat(core.primary_dark),
        borderRightFocused: 0,
        borderRadius: 0
      },
      pickerInput: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2
      }
    },
    color: {
      core: core,
      disabled: core.grayLightest,
      background: core.white,
      backgroundDark: '#f2f2f2',
      backgroundFocused: core.white,
      border: 'rgb(219, 219, 219)',
      text: core.gray,
      textDisabled: core.border,
      textFocused: '#007a87',
      placeholderText: '#757575',
      outside: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      highlighted: {
        backgroundColor: core.yellow,
        backgroundColor_active: core.yellow_dark,
        backgroundColor_hover: core.yellow_dark,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      minimumNights: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLighter,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },
      hoveredSpan: {
        backgroundColor: core.primaryShade_4,
        backgroundColor_active: core.primaryShade_3,
        backgroundColor_hover: core.primaryShade_4,
        borderColor: core.primaryShade_3,
        borderColor_active: core.primaryShade_3,
        borderColor_hover: core.primaryShade_3,
        color: core.secondary,
        color_active: core.secondary,
        color_hover: core.secondary
      },
      selectedSpan: {
        backgroundColor: core.primaryShade_2,
        backgroundColor_active: core.primaryShade_1,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primaryShade_1,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      selected: {
        backgroundColor: core.primary,
        backgroundColor_active: core.primary,
        backgroundColor_hover: core.primary,
        borderColor: core.primary,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      blocked_calendar: {
        backgroundColor: core.grayLighter,
        backgroundColor_active: core.grayLighter,
        backgroundColor_hover: core.grayLighter,
        borderColor: core.grayLighter,
        borderColor_active: core.grayLighter,
        borderColor_hover: core.grayLighter,
        color: core.grayLight,
        color_active: core.grayLight,
        color_hover: core.grayLight
      },
      blocked_out_of_range: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      }
    },
    spacing: {
      dayPickerHorizontalPadding: 9,
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      displayTextPaddingVertical: undefined,
      displayTextPaddingTop: 11,
      displayTextPaddingBottom: 9,
      displayTextPaddingHorizontal: undefined,
      displayTextPaddingLeft: 11,
      displayTextPaddingRight: 11,
      displayTextPaddingVertical_small: undefined,
      displayTextPaddingTop_small: 7,
      displayTextPaddingBottom_small: 5,
      displayTextPaddingHorizontal_small: undefined,
      displayTextPaddingLeft_small: 7,
      displayTextPaddingRight_small: 7
    },
    sizing: {
      inputWidth: 130,
      inputWidth_small: 97,
      arrowWidth: 24
    },
    noScrollBarOnVerticalScrollable: false,
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 19,
        weight: 200,
        lineHeight: '24px',
        size_small: 15,
        lineHeight_small: '18px',
        letterSpacing_small: '0.2px',
        styleDisabled: 'italic'
      }
    }
  }
};
exports["default"] = _default;
});

var registerInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerInterfaceWithDefaultTheme;

var _ThemedStyleSheet = interopRequireDefault(ThemedStyleSheet);

var _DefaultTheme = interopRequireDefault(DefaultTheme);

function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
}
});

var registerCSSInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerCSSInterfaceWithDefaultTheme;

var _reactWithStylesInterfaceCss = interopRequireDefault(reactWithStylesInterfaceCss);

var _registerInterfaceWithDefaultTheme = interopRequireDefault(registerInterfaceWithDefaultTheme_1);

function registerCSSInterfaceWithDefaultTheme() {
  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
}
});

var _registerCSSInterfaceWithDefaultTheme = interopRequireDefault(registerCSSInterfaceWithDefaultTheme_1);

(0, _registerCSSInterfaceWithDefaultTheme["default"])();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".icon-vertical-fix {\n  display: inline-flex;\n  align-items: center;\n  line-height: inherit; }\n  .icon-vertical-fix::before {\n    line-height: inherit !important; }\n\n.icon-vertical-fix-block {\n  display: flex;\n  align-items: center;\n  line-height: inherit; }\n  .icon-vertical-fix-block::before {\n    line-height: inherit !important; }\n";
styleInject(css_248z);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var css_248z$1 = "@-webkit-keyframes address--address__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes address--address__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes address--address__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes address--address__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.address--address__address {\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #5644d8;\n  position: relative;\n  outline: none; }\n";
var styles = {"address":"address--address__address","wiggle":"address--address__wiggle","spin":"address--address__spin"};
styleInject(css_248z$1);

var Address =
/** @class */
function (_super) {
  __extends(Address, _super);

  function Address() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Address.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        onClick = _b.onClick,
        children = _b.children,
        tip = _b.tip,
        otherProps = __rest(_b, ["className", "onClick", "children", "tip"]);

    var rootClass = classnames((_a = {}, _a[styles.address] = true, _a), className);
    return /*#__PURE__*/React.createElement("button", __assign({
      title: tip,
      type: "button"
    }, otherProps, {
      className: rootClass,
      onClick: onClick
    }), children);
  };

  return Address;
}(PureComponent);

var defaultValue = {
  onError: function onError(error, errorInfo) {
    console.error(error, errorInfo);
  }
};
var ErrorBoundaryContext = /*#__PURE__*/React.createContext(defaultValue);

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement$1,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var initialState = {
  error: null
};

var ErrorBoundary =
/** @class */
function (_super) {
  __extends(ErrorBoundary, _super);

  function ErrorBoundary(props) {
    var _this = _super.call(this, props) || this;

    _this.state = initialState;
    _this.resetErrorBoundary = _this.resetErrorBoundary.bind(_this);
    _this.resetInternally = _this.resetInternally.bind(_this);
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function (error) {
    return {
      error: error
    };
  };

  ErrorBoundary.prototype.componentDidCatch = function (error, info) {
    var _a, _b, _c, _d;

    (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, info);
    (_d = (_c = this.context) === null || _c === void 0 ? void 0 : _c.onError) === null || _d === void 0 ? void 0 : _d.call(_c, error, info);
  };

  ErrorBoundary.prototype.resetErrorBoundary = function () {
    var _a, _b;

    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    (_b = (_a = this.props).onReset) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArrays([_a], args));
    this.resetInternally();
  };

  ErrorBoundary.prototype.resetInternally = function () {
    this.setState(initialState);
  };

  ErrorBoundary.prototype.hasError = function (error) {
    return error !== null;
  };

  ErrorBoundary.prototype.ensureErrorHandlerExists = function () {
    var _a = this.props,
        fallback = _a.fallback,
        fallbackRender = _a.fallbackRender;
    var hasFallbackElement = this.hasFallbackElement(fallback);
    var hasFallbackRenderer = this.hasFallbackRenderer(fallbackRender);

    if (!hasFallbackElement && !hasFallbackRenderer) {
      throw new Error(ErrorBoundary.name + " requires either a fallback component or a fallback renderer");
    }
  };

  ErrorBoundary.prototype.hasFallbackRenderer = function (fallbackRender) {
    return typeof fallbackRender === 'function';
  };

  ErrorBoundary.prototype.hasFallbackElement = function (fallback) {
    return fallback === null || typeof fallback === 'string' || /*#__PURE__*/React.isValidElement(fallback);
  };

  ErrorBoundary.prototype.render = function () {
    var error = this.state.error;
    var _a = this.props,
        fallbackRender = _a.fallbackRender,
        fallback = _a.fallback; // disallow usage of this component without any fallback
    // even when typescript is explicitly disabled and type safety is lost

    this.ensureErrorHandlerExists();

    if (!this.hasError(error)) {
      return this.props.children;
    } else {
      if (this.hasFallbackElement(fallback)) {
        return fallback;
      }

      if (this.hasFallbackRenderer(fallbackRender)) {
        return fallbackRender({
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        });
      }
    }
  };

  ErrorBoundary.contextType = ErrorBoundaryContext;
  return ErrorBoundary;
}(React.Component);
/**
 *
 * @param Component make sure this component doesn't have a typed defaultProps (let it be inferred)
 */

function withErrorBoundary(Component, errorBoundaryProps) {
  var _a;

  var name = Component.displayName || Component.name || 'Unknown'; // Hoist all the non-react static properties (exp: static defaultProps) on the component to the wrapper-level,
  // so that the wrapper component is exactly like the wrapped component from outside POV

  return hoistNonReactStatics_cjs((_a =
  /** @class */
  function (_super) {
    __extends(Wrapped, _super);

    function Wrapped() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    Wrapped.prototype.render = function () {
      var Cmp = Component;
      return /*#__PURE__*/React.createElement(ErrorBoundary, __assign({}, errorBoundaryProps), /*#__PURE__*/React.createElement(Cmp, __assign({}, this.props)));
    };

    return Wrapped;
  }(React.Component), _a.displayName = "withErrorBoundary(" + name + ")", _a.defaultProps = Component.defaultProps, _a), Component);
}

var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n<symbol id=\"icon-angle-double-left-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.88 4.825a.5.5 0 00-.76-.65l-3 3.5a.5.5 0 000 .65l3 3.5a.5.5 0 00.76-.65L5.159 8l2.72-3.175zm4 0a.5.5 0 10-.76-.65l-3 3.5a.5.5 0 000 .65l3 3.5a.5.5 0 00.76-.65L9.159 8l2.72-3.175z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-double-right-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.12 11.175a.5.5 0 10.76.65l3-3.5a.5.5 0 000-.65l-3-3.5a.5.5 0 00-.76.65L6.841 8l-2.72 3.175zm4 0a.5.5 0 10.76.65l3-3.5a.5.5 0 000-.65l-3-3.5a.5.5 0 00-.76.65L10.842 8 8.12 11.175z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-down-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.12 6.175a.5.5 0 01.705-.055L8 8.841l3.175-2.72a.5.5 0 11.65.759l-3.5 3a.5.5 0 01-.65 0l-3.5-3a.5.5 0 01-.055-.705z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-left-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M9.825 4.12a.5.5 0 01.055.705L7.159 8l2.72 3.175a.5.5 0 11-.759.65l-3-3.5a.5.5 0 010-.65l3-3.5a.5.5 0 01.705-.055z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-right-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.175 11.88a.5.5 0 01-.055-.705L8.841 8l-2.72-3.175a.5.5 0 01.759-.65l3 3.5a.5.5 0 010 .65l-3 3.5a.5.5 0 01-.705.055z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-up-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11.88 9.825a.5.5 0 01-.705.055L8 7.159l-3.175 2.72a.5.5 0 01-.65-.759l3.5-3a.5.5 0 01.65 0l3.5 3a.5.5 0 01.055.705z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-down-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8.5 1.5a.5.5 0 00-1 0v11.715L2.869 8.162a.5.5 0 10-.738.676l5.5 5.998a.498.498 0 00.36.163L8 15h.01a.498.498 0 00.359-.162l5.5-6a.5.5 0 00-.738-.676L8.5 13.215V1.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-left-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.838 2.869a.5.5 0 00-.676-.738l-6 5.5a.5.5 0 000 .738l6 5.5a.5.5 0 00.676-.738L2.785 8.5H14.5a.5.5 0 000-1H2.785l5.053-4.631z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-right-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8.162 13.131a.5.5 0 00.676.738l6-5.5a.5.5 0 000-.738l-6-5.5a.5.5 0 10-.676.738L13.215 7.5H1a.5.5 0 100 1h12.215l-5.053 4.631z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-down-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zM2.5 2a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-11zm9.38 6.175a.5.5 0 01-.055.705l-3.5 3a.5.5 0 01-.65 0l-3.5-3a.5.5 0 01.65-.76L7.5 10.413V4.5a.5.5 0 011 0v5.913l2.675-2.293a.5.5 0 01.705.055z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-left-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zM2.5 2a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-11zm5.325 9.88a.5.5 0 01-.705-.055l-3-3.5a.5.5 0 010-.65l3-3.5a.5.5 0 11.76.65L5.587 7.5H11.5a.5.5 0 010 1H5.587l2.293 2.675a.5.5 0 01-.055.705z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-right-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zM2.5 2a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-11zm5.675 2.12a.5.5 0 01.705.055l3 3.5a.5.5 0 010 .65l-3 3.5a.5.5 0 11-.76-.65L10.413 8.5H4.5a.5.5 0 010-1h5.913L8.12 4.825a.5.5 0 01.055-.705z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-up-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zM2.5 2a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-11zm1.62 5.825a.5.5 0 01.055-.705l3.5-3a.5.5 0 01.65 0l3.5 3a.5.5 0 11-.65.76L8.5 5.587V11.5a.5.5 0 01-1 0V5.587L4.825 7.88a.5.5 0 01-.705-.055z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-up-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13.131 7.838a.5.5 0 00.738-.676l-5.5-6a.502.502 0 00-.74.002L2.132 7.162a.5.5 0 10.738.676L7.5 2.785V14.5a.5.5 0 001 0V2.785l4.631 5.053z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrows-h-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M16 8a.5.5 0 01-.18.384l-3 2.5a.5.5 0 01-.64-.768L14.119 8.5H1.881l1.94 1.616a.5.5 0 11-.641.768l-3-2.5a.5.5 0 010-.768l3-2.5a.5.5 0 11.64.768L1.881 7.5h12.238l-1.94-1.616a.5.5 0 01.641-.768l3 2.5A.5.5 0 0116 8z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-arrows-v-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 0a.5.5 0 01.384.18l2.5 3a.5.5 0 01-.768.64L8.5 1.881v12.238l1.616-1.94a.5.5 0 01.768.641l-2.5 3a.5.5 0 01-.768 0l-2.5-3a.5.5 0 01.768-.64L7.5 14.119V1.881l-1.616 1.94a.5.5 0 11-.768-.641l2.5-3A.5.5 0 018 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-compress-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15.854.146a.5.5 0 010 .708L10.707 6H14.5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.793L15.146.146a.5.5 0 01.708 0zM1 9.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-3.793L.854 15.854a.5.5 0 01-.708-.707L5.293 10H1.5a.5.5 0 01-.5-.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-exchange-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M4.825 7.88a.5.5 0 01-.705-.055L1.123 4.328l-.003-.003a.499.499 0 01.001-.651l3-3.5a.5.5 0 01.759.651L2.587 3.5H14.5a.5.5 0 010 1H2.587L4.88 7.175a.5.5 0 01-.055.705zm6.35.24a.5.5 0 01.705.055l3 3.5a.5.5 0 010 .65l-3 3.5a.5.5 0 11-.76-.65l2.293-2.675H1.5a.5.5 0 010-1h11.913L11.12 8.825a.5.5 0 01.055-.705z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-redo-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2 8c0-3.305 2.73-6 6.117-6a6.137 6.137 0 015.3 3H10.5a.5.5 0 000 1h4a.5.5 0 00.5-.5v-4a.5.5 0 00-1 0v2.559A7.144 7.144 0 008.117 1C4.195 1 1 4.126 1 8s3.195 7 7.117 7a.5.5 0 000-1C4.73 14 2 11.305 2 8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sign-in-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.5 1a.5.5 0 000 1h5.4c.692 0 1.1.44 1.1.9v10.2c0 .46-.408.9-1.1.9H7.5a.5.5 0 000 1h5.4c1.108 0 2.1-.76 2.1-1.9V2.9c0-1.14-.992-1.9-2.1-1.9H7.5zm-.312 4.11a.5.5 0 01.702.078l2 2.5a.5.5 0 010 .624l-2 2.5a.5.5 0 11-.78-.624L8.46 8.5H1.5a.5.5 0 010-1h6.96L7.11 5.812a.5.5 0 01.078-.702z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sign-out-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.1 1C1.992 1 1 1.76 1 2.9v10.2c0 1.14.992 1.9 2.1 1.9h5.4a.5.5 0 000-1H3.1c-.692 0-1.1-.44-1.1-.9V2.9c0-.46.408-.9 1.1-.9h5.4a.5.5 0 000-1H3.1zm9.088 4.11a.5.5 0 01.702.078l1.999 2.497a.497.497 0 01.11.305L15 8c0 .12-.042.23-.113.316l-1.997 2.496a.5.5 0 11-.78-.624L13.46 8.5H6.5a.5.5 0 010-1h6.96l-1.35-1.688a.5.5 0 01.078-.702z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sync-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M15 6.5v-4a.5.5 0 00-1 0v1.867C12.651 2.337 10.492 1 8 1 4.77 1 2.1 3.244 1.028 6.336a.5.5 0 00.945.328C2.93 3.899 5.27 2 8 2c2.505 0 4.682 1.6 5.764 4H10.5a.5.5 0 100 1h4a.5.5 0 00.5-.5zm-14 3a.5.5 0 01.5-.5h5a.5.5 0 110 1H2.236C3.32 12.4 5.496 14 8 14c2.729 0 5.069-1.899 6.028-4.664a.5.5 0 01.944.328C13.9 12.756 11.23 15 8 15c-2.492 0-4.651-1.336-6-3.367V14.5a.5.5 0 11-1 0v-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-undo-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.5 5a.5.5 0 010 1h-4a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v2.559A7.144 7.144 0 017.883 1C11.805 1 15 4.126 15 8s-3.195 7-7.117 7a.5.5 0 010-1C11.27 14 14 11.305 14 8s-2.73-6-6.117-6a6.137 6.137 0 00-5.3 3H5.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-announcement-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.146.146a.5.5 0 01.708 0l15 15a.5.5 0 01-.708.708l-15-15a.5.5 0 010-.708zM3 7.5a.5.5 0 00-1 0v.1a5.876 5.876 0 005.5 5.887V15.5a.5.5 0 001 0v-2a.5.5 0 000-1h-.6A4.878 4.878 0 013 7.6v-.1zM13.5 7a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zM8 0c-.869 0-1.754.49-2.147 1.276a.5.5 0 00.894.448C6.954 1.31 7.47 1 8 1c.824 0 1.5.676 1.5 1.5v2.7a.5.5 0 101 0V2.5C10.5 1.124 9.376 0 8 0z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-announcement-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.5 2.5C6.5 1.676 7.176 1 8 1s1.5.676 1.5 1.5v6c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5v-6zM8 0a2.506 2.506 0 00-2.5 2.5v6C5.5 9.876 6.624 11 8 11s2.5-1.124 2.5-2.5v-6C10.5 1.124 9.376 0 8 0zM2.5 6a.5.5 0 01.5.5v1.4C3 10.73 5.282 13 8 13s5-2.27 5-5.1V6.5a.5.5 0 011 0v1.4c0 3.197-2.447 5.818-5.5 6.079V15.5a.5.5 0 01-1 0v-1.521C4.446 13.719 2 11.098 2 7.9V6.5a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-headset-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 7.7C1 4.094 4.158 1 8 1c3.846 0 7 2.998 7 6.7v4.2c0 1.112-.964 2.1-2.2 2.1H10a2 2 0 10-.268 1H12.8c1.764 0 3.2-1.412 3.2-3.1V7.7C16 3.402 12.354 0 8 0 3.642 0 0 3.506 0 7.7v.6a.5.5 0 001 0v-.6zM7 14a1 1 0 112 0 1 1 0 01-2 0zm-2-3.5v-4a.5.5 0 00-1 0v4a.5.5 0 001 0zM4.5 5A1.5 1.5 0 003 6.5v4a1.5 1.5 0 003 0v-4A1.5 1.5 0 004.5 5zM12 6.5v4a.5.5 0 01-1 0v-4a.5.5 0 011 0zm-2 0a1.5 1.5 0 013 0v4a1.5 1.5 0 01-3 0v-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-pause-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 3.1a.2.2 0 01.028-.1h1.963c.004.02.009.052.009.1V13H4.01a.437.437 0 01-.01-.1V3.1zM4 2a.955.955 0 00-.757.38c-.16.206-.243.465-.243.72v9.8c0 .278.07.56.261.78.2.227.473.32.739.32h2a1 1 0 00.716-.284A1 1 0 007 13V3.1c0-.278-.07-.56-.261-.78A.961.961 0 006 2H4zm6 1.1a.2.2 0 01.028-.1h1.963c.004.02.009.052.009.1V13h-1.99a.438.438 0 01-.01-.1V3.1zM10 2a.955.955 0 00-.757.38c-.16.206-.243.465-.243.72v9.8c0 .278.07.56.261.78.2.227.473.32.739.32h2a1 1 0 00.716-.284A1 1 0 0013 13V3.1c0-.278-.07-.56-.261-.78A.961.961 0 0012 2h-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-play-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.004 2.167c.531-.231 1.21-.24 1.771.108l.015.01 6.537 4.4.04.03c.814.675.888 1.983-.042 2.6l-.001.002-6.534 4.398a.485.485 0 01-.015.01c-.561.348-1.24.34-1.77.109C3.472 13.602 3 13.1 3 12.4V3.6c0-.701.473-1.202 1.004-1.433zm.4.917C4.13 3.201 4 3.4 4 3.6v8.8c0 .199.13.398.403.516.272.119.595.11.837-.037l6.531-4.396c.271-.18.347-.659-.026-.984L5.24 3.121a.929.929 0 00-.837-.038z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-record-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 14A6 6 0 108 2a6 6 0 000 12zm0 1A7 7 0 108 1a7 7 0 000 14z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-stop-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2 3.5A1.5 1.5 0 013.5 2h9A1.5 1.5 0 0114 3.5v9a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 12.5v-9zM3.5 3a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-down-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M10 2.5a.5.5 0 00-.777-.416L6.349 4H3.2C2.524 4 2 4.524 2 5.2v5.6c0 .676.524 1.2 1.2 1.2h2.667l3.385 1.934A.5.5 0 0010 13.5v-11zM6.777 4.916L9 3.434v9.204l-2.752-1.572A.5.5 0 006 11H3.2c-.124 0-.2-.076-.2-.2V5.2c0-.124.076-.2.2-.2h3.3a.5.5 0 00.277-.084zm7.14-.693a.5.5 0 00-.833.554C13.627 5.593 14 6.696 14 8c0 1.304-.373 2.407-.916 3.223a.5.5 0 00.832.554C14.573 10.793 15 9.496 15 8s-.427-2.793-1.084-3.777z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-mute-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.146.146a.5.5 0 01.708 0l15 15a.5.5 0 01-.708.708l-15-15a.5.5 0 010-.708zm12.674.97a.5.5 0 00-.64.768C13.86 3.284 15 5.641 15 8.2c0 .761-.095 1.514-.28 2.163a.5.5 0 10.96.274c.216-.751.32-1.598.32-2.437 0-2.841-1.26-5.485-3.18-7.084zM1 5.2c0-.124.076-.2.2-.2a.5.5 0 000-1C.524 4 0 4.524 0 5.2v5.6c0 .676.524 1.2 1.2 1.2h2.667l3.385 1.934A.5.5 0 008 13.5v-2a.5.5 0 00-1 0v1.138l-2.752-1.572A.5.5 0 004 11H1.2c-.124 0-.2-.076-.2-.2V5.2zm10.9-1a.5.5 0 10-.8.6c.542.722.9 1.618.9 2.7a.5.5 0 001 0 5.412 5.412 0 00-1.1-3.3z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-volume-off-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.736 2.06A.5.5 0 018 2.5v11a.5.5 0 01-.748.434L3.867 12H1.2C.524 12 0 11.476 0 10.8V5.2C0 4.524.524 4 1.2 4h3.149l2.874-1.916a.5.5 0 01.513-.025zM7 3.433L4.777 4.916A.5.5 0 014.5 5H1.2c-.124 0-.2.076-.2.2v5.6c0 .124.076.2.2.2H4a.5.5 0 01.248.066L7 12.638V3.434zm5.146 2.712a.5.5 0 01.708 0L14 7.293l1.146-1.147a.5.5 0 01.708.708L14.707 8l1.147 1.146a.5.5 0 01-.708.708L14 8.707l-1.146 1.147a.5.5 0 01-.708-.708L13.293 8l-1.147-1.146a.5.5 0 010-.708z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-up-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M12.82 1.116a.5.5 0 00-.64.768C13.87 3.293 15 5.454 15 8s-1.13 4.707-2.82 6.116a.5.5 0 00.64.768C14.73 13.293 16 10.854 16 8s-1.27-5.293-3.18-6.884zm-5.084.943A.5.5 0 018 2.5v11a.5.5 0 01-.748.434L3.867 12H1.2C.524 12 0 11.476 0 10.8V5.2C0 4.524.524 4 1.2 4h3.149l2.874-1.916a.5.5 0 01.513-.025zM7 3.434L4.777 4.916A.5.5 0 014.5 5H1.2c-.124 0-.2.076-.2.2v5.6c0 .124.076.2.2.2H4a.5.5 0 01.248.066L7 12.638V3.434zm4.223.65a.5.5 0 01.693.139C12.573 5.207 13 6.504 13 8s-.427 2.793-1.084 3.777a.5.5 0 01-.832-.554C11.627 10.407 12 9.304 12 8c0-1.304-.373-2.407-.916-3.223a.5.5 0 01.139-.693z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-activity-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.544 2.002a.5.5 0 01.438.366l2.707 9.924 1.992-3.064A.5.5 0 0112.1 9h3.4a.5.5 0 010 1h-3.129L9.92 13.773a.5.5 0 01-.901-.141L6.374 3.939 3.652 9.713A.5.5 0 013.2 10H.5a.5.5 0 110-1h2.383l3.165-6.713a.5.5 0 01.496-.285z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-address-book-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.9 2c-.548 0-.9.4-.9.8V13.2c0 .4.352.8.9.8h8.2c.548 0 .9-.4.9-.8V2H2.9zM1 12.5v.7c0 1 .848 1.8 1.9 1.8h8.2c1.052 0 1.9-.8 1.9-1.8V10h1c1.017 0 2-.784 2-1.833V6.833c0-.537-.258-1.004-.645-1.333.387-.329.645-.796.645-1.333V2.833C16 1.784 15.017 1 14 1H2.9C1.848 1 1 1.8 1 2.8v.7H.5a.5.5 0 000 1H1v3H.5a.5.5 0 000 1H1v3H.5a.5.5 0 000 1H1zM14 5h-1V2h1c.583 0 1 .447 1 .833v1.334c0 .386-.417.833-1 .833zm0 1h-1v3h1c.583 0 1-.447 1-.833V6.833C15 6.447 14.583 6 14 6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-align-left-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 3a.5.5 0 000 1h7a.5.5 0 000-1h-7zm0 3a.5.5 0 000 1h9a.5.5 0 000-1h-9zM2 9.5a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h11a.5.5 0 000-1h-11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-american-football-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M9.817 1.13c-1.981.273-4.16 1.025-5.91 2.776-1.804 1.804-2.548 4.06-2.8 6.088l4.899 4.898c2.028-.25 4.284-.995 6.088-2.798 1.75-1.752 2.503-3.93 2.775-5.911L9.817 1.13zm5.169 3.756A15.933 15.933 0 0014.86 2.1c-.047-.35-.097-.632-.136-.825a13.42 13.42 0 00-.825-.136 15.923 15.923 0 00-2.786-.125l3.872 3.872zM4.693 14.993l-3.686-3.686a15.963 15.963 0 00.132 2.593c.047.35.097.632.136.825.193.039.474.089.825.136.66.088 1.564.165 2.593.132zM15.63.733l-.485.122.123-.484a.5.5 0 01.361.362zM.854 15.145c-.123.484-.122.485-.122.485h.002l.005.001.018.005.067.015.246.053c.212.042.517.096.897.147.757.101 1.816.188 3.02.13 2.403-.115 5.442-.811 7.812-3.18 2.37-2.37 3.066-5.41 3.181-7.812a16.914 16.914 0 00-.13-3.021 14.466 14.466 0 00-.2-1.143 4.415 4.415 0 00-.015-.067L15.63.74V.735l-.002-.002-.484.122c.123-.484.122-.485.122-.485h-.002L15.26.369l-.018-.005a14.385 14.385 0 00-1.21-.215 16.91 16.91 0 00-3.02-.13C8.608.134 5.57.83 3.2 3.199.83 5.57.134 8.61.019 11.012a16.91 16.91 0 00.13 3.021 14.386 14.386 0 00.215 1.21l.005.018v.005l.002.002a.5.5 0 00.361.362l.123-.484zm0 0l-.484.122.484-.122zM9.503 4.799a.5.5 0 10-.707.706l1.699 1.7a.5.5 0 10.706-.707l-1.698-1.7zM7.304 6.697a.5.5 0 10-.707.707l1.999 1.999a.5.5 0 10.707-.707L7.304 6.697zM4.699 8.896a.5.5 0 01.706 0l1.7 1.699a.5.5 0 11-.707.706l-1.7-1.699a.5.5 0 010-.706z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-anchor-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.5 3.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8 1a2.5 2.5 0 00-.498 4.95A.507.507 0 007.5 6v7.987C5.41 13.88 3.558 13.1 2 11.772V10h.5a.5.5 0 000-1h-1a.5.5 0 00-.5.5V12a.5.5 0 00.168.374C3.054 14.05 5.37 15 8 15c2.629 0 4.946-.95 6.832-2.626A.5.5 0 0015 12V9.5a.5.5 0 00-.5-.5h-1a.5.5 0 000 1h.5v1.772c-1.558 1.327-3.41 2.108-5.5 2.215V6c0-.017 0-.033-.002-.05A2.5 2.5 0 008 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-archive-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14 3H2v2h12V3zM1 5v8a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1H2a1 1 0 00-1 1v2zm13 8V6H2v7h12zM5.5 8a.5.5 0 000 1h5a.5.5 0 000-1h-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-ban-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14 8a6 6 0 01-9.874 4.582l8.456-8.456A5.976 5.976 0 0114 8zM3.419 11.874l8.455-8.455a6 6 0 00-8.456 8.456zM15 8A7 7 0 111 8a7 7 0 0114 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bars-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3 4.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0 8a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zM3.5 8a.5.5 0 000 1h9a.5.5 0 000-1h-9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bell-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.854.146a.5.5 0 10-.708.708l15 15a.5.5 0 00.708-.708l-15-15zM8.528 1c-.863 0-1.64.229-2.311.702a.53.53 0 00-.135.71c.149.236.45.3.674.143.495-.348 1.08-.53 1.772-.53 1.967 0 3.5 1.617 3.5 3.693v2.77a.5.5 0 00.486.512.5.5 0 00.486-.513V5.718C13 3.076 11.032 1 8.528 1zM3.724 9.053a.5.5 0 01.223.67L2.31 13H7.5a.5.5 0 110 1H7c0 .524.476 1 1 1s1-.476 1-1a.5.5 0 011 0c0 1.076-.924 2-2 2s-2-.924-2-2H1.5a.5.5 0 01-.447-.724l2-4a.5.5 0 01.67-.223z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-bell-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 5c0-2.224 1.776-4 4-4s4 1.776 4 4v3.5c0 .064.012.127.036.186L13.762 13H2.239l1.725-4.314A.5.5 0 004 8.5V5zm4-5C5.224 0 3 2.224 3 5v3.404l-1.964 4.91A.5.5 0 001.5 14H6c0 1.076.924 2 2 2s2-.924 2-2h4.5a.5.5 0 00.464-.686L13 8.404V5c0-2.776-2.224-5-5-5zm1 14H7c0 .524.476 1 1 1s1-.476 1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bold-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.58 1a.58.58 0 00-.58.58V14.5a.5.5 0 00.5.5H9a4 4 0 001.572-7.68A3.5 3.5 0 008.5 1H3.58zM8.5 7a2.5 2.5 0 000-5H4v5h4.5zM4 8v6h5a3 3 0 100-6H4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bolt-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.015.379A.5.5 0 015.5 0h5a.5.5 0 01.485.621L10.14 4H11.8a1.5 1.5 0 011.31 2.23l-5.017 9.01a1.48 1.48 0 01-2.716-1.126L6.837 9H4.781a1.5 1.5 0 01-1.455-1.864L5.015.38zM5.89 1L4.296 7.379A.5.5 0 004.78 8H7.5a.5.5 0 01.48.637l-1.642 5.751a.48.48 0 00.88.366l5.018-9.01A.5.5 0 0011.799 5H9.5a.5.5 0 01-.485-.621L9.86 1H5.89z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bookmark-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.5 1c-.414 0-.797.14-1.079.421C2.141 1.703 2 2.086 2 2.5v11.99a.496.496 0 00.232.432.497.497 0 00.491.025L8 12.454l5.277 2.495A.5.5 0 0014 14.49V2.5c0-.414-.14-.797-.421-1.079C13.297 1.141 12.914 1 12.5 1h-9zM13 13.71V2.5c0-.186-.06-.303-.129-.371-.068-.07-.185-.129-.371-.129h-9c-.186 0-.303.06-.371.129-.07.068-.129.185-.129.371v11.21l4.786-2.262a.5.5 0 01.428 0L13 13.711z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-branch-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.5 2.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8 0a2.5 2.5 0 00-.498 4.95A.507.507 0 007.5 5v3H5.2C3.476 8 2 9.274 2 10.9v.15a2.5 2.5 0 101 0v-.15C3 9.926 3.924 9 5.2 9h5.5c1.389 0 2.3.937 2.3 1.9v.15a2.5 2.5 0 101 0v-.15C14 9.263 12.511 8 10.7 8H8.5V5c0-.017 0-.033-.002-.05A2.5 2.5 0 008 0zM1 13.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm11 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-building-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13 1H3v14h4v-1.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V15h4V1zM8.5 16h6a.5.5 0 000-1H14V1a1 1 0 00-1-1H3a1 1 0 00-1 1v14h-.5a.5.5 0 000 1h7zM6 3a1 1 0 100 2 1 1 0 000-2zM5 7a1 1 0 112 0 1 1 0 01-2 0zm1 2a1 1 0 100 2 1 1 0 000-2zm3-5a1 1 0 112 0 1 1 0 01-2 0zm1 2a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 112 0 1 1 0 01-2 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-camera-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14.5 15.002h-13a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h1.79l1-1.75a.48.48 0 01.47-.25h5.93a.5.5 0 01.43.25l1 1.75h2.38a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5zm-13-11a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-2.63a.48.48 0 01-.43-.25l-1.04-1.75H5l-1 1.75a.48.48 0 01-.43.25H1.5zm6.5 8a3 3 0 110-6 3 3 0 010 6zm0-5a2 2 0 100 4 2 2 0 000-4zM12.5 7a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-channels-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3 2.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm2 2.45a2.5 2.5 0 10-1 0v6.1a2.5 2.5 0 101 0V11c0-.451.228-.956.62-1.357C6.01 9.243 6.513 9 7 9h2.5c.751 0 1.393-.228 1.846-.695.45-.464.654-1.102.654-1.805V4.95a2.5 2.5 0 10-1 0V6.5c0 .515-.147.877-.371 1.109-.222.229-.58.391-1.129.391H7c-.766 0-1.474.353-2 .85v-3.9zM4.5 12a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13 2.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chart-bar-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 1c-.524 0-1 .476-1 1v12c0 .524.476 1 1 1s1-.476 1-1V2c0-.524-.476-1-1-1zM6 2c0-1.076.924-2 2-2s2 .924 2 2v12c0 1.076-.924 2-2 2s-2-.924-2-2V2zM3 8c-.524 0-1 .476-1 1v5c0 .524.476 1 1 1s1-.476 1-1V9c0-.524-.476-1-1-1zM1 9c0-1.076.924-2 2-2s2 .924 2 2v5c0 1.076-.924 2-2 2s-2-.924-2-2V9zm11-2c0-.524.476-1 1-1s1 .476 1 1v7c0 .524-.476 1-1 1s-1-.476-1-1V7zm1-2c-1.076 0-2 .924-2 2v7c0 1.076.924 2 2 2s2-.924 2-2V7c0-1.076-.924-2-2-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1.646 2.646C2.63 1.663 4.054 1 5.5 1h3a.5.5 0 010 1h-3c-1.154 0-2.33.537-3.146 1.354C1.533 4.174 1 5.252 1 6.5c0 2.155 1.526 3.96 3.606 4.411A.5.5 0 015 11.4v2.166l3.723-2.482A.5.5 0 019 11h1.5c1.153 0 2.33-.537 3.146-1.354C14.467 8.826 15 7.748 15 6.5v-1a.5.5 0 011 0v1c0 1.552-.667 2.874-1.646 3.854C13.37 11.337 11.947 12 10.5 12H9.151l-4.374 2.916A.5.5 0 014 14.5v-2.712c-2.319-.68-4-2.782-4-5.288 0-1.552.667-2.874 1.646-3.854zM12.5 1a.5.5 0 01.5.5V3h1.5a.5.5 0 010 1H13v1.5a.5.5 0 01-1 0V4h-1.5a.5.5 0 010-1H12V1.5a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.854.146a.5.5 0 10-.708.708l14 14a.5.5 0 00.708-.708l-14-14zM5 1.5a.5.5 0 01.5-.5h5C13.563 1 16 3.31 16 6.4a5.645 5.645 0 01-1.646 3.954.5.5 0 01-.708-.708A4.645 4.645 0 0015 6.4C15 3.89 13.037 2 10.5 2h-5a.5.5 0 01-.5-.5zM1.124 3.953a.5.5 0 01.223.67C1.095 5.128 1 5.742 1 6.4c0 2.155 1.526 3.96 3.606 4.411A.5.5 0 015 11.3v2.12l3.207-2.325a.5.5 0 11.586.81l-4 2.9A.5.5 0 014 14.4v-2.712c-2.319-.68-4-2.782-4-5.288 0-.74.105-1.527.453-2.224a.5.5 0 01.67-.223z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-check-circle-filled-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-circle-filled-16\" viewBox=\"0 0 16 16\"><circle cx=\"8\" cy=\"8\" r=\"6\"/></symbol>\n<symbol id=\"icon-close-circle-filled-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 0a8 8 0 100 16A8 8 0 008 0zm2.854 5.146a.5.5 0 010 .708L8.707 8l2.147 2.146a.5.5 0 01-.708.708L8 8.707l-2.146 2.147a.5.5 0 01-.708-.708L7.293 8 5.146 5.854a.5.5 0 11.708-.708L8 7.293l2.146-2.147a.5.5 0 01.708 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-close-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-download-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12.425 7h.109a2.505 2.505 0 012.485 2.5 2.499 2.499 0 01-2.503 2.5.501.501 0 00-.354.854.502.502 0 00.348.146h-.014.02-.006a3.507 3.507 0 002.464-1.025 3.498 3.498 0 00-1.956-5.936L13.016 6a4.997 4.997 0 00-1.466-3.536 5.01 5.01 0 00-7.08 0A4.997 4.997 0 003.004 6l-.002.036A3.506 3.506 0 000 9.5c0 .928.37 1.819 1.026 2.475A3.506 3.506 0 003.504 13h.02a.501.501 0 000-1 2.505 2.505 0 01-2.503-2.5A2.498 2.498 0 013.564 7 .481.481 0 004 6.596a.503.503 0 00.006-.156 3.146 3.146 0 010-.44c0-1.06.422-2.078 1.173-2.828A4.008 4.008 0 0112.015 6c.01.146.01.294 0 .44a.51.51 0 00.41.56zM7.51 6.5v6.63l-1.625-1.95a.5.5 0 00-.768.64l2.5 3a.5.5 0 00.768 0l2.5-3a.5.5 0 00-.768-.64L8.51 13.106V6.5a.5.5 0 00-1.002 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-upload-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12.486 7h-.06a.51.51 0 01-.411-.56c.01-.146.01-.294 0-.44 0-1.06-.422-2.078-1.173-2.828A4.008 4.008 0 004.005 6c-.01.146-.01.294 0 .44a.503.503 0 01-.006.156.48.48 0 01-.435.404.505.505 0 01-.11.001A2.505 2.505 0 001.02 9.5 2.499 2.499 0 003.524 12a.501.501 0 010 1h-.02a3.498 3.498 0 01-.502-6.964L3.004 6c0-1.326.527-2.598 1.466-3.536a5.01 5.01 0 017.08 0A4.997 4.997 0 0113.016 6l.002.04A3.506 3.506 0 0116 9.5c0 .928-.37 1.819-1.026 2.475A3.507 3.507 0 0112.51 13a.502.502 0 01-.348-.854.501.501 0 01.354-.146 2.505 2.505 0 002.503-2.5A2.499 2.499 0 0012.486 7zm.024 6h.006-.02.014zm-4.5 2a.501.501 0 01-.5-.5V7.87L5.883 9.82a.5.5 0 01-.768-.64l2.5-3A.5.5 0 018.005 6h.005a.5.5 0 01.436.254l2.438 2.926a.5.5 0 01-.768.64L8.51 7.894V14.5a.5.5 0 01-.501.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M12.425 8h.109a2.505 2.505 0 012.485 2.5 2.498 2.498 0 01-2.503 2.5H3.524a2.505 2.505 0 01-2.503-2.5A2.498 2.498 0 013.564 8h1.943a.5.5 0 100-1H4.005c0-1.06.422-2.078 1.173-2.828A4.008 4.008 0 0112.015 7c.01.146.01.294 0 .44a.51.51 0 00.41.56zm.591-1l.002.04A3.506 3.506 0 0116 10.5a3.498 3.498 0 01-3.44 3.5H3.504a3.498 3.498 0 01-.502-6.964L3.004 7c0-1.326.527-2.598 1.466-3.536a5.01 5.01 0 017.08 0A4.997 4.997 0 0113.016 7z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-code-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.468 4c.126 0 .248.051.338.144a.495.495 0 01.175.34.522.522 0 01-.108.368L3.121 8.007l2.752 3.154a.521.521 0 01.087.54.493.493 0 01-.177.219.46.46 0 01-.262.08.447.447 0 01-.353-.16L2.121 8.346a.534.534 0 010-.679l3.01-3.523A.474.474 0 015.467 4zm5.364.144l3.047 3.507a.537.537 0 010 .682l-3.047 3.507a.468.468 0 01-.353.16.46.46 0 01-.262-.08.495.495 0 01-.177-.22.524.524 0 01.087-.542l2.752-3.166-2.723-3.136a.504.504 0 01-.141-.356.523.523 0 01.14-.356.473.473 0 01.339-.144c.126 0 .247.052.338.144z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cog-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.446 16h1.119a1.367 1.367 0 001.338-1.24l.2-1.3a5.603 5.603 0 001.379-.84l1.118.44a1.337 1.337 0 001.668-.62l.55-1a1.431 1.431 0 00-.3-1.77l-.949-.83c.08-.577.08-1.163 0-1.74l.95-.83a1.43 1.43 0 00.299-1.77l-.55-1a1.34 1.34 0 00-1.668-.62l-1.118.44a5.6 5.6 0 00-1.379-.84l-.2-1.3A1.37 1.37 0 008.565 0H7.446a1.368 1.368 0 00-1.338 1.18l-.2 1.3a5.602 5.602 0 00-1.378.84L3.41 2.88a1.337 1.337 0 00-1.668.65l-.55 1a1.431 1.431 0 00.3 1.77l1 .83a6.347 6.347 0 000 1.74l-1 .83a1.43 1.43 0 00-.3 1.8l.55 1a1.339 1.339 0 001.668.62l1.119-.44c.416.345.88.628 1.378.84l.2 1.3A1.37 1.37 0 007.446 16zM4.97 11.73a.509.509 0 00-.34-.13.568.568 0 00-.21.03l-1.407.57a.34.34 0 01-.39-.19l-.56-1a.45.45 0 01.09-.54l1.16-1A.49.49 0 003.47 9a5.276 5.276 0 010-2 .49.49 0 00-.16-.46l-1.158-1a.45.45 0 01-.09-.54l.559-1a.34.34 0 01.39-.2l1.478.57a.499.499 0 00.52-.1 4.604 4.604 0 011.517-.96.51.51 0 00.33-.39l.24-1.58a.37.37 0 01.35-.34h1.118a.37.37 0 01.35.34l.27 1.54a.51.51 0 00.329.39 4.603 4.603 0 011.558 1 .5.5 0 00.52.1L13 3.8a.339.339 0 01.44.2l.559 1a.45.45 0 01-.14.59l-1.159 1a.49.49 0 00-.16.47c.12.641.12 1.299 0 1.94a.491.491 0 00.21.46l1.159 1a.45.45 0 01.09.54l-.58 1.03a.34.34 0 01-.42.17l-1.438-.57a.498.498 0 00-.519.1 4.605 4.605 0 01-1.558 1 .509.509 0 00-.33.39l-.24 1.58a.37.37 0 01-.349.34H7.446a.37.37 0 01-.35-.34l-.239-1.58a.51.51 0 00-.33-.39 4.604 4.604 0 01-1.558-1zm1.364-1.236a3 3 0 103.333-4.988 3 3 0 00-3.333 4.988zm.556-4.157A2 2 0 119.11 9.663 2 2 0 016.89 6.337z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-conversations-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M9.82 6.82A4.003 4.003 0 017 7.986H5.36L2.8 9.884a.47.47 0 01-.3.1.64.64 0 01-.23-.09.52.52 0 01-.27-.45V7.449a3.997 3.997 0 01-2-3.454 3.988 3.988 0 011.18-2.826A4.003 4.003 0 014 0h3c1.06 0 2.078.42 2.828 1.17A3.99 3.99 0 0111 3.994a3.988 3.988 0 01-1.18 2.825zM3 8.485L4.89 7.09a.47.47 0 01.3-.1H7a2.934 2.934 0 002.11-.879A2.935 2.935 0 0010 3.994c0-.795-.316-1.557-.879-2.118A3.002 3.002 0 007 .998H4a2.934 2.934 0 00-2.11.879A2.935 2.935 0 001 3.994a2.992 2.992 0 001.71 2.705.49.49 0 01.29.45v1.337zm11.481-2.47a.499.499 0 01.347.114 4.325 4.325 0 011.16 3.294 3.678 3.678 0 01-2 3.363v2.712a.51.51 0 01-.239.43.48.48 0 01-.26.07c-.08.001-.16-.02-.23-.06l-3.717-1.941H8.323a3.702 3.702 0 01-3.177-1.151.501.501 0 01.163-.81.499.499 0 01.546.11 2.747 2.747 0 002.468.85h1.34c.08 0 .16.02.23.06l3.087 1.612v-2.173a.51.51 0 01.26-.44 2.718 2.718 0 001.748-2.632 3.45 3.45 0 00-.85-2.573.501.501 0 01.343-.834z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-copy-16\" viewBox=\"0 0 16 16\"><path d=\"M14.86 4.88L10.42.16a.5.5 0 00-.36-.16H5.61A1.64 1.64 0 004 1.68V2H2.61A1.64 1.64 0 001 3.68v10.64A1.64 1.64 0 002.61 16h7.78A1.64 1.64 0 0012 14.32V14h1.39A1.64 1.64 0 0015 12.32V5.23a.52.52 0 00-.14-.35zM13.6 5H10V1.17L13.6 5zM11 14.32a.65.65 0 01-.61.68H2.61a.65.65 0 01-.61-.68V3.68A.65.65 0 012.61 3H4v9.32A1.64 1.64 0 005.61 14H11v.32zM13.39 13H5.61a.65.65 0 01-.61-.68V1.68A.65.65 0 015.61 1H9v4.5a.5.5 0 00.5.5H14v6.32a.65.65 0 01-.61.68z\"/></symbol>\n<symbol id=\"icon-credit-card-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 3.51c0-.191.06-.31.13-.38S1.315 3 1.5 3h13c.185 0 .3.06.37.13s.13.189.13.38V6H1V3.51zM0 6.5V3.51c0-.416.14-.801.42-1.084C.7 2.142 1.085 2 1.5 2h13c.415 0 .8.142 1.08.426.28.283.42.668.42 1.083v8.981c0 .416-.14.801-.42 1.084-.28.284-.665.426-1.08.426h-13c-.415 0-.8-.142-1.08-.426-.28-.283-.42-.668-.42-1.083V6.5zM15 7v5.49c0 .191-.06.31-.13.38s-.185.13-.37.13h-13c-.185 0-.3-.06-.37-.13S1 12.681 1 12.49V7h14zM4 11.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cut-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M3.2 1a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4zM0 3.2a3.2 3.2 0 114.307 3.003L6.908 7.45l8.377-4a.5.5 0 01.43.902L4.312 9.798A3.201 3.201 0 013.2 16a3.2 3.2 0 01-1.458-6.05.499.499 0 01.142-.101L5.75 8.003 1.884 6.151a.499.499 0 01-.142-.102A3.2 3.2 0 010 3.2zm9.548 6.086a.5.5 0 01.666-.238l5.5 2.6a.5.5 0 01-.428.904l-5.5-2.6a.5.5 0 01-.238-.666zM3.2 10.6a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-dashboard-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.416 2.71A6.97 6.97 0 017.5 1.017V2.5a.5.5 0 001 0V1.018a6.97 6.97 0 014.084 1.691l-.938.937a.5.5 0 00.708.708l.937-.938A6.972 6.972 0 0114.929 7H13.5a.5.5 0 000 1H15A7 7 0 111 8h1.5a.5.5 0 000-1H1.07a6.972 6.972 0 011.64-3.584l.936.938a.5.5 0 10.708-.708l-.938-.937zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-2a.5.5 0 01.5.5v2.563a2 2 0 11-1 0V6.5A.5.5 0 018 6zm0 4a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dixa-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.356.862a6.434 6.434 0 018.782 2.346A6.385 6.385 0 0116 6.412a6.417 6.417 0 01-3.216 5.565L8.161 14.64l-.944.542-1.378.796a.152.152 0 01-.229-.132v-3.156c0-.187-.05-.37-.143-.533L1.078 4.573a.582.582 0 01.214-.796L6.356.862zm2.683 8.334l1.601-.924a2.137 2.137 0 00.786-2.924 2.143 2.143 0 00-2.927-.781l-1.604.92a.291.291 0 00-.107.4L8.64 9.088c.08.14.259.187.399.107z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-done-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11.854 5.146a.5.5 0 010 .708l-5 5a.5.5 0 01-.708 0l-2-2a.5.5 0 11.708-.708L6.5 9.793l4.646-4.647a.5.5 0 01.708 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dots-h-16\" viewBox=\"0 0 16 16\"><path d=\"M4 9a1 1 0 100-2 1 1 0 000 2zM8 9a1 1 0 100-2 1 1 0 000 2zM12 9a1 1 0 100-2 1 1 0 000 2z\"/></symbol>\n<symbol id=\"icon-dots-v-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7 4a1 1 0 102 0 1 1 0 00-2 0zm0 4a1 1 0 102 0 1 1 0 00-2 0zm1 5a1 1 0 110-2 1 1 0 010 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-download-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11.124 6.17l-2.624 3V1.5a.5.5 0 00-1 0v7.67l-2.624-3a.5.5 0 10-.752.66l3.5 4a.5.5 0 00.752 0l3.5-4a.5.5 0 00-.752-.66zM2.5 14a.5.5 0 000 1h11a.5.5 0 000-1h-11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dropdown-list-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 1.5a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0 3a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM1.5 7a.5.5 0 000 1h7a.5.5 0 000-1h-7zM8 11.5a.5.5 0 01.5-.5H11V8.5a.5.5 0 011 0V11h2.5a.5.5 0 010 1H12v2.5a.5.5 0 01-1 0V12H8.5a.5.5 0 01-.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-enter-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 1A1.5 1.5 0 001 2.5v11A1.5 1.5 0 002.5 15h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0013.5 1h-11zM2 2.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-11zM11.5 5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H5.707l1.147 1.146a.5.5 0 01-.708.708l-2-2a.5.5 0 010-.708l2-2a.5.5 0 11.708.708L5.707 8H11V5.5a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-circle-filled-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M16 8A8 8 0 110 8a8 8 0 0116 0zM8 9a1 1 0 01-1-1V5a1 1 0 112 0v3a1 1 0 01-1 1zm0 1a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-triangle-filled-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M15.675 11.25l-5.556-9.987a2.41 2.41 0 00-4.238 0L.325 11.25C-.605 12.921.57 15 2.444 15h11.112c1.874 0 3.048-2.079 2.119-3.75zM8 9a1 1 0 01-1-1V5a1 1 0 112 0v3a1 1 0 01-1 1zm0 1a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 15c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7zM8 4c.3 0 .5.2.5.5v5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5zm.5 7.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-expand-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1.491 1A.491.491 0 001 1.491V5.51a.491.491 0 00.982 0V1.982H5.51a.491.491 0 000-.982H1.49zM14.51 15c.271 0 .491-.22.491-.491V10.49a.491.491 0 00-.982 0v3.527H10.49a.491.491 0 100 .982h4.018zm0-14c.271 0 .491.22.491.491V5.51a.491.491 0 01-.982 0V1.982H10.49a.491.491 0 010-.982h4.018zM1 14.509c0 .271.22.491.491.491H5.51a.491.491 0 000-.982H1.982V10.49a.491.491 0 00-.982 0v4.018z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-external-link-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M10 2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-1 0V3.707L7.854 8.854a.5.5 0 11-.708-.708L12.293 3H10.5a.5.5 0 01-.5-.5zm-7 2a.5.5 0 01.5-.5h1a.5.5 0 000-1h-1A1.5 1.5 0 002 4.5v8A1.5 1.5 0 003.5 14h8a1.5 1.5 0 001.5-1.5v-1a.5.5 0 00-1 0v1a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-eye-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M0 8c0 1.18 3.59 6 8 6s8-4.82 8-6c0-1.18-3.59-6-8-6S0 6.82 0 8zm1 0c.05-.62 3.07-5 7-5s7 4.38 7 5c0 .62-3.07 5-7 5S.95 8.62 1 8zm5.611 2.079A2.5 2.5 0 109.39 5.92 2.5 2.5 0 006.61 10.08zm.556-3.326a1.5 1.5 0 111.666 2.494 1.5 1.5 0 01-1.666-2.494z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2 1.5a.5.5 0 01.5-.5H10v4.5a.5.5 0 00.5.5H14v8.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-13zM13.46 5L11 1.925V5h2.46zM2.5 0A1.5 1.5 0 001 1.5v13A1.5 1.5 0 002.5 16h11a1.5 1.5 0 001.5-1.5v-9a.5.5 0 00-.11-.312l-4-5A.5.5 0 0010.5 0h-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-filter-16\" viewBox=\"0 0 16 16\"><path d=\"M6.492 15c-.08 0-.16-.02-.23-.06a.5.5 0 01-.271-.44v-3.84L1.32 4a1.997 1.997 0 01-.1-2 1.63 1.63 0 011.453-1h10.642a1.666 1.666 0 011.463.91 1.997 1.997 0 01-.1 2l-4.68 6.75V12a1.488 1.488 0 01-.671 1.25l-2.555 1.67a.572.572 0 01-.281.08zM2.674 2a.682.682 0 00-.57.38.998.998 0 000 1l4.799 6.83a.52.52 0 01.09.29v3.07l1.784-1.19a.5.5 0 00.22-.38v-1.5a.52.52 0 01.09-.29l4.77-6.82a.999.999 0 000-1 .68.68 0 00-.541-.39H2.674z\"/></symbol>\n<symbol id=\"icon-flag-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2 0a.5.5 0 01.5.5v1.292c.38-.118.895-.255 1.485-.348 1.233-.195 2.874-.212 4.272.627 1.106.664 2.594.72 3.875.578a12.576 12.576 0 002.173-.445l.03-.01.006-.001h.001a.5.5 0 01.658.474.8.8 0 01-.026.192 1.9 1.9 0 01-.046.15 6.02 6.02 0 01-.138.358c-.114.273-.274.626-.462 1.029-.348.741-.801 1.665-1.261 2.588l1.867 3.268a.5.5 0 01-.313.733L14.5 10.5l.121.485h-.001l-.004.001-.01.003-.038.009-.14.031a14.436 14.436 0 01-2.216.283c-1.343.064-3.09-.056-4.47-.883-1.125-.676-2.508-.802-3.653-.742a10.525 10.525 0 00-1.589.208V15.5a.5.5 0 01-1 0V2.512.5A.5.5 0 012 0zm.5 2.845v6.03c.384-.074.92-.154 1.536-.187 1.23-.065 2.847.059 4.221.883 1.121.673 2.624.803 3.907.742.615-.03 1.16-.102 1.557-.168l-1.65-2.889a.5.5 0 01-.018-.48c.5-.998.997-2.01 1.37-2.805.097-.208.185-.399.262-.57-.397.088-.893.18-1.442.242-1.344.15-3.106.122-4.5-.714C6.64 2.268 5.282 2.25 4.14 2.43a9.601 9.601 0 00-1.64.414zm11.505-.236v.004-.004z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-flow-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 2A1.5 1.5 0 001 3.5v2A1.5 1.5 0 002.5 7h2c.26 0 .506-.067.72-.184L9.112 9.93A1.496 1.496 0 009 10.5v2a1.5 1.5 0 001.5 1.5h2a1.5 1.5 0 001.5-1.5v-2A1.5 1.5 0 0012.5 9h-2c-.26 0-.506.067-.72.184L5.888 6.07C5.96 5.894 6 5.702 6 5.5V5h4v.5A1.5 1.5 0 0011.5 7h2A1.5 1.5 0 0015 5.5v-2A1.5 1.5 0 0013.5 2h-2A1.5 1.5 0 0010 3.5V4H6v-.5A1.5 1.5 0 004.5 2h-2zM5 4v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V4zm6 0v1.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5V4zm-.5 6a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-format-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 6a4 4 0 118 0v4H4V6zm0 5v3.375c0 .345-.224.625-.5.625s-.5-.28-.5-.625v-8.75a.76.76 0 01.037-.236 5 5 0 019.926 0 .763.763 0 01.037.236v8.75c0 .345-.224.625-.5.625s-.5-.28-.5-.625V11H4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-gift-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.404 2.404C2.16 2.647 2 3.014 2 3.5V4h4.896c-.19-.196-.409-.41-.652-.625C5.404 2.634 4.402 2 3.5 2c-.486 0-.853.16-1.096.404zM7.995 5H15v2H1V5h6.995zM1 4v-.5c0-.714.24-1.347.696-1.804C2.153 1.24 2.786 1 3.5 1c1.298 0 2.546.866 3.406 1.625.444.392.815.782 1.074 1.074l.02.023.02-.023c.26-.292.63-.682 1.074-1.074C9.954 1.866 11.202 1 12.5 1c.714 0 1.347.24 1.804.696.456.457.696 1.09.696 1.804V4h.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H15v5.9c0 .336-.13.624-.355.824A1.12 1.12 0 0113.9 15H2.2a1.08 1.08 0 01-.824-.355A1.121 1.121 0 011.1 13.9V8H.5a.5.5 0 01-.5-.5v-3A.5.5 0 01.5 4H1zm1.1 4v5.9c0 .043.015.07.024.08a.038.038 0 00.014.01c.007.003.025.01.062.01h5.3V8H2.1zm6.4 0v6h5.4c.043 0 .07-.015.08-.024a.038.038 0 00.01-.014.154.154 0 00.01-.062V8H8.5zM14 4v-.5c0-.486-.16-.853-.403-1.096C13.353 2.16 12.987 2 12.5 2c-.902 0-1.904.634-2.744 1.375-.243.214-.463.429-.652.625H14z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-hamburger-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.155 2.21C4.425 1.452 6.149 1 8.025 1s3.6.452 4.87 1.21c1.26.75 2.155 1.859 2.155 3.179 0 .918-.79 1.611-1.687 1.611H2.686C1.788 7 1 6.306 1 5.389c0-1.32.895-2.428 2.155-3.18zM2.686 6h10.677c.408 0 .687-.307.687-.611 0-.828-.566-1.664-1.667-2.32C11.293 2.419 9.753 2 8.025 2c-1.728 0-3.267.418-4.358 1.069C2.566 3.725 2 4.56 2 5.389c0 .305.279.611.686.611zM1 9a.5.5 0 01.5-.5h13a.5.5 0 010 1h-13A.5.5 0 011 9zm1 3.25c0-.09.032-.16.068-.203.036-.04.066-.047.082-.047h11.7c.016 0 .046.006.082.047a.31.31 0 01.068.203c0 1.036-.714 1.75-1.45 1.75h-9.1C2.714 14 2 13.286 2 12.25zM2.15 11c-.7 0-1.15.63-1.15 1.25C1 13.7 2.032 15 3.45 15h9.1c1.418 0 2.45-1.3 2.45-2.75 0-.62-.45-1.25-1.15-1.25H2.15z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-heart-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1.024 2.588C1.742 1.627 2.84 1 4.3 1c1.731 0 2.88.91 3.683 1.743C8.78 1.845 9.872 1 11.7 1c1.461 0 2.56.628 3.278 1.604C15.682 3.562 16 4.825 16 6.1c0 2.142-1.205 4.038-2.739 5.533-1.539 1.5-3.47 2.658-5.068 3.328a.5.5 0 01-.399-.005c-1.591-.719-3.519-1.9-5.057-3.412C1.205 10.038 0 8.142 0 6c0-1.229.32-2.467 1.024-3.412zm.802.599C1.28 3.917 1 4.929 1 6c0 1.758.995 3.412 2.438 4.831 1.374 1.351 3.101 2.434 4.57 3.122 1.46-.64 3.183-1.698 4.556-3.036C14.005 9.512 15 7.857 15 6.1c0-1.125-.283-2.162-.828-2.904C13.64 2.472 12.84 2 11.7 2c-1.67 0-2.542.853-3.31 1.812a.5.5 0 01-.764.02C6.836 2.942 5.866 2 4.3 2c-1.14 0-1.942.473-2.474 1.187z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-hide-strategy-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 3a.5.5 0 00-.5.5V13h12V7.5a.5.5 0 011 0V13h.5a.5.5 0 010 1H.5a.5.5 0 110-1H1V3.5A1.5 1.5 0 012.5 2h4a.5.5 0 010 1h-4zm8-1a.5.5 0 01.5.5v3.793l1.146-1.147a.5.5 0 01.708.708l-2 2a.5.5 0 01-.708 0l-2-2a.5.5 0 11.708-.708L10 6.293V2.5a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-home-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8.312.11a.5.5 0 00-.624 0l-7.5 6A.5.5 0 000 6.5v8A1.5 1.5 0 001.5 16h13a1.5 1.5 0 001.5-1.5v-8a.5.5 0 00-.188-.39l-7.5-6zM11 15h3.5a.5.5 0 00.5-.5V6.74l-7-5.6-7 5.6v7.76a.5.5 0 00.5.5H5v-3a3 3 0 116 0v3zm-5 0h4v-3a2 2 0 10-4 0v3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-id-card-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 3.5c0-.186.06-.303.129-.371.068-.07.185-.129.371-.129h13c.186 0 .303.06.371.129.07.068.129.185.129.371v9c0 .186-.06.303-.129.371-.068.07-.185.129-.371.129H9v-1c0-1.676-1.324-3-3-3s-3 1.324-3 3v1H1.5c-.186 0-.303-.06-.371-.129-.07-.068-.129-.185-.129-.371v-9zM3.5 14h-2c-.414 0-.797-.14-1.079-.421C.141 13.297 0 12.914 0 12.5v-9c0-.414.14-.797.421-1.079C.703 2.141 1.086 2 1.5 2h13c.414 0 .797.14 1.079.421.28.282.421.665.421 1.079v9c0 .414-.14.797-.421 1.079-.282.28-.665.421-1.079.421h-11zM8 13H4v-1c0-1.124.876-2 2-2s2 .876 2 2v1zM4 6c0-1.076.924-2 2-2s2 .924 2 2-.924 2-2 2-2-.924-2-2zm2-1c-.524 0-1 .476-1 1s.476 1 1 1 1-.476 1-1-.476-1-1-1zm4 1.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-image-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11A1.5 1.5 0 012.5 1zM2 12.68v.82a.5.5 0 00.5.5h7.91l-4.9-5.72L2 12.68zm11.854 1.174A.5.5 0 0014 13.5v-11a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v8.57l3.11-3.88A.47.47 0 015.49 7a.66.66 0 01.39.17L11.73 14h1.77a.5.5 0 00.354-.146zM8.889 3.337a2 2 0 112.222 3.326A2 2 0 018.89 3.337zm.555 2.494a1 1 0 101.112-1.663 1 1 0 00-1.112 1.663z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-info-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 12c-.3 0-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5s.5.2.5.5v5c0 .3-.2.5-.5.5zm-.5-7.5c0 .3.2.5.5.5s.5-.2.5-.5S8.3 4 8 4s-.5.2-.5.5z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M8 14A6 6 0 108 2a6 6 0 000 12zm0 1A7 7 0 108 1a7 7 0 000 14z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-input-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2 2.682C2 2.308 2.308 2 2.682 2h10.636c.374 0 .682.308.682.682v10.636a.685.685 0 01-.682.682H2.682A.685.685 0 012 13.318V2.682zM2.682 1C1.756 1 1 1.756 1 2.682v10.636C1 14.244 1.756 15 2.682 15h10.636c.926 0 1.682-.756 1.682-1.682V2.682C15 1.756 14.244 1 13.318 1H2.682zM5 4.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-italic-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M9.51 1h4.99a.5.5 0 010 1H9.898l-2.77 12H11.5a.5.5 0 010 1H6.51a.33.33 0 01-.02 0H1.5a.5.5 0 110-1h4.602l2.77-12H4.5a.5.5 0 010-1h5.011z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-key-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6 5.5a4.5 4.5 0 114.5 4.5h-3a.5.5 0 00-.5.5V12H4.5a.5.5 0 00-.5.5V15H1v-3.293l4.854-4.853A.5.5 0 006 6.5v-1zm-1 0a5.5 5.5 0 115.5 5.5H8v1.5a.5.5 0 01-.5.5H5v2.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.146-.354L5 6.293V5.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-lightbulb-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M14 6.316C14 2.59 10.935-.382 7.316.04c-2.64.308-4.833 2.5-5.241 5.267-.26 1.763.177 3.42 1.067 4.71l.224.322c.705 1.01 1.441 2.064 1.634 3.243v.918A1.5 1.5 0 006.5 16h3a1.5 1.5 0 001.5-1.5v-.918c.192-1.216.961-2.3 1.685-3.32.045-.063.09-.125.133-.188A6.496 6.496 0 0014 6.316zM10.149 13c.318-1.275 1.127-2.418 1.881-3.485l.027-.037a5.46 5.46 0 00.993-3.162c0-3.136-2.579-5.638-5.63-5.282a4.68 4.68 0 00-1.106.27c-1.702.64-3.018 2.238-3.301 4.156-.22 1.493.149 2.885.897 3.969l.15.217C4.778 10.681 5.54 11.778 5.85 13H10.149zM6 14.5V14h4v.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-link-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M8.353 2.143l-.69.7a.51.51 0 01-.71 0 .5.5 0 010-.71l.7-.7a4.893 4.893 0 116.92 6.92l-.7.7a.49.49 0 01-.35.15.51.51 0 01-.36-.15.51.51 0 010-.71l.7-.69a3.9 3.9 0 10-5.51-5.51zm2.02 2.78l-.68.68a.51.51 0 000 .71.5.5 0 00.36.14.49.49 0 00.35-.14l.68-.68a.502.502 0 00-.71-.71zM5.5 11a.51.51 0 00.36-.15l.993-.993a.502.502 0 00-.71-.71l-.993.993a.5.5 0 000 .71.5.5 0 00.35.15zm2.843 2.163l-.69.7a3.9 3.9 0 01-5.51-5.51l.7-.69a.51.51 0 000-.71.5.5 0 00-.71 0l-.7.7a4.893 4.893 0 006.92 6.92l.7-.7a.5.5 0 00-.355-.854.51.51 0 00-.355.144zM.853.153l15 15a.478.478 0 010 .7.481.481 0 01-.7 0l-15-15a.48.48 0 010-.7.48.48 0 01.7 0z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-link-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13.446 2.554a3.601 3.601 0 00-5.119.025l-1.5 1.299a.5.5 0 01-.654-.756L7.66 1.834a4.601 4.601 0 016.506 6.506l-1.288 1.487a.5.5 0 11-.756-.654l1.3-1.5a3.601 3.601 0 00.024-5.118zM3.827 6.122a.5.5 0 01.05.705l-1.298 1.5a3.601 3.601 0 105.094 5.094l1.5-1.299a.5.5 0 11.654.756l-1.486 1.288A4.601 4.601 0 011.835 7.66l1.287-1.487a.5.5 0 01.705-.051zm7.027-.268a.5.5 0 00-.708-.708l-5 5a.5.5 0 00.708.708l5-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-list-ol-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2H.5a.5.5 0 010-1h1a.5.5 0 01.5.5v3a.5.5 0 11-1 0V2zm4.51.5h9.99a.5.5 0 100-1H5.51a.5.5 0 000 1zm0 5h9.99a.5.5 0 110 1H5.51a.5.5 0 010-1zm0 6h9.99a.5.5 0 010 1H5.51a.5.5 0 010-1zM2.5 9H1.43l1.09-1.62a.93.93 0 000-.94.83.83 0 00-.69-.44H.5a.5.5 0 000 1h1.07L.48 8.62a.93.93 0 000 .94.83.83 0 00.69.44H2.5a.5.5 0 100-1zm-2 2h1.67a.851.851 0 01.83.88v2.24a.85.85 0 01-.83.88H.5a.5.5 0 010-1H2v-.5H1a.5.5 0 010-1h1V12H.5a.5.5 0 010-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-list-ul-16\" viewBox=\"0 0 16 16\"><path d=\"M2 2a1 1 0 11-2 0 1 1 0 012 0zM4.5 2.5h11a.5.5 0 000-1h-11a.5.5 0 100 1zM4.5 7.5h11a.5.5 0 010 1h-11a.5.5 0 110-1zM4.5 13.5h11a.5.5 0 010 1h-11a.5.5 0 010-1zM2 14a1 1 0 11-2 0 1 1 0 012 0zM1 9a1 1 0 100-2 1 1 0 000 2z\"/></symbol>\n<symbol id=\"icon-lock-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12 8V4a4 4 0 00-8 0v4a5 5 0 108 0zm-1-1V4a3 3 0 00-6 0v3c.836-.628 1.874-1 3-1s2.164.372 3 1zm-3 8a4 4 0 100-8 4 4 0 000 8zm0-3a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-map-pin-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12 5a4 4 0 11-8 0 4 4 0 018 0zM8.5 9.975a5 5 0 10-1 0V15.5a.5.5 0 001 0V9.975z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-merge-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3 2.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm2.027 2.444A2.5 2.5 0 104 4.95v6.1a2.5 2.5 0 101 0V7.474c.248.346.53.662.836.943.92.85 2.088 1.43 3.209 1.557a2.5 2.5 0 10.012-1.007c-.844-.122-1.776-.576-2.543-1.284-.79-.729-1.36-1.685-1.487-2.739zM10 9.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-7 4a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-minus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3 8a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9A.5.5 0 013 8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-paper-plane-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M9.942 15.776c.228.147.495.225.767.224h.09a1.448 1.448 0 001.308-1.059L15.98.648a.48.48 0 00-.15-.5.48.48 0 00-.48-.13L1.053 3.895A1.448 1.448 0 00.004 5.203 1.379 1.379 0 00.853 6.58l6.07 2.497 2.497 6.093c.112.248.293.458.522.605zM1.102 5.005a.45.45 0 01.23-.152l12.481-3.367-6.63 6.625-5.94-2.449a.4.4 0 01-.24-.4.45.45 0 01.098-.257zm6.777 3.787l6.637-6.614-3.368 12.494a.45.45 0 01-.41.33.39.39 0 01-.399-.23l-2.46-5.98z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-paperclip-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13.11 2.89a2.98 2.98 0 00-4.262 0 .496.496 0 11-.703-.702 3.973 3.973 0 015.667 0 3.973 3.973 0 010 5.667l-5.957 5.957a3.973 3.973 0 01-5.667 0 3.973 3.973 0 010-5.667l3.177-3.177a2.235 2.235 0 013.185 0 2.235 2.235 0 010 3.184L5.372 11.33a.497.497 0 01-.702-.702L7.848 7.45a1.242 1.242 0 000-1.78 1.242 1.242 0 00-1.78 0L2.89 8.848a2.98 2.98 0 000 4.262 2.98 2.98 0 004.262 0l5.958-5.957a2.98 2.98 0 000-4.263z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-pen-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M11.016.855a2.919 2.919 0 114.128 4.128l-2.688 2.689a.5.5 0 01-.707-.708l2.688-2.688a1.919 1.919 0 10-2.714-2.714L9.035 4.25a.5.5 0 01-.707-.707L11.016.855zM4.238 8.353a.5.5 0 010 .707l-1.62 1.62-1.332 4.034 4.033-1.332 1.62-1.62a.5.5 0 11.708.707l-1.705 1.705a.5.5 0 01-.196.12l-5.09 1.68a.5.5 0 01-.63-.631l1.68-5.089a.5.5 0 01.12-.197l1.705-1.704a.5.5 0 01.707 0zM.854.147a.5.5 0 00-.708.707l15 15a.5.5 0 00.707-.707l-15-15z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-pen-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15.087.805a3.086 3.086 0 00-4.175.018L8.82 2.926l-7.277 7.311a.501.501 0 00-.127.217L.019 15.362a.502.502 0 00.127.491.497.497 0 00.49.128l4.884-1.402a.497.497 0 00.216-.128l7.276-7.31V7.14h.002l2.092-2.104c1.192-1.197 1.192-3.016 0-4.213a.444.444 0 00-.019-.018zM12.66 6.077l1.741-1.749c.8-.803.803-1.982.01-2.788-.804-.718-2-.718-2.803 0L9.876 3.28l2.784 2.797zM9.171 3.988l-6.833 6.866-1.114 3.916 3.898-1.119 6.834-6.865L9.17 3.988z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-phone-hang-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13.363 6.617C14.423 7.23 15 8.342 15 9.53v.942c0 .413-.139.8-.414 1.086A1.48 1.48 0 0113.5 12h-2.1c-.418 0-.79-.21-1.046-.473-.257-.264-.454-.64-.454-1.056V9.107a6.174 6.174 0 00-3.8 0v1.364c0 .413-.139.8-.414 1.086A1.48 1.48 0 014.6 12H2.5c-.762 0-1.5-.639-1.5-1.529V9.53c0-1.187.578-2.3 1.637-2.912a9.7 9.7 0 0110.726 0zm-.54.842a8.7 8.7 0 00-9.675.018C2.417 7.895 2 8.664 2 9.529v.942c0 .31.262.529.5.529h2.1c.176 0 .292-.06.364-.136a.551.551 0 00.136-.393V8.757a.5.5 0 01.314-.464 7.125 7.125 0 015.172 0 .5.5 0 01.314.464v1.714c0 .1.053.238.171.359.119.122.247.17.329.17h2.1c.176 0 .292-.06.364-.136a.55.55 0 00.136-.393V9.53c0-.865-.417-1.634-1.148-2.052a.535.535 0 01-.029-.018z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-outgoing-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12.146 1.146a.5.5 0 01.708 0l2 2a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708L13.293 4H9.5a.5.5 0 010-1h3.793l-1.147-1.146a.5.5 0 010-.708zM7.116 3.23l-1.75-1.673a1.58 1.58 0 00-2.409.004l-.752.752c-.959.96-1.39 2.35-1.13 3.732v.004a11.276 11.276 0 008.876 8.877c1.315.263 2.706-.176 3.66-1.13l.815-.815c.793-.6.733-1.72.014-2.35l-1.745-1.746a1.7 1.7 0 00-2.389 0l-1.137 1.2A7.28 7.28 0 015.91 6.823l1.205-1.205a1.7 1.7 0 000-2.388zM3.703 2.227c.259-.303.663-.303.922 0l.034.036 1.753 1.676a.7.7 0 01-.003.971L4.957 6.362a.5.5 0 00-.105.553 8.257 8.257 0 004.233 4.233.5.5 0 00.562-.114l1.37-1.447a.7.7 0 01.97.004l1.758 1.758.028.026c.326.279.268.652.035.819a.5.5 0 00-.063.053l-.84.84c-.727.727-1.781 1.053-2.758.857h-.002a10.276 10.276 0 01-8.088-8.087 3.174 3.174 0 01.856-2.838l.764-.764a.5.5 0 00.026-.028z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12 1.5a.5.5 0 011 0V3h1.5a.5.5 0 010 1H13v1.5a.5.5 0 01-1 0V4h-1.5a.5.5 0 010-1H12V1.5zM7.116 3.229l-1.75-1.673a1.58 1.58 0 00-2.409.004l-.752.752c-.959.96-1.39 2.35-1.13 3.732v.004a11.276 11.276 0 008.876 8.877c1.315.263 2.706-.176 3.66-1.13l.815-.815c.793-.6.733-1.72.014-2.35l-1.745-1.746a1.7 1.7 0 00-2.389 0l-1.137 1.2A7.28 7.28 0 015.91 6.823l1.205-1.205a1.7 1.7 0 000-2.388zM3.703 2.227c.259-.303.663-.303.922 0l.034.036 1.753 1.676a.7.7 0 01-.003.971L4.957 6.362a.5.5 0 00-.105.553 8.257 8.257 0 004.233 4.233.5.5 0 00.562-.114l1.37-1.447a.7.7 0 01.97.004l1.758 1.758.028.026c.326.279.268.652.035.819a.5.5 0 00-.063.053l-.84.84c-.727.727-1.781 1.053-2.758.857h-.002a10.276 10.276 0 01-8.088-8.087 3.174 3.174 0 01.856-2.838l.764-.764a.5.5 0 00.026-.028z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-plane-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15 8a1 1 0 00-1-1h-2.5a.5.5 0 01-.416-.223L7.232 1H5.194l1.78 5.342A.5.5 0 016.5 7h-3a.5.5 0 01-.416-.223L1.232 4h-.148l.61 3.923a.5.5 0 010 .154L1.084 12h.148l1.852-2.777A.5.5 0 013.5 9h3a.5.5 0 01.474.658L5.194 15h2.038l3.852-5.777A.5.5 0 0111.5 9H14a1 1 0 001-1zm-1-2a2 2 0 110 4h-2.232l-3.852 5.777A.5.5 0 017.5 16h-3a.5.5 0 01-.474-.658L5.806 10H3.768l-1.852 2.777A.5.5 0 011.5 13h-1a.5.5 0 01-.494-.577L.694 8 .006 3.577A.5.5 0 01.5 3h1a.5.5 0 01.416.223L3.768 6h2.038L4.026.658A.5.5 0 014.5 0h3a.5.5 0 01.416.223L11.768 6H14z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-plug-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.5.5a.5.5 0 00-1 0V4h-2a.5.5 0 00-.5.5V8c0 3.108 2.451 5.719 5.5 5.979V15.5a.5.5 0 001 0v-1.52A5.981 5.981 0 0014 8V4.5a.5.5 0 00-.5-.5h-2V.5a.5.5 0 00-1 0V4h-5V.5zM11 5H3v3c0 2.724 2.276 5 5 5 2.73 0 5-2.182 5-5V5h-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8.5 3.5a.5.5 0 00-1 0v4h-4a.5.5 0 000 1h4v4a.5.5 0 001 0v-4h4a.5.5 0 000-1h-4v-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-print-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.14 0a.5.5 0 00-.33.124L3.812 1H1.5A1.5 1.5 0 000 2.5v4A1.5 1.5 0 001.5 8H3v7.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V8h1.5A1.5 1.5 0 0016 6.5v-4A1.5 1.5 0 0014.5 1h-2.312L11.19.124A.5.5 0 0010.86 0H5.14zM12 8H4v7h8V8zM4.33 1.876L5.328 1h5.344l.998.876A.5.5 0 0012 2h2.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5H4a.5.5 0 00.33-.124zM6.09 10a.5.5 0 000 1h3.82a.5.5 0 000-1H6.09zm-.5 2.5a.5.5 0 01.5-.5h3.82a.5.5 0 010 1H6.09a.5.5 0 01-.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-question-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.556 14.654A7.992 7.992 0 008 16a7.992 7.992 0 007.391-4.936 8 8 0 10-11.835 3.59zm.524-12.48A6.992 6.992 0 018 1.006a6.992 6.992 0 014.996 2.05A7.034 7.034 0 018.025 15.06a7.029 7.029 0 01-4.971-2.06A6.998 6.998 0 014.08 2.174zm3.926 7.832a.48.48 0 01-.42-.23.5.5 0 01.15-.69l1.32-.84a1.66 1.66 0 00.95-1.49v-.11a1.65 1.65 0 00-1.64-1.64h-.72a1.65 1.65 0 00-1.64 1.64.5.5 0 01-1 0 2.65 2.65 0 012.64-2.64h.72a2.65 2.65 0 012.64 2.64v.11a2.63 2.63 0 01-1.46 2.36l-1.27.81a.53.53 0 01-.27.08zm0 2a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-rec-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M0 3.5A1.5 1.5 0 011.5 2h13A1.5 1.5 0 0116 3.5v9a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 12.5v-9zM1.5 3a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-13zm8 2a.5.5 0 010 1H8v1.5h.5a.5.5 0 010 1H8V10h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h2zM2 10.333V5.53A.53.53 0 012.53 5H4a2 2 0 01.612 3.905l1.242 1.241a.5.5 0 01-.708.708L3.293 9H3v1.333c0 .368-.224.667-.5.667s-.5-.299-.5-.667zM3.5 8H4a1 1 0 000-2H3v2h.5zM11 6.5A1.5 1.5 0 0112.5 5h1a.5.5 0 010 1h-1a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h1a.5.5 0 010 1h-1A1.5 1.5 0 0111 9.5v-3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-reply-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6.7 1.035a.5.5 0 01.318.465L7 5c1.982.024 3.645.101 5.02.53 1.496.468 2.656 1.225 3.332 2.259 1.393 2.132.532 5.027-2.504 8.065a.5.5 0 01-.85-.41c.24-2.164-.255-3.174-1.085-3.712-.446-.29-1.037-.477-1.786-.589-.62-.092-1.324-.13-2.109-.14V14.5a.5.5 0 01-.866.34L.133 8.34a.5.5 0 010-.68l6.019-6.5a.5.5 0 01.549-.125zM1.182 8l4.838 5.225V10.5a.5.5 0 01.5-.5c1 0 1.932.031 2.755.154.822.123 1.57.341 2.183.739 1.012.656 1.54 1.715 1.595 3.268 2.121-2.5 2.328-4.501 1.463-5.825-.508-.778-1.437-1.427-2.793-1.85C10.37 6.062 8.5 6 6.548 5.998a.5.5 0 01-.53-.499V2.776L1.182 8z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-route-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M10.854.854a.5.5 0 00-.708-.708l-3 3a.5.5 0 000 .708l3 3a.5.5 0 00.708-.708L8.707 4H10.5C11.924 4 13 5.076 13 6.5v4.55a2.5 2.5 0 101 0V6.5C14 4.524 12.476 3 10.5 3H8.707L10.854.854zM13.5 12a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM1 2.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm4 0a2.5 2.5 0 01-2 2.45V9.5C3 10.924 4.076 12 5.5 12h1.793L5.146 9.854a.5.5 0 11.708-.708l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L7.293 13H5.5C3.524 13 2 11.476 2 9.5V4.95A2.5 2.5 0 115 2.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-search-minus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M6.5 11a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 1c1.34 0 2.567-.479 3.52-1.274a.56.56 0 00.026.028l4.1 4.1a.5.5 0 00.708-.708l-4.1-4.1a.518.518 0 00-.028-.025A5.5 5.5 0 106.5 12zm-2-6a.5.5 0 000 1h4a.5.5 0 000-1h-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-search-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-.98 4.227a5.5 5.5 0 11.707-.707l4.127 4.126a.5.5 0 01-.708.708l-4.127-4.127zM7 4.5a.5.5 0 00-1 0V6H4.5a.5.5 0 000 1H6v1.5a.5.5 0 001 0V7h1.5a.5.5 0 000-1H7V4.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-search-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-.952 4.203a5.5 5.5 0 11.654-.654.489.489 0 01.135.095l4.02 4.02a.49.49 0 11-.694.692l-4.02-4.02a.489.489 0 01-.095-.133z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-smile-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 8a7 7 0 1114 0A7 7 0 011 8zm7-8a8 8 0 100 16A8 8 0 008 0zM5.146 10.146a.5.5 0 000 .708C5.841 11.548 6.87 12 8 12s2.159-.452 2.854-1.146a.5.5 0 00-.708-.708C9.641 10.652 8.87 11 8 11s-1.641-.348-2.146-.854a.5.5 0 00-.708 0zM6 7.5a.5.5 0 11-1 0 .5.5 0 011 0zm4.5.5a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-social-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M12 2.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM13.5 0a2.5 2.5 0 00-2.412 3.16L4.459 6.947a2.5 2.5 0 10.04 3.054l6.583 2.862A2.502 2.502 0 0013.5 16a2.5 2.5 0 10-1.974-4.034L4.928 9.097a2.506 2.506 0 00-.016-1.257l6.628-3.787A2.5 2.5 0 1013.5 0zm0 12a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM1 8.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-star-full-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path d=\"M3.558 15.989a1.139 1.139 0 01-1.07-1.508l1.45-4.486-3.58-2.697a1.119 1.119 0 01-.28-1.229 1 1 0 011-.62h4.37L6.918.806a1.119 1.119 0 012.15 0l1.41 4.655h4.45a1 1 0 011 .61 1.138 1.138 0 01-.23 1.188l-3.65 2.737 1.46 4.505a1.168 1.168 0 01-.4 1.279 1.141 1.141 0 01-1.35 0l-3.76-2.787-3.77 2.777c-.194.143-.43.22-.67.22z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-star-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path d=\"M3.558 15.989a1.139 1.139 0 01-1.07-1.508l1.45-4.486-3.58-2.697a1.119 1.119 0 01-.28-1.229 1 1 0 011-.62h4.37L6.918.806a1.119 1.119 0 012.15 0l1.41 4.655h4.45a1 1 0 011 .61 1.138 1.138 0 01-.23 1.188l-3.65 2.737 1.46 4.505a1.168 1.168 0 01-.4 1.279 1.141 1.141 0 01-1.35 0l-3.76-2.787-3.77 2.777c-.194.143-.43.22-.67.22zm4.44-4.106a.52.52 0 01.29.09l4.07 2.997.075.046h.067c.027-.023.044-.08.053-.113a.17.17 0 00-.005-.103l-1.55-4.805a.49.49 0 01.17-.55l3.83-2.946h-4.89a.5.5 0 01-.48-.35l-1.51-4.995a.14.14 0 00-.25 0L6.298 6.1a.5.5 0 01-.48.35h-4.73a.24.24 0 00-.1 0l3.84 2.947a.51.51 0 01.17.6l-1.56 4.784a.16.16 0 00.05.18.11.11 0 00.14 0l4.07-2.967a.53.53 0 01.3-.11z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-sticky-note-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.15 15h9.21a1.77 1.77 0 001.27-.53l1.84-1.84a1.79 1.79 0 00.53-1.27V2.15A1.16 1.16 0 0013.85 1H2.15A1.16 1.16 0 001 2.15v11.7A1.16 1.16 0 002.15 15zM2.044 2.044A.15.15 0 012.15 2h11.7a.15.15 0 01.15.15V9h-3.85A1.16 1.16 0 009 10.15V14H2.15a.15.15 0 01-.15-.15V2.15a.15.15 0 01.044-.106zM10 14h1.36a.81.81 0 00.57-.23l1.84-1.84a.79.79 0 00.23-.57V10h-3.85a.15.15 0 00-.15.15V14z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-tag-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6.035 15.858c.227.094.47.142.715.142a1.829 1.829 0 001.32-.5L15.46 8A1.83 1.83 0 0016 6.64V1.86a1.81 1.81 0 00-.55-1.31A1.81 1.81 0 0014.14 0H9.36a1.87 1.87 0 00-1.31.54L.54 7.93a1.87 1.87 0 000 2.63l4.89 4.89c.173.175.379.313.605.408zM9.031 1.064A.86.86 0 019.36 1h4.78a.85.85 0 01.86.86v4.78a.86.86 0 01-.25.61l-7.39 7.5a.88.88 0 01-1.22 0L1.25 9.86a.86.86 0 010-1.22l7.5-7.39a.86.86 0 01.28-.186zM12.5 4a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-team-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.5 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM8 1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm-6.146 9.854a.5.5 0 00-.708-.708c-.37.37-.651.893-.84 1.406C.116 12.068 0 12.628 0 13.1v.4a.5.5 0 001 0v-.4c0-.328.084-.768.244-1.202.161-.437.38-.814.61-1.044zm12.292-.708a.5.5 0 01.708 0c.37.37.651.893.84 1.406.19.516.306 1.076.306 1.548v.4a.5.5 0 01-1 0v-.4c0-.328-.084-.768-.244-1.202-.161-.437-.38-.814-.61-1.044a.5.5 0 010-.708zM8 9c-3.052 0-5 2.1-5 4.5v1a.5.5 0 001 0v-1C4 11.7 5.452 10 8 10c2.547 0 4 1.7 4 3.5v1a.5.5 0 001 0v-1C13 11.1 11.053 9 8 9zM2.5 4C1.676 4 1 4.676 1 5.5S1.676 7 2.5 7a.5.5 0 010 1A2.506 2.506 0 010 5.5C0 4.124 1.124 3 2.5 3a.5.5 0 010 1zm11-1a.5.5 0 000 1c.824 0 1.5.676 1.5 1.5S14.324 7 13.5 7a.5.5 0 000 1C14.876 8 16 6.876 16 5.5S14.876 3 13.5 3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-th-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zM2 6v4h3V6H2zm3-1H2V2.5a.5.5 0 01.5-.5H5v3zm1 1v4h4V6H6zm4-1H6V2h4v3zm1 1v4h3V6h-3zm3-1h-3V2h2.5a.5.5 0 01.5.5V5zm-4 6H6v3h4v-3zm-5 0H2v2.5a.5.5 0 00.5.5H5v-3zm9 0h-3v3h2.5a.5.5 0 00.5-.5V11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbs-down-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8.938 15c.511 0 .992-.24 1.299-.65L12.9 10.8a.5.5 0 00.1-.3v-6A3.5 3.5 0 009.5 1h-3a4.5 4.5 0 00-3.6 1.8L1.1 5.2a.5.5 0 00-.1.3v4A1.5 1.5 0 002.5 11h5.36l-.496 1.983A1.623 1.623 0 008.938 15zm.499-1.25a.623.623 0 01-1.103-.524l.651-2.605A.5.5 0 008.5 10h-6a.5.5 0 01-.5-.5V5.667L3.7 3.4A3.5 3.5 0 016.5 2h3A2.5 2.5 0 0112 4.5v5.833l-2.563 3.418zM14 10.5a.5.5 0 001 0v-8a.5.5 0 00-1 0v8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbs-up-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M7.062 1c-.511 0-.992.24-1.299.65L3.1 5.2a.5.5 0 00-.1.3v6A3.5 3.5 0 006.5 15h3a4.5 4.5 0 003.6-1.8l1.8-2.4a.5.5 0 00.1-.3v-4A1.5 1.5 0 0013.5 5H8.14l.496-1.983A1.623 1.623 0 007.062 1zm-.499 1.25a.623.623 0 011.103.524L7.015 5.38A.5.5 0 007.5 6h6a.5.5 0 01.5.5v3.833L12.3 12.6A3.5 3.5 0 019.5 14h-3A2.5 2.5 0 014 11.5V5.667l2.563-3.418zM2 5.5a.5.5 0 00-1 0v8a.5.5 0 001 0v-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbtack-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.5 0h8a.5.5 0 010 1H12v5.273a6.148 6.148 0 012 4.199.5.5 0 01-.5.528h-5v4.5a.5.5 0 01-1 0V11h-5a.5.5 0 01-.5-.528 6.15 6.15 0 012-4.199V1h-.5a.5.5 0 010-1h1zM5 1v5.5a.5.5 0 01-.178.382A5.15 5.15 0 003.057 10H7.5V6.5a.5.5 0 011 0V10h4.443a5.15 5.15 0 00-1.765-3.118A.5.5 0 0111 6.5V1H5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-transcript-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15 5.967v1.25l-1 .6V5.02l.735.505a.5.5 0 01.265.442zm-1-2.153V3.5A1.5 1.5 0 0012.5 2h-9A1.5 1.5 0 002 3.5v.314l-1.206.83A1.5 1.5 0 000 5.966V13.5A1.5 1.5 0 001.5 15h13a1.5 1.5 0 001.5-1.5V5.967a1.5 1.5 0 00-.794-1.324L14 3.814zM2 5.02l-.735.505A.5.5 0 001 5.967v1.25l1 .6V5.02zm1 3.397V3.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v4.917l-4.228 2.537a1.5 1.5 0 01-1.544 0L3 8.417zm-1 .566V9h.028l4.686 2.811a2.5 2.5 0 002.572 0L13.972 9H14v-.017l1-.6V13.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V8.383l1 .6zM9.605 2h1.755L8.706.176a1.5 1.5 0 00-1.412 0L4.64 2h1.755l1.37-.941a.5.5 0 01.47 0L9.605 2zM5.5 5h5a.5.5 0 010 1h-5a.5.5 0 010-1zm5 2h-5a.5.5 0 000 1h5a.5.5 0 000-1z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-trash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path d=\"M14.461 3H11.97V2c0-.514-.196-1.008-.549-1.38A1.992 1.992 0 0010.074 0H5.886A1.992 1.992 0 004.54.62c-.353.372-.55.866-.549 1.38v1H1.5A.498.498 0 001 3.5a.5.5 0 00.499.5h.498l.888 10.62A1.502 1.502 0 004.41 16h7.14a1.493 1.493 0 001.486-1.38L13.963 4h.538A.498.498 0 0015 3.5a.5.5 0 00-.499-.5h-.04zM4.99 2a1.002 1.002 0 01.897-1h4.188a.996.996 0 01.898 1v1H4.989V2zm7.06 12.54a.5.5 0 01-.5.46H4.41a.498.498 0 01-.498-.46L2.994 4h9.972l-.918 10.54z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-upload-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 1a.5.5 0 01.376.17l3.5 4a.5.5 0 01-.752.66l-2.624-3v7.67a.5.5 0 01-1 0V2.83l-2.624 3a.5.5 0 11-.752-.66l3.5-4A.5.5 0 018 1zM2.5 14a.5.5 0 000 1h11a.5.5 0 000-1h-11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-url-trigger-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 1.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5V4H1V1.5zM1 5v8h3.5a.5.5 0 010 1h-4a.5.5 0 01-.5-.5v-12A1.5 1.5 0 011.5 0h11A1.5 1.5 0 0114 1.5v4a.5.5 0 01-1 0V5H1zm2-2.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM7 2.5a.5.5 0 11-1 0 .5.5 0 011 0zm2.955 4.455a3 3 0 100 6 3 3 0 000-6zm-4 3a4 4 0 117.16 2.452l2.739 2.74a.5.5 0 01-.708.707l-2.739-2.74a4 4 0 01-6.453-3.16z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM5.5 1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 8C2.557 9 0 10.807 0 13.3v1.2a.5.5 0 001 0v-1.2C1 11.593 2.843 10 5.5 10s4.5 1.593 4.5 3.3v1.2a.5.5 0 001 0v-1.2C11 10.807 8.443 9 5.5 9zm8-4a.5.5 0 01.5.5V7h1.5a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0V8h-1.5a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-secret-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6.658.026a.5.5 0 00-.618.277L4.644 3.561l-2.242.449a.5.5 0 00-.048.968c.59.181 1.15.339 1.683.472A4.036 4.036 0 004.126 7H2.5a.5.5 0 00-.447.724l.767 1.534a3.73 3.73 0 00-.94.652 2.764 2.764 0 00-.73 1.238c-.134.457-.178.962-.188 1.507-.008.414.003.875.015 1.376l.011.479C1.006 15.327 1.67 16 2.5 16h11c.826 0 1.505-.671 1.497-1.505-.012-1.221-.067-2.323-.37-3.239-.265-.805-.72-1.464-1.469-1.954l.79-1.578A.5.5 0 0013.5 7h-1.626a4.01 4.01 0 00.09-1.542 31.52 31.52 0 001.685-.48.5.5 0 00-.05-.968l-2.243-.449L9.96.303a.5.5 0 00-.618-.277L8 .473 6.658.026zm4.325 5.656c-1.031.21-1.992.317-2.96.316-.977 0-1.952-.11-3.005-.325a3 3 0 105.966.01zM5.46 4.197L6.778 1.12l1.064.354a.5.5 0 00.316 0l1.064-.354 1.318 3.077a.5.5 0 00.362.293l.444.09c-1.204.281-2.265.419-3.322.418-1.06 0-2.13-.14-3.35-.423l.424-.085a.5.5 0 00.362-.293zm1.487 7.08l-.89-1.78C6.634 9.818 7.296 10 8 10c.705 0 1.367-.182 1.942-.502l-.724 1.447a1.5 1.5 0 00-.113 1.035L9.86 15H6.14l.845-3.379a.5.5 0 00-.038-.345zM11.81 8l-1.696 3.393a.5.5 0 00-.038.345L10.89 15h2.61c.278 0 .5-.225.497-.496-.012-1.227-.071-2.184-.319-2.934-.237-.716-.645-1.244-1.402-1.623a.5.5 0 01-.223-.67L12.69 8h-.882zm-8.5 0h.882l1.78 3.558L5.11 15H2.5a.519.519 0 01-.512-.511l-.011-.5c-.012-.494-.023-.925-.015-1.315.01-.514.051-.915.147-1.246.094-.321.24-.578.47-.804.237-.231.583-.45 1.107-.66a.5.5 0 00.261-.688L3.31 8z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-user-slash-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.146.146a.5.5 0 01.708 0l15 15a.5.5 0 01-.708.708l-15-15a.5.5 0 010-.708zM6.188.71C6.797.222 7.615 0 8.4 0 10.376 0 12 1.624 12 3.6c0 .785-.222 1.603-.71 2.212a.5.5 0 11-.78-.624c.312-.391.49-.973.49-1.588C11 2.176 9.824 1 8.4 1c-.615 0-1.197.178-1.588.49a.5.5 0 11-.624-.78zm.433 10.262a.493.493 0 00.36-.607.516.516 0 00-.63-.347c-1.178.31-2.378.748-3.12 1.367C2.482 12.008 2 12.802 2 13.725v1.78c0 .274.23.495.514.495a.504.504 0 00.513-.495v-1.78c0-.56.287-1.102.875-1.592.593-.494 1.639-.877 2.72-1.161z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-user-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5 4a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8zm0 10c-1.577 0-3.044.393-4.132 1.046C2.792 11.691 2 12.652 2 13.8v1.7a.5.5 0 001 0v-1.7c0-.652.458-1.341 1.382-1.896C5.294 11.357 6.577 11 8 11s2.706.357 3.618.904C12.542 12.459 13 13.149 13 13.8v1.7a.5.5 0 001 0v-1.7c0-1.149-.792-2.109-1.868-2.754C11.044 10.393 9.577 10 8 10z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-users-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M5.5 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM2 4.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm9.565 4.504a.5.5 0 10-.13.992C13.571 10.274 15 11.728 15 13.3v1.2a.5.5 0 101 0v-1.2c0-2.228-1.971-3.974-4.435-4.296zM5.5 9C2.557 9 0 10.807 0 13.3v1.2a.5.5 0 001 0v-1.2C1 11.593 2.843 10 5.5 10s4.5 1.593 4.5 3.3v1.2a.5.5 0 001 0v-1.2C11 10.807 8.443 9 5.5 9zm5-8a.5.5 0 000 1C11.924 2 13 3.076 13 4.5S11.924 7 10.5 7a.5.5 0 000 1C12.476 8 14 6.476 14 4.5S12.476 1 10.5 1z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-video-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1.87 14h8.26A1.87 1.87 0 0012 12.13v-1.82l3.28 1.64a.54.54 0 00.22.05.48.48 0 00.434-.255A.52.52 0 0016 11.5v-7a.52.52 0 00-.24-.4.48.48 0 00-.48 0L12 5.74V3.87A1.87 1.87 0 0010.13 2H1.87A1.87 1.87 0 000 3.87v8.26A1.87 1.87 0 001.87 14zM11 6.52a.51.51 0 000 .06v2.89a.51.51 0 000 .06v2.6a.87.87 0 01-.87.87H1.87a.87.87 0 01-.87-.87V3.87A.87.87 0 011.87 3h8.26a.87.87 0 01.87.87v2.65zm1 2.67V6.856l3-1.546v5.38l-3-1.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-widget-customize-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 3a.5.5 0 00-.5.5V13h12V9.5a.5.5 0 011 0V13h.5a.5.5 0 010 1H.5a.5.5 0 110-1H1V3.5A1.5 1.5 0 012.5 2h4a.5.5 0 010 1h-4zm9.82.3c.4-.4.978-.4 1.38 0 .4.402.4.98 0 1.38L9.311 9.068l-2.036.657.657-2.036L12.319 3.3zm2.086-.706a1.94 1.94 0 00-2.794 0L7.14 7.066a.5.5 0 00-.122.2l-.994 3.08a.5.5 0 00.63.63l3.08-.994a.5.5 0 00.2-.122l4.472-4.472a1.94 1.94 0 000-2.794z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-plus-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 0a.5.5 0 01.5.5V2h7V.5a.5.5 0 011 0V2h1.61C15.158 2 16 2.803 16 3.8v10.4a.501.501 0 01-.005.07c-.131.926-.92 1.73-1.985 1.73H1.89C.842 16 0 15.197 0 14.2V3.8C0 2.803.841 2 1.89 2H3.5V.5A.5.5 0 014 0zm7.5 3v.5a.5.5 0 001 0V3h1.61c.54 0 .89.397.89.8v10.361c-.08.46-.477.839-.99.839H1.89c-.54 0-.89-.397-.89-.8V3.8c0-.403.35-.8.89-.8H3.5v.5a.5.5 0 001 0V3h7zM8 6a.5.5 0 01.5.5v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-1 0v-2h-2a.5.5 0 010-1h2v-2A.5.5 0 018 6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-times-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 0a.5.5 0 01.5.5V2h7V.5a.5.5 0 011 0V2h1.61C15.158 2 16 2.803 16 3.8v10.4a.501.501 0 01-.005.07c-.131.926-.92 1.73-1.985 1.73H1.89C.842 16 0 15.197 0 14.2V3.8C0 2.803.841 2 1.89 2H3.5V.5A.5.5 0 014 0zm7.5 3v.5a.5.5 0 001 0V3h1.61c.54 0 .89.397.89.8v10.361c-.08.46-.477.839-.99.839H1.89c-.54 0-.89-.397-.89-.8V3.8c0-.403.35-.8.89-.8H3.5v.5a.5.5 0 001 0V3h7zM6.146 7.146a.5.5 0 01.708 0L8 8.293l1.146-1.147a.5.5 0 11.708.708L8.707 9l1.147 1.146a.5.5 0 01-.708.708L8 9.707l-1.146 1.147a.5.5 0 01-.708-.708L7.293 9 6.146 7.854a.5.5 0 010-.708z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 0a.5.5 0 01.5.5V2h7V.5a.5.5 0 011 0V2h1.61C15.158 2 16 2.803 16 3.8v10.4a.501.501 0 01-.005.07c-.131.926-.92 1.73-1.985 1.73H1.89C.842 16 0 15.197 0 14.2V3.8C0 2.803.841 2 1.89 2H3.5V.5A.5.5 0 014 0zm7.5 3v.5a.5.5 0 001 0V3h1.61c.54 0 .89.397.89.8V6H1V3.8c0-.403.35-.8.89-.8H3.5v.5a.5.5 0 001 0V3h7zM15 7v7.161c-.08.46-.477.839-.99.839H1.89c-.54 0-.89-.397-.89-.8V7h14z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-one-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 8a7 7 0 1114 0A7 7 0 011 8zm7-8a8 8 0 100 16A8 8 0 008 0zm0 4.5a.5.5 0 00-1 0v5.1a.5.5 0 00.92.271l2-3.1a.5.5 0 10-.84-.542L8 7.903V4.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-three-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 8a7 7 0 1114 0A7 7 0 011 8zm7-8a8 8 0 100 16A8 8 0 008 0zm0 4.5a.5.5 0 00-1 0v4a.5.5 0 00.5.5h3a.5.5 0 000-1H8V4.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1 8a7 7 0 1114 0A7 7 0 011 8zm7-8a8 8 0 100 16A8 8 0 008 0zm1 4.49C9 4.22 8.799 4 8.5 4s-.5.22-.5.49v3.53H5.54c-.298 0-.54.22-.54.49s.242.49.54.49h2.92c.298 0 .54-.22.54-.49V4.49z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-history-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M3.046 7.246A5.986 5.986 0 019 2c3.324 0 6 2.676 6 6s-2.676 6-6 6a.5.5 0 000 1c3.876 0 7-3.124 7-7s-3.124-7-7-7a6.986 6.986 0 00-6.968 6.325L.854 6.146a.5.5 0 10-.708.708l2 2a.5.5 0 00.708 0l2-2a.5.5 0 10-.708-.708l-1.1 1.1zM8.5 5a.5.5 0 01.5.5V8h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-moon-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M9.025 0c.285 0 .655 0 1.033.126a.5.5 0 01.17.852C8.838 2.18 8 3.942 8 6c0 3.641 2.704 6.53 6.154 6.903a.5.5 0 01.3.85A7.677 7.677 0 019 16c-4.376 0-8-3.624-8-8 0-4.376 3.624-8 8-8h.025zm-.229 1.003C5.064 1.113 2 4.244 2 8c0 3.824 3.176 7 7 7a6.69 6.69 0 003.977-1.293A7.893 7.893 0 017 6c0-1.937.657-3.667 1.796-4.997z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-sun-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M11.98.36a.5.5 0 00-.642-.333L8 1.171 4.662.027a.5.5 0 00-.636.315l-.921 2.763-2.763.92a.5.5 0 00-.315.637L1.171 8 .027 11.338a.5.5 0 00.334.642l2.835.823.824 2.836a.5.5 0 00.642.334L8 14.829l3.338 1.144a.5.5 0 00.642-.334l.823-2.835 2.836-.824a.5.5 0 00.334-.642L14.829 8l1.144-3.338a.5.5 0 00-.334-.642l-2.835-.823L11.98.36zM3.974 3.659l.84-2.521 3.024 1.036a.5.5 0 00.324 0l3.004-1.03.754 2.596a.5.5 0 00.34.341l2.597.754-1.03 3.004a.5.5 0 000 .324l1.03 3.004-2.596.754a.5.5 0 00-.341.34l-.754 2.597-3.004-1.03a.5.5 0 00-.324 0l-3.004 1.03-.754-2.596a.5.5 0 00-.34-.341l-2.597-.754 1.03-3.004a.5.5 0 000-.324L1.137 4.815l2.521-.84a.5.5 0 00.316-.317zM5 8a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-callback-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11.854 5.854a.5.5 0 01-.708 0l-2-2a.5.5 0 010-.708l2-2a.5.5 0 01.708.708L10.707 3H14.5a.5.5 0 010 1h-3.793l1.147 1.146a.5.5 0 010 .708zM5.367 1.556l1.749 1.673a1.7 1.7 0 010 2.388L5.91 6.822a7.28 7.28 0 003.258 3.263l1.137-1.2a1.7 1.7 0 012.389 0l1.745 1.745c.719.63.78 1.75-.014 2.35l-.814.814c-.955.955-2.346 1.394-3.66 1.13a11.276 11.276 0 01-8.877-8.876v-.004a4.174 4.174 0 011.13-3.732l.752-.752a1.58 1.58 0 012.41-.004zm-.742.67c-.26-.302-.663-.302-.922 0a.5.5 0 01-.026.029l-.764.764a3.175 3.175 0 00-.856 2.838 10.276 10.276 0 008.088 8.087h.002c.977.196 2.031-.13 2.758-.857l.84-.84a.5.5 0 01.063-.053c.233-.167.29-.54-.035-.819a.495.495 0 01-.028-.026l-1.757-1.758a.7.7 0 00-.97-.004l-1.37 1.447a.5.5 0 01-.563.114 8.257 8.257 0 01-4.233-4.233.5.5 0 01.105-.553L6.409 4.91a.7.7 0 00.003-.97L4.659 2.262a.502.502 0 01-.034-.036z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-voicemail-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h13a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0014.5 2h-13zM1 3.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-9zM6 8a1 1 0 11-2 0 1 1 0 012 0zm1 0c0 .364-.097.706-.268 1h2.536A2 2 0 1111 10H5a2 2 0 112-2zm5 0a1 1 0 11-2 0 1 1 0 012 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-widget-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.129 3.129C2.059 3.197 2 3.314 2 3.5V13h5v-1.5c0-.414.14-.797.421-1.079.282-.28.665-.421 1.079-.421h3c.414 0 .797.14 1.079.421.28.282.421.665.421 1.079V13h1V3.5c0-.186-.06-.303-.129-.371-.068-.07-.185-.129-.371-.129h-11c-.186 0-.303.06-.371.129zM13 14H.5a.5.5 0 010-1H1V3.5c0-.414.14-.797.421-1.079C1.703 2.141 2.086 2 2.5 2h11c.414 0 .797.14 1.079.421.28.282.421.665.421 1.079V13h.5a.5.5 0 010 1H13zm-1-1v-1.5c0-.186-.06-.303-.129-.371-.068-.07-.185-.129-.371-.129h-3c-.186 0-.303.06-.371.129-.07.068-.129.185-.129.371V13h4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.5 2c-1.154 0-2.33.537-3.146 1.354C1.533 4.174 1 5.252 1 6.5c0 2.155 1.526 3.96 3.606 4.411A.5.5 0 015 11.4v2.166l3.723-2.482A.5.5 0 019 11h1.5c1.153 0 2.33-.537 3.146-1.354C14.467 8.826 15 7.748 15 6.5 15 3.976 13.024 2 10.5 2h-5zm-3.854.646C2.63 1.663 4.054 1 5.5 1h5C13.576 1 16 3.424 16 6.5c0 1.552-.667 2.874-1.646 3.854C13.37 11.337 11.947 12 10.5 12H9.151l-4.374 2.916A.5.5 0 014 14.5v-2.712c-2.319-.68-4-2.782-4-5.288 0-1.552.667-2.874 1.646-3.854z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-facebook-messenger-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.354 3.354C3.17 2.537 4.346 2 5.5 2h5C13.024 2 15 3.976 15 6.5c0 1.248-.533 2.326-1.354 3.146C12.83 10.463 11.653 11 10.5 11H9a.5.5 0 00-.277.084L5 13.566V11.4a.5.5 0 00-.394-.489C2.526 10.46 1 8.655 1 6.5c0-1.248.533-2.326 1.354-3.146zM5.5 1c-1.446 0-2.87.663-3.854 1.646C.667 3.626 0 4.948 0 6.5c0 2.506 1.681 4.608 4 5.288V14.5a.5.5 0 00.777.416L9.151 12H10.5c1.447 0 2.87-.663 3.854-1.646C15.333 9.374 16 8.052 16 6.5 16 3.424 13.576 1 10.5 1h-5zm1.886 4l1.65 1.377L12 5 8.65 8 7.034 6.565 4 7.957 7.386 5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-mail-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M1 3.5c0-.186.06-.303.129-.371.068-.07.185-.129.371-.129h13c.186 0 .303.06.371.129.07.068.129.185.129.371V5L8.614 7.893a1.814 1.814 0 01-1.227 0L1 5V3.5zm-1 2v-2c0-.414.14-.797.421-1.079C.703 2.141 1.086 2 1.5 2h13c.414 0 .797.14 1.079.421.28.282.421.665.421 1.079v9c0 .414-.14.797-.421 1.079-.282.28-.665.421-1.079.421h-13c-.414 0-.797-.14-1.079-.421C.141 13.297 0 12.914 0 12.5v-7zM15 6v6.5c0 .186-.06.303-.129.371-.068.07-.185.129-.371.129h-13c-.186 0-.303-.06-.371-.129-.07-.068-.129-.185-.129-.371V6l6.004 2.817a2.811 2.811 0 001.992 0L15 6z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-messaging-settings-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.5 2c-1.154 0-2.33.537-3.146 1.354C1.533 4.174 1 5.252 1 6.5c0 2.155 1.526 3.96 3.606 4.411A.5.5 0 015 11.4v2.166l3.723-2.482A.5.5 0 019 11h1.5c1.153 0 2.33-.537 3.146-1.354C14.467 8.826 15 7.748 15 6.5 15 3.976 13.024 2 10.5 2h-5zm-3.854.646C2.63 1.663 4.054 1 5.5 1h5C13.576 1 16 3.424 16 6.5c0 1.552-.667 2.874-1.646 3.854C13.37 11.337 11.947 12 10.5 12H9.151l-4.374 2.916A.5.5 0 014 14.5v-2.712c-2.319-.68-4-2.782-4-5.288 0-1.552.667-2.874 1.646-3.854zm7.301 1.63a.5.5 0 10-.894.448L8.69 6H6.5a.5.5 0 00-.447.724l1 2a.5.5 0 10.894-.448L7.31 7H9.5a.5.5 0 00.447-.724l-1-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-messenger-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.5 1A1.5 1.5 0 001 2.5v8A1.5 1.5 0 002.5 12H4v2.5a.5.5 0 00.777.416L9.151 12H13.5a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0013.5 1h-11zm6.355 10.021a.5.5 0 00-.138.067L5 13.566V11.5a.5.5 0 00-.5-.5h-2a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v8a.5.5 0 01-.5.5H9c-.05 0-.1.008-.145.021zM7 6.5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.367 1.556l1.749 1.673a1.7 1.7 0 010 2.388L5.91 6.822a7.28 7.28 0 003.258 3.263l1.137-1.2a1.7 1.7 0 012.389 0l1.745 1.745c.719.63.78 1.75-.014 2.35l-.814.814c-.955.955-2.346 1.394-3.66 1.13a11.276 11.276 0 01-8.877-8.876v-.004a4.174 4.174 0 011.13-3.732l.752-.752a1.58 1.58 0 012.41-.004zm-.742.67c-.26-.302-.663-.302-.922 0a.5.5 0 01-.026.029l-.764.764a3.174 3.174 0 00-.856 2.838 10.276 10.276 0 008.088 8.087h.002c.977.196 2.031-.13 2.758-.857l.84-.84a.5.5 0 01.063-.053c.233-.167.29-.54-.035-.819a.495.495 0 01-.028-.026l-1.757-1.758a.7.7 0 00-.97-.004l-1.37 1.447a.5.5 0 01-.563.114 8.257 8.257 0 01-4.233-4.233.5.5 0 01.105-.553L6.409 4.91a.7.7 0 00.003-.97L4.659 2.262a.502.502 0 01-.034-.036z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-simultaneous-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 15a7 7 0 006.76-8.823 3.001 3.001 0 11-3.118-4.156A7 7 0 001.24 9.823a3 3 0 113.119 4.156A6.968 6.968 0 008 15zm0 1A8 8 0 108 0a8 8 0 000 16zm-4-3a2 2 0 100-4 2 2 0 000 4zm10-8a2 2 0 11-4 0 2 2 0 014 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-whatsapp-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.502 1h5.002a5.456 5.456 0 015.085 3.373 5.443 5.443 0 01-1.233 5.973 5.555 5.555 0 01-3.852 1.65h-1.35l-4.372 2.918a.5.5 0 01-.78-.42v-2.708A5.523 5.523 0 010 6.498a5.404 5.404 0 011.65-3.849A5.555 5.555 0 015.503 1zm5.002 9.996a4.644 4.644 0 003.152-1.35A4.457 4.457 0 0010.504 2H5.502a4.644 4.644 0 00-3.151 1.35 4.408 4.408 0 00-1.35 3.148 4.526 4.526 0 003.61 4.408.49.49 0 01.391.49v2.169l3.722-2.49a.54.54 0 01.28-.08h1.5zM9.7 7.12c.13.04.85.36 1 .429l.056.022c.117.046.192.076.244.127v.081c.001.242.002.397-.1.577a1.488 1.488 0 01-1 .628 3.068 3.068 0 01-1.78-.358A6.357 6.357 0 015.6 6.632 2.478 2.478 0 015 5.266a1.432 1.432 0 01.52-1.106.55.55 0 01.39-.16h.28c.09 0 .293 0 .37.18.046.107.124.27.202.433.124.26.248.52.248.563a.209.209 0 010 .23c-.124.22-.251.341-.342.427-.115.11-.172.163-.088.29a3.918 3.918 0 002 1.575c.15.1.23.09.32 0 .166-.163.323-.336.47-.518.1-.13.2-.1.33-.06z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-working-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M15 8A7 7 0 111 8a7 7 0 0114 0zm1 0A8 8 0 110 8a8 8 0 0116 0zM8.5 5.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-agillic-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M9.258 5.302c0-.166.144-.302.32-.302.178 0 .32.136.32.302v4.5c0 .166-.143.301-.32.301-.176 0-.32-.135-.32-.301v-4.5zm-.96 1.078c.21 0 .381-.16.381-.36 0-.198-.17-.359-.381-.359s-.382.161-.382.36c0 .198.17.36.382.36zm0 .545c.176 0 .32.136.32.302v2.575c0 .166-.144.301-.32.301-.177 0-.32-.135-.32-.301V7.227c0-.166.143-.302.32-.302zM2.743 9.81v-.052a1.74 1.74 0 01-1.057.35 1.73 1.73 0 01-1.192-.464C.174 9.343 0 8.943 0 8.52c0-.425.175-.822.493-1.123a1.73 1.73 0 011.192-.465c.39 0 .76.124 1.058.351v-.05c0-.165.144-.3.32-.3.177 0 .32.134.32.3V9.81c0 .165-.144.301-.32.301-.176 0-.32-.136-.32-.301zm-1.058-.303c-.578 0-1.047-.442-1.047-.986s.47-.986 1.047-.986c.578 0 1.047.442 1.047.986s-.47.986-1.047.986zM12.522 6.02c0 .198-.17.36-.382.36-.21 0-.382-.162-.382-.36 0-.199.171-.36.382-.36s.382.161.382.36zm-.382.904c-.176 0-.32.136-.32.302v2.575c0 .166.144.301.32.301.176 0 .32-.135.32-.301V7.227c0-.166-.142-.302-.32-.302zM10.86 5c-.177 0-.32.136-.32.302v4.5c0 .166.143.301.32.301.175 0 .32-.135.32-.301v-4.5c0-.166-.143-.302-.32-.302zm2.165 3.52c0-.879.758-1.593 1.692-1.593.447 0 .858.16 1.19.463a.286.286 0 01.09.213.295.295 0 01-.08.213.304.304 0 01-.215.087.427.427 0 01-.242-.085l-.018-.011c-.155-.11-.387-.277-.725-.277-.58 0-1.052.444-1.052.99s.472.99 1.052.99c.308 0 .543-.156.683-.25l.015-.01c.015-.01.029-.02.042-.027a.454.454 0 01.241-.079c.085 0 .158.031.218.094.057.06.087.137.083.217a.295.295 0 01-.105.209c-.338.29-.757.45-1.177.45-.934 0-1.693-.715-1.693-1.594zM5.633 6.927c-.45 0-.874.164-1.193.465-.317.299-.494.698-.494 1.122 0 .424.175.823.494 1.123.318.3.742.465 1.193.465.39 0 .762-.125 1.062-.355v.088c0 .522-.479.963-1.045.963h-.016a1.138 1.138 0 01-.72-.285.371.371 0 00-.241-.097.335.335 0 00-.231.098c-.105.104-.093.305.028.43.293.302.69.456 1.181.456.452 0 .877-.166 1.196-.469.318-.301.493-.701.489-1.127V7.227c0-.166-.144-.302-.32-.302-.177 0-.32.136-.32.302v.055c-.3-.23-.672-.355-1.063-.355zm0 2.572c-.578 0-1.047-.442-1.047-.986s.469-.986 1.047-.986c.577 0 1.046.442 1.046.986s-.469.986-1.046.986z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-busylight-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M5.332 2.052L4.586.547a.374.374 0 01.167-.504.363.363 0 01.5.165L6 1.713a.376.376 0 01-.166.505.338.338 0 01-.166.037.375.375 0 01-.335-.203zm-.111 13.085s-2.13-.81-2.292-1.731a1.93 1.93 0 01-.027-.418c.066-1.478.157-2.791.274-3.94.151-1.487.373-2.962.665-4.426.102-.514.45-.933.916-1.102.846-.309 1.914-.463 3.204-.463 1.301 0 2.376.157 3.225.47.458.17.802.58.908 1.084.26 1.23.478 2.714.654 4.451.133 1.304.229 2.613.287 3.928.041.917-2.331 2.154-2.331 2.154s-.52.242-.866.267c-.268.02-.481.01-1.036-.033-.397-.03-.598-.042-.837-.042-.237 0-.435.01-.829.04-.566.042-.785.05-1.058.029-.34-.028-.857-.268-.857-.268zm1.845-.846c-.545.041-1.04.052-1.98-.28-.938-.331-1.165-.533-1.165-.972 0-.438.154-2.749.269-3.873.147-1.45.364-2.89.648-4.318a.398.398 0 01.249-.3c.728-.265 1.688-.404 2.874-.404 1.196 0 2.161.141 2.892.41a.398.398 0 01.246.295c.25 1.187.462 2.631.635 4.33.127 1.239.277 3.385.277 3.732 0 .347-.433.739-.912.939-.479.2-1.69.486-2.222.444-.44-.034-.653-.045-.912-.045-.256 0-.465.01-.9.042zM6.06 15.744a2.115 2.115 0 01-.771-.196.7.7 0 00.675.452h4.013a.678.678 0 00.114-.01c.296-.05.493-.189.567-.446-.236.12-.5.184-.806.207-.282.02-.501.011-1.067-.033a9.86 9.86 0 00-.821-.042c-.23 0-.425.011-.813.04-.577.043-.803.052-1.09.028zm1.384-4.796l.191 2.62s-.471.012-.561.019c-.42.032-.646.007-.847-.016a4.497 4.497 0 00-.191-.02c-.346-.025-.398.231-.017.26.068.004.133.011.2.019.21.023.441.049.872.015.393-.03.59-.041.823-.041.231 0 .426.01.815.04.445.032.682.005.899-.02a5.55 5.55 0 01.197-.02c.389-.031.334-.287-.018-.259-.065.005-.126.012-.19.02-.207.024-.437.051-.87.02-.032-.003-.15-.005-.263-.007a8.718 8.718 0 01-.22-.005l.222-2.625c0-.374-.187-.677-.537-.677-.35 0-.505.303-.505.677zm-5.42-5.07c.224 0 .405.188.405.407 0 .229-.181.407-.405.407H.405A.403.403 0 010 6.285a.41.41 0 01.405-.406h1.62zM16 6.286c0-.22-.18-.406-.405-.406h-1.62a.41.41 0 00-.405.406c0 .229.182.407.405.407h1.62A.403.403 0 0016 6.285zM9.855 2.218c.053.03.11.037.166.037a.375.375 0 00.334-.203l.746-1.505a.374.374 0 00-.166-.504.364.364 0 00-.5.165l-.747 1.505a.376.376 0 00.167.505zm-6.747.584c.2.095.281.333.18.532a.409.409 0 01-.361.215.372.372 0 01-.18-.039l-1.62-.797a.392.392 0 01-.182-.532.4.4 0 01.544-.175l1.62.796zM14.7 2.713a.391.391 0 00.181-.532.399.399 0 00-.543-.175l-1.62.796a.392.392 0 00-.18.532c.07.136.213.215.362.215.06 0 .122-.008.18-.039l1.62-.797z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-magento-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15 11.998V3.996L8.006 0 1 4.002v7.996l1.999 1.143-.013-7.995 5.008-2.862 5.004 2.862v7.992L15 11.998zm-7 1.715l.998-.575V5.143L11 6.286v7.999L7.997 16 5 14.285l-.003-7.996 1.999-1.143v7.998L8 13.713z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-podio-16\" viewBox=\"0 0 16 16\"><path d=\"M13.019 1.993C10.284-.654 5.839-.664 3.09 1.962l-.032.031a6.667 6.667 0 00.002 9.636l4.24 4.103a.96.96 0 00.67.268c.243 0 .486-.09.671-.268a.897.897 0 000-1.298L4.4 10.332a4.872 4.872 0 01-.019-7.025l.02-.018c2.006-1.94 5.271-1.94 7.277 0 1.647 1.594 1.883 4.321.549 6.345a.9.9 0 00.289 1.266.966.966 0 001.309-.279c1.831-2.777 1.492-6.405-.806-8.628zm-1.697 9.846c.37.359.37.94 0 1.297a.958.958 0 01-.67.27.964.964 0 01-.671-.27L5.74 9.036a3.078 3.078 0 010-4.448 3.286 3.286 0 012.297-.92h.001c.868 0 1.684.327 2.298.921a3.072 3.072 0 01.815 3.125.954.954 0 01-1.18.617.913.913 0 01-.637-1.142 1.28 1.28 0 00-.34-1.303A1.367 1.367 0 008.04 5.5c-.363 0-.702.136-.958.383a1.282 1.282 0 000 1.853l4.24 4.102z\"/></symbol>\n<symbol id=\"icon-salesforce-16\" viewBox=\"0 0 16 16\"><path d=\"M6.787 4.019A2.71 2.71 0 004.674 3C3.163 3 1.937 4.25 1.937 5.793c0 .407.085.793.238 1.141A2.338 2.338 0 001 8.972c0 1.287 1.022 2.33 2.283 2.33.187 0 .369-.022.542-.066C4.128 12.256 5.057 13 6.155 13a2.435 2.435 0 002.25-1.532c.277.112.579.174.895.174.874 0 1.64-.47 2.07-1.177.2.043.408.066.621.066C13.653 10.53 15 9.156 15 7.46c0-1.696-1.347-3.071-3.009-3.071-.409 0-.798.083-1.154.234A2.677 2.677 0 008.56 3.34a2.65 2.65 0 00-1.772.679z\"/></symbol>\n<symbol id=\"icon-shopify-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M13.123 2.986c-.058-.006-1.281-.097-1.281-.097l-.944-.941c-.093-.094-.275-.065-.346-.044-.007.001-.086.026-.224.069l-.252.078C9.792 1.23 9.291.475 8.41.475l-.074.003C8.085.145 7.774 0 7.506 0 5.453 0 4.472 2.58 4.164 3.89l-1.437.448c-.445.141-.46.155-.518.577C2.165 5.234 1 14.29 1 14.29L10.08 16 15 14.93 13.262 3.116a.154.154 0 00-.14-.13zm-5.079-.372l-1.538.494c.296-1.185.851-1.758 1.337-1.974.122.318.202.775.202 1.39v.09zm-2.147.689c.288-1.565.972-2.349 1.61-2.66a.44.44 0 00-.256-.09c-1.43 0-2.232 1.946-2.57 3.14l1.216-.39zm.55 3.943c-.925 0-.972.603-.972.754 0 .327.325.575.719.875.602.458 1.363 1.038 1.363 2.211 0 1.526-.933 2.509-2.192 2.509-1.511 0-2.284-.975-2.284-.975l.405-1.385s.794.707 1.464.707c.438 0 .616-.358.616-.619 0-.473-.328-.749-.697-1.058-.472-.397-1.011-.85-1.011-1.846 0-1.494 1.034-2.94 3.122-2.94.804 0 1.202.239 1.202.239L7.594 7.53s-.515-.285-1.146-.285zM8.39 1.033c.11.325.178.736.178 1.246V2.446l.744-.24c-.189-.597-.482-1.116-.922-1.173z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-web-form-16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 3a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 10-1.723-.984l-3.261 3.26a2 2 0 100 3.446l3.26 3.262a2 2 0 10.707-.707l-3.26-3.261c.094-.16.167-.332.214-.516h8.126a2 2 0 100-1H3.937a1.988 1.988 0 00-.214-.516l3.261-3.26A1.99 1.99 0 008 4zM2 9a1 1 0 100-2 1 1 0 000 2zm7 5a1 1 0 11-2 0 1 1 0 012 0zm5-5a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-webhooks-16\" viewBox=\"0 0 16 16\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M10.294 4.356a.498.498 0 01-.309-.634c.12-.347.142-.725.059-1.09a2.083 2.083 0 00-.53-.983 2.122 2.122 0 00-.967-.576 2.062 2.062 0 00-1.11.002A1.946 1.946 0 006.04 2.617c-.063.365-.024.743.115 1.094.127.319.332.603.596.826a.497.497 0 01.143.121.498.498 0 01-.01.693l-3.09 7.039a1 1 0 11-.925-.382L5.9 5.109a3.092 3.092 0 01-.674-1.029 3.01 3.01 0 01-.17-1.633A2.944 2.944 0 015.77.978c.373-.412.856-.71 1.394-.863a3.066 3.066 0 011.65-.004 3.121 3.121 0 011.422.847c.389.406.66.908.784 1.452a2.985 2.985 0 01-.09 1.637c-.09.26-.375.4-.636.31zM9.002 3a.995.995 0 01-.186.58l2.923 6.66a3.108 3.108 0 011.034-.264 3.038 3.038 0 011.615.321 2.954 2.954 0 011.611 2.7c-.013.557-.18 1.101-.484 1.573a3.116 3.116 0 01-2.856 1.42 3.01 3.01 0 01-1.542-.57.499.499 0 11.591-.804c.298.218.653.35 1.028.379a2.119 2.119 0 001.936-.965c.206-.32.318-.685.326-1.057a1.952 1.952 0 00-1.065-1.787 2.034 2.034 0 00-1.081-.214 2.112 2.112 0 00-.99.336.5.5 0 01-.813-.152l-3.143-7.16a1 1 0 111.096-.996zm4 11a1 1 0 10-.838-1.548h-6.66v.048a.5.5 0 00-.5.5c0 .383-.104.695-.298 1.02a2.026 2.026 0 01-.8.758 1.95 1.95 0 01-2.075-.168 2.054 2.054 0 01-.675-.879 2.12 2.12 0 01.329-2.138c.24-.289.554-.502.903-.618a.5.5 0 10-.316-.949 2.998 2.998 0 00-1.356.927 3.12 3.12 0 00-.488 3.152c.21.521.558.974 1.006 1.307a2.95 2.95 0 003.136.252c.494-.258.907-.65 1.195-1.13a2.98 2.98 0 00.405-1.084h6.138a1 1 0 00.894.55z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-angle-double-left-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M9.126 14.832a.5.5 0 10.748-.664L6.169 10l3.705-4.168a.5.5 0 10-.748-.664l-4 4.5a.5.5 0 000 .664l4 4.5zm5 0a.5.5 0 10.748-.664L11.169 10l3.705-4.168a.5.5 0 10-.748-.664l-4 4.5a.5.5 0 000 .664l4 4.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-double-right-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M5.874 5.168a.5.5 0 00-.748.664L8.831 10l-3.705 4.168a.5.5 0 00.748.664l4-4.5a.5.5 0 000-.664l-4-4.5zm5 0a.5.5 0 00-.748.664L13.831 10l-3.705 4.168a.5.5 0 00.748.664l4-4.5a.5.5 0 000-.664l-4-4.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-down-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h15A1.5 1.5 0 0119 2.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 011 17.5v-15zM2.5 2a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-15zm12.374 8.168a.5.5 0 01-.042.706l-4.5 4a.5.5 0 01-.664 0l-4.5-4a.5.5 0 01.664-.748l3.668 3.26V5.5a.5.5 0 011 0v7.887l3.668-3.26a.5.5 0 01.706.04z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-left-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h15A1.5 1.5 0 0119 2.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 011 17.5v-15zM2.5 2a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-15zm7.332 12.874a.5.5 0 01-.706-.042l-4-4.5a.5.5 0 010-.664l4-4.5a.5.5 0 01.748.664L6.614 9.5H14.5a.5.5 0 010 1H6.613l3.26 3.668a.5.5 0 01-.04.706z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-right-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h15A1.5 1.5 0 0119 2.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 011 17.5v-15zM2.5 2a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-15zm7.668 3.126a.5.5 0 01.706.042l4 4.5a.5.5 0 010 .664l-4 4.5a.5.5 0 11-.748-.664l3.26-3.668H5.5a.5.5 0 010-1h7.887l-3.26-3.668a.5.5 0 01.04-.706z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-up-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 2.5A1.5 1.5 0 012.5 1h15A1.5 1.5 0 0119 2.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 011 17.5v-15zM2.5 2a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-15zm2.626 7.832a.5.5 0 01.042-.706l4.5-4a.5.5 0 01.664 0l4.5 4a.5.5 0 11-.664.748L10.5 6.614V14.5a.5.5 0 01-1 0V6.613l-3.668 3.26a.5.5 0 01-.706-.04z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrows-h-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M20 10a.5.5 0 01-.17.376l-4 3.5a.5.5 0 01-.66-.752l3-2.624H1.83l3 2.624a.5.5 0 01-.66.752l-4-3.5a.5.5 0 010-.752l4-3.5a.5.5 0 01.66.752l-3 2.624h16.34l-3-2.624a.5.5 0 01.66-.752l4 3.5A.5.5 0 0120 10z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-arrows-v-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 0a.5.5 0 01.376.17l3.5 4a.5.5 0 01-.752.66l-2.624-3v16.34l2.624-3a.5.5 0 01.752.66l-3.5 4a.5.5 0 01-.752 0l-3.5-4a.5.5 0 01.752-.66l2.624 3V1.83l-2.624 3a.5.5 0 11-.752-.66l3.5-4A.5.5 0 0110 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sign-out-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M4.5 2A2.5 2.5 0 002 4.5v11A2.5 2.5 0 004.5 18h5a.5.5 0 000-1h-5A1.5 1.5 0 013 15.5v-11A1.5 1.5 0 014.5 3h5a.5.5 0 000-1h-5zm9.675 4.12a.5.5 0 01.705.055l3 3.5a.5.5 0 010 .65l-3 3.5a.5.5 0 11-.76-.65l2.293-2.675H8a.5.5 0 010-1h8.413L14.12 6.825a.5.5 0 01.055-.705z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-headset-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M2 10a8 8 0 1116 0v5a1.5 1.5 0 01-1.5 1.5h-4.563a2 2 0 100 1H16.5A2.5 2.5 0 0019 15v-5a9 9 0 10-18 0 .5.5 0 001 0zm4 3a1 1 0 001-1V9a1 1 0 00-2 0v3a1 1 0 001 1zm0-6a2 2 0 00-2 2v3a2 2 0 104 0V9a2 2 0 00-2-2zm4 11a1 1 0 100-2 1 1 0 000 2zm4-10a1 1 0 011 1v3a1 1 0 11-2 0V9a1 1 0 011-1zm-2 1a2 2 0 114 0v3a2 2 0 11-4 0V9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-building-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M3.5 0A1.5 1.5 0 002 1.5V19h-.5a.5.5 0 000 1h17a.5.5 0 000-1H18V1.5A1.5 1.5 0 0016.5 0h-13zM17 19V1.5a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5V19h5v-2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V19h5zm-6 0v-2H9v2h2zM9 5a1 1 0 11-2 0 1 1 0 012 0zm-1 5a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm3-7a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm-1 5a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chart-bar-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M11 2a1 1 0 10-2 0v16a1 1 0 102 0V2zm-1-2a2 2 0 00-2 2v16a2 2 0 104 0V2a2 2 0 00-2-2zM5 18v-7a1 1 0 10-2 0v7a1 1 0 102 0zM4 9a2 2 0 00-2 2v7a2 2 0 104 0v-7a2 2 0 00-2-2zm13-1v10a1 1 0 11-2 0V8a1 1 0 112 0zm-3 0a2 2 0 114 0v10a2 2 0 11-4 0V8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-slash-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.854.146a.5.5 0 10-.708.708l17 17a.5.5 0 00.708-.708l-17-17zM6.3 1.5a.5.5 0 01.5-.5h6.3c3.776 0 6.8 3.024 6.8 6.8 0 1.838-.756 3.555-1.931 4.838a.5.5 0 01-.738-.676c1.025-1.117 1.669-2.6 1.669-4.162 0-3.224-2.576-5.8-5.8-5.8H6.8a.5.5 0 01-.5-.5zM1.324 4.653a.5.5 0 01.223.67C1.186 6.047 1 6.869 1 7.8c0 2.85 2.021 5.156 4.701 5.71A.5.5 0 016.1 14v3.028l4.11-2.935a.5.5 0 01.58.814l-4.9 3.5A.5.5 0 015.1 18v-3.605C2.179 13.61 0 11.005 0 7.8c0-1.068.214-2.046.653-2.924a.5.5 0 01.67-.223z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-code-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M12.126 14.168a.5.5 0 10.748.664l4-4.5a.5.5 0 000-.664l-4-4.5a.5.5 0 00-.748.664L15.831 10l-3.705 4.168zM7.874 5.832a.5.5 0 00-.748-.664l-4 4.5a.5.5 0 000 .664l4 4.5a.5.5 0 10.748-.664L4.169 10l3.705-4.168z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cog-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M9.324 0c-.413 0-.78.146-1.06.415-.272.263-.432.616-.495.997l-.333 1.726a7.716 7.716 0 00-1.88 1.09l-1.554-.593c-.73-.298-1.564.016-1.969.714a.504.504 0 00-.01.02L1.35 5.66a1.744 1.744 0 00.31 2.123l1.31 1.102A4.97 4.97 0 002.835 10v.031c0 .368 0 .721.051 1.075l-1.322 1.111a.499.499 0 00-.037.036 1.933 1.933 0 00-.397 2.027c.01.026.022.052.037.075l.771 1.298c.405.697 1.239 1.01 1.968.712l1.55-.592c.566.468 1.204.878 1.873 1.112l.244 1.687.001.008c.132.815.802 1.42 1.557 1.42h1.642c.412 0 .78-.146 1.06-.415.273-.265.434-.621.496-1.006l.248-1.714a7.52 7.52 0 001.864-1.094l1.556.594c.73.298 1.563-.015 1.968-.712l.771-1.298.003-.004c.413-.712.266-1.576-.395-2.13l-1.233-1.106c.054-.382.054-.787.054-1.088v-.054c0-.299 0-.698-.053-1.077l1.323-1.113a.502.502 0 00.038-.036c.531-.55.655-1.359.397-2.027a.492.492 0 00-.037-.075l-.771-1.298c-.405-.697-1.239-1.01-1.968-.712l-1.551.592c-.565-.468-1.204-.878-1.872-1.112l-.244-1.687-.002-.007C12.294.605 11.624 0 10.87 0H9.324zm-.57 1.58c.036-.216.116-.36.205-.445A.499.499 0 019.324 1h1.545c.21 0 .505.194.568.576l.29 1.996a.5.5 0 00.37.412c.665.172 1.368.616 2.014 1.19a.5.5 0 00.51.093l1.835-.7.014-.005c.234-.097.554-.01.728.289l.752 1.264c.107.317.04.68-.18.921l-1.524 1.281a.5.5 0 00-.164.5c.08.331.083.767.083 1.183 0 .416-.003.852-.083 1.183a.5.5 0 00.152.49l1.449 1.3a.559.559 0 00.012.01l.003.002c.297.247.341.578.177.862l-.77 1.298-.004.004c-.173.3-.494.386-.728.289l-1.848-.705a.5.5 0 00-.505.088c-.542.468-1.26.931-2.058 1.206a.5.5 0 00-.332.401l-.29 1.996c-.034.214-.115.357-.203.441a.499.499 0 01-.364.135H9.13c-.211 0-.506-.194-.569-.576l-.289-1.996a.5.5 0 00-.37-.412c-.665-.172-1.368-.616-2.014-1.19a.5.5 0 00-.51-.093l-1.836.7-.013.005c-.234.097-.555.01-.728-.289l-.752-1.264a.934.934 0 01.18-.921l1.524-1.281a.5.5 0 00.164-.5c-.08-.332-.083-.67-.083-1.183 0-.434.082-.781.18-1.183a.5.5 0 00-.165-.5L2.327 7.036a.742.742 0 01-.094-.905l.67-1.289c.175-.293.492-.376.724-.28l1.848.705a.5.5 0 00.51-.093c.617-.548 1.332-.92 2.07-1.208a.5.5 0 00.31-.371l.387-2 .003-.016zM7 10a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-conversations-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M2.154 2.154C2.858 1.45 3.929 1 5 1h4c2.224 0 4 1.776 4 4 0 1.07-.45 2.142-1.154 2.846C11.142 8.55 10.071 9 9 9H7.2a.5.5 0 00-.31.108l-2.99 2.36V9.2a.5.5 0 00-.324-.468A4.003 4.003 0 011 5c0-1.07.45-2.142 1.154-2.846zM5 0C3.67 0 2.342.55 1.446 1.446.55 2.342 0 3.671 0 5c0 2.088 1.273 3.78 2.9 4.533V12.5a.5.5 0 00.81.392L7.374 10H9c1.33 0 2.658-.55 3.554-1.446C13.45 7.658 14 6.329 14 5c0-2.776-2.224-5-5-5H5zm11.621 7.015a.5.5 0 00-.242.97C18.07 8.408 19 10.13 19 12c0 1.753-1.234 3.208-2.724 3.953A.5.5 0 0016 16.4v2.068l-2.99-2.36A.5.5 0 0012.7 16H11c-1.82 0-3.2-.908-4.146-1.854a.5.5 0 00-.708.707C7.201 15.909 8.821 17 11 17h1.526l3.664 2.892A.5.5 0 0017 19.5v-2.8c1.6-.898 3-2.574 3-4.7 0-2.129-1.072-4.408-3.379-4.985z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-copy-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M5.5 1a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V7h-4.5A1.5 1.5 0 0112 5.5V1H5.5zm7.5.707V5.5a.5.5 0 00.5.5h3.793L13 1.707zM4 1.5V3H2.5A1.5 1.5 0 001 4.5v14A1.5 1.5 0 002.5 20h12a1.5 1.5 0 001.5-1.5V17h1.5a1.5 1.5 0 001.5-1.5V6.914a1.5 1.5 0 00-.44-1.06L13.147.439A1.5 1.5 0 0012.086 0H5.5A1.5 1.5 0 004 1.5zm11 17V17H5.5A1.5 1.5 0 014 15.5V4H2.5a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h12a.5.5 0 00.5-.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-credit-card-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 000 3.5v13A1.5 1.5 0 001.5 18h17a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0018.5 2h-17zM1 8v8.5a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V8H1zm18-1V3.5a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5V7h18zM3 14a1 1 0 112 0 1 1 0 01-2 0zm5-1a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dashboard-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M19 10a9 9 0 11-18 0h2.5a.5.5 0 000-1H1.055a8.965 8.965 0 012.237-5l1.83 1.828a.5.5 0 10.706-.707L4 3.292A8.964 8.964 0 019.5 1.014V3.5a.5.5 0 001 0V1.014A8.964 8.964 0 0116 3.292l-1.854 1.854a.5.5 0 10.708.708l1.854-1.855A8.966 8.966 0 0118.945 9H16.5a.5.5 0 000 1H19zM10.5.012C15.79.272 20 4.645 20 10c0 5.523-4.477 10-10 10S0 15.523 0 10C0 4.645 4.21.273 9.5.012V0h1v.012zM10 14a1 1 0 100-2 1 1 0 000 2zm-.5-2.937a2 2 0 101 0V7.5a.5.5 0 00-1 0v3.563z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dixa-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7.784 1.077C11.68-1.138 16.659.173 18.908 4.01A7.9 7.9 0 0120 8.015a8.002 8.002 0 01-4.073 6.956l-5.856 3.33-1.196.678-1.746.995a.193.193 0 01-.29-.165v-3.946c0-.233-.062-.462-.18-.665l-5.56-9.482a.723.723 0 01.271-.995l6.414-3.644zm3.399 10.417l2.028-1.154a2.664 2.664 0 001.358-2.321c0-.452-.115-.915-.363-1.334-.75-1.28-2.408-1.716-3.707-.977L8.468 6.86a.362.362 0 00-.136.498l2.345 4.003a.374.374 0 00.506.133z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-done-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15.707 6.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L8 12.586l6.293-6.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-home-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10.317.113a.5.5 0 00-.634 0l-9.5 7.773A.5.5 0 000 8.273v9.5C0 19.003.997 20 2.227 20h15.546c1.23 0 2.227-.997 2.227-2.227v-9.5a.5.5 0 00-.183-.387l-9.5-7.773zM14 19h3.773C18.45 19 19 18.45 19 17.773V8.51l-9-7.364L1 8.51v9.263C1 18.45 1.55 19 2.227 19H6v-4a4 4 0 018 0v4zm-1-4a3 3 0 10-6 0v4h6v-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-id-card-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M0 3.5A1.5 1.5 0 011.5 2h17A1.5 1.5 0 0120 3.5v13a1.5 1.5 0 01-1.5 1.5h-17A1.5 1.5 0 010 16.5v-13zM18.5 17H11v-1a4 4 0 00-8 0v1H1.5a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v13a.5.5 0 01-.5.5zM7 13a3 3 0 013 3v1H4v-1a3 3 0 013-3zm5.5-3a.5.5 0 000 1h4a.5.5 0 000-1h-4zM12 7.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM9 8a2 2 0 11-4 0 2 2 0 014 0zm1 0a3 3 0 11-6 0 3 3 0 016 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-link-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.688 3.312a4.48 4.48 0 00-6.334 0L7.926 5.74a.5.5 0 01-.708-.708l2.428-2.427a5.48 5.48 0 017.75 7.748l-2.429 2.428a.5.5 0 01-.707-.707l2.428-2.427a4.48 4.48 0 000-6.335zM5.74 7.218a.5.5 0 010 .708l-2.428 2.427a4.48 4.48 0 006.334 6.335l2.428-2.428a.5.5 0 01.707.707l-2.428 2.428a5.48 5.48 0 01-7.749-7.749l2.428-2.428a.5.5 0 01.708 0zm7.704.045a.5.5 0 10-.707-.707l-6.181 6.181a.5.5 0 10.707.707l6.181-6.181z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-map-pin-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 1a5 5 0 100 10 5 5 0 000-10zm.5 10.98a6 6 0 10-1 0v7.52a.5.5 0 001 0v-7.52zM11 4a1 1 0 11-2 0 1 1 0 012 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-plug-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7 .5a.5.5 0 00-1 0V4H3.5a.5.5 0 00-.5.5V9a7 7 0 006.5 6.982V19.5a.5.5 0 001 0v-3.518A7 7 0 0017 9V4.5a.5.5 0 00-.5-.5H14V.5a.5.5 0 00-1 0V4H7V.5zM10 15a6 6 0 006-6V5H4v4a6 6 0 006 6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-rec-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 000 3.5v13A1.5 1.5 0 001.5 18h17a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0018.5 2h-17zM1 3.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v13a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-13zm7 4a.5.5 0 01.5-.5h3a.5.5 0 010 1H9v1.5h1.5a.5.5 0 010 1H9V12h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-5zM3 11V7.53A.53.53 0 013.53 7H5a2 2 0 01.612 3.905l1.242 1.241a.5.5 0 01-.708.708L4.293 11H4v1.5a.5.5 0 01-1 0V11zm1.5-1H5a1 1 0 100-2H4v2h.5zm11-3A2.5 2.5 0 0013 9.5v1a2.5 2.5 0 002.5 2.5h1a.5.5 0 000-1h-1a1.5 1.5 0 01-1.5-1.5v-1A1.5 1.5 0 0115.5 8h1a.5.5 0 000-1h-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-search-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M14 8A6 6 0 112 8a6 6 0 0112 0zm-1.41 5.286a7 7 0 11.696-.696.505.505 0 01.068.056l5.5 5.5a.5.5 0 01-.708.708l-5.5-5.5a.505.505 0 01-.057-.068z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-smile-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M19 10a9 9 0 11-18 0 9 9 0 0118 0zm1 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM6.5 9a.5.5 0 100-1 .5.5 0 000 1zm7.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm-7.812 3.61a.496.496 0 01.702.08l.358.451c1.545 1.953 4.542 1.751 5.819-.388a.5.5 0 01.933.252c0 .099-.028.19-.076.268-1.635 2.743-5.476 3.002-7.457.5l-.357-.452a.509.509 0 01.078-.71z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-tag-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M11.721 0c-.585 0-1.148.23-1.565.643l-9.501 9.36-.003.002c-.87.87-.87 2.28 0 3.15l6.192 6.193c.87.87 2.28.87 3.15 0l.003-.002 9.36-9.5c.412-.418.642-.981.642-1.566V2.228A2.225 2.225 0 0017.773 0h-6.052zm0 1h6.052C18.451 1 19 1.55 19 2.227V8.28c0 .323-.127.633-.354.862l-9.358 9.5h-.001a1.228 1.228 0 01-1.735-.002L1.36 12.447a1.228 1.228 0 010-1.734l9.499-9.358v-.001c.23-.227.54-.354.863-.354zM15.5 5a.5.5 0 100-1 .5.5 0 000 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-team-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7 5a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8zM3.652 3.847a.5.5 0 10-.447-.894A3.074 3.074 0 001.5 5.72c0 1.689 1.241 3.171 2.938 3.277A.5.5 0 104.5 8c-1.16-.073-2-1.11-2-2.279 0-.796.432-1.514 1.152-1.874zm12.472-.57a.5.5 0 00.224.67A2.074 2.074 0 0117.5 5.822c0 1.169-.84 2.105-2 2.178a.5.5 0 10.062.998C17.26 8.892 18.5 7.51 18.5 5.822c0-1.168-.64-2.236-1.705-2.77a.5.5 0 00-.67.224zM3 17c0-3.349 3.203-6 7-6s7 2.651 7 6v1.5a.5.5 0 01-1 0V17c0-2.651-2.598-5-6-5-3.403 0-6 2.349-6 5v1.5a.5.5 0 01-1 0V17zm-1.146-4.146a.5.5 0 00-.708-.708c-.396.397-.675 1.003-.86 1.847C.102 14.843 0 15.983 0 17.5a.5.5 0 001 0c0-1.482.1-2.543.263-3.293.166-.756.387-1.15.59-1.353zm16.292 0a.5.5 0 01.708-.708c.396.397.675 1.003.86 1.847.185.85.286 1.99.286 3.507a.5.5 0 01-1 0c0-1.482-.1-2.543-.264-3.293-.165-.756-.386-1.15-.59-1.353z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-secret-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M7.677.036a.501.501 0 00-.646.267L5.608 3.62 2.287 5.041a.5.5 0 00.113.952c.969.165 1.833.307 2.621.426A5.046 5.046 0 005.088 8H2.484a.5.5 0 00-.417.777l1.687 2.527c-1.026.568-1.69 1.34-2.105 2.307-.47 1.095-.605 2.409-.648 3.874C.961 18.883 2.109 20 3.485 20h13.02c1.377 0 2.522-1.117 2.495-2.51-.029-1.46-.139-2.778-.602-3.876-.41-.975-1.088-1.751-2.156-2.318l1.681-2.519A.5.5 0 0017.507 8h-2.604a5.014 5.014 0 00.067-1.576c.788-.12 1.65-.264 2.622-.431a.5.5 0 00.112-.952l-3.321-1.422L12.959.303a.5.5 0 00-.646-.267L9.995.962 7.677.036zm6.301 6.533c-1.471.2-2.69.304-3.92.305-1.25 0-2.507-.104-4.045-.313A4.003 4.003 0 009.995 11a4.003 4.003 0 003.983-4.431zM6.45 4.197l1.31-3.051 2.05.818c.12.048.253.048.372 0l2.05-.818 1.31 3.051a.5.5 0 00.263.263l1.94.83c-2.397.39-4.037.582-5.686.584-1.656.001-3.333-.19-5.805-.587l1.933-.827a.5.5 0 00.263-.263zm1.985 8.568l-.693-1.299A4.993 4.993 0 009.995 12c.828 0 1.608-.2 2.296-.555l-.73 1.312a.5.5 0 00-.05.356L12.87 19H7.119l1.361-5.887a.5.5 0 00-.046-.348zM14.797 9l-2.268 4.075L13.9 19h2.606c.835 0 1.51-.676 1.493-1.49-.028-1.453-.14-2.601-.523-3.508-.368-.874-1.001-1.555-2.165-2.04a.5.5 0 01-.223-.74L16.57 9h-1.774zM6.092 19l1.37-5.93L5.29 9H3.42l1.483 2.223a.5.5 0 01-.216.735c-1.11.484-1.74 1.165-2.117 2.046-.39.91-.526 2.063-.568 3.51C1.98 18.324 2.65 19 3.485 19h2.607z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-user-slash-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.146.146a.5.5 0 01.708 0l19 19a.5.5 0 01-.708.708l-19-19a.5.5 0 010-.708zM7.204.96A4.87 4.87 0 0110.096 0 4.905 4.905 0 0115 4.904a4.86 4.86 0 01-.961 2.893.5.5 0 11-.806-.594 3.86 3.86 0 00.767-2.3A3.905 3.905 0 0010.096 1c-.86 0-1.65.288-2.3.766A.5.5 0 117.204.96zm-.579 12.024a.5.5 0 00-.25-.968C3.448 12.773 2 14.905 2 17v2.5a.5.5 0 001 0V17c0-1.596 1.096-3.362 3.625-4.016z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-user-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M14 5a4 4 0 11-8 0 4 4 0 018 0zm1 0A5 5 0 115 5a5 5 0 0110 0zm-5 8c-1.847 0-3.81.595-5.316 1.482-.755.445-1.415.973-1.892 1.557C2.317 16.621 2 17.29 2 18v1.5a.5.5 0 001 0V18c0-.406.183-.858.567-1.328.383-.47.942-.926 1.624-1.328C6.56 14.539 8.347 14 10 14s3.44.539 4.809 1.344c.683.402 1.241.859 1.624 1.328.384.47.567.922.567 1.328v1.5a.5.5 0 001 0V18c0-.71-.317-1.379-.792-1.96-.477-.585-1.137-1.113-1.892-1.558C13.81 13.595 11.847 13 10 13z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-users-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6.5 2.026a3.474 3.474 0 100 6.948 3.474 3.474 0 000-6.948zM2 5.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM6.5 12c-1.755 0-3.365.548-4.546 1.455C.774 14.363 0 15.65 0 17.11v1.394a.497.497 0 10.993 0V17.11c0-1.085.573-2.103 1.566-2.866.994-.763 2.386-1.25 3.941-1.25 1.555 0 2.947.487 3.94 1.25.994.763 1.567 1.781 1.567 2.866v1.394a.497.497 0 10.993 0V17.11c0-1.459-.773-2.747-1.954-3.654S8.256 12 6.5 12zm8.055.062a.5.5 0 10-.117.993c2.763.324 4.562 2.347 4.562 4.314v1.404a.5.5 0 001 0v-1.404c0-2.674-2.406-4.95-5.445-5.307zM12.5 1a.5.5 0 000 1 3.5 3.5 0 110 7 .5.5 0 000 1 4.5 4.5 0 100-9z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-clock-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm1 0a9 9 0 11-18 0 9 9 0 0118 0zm-8-3.5a.5.5 0 00-1 0V10H7.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-history-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M11 2a8 8 0 00-7.966 7.259l1.112-1.113a.5.5 0 11.708.708l-2 2a.5.5 0 01-.708 0l-2-2a.5.5 0 11.708-.708l1.171 1.172A9 9 0 1111 19a.5.5 0 010-1 8 8 0 100-16zm0 4.5a.5.5 0 00-1 0v4a.5.5 0 00.5.5h3a.5.5 0 000-1H11V6.5z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v20H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-chat-widget-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 3.5A1.5 1.5 0 012.5 2h15A1.5 1.5 0 0119 3.5V17h.5a.5.5 0 010 1H.5a.5.5 0 010-1H1V3.5zM10 17h5v-2.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17zm6 0v-2.5a1.5 1.5 0 00-1.5-1.5h-4A1.5 1.5 0 009 14.5V17H2V3.5a.5.5 0 01.5-.5h15a.5.5 0 01.5.5V17h-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M2.046 3.046A6.92 6.92 0 017 1h6c3.876 0 7 3.124 7 7a6.92 6.92 0 01-2.046 4.954A6.92 6.92 0 0113 15h-1.74l-5.47 3.907A.5.5 0 015 18.5v-3.616C2.084 14.025 0 11.586 0 8a6.92 6.92 0 012.046-4.954zM7 2a5.92 5.92 0 00-4.246 1.754A5.92 5.92 0 001 8c0 3.259 1.932 5.366 4.617 6.014A.5.5 0 016 14.5v3.028l4.81-3.435A.5.5 0 0111.1 14H13a5.92 5.92 0 004.246-1.754A5.92 5.92 0 0019 8c0-3.324-2.676-6-6-6H7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-mail-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 3.5c0-.186.06-.303.129-.371.068-.07.185-.129.371-.129h17c.186 0 .303.06.371.129.07.068.129.185.129.371v2.668l-8.03 3.381a2.5 2.5 0 01-1.94 0L1 6.168V3.5zm0 3.753V16.5c0 .186.06.303.129.371.068.07.185.129.371.129h17c.186 0 .303-.06.371-.129.07-.068.129-.185.129-.371V7.253l-7.642 3.218a3.5 3.5 0 01-2.716 0L1 7.253zM1.5 2c-.414 0-.797.14-1.079.421C.141 2.703 0 3.086 0 3.5v13c0 .414.14.797.421 1.079.282.28.665.421 1.079.421h17c.414 0 .797-.14 1.079-.421.28-.282.421-.665.421-1.079v-13c0-.414-.14-.797-.421-1.079C19.297 2.141 18.914 2 18.5 2h-17z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-messaging-settings-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7 1a6.92 6.92 0 00-4.954 2.046A6.92 6.92 0 000 8c0 3.586 2.084 6.025 5 6.884V18.5a.5.5 0 00.79.407L11.26 15H13a6.92 6.92 0 004.954-2.046A6.92 6.92 0 0020 8c0-3.876-3.124-7-7-7H7zM2.754 3.754A5.92 5.92 0 017 2h6c3.324 0 6 2.676 6 6a5.92 5.92 0 01-1.754 4.246A5.92 5.92 0 0113 14h-1.9a.5.5 0 00-.29.093L6 17.528V14.5a.5.5 0 00-.383-.486C2.932 13.366 1 11.259 1 8a5.92 5.92 0 011.754-4.246zm8.21 2.06a.5.5 0 10-.928.372L10.762 8H8.5a.5.5 0 00-.464.686l1 2.5a.5.5 0 10.928-.372L9.24 9H11.5a.5.5 0 00.464-.686l-1-2.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-messenger-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M2.129 2.129C2.059 2.197 2 2.314 2 2.5v11c0 .186.06.303.129.371.068.07.185.129.371.129h3a.5.5 0 01.5.5v3.018l4.701-3.42A.498.498 0 0111 14h6.5c.186 0 .303-.06.371-.129.07-.068.129-.185.129-.371v-11c0-.186-.06-.303-.129-.371-.068-.07-.185-.129-.371-.129h-15c-.186 0-.303.06-.371.129zM11.163 15H17.5c.414 0 .797-.14 1.079-.421.28-.282.421-.665.421-1.079v-11c0-.414-.14-.797-.421-1.079C18.297 1.141 17.914 1 17.5 1h-15c-.414 0-.797.14-1.079.421C1.141 1.703 1 2.086 1 2.5v11c0 .414.14.797.421 1.079.282.28.665.421 1.079.421H5v3.5a.5.5 0 00.794.404L11.163 15zM7 8a1 1 0 11-2 0 1 1 0 012 0zm3.005 1a1 1 0 100-2 1 1 0 000 2zM14 9a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M3.926 1.41c.658-.528 1.649-.578 2.262.037l2.895 2.902a.5.5 0 01.036.041c.527.66.577 1.653-.036 2.268l-1.86 1.865c.843 1.92 2.442 3.458 4.393 4.388l1.852-1.857a.479.479 0 01.04-.037c.659-.527 1.65-.577 2.263.037l2.795 2.803a1.51 1.51 0 01-.118 2.226l-1.371 1.375c-1.11 1.218-2.777 1.781-4.349 1.447-5.996-1.04-10.644-5.808-11.677-11.714l-.003-.015a5.203 5.203 0 011.44-4.328l1.397-1.401a.501.501 0 01.04-.037zm.643.766l-1.376 1.38a4.201 4.201 0 00-1.157 3.47c.965 5.497 5.296 9.93 10.871 10.895a.46.46 0 01.02.003c1.216.262 2.535-.173 3.42-1.148a.444.444 0 01.016-.017l1.397-1.401a.497.497 0 01.041-.037.508.508 0 00.059-.757l-2.795-2.802c-.182-.183-.577-.234-.913.022l-2.075 2.08a.498.498 0 01-.552.105c-2.4-1.046-4.403-2.938-5.356-5.38a.501.501 0 01.112-.537L8.377 5.95c.182-.182.233-.578-.022-.915l-2.873-2.88c-.182-.183-.577-.235-.913.021z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-simultaneous-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 18a8 8 0 006.998-11.88 3 3 0 11-3.118-3.118A8 8 0 003.002 13.88a3 3 0 113.118 3.118A7.964 7.964 0 0010 18zm0 1a9 9 0 100-18 9 9 0 000 18zm-4-3a2 2 0 100-4 2 2 0 000 4zM16 6a2 2 0 11-4 0 2 2 0 014 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-voicemail-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1 3.5c0-.186.06-.303.129-.371.068-.07.185-.129.371-.129h17c.186 0 .303.06.371.129.07.068.129.185.129.371v13c0 .186-.06.303-.129.371-.068.07-.185.129-.371.129h-17c-.186 0-.303-.06-.371-.129-.07-.068-.129-.185-.129-.371v-13zM1.5 2c-.414 0-.797.14-1.079.421C.141 2.703 0 3.086 0 3.5v13c0 .414.14.797.421 1.079.282.28.665.421 1.079.421h17c.414 0 .797-.14 1.079-.421.28-.282.421-.665.421-1.079v-13c0-.414-.14-.797-.421-1.079C19.297 2.141 18.914 2 18.5 2h-17zM8 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1 0c0 .563-.186 1.082-.5 1.5h3a2.5 2.5 0 112 1h-7A2.5 2.5 0 119 10.5zm6 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-working-20\" viewBox=\"0 0 21 20\"><path fill-rule=\"evenodd\" d=\"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm1 0a9 9 0 11-18 0 9 9 0 0118 0zm-8.5-3.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-agillic-20\" viewBox=\"0 0 20 20\"><g clip-path=\"url(#clip0)\"><path d=\"M3.596 8.997a2.162 2.162 0 00-1.49-.582c-.562 0-1.091.206-1.49.582A1.917 1.917 0 000 10.4c0 .53.219 1.028.617 1.403.398.374.927.582 1.49.582s1.092-.206 1.49-.582c.398-.374.618-.872.618-1.403a1.926 1.926 0 00-.619-1.403zm-1.49 2.635c-.722 0-1.309-.552-1.309-1.232 0-.68.587-1.232 1.31-1.232.721 0 1.308.552 1.308 1.232 0 .68-.587 1.232-1.309 1.232z\"/><path d=\"M3.829 8.415c-.22 0-.4.17-.4.377v3.219c0 .207.18.377.4.377.22 0 .4-.17.4-.377V8.792c0-.209-.178-.377-.4-.377zM10.772 8.784c0-.208-.18-.377-.4-.377-.22 0-.4.17-.4.377v3.218c0 .208.18.377.4.377.22 0 .4-.17.4-.377V8.784zM10.372 7.725c.264 0 .477-.201.477-.45 0-.247-.213-.449-.477-.449s-.477.202-.477.45.213.45.477.45zM15.175 7.725c.264 0 .478-.201.478-.45 0-.247-.214-.449-.478-.449-.263 0-.477.202-.477.45s.214.45.477.45zM15.175 8.407c-.22 0-.4.17-.4.377v3.218c0 .208.18.377.4.377.22 0 .4-.17.4-.377V8.784c0-.208-.178-.377-.4-.377zM11.973 6c-.22 0-.4.17-.4.377v5.625c0 .207.18.377.4.377.22 0 .4-.17.4-.377V6.377c0-.207-.178-.377-.4-.377zM13.574 6c-.22 0-.4.17-.4.377v5.625c0 .207.18.377.4.377.22 0 .4-.17.4-.377V6.377c0-.207-.178-.377-.4-.377zM18.396 8.408c-1.167 0-2.115.893-2.115 1.992 0 1.1.948 1.992 2.115 1.992.525 0 1.049-.2 1.472-.562a.368.368 0 00.13-.261.367.367 0 00-.102-.272.365.365 0 00-.273-.117c-.095 0-.2.033-.302.099l-.07.046c-.176.118-.47.313-.855.313-.725 0-1.315-.555-1.315-1.238 0-.683.59-1.238 1.315-1.238.423 0 .714.209.907.346l.021.015a.534.534 0 00.304.106.38.38 0 00.27-.109c.06-.058.1-.16.098-.267a.356.356 0 00-.111-.265c-.416-.38-.93-.58-1.489-.58zM7.042 8.408c-.562 0-1.092.206-1.49.581a1.917 1.917 0 00-.618 1.404c0 .529.219 1.028.618 1.403.397.374.926.582 1.49.582.562 0 1.091-.206 1.49-.582.397-.374.618-.872.618-1.403 0-.53-.22-1.03-.62-1.404a2.155 2.155 0 00-1.488-.58zm0 3.216c-.722 0-1.309-.553-1.309-1.233S6.32 9.16 7.042 9.16s1.309.552 1.309 1.232c0 .68-.587 1.233-1.31 1.233z\"/><path d=\"M5.589 13.429c.366.378.863.571 1.476.571.565 0 1.096-.207 1.495-.586.397-.377.616-.877.611-1.409V8.784c0-.208-.18-.377-.4-.377-.22 0-.4.17-.4.377v3.26c0 .653-.6 1.204-1.308 1.204h-.02a1.422 1.422 0 01-.9-.357.464.464 0 00-.3-.12.418.418 0 00-.29.121c-.13.13-.115.382.036.537z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h20v8H0z\" transform=\"translate(0 6)\"/></clipPath></defs></symbol>\n<symbol id=\"icon-busylight-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M6.665 2.565L5.733.684a.468.468 0 01.208-.63c.23-.123.51-.029.625.206L7.5 2.142a.47.47 0 01-.208.631.422.422 0 01-.208.046.468.468 0 01-.418-.254zm-.139 16.357s-2.663-1.014-2.865-2.165a2.413 2.413 0 01-.033-.522c.082-1.848.195-3.49.342-4.925.189-1.858.466-3.702.83-5.532.129-.643.564-1.166 1.146-1.378 1.058-.386 2.393-.578 4.006-.578 1.626 0 2.97.195 4.03.587.573.211 1.003.724 1.136 1.355.324 1.538.596 3.393.817 5.564.166 1.63.286 3.266.359 4.91.051 1.146-2.914 2.692-2.914 2.692s-.65.302-1.082.334c-.335.024-.602.013-1.295-.041a12.504 12.504 0 00-1.047-.053c-.296 0-.544.013-1.035.05-.708.053-.982.063-1.323.036-.426-.035-1.072-.334-1.072-.334zm2.306-1.058c-.68.051-1.3.065-2.473-.35C5.185 17.1 4.9 16.848 4.9 16.3c0-.548.193-3.436.336-4.842.185-1.813.455-3.612.81-5.397a.498.498 0 01.312-.375c.91-.331 2.11-.505 3.593-.505 1.494 0 2.7.176 3.614.513a.497.497 0 01.308.369c.312 1.483.578 3.289.794 5.413.158 1.547.345 4.23.345 4.664 0 .433-.54.923-1.14 1.173-.598.25-2.11.608-2.777.556-.55-.043-.815-.057-1.14-.057-.32 0-.58.013-1.124.053zM7.577 19.68a2.643 2.643 0 01-.965-.245c.127.347.457.565.844.565h5.016a.84.84 0 00.143-.012c.37-.064.616-.236.708-.558-.294.15-.623.23-1.006.259-.353.026-.628.014-1.335-.041-.49-.038-.735-.052-1.026-.052-.288 0-.53.013-1.016.049-.722.053-1.003.064-1.363.035zm1.73-5.994l.238 3.275s-.59.014-.702.022c-.525.041-.807.009-1.057-.02a5.92 5.92 0 00-.24-.024c-.432-.031-.498.289-.02.324.084.006.165.015.249.024.263.03.551.062 1.09.02a12.43 12.43 0 011.03-.052c.288 0 .531.013 1.018.049.556.041.852.007 1.123-.024.082-.01.162-.019.246-.025.487-.04.418-.36-.022-.324a6.33 6.33 0 00-.237.025c-.259.03-.547.064-1.09.024-.038-.002-.186-.005-.327-.008a11.346 11.346 0 01-.276-.006l.28-3.28c0-.468-.236-.847-.672-.847-.437 0-.632.379-.632.847zM2.53 7.348a.51.51 0 01.506.509.504.504 0 01-.506.508H.506A.504.504 0 010 7.857c0-.275.227-.509.506-.509h2.025zM20 7.857a.51.51 0 00-.506-.509h-2.025a.511.511 0 00-.506.509c0 .286.227.508.506.508h2.025c.28 0 .506-.222.506-.508zm-7.681-5.084a.42.42 0 00.208.046c.17 0 .335-.094.417-.254l.933-1.881a.468.468 0 00-.208-.63.455.455 0 00-.626.206l-.933 1.882a.47.47 0 00.209.631zm-8.434.73c.25.118.351.416.226.665a.51.51 0 01-.453.269.465.465 0 01-.225-.049l-2.025-.996a.49.49 0 01-.227-.666.5.5 0 01.68-.22l2.024.996zm14.49-.111a.49.49 0 00.226-.666.498.498 0 00-.678-.22l-2.025.996a.49.49 0 00-.226.666.51.51 0 00.453.269c.076 0 .153-.01.226-.049l2.024-.996z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-magento-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M19 14.997V4.995L10.008 0 1 5.003v9.994l2.57 1.43-.017-9.995 6.439-3.577 6.434 3.577v9.99L19 14.997zm-9 2.144l1.283-.718V6.429l2.574 1.429v9.998L9.996 20l-3.853-2.144-.004-9.994 2.57-1.43v9.998l1.291.711z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-podio-20\" viewBox=\"0 0 20 20\"><path d=\"M16.453 2.49C12.936-.816 7.223-.83 3.687 2.454l-.04.038c-3.53 3.322-3.529 8.725.001 12.045l5.453 5.129c.238.224.55.335.861.335.312 0 .624-.111.862-.335a1.1 1.1 0 000-1.622l-5.453-5.128c-2.572-2.42-2.58-6.352-.024-8.78l.025-.024c2.58-2.426 6.778-2.425 9.357.001 2.117 1.992 2.421 5.401.705 7.93-.361.534-.195 1.243.372 1.584.569.341 1.321.184 1.683-.35 2.354-3.47 1.919-8.006-1.036-10.785zM14.27 14.8a1.099 1.099 0 010 1.62 1.25 1.25 0 01-.861.337c-.313 0-.625-.112-.863-.336l-5.452-5.128c-1.63-1.533-1.63-4.027 0-5.56a4.29 4.29 0 012.954-1.15h.001c1.116 0 2.166.41 2.954 1.152 1.087 1.022 1.49 2.519 1.05 3.906-.195.607-.872.953-1.518.77-.645-.18-1.012-.819-.82-1.426a1.57 1.57 0 00-.436-1.629 1.784 1.784 0 00-1.23-.48c-.466 0-.903.17-1.232.479a1.572 1.572 0 000 2.316l5.453 5.128z\"/></symbol>\n<symbol id=\"icon-salesforce-20\" viewBox=\"0 0 20 20\"><path d=\"M8.268 4.426a3.91 3.91 0 00-6.589 4.081 3.262 3.262 0 002.357 6.023 3.479 3.479 0 006.542.325 3.475 3.475 0 004.237-1.404 4.299 4.299 0 10-.761-8.18 3.842 3.842 0 00-5.786-.844z\"/></symbol>\n<symbol id=\"icon-shopify-20\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.587 3.732l-1.648-.12-1.213-1.177c-.12-.118-.354-.082-.445-.056l-.288.087-.323.098c-.365-1.026-1.01-1.97-2.143-1.97-.03 0-.064.002-.095.004C10.108.18 9.71 0 9.364 0c-2.64 0-3.901 3.225-4.297 4.863-1.026.31-1.754.531-1.847.56-.573.176-.591.193-.666.72C2.498 6.543 1 17.863 1 17.863L12.674 20 19 18.663S16.78 3.995 16.766 3.894c-.014-.1-.105-.156-.18-.162zm-6.53-.465l-1.978.617c.38-1.48 1.095-2.196 1.719-2.466.157.397.26.968.26 1.737v.058l-.001.054zm-2.761.862c.371-1.957 1.25-2.937 2.07-3.325a.576.576 0 00-.329-.112c-1.838 0-2.87 2.432-3.304 3.925l1.563-.488zm.708 4.929c-1.19 0-1.25.753-1.25.942 0 .41.418.719.924 1.093.774.573 1.753 1.298 1.753 2.764 0 1.908-1.2 3.137-2.82 3.137-1.942 0-2.935-1.219-2.935-1.219l.52-1.732s1.021.884 1.883.884c.562 0 .792-.447.792-.773 0-.592-.422-.936-.896-1.323-.608-.496-1.3-1.061-1.3-2.308 0-1.867 1.329-3.675 4.014-3.675 1.034 0 1.545.299 1.545.299l-.756 2.267s-.662-.356-1.474-.356zM10.5 1.29c.14.407.228.92.228 1.558V3.057l.957-.298c-.242-.747-.62-1.397-1.185-1.468z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-undo-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9 8a1 1 0 010 2H3a1 1 0 01-1-1V3a1 1 0 012 0v3.591C5.736 3.836 8.763 2 12.224 2 17.647 2 22 6.501 22 12s-4.353 10-9.776 10a1 1 0 110-2C16.494 20 20 16.442 20 12s-3.505-8-7.776-8C9.356 4 6.836 5.6 5.487 8H9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-double-left-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.768 6.64a1 1 0 10-1.536-1.28l-5 6a1 1 0 000 1.28l5 6a1 1 0 101.536-1.28L7.302 12l4.466-5.36zm7 0a1 1 0 10-1.536-1.28l-5 6a1 1 0 000 1.28l5 6a1 1 0 101.536-1.28L14.302 12l4.466-5.36z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-double-right-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5.232 17.36a1 1 0 001.536 1.28l5-6a1 1 0 000-1.28l-5-6a1 1 0 10-1.536 1.28L9.698 12l-4.466 5.36zm7 0a1 1 0 101.536 1.28l5-6a1 1 0 000-1.28l-5-6a1 1 0 10-1.536 1.28L16.698 12l-4.466 5.36z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-down-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4.24 8.35a1 1 0 011.41-.11L12 13.684l6.35-5.442a1 1 0 011.3 1.518l-7 6a1 1 0 01-1.3 0l-7-6a1 1 0 01-.11-1.41z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-left-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M15.65 4.24a1 1 0 01.11 1.41L10.316 12l5.442 6.35a1 1 0 01-1.518 1.3l-6-7a1 1 0 010-1.3l6-7a1 1 0 011.41-.11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-right-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8.35 19.76a1 1 0 01-.11-1.41L13.684 12 8.24 5.65a1 1 0 111.518-1.3l6 7a1 1 0 010 1.3l-6 7a1 1 0 01-1.41.11z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-angle-up-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M19.76 15.65a1 1 0 01-1.41.11L12 10.316 5.65 15.76a1 1 0 11-1.3-1.518l7-6a1 1 0 011.3 0l7 6a1 1 0 01.11 1.41z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-down-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13 2a1 1 0 10-2 0v16.339l-5.247-5.997a1 1 0 00-1.506 1.316l7 8a1 1 0 001.506 0l7-8a1 1 0 00-1.506-1.316L13 18.338V2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-left-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.659 5.753a1 1 0 10-1.318-1.506l-8 7a1 1 0 000 1.506l8 7a1 1 0 101.318-1.506L5.66 13H21a1 1 0 100-2H5.661l5.998-5.247z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-right-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13.659 4.247a1 1 0 10-1.318 1.506L18.34 11H3a1 1 0 100 2h15.339l-5.997 5.247a1 1 0 001.316 1.506l8-7a1 1 0 000-1.506l-8-7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-down-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M20 1a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h16zm1 3a1 1 0 00-1-1H4a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4zm-3.293 7.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L11 14.586V7a1 1 0 112 0v7.586l3.293-3.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-left-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1 4a3 3 0 013-3h16a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3V4zm3-1a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H4zm8.707 14.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L9.414 11H17a1 1 0 110 2H9.414l3.293 3.293a1 1 0 010 1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-right-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1 4a3 3 0 013-3h16a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3V4zm3-1a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H4zm7.293 3.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L14.586 13H7a1 1 0 110-2h7.586l-3.293-3.293a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-square-up-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1 4a3 3 0 013-3h16a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3V4zm3-1a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H4zm2.293 9.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L13 9.414V17a1 1 0 11-2 0V9.414l-3.293 3.293a1 1 0 01-1.414 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrow-up-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12.753 2.341a1 1 0 00-1.506 0l-7 8a1 1 0 001.506 1.318L11 5.66V21a1 1 0 102 0V5.661l5.247 5.998a1 1 0 001.506-1.318l-7-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-arrows-h-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M24 12a1 1 0 01-.293.707l-4 4a1 1 0 01-1.414-1.414L20.586 13H3.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L3.414 11h17.172l-2.293-2.293a1 1 0 011.414-1.414l4 4A1 1 0 0124 12z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-arrows-v-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 0a1 1 0 01.707.293l4 4a1 1 0 01-1.414 1.414L13 3.414v17.172l2.293-2.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L11 20.586V3.414L8.707 5.707a1 1 0 01-1.414-1.414l4-4A1 1 0 0112 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-compress-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M23.707.293a1 1 0 010 1.414L16.414 9H21a1 1 0 110 2h-7a1 1 0 01-1-1V3a1 1 0 112 0v4.586L22.293.293a1 1 0 011.414 0zM3 13a1 1 0 100 2h4.586L.293 22.293a1 1 0 101.414 1.414L9 16.414V21a1 1 0 102 0v-7a1 1 0 00-1-1H3z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-exchange-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6.707 1.293a1 1 0 010 1.414L4.414 5H18a1 1 0 110 2H4.414l2.293 2.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0zm16 16l-4-4a1 1 0 00-1.414 1.414L19.586 17H6a1 1 0 100 2h13.586l-2.293 2.293a1 1 0 001.414 1.414l4-4a1 1 0 000-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-redo-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 12c0-4.442 3.505-8 7.776-8 2.868 0 5.388 1.6 6.737 4H15a1 1 0 100 2h6a1 1 0 001-1V3a1 1 0 10-2 0v3.591C18.264 3.836 15.237 2 11.776 2 6.353 2 2 6.501 2 12s4.353 10 9.776 10a1 1 0 100-2C7.506 20 4 16.442 4 12z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sign-in-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11 3a1 1 0 011-1h7c1.652 0 3 1.348 3 3v14c0 1.652-1.348 3-3 3h-7a1 1 0 110-2h7c.548 0 1-.452 1-1V5c0-.548-.452-1-1-1h-7a1 1 0 01-1-1zm.707 4.293l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 13H3a1 1 0 110-2h9.586l-2.293-2.293a1 1 0 111.414-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sign-out-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 5c0-1.652 1.348-3 3-3h7a1 1 0 110 2H5c-.548 0-1 .452-1 1v14c0 .548.452 1 1 1h7a1 1 0 110 2H5c-1.652 0-3-1.348-3-3V5zm14.293 2.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L18.586 13H9a1 1 0 110-2h9.586l-2.293-2.293a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sync-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.6 3C7.667 3 4.312 5.591 2.94 9.344a1 1 0 11-1.88-.688C2.689 4.21 6.734 1 11.6 1c3.968 0 7.39 2.133 9.4 5.33V2a1 1 0 112 0v7a1 1 0 01-1 1h-7a1 1 0 110-2h4.66c-1.616-3.013-4.617-5-8.06-5zM3 22v-4.331C5.01 20.867 8.432 23 12.4 23c4.867 0 8.912-3.209 10.54-7.656a1 1 0 10-1.88-.688C19.689 18.41 16.334 21 12.4 21c-3.444 0-6.444-1.987-8.06-5H9a1 1 0 100-2H2a1 1 0 00-1 1v7a1 1 0 102 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-announcement-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.293.293a1 1 0 011.414 0l22 22a1 1 0 01-1.414 1.414l-22-22a1 1 0 010-1.414zM20 9a1 1 0 011 1v2c0 .34-.022.669-.057.988a1 1 0 01-1.988-.22c.029-.259.045-.514.045-.768v-2a1 1 0 011-1zm-9 11.945V23a1 1 0 102 0v-2.058a1 1 0 00-.232-1.987c-.257.029-.51.045-.763.045h-.01C8.138 18.997 5 15.857 5 12v-.929a1 1 0 10-2 0V12c0 4.625 3.506 8.446 8 8.945zM12 0a3.992 3.992 0 00-3.373 1.863 1 1 0 001.688 1.072C10.675 2.369 11.295 2 12 2a2 2 0 012 2v3.929a1 1 0 102 0V4a4 4 0 00-4-4z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-announcement-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2a2 2 0 00-2 2v8a2 2 0 104 0V4a2 2 0 00-2-2zM8 4a4 4 0 118 0v8a4 4 0 11-8 0V4zM4 9a1 1 0 011 1v2c0 3.859 3.141 7 7 7s7-3.141 7-7v-2a1 1 0 112 0v2c0 4.625-3.506 8.446-8 8.945V23a1 1 0 11-2 0v-2.055c-4.494-.499-8-4.32-8-8.945v-2a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-headset-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2C6.477 2 2 6.477 2 12v1a1 1 0 11-2 0v-1C0 5.373 5.373 0 12 0s12 5.373 12 12v5a5 5 0 01-5 5h-4.17a3.001 3.001 0 110-2H19a3 3 0 003-3v-5c0-5.523-4.477-10-10-10zm1 19a1 1 0 10-2 0 1 1 0 002 0zM7 8a3 3 0 00-3 3v4a3 3 0 106 0v-4a3 3 0 00-3-3zm-1 3a1 1 0 112 0v4a1 1 0 11-2 0v-4zm11-3a3 3 0 00-3 3v4a3 3 0 106 0v-4a3 3 0 00-3-3zm-1 3a1 1 0 112 0v4a1 1 0 11-2 0v-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-pause-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 4.001C5 3.448 5.448 3 6.001 3h1.997C8.552 3 9 3.449 9 4.001v15.997C9 20.552 8.551 21 7.999 21H6.001A1.001 1.001 0 015 19.999V4.001zM6.001 23h1.998A3.001 3.001 0 0011 19.998V4.001A3.001 3.001 0 007.998 1H6.001A3.001 3.001 0 003 4.001v15.998A3.001 3.001 0 006.001 23zM15 4.001C15 3.448 15.448 3 16.001 3h1.997C18.552 3 19 3.449 19 4.001v15.997c0 .554-.449 1.002-1.001 1.002h-1.997A1.001 1.001 0 0115 19.999V4.001zM16.002 23h1.997A3.001 3.001 0 0021 19.998V4.001A3.001 3.001 0 0017.998 1h-1.997A3.001 3.001 0 0013 4.001v15.998A3.001 3.001 0 0016.002 23z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-play-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 4.803C5 2.52 7.592 1.159 9.443 2.567l9.454 7.195c1.471 1.12 1.471 3.35 0 4.47l-9.453 7.192C7.593 22.83 5 21.47 5 19.189V4.803zm3.232-.645C7.744 3.786 7 4.118 7 4.803v14.386c0 .684.743 1.016 1.233.644l9.452-7.193a.816.816 0 000-1.288L8.232 4.158z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-record-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-stop-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 4.997A3.002 3.002 0 014.997 2H19.2C20.742 2 22 3.258 22 4.8v14.4c0 1.542-1.258 2.8-2.8 2.8H4.8A2.805 2.805 0 012 19.2V4.997zM19.2 4H4.997C4.45 4 4 4.45 4 4.997V19.2c0 .438.362.8.8.8h14.4c.438 0 .8-.362.8-.8V4.8c0-.438-.362-.8-.8-.8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-down-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 3a1 1 0 00-1.625-.78L5.65 6H3a3 3 0 00-3 3v6a3 3 0 003 3h2.65l4.725 3.78A1 1 0 0012 21V3zM6.625 7.78L10 5.08v13.84l-3.375-2.7A1 1 0 006 16H3a1 1 0 01-1-1V9a1 1 0 011-1h3a1 1 0 00.625-.22zm11.104-1.466a1 1 0 00-1.454 1.374 6.254 6.254 0 01-.002 8.626 1 1 0 001.454 1.374 8.254 8.254 0 00.002-11.374z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-mute-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 00.293 1.707l22 22a1 1 0 001.414-1.414l-22-22zm16.895.907A1 1 0 0017.4 2.8 11.48 11.48 0 0122 12c0 1.089-.169 2.142-.459 3.158a1 1 0 001.924.549c.334-1.171.535-2.41.535-3.707a13.48 13.48 0 00-5.398-10.8zm-2.287 5.074a1 1 0 011.414.04 8.26 8.26 0 012.267 5.6 1 1 0 01-2 .021 6.26 6.26 0 00-1.721-4.247 1 1 0 01.04-1.414zM2.078 8.614A1 1 0 00.234 7.84 2.99 2.99 0 000 9v6a3 3 0 003 3h2.65l4.725 3.78A1 1 0 0012 21v-2.929a1 1 0 10-2 0v.848l-3.375-2.7A1 1 0 006 16H3a1 1 0 01-1-1V9a.99.99 0 01.078-.386z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-volume-off-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.433 2.099A1 1 0 0112 3v18a1 1 0 01-1.625.78L5.65 18H3a3 3 0 01-3-3V9a3 3 0 013-3h2.65l4.725-3.78a1 1 0 011.058-.121zM10 5.08l-3.375 2.7A1 1 0 016 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3a1 1 0 01.625.22L10 18.92V5.08zm6.293 3.212a1 1 0 011.414 0L20 10.586l2.293-2.293a1 1 0 111.414 1.414L21.414 12l2.293 2.293a1 1 0 01-1.414 1.414L20 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L18.586 12l-2.293-2.293a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-volume-up-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M18.602 1.2A1 1 0 0017.4 2.8 11.48 11.48 0 0122 12c0 3.761-1.804 7.1-4.6 9.2a1 1 0 101.202 1.6A13.48 13.48 0 0024 12a13.48 13.48 0 00-5.398-10.8zm-7.169.899A1 1 0 0112 3v18a1 1 0 01-1.625.78L5.65 18H3a3 3 0 01-3-3V9a3 3 0 013-3h2.65l4.725-3.78a1 1 0 011.058-.121zM10 5.08l-3.375 2.7A1 1 0 016 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3a1 1 0 01.625.22L10 18.92V5.08zm6.315 1.193a1 1 0 011.414.04 8.254 8.254 0 01-.002 11.374 1 1 0 01-1.454-1.374 6.254 6.254 0 00.002-8.626 1 1 0 01.04-1.414z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-activity-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M8.493 2a1 1 0 01.956.684l5.236 15.71 2.42-4.841A1 1 0 0118 13h5a1 1 0 110 2h-4.382l-3.224 6.447a1 1 0 01-1.843-.13L8.522 6.228l-2.57 8.074A1 1 0 015 15H1a1 1 0 110-2h3.269L7.547 2.697A1 1 0 018.493 2z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-address-book-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V3H5zM2 19v1a3 3 0 003 3h12a3 3 0 003-3v-5h1a3 3 0 003-3v-2c0-.768-.289-1.47-.764-2 .475-.53.764-1.232.764-2V4a3 3 0 00-3-3H5a3 3 0 00-3 3v1H1a1 1 0 000 2h1v4H1a1 1 0 100 2h1v4H1a1 1 0 100 2h1zM21 7h-1V3h1a1 1 0 011 1v2a1 1 0 01-1 1zm0 2h-1v4h1a1 1 0 001-1v-2a1 1 0 00-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-align-left-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 2a1 1 0 000 2h10a1 1 0 100-2H4zm0 6a1 1 0 000 2h13a1 1 0 100-2H4zm-1 7a1 1 0 011-1h10a1 1 0 110 2H4a1 1 0 01-1-1zm1 5a1 1 0 100 2h16a1 1 0 100-2H4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-american-football-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M14.787 2.26c-2.927.37-6.133 1.438-8.661 3.966-2.527 2.526-3.594 5.73-3.966 8.655l7.115 7.02c2.903-.38 6.07-1.451 8.572-3.954 2.552-2.552 3.615-5.794 3.977-8.743L14.787 2.26zm7.193 4.28a23.977 23.977 0 00-.2-3.058 20.7 20.7 0 00-.16-1.028 20.742 20.742 0 00-1.03-.16 23.965 23.965 0 00-3.116-.201L21.98 6.54zM6.6 22.08l-4.607-4.546a23.959 23.959 0 00.2 3.157c.055.414.112.761.16 1.028.268.049.615.106 1.03.16.842.11 1.953.208 3.216.201zM23.441 1.364l-.974.24.974-.24a1.003 1.003 0 00-.733-.733l-.24.974.24-.974h-.002L22.706.63l-.009-.002-.029-.007a14.426 14.426 0 00-.473-.1 22.062 22.062 0 00-1.343-.217 25.768 25.768 0 00-4.511-.19C12.764.283 8.214 1.3 4.707 4.807 1.201 8.314.183 12.864.014 16.44a25.768 25.768 0 00.19 4.511 22.062 22.062 0 00.294 1.715l.023.102.007.028.002.009v.003s.001.001.975-.24l-.974.241c.09.361.371.643.733.733l.24-.974-.24.974h.001l.003.001.009.002.028.007.102.023a22.072 22.072 0 001.715.293c1.133.149 2.714.276 4.51.191 3.577-.169 8.127-1.187 11.634-4.693 3.506-3.507 4.524-8.057 4.693-11.633a25.757 25.757 0 00-.19-4.511 22.072 22.072 0 00-.294-1.715l-.023-.102-.007-.028-.002-.009v-.003zM14.566 7.13a1.003 1.003 0 10-1.448 1.39l2.408 2.507a1.003 1.003 0 101.447-1.39L14.566 7.13zM11.24 9.822a1.003 1.003 0 00-1.418 1.419l3.009 3.01a1.003 1.003 0 001.418-1.42l-3.009-3.009zM7.13 13.118c.4-.383 1.035-.37 1.418.03l2.408 2.507a1.003 1.003 0 11-1.447 1.389L7.1 14.536c-.383-.4-.37-1.034.03-1.418z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-anchor-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 3a2 2 0 100 4 2 2 0 000-4zm4 2a4.002 4.002 0 01-3 3.874v12.089c3.007-.226 5.768-1.459 8-3.408V15h-1a1 1 0 110-2h2a1 1 0 011 1v4a1 1 0 01-.32.734C19.813 21.386 16.085 23 12 23c-4.086 0-7.813-1.614-10.68-4.265a1 1 0 01-.32-.734V14a1 1 0 011-1h2a1 1 0 110 2H3v2.555c2.233 1.95 4.993 3.183 8 3.408V8.874A4.002 4.002 0 0112 1a4 4 0 014 4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-archive-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3.818 4C3.282 4 3 4.378 3 4.667V7h18V4.667c0-.289-.282-.667-.818-.667H3.818zM1 4.667v14.476C1 20.7 2.241 22 3.818 22h16.364C21.759 22 23 20.701 23 19.143V4.667C23 3.113 21.655 2 20.182 2H3.818C2.345 2 1 3.113 1 4.667zM3 9h18v10.143c0 .494-.386.857-.818.857H3.818C3.386 20 3 19.637 3 19.143V9zm6 2a1 1 0 100 2h6a1 1 0 100-2H9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-ban-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M22 12c0 5.523-4.477 10-10 10a9.959 9.959 0 01-6.329-2.257L19.743 5.67A9.959 9.959 0 0122 12zM4.257 18.329L18.329 4.257A9.959 9.959 0 0012 2C6.477 2 2 6.477 2 12c0 2.401.846 4.605 2.257 6.329zM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bars-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 5a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zm0 7a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zm1 6a1 1 0 100 2h18a1 1 0 100-2H3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bell-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 00.293 1.707l22 22a1 1 0 001.414-1.414l-22-22zM12 0c-1.275 0-2.573.347-3.655 1.068a1 1 0 001.11 1.664C10.173 2.253 11.075 2 12 2c2.748 0 5 2.252 5 5v3.9a1 1 0 102 0V7c0-3.852-3.148-7-7-7zM8 20H3a1 1 0 01-.924-1.381l2.6-6.3a1 1 0 111.848.762L4.494 18H11.9a1 1 0 110 2H10c0 1.148.852 2 2 2 .717 0 1.314-.389 1.652-.93a1 1 0 011.696 1.06C14.686 23.189 13.483 24 12 24c-2.252 0-4-1.748-4-4z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-bell-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7 7c0-2.748 2.252-5 5-5s5 2.252 5 5v5a1 1 0 00.08.394L19.485 18H4.515l2.403-5.606A1 1 0 007 12V7zm1.003 13H3a1 1 0 01-.92-1.394L5 11.795V7c0-3.852 3.148-7 7-7s7 3.148 7 7v4.795l2.92 6.811A1 1 0 0121 20h-5.003c-.076 2.22-1.75 4-3.997 4s-3.921-1.78-3.997-4zm2.002 0c.07 1.2.94 2 1.995 2 1.054 0 1.925-.8 1.995-2h-3.99z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bold-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 4a1 1 0 011-1h7a5 5 0 013.436 8.633A5 5 0 0114 21H6a1 1 0 01-1-1V4zm2 9h7a3 3 0 010 6H7v-6zm0-2V5h6a3 3 0 010 6H7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bolt-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6.6 1.821A.991.991 0 017.572 1h6.913c.296 0 .576.134.763.366.188.232.263.536.205.83L14.702 6h1.331c2.27 0 3.697 2.48 2.578 4.479L12.275 21.8a2.332 2.332 0 01-2.033 1.2c-1.495 0-2.606-1.402-2.282-2.88L9.303 14h-1.34c-1.848 0-3.245-1.695-2.914-3.537L6.6 1.821zM8.396 3l-1.404 7.821A.996.996 0 007.963 12h2.572c.3 0 .582.138.77.374.187.237.259.547.194.843l-1.61 7.337a.361.361 0 00.668.26l6.335-11.321C17.265 8.826 16.79 8 16.033 8h-2.536a.983.983 0 01-.764-.366 1.01 1.01 0 01-.204-.83L13.28 3H8.396z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-bookmark-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 4a3 3 0 013-3h12a3 3 0 013 3v18a1 1 0 01-1.447.894L12 19.118l-7.553 3.776A1 1 0 013 22V4zm3-1a1 1 0 00-1 1v16.382l6.553-3.276a1 1 0 01.894 0L19 20.382V4a1 1 0 00-1-1H6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-branch-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 6a2 2 0 100-4 2 2 0 000 4zm4-2a4.002 4.002 0 01-3 3.874V11h3c2.752 0 5 2.248 5 5v.126A4.002 4.002 0 0120 24a4 4 0 01-1-7.874V16c0-1.648-1.352-3-3-3H8c-1.648 0-3 1.352-3 3v.126A4.002 4.002 0 014 24a4 4 0 01-1-7.874V16c0-2.752 2.248-5 5-5h3V7.874A4.002 4.002 0 0112 0a4 4 0 014 4zm4 14a2 2 0 100 4 2 2 0 000-4zM6 20a2 2 0 11-4 0 2 2 0 014 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-building-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 2.88C2 1.29 3.343 0 5 0h14c1.657 0 3 1.29 3 2.88V22h1a1 1 0 110 2H1a1 1 0 110-2h1V2.88zM11 22h2v-1h-2v1zm4 0v-2a1 1 0 00-1-1h-4a1 1 0 00-1 1v2H4V2.88c0-.53.448-.96 1-.96h14c.552 0 1 .43 1 .96V22h-5zM8 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM14.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 10.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM14.5 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 15.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6.5-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-camera-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7.168 1.445A1 1 0 018 1h8a1 1 0 01.832.445L18.535 4H21a3 3 0 013 3v13a3 3 0 01-3 3H3a3 3 0 01-3-3V7a3 3 0 013-3h2.465l1.703-2.555zM8.535 3L6.832 5.555A1 1 0 016 6H3a1 1 0 00-1 1v13a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1h-3a1 1 0 01-.832-.445L15.465 3h-6.93zM12 10a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0zm13-4.01a1 1 0 10-2 0V9a1 1 0 102 0v-.01z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-channels-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 4a2 2 0 114 0 2 2 0 01-4 0zm3 3.874A4.002 4.002 0 006 0a4 4 0 00-1 7.874v8.252A4.002 4.002 0 006 24a4 4 0 001.121-7.84A3.016 3.016 0 0110 14h4c2.752 0 5-2.248 5-5V7.874A4.002 4.002 0 0018 0a4 4 0 00-1 7.874V9c0 1.648-1.352 3-3 3h-4a4.97 4.97 0 00-3 1.005V7.874zM18 6a2 2 0 100-4 2 2 0 000 4zM4 20a2 2 0 114 0 2 2 0 01-4 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chart-bar-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11 3c0-.548.452-1 1-1s1 .452 1 1v18c0 .548-.452 1-1 1s-1-.452-1-1V3zm1-3c-1.652 0-3 1.348-3 3v18c0 1.652 1.348 3 3 3s3-1.348 3-3V3c0-1.652-1.348-3-3-3zm8 9c-.548 0-1 .452-1 1v11c0 .548.452 1 1 1s1-.452 1-1V10c0-.548-.452-1-1-1zm-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v11c0 1.652-1.348 3-3 3s-3-1.348-3-3V10zM4 12c-.548 0-1 .452-1 1v8c0 .548.452 1 1 1s1-.452 1-1v-8c0-.548-.452-1-1-1zm-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v8c0 1.652-1.348 3-3 3s-3-1.348-3-3v-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M0 10.095C0 5.027 4.3 1 9.5 1H12a1 1 0 110 2H9.5C5.312 3 2 6.222 2 10.095c0 3.451 2.625 6.374 6.168 6.976a1 1 0 01.832.986v2.123l4.464-2.834a1 1 0 01.536-.155h.5c4.188 0 7.5-3.223 7.5-7.096V10a1 1 0 112 0v.095c0 5.068-4.3 9.095-9.5 9.095h-.21l-5.754 3.654A1 1 0 017 22v-3.136c-4.004-1.045-7-4.542-7-8.769zM19 1a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V6h-2a1 1 0 110-2h2V2a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 00.293 1.707l22 22a1 1 0 001.414-1.414l-22-22zM8.5 2a1 1 0 011-1h5c5.252 0 9.5 4.248 9.5 9.5 0 2.33-.78 4.466-2.244 6.155a1 1 0 11-1.512-1.31C21.38 14.035 22 12.37 22 10.5 22 6.352 18.648 3 14.5 3h-5a1 1 0 01-1-1zM7 18.701C2.943 17.608 0 13.892 0 9.5a1 1 0 112 0c0 3.714 2.65 6.799 6.172 7.415A1 1 0 019 17.9v2.482l4.553-2.277a1 1 0 01.894 1.79l-6 3A1 1 0 017 22v-3.299z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-check-circle-filled-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm4.768-14.36a1 1 0 10-1.536-1.28l-4.3 5.159-2.225-2.226a1 1 0 00-1.414 1.414l3 3a1 1 0 001.475-.067l5-6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-close-circle-filled-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm4.707-16.707a1 1 0 010 1.414L13.414 12l3.293 3.293a1 1 0 01-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 11-1.414-1.414L10.586 12 7.293 8.707a1 1 0 111.414-1.414L12 10.586l3.293-3.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-close-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-download-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2h-.026c-4.188.108-7.588 3.272-7.943 7.387C1.767 10.047 0 12.069 0 14.7c0 2.815 2.085 5.128 4.87 5.492a1 1 0 00.26-1.984C3.314 17.972 2 16.485 2 14.7c0-1.854 1.383-3.27 3.135-3.51A1 1 0 006 10.2v-.1C6 6.761 8.646 4.093 12.013 4A5.957 5.957 0 0118 10v.1a1 1 0 00.865.99C20.602 11.329 22 12.834 22 14.6c0 1.804-1.426 3.353-3.09 3.504a1 1 0 10.18 1.992c2.736-.249 4.91-2.7 4.91-5.496 0-2.53-1.758-4.632-4.03-5.31A7.952 7.952 0 0012 2zm0 8a1 1 0 011 1v7.586l2.293-2.293a1 1 0 011.414 1.414l-3.998 3.998a.997.997 0 01-.707.295h-.008a.997.997 0 01-.701-.293l-4-4a1 1 0 111.414-1.414L11 18.586V11a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-upload-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2a7.952 7.952 0 00-7.97 7.287C1.778 9.944 0 11.948 0 14.5 0 17.552 2.448 20 5.5 20H7a1 1 0 100-2H5.5A3.481 3.481 0 012 14.5c0-1.74 1.369-3.168 3.135-3.41A1 1 0 006 10.1V10c0-3.348 2.652-6 6-6s6 2.653 6 6v.1a1 1 0 00.91.996C20.602 11.25 22 12.725 22 14.5c0 1.948-1.552 3.5-3.5 3.5H17a1 1 0 100 2h1.5c3.052 0 5.5-2.448 5.5-5.5 0-2.512-1.742-4.63-4.033-5.24A7.952 7.952 0 0012 2zM7.293 14.293l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L13 13.414V21a1 1 0 11-2 0v-7.586l-2.293 2.293a1 1 0 01-1.414-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 3a7.952 7.952 0 00-7.96 7.187C1.762 10.862 0 12.967 0 15.5 0 18.552 2.448 21 5.5 21h13c3.052 0 5.5-2.448 5.5-5.5 0-2.493-1.728-4.711-4.04-5.34C19.552 6.024 16.165 3 12 3zm0 2c3.357 0 6 2.562 6 6a1 1 0 00.91.996c1.664.151 3.09 1.7 3.09 3.504 0 1.948-1.552 3.5-3.5 3.5h-13A3.481 3.481 0 012 15.5c0-1.746 1.364-3.236 3.072-3.5H8a1 1 0 100-2H6.08C6.549 7.14 8.995 5 12 5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-code-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8.707 6.707a1 1 0 00-1.414-1.414l-6 6a1 1 0 000 1.414l6 6a1 1 0 001.414-1.414L3.414 12l5.293-5.293zm8-1.414a1 1 0 10-1.414 1.414L20.586 12l-5.293 5.293a1 1 0 001.414 1.414l6-6a1 1 0 000-1.414l-6-6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cog-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.3 0c-1.139 0-2.198.806-2.386 1.936a1.01 1.01 0 00-.006.035L8.683 3.7C8 4 7.294 4.374 6.684 4.856l-1.596-.58c-1.153-.536-2.304.092-2.869.798a1 1 0 00-.113.178l-.786 1.57a2.249 2.249 0 00.546 2.85l1.342 1.119c-.06.359-.108.76-.108 1.208 0 .449.048.85.108 1.208l-1.342 1.118c-.926.748-1.03 1.983-.56 2.921a.994.994 0 00.012.024l.794 1.49c.57 1.122 1.836 1.41 2.804 1.088a.927.927 0 00.048-.018l1.757-.687c.624.473 1.289.85 1.987 1.164L9.002 22c.06 1.247 1.242 2 2.298 2H13c1.228 0 2.11-.893 2.286-1.932v-.004l.3-1.719c.74-.304 1.412-.735 2.012-1.209l1.66.604a.955.955 0 00.026.009c.96.32 2.214.038 2.79-1.063l.883-1.471a.954.954 0 00.037-.068c.47-.94.365-2.18-.57-2.928l-1.328-1.034c.058-.353.104-.746.104-1.185 0-.449-.048-.85-.108-1.208l1.341-1.118c.927-.748 1.03-1.983.561-2.921a.965.965 0 00-.037-.067l-.882-1.472c-.577-1.101-1.83-1.383-2.791-1.063a.977.977 0 00-.063.023l-1.65.676a10.141 10.141 0 00-1.98-1.158l-.305-1.76A2.318 2.318 0 0014.482.56 2.324 2.324 0 0013 0h-1.7zm-.708 4.53l.296-2.273A.306.306 0 0111 2.106.485.485 0 0111.3 2H13c.028 0 .106.016.193.09a.333.333 0 01.12.174l.402 2.307a1 1 0 00.614.757c.923.37 1.718.817 2.412 1.425a1 1 0 001.038.173l2.16-.884a.421.421 0 01.245.003.197.197 0 01.122.102.967.967 0 00.037.067l.875 1.46a.51.51 0 01.046.287.242.242 0 01-.089.158l-.015.013-1.8 1.5a1 1 0 00-.34.964c.1.505.18.915.18 1.404 0 .489-.08.9-.18 1.404a1 1 0 00.366.985l1.793 1.395a.242.242 0 01.085.155.51.51 0 01-.046.287l-.875 1.46a.977.977 0 00-.037.067.197.197 0 01-.122.102.425.425 0 01-.259 0l-2.183-.795a1 1 0 00-1 .187c-.742.65-1.517 1.152-2.33 1.395a1 1 0 00-.697.787l-.4 2.3-.001.007a.33.33 0 01-.103.192A.3.3 0 0113 22h-1.7a.426.426 0 01-.268-.09.194.194 0 01-.032-.032.99.99 0 00-.015-.15l-.4-2.3a1 1 0 00-.614-.756c-.923-.37-1.718-.817-2.412-1.425a1 1 0 00-1.023-.178l-2.27.888a.423.423 0 01-.25-.002.197.197 0 01-.122-.102.858.858 0 00-.012-.024l-.792-1.485a.518.518 0 01-.054-.305.242.242 0 01.089-.158l.015-.013 1.8-1.5a1 1 0 00.34-.964c-.1-.505-.18-.915-.18-1.404 0-.489.08-.9.18-1.404a1 1 0 00-.34-.964l-1.8-1.5-.015-.013a.246.246 0 01-.09-.153.226.226 0 01.022-.152 1 1 0 00.037-.067l.743-1.485A.682.682 0 014.09 6.1c.093-.031.137-.017.162-.005.034.018.07.033.105.046l2.2.8a1 1 0 001.05-.233c.55-.55 1.391-.99 2.363-1.379a1 1 0 00.62-.799zM10.1 12a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-conversations-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6.707 0C3.691 0 .848 1.975.133 5.075a6.643 6.643 0 002.874 6.897V15a1 1 0 001.515.857L9.284 13h2.023c3.013 0 5.978-2.077 6.582-5.208C18.713 3.657 15.518 0 11.507 0h-4.8zM4.471 10.514c-1.719-.9-2.79-2.863-2.385-5.007C2.577 3.417 4.53 2 6.707 2h4.8c2.788 0 4.992 2.541 4.42 5.404l-.002.007C15.528 9.48 13.493 11 11.307 11h-2.3a1 1 0 00-.514.143l-3.486 2.09V11.4a1 1 0 00-.536-.886zm17.243-1.221a1 1 0 10-1.414 1.414c.406.406.843 1.03 1.177 1.742.335.716.53 1.443.53 2.051 0 1.722-.986 3.275-2.447 4.006a1 1 0 00-.553.894v1.93l-4.128-2.211a1 1 0 00-.472-.119h-1.9c-.625 0-1.358-.18-2.062-.498-.704-.32-1.308-.746-1.698-1.175a1 1 0 00-1.48 1.346c.61.671 1.456 1.244 2.353 1.65.896.407 1.913.677 2.887.677h1.65l5.378 2.881A1 1 0 0021.007 23v-3.018a6.51 6.51 0 003-5.482c0-.992-.305-2.015-.72-2.9-.415-.887-.978-1.713-1.573-2.307z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-copy-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8.667 2A.657.657 0 008 2.636v14.728c0 .33.285.636.667.636h11.666a.657.657 0 00.667-.636V9h-6a1 1 0 01-1-1V2H8.667zM18 20h2.333C21.785 20 23 18.833 23 17.364V7.545a1 1 0 00-.3-.713L16.035.286a1 1 0 00-.7-.286H8.666C7.215 0 6 1.167 6 2.636V4H3.667C2.215 4 1 5.167 1 6.636v14.728C1 22.834 2.215 24 3.667 24h11.666C16.785 24 18 22.833 18 21.364V20zm-2 0H8.667C7.215 20 6 18.833 6 17.364V6H3.667A.657.657 0 003 6.636v14.728c0 .33.285.636.667.636h11.666a.657.657 0 00.667-.636V20zm0-13h4.017L16 3.056V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-credit-card-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 6a1 1 0 011-1h18a1 1 0 011 1v3H2V6zm-2 4V6a3 3 0 013-3h18a3 3 0 013 3v12a3 3 0 01-3 3H3a3 3 0 01-3-3v-8zm22 1v7a1 1 0 01-1 1H3a1 1 0 01-1-1v-7h20zM8 14.99c.552 0 1 .445 1 .995v.01c0 .55-.448.995-1 .995s-1-.445-1-.995v-.01c0-.55.448-.995 1-.995zm-2 .995a.998.998 0 00-1-.995c-.552 0-1 .445-1 .995v.01c0 .55.448.995 1 .995s1-.445 1-.995v-.01z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cut-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6.91 5a1.91 1.91 0 00-.8 3.643l.019.01A1.91 1.91 0 106.909 5zm2.26 5.1a3.91 3.91 0 10-3.86.377L8.507 12 5.31 13.522a3.91 3.91 0 103.858.378L20.43 8.54a1 1 0 10-.86-1.806l-8.736 4.16L9.17 10.1zm-3.09 5.27l.03-.013.02-.01a1.91 1.91 0 11-.05.023zm7.2-2.206a1 1 0 011.332-.473l5.819 2.77a1 1 0 01-.86 1.806l-5.819-2.77a1 1 0 01-.473-1.333z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dashboard-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11 2.05a9.954 9.954 0 00-5.329 2.207l1.336 1.336a1 1 0 01-1.414 1.414L4.257 5.671A9.954 9.954 0 002.049 11H4a1 1 0 110 2H2.05c.501 5.053 4.765 9 9.95 9s9.449-3.947 9.95-9H20a1 1 0 110-2h1.95a9.953 9.953 0 00-2.207-5.329l-1.336 1.336a1 1 0 11-1.414-1.414l1.336-1.336A9.954 9.954 0 0013 2.049V4a1 1 0 11-2 0V2.05zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1 16a1 1 0 112 0 1 1 0 01-2 0zm0-7v4.17a3.001 3.001 0 102 0V9a1 1 0 10-2 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dixa-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9.212 1.292c4.716-2.658 10.744-1.084 13.466 3.52A9.417 9.417 0 0124 9.618c0 3.327-1.77 6.563-4.931 8.347l-7.089 3.997-1.447.813L8.42 23.97c-.156.088-.351-.022-.351-.198v-4.735c0-.28-.076-.555-.22-.798L1.12 6.86a.863.863 0 01.328-1.195l7.764-4.373zm4.114 12.501l2.456-1.385a3.192 3.192 0 001.643-2.786c0-.542-.139-1.097-.439-1.6-.909-1.535-2.915-2.06-4.487-1.172l-2.46 1.382a.432.432 0 00-.164.598l2.84 4.803c.123.21.397.281.611.16z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-done-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M19.689 6.275a1 1 0 01.036 1.414l-9.5 10a1 1 0 01-1.39.058l-4.5-4a1 1 0 011.33-1.494L9.44 15.61l8.834-9.299a1 1 0 011.414-.036z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dots-h-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 14a2 2 0 100-4 2 2 0 000 4zm9 0a2 2 0 100-4 2 2 0 000 4zm11-2a2 2 0 11-4 0 2 2 0 014 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dots-v-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10 3a2 2 0 104 0 2 2 0 00-4 0zm0 9a2 2 0 104 0 2 2 0 00-4 0zm2 11a2 2 0 110-4 2 2 0 010 4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-download-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13 3a1 1 0 10-2 0v9.586l-2.293-2.293a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414L13 12.586V3zM4 21a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-dropdown-list-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M0 1a1 1 0 011-1h11a1 1 0 110 2H1a1 1 0 01-1-1zm0 5a1 1 0 011-1h11a1 1 0 110 2H1a1 1 0 01-1-1zm1 4a1 1 0 100 2h11a1 1 0 100-2H1zm16 0a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5h-5a1 1 0 110-2h5v-5a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-enter-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 1a3 3 0 00-3 3v16a3 3 0 003 3h16a3 3 0 003-3V4a3 3 0 00-3-3H4zM3 4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm14 3a1 1 0 011 1v5a1 1 0 01-1 1H9.38l1.318 1.284a1 1 0 01-1.396 1.432l-3-2.923a1 1 0 01-.018-1.414l3-3.077a1 1 0 111.432 1.396L9.446 12H16V8a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-circle-filled-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-12 1a1 1 0 01-1-1V7a1 1 0 112 0v5a1 1 0 01-1 1zm0 2a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-triangle-filled-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M23.512 17.5L15.178 2.852c-1.405-2.47-4.952-2.47-6.357 0L.488 17.5C-.907 19.95.855 23 3.665 23h16.67c2.81 0 4.572-3.05 3.177-5.5zM12 15a1 1 0 01-1-1V9a1 1 0 112 0v5a1 1 0 01-1 1zm0 2a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm12 2a1 1 0 01-1-1V7a1 1 0 112 0v6a1 1 0 01-1 1zm0 2a1 1 0 100 2 1 1 0 000-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-expand-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1 0a1 1 0 00-1 1v6a1 1 0 002 0V2h5a1 1 0 000-2H1zm16 0a1 1 0 100 2h5v5a1 1 0 102 0V1a1 1 0 00-1-1h-6zm6 16a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 110-2h5v-5a1 1 0 011-1zM2 17a1 1 0 10-2 0v6a1 1 0 001 1h6a1 1 0 100-2H2v-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-external-link-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M14 3a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 11-2 0V5.378l-8.337 8.337a.974.974 0 11-1.378-1.378L18.622 4H15a1 1 0 01-1-1zM4 7c0-.548.452-1 1-1h1a1 1 0 000-2H5C3.348 4 2 5.348 2 7v12c0 1.652 1.348 3 3 3h12c1.652 0 3-1.348 3-3v-1a1 1 0 10-2 0v1c0 .548-.452 1-1 1H5c-.548 0-1-.452-1-1V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-eye-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M0 11.95C0 14.138 5.5 21 12 21s12-6.762 12-8.95C24 9.862 18.5 3 12 3S0 9.762 0 11.95zm2 .1c.2-1.194 4.7-7.061 10-7.061s9.8 5.867 10 6.961c-.2 1.194-4.7 7.061-10 7.061S2.2 13.144 2 12.05zm6 0C8 14.178 9.744 16 12 16c2.256 0 4-1.924 4-4.05C16 9.822 14.256 8 12 8c-2.256 0-4 1.924-4 4.05zm2.051-.1c0-1.013.82-1.925 1.949-1.925 1.128 0 1.949 1.013 1.949 2.026 0 1.012-.82 1.924-1.949 1.924-1.128 0-1.949-1.013-1.949-2.026z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-archive-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 2a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V7.414L14.586 2H5zM2 3a3 3 0 013-3h10a1 1 0 01.707.293l6 6A1 1 0 0122 7v14a3 3 0 01-3 3H5a3 3 0 01-3-3V3zm6 1a1 1 0 011-1h4a1 1 0 110 2H9a1 1 0 01-1-1zm1 2a1 1 0 000 2h4a1 1 0 100-2H9zm-1 4a1 1 0 011-1h4a1 1 0 110 2H9a1 1 0 01-1-1zm1 2a1 1 0 00-1 1v2a3 3 0 106 0v-2a1 1 0 00-1-1H9zm1 3v-1h2v1a1 1 0 11-2 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-audio-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 2a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V7.46L13.63 2H5zM2 3a3 3 0 013-3h9a1 1 0 01.65.24l7 6A1 1 0 0122 7v14a3 3 0 01-3 3H5a3 3 0 01-3-3V3zm11.526 6.15A1 1 0 0114 10v8a1 1 0 01-1.447.894L8.763 17H8a3 3 0 110-6h.764l3.789-1.894a1 1 0 01.973.043zM12 11.617l-2.553 1.276A1 1 0 019 13H8a1 1 0 000 2h1a1 1 0 01.447.106L12 16.382v-4.764zm5.8-1.219a1 1 0 10-1.6 1.202c.503.668.8 1.498.8 2.4 0 .901-.297 1.73-.8 2.398a1 1 0 101.6 1.202 5.974 5.974 0 001.2-3.6c0-1.35-.447-2.598-1.2-3.602z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-csv-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 3c0-.548.452-1 1-1h9.586L20 7.414V8a1 1 0 102 0V7a1 1 0 00-.293-.707l-6-6A1 1 0 0015 0H5C3.348 0 2 1.348 2 3v5a1 1 0 002 0V3zm3 8c-1.652 0-3 1.348-3 3v2c0 1.652 1.348 3 3 3a1 1 0 100-2c-.548 0-1-.452-1-1v-2c0-.548.452-1 1-1a1 1 0 100-2zM2.853 21.105a1 1 0 011.341.448c.114.226.444.447.806.447h14c.362 0 .692-.221.806-.447a1 1 0 011.788.894C21.108 23.421 20.038 24 19 24H5c-1.038 0-2.108-.579-2.594-1.553a1 1 0 01.447-1.341zm16.117-8.863a1 1 0 10-1.94-.485l-.53 2.12-.53-2.12a1 1 0 10-1.94.486l1.495 5.98A1.005 1.005 0 0016.5 19a1.002 1.002 0 00.975-.778l1.495-5.98zM11 11c-.527 0-1.044.18-1.432.568C9.18 11.956 9 12.473 9 13v1c0 .527.18 1.044.568 1.432.388.388.905.568 1.432.568v1h-1a1 1 0 100 2h1c.527 0 1.044-.18 1.432-.568.388-.388.568-.905.568-1.432v-1c0-.527-.18-1.044-.568-1.432C12.044 14.18 11.527 14 11 14v-1h1a1 1 0 100-2h-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-excel-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 2a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V7.46L13.63 2H5zM2 3a3 3 0 013-3h9a1 1 0 01.65.24l7 6A1 1 0 0122 7v14a3 3 0 01-3 3H5a3 3 0 01-3-3V3zm6.445 5.168a1 1 0 011.387.277L12 11.697l2.168-3.252a1 1 0 011.664 1.11l-2.63 3.945 2.63 3.945a1 1 0 01-1.664 1.11L12 15.303l-2.168 3.252a1 1 0 01-1.664-1.11l2.63-3.945-2.63-3.945a1 1 0 01.277-1.387z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-image-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 2a1 1 0 00-1 1v13.297l4.24-4.948a1 1 0 011.534.018L18.474 22H19a1 1 0 001-1V7.46L13.63 2H5zM2 19v2a3 3 0 003 3h14a3 3 0 003-3V7a1 1 0 00-.35-.76l-7-6A1 1 0 0014 0H5a3 3 0 00-3 3v16zm3 3h10.89l-6.908-8.443L4 19.37V21a1 1 0 001 1zm9-12a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-pdf-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 3c0-.548.452-1 1-1h9.586L20 7.414V8a1 1 0 102 0V7a1 1 0 00-.293-.707l-6-6A1 1 0 0015 0H5C3.348 0 2 1.348 2 3v5a1 1 0 002 0V3zm7 8a1 1 0 00-1 1v6a1 1 0 001 1h2c.527 0 1.044-.18 1.432-.568.388-.388.568-.905.568-1.432v-4c0-.527-.18-1.044-.568-1.432C14.044 11.18 13.527 11 13 11h-2zm1 2h1v4h-1v-4zm-8-1a1 1 0 011-1h2c.527 0 1.044.18 1.432.568.388.388.568.905.568 1.432v2c0 .527-.18 1.044-.568 1.432C8.044 16.82 7.527 17 7 17H6v1a1 1 0 11-2 0v-6zm2 3h1v-2H6v2zm11-4a1 1 0 00-1 1v6a1 1 0 102 0v-2h1a1 1 0 100-2h-1v-1h2a1 1 0 100-2h-3zM4.194 21.553a1 1 0 00-1.788.894C2.892 23.421 3.962 24 5 24h14c1.038 0 2.108-.579 2.595-1.553a1 1 0 00-1.79-.894c-.113.226-.443.447-.805.447H5c-.362 0-.692-.221-.806-.447z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-powerpoint-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 2a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V7.46L13.63 2H5zM2 3a3 3 0 013-3h9a1 1 0 01.65.24l7 6A1 1 0 0122 7v14a3 3 0 01-3 3H5a3 3 0 01-3-3V3zm7 5h3.5a3.5 3.5 0 110 7H10v2.5a1 1 0 11-2 0V9a1 1 0 011-1zm1 5v-3h2.5a1.5 1.5 0 010 3H10z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-video-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 3a1 1 0 011-1h8.63L20 7.46V21a1 1 0 01-1 1H5a1 1 0 01-1-1V3zm1-3a3 3 0 00-3 3v18a3 3 0 003 3h14a3 3 0 003-3V7a1 1 0 00-.35-.76l-7-6A1 1 0 0014 0H5zm5.946 7.41a1.749 1.749 0 00-1.976-.19c-.582.321-.97.95-.97 1.682V16.1a1.9 1.9 0 00.97 1.68 1.75 1.75 0 001.976-.19l4.363-3.597c.921-.76.921-2.223 0-2.983l-4.363-3.6zm3.028 5.09L10 9v7l3.974-3.5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-word-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 3a1 1 0 011-1h8.63L20 7.46V21a1 1 0 01-1 1H5a1 1 0 01-1-1V3zm1-3a3 3 0 00-3 3v18a3 3 0 003 3h14a3 3 0 003-3V7a1 1 0 00-.35-.76l-7-6A1 1 0 0014 0H5zm2.97 9.757a1 1 0 00-1.94.486l2 8a1 1 0 001.906.108L12 12.848l2.064 5.503a1 1 0 001.906-.108l2-8a1 1 0 10-1.94-.486l-1.221 4.885-1.873-4.993a1 1 0 00-1.872 0L9.19 14.642l-1.22-4.885z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-file-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 3c0-.548.452-1 1-1h8v7a1 1 0 001 1h6v11c0 .548-.452 1-1 1H5c-.548 0-1-.452-1-1V3zm15.586 5L15 3.414V8h4.586zM5 0C3.348 0 2 1.348 2 3v18c0 1.652 1.348 3 3 3h14c1.652 0 3-1.348 3-3V8a1 1 0 00-.293-.707l-7-7A1 1 0 0014 0H5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-filter-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M.626 5.825C-.894 3.845.528 1 3.014 1h17.972c2.486 0 3.908 2.844 2.388 4.825l-.003.004-7.372 9.513v2.725c0 1.143-.608 2.253-1.748 2.749h-.001l-4.852 2.102A1 1 0 018 22v-6.658L.626 5.825zm1.585-1.22l.001.002 7.579 9.78A1 1 0 0110 15v5.477l3.453-1.495c.322-.14.546-.469.546-.915V15a1 1 0 01.21-.613l7.578-9.78v-.001A1 1 0 0020.987 3H3.014a1 1 0 00-.803 1.606z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-flag-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 0a1 1 0 011 1v1.224a17.287 17.287 0 011.927-.278c1.82-.158 4.256-.06 6.36 1.114 1.56.87 3.835.926 5.885.688a23.003 23.003 0 003.474-.686l.048-.014.01-.003h.002a1 1 0 011.152 1.47c-1.3 2.164-1.834 3.18-3.023 5.439l-.275.523 3.275 4.973a1 1 0 01-.664 1.535L22 16l.17.985h-.002l-.005.002-.018.003-.062.01-.229.034a27.133 27.133 0 01-3.575.258c-2.13.008-4.914-.254-6.993-1.501-1.567-.94-3.513-1.062-5.166-.904a14.489 14.489 0 00-2.12.367V23a1 1 0 11-2 0V3.523 1a1 1 0 011-1zm1 4.27v8.93c.528-.116 1.19-.233 1.93-.304 1.83-.175 4.284-.08 6.385 1.18 1.587.952 3.902 1.224 5.956 1.216a24.86 24.86 0 002.005-.092l-2.697-4.095a1 1 0 01-.064-1.038l.55-1.043c.77-1.465 1.276-2.426 1.898-3.523-.474.087-1.001.17-1.56.234-2.125.246-4.95.268-7.09-.928-1.596-.892-3.56-1.012-5.215-.869A15.306 15.306 0 004 4.27z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-flow-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7 4H3v4h4V4zM3 2a2 2 0 00-2 2v4a2 2 0 002 2h4c.18 0 .353-.024.518-.068l5.55 5.55A2.006 2.006 0 0013 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2h-4c-.18 0-.353.024-.518.068l-5.55-5.55C8.976 8.353 9 8.18 9 8V7h6v1a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v1H9V4a2 2 0 00-2-2H3zm16 18v-4h-4v4h4zM17 4h4v4h-4V4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-format-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7 10a5 5 0 1110 0v4H7v-4zm-2 5v-5a7 7 0 1114 0v10a1 1 0 11-2 0v-4H7v4a1 1 0 11-2 0v-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-gift-24\" viewBox=\"0 0 24 24\"><path d=\"M23 6h-1v-.3C22 3.1 20 1 17.6 1 15 1 13.1 3.3 12 5c-1.1-1.6-3-4-5.6-4C4 1 2 3.1 2 5.7V6H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1v7c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-7c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm-5.4-3C18.9 3 20 4.2 20 5.7V6h-6.3c.9-1.4 2.3-3 3.9-3zM4 5.7C4 4.2 5.1 3 6.4 3c1.6 0 3 1.6 3.9 3H4v-.3zM2 8h20v3H2V8zm1 12v-7h8v8H4c-.6 0-1-.4-1-1zm18 0c0 .6-.4 1-1 1h-7v-8h8v7z\"/></symbol>\n<symbol id=\"icon-hamburger-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 1c-2.918 0-5.607.734-7.599 1.973C2.424 4.203 1 6.03 1 8.222 1 9.776 2.288 11 3.815 11h16.369C21.71 11 23 9.776 23 8.222c0-2.19-1.424-4.02-3.401-5.25C17.607 1.735 14.919 1 12 1zm8.184 8H3.815c-.473 0-.82-.376-.82-.778 0-1.245.814-2.527 2.458-3.55C7.08 3.66 9.393 3 12 3c2.607 0 4.92.66 6.547 1.672 1.644 1.023 2.458 2.305 2.458 3.55 0 .402-.348.778-.821.778zm-7.217-4c0-.552-.446-1-.997-1a.999.999 0 00-.997 1v.01c0 .552.446 1 .997 1 .55 0 .997-.448.997-1V5zm-5.983-.01c.55 0 .997.448.997 1V6c0 .552-.447 1-.997 1a.999.999 0 01-.998-1v-.01c0-.552.447-1 .998-1zm10.97 1a.999.999 0 10-1.995 0V6c0 .552.447 1 .997 1 .551 0 .998-.448.998-1v-.01zM1 14c0-.552.446-1 .997-1h19.946c.55 0 .997.448.997 1s-.446 1-.997 1H1.997A.999.999 0 011 14zm1.995 3A1.998 1.998 0 001 19c0 2.21 1.786 4 3.99 4H18.95c2.203 0 3.99-1.79 3.99-4 0-1.104-.894-2-1.995-2H2.995zm1.994 4a1.997 1.997 0 01-1.994-2h17.95c0 1.105-.892 2-1.994 2H4.989z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-heart-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1.587 4.323C2.69 2.913 4.353 2 6.5 2c2.63 0 4.287 1.167 5.5 2.299C13.213 3.167 14.87 2 17.5 2c2.147 0 3.81.914 4.913 2.323C23.493 5.705 24 7.51 24 9.3c0 3.12-1.834 5.842-4.101 7.947-2.284 2.119-5.146 3.746-7.533 4.684a1 1 0 01-.732 0c-2.387-.938-5.25-2.565-7.533-4.684C1.834 15.143 0 12.42 0 9.3c0-1.79.506-3.595 1.587-4.977zm1.575 1.232C2.41 6.516 2 7.861 2 9.3c0 2.316 1.375 4.544 3.462 6.48 1.957 1.817 4.42 3.26 6.538 4.141 2.118-.88 4.581-2.324 6.538-4.14C20.625 13.844 22 11.616 22 9.3c0-1.44-.41-2.784-1.162-3.745C20.107 4.622 19.02 4 17.5 4c-2.317 0-3.569 1.167-4.788 2.402a1 1 0 01-1.424 0C10.07 5.167 8.817 4 6.5 4c-1.52 0-2.607.622-3.338 1.555z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-hide-strategy-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 6a1 1 0 011-1h6a1 1 0 100-2H5a3 3 0 00-3 3v13H1a1 1 0 100 2h22a1 1 0 100-2h-1v-5a1 1 0 10-2 0v5H4V6zm13-3a1 1 0 011 1v4.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L16 8.586V4a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-home-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12.633.226a1 1 0 00-1.266 0l-11 9A1 1 0 000 10v11a3 3 0 003 3h18a3 3 0 003-3V10a1 1 0 00-.367-.774l-11-9zM17 22h4a1 1 0 001-1V10.474L12 2.292 2 10.474V21a1 1 0 001 1h4v-5a5 5 0 0110 0v5zm-8 0v-5a3 3 0 016 0v5H9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-id-card-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 5c0-.548.452-1 1-1h18c.548 0 1 .452 1 1v14c0 .548-.452 1-1 1h-8v-1.5c0-2.452-2.048-4.5-4.5-4.5S4 16.048 4 18.5V20H3c-.548 0-1-.452-1-1V5zm3 17H3c-1.652 0-3-1.348-3-3V5c0-1.652 1.348-3 3-3h18c1.652 0 3 1.348 3 3v14c0 1.652-1.348 3-3 3H5zm6-2H6v-1.5C6 17.152 7.152 16 8.5 16s2.5 1.152 2.5 2.5V20zM8.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM5 9.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM15 8a1 1 0 100 2h4a1 1 0 100-2h-4zm-1 5a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-image-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 6c0-1.648 1.352-3 3-3h12c1.648 0 3 1.352 3 3v12a3.012 3.012 0 01-2.913 2.999l-8.3-10.615a1 1 0 00-1.576.001L3 17.075V6zM1.308 19.725c.024.187.1.368.226.517A5.012 5.012 0 006 23H18c2.752 0 5-2.248 5-5V6c0-2.752-2.248-5-5-5H6C3.248 1 1 3.248 1 6v12c0 .606.109 1.187.308 1.725zM15.548 21H6a3.006 3.006 0 01-2.487-1.33L9 12.626 15.55 21zM16 7a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-info-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm12-2a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm0-2a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-input-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 3.818C3 3.37 3.37 3 3.818 3h16.364c.448 0 .818.37.818.818v16.364c0 .448-.37.818-.818.818H3.818A.824.824 0 013 20.182V3.818zM3.818 1A2.824 2.824 0 001 3.818v16.364A2.824 2.824 0 003.818 23h16.364A2.824 2.824 0 0023 20.182V3.818A2.824 2.824 0 0020.182 1H3.818zM8 6a1 1 0 00-2 0v12a1 1 0 102 0V6z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-italic-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M14.021 4H20a1 1 0 110 2h-5.246l-3.428 12H16a1 1 0 110 2H4a1 1 0 110-2h5.246l3.428-12H8a1 1 0 010-2h6.021z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-key-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M15.5 0A8.5 8.5 0 007 8.5c0 .348.023.689.065 1.02L.293 16.294A1 1 0 000 17v6a1 1 0 001 1h6a1 1 0 001-1v-3h3a1 1 0 001-1v-2h3.5a8.5 8.5 0 000-17zM9 8.5a6.5 6.5 0 116.5 6.5H11a1 1 0 00-1 1v2H7a1 1 0 00-1 1v3H2v-4.586l6.838-6.838a1 1 0 00.276-.89A6.441 6.441 0 019 8.5zm6.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-lightbulb-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path d=\"M18.004 2.265A8.96 8.96 0 0011.012.062c-3.995.4-7.291 3.606-7.89 7.512-.4 2.404.2 4.808 1.598 6.71 1.098 1.603 2.075 3.043 2.275 4.746.022.964.022 1.264.022 1.765v.2c0 1.703 1.298 3.005 2.996 3.005h3.995c1.698 0 2.997-1.302 2.997-3.005v-.2c0-.5-.022-.763 0-1.765.3-1.703 1.099-3.243 2.197-4.645A9.018 9.018 0 0021 8.976a8.965 8.965 0 00-2.996-6.71zm-2.997 18.53v.2c0 .601-.4 1.002-.999 1.002h-3.995c-.6 0-.999-.4-.999-1.002v-.2-.801h5.993v.8zm2.597-7.612c-1.099 1.502-1.898 3.105-2.297 4.808H8.615c-.4-1.703-1.199-3.306-2.297-4.908-1.099-1.503-1.499-3.406-1.199-5.209.5-3.004 2.997-5.508 6.093-5.809 1.997-.2 3.995.4 5.493 1.703 1.399 1.302 2.297 3.205 2.297 5.208 0 1.502-.499 3.005-1.398 4.207z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-link-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M1.7.3l22 22c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-22-22C-.1 1.3-.1.7.3.3c.4-.4 1-.4 1.4 0zm11 3.3l-1 1c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l1-1c2.9-2.9 7.6-2.9 10.5 0 2.9 2.9 2.9 7.6 0 10.5l-1 1c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1-1c2.1-2.1 2.1-5.6 0-7.7-2.1-2.1-5.6-2.1-7.7 0zm2.6 3.7l-1 1c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zm-6.6 9.4l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1 1c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3zm3.6 2.7l-1 1c-2.1 2.1-5.6 2.1-7.7 0-2.1-2.1-2.1-5.6 0-7.7l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1 1c-2.9 2.9-2.9 7.6 0 10.5C3.6 23.3 5.5 24 7.4 24c1.9 0 3.8-.7 5.3-2.2l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-link-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M18.037 16.092c-.299 0-.498-.1-.698-.3a.97.97 0 010-1.402l3.094-3.103c2.095-2.102 2.095-5.606 0-7.708-2.096-2.102-5.589-2.102-7.684 0L9.655 6.682c-.4.4-.998.4-1.397 0a.97.97 0 010-1.402l3.093-3.103a7.392 7.392 0 0110.478 0 7.448 7.448 0 010 10.511l-3.093 3.103c-.2.2-.499.3-.699.3zM7.46 24a7.39 7.39 0 01-5.289-2.202 7.448 7.448 0 010-10.511l3.094-3.103c.4-.4.998-.4 1.397 0 .4.4.4 1 0 1.401l-3.093 3.103c-2.096 2.102-2.096 5.606 0 7.708 2.095 2.102 5.588 2.102 7.684 0l3.093-3.103c.4-.4.998-.4 1.397 0 .4.4.4 1.001 0 1.402l-3.093 3.103C11.35 23.299 9.356 24 7.459 24zm-.1-7.308c.2.2.4.3.7.3.299 0 .498-.1.698-.3l7.983-8.008a.97.97 0 000-1.401c-.399-.4-.998-.4-1.397 0L7.36 15.29a.97.97 0 000 1.401z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-list-ol-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M1 2a1 1 0 011-1h1a1 1 0 011 1v5a1 1 0 01-2 0V3a1 1 0 01-1-1zm8 1a1 1 0 100 2h13a1 1 0 100-2H9zm-1 9a1 1 0 011-1h13a1 1 0 110 2H9a1 1 0 01-1-1zm0 8a1 1 0 011-1h13a1 1 0 110 2H9a1 1 0 01-1-1zM1 10a1 1 0 100 2h1L.8 13.6C.06 14.59.762 16 2 16h2a1 1 0 100-2H3l1.2-1.6c.74-.989.037-2.4-1.2-2.4H1zm-1 9a1 1 0 011-1h2.5A1.5 1.5 0 015 19.5v3A1.5 1.5 0 013.5 24H1a1 1 0 110-2h1.5a1 1 0 110-2H1a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-list-ul-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 4a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zm5 3a1 1 0 011-1h13a1 1 0 110 2H9a1 1 0 01-1-1zm1 7a1 1 0 100 2h13a1 1 0 100-2H9zm0 8a1 1 0 100 2h13a1 1 0 100-2H9zm-7 1a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zm0-6a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-lock-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 1C8.78 1 6 3.396 6 6.545v5.847a7 7 0 1012 0V6.546C18 3.395 15.222 1 12 1zm4 9.255v-3.71C16 4.675 14.3 3 12 3S8 4.675 8 6.545v3.71A6.968 6.968 0 0112 9c1.487 0 2.866.464 4 1.255zM12 11a5 5 0 100 10 5 5 0 000-10zm0 4a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-merge-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 4a2 2 0 114 0 2 2 0 01-4 0zm3.06 3.858A4.002 4.002 0 006 0a4 4 0 00-1 7.874v8.252A4.002 4.002 0 006 24a4 4 0 001-7.874v-3.808A7.97 7.97 0 0013 15h1.126A4.002 4.002 0 0022 14a4 4 0 00-7.874-1H13c-3.056 0-5.532-2.21-5.94-5.142zM16 14a2 2 0 104 0 2 2 0 00-4 0zM4 20a2 2 0 114 0 2 2 0 01-4 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-minus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 12a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-paper-plane-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M23.73.317a.996.996 0 01.23.962l-5.657 20.968-.006.024c-.6 2.03-3.516 2.442-4.437.345l-.009-.021-3.631-8.815-8.815-3.631-.021-.01c-2.097-.92-1.685-3.836.347-4.436l.023-.006L22.72.039a1.002 1.002 0 011.009.278zM19.645 2.94L2.289 7.624a.394.394 0 00-.288.354.359.359 0 00.038.203.288.288 0 00.142.124l8.57 3.53 8.894-8.894zm-7.48 10.309l8.894-8.895-4.683 17.357a.394.394 0 01-.354.287.359.359 0 01-.203-.038.287.287 0 01-.124-.141l-3.53-8.57z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-paperclip-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M19.709 4.292a4.408 4.408 0 00-6.236 0 1 1 0 01-1.414-1.414 6.409 6.409 0 019.064 0 6.409 6.409 0 010 9.064l-9.181 9.18a6.409 6.409 0 01-9.064 0 6.408 6.408 0 010-9.063L7.85 7.086a3.705 3.705 0 015.239 5.239l-4.972 4.973a1 1 0 11-1.414-1.414l4.972-4.973A1.705 1.705 0 009.265 8.5l-4.973 4.973a4.409 4.409 0 106.236 6.236l9.18-9.181a4.409 4.409 0 000-6.236z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-pen-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M16.236 1.332a4.548 4.548 0 116.432 6.432l-3.943 3.943a1 1 0 01-1.414-1.414l3.942-3.943a2.548 2.548 0 10-3.603-3.603l-3.943 3.942a1 1 0 11-1.414-1.414l3.943-3.943zM6.67 12.33a1 1 0 010 1.414L4.34 16.076l-1.767 5.352 5.353-1.766 2.332-2.332a1 1 0 011.414 1.414l-2.5 2.5a1 1 0 01-.394.242L1.313 23.95A1 1 0 01.05 22.686l2.464-7.463a1 1 0 01.243-.393l2.5-2.5a1 1 0 011.414 0zM1.707.294A1 1 0 00.293 1.708l22 22a1 1 0 101.414-1.414l-22-22z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-pen-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M22.647 1.353a4.617 4.617 0 00-6.53 0L2.303 15.167a1 1 0 00-.256.435L.037 22.73a1 1 0 001.234 1.233l7.126-2.01a1 1 0 00.436-.255L19.61 10.922l.005-.006.006-.005 3.027-3.028a4.617 4.617 0 000-6.53zm-3.74 7.442l2.326-2.326a2.617 2.617 0 10-3.702-3.702l-2.326 2.326 3.702 3.702zm-5.116-2.288l-9.89 9.89-1.454 5.156 5.156-1.454 9.89-9.89-3.702-3.702z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-phone-hang-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3.709 8.715c5.098-3.623 11.696-3.62 16.792.008l.031.023C22.05 9.92 23 11.697 23 13.716v1.593C23 16.81 21.904 18 20.416 18H17.5c-1.592 0-2.5-1.405-2.5-2.691v-2.112c-1.849-.591-4.151-.591-6 0v2.112c0 .699-.215 1.37-.666 1.88-.46.52-1.111.811-1.834.811H3.584C2.097 18 1 16.81 1 15.309v-1.593c0-2.029.961-3.825 2.709-5.001zm15.615 1.625c-4.403-3.124-10.067-3.12-14.467.012l-.023.016c-1.216.814-1.834 2-1.834 3.348v1.593c0 .488.29.691.584.691H6.5c.168 0 .267-.058.335-.135.076-.086.165-.26.165-.556V12.5a1 1 0 01.614-.922c2.623-1.099 6.149-1.099 8.772 0A1 1 0 0117 12.5v2.809c0 .227.078.416.179.534A.402.402 0 0017.5 16h2.916c.294 0 .584-.204.584-.691v-1.593c0-1.357-.628-2.559-1.676-3.376z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-outgoing-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10.787 4.481L8.115 1.925C7.015.688 5.17.692 4.073 1.935l-1.15 1.15C1.39 4.618.704 6.834 1.117 9.034l.002.008a17.578 17.578 0 0013.837 13.84c2.101.419 4.318-.281 5.84-1.803l1.24-1.241c1.338-1.025 1.22-2.908.029-3.96l-2.68-2.68a2.845 2.845 0 00-4.02.02l-1.617 1.707a10.98 10.98 0 01-4.682-4.69l1.736-1.736a2.845 2.845 0 000-4.001l-.016-.016zM5.564 3.268c.307-.357.762-.357 1.068 0a1 1 0 00.068.072l2.695 2.577a.846.846 0 01-.006 1.166L7.155 9.317a1 1 0 00-.21 1.106 12.934 12.934 0 006.632 6.632 1 1 0 001.125-.23l2.105-2.221a.846.846 0 011.164.007l2.705 2.704c.018.019.037.036.056.053.2.17.268.368.268.519 0 .145-.06.277-.198.377a1.008 1.008 0 00-.126.106l-1.294 1.294c-1.064 1.064-2.609 1.54-4.035 1.255l-.003-.001A15.578 15.578 0 013.083 8.66c-.291-1.56.199-3.105 1.253-4.16l1.176-1.176a.995.995 0 00.052-.056zm12.729-1.975a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L19.586 6H15a1 1 0 110-2h4.586l-1.293-1.293a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M18 2a1 1 0 112 0v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V6h-2a1 1 0 110-2h2V2zm-7.213 2.481L8.115 1.925C7.015.688 5.17.692 4.073 1.935l-1.15 1.15C1.39 4.618.704 6.834 1.117 9.034l.002.008a17.578 17.578 0 0013.837 13.84c2.101.419 4.318-.281 5.84-1.803l1.24-1.241c1.338-1.025 1.22-2.908.029-3.96l-2.68-2.68a2.845 2.845 0 00-4.02.02l-1.617 1.707a10.98 10.98 0 01-4.682-4.69l1.736-1.736a2.845 2.845 0 000-4.001l-.016-.016zM5.564 3.268c.307-.357.762-.357 1.068 0a1 1 0 00.068.072l2.695 2.577a.846.846 0 01-.006 1.166L7.155 9.317a1 1 0 00-.21 1.106 12.934 12.934 0 006.632 6.632 1 1 0 001.125-.23l2.105-2.221a.846.846 0 011.165.007l2.704 2.704a.995.995 0 00.056.053c.2.17.268.368.268.519 0 .145-.06.277-.198.377a1.008 1.008 0 00-.126.106l-1.294 1.294c-1.064 1.064-2.609 1.54-4.035 1.255l-.003-.001A15.578 15.578 0 013.083 8.66c-.291-1.56.199-3.105 1.253-4.16l1.176-1.176a.995.995 0 00.052-.056z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-plane-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M22 12c0-1.148-.852-2-2-2h-4a1 1 0 01-.814-.419L10.486 3h-2.16l1.636 5.725A1 1 0 019 10H6a1 1 0 01-.6-.2L2.254 7.44l.732 4.396a1 1 0 010 .328l-.732 4.396L5.4 14.2A1 1 0 016 14h3a1 1 0 01.962 1.275L8.326 21h2.16l4.7-6.581A1 1 0 0116 14h4c1.148 0 2-.852 2-2zm-2-4c2.252 0 4 1.748 4 4s-1.748 4-4 4h-3.485l-4.701 6.581A1 1 0 0111 23H7a1 1 0 01-.962-1.275L7.674 16h-1.34L2.6 18.8a1 1 0 01-.6.2H1a1 1 0 01-.986-1.164L.986 12 .014 6.164A1 1 0 011 5h1a1 1 0 01.6.2L6.333 8h1.341L6.038 2.275A1 1 0 017 1h4a1 1 0 01.814.419L16.514 8H20z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-plug-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9 1a1 1 0 00-2 0v5H4a1 1 0 00-1 1v5c0 4.632 3.5 8.448 8 8.945V23a1 1 0 102 0v-2.055c4.5-.497 8-4.313 8-8.945V7a1 1 0 00-1-1h-3V1a1 1 0 10-2 0v5H9V1zm7 7H5v4a7 7 0 0014 0V8h-3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13 4a1 1 0 10-2 0v7H4a1 1 0 100 2h7v7a1 1 0 102 0v-7h7a1 1 0 100-2h-7V4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-print-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8 0a1 1 0 00-.707.293L5.586 2H3a3 3 0 00-3 3v4a3 3 0 003 3h1v11a1 1 0 001 1h14a1 1 0 001-1V12h1a3 3 0 003-3V5a3 3 0 00-3-3h-2.586L16.707.293A1 1 0 0016 0H8zm10 12v10H6V12h12zm1-2h2a1 1 0 001-1V5a1 1 0 00-1-1h-3a1 1 0 01-.707-.293L15.586 2H8.414L6.707 3.707A1 1 0 016 4H3a1 1 0 00-1 1v4a1 1 0 001 1h16zM9 14a1 1 0 100 2h6a1 1 0 100-2H9zm-1 5a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-question-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm11 5a1 1 0 112 0 1 1 0 01-2 0zm1-11c-2.252 0-4 1.748-4 4a1 1 0 102 0c0-1.148.852-2 2-2h1c1.148 0 2 .852 2 2v.1c0 .788-.455 1.46-1.147 1.806l-.016.007-2.3 1.2a1 1 0 00.926 1.774l2.292-1.197C16.06 13.035 17 11.71 17 10.1V10c0-2.252-1.748-4-4-4h-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-rec-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M0 5a3 3 0 013-3h18a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1H3zm7 5a1 1 0 011-1h3a1 1 0 110 2h-2v1h1a1 1 0 110 2h-1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V9zm-7 .04C3 8.465 3.465 8 4.04 8H6a3 3 0 011.605 5.535l.95.633a1 1 0 01-1.11 1.664L5 14.202V15a1 1 0 11-2 0V9.04zM5.017 12H5v-2h1a1 1 0 110 2h-.983zM16 11a3 3 0 013-3h1a1 1 0 110 2h-1a1 1 0 00-1 1v2a1 1 0 001 1h1a1 1 0 110 2h-1a3 3 0 01-3-3v-2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-reply-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M10.42 1.072a1 1 0 01.626.928v5.012c2.659.062 4.992.377 6.918.952 2.152.642 3.889 1.638 4.946 3.066 1.089 1.47 1.36 3.265.821 5.248-.528 1.944-1.831 4.08-3.894 6.388a1 1 0 01-1.74-.777c.172-1.538.052-2.616-.235-3.377a2.942 2.942 0 00-1.35-1.587c-.65-.374-1.52-.615-2.634-.755-.846-.106-1.792-.15-2.832-.164V21a1 1 0 01-1.728.686L.272 12.091a1 1 0 01.007-1.38l9.046-9.404a1 1 0 011.094-.235zm-8.04 10.34l6.666 7.07V15a1 1 0 011-1c1.452 0 2.839.03 4.08.186 1.239.155 2.405.444 3.383 1.005a4.94 4.94 0 012.225 2.616c.158.419.272.872.345 1.36.897-1.28 1.452-2.419 1.722-3.414.404-1.486.172-2.628-.498-3.533-.701-.947-1.98-1.764-3.911-2.34C15.472 9.307 13 9 10.046 9a1 1 0 01-1-1V4.482l-6.665 6.93z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-route-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M15.707 1.707A1 1 0 0014.293.293l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414-1.414L13.414 6H16c1.648 0 3 1.352 3 3v7.126a4 4 0 102 0V9c0-2.752-2.248-5-5-5h-2.586l2.293-2.293zm2.879 16.879c.39-.39.902-.586 1.413-.586h.002a2 2 0 11-1.415.586zM4 2a2 2 0 100 4 2 2 0 000-4zm4 2a4.002 4.002 0 01-3 3.874V15c0 1.648 1.352 3 3 3h2.586l-2.293-2.293a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L10.586 20H8c-2.752 0-5-2.248-5-5V7.874A4.002 4.002 0 014 0a4 4 0 014 4z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-search-minus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1116.032 5.618l5.675 5.675a1 1 0 01-1.414 1.414l-5.675-5.675A9 9 0 011 10zm5 0a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-search-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1116.032 5.618l5.675 5.675a1 1 0 01-1.414 1.414l-5.675-5.675A9 9 0 011 10zm10-3a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-search-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M3 10a7 7 0 1114 0 7 7 0 01-14 0zm7-9a9 9 0 105.618 16.032l5.675 5.675a1 1 0 001.414-1.414l-5.675-5.675A9 9 0 0010 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-smile-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.8 15.6a1 1 0 10-1.6-1.2A3.994 3.994 0 0112 16a3.995 3.995 0 01-3.2-1.598 1 1 0 00-1.597 1.204A5.995 5.995 0 0012 18a5.994 5.994 0 004.8-2.4zM16 8.996c.552 0 1 .445 1 .995V10c0 .55-.448.995-1 .995s-1-.445-1-.995v-.01c0-.55.448-.995 1-.995zM9 9.99a.998.998 0 00-1-.995c-.552 0-1 .445-1 .995V10c0 .55.448.995 1 .995S9 10.55 9 10v-.01z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-social-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M20 2a2 2 0 00-1.777 2.919 1.014 1.014 0 01.068.121A1.999 1.999 0 0022 4a2 2 0 00-2-2zm-4 2c0 .355.046.7.133 1.027L6.885 10.23a4 4 0 10.262 5.239l8.903 3.894a4 4 0 10.802-1.832L7.95 13.637a4.028 4.028 0 00-.083-1.665l9.247-5.202A4 4 0 1016 4zM5.709 11.96a1.02 1.02 0 00.068.121 1.991 1.991 0 01.054 1.72 2 2 0 11-.122-1.841zm12.438 7.286a2 2 0 103.706 1.508 2 2 0 00-3.706-1.508z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-star-full-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path d=\"M5.545 24c-.4 0-.8-.1-1.2-.4-.701-.5-.901-1.4-.701-2.2L5.745 15 .641 11.2l-.1-.1c-.5-.5-.7-1.3-.4-2 .3-.7 1-1.1 1.801-1.1h6.205l2.102-6.6c.2-.9 1-1.4 1.801-1.4.8 0 1.601.5 1.801 1.3L15.853 8h6.305c.8 0 1.4.4 1.7 1.1.301.7.101 1.5-.4 2l-.1.1-5.003 3.8 2.101 6.4c.3.8 0 1.7-.7 2.2-.7.5-1.601.5-2.302 0l-5.404-3.9-5.404 3.9c-.3.3-.7.4-1.1.4z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-star-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path d=\"M5.545 24c-.4 0-.8-.1-1.2-.4-.701-.5-.901-1.4-.701-2.2L5.745 15 .641 11.2l-.1-.1c-.5-.5-.7-1.3-.4-2 .3-.7 1-1.1 1.801-1.1h6.205l2.102-6.6c.2-.9 1-1.4 1.801-1.4.8 0 1.601.5 1.801 1.3L15.853 8h6.305c.8 0 1.4.4 1.7 1.1.301.7.101 1.5-.4 2l-.1.1-5.003 3.8 2.101 6.4c.3.8 0 1.7-.7 2.2-.7.5-1.601.5-2.302 0l-5.404-3.9-5.404 3.9c-.3.3-.7.4-1.1.4zm6.505-6.6c.2 0 .4.1.6.2l5.805 4.3-2.302-7c-.1-.4 0-.9.4-1.1l5.104-3.8h-6.505c-.4 0-.8-.3-1-.7L12.05 2.2 9.848 9.3c-.2.4-.6.7-1 .7H2.443l5.104 3.8c.3.3.5.7.4 1.1l-2.202 6.9 5.805-4.3c.1 0 .3-.1.5-.1z\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-sticky-note-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 1a3 3 0 00-3 3v16a3 3 0 003 3h13.172a3 3 0 002.12-.879l2.83-2.828A3 3 0 0023 17.172V4a3 3 0 00-3-3H4zM3 4a1 1 0 011-1h16a1 1 0 011 1v10h-4a3 3 0 00-3 3v4H4a1 1 0 01-1-1V4zm13 17h1.172a1 1 0 00.707-.293l2.828-2.828a1 1 0 00.293-.707V16h-4a1 1 0 00-1 1v4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-tag-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8.1 23.1c.6.6 1.3.9 2.1.9.7 0 1.5-.3 2.1-.9l10.8-11c.6-.6.9-1.3.9-2.1V3c0-.8-.3-1.6-.9-2.1C22.6.3 21.8 0 21 0h-7c-.8 0-1.6.3-2.1 1L.9 11.8c-1.2 1.1-1.2 3 0 4.2l7.2 7.1zm5.2-20.8c.2-.2.4-.3.7-.3h7c.3 0 .5.1.7.3.2.2.3.4.3.7v7c0 .3-.1.5-.3.7l-10.8 11c-.4.4-1 .4-1.4 0l-7.2-7.2c-.4-.4-.4-1 0-1.4l11-10.8zM17 6c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-team-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M8.5 6.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM12 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 13c-2.132 0-4.1.665-5.557 1.783C4.986 16.902 4 18.517 4 20.375V22a1 1 0 102 0v-1.625c0-1.106.584-2.178 1.662-3.006C8.74 16.541 10.272 16 12 16c1.728 0 3.26.54 4.338 1.37 1.078.827 1.662 1.9 1.662 3.005V22a1 1 0 102 0v-1.625c0-1.858-.986-3.473-2.444-4.592C16.1 14.665 14.133 14 12 14zm-9.213 2.617a1 1 0 10-1.574-1.234c-.318.405-.633.825-.857 1.306A3.864 3.864 0 000 18.375V21a1 1 0 102 0v-2.625c0-.37.064-.616.169-.841.117-.252.302-.514.618-.917zm18.596-1.404a1 1 0 011.404.17c.318.405.633.825.857 1.306.237.508.356 1.045.356 1.686V21a1 1 0 11-2 0v-2.625c0-.37-.064-.616-.169-.841-.117-.252-.302-.514-.618-.917a1 1 0 01.17-1.404zm-1.777-10.66a1 1 0 011.341-.447 3.434 3.434 0 011.569 1.532C22.86 6.314 23 7.111 23 8c0 2.2-1.944 3.857-3.93 3.998a1 1 0 01-.14-1.995C20.058 9.922 21 8.97 21 8c0-.696-.111-1.15-.265-1.452-.145-.283-.355-.49-.682-.654a1 1 0 01-.447-1.341zM3.947 5.894a1 1 0 00-.894-1.788C1.597 4.833 1 6.272 1 8c0 2.2 1.944 3.857 3.93 3.998a1 1 0 10.14-1.995C3.942 9.922 3 8.97 3 8c0-1.272.403-1.833.947-2.106z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-th-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v3h4V4H5zm3 6H4v4h4v-4zm2 0h4v4h-4v-4zm4-2h-4V4h4v4zm2 2v4h4v-4h-4zm4-2h-4V4h3a1 1 0 011 1v3zM4 19v-3h4v4H5a1 1 0 01-1-1zm6 1v-4h4v4h-4zm6 0v-4h4v3a1 1 0 01-1 1h-3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbs-down-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10.398 22.436c1.437 1.012 3.366.617 4.341-.827l4.09-6.05A1 1 0 0019 15V6a5 5 0 00-5-5H7.484a5 5 0 00-4.466 2.753L1.107 7.55A1 1 0 001 8v5a3 3 0 003 3h6.196l-.96 2.534c-.53 1.404-.07 3.033 1.162 3.902zm2.684-1.947c-.37.548-1.041.657-1.532.312-.455-.321-.665-.971-.443-1.559l1.472-3.889A1 1 0 0011.644 14H4a1 1 0 01-1-1V8.237L4.804 4.65a2.999 2.999 0 012.68-1.652H14a3 3 0 013 3v8.694l-3.918 5.796zM21 15a1 1 0 102 0V3a1 1 0 10-2 0v12z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbs-up-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13.602 1.563C12.165.551 10.236.946 9.26 2.39L5.171 8.44A1 1 0 005 9v9a5 5 0 005 5h6.516a5 5 0 004.466-2.753l1.911-3.798A1 1 0 0023 16v-5a3 3 0 00-3-3h-6.196l.96-2.534c.53-1.404.07-3.033-1.162-3.902zM10.918 3.51c.37-.548 1.041-.657 1.532-.312.455.321.665.971.443 1.559L11.42 8.646A1 1 0 0012.356 10H20a1 1 0 011 1v4.762l-1.804 3.587a2.999 2.999 0 01-2.68 1.65H10a3 3 0 01-3-3V9.307l3.918-5.796zM3 9a1 1 0 00-2 0v12a1 1 0 102 0V9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-thumbtack-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7 0h11a1 1 0 110 2v7.713A7.97 7.97 0 0120 15a1 1 0 01-1 1h-6v7a1 1 0 11-2 0v-7H5a1 1 0 01-1-1 7.97 7.97 0 012-5.287V2a1 1 0 010-2h1zm1 2v8.105a1 1 0 01-.285.7A5.986 5.986 0 006.083 14H11V8a1 1 0 112 0v6h4.917a5.987 5.987 0 00-1.632-3.196 1 1 0 01-.285-.699V2H8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-transcript-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12.633 2.31a1 1 0 00-1.266 0l-.843.69h2.952l-.843-.69zm4.002.69H17a3 3 0 012.99 2.745l2.91 2.38a3 3 0 011.1 2.323V20a3 3 0 01-3 3H3a3 3 0 01-3-3v-9.552a3 3 0 011.1-2.322l2.91-2.381A3 3 0 017 3h.365L10.1.762a3 3 0 013.8 0L16.635 3zM4 8.338L2.367 9.674a1 1 0 00-.367.774v.934l2 1V8.338zm2 5.044l5.553 2.776a1 1 0 00.894 0L18 13.382V6a1 1 0 00-1-1H7a1 1 0 00-1 1v7.382zm14-1l2-1v-.934a1 1 0 00-.367-.774L20 8.338v4.044zM2 20v-6.382l8.658 4.33a3 3 0 002.684 0L22 13.617V20a1 1 0 01-1 1H3a1 1 0 01-1-1zM8 8a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-trash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M6 3a3 3 0 013-3h6a3 3 0 013 3v1h3a1 1 0 110 2h-.054l-.843 15.163A3.004 3.004 0 0117.105 24H6.896a3.004 3.004 0 01-3-2.837L3.055 6H3a1 1 0 010-2h3V3zm2 1h8V3a1 1 0 00-1-1H9a1 1 0 00-1 1v1zM5.057 6l.836 15.052c.03.532.47.948 1.003.948h10.208c.533 0 .973-.416 1.003-.948L18.943 6H5.057z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-upload-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M11.293 2.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L13 5.414V15a1 1 0 11-2 0V5.414L8.707 7.707a1 1 0 01-1.414-1.414l4-4zM4 21a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-url-trigger-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 3a1 1 0 011-1h16a1 1 0 011 1v3H2V3zM0 7V3a3 3 0 013-3h16a3 3 0 013 3v5.5a1 1 0 11-2 0V8H2v12h4a1 1 0 110 2H1a1 1 0 01-1-1V7zm9-3a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zM5 4a1 1 0 11-2 0 1 1 0 012 0zm10 7a4 4 0 100 8 4 4 0 000-8zm-6 4a6 6 0 1110.89 3.477l3.817 3.816a1 1 0 01-1.414 1.414l-3.816-3.816A6 6 0 019 15z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4.5 6.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM8 1a5.5 5.5 0 100 11A5.5 5.5 0 008 1zm0 13c-2.132 0-4.1.665-5.557 1.783C.986 16.902 0 18.517 0 20.375V22a1 1 0 102 0v-1.625c0-1.106.584-2.178 1.662-3.006C4.74 16.541 6.272 16 8 16c1.728 0 3.26.54 4.338 1.37 1.079.827 1.662 1.9 1.662 3.005V22a1 1 0 102 0v-1.625c0-1.858-.986-3.473-2.444-4.592C12.1 14.665 10.133 14 8 14zm12-6a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2V9a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-secret-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9.3.051a1.005 1.005 0 00-1.29.706l-.89 3.547-3.598 1.792a.999.999 0 00.283 1.88c.806.134 1.537.256 2.206.365A6.054 6.054 0 006.058 10H3.97a.998.998 0 00-.834 1.555l1.378 2.06c-1.1.643-1.91 1.457-2.47 2.513-.702 1.328-.953 2.938-1.04 4.825C.925 22.66 2.326 24 3.97 24h16.066c1.62 0 3.022-1.306 2.962-3.002-.062-1.756-.294-3.372-.99-4.74-.557-1.094-1.383-1.976-2.539-2.65l1.368-2.055A.998.998 0 0020.002 10h-2.081a6.026 6.026 0 00.048-1.653c.61-.101 1.272-.214 1.999-.337l.209-.035a.999.999 0 00.28-1.88l-3.597-1.79-.89-3.548A1 1 0 0014.68.05l-2.69.893L9.3.051zm6.685 8.608c-1.527.223-2.718.34-3.92.341-1.227.001-2.46-.118-4.07-.35A4.005 4.005 0 0011.99 13a4.005 4.005 0 003.996-4.34zM8.952 5.236l.74-2.948 1.98.658c.206.068.429.068.634 0l1.981-.658.74 2.948a1 1 0 00.524.651l1.253.624c-2.067.33-3.4.49-4.74.49-1.355.002-2.727-.158-4.877-.496l1.24-.618a1 1 0 00.525-.651zm-1.829 7.29A6.005 6.005 0 016.78 12h-.937l.966 1.445a.998.998 0 01-.438 1.474c-1.337.573-2.087 1.261-2.555 2.144-.49.927-.727 2.174-.81 3.982-.023.5.394.955.964.955h4.143l.835-5.832-1.825-3.642zM11.99 15a6.032 6.032 0 01-1.597-.214l.488.767a.998.998 0 01.096.588L10.138 22h3.703l-.839-5.859a.998.998 0 01.096-.588l.488-.767A6.032 6.032 0 0111.99 15zm3.041 1.168l1.825-3.642c.123-.169.238-.344.343-.526h.934l-.964 1.447a.998.998 0 00.453 1.478c1.35.554 2.122 1.303 2.598 2.238.497.977.716 2.243.775 3.906.017.486-.393.931-.96.931h-4.169l-.835-5.832z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-user-slash-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M.293.293a1 1 0 011.414 0l22 22a1 1 0 01-1.414 1.414l-22-22a1 1 0 010-1.414zM8.5 1.2C9.446.49 10.653 0 12 0c3.352 0 6 2.648 6 6 0 1.347-.49 2.554-1.2 3.5a1 1 0 11-1.6-1.2c.49-.654.8-1.447.8-2.3 0-2.248-1.752-4-4-4-.853 0-1.646.31-2.3.8a1 1 0 11-1.2-1.6zm.17 15.163a1 1 0 10-.54-1.926c-1.7.478-3.195 1.21-4.286 2.158C2.752 17.544 2 18.773 2 20.2V23a1 1 0 102 0v-2.8c0-.673.348-1.394 1.156-2.095.809-.702 2.013-1.32 3.515-1.742z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-user-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8 6a4 4 0 118 0 4 4 0 01-8 0zm4-6a6 6 0 100 12 6 6 0 000-12zm0 15c-2.622 0-5.052.623-6.86 1.678C3.358 17.718 2 19.3 2 21.25V23a1 1 0 102 0v-1.75c0-.938.667-1.98 2.148-2.844C7.602 17.558 9.672 17 12 17c2.328 0 4.398.558 5.852 1.406C19.333 19.27 20 20.312 20 21.25V23a1 1 0 102 0v-1.75c0-1.95-1.358-3.532-3.14-4.572C17.052 15.623 14.622 15 12 15z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-users-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M15.073 1.092C15.34 1.045 15.656 1 16 1c3.033 0 5.5 2.467 5.5 5.5S19.033 12 16 12c-.345 0-.662-.047-.923-.091a1 1 0 11.336-1.972c.231.04.414.063.587.063 1.929 0 3.5-1.571 3.5-3.5S17.93 3 16 3c-.174 0-.358.023-.584.062a1 1 0 11-.343-1.97zM8 14c-2.132 0-4.1.665-5.557 1.783C.986 16.902 0 18.517 0 20.375V22a1 1 0 102 0v-1.625c0-1.106.584-2.178 1.662-3.006C4.74 16.541 6.272 16 8 16c1.728 0 3.26.54 4.338 1.37 1.079.827 1.662 1.9 1.662 3.005V22a1 1 0 102 0v-1.625c0-1.858-.986-3.473-2.444-4.592C12.1 14.665 10.133 14 8 14zm9.174.075a1 1 0 10-.232 1.986c3.081.362 5.058 2.334 5.058 4.314V22a1 1 0 102 0v-1.625c0-3.393-3.19-5.874-6.826-6.3zM4.5 6.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM8 1a5.5 5.5 0 100 11A5.5 5.5 0 008 1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-video-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 5.993C2 5.444 2.444 5 2.993 5h12.015c.547 0 .992.444.992.993v12.015a.992.992 0 01-.993.992H2.993A.993.993 0 012 18.007V5.993zm16 10.625v1.39A2.992 2.992 0 0115.007 21H2.993A2.993 2.993 0 010 18.007V5.993A2.993 2.993 0 012.993 3h12.015A2.992 2.992 0 0118 5.993v1.389l4.553-2.276A1 1 0 0124 6v12a1 1 0 01-1.447.894L18 16.618zm0-2.236l4 2V7.618l-4 2v4.764z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-widget-customize-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 6a1 1 0 011-1h6a1 1 0 100-2H5a3 3 0 00-3 3v13H1a1 1 0 100 2h22a1 1 0 100-2h-1v-5a1 1 0 10-2 0v5H4V6zm12.893-2.107c1.155-1.155 3.11-1.234 4.237.023 1.168 1.191 1.16 3.008-.023 4.191l-7.5 7.5a1 1 0 01-.435.256l-3.9 1.1a1 1 0 01-1.234-1.234l1.1-3.9a1 1 0 01.255-.436l7.5-7.5zm1.414 1.414c.438-.437 1.064-.365 1.34-.048l.046.048c.41.41.41.976 0 1.386l-7.316 7.315-1.93.545.545-1.93 7.315-7.316z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-plus-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6 0a1 1 0 011 1v1h10V1a1 1 0 112 0v1h2a3 3 0 013 3v16a3 3 0 01-3 3H3a3 3 0 01-3-3V5a3 3 0 013-3h2V1a1 1 0 011-1zm11 6a1 1 0 102 0V4h2a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2v2a1 1 0 002 0V4h10v2zm-5 3a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3v-3a1 1 0 011-1z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-times-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6 0a1 1 0 011 1v1h10V1a1 1 0 112 0v1h2a3 3 0 013 3v16a3 3 0 01-3 3H3a3 3 0 01-3-3V5a3 3 0 013-3h2V1a1 1 0 011-1zm11 4v2a1 1 0 102 0V4h2a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2v2a1 1 0 002 0V4h10zm-7.293 6.293a1 1 0 10-1.414 1.414L10.586 14l-2.293 2.293a1 1 0 101.414 1.414L12 15.414l2.293 2.293a1 1 0 001.414-1.414L13.414 14l2.293-2.293a1 1 0 00-1.414-1.414L12 12.586l-2.293-2.293z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-calendar-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M6 0a1 1 0 011 1v1h10V1a1 1 0 112 0v1h2a3 3 0 013 3v16a3 3 0 01-3 3H3a3 3 0 01-3-3V5a3 3 0 013-3h2V1a1 1 0 011-1zm11 4v2a1 1 0 102 0V4h2a1 1 0 011 1v4H2V5a1 1 0 011-1h2v2a1 1 0 002 0V4h10zm5 7v10a1 1 0 01-1 1H3a1 1 0 01-1-1V11h20z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-one-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1 7a1 1 0 012 0v3l1.2-1.6a1 1 0 011.6 1.2l-3 4A1 1 0 0111 13V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-three-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1 7a1 1 0 112 0v5h3a1 1 0 110 2h-4a1 1 0 01-1-1V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-clock-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm1 7a1 1 0 10-2 0v5H8a1 1 0 100 2h4a1 1 0 001-1V7z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-history-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M3 12C3 6.477 7.477 2 13 2s10 4.477 10 10-4.477 10-10 10a1 1 0 110-2 8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8v.586l1.293-1.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L3 12.586V12zm11-4a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2h-3V8z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-moon-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13.444 0C6.609 0 1 5.336 1 12s5.61 12 12.444 12c3.692 0 7.005-1.56 9.286-4.029l.029-.031a.995.995 0 00.237-.737V19.2a.996.996 0 00-.318-.647l-.012-.011a.997.997 0 00-.756-.25c-.29.025-.564.041-.836.041-5.28 0-9.491-4.103-9.491-9.083 0-2.99 1.517-5.649 3.877-7.311a1 1 0 00-.423-1.83A12.876 12.876 0 0013.444 0zm-1.098 2.054C7.064 2.581 3 6.864 3 12c0 5.486 4.639 10 10.444 10 2.213 0 4.257-.662 5.942-1.786-5.52-.786-9.803-5.365-9.803-10.964 0-2.757 1.047-5.266 2.763-7.196z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-sun-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M16.4 24h.2c.042 0 .067 0 .089-.008.03-.01.053-.035.111-.092.3-.1.6-.3.7-.6l1.7-4.2 4.2-1.7c.05-.05.1-.075.15-.1.05-.025.1-.05.15-.1.1-.1.3-.3.3-.5v-.1a.773.773 0 00-.05-.2c-.025-.075-.05-.15-.05-.2L22.2 12l1.7-4.3c.1-.1.1-.3.1-.4v-.1c-.1-.2-.2-.4-.4-.4-.1-.1-.2-.2-.3-.2l-4.2-1.7L17.4.7c-.1-.3-.4-.5-.7-.6h-.5L12 1.8 7.7 0h-.5c-.3.1-.6.3-.7.7L4.8 4.9.6 6.6c-.05.05-.1.075-.15.1-.05.025-.1.05-.15.1-.1.1-.3.3-.3.5v.1c0 .1 0 .2.1.4L1.8 12 .1 16.3c-.1.1-.1.3-.1.4v.1c.1.2.2.4.4.4.1.1.2.2.3.2l4.2 1.7 1.7 4.2c.1.3.4.5.7.6h.5l4.2-1.7 4.3 1.8h.1zm-4-3.7c-.1-.1-.3-.1-.4-.1h-.3L8 21.7l-1.4-3.6c-.1-.3-.3-.5-.6-.6L2.3 16l1.5-3.7c.1-.2.1-.5 0-.7L2.3 8 6 6.5c.2-.1.4-.3.5-.5L8 2.3l3.6 1.5c.2.1.5.1.7 0L16 2.3l1.4 3.6c.1.3.3.5.6.6L21.7 8l-1.3 3.7c-.1.2-.1.5 0 .7l1.5 3.6-3.7 1.5c-.3.1-.5.3-.6.6l-1.5 3.7-3.7-1.5zM6 12c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zm2 0c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-voicemail-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm1-3a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3H3zm5 9a1 1 0 01-.999 1H7A1 1 0 118 12zm2 0c0 .35-.06.687-.17 1h4.34A3 3 0 1117 15H7a3 3 0 113-3zm8 0a1 1 0 11-2 0 1 1 0 012 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-callback-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M10.787 4.481L8.115 1.925C7.015.688 5.17.692 4.073 1.935l-1.15 1.15C1.39 4.618.704 6.834 1.117 9.034l.002.008a17.578 17.578 0 0013.837 13.84c2.101.419 4.318-.281 5.84-1.803l1.24-1.241c1.338-1.025 1.22-2.908.029-3.96l-2.68-2.68a2.845 2.845 0 00-4.02.02l-1.617 1.707a10.98 10.98 0 01-4.682-4.69l1.736-1.736a2.845 2.845 0 000-4.001l-.016-.016zM5.564 3.268c.307-.357.762-.357 1.068 0a1 1 0 00.068.072l2.695 2.577a.846.846 0 01-.006 1.166L7.155 9.317a1 1 0 00-.21 1.106 12.934 12.934 0 006.632 6.632 1 1 0 001.125-.23l2.105-2.221a.846.846 0 011.165.007l2.704 2.704a.995.995 0 00.056.053c.2.17.268.368.268.519 0 .145-.06.277-.198.377a1.008 1.008 0 00-.126.106l-1.294 1.294c-1.064 1.064-2.609 1.54-4.035 1.255l-.003-.001A15.578 15.578 0 013.083 8.66c-.291-1.56.199-3.105 1.253-4.16l1.176-1.176a.995.995 0 00.052-.056zm13.143 5.44a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.415l3-3a1 1 0 111.414 1.414L17.414 4H22a1 1 0 110 2h-4.586l1.293 1.293a1 1 0 010 1.414z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-widget-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M5 5a1 1 0 00-1 1v13h4v-1a3 3 0 013-3h5a3 3 0 013 3v1h1V6a1 1 0 00-1-1H5zm12 14v-1a1 1 0 00-1-1h-5a1 1 0 00-1 1v1h7zm-8 2H1a1 1 0 110-2h1V6a3 3 0 013-3h14a3 3 0 013 3v13h1a1 1 0 110 2H9z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chat-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M0 10.095C0 5.027 4.3 1 9.5 1h5c5.2 0 9.5 4.027 9.5 9.095 0 5.068-4.3 9.095-9.5 9.095h-.21l-5.754 3.654A1 1 0 017 22v-3.136c-4.004-1.045-7-4.542-7-8.769zM9.5 3C5.312 3 2 6.222 2 10.095c0 3.451 2.625 6.374 6.168 6.976a1 1 0 01.832.986v2.123l4.464-2.834a1 1 0 01.536-.155h.5c4.188 0 7.5-3.223 7.5-7.096S18.688 3 14.5 3h-5z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-facebook-messenger-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9.5 1C4.3 1 0 5.027 0 10.095c0 4.227 2.996 7.724 7 8.769V22a1 1 0 001.536.844l5.755-3.654h.209c5.2 0 9.5-4.027 9.5-9.095C24 5.027 19.7 1 14.5 1h-5zM2 10.095C2 6.222 5.312 3 9.5 3h5c4.188 0 7.5 3.222 7.5 7.095 0 3.873-3.312 7.095-7.5 7.095H14a1 1 0 00-.536.156L9 20.18v-2.123a1 1 0 00-.832-.986C4.625 16.47 2 13.546 2 10.095zM11.079 8l2.474 2.295L18 8l-5.026 5-2.421-2.391L6 12.928 11.079 8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-mail-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M2 5a1 1 0 011-1h18a1 1 0 011 1v2.283l-8.743 4.035a2.998 2.998 0 01-2.514 0L2 7.283V5zM0 7.9V19a3 3 0 003 3h18a3 3 0 003-3V7.944 5a3 3 0 00-3-3H3a3 3 0 00-3 3v2.9zm22 1.586V19a1 1 0 01-1 1H3a1 1 0 01-1-1V9.486l7.905 3.648a4.999 4.999 0 004.19 0L22 9.486z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol>\n<symbol id=\"icon-messaging-settings-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9.5 1C4.3 1 0 5.027 0 10.095c0 4.227 2.996 7.724 7 8.769V22a1 1 0 001.536.844l5.755-3.654h.209c5.2 0 9.5-4.027 9.5-9.095C24 5.027 19.7 1 14.5 1h-5zM2 10.095C2 6.222 5.312 3 9.5 3h5c4.188 0 7.5 3.222 7.5 7.095 0 3.873-3.312 7.095-7.5 7.095H14a1 1 0 00-.536.156L9 20.18v-2.123a1 1 0 00-.832-.986C4.625 16.47 2 13.546 2 10.095zm10.832-3.65a1 1 0 00-1.664 1.11L12.132 9H10a1 1 0 00-.832 1.555l2 3a1 1 0 001.664-1.11L11.868 11H14a1 1 0 00.832-1.555l-2-3z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-messenger-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M4 1C2.348 1 1 2.348 1 4v12c0 1.652 1.348 3 3 3h2v3a1 1 0 001.555.832L13.303 19H20c1.652 0 3-1.348 3-3V4c0-1.652-1.348-3-3-3H4zM3 4c0-.548.452-1 1-1h16c.548 0 1 .452 1 1v12c0 .548-.452 1-1 1h-7a1 1 0 00-.555.168L8 20.13V18a1 1 0 00-1-1H4c-.548 0-1-.452-1-1V4zm5 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm9.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-4-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M8.115 1.925l2.672 2.556.016.016a2.845 2.845 0 010 4l-1.736 1.736a10.98 10.98 0 004.682 4.69l1.617-1.707.019-.019a2.845 2.845 0 014 0l2.68 2.68c1.191 1.052 1.31 2.935-.027 3.96l-1.241 1.24c-1.522 1.523-3.739 2.223-5.84 1.803A17.578 17.578 0 011.12 9.041l-.002-.008c-.413-2.2.273-4.416 1.804-5.947l1.151-1.151C5.17.692 7.015.688 8.115 1.925zM6.632 3.268c-.306-.357-.761-.357-1.068 0a.995.995 0 01-.052.056L4.336 4.5C3.282 5.555 2.792 7.1 3.083 8.66a15.578 15.578 0 0012.261 12.258h.004c1.425.286 2.97-.19 4.034-1.254l1.294-1.294c.039-.039.08-.074.126-.106a.446.446 0 00.198-.377c0-.15-.068-.348-.268-.52a.995.995 0 01-.056-.052l-2.704-2.704a.846.846 0 00-1.165-.007l-2.105 2.222a1 1 0 01-1.125.23 12.934 12.934 0 01-6.632-6.633 1 1 0 01.21-1.106l2.234-2.234a.846.846 0 00.006-1.166L6.7 3.34a1 1 0 01-.068-.072z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-simultaneous-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10a9.958 9.958 0 00-1.098-4.56A4.502 4.502 0 0112 6.5a4.501 4.501 0 012.708-4.129A10.009 10.009 0 0012 2C6.477 2 2 6.477 2 12c0 1.643.396 3.193 1.098 4.56A4.502 4.502 0 0112 17.5a4.501 4.501 0 01-2.708 4.129c.861.242 1.77.371 2.708.371zm0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-4.5-4a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM19 6.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-whatsapp-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M9.5 1C4.3 1 0 5.027 0 10.095c0 4.227 2.996 7.724 7 8.769V22a1 1 0 001.536.844l5.755-3.654h.209c5.2 0 9.5-4.027 9.5-9.095C24 5.027 19.7 1 14.5 1h-5zM2 10.095C2 6.222 5.312 3 9.5 3h5c4.188 0 7.5 3.222 7.5 7.095 0 3.873-3.312 7.095-7.5 7.095H14a1 1 0 00-.536.156L9 20.18v-2.123a1 1 0 00-.832-.986C4.625 16.47 2 13.546 2 10.095zm13.035.907c.204.069 1.293.58 1.513.688l.102.047c.164.075.274.125.317.205.056.088.056.512-.127 1.009-.184.496-1.066.947-1.494 1.008-.702.1-1.253.05-2.659-.53-2.07-.858-3.47-2.773-3.743-3.146a2.352 2.352 0 00-.042-.057l-.01-.013C8.755 10.033 8 9.05 8 8.033c0-.975.498-1.486.73-1.723l.045-.046A.838.838 0 019.365 6c.148 0 .296 0 .424.008h.051c.129 0 .29 0 .448.363l.212.494.002.003c.197.461.43 1.002.468 1.077.056.107.092.23.02.37-.188.36-.382.556-.52.694-.173.172-.257.256-.13.464.858 1.41 1.713 1.9 3.014 2.522.22.107.351.088.48-.053.13-.145.554-.62.702-.833.148-.214.295-.18.499-.107z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-working-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm2 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM13 8a1 1 0 10-2 0v8a1 1 0 102 0V8z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-agillic-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13.888 7.452c0-.248.216-.452.48-.452.266 0 .48.204.48.452v6.751c0 .249-.216.452-.48.452s-.48-.203-.48-.452v-6.75zM12.447 9.07c.316 0 .573-.241.573-.539 0-.298-.257-.54-.573-.54-.316 0-.573.242-.573.54 0 .298.257.54.573.54zm0 .818c.264 0 .48.204.48.453v3.862c0 .249-.216.452-.48.452s-.48-.203-.48-.452v-3.862c0-.25.216-.453.48-.453zm-8.333 4.325v-.076a2.61 2.61 0 01-1.585.525 2.595 2.595 0 01-1.788-.698A2.299 2.299 0 010 12.28a2.3 2.3 0 01.739-1.684 2.594 2.594 0 011.788-.698c.585 0 1.14.187 1.587.527v-.074c0-.25.217-.453.48-.453.267 0 .481.202.481.453v3.862c0 .249-.216.453-.48.453s-.48-.204-.48-.453zm-1.587-.454c-.866 0-1.57-.663-1.57-1.479 0-.816.704-1.479 1.57-1.479.867 0 1.57.663 1.57 1.48 0 .815-.703 1.478-1.57 1.478zm16.257-5.228c0 .298-.256.54-.573.54-.316 0-.572-.242-.572-.54 0-.298.256-.54.572-.54.317 0 .573.242.573.54zm-.573 1.357c-.264 0-.48.204-.48.453v3.862c0 .249.216.452.48.452.265 0 .48-.203.48-.452v-3.862c0-.25-.214-.453-.48-.453zM16.29 7c-.264 0-.48.204-.48.452v6.751c0 .249.216.452.48.452s.48-.203.48-.452v-6.75c0-.25-.214-.453-.48-.453zm3.248 5.28c0-1.318 1.138-2.39 2.538-2.39.67 0 1.288.24 1.787.696.085.076.131.19.133.318a.442.442 0 01-.118.32.457.457 0 01-.324.13.641.641 0 01-.364-.126l-.026-.018c-.232-.166-.58-.415-1.088-.415-.87 0-1.578.666-1.578 1.486 0 .819.708 1.485 1.578 1.485.462 0 .815-.235 1.026-.376l.022-.014a1.64 1.64 0 01.063-.041.682.682 0 01.362-.119c.127 0 .236.048.327.141a.44.44 0 01.123.326.442.442 0 01-.156.313 2.733 2.733 0 01-1.767.675c-1.4 0-2.538-1.072-2.538-2.39zM8.45 9.89c-.675 0-1.31.247-1.789.698a2.3 2.3 0 00-.74 1.684c0 .635.262 1.233.74 1.684a2.595 2.595 0 001.789.698c.587 0 1.144-.188 1.594-.533v.133c0 .782-.719 1.444-1.568 1.444h-.024a1.707 1.707 0 01-1.081-.428.557.557 0 00-.36-.145.502.502 0 00-.348.146c-.157.157-.138.458.043.644.44.454 1.036.686 1.771.686a2.59 2.59 0 001.794-.703 2.29 2.29 0 00.734-1.691V10.34c0-.25-.216-.453-.48-.453-.265 0-.48.204-.48.453v.082A2.602 2.602 0 008.45 9.89zm0 3.859c-.867 0-1.57-.663-1.57-1.479 0-.816.703-1.479 1.57-1.479.866 0 1.57.663 1.57 1.479 0 .816-.704 1.479-1.57 1.479z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-busylight-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M7.998 3.078L6.88.82a.562.562 0 01.25-.755.545.545 0 01.75.247L9 2.57a.564.564 0 01-.25.758.507.507 0 01-.25.055.562.562 0 01-.5-.305zm-.167 19.628s-3.196-1.217-3.437-2.598a2.896 2.896 0 01-.04-.626c.097-2.217.234-4.187.41-5.91.227-2.23.56-4.443.997-6.639.154-.77.676-1.399 1.375-1.654 1.269-.462 2.87-.693 4.806-.693 1.951 0 3.563.235 4.837.705.688.253 1.203.868 1.362 1.626.39 1.845.716 4.07.982 6.677.199 1.955.342 3.919.43 5.892.061 1.375-3.497 3.23-3.497 3.23s-.781.363-1.299.4c-.401.03-.722.016-1.554-.049a15.024 15.024 0 00-1.256-.063c-.355 0-.652.016-1.242.06-.85.063-1.178.076-1.588.043-.51-.041-1.286-.401-1.286-.401zm2.767-1.269c-.816.061-1.56.078-2.968-.42-1.408-.497-1.748-.8-1.748-1.458 0-.658.23-4.124.403-5.81a68.69 68.69 0 01.972-6.477.597.597 0 01.373-.45c1.093-.398 2.533-.605 4.312-.605 1.793 0 3.242.21 4.337.615a.597.597 0 01.37.442c.375 1.78.693 3.947.953 6.495.189 1.858.414 5.077.414 5.597 0 .52-.65 1.108-1.367 1.408-.718.3-2.534.73-3.334.667a16.11 16.11 0 00-1.368-.068c-.383 0-.697.016-1.349.064zm-1.506 2.18a3.17 3.17 0 01-1.157-.295c.152.417.547.678 1.012.678h6.02c.057 0 .114-.005.171-.015.443-.076.739-.283.85-.67-.353.18-.748.278-1.208.311-.423.032-.753.017-1.601-.049a14.773 14.773 0 00-1.232-.062c-.345 0-.636.015-1.219.059-.866.064-1.204.077-1.636.043zm2.075-7.194l.287 3.93s-.707.017-.842.027c-.63.049-.968.01-1.27-.024a6.829 6.829 0 00-.287-.029c-.518-.038-.597.347-.025.388.103.008.2.019.3.03.315.035.662.073 1.308.023.59-.045.886-.062 1.235-.062.346 0 .639.016 1.223.059.667.049 1.022.008 1.347-.03.099-.01.195-.021.296-.03.583-.046.5-.43-.027-.388a7.576 7.576 0 00-.285.03c-.31.037-.655.078-1.306.03a14.582 14.582 0 00-.394-.01 13.416 13.416 0 01-.33-.008l.334-3.936c0-.561-.282-1.016-.806-1.016s-.758.454-.758 1.016zm-8.13-7.605c.336 0 .607.28.607.61 0 .343-.27.61-.607.61H.607A.605.605 0 010 9.428c0-.33.272-.61.607-.61h2.43zM24 9.428c0-.33-.27-.61-.607-.61h-2.43a.614.614 0 00-.607.61c0 .343.272.61.607.61h2.43a.604.604 0 00.607-.61zm-9.217-6.1c.08.044.165.055.25.055a.563.563 0 00.5-.305L16.652.82a.561.561 0 00-.25-.755.546.546 0 00-.75.247l-1.12 2.258a.564.564 0 00.25.758zm-10.12.875c.3.142.42.5.27.799a.613.613 0 01-.543.322.559.559 0 01-.27-.058L1.69 4.07a.588.588 0 01-.272-.799.6.6 0 01.815-.263l2.43 1.195zM22.05 4.07a.587.587 0 00.27-.799.598.598 0 00-.813-.263l-2.43 1.195a.587.587 0 00-.272.799c.106.203.32.322.544.322a.562.562 0 00.271-.058l2.43-1.196z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-magento-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M23 17.997V5.994L12.01 0 1 6.004v11.993l3.14 1.715-.02-11.993 7.87-4.293 7.864 4.293v11.988L23 17.997zm-11 2.572l1.568-.862V7.714l3.146 1.715v11.998L11.995 24l-4.709-2.573-.005-11.993 3.141-1.715v11.997L12 20.57z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-podio-24\" viewBox=\"0 0 24 24\"><path d=\"M19.17 3.864C15.262.06 8.913.045 4.986 3.82l-.046.045a9.625 9.625 0 00.002 13.852l6.059 5.897c.264.258.61.386.957.386.346 0 .694-.128.958-.386a1.296 1.296 0 000-1.865l-6.06-5.897A7.033 7.033 0 016.83 5.754l.028-.026c2.867-2.79 7.531-2.789 10.396 0 2.353 2.292 2.69 6.212.784 9.121a1.298 1.298 0 00.413 1.82 1.375 1.375 0 001.87-.401c2.616-3.992 2.132-9.208-1.151-12.404zM16.745 18.02c.529.515.53 1.35 0 1.865-.263.258-.61.386-.956.386-.347 0-.694-.128-.96-.386l-6.057-5.897a4.444 4.444 0 010-6.394 4.679 4.679 0 013.283-1.323h.001c1.24 0 2.406.47 3.282 1.325a4.436 4.436 0 011.165 4.493c-.215.697-.968 1.095-1.685.886-.717-.208-1.125-.943-.911-1.641a1.848 1.848 0 00-.484-1.873 1.946 1.946 0 00-1.368-.553c-.517 0-1.002.196-1.368.551a1.851 1.851 0 000 2.664l6.058 5.897z\"/></symbol>\n<symbol id=\"icon-salesforce-24\" viewBox=\"0 0 24 24\"><path d=\"M9.921 5.63A4.775 4.775 0 006.298 4c-2.59 0-4.691 2-4.691 4.47 0 .65.146 1.267.408 1.825C.813 10.93 0 12.153 0 13.555c0 2.06 1.752 3.729 3.914 3.729.32 0 .631-.037.93-.106C5.362 18.811 6.954 20 8.838 20c1.738 0 3.227-1.012 3.855-2.45.475.179.994.277 1.536.277 1.498 0 2.813-.752 3.548-1.883.344.07.7.105 1.065.105 2.849 0 5.158-2.2 5.158-4.913 0-2.714-2.31-4.914-5.158-4.914-.7 0-1.369.133-1.978.375-.817-1.234-2.26-2.054-3.905-2.054A4.73 4.73 0 009.921 5.63z\"/></symbol>\n<symbol id=\"icon-shopify-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M20.05 4.478l-2.013-.144-1.482-1.412c-.147-.141-.434-.098-.545-.067l-.353.105-.394.116C14.817 1.845 14.029.713 12.645.713c-.039 0-.079.002-.118.004-.394-.5-.882-.717-1.303-.717-3.227 0-4.768 3.87-5.252 5.836-1.254.372-2.144.637-2.257.672-.701.21-.723.231-.814.864C2.83 7.85 1 21.436 1 21.436L15.268 24 23 22.396S20.286 4.794 20.27 4.673c-.018-.12-.128-.187-.22-.195zm-7.629-.558l-2.494.741c.48-1.777 1.38-2.636 2.167-2.96.198.477.328 1.162.328 2.085v.07l-.001.064zM8.939 4.955c.468-2.348 1.576-3.524 2.61-3.99a.752.752 0 00-.414-.135c-2.317 0-3.62 2.92-4.167 4.71l1.97-.585zm.893 5.914c-1.5 0-1.577.904-1.577 1.131 0 .491.528.863 1.166 1.312.976.687 2.21 1.557 2.21 3.317 0 2.289-1.513 3.763-3.555 3.763-2.45 0-3.702-1.462-3.702-1.462l.656-2.078s1.288 1.06 2.375 1.06c.709 0 .998-.536.998-.927 0-.71-.532-1.124-1.13-1.588-.766-.595-1.64-1.273-1.64-2.77 0-2.24 1.677-4.41 5.062-4.41 1.305 0 1.95.36 1.95.36l-.954 2.72s-.835-.428-1.859-.428zm3.147-9.32c.178.489.289 1.105.289 1.87v.13l-.001.12.559-.166.648-.192c-.306-.897-.781-1.676-1.495-1.761z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-web-form-24\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" d=\"M13 3a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 01-4.293 2.708l-5 4.999c.046.095.087.193.122.293h12.342a3.001 3.001 0 110 2H5.829c-.035.1-.076.198-.121.293l4.998 5a3 3 0 11-1.414 1.414l-4.999-5a3 3 0 110-5.415l5-4.999A3 3 0 1115 3zM3 13a1 1 0 100-2 1 1 0 000 2zm18 0a1 1 0 100-2 1 1 0 000 2zm-9 9a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-webhooks-24\" viewBox=\"0 0 24 24\"><g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" d=\"M8.54 3.987a3.978 3.978 0 001.465 5.446c.347.2.53.575.497.948a.987.987 0 01-.09.506L7.627 16.83c.236.327.375.729.375 1.162 0 1.101-.896 1.993-2 1.993A1.997 1.997 0 014 17.993c0-1.034.791-1.885 1.803-1.983l2.495-5.326a5.965 5.965 0 01-1.49-7.693C8.465.13 12.137-.85 15.008.802a5.967 5.967 0 012.198 8.168c-.277.477-.889.64-1.367.365a.995.995 0 01-.367-1.361 3.978 3.978 0 00-1.464-5.446 4.01 4.01 0 00-5.467 1.46zm5.016 3.272a2 2 0 10-1.867.717l2.382 6.327a1.002 1.002 0 001.556.434 4.164 4.164 0 012.08-.75 4.047 4.047 0 012.174.438 3.922 3.922 0 012.115 3.631 4.056 4.056 0 01-.692 2.113 4.168 4.168 0 01-3.927 1.81 3.995 3.995 0 01-2.035-.85 1.003 1.003 0 00-1.407.15.994.994 0 00.15 1.4 6 6 0 003.055 1.279 6.167 6.167 0 005.826-2.678 6.045 6.045 0 001.03-3.15 5.913 5.913 0 00-3.19-5.473A6.055 6.055 0 0017.551 12a6.16 6.16 0 00-2.02.51l-1.976-5.25zM18 20a2 2 0 10-1.732-3H11a.997.997 0 00-1 .997V18c0 .766-.21 1.43-.607 2.078a4.032 4.032 0 01-1.63 1.504 3.926 3.926 0 01-4.191-.421 4.081 4.081 0 01-1.314-1.803 4.17 4.17 0 01-.18-2.245 4.118 4.118 0 011.008-2 3.985 3.985 0 011.883-1.148 1 1 0 10-.526-1.93 5.984 5.984 0 00-2.828 1.724 6.118 6.118 0 00-1.5 2.97 6.17 6.17 0 00.268 3.323 6.081 6.081 0 001.958 2.685 5.926 5.926 0 006.319.632 6.032 6.032 0 002.44-2.248 5.994 5.994 0 00.816-2.128h4.348A1.999 1.999 0 0018 20z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"clip0\"><path d=\"M0 0h24v24H0z\"/></clipPath></defs></symbol></svg>";
var iconconfig = {
	svg: svg
};

var css_248z$2 = "@-webkit-keyframes icon--icon__spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n@keyframes icon--icon__spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n.icon--icon__root {\n  fill: currentColor; }\n  .icon--icon__rootSpin {\n    -webkit-animation: icon--icon__spin 1.5s linear infinite;\n            animation: icon--icon__spin 1.5s linear infinite; }\n";
var styles$1 = {"root":"icon--icon__root","rootSpin":"icon--icon__rootSpin","spin":"icon--icon__spin"};
styleInject(css_248z$2);

var DEFAULT_SIZE = 16;
/**
 * Appends the svg icons to the provided document.
 * @param document The document.
 */

function addSvgIconsToDocument(document) {
  var svgContainerId = 'dixa-icons-svg';

  if (document.getElementById(svgContainerId)) {
    return;
  }

  var svgContainer = document.createElement('span');
  svgContainer.id = svgContainerId;
  svgContainer.style.display = 'none';
  svgContainer.innerHTML = iconconfig.svg;
  document.body.appendChild(svgContainer);
}
addSvgIconsToDocument(document);

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon() {
    return _super !== null && _super.apply(this, arguments) || this;
  } // TODO remove this function and update other components to use pixel perfect sizes
  // https://dixa-product.atlassian.net/browse/TEAMS-3401


  Icon.prototype.legacyGetPixelPerfectSize = function () {
    var size = this.props.size;

    if (!size || size <= 16) {
      return 16;
    }

    if (size <= 20) {
      return 20;
    }

    return 24;
  };

  Icon.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        name = _b.name,
        size = _b.size,
        color = _b.color,
        style = _b.style,
        spin = _b.spin,
        otherProps = __rest(_b, ["className", "name", "size", "color", "style", "spin"]);

    var rootClass = classnames((_a = {}, _a[styles$1.root] = true, _a[styles$1.rootSpin] = spin, _a), className);

    var styleProp = __assign({}, style);

    var sizeProps = {
      height: size,
      width: size
    };

    if (color) {
      styleProp.color = color;
    }

    return /*#__PURE__*/React.createElement("svg", __assign({}, otherProps, {
      className: rootClass,
      style: styleProp
    }, sizeProps), /*#__PURE__*/React.createElement("use", {
      href: "#icon-" + name + "-" + this.legacyGetPixelPerfectSize()
    }));
  };

  Icon.defaultProps = {
    size: DEFAULT_SIZE
  };
  return Icon;
}(React.PureComponent);
var IconWithErrorBoundary = withErrorBoundary(Icon, {
  fallback: null
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var color = {
	purple: {
		"100": "#f0f0ff",
		"200": "#ddd8fd",
		"300": "#c1b9f8",
		"400": "#8f82ed",
		"500": "#5644d8",
		"600": "#392aa7",
		"700": "#281c82",
		"800": "#140561",
		"900": "#0c0146"
	},
	green: {
		"100": "#dffbe9",
		"200": "#c6f5d6",
		"300": "#9febb9",
		"400": "#6ad495",
		"500": "#33b967",
		"600": "#23924e",
		"700": "#196c39",
		"800": "#195239",
		"900": "#164832"
	},
	blue: {
		"100": "#e7f5fe",
		"200": "#a8d9fc",
		"300": "#69bbf6",
		"400": "#36a1ec",
		"500": "#0078cc",
		"600": "#0067ad",
		"700": "#005893",
		"800": "#00487a",
		"900": "#003d66"
	},
	orange: {
		"100": "#ffeedd",
		"200": "#ffdcaf",
		"300": "#ffbd6e",
		"400": "#ff9e37",
		"500": "#fc800d",
		"600": "#e56500",
		"700": "#ca4f00",
		"800": "#a93900",
		"900": "#872600"
	},
	red: {
		"100": "#fff2f2",
		"200": "#f5cccb",
		"300": "#eaa8a6",
		"400": "#db6a68",
		"500": "#c83c3c",
		"600": "#c11d1d",
		"700": "#b30908",
		"800": "#9e0302",
		"900": "#870000"
	},
	neutral: {
		"100": "#f5f7fa",
		"200": "#e7ecf3",
		"300": "#d7dfea",
		"400": "#b5c1d4",
		"500": "#8193b0",
		"600": "#617598",
		"700": "#45587c",
		"800": "#263758",
		"900": "#132243",
		"000": "#ffffff"
	}
};
var effect = {
	elevation: {
		"100": {
			type: "DROP_SHADOW",
			radius: "2px",
			color: "#6176980a",
			"offset-x": "0px",
			"offset-y": "1px"
		},
		"200": {
			type: "DROP_SHADOW",
			radius: "4px",
			color: "#6176980a",
			"offset-x": "0px",
			"offset-y": "2px"
		},
		"300": {
			type: "DROP_SHADOW",
			radius: "8px",
			color: "#6176980a",
			"offset-x": "0px",
			"offset-y": "4px"
		},
		"400": {
			type: "DROP_SHADOW",
			radius: "16px",
			color: "#6176980a",
			"offset-x": "0px",
			"offset-y": "8px"
		}
	},
	opacity: {
		"200": 0.2,
		"500": 0.5
	}
};
var size = {
	spacer: {
		"100": "4px",
		"200": "8px",
		"250": "12px",
		"300": "16px",
		"400": "24px",
		"500": "32px"
	},
	"border-radius": {
		"50": "2px",
		"100": "4px"
	},
	border: {
		"100": "1px",
		"200": "2px"
	}
};
var typography = {
	weight: {
		semibold: 600,
		normal: 400
	},
	"line-height": {
		"100": "12px",
		"200": "16px",
		"300": "20px",
		"400": "24px"
	},
	color: {
		primary: "#132244",
		secondary: "#46597C",
		tertiary: "#8294B0",
		success: "#23924E",
		error: "#C11D1D",
		warning: "#E56500",
		link: "#0079CC"
	},
	size: {
		"100": "10px",
		"200": "12px",
		"300": "14px",
		"400": "16px",
		"500": "18px"
	},
	"letter-spacing": {
		"100": "-0.32px",
		"200": "-0.24px",
		"300": "-0.16px",
		"400": "-0.08px",
		"500": "0px",
		"600": "0.08px",
		"700": "0.16px",
		"800": "0.24px",
		"900": "0.32px"
	},
	family: {
		"default": "Open Sans, Arial, sans-serif",
		code: "Courier, Consolas, Monaco, Lucida Console, Liberation Mono"
	}
};
var json = {
	color: color,
	effect: effect,
	size: size,
	typography: typography
};

const colors = json.color;
const sizes = json.size;
const typography$1 = json.typography;

var navigateTokenPath = function navigateTokenPath(path, tokenObj) {
  var pathArr = path.split('.').reverse();
  var token = tokenObj;

  while (pathArr.length) {
    var key = pathArr.pop();
    if (!key) return null;

    if (token[key] === undefined) {
      if (key === '0') return key;
      console.warn("Token does not exist. (" + key + ")");
      return null;
    }

    token = token[key];
  }

  if (token && _typeof(token) !== 'object') {
    return token;
  }

  return null;
};

var navigateTokens = function navigateTokens(path, tokenObj) {
  var paths = path.split(' ');
  return paths.map(function (p) {
    return navigateTokenPath(p, tokenObj);
  }).filter(function (val) {
    return val !== null;
  }).join(' ');
};
var colorKeywords = ['currentColor', 'transparent'];
var resolveColor = function resolveColor(path) {
  if (path.indexOf('#') === 0 || colorKeywords.includes(path)) return path;
  var color = navigateTokens(path, colors);
  if (color) return color;
  return '';
};

var isValue = function isValue(value) {
  return value.indexOf('px') > -1 || value.indexOf('%') > -1 || value.indexOf('vh') > -1 || value.indexOf('vw') > -1;
};

var resolveSpacer = function resolveSpacer(path) {
  if (path === void 0) {
    path = '200';
  }

  if (isValue(path)) return path;
  var spacer = navigateTokens(path, sizes.spacer);
  if (spacer) return spacer;
  return '';
};
var resolveBorderRadius = function resolveBorderRadius(path) {
  if (path === void 0) {
    path = '100';
  }

  if (isValue(path)) return path;
  var radius = navigateTokens(path, sizes['border-radius']);
  if (radius) return radius;
  return '';
};
var resolveBorderSize = function resolveBorderSize(path) {
  if (path === void 0) {
    path = '100';
  }

  if (isValue(path)) return path;
  var size = navigateTokens(path, sizes.border);
  if (size) return size;
  return '';
};

var css_248z$3 = ".box--box__root {\n  box-sizing: border-box; }\n";
var styles$2 = {"root":"box--box__root"};
styleInject(css_248z$3);

var Box =
/** @class */
function (_super) {
  __extends(Box, _super);

  function Box() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Box.prototype.render = function () {
    var _a;

    var _b = this.props,
        asElement = _b.as,
        display = _b.display,
        background = _b.background,
        color = _b.color,
        fontSize = _b.fontSize,
        padding = _b.padding,
        margin = _b.margin,
        width = _b.width,
        minWidth = _b.minWidth,
        maxWidth = _b.maxWidth,
        height = _b.height,
        minHeight = _b.minHeight,
        maxHeight = _b.maxHeight,
        borderRadius = _b.borderRadius,
        borderColor = _b.borderColor,
        borderWidth = _b.borderWidth,
        flex = _b.flex,
        justifySelf = _b.justifySelf,
        alignSelf = _b.alignSelf,
        style = _b.style,
        className = _b.className,
        otherProps = __rest(_b, ["as", "display", "background", "color", "fontSize", "padding", "margin", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "borderRadius", "borderColor", "borderWidth", "flex", "justifySelf", "alignSelf", "style", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$2.root] = styles$2.root, _a), className);
    var Element = asElement === undefined ? 'div' : asElement;
    var styleObj = {};
    [{
      value: display,
      name: 'display'
    }, {
      value: fontSize,
      name: 'fontSize'
    }, {
      value: width,
      name: 'width'
    }, {
      value: height,
      name: 'height'
    }, {
      value: minWidth,
      name: 'minWidth'
    }, {
      value: maxWidth,
      name: 'maxWidth'
    }, {
      value: minHeight,
      name: 'minHeight'
    }, {
      value: maxHeight,
      name: 'maxHeight'
    }, {
      value: flex,
      name: 'flex'
    }, {
      value: justifySelf,
      name: 'justifySelf'
    }, {
      value: alignSelf,
      name: 'alignSelf'
    }].forEach(function (property) {
      if (property.value) {
        styleObj[property.name] = property.value;
      }
    });

    if (background) {
      styleObj.backgroundColor = resolveColor(background);
    }

    if (color) {
      styleObj.color = resolveColor(color);
    }

    if (padding) {
      styleObj.padding = resolveSpacer(padding);
    }

    if (margin) {
      styleObj.margin = resolveSpacer(margin);
    }

    if (padding) {
      styleObj.padding = resolveSpacer(padding);
    }

    if (borderRadius) {
      styleObj.borderRadius = resolveBorderRadius(typeof borderRadius === 'boolean' ? '100' : borderRadius);
    }

    if (borderColor) {
      styleObj.borderColor = resolveColor(borderColor);
      styleObj.borderWidth = resolveBorderSize();
      styleObj.borderStyle = 'solid';
    }

    if (borderWidth) {
      styleObj.borderWidth = resolveBorderSize(borderWidth);
    }

    styleObj = __assign(__assign({}, styleObj), style);
    return /*#__PURE__*/React.createElement(Element, __assign({}, otherProps, {
      style: styleObj,
      className: rootClass
    }), this.props.children);
  };

  Box.defaultProps = {
    as: 'div'
  };
  return Box;
}(PureComponent);

var css_248z$4 = "@-webkit-keyframes text--sharedStyles__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes text--sharedStyles__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes text--sharedStyles__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes text--sharedStyles__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.text--sharedStyles__text {\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n";
var sharedStyles = {"text":"text--sharedStyles__text","wiggle":"text--sharedStyles__wiggle","spin":"text--sharedStyles__spin"};
styleInject(css_248z$4);

var textColorToClassNameMap = {
  primary: typography$1.color.primary,
  secondary: typography$1.color.secondary,
  tertiary: typography$1.color.tertiary,
  white: colors.neutral['000']
};
function resolveTextColor(color) {
  if (color === undefined) {
    return undefined;
  }

  return color in textColorToClassNameMap ? textColorToClassNameMap[color] : color;
}

function calculateTextStyles(textProps) {
  var styles = {};
  var color = textProps.color,
      align = textProps.align,
      wrap = textProps.wrap,
      display = textProps.display;

  if (display) {
    styles.display = display;
  }

  if (color) {
    styles.color = resolveTextColor(color);
  }

  if (align) {
    styles.textAlign = align;
  }

  if (wrap) {
    styles.whiteSpace = wrap;
  }

  return styles;
}

var css_248z$5 = "@-webkit-keyframes heading--heading__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes heading--heading__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes heading--heading__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes heading--heading__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.heading--heading__heading-1 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.24px;\n  color: #132244; }\n\n.heading--heading__heading-2 {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.24px;\n  color: #132244; }\n\n.heading--heading__heading-3 {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.16px;\n  color: #132244; }\n\n.heading--heading__heading-4 {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.08px;\n  color: #132244; }\n\n.heading--heading__withMarginBottom {\n  margin-bottom: 24px; }\n";
var styles$3 = {"heading-1":"heading--heading__heading-1","heading-2":"heading--heading__heading-2","heading-3":"heading--heading__heading-3","heading-4":"heading--heading__heading-4","withMarginBottom":"heading--heading__withMarginBottom","wiggle":"heading--heading__wiggle","spin":"heading--heading__spin"};
styleInject(css_248z$5);

var variantClassNameMap = {
  'heading-1': styles$3['heading-1'],
  'heading-2': styles$3['heading-2'],
  'heading-3': styles$3['heading-3'],
  'heading-4': styles$3['heading-4']
};

var Heading =
/** @class */
function (_super) {
  __extends(Heading, _super);

  function Heading() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Heading.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        variant = _b.variant,
        className = _b.className,
        withMarginBottom = _b.withMarginBottom,
        as = _b.as;
    var classNames = classnames(sharedStyles.text, variantClassNameMap[variant], (_a = {}, _a[styles$3.withMarginBottom] = withMarginBottom, _a), className);
    return /*#__PURE__*/React.createElement(Box, {
      as: as,
      className: classNames,
      style: calculateTextStyles(this.props)
    }, children);
  };

  Heading.defaultProps = {
    variant: 'heading-2',
    withMarginBottom: false,
    as: 'h2'
  };
  return Heading;
}(React.PureComponent);

var css_248z$6 = "@-webkit-keyframes input--input__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes input--input__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes input--input__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes input--input__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.input--input__title, .input--input__success, .input--input__warning, .input--input__error {\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: -0.08px; }\n\n.input--input__title {\n  color: #46597C; }\n\n.input--input__success {\n  color: #23924E; }\n\n.input--input__warning {\n  color: #E56500; }\n\n.input--input__error {\n  color: #C11D1D; }\n";
var styles$4 = {"title":"input--input__title","success":"input--input__success","warning":"input--input__warning","error":"input--input__error","wiggle":"input--input__wiggle","spin":"input--input__spin"};
styleInject(css_248z$6);

var variantClassNameMap$1 = {
  title: styles$4.title,
  success: styles$4.success,
  warning: styles$4.warning,
  error: styles$4.error
};

var Input =
/** @class */
function (_super) {
  __extends(Input, _super);

  function Input() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Input.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        variant = _a.variant,
        className = _a.className,
        as = _a.as;
    var classNames = classnames(sharedStyles.text, variantClassNameMap$1[variant], className);
    return /*#__PURE__*/React.createElement(Box, {
      as: as,
      role: "alert",
      className: classNames,
      style: calculateTextStyles(this.props)
    }, children);
  };

  Input.defaultProps = {
    variant: 'title',
    as: 'div'
  };
  return Input;
}(React.PureComponent);

var css_248z$7 = "@-webkit-keyframes link--externalLink__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes link--externalLink__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes link--externalLink__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes link--externalLink__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.link--externalLink__linkText {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.16px;\n  color: #0079CC;\n  -webkit-text-decoration-line: none;\n          text-decoration-line: none; }\n  .link--externalLink__linkText:hover, .link--externalLink__linkText:focus {\n    color: #005893;\n    -webkit-text-decoration-line: underline;\n            text-decoration-line: underline; }\n  .link--externalLink__linkText:active {\n    color: #003d66; }\n";
var styles$5 = {"linkText":"link--externalLink__linkText","wiggle":"link--externalLink__wiggle","spin":"link--externalLink__spin"};
styleInject(css_248z$7);

var ExternalLink =
/** @class */
function (_super) {
  __extends(ExternalLink, _super);

  function ExternalLink() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ExternalLink.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        color = _a.color,
        align = _a.align,
        display = _a.display,
        wrap = _a.wrap,
        as = _a.as,
        anchorTagProps = __rest(_a, ["children", "className", "color", "align", "display", "wrap", "as"]);

    var classNames = classnames(styles$5.linkText, sharedStyles.text, className);
    return /*#__PURE__*/React.createElement(Box, __assign({
      as: as,
      className: classNames,
      style: calculateTextStyles(this.props)
    }, anchorTagProps), children);
  };

  ExternalLink.defaultProps = {
    as: 'a'
  };
  return ExternalLink;
}(React.PureComponent);

var css_248z$8 = "@-webkit-keyframes paragraph--paragraph__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes paragraph--paragraph__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes paragraph--paragraph__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes paragraph--paragraph__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.paragraph--paragraph__variant-1 {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.16px;\n  color: #132244; }\n  .paragraph--paragraph__variant-1-subdued {\n    color: #46597C; }\n\n.paragraph--paragraph__variant-2 {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.16px;\n  color: #132244; }\n  .paragraph--paragraph__variant-2-subdued {\n    color: #46597C; }\n\n.paragraph--paragraph__variant-3 {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.08px;\n  color: #132244; }\n  .paragraph--paragraph__variant-3-subdued {\n    color: #46597C; }\n\n.paragraph--paragraph__variant-4 {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.08px;\n  color: #132244; }\n  .paragraph--paragraph__variant-4-subdued {\n    color: #46597C; }\n\n.paragraph--paragraph__variant-5 {\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: 0px;\n  color: #132244; }\n\n.paragraph--paragraph__withMarginBottom {\n  margin-bottom: 24px; }\n";
var styles$6 = {"variant-1":"paragraph--paragraph__variant-1","variant-1-subdued":"paragraph--paragraph__variant-1-subdued","variant-2":"paragraph--paragraph__variant-2","variant-2-subdued":"paragraph--paragraph__variant-2-subdued","variant-3":"paragraph--paragraph__variant-3","variant-3-subdued":"paragraph--paragraph__variant-3-subdued","variant-4":"paragraph--paragraph__variant-4","variant-4-subdued":"paragraph--paragraph__variant-4-subdued","variant-5":"paragraph--paragraph__variant-5","withMarginBottom":"paragraph--paragraph__withMarginBottom","wiggle":"paragraph--paragraph__wiggle","spin":"paragraph--paragraph__spin"};
styleInject(css_248z$8);

var variantClassNameMap$2 = {
  '1': styles$6['variant-1'],
  '2': styles$6['variant-2'],
  '3': styles$6['variant-3'],
  '4': styles$6['variant-4'],
  '5': styles$6['variant-5']
};
var subduedVariantClassNameMap = {
  '1': styles$6['variant-1-subdued'],
  '2': styles$6['variant-2-subdued'],
  '3': styles$6['variant-3-subdued'],
  '4': styles$6['variant-4-subdued'],
  '5': ''
};

var Paragraph =
/** @class */
function (_super) {
  __extends(Paragraph, _super);

  function Paragraph() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Paragraph.prototype.calculateClassName = function () {
    var _a;

    var _b = this.props,
        variant = _b.variant,
        subdued = _b.subdued,
        withMarginBottom = _b.withMarginBottom,
        className = _b.className;
    var variantClassName = variantClassNameMap$2[variant];
    var subduedVariantClassName = subduedVariantClassNameMap[variant];
    return classnames([sharedStyles.text, variantClassName, className, (_a = {}, _a[subduedVariantClassName] = subdued, _a[styles$6.withMarginBottom] = withMarginBottom, _a)]);
  };

  Paragraph.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        as = _a.as;
    return /*#__PURE__*/React.createElement(Box, {
      as: as,
      className: this.calculateClassName(),
      style: calculateTextStyles(this.props)
    }, children);
  };

  Paragraph.defaultProps = {
    as: 'p',
    variant: '2',
    subdued: false,
    withMarginBottom: false
  };
  return Paragraph;
}(React.PureComponent);

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Text.prototype.render = function () {
    console.error('Using <Text> component directly is not allowed, use one of the sub-components instead: <Text.Paragraph>');
    return null;
  };

  Text.Heading = Heading;
  Text.Paragraph = Paragraph;
  Text.ExternalLink = ExternalLink;
  Text.Input = Input;
  return Text;
}(React.PureComponent);

var css_248z$9 = "@-webkit-keyframes styles--button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes styles--button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes styles--button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes styles--button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.styles--button__button {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 4px;\n  border: 2px solid transparent;\n  box-sizing: border-box;\n  max-width: 100%;\n  width: auto;\n  white-space: nowrap;\n  text-decoration: none;\n  text-transform: capitalize;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  transition: all 0.3s; }\n  .styles--button__buttonNormal {\n    height: 32px;\n    padding-left: 12px;\n    padding-right: 12px; }\n  .styles--button__buttonLarge {\n    height: 40px;\n    padding-left: 16px;\n    padding-right: 16px; }\n  .styles--button__buttonDisabled, .styles--button__buttonLoading {\n    pointer-events: none;\n    cursor: not-allowed;\n    opacity: 0.5; }\n  .styles--button__buttonWithLabel.styles--button__buttonNormal {\n    padding-right: 2px; }\n  .styles--button__buttonWithLabel.styles--button__buttonLarge {\n    padding-right: 4px; }\n  .styles--button__buttonLabel {\n    height: 24px;\n    padding: 4px 8px;\n    border-radius: 2px;\n    flex-shrink: 0;\n    margin-left: 8px; }\n";
var baseStyles = {"button":"styles--button__button","buttonNormal":"styles--button__buttonNormal","buttonLarge":"styles--button__buttonLarge","buttonDisabled":"styles--button__buttonDisabled","buttonLoading":"styles--button__buttonLoading","buttonWithLabel":"styles--button__buttonWithLabel","buttonLabel":"styles--button__buttonLabel","wiggle":"styles--button__wiggle","spin":"styles--button__spin"};
styleInject(css_248z$9);

var css_248z$a = "@-webkit-keyframes styles--danger-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes styles--danger-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes styles--danger-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes styles--danger-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.styles--danger-button__danger {\n  background-color: #c11d1d;\n  color: #ffffff; }\n  .styles--danger-button__danger:focus {\n    border-color: #eaa8a6;\n    outline: none; }\n  .styles--danger-button__danger:hover {\n    background-color: #9e0302; }\n  .styles--danger-button__danger:active {\n    background-color: #870000; }\n  .styles--danger-button__dangerLabel {\n    background: rgba(255, 255, 255, 0.2);\n    color: #ffffff; }\n";
var dangerStyles = {"danger":"styles--danger-button__danger","dangerLabel":"styles--danger-button__dangerLabel","wiggle":"styles--danger-button__wiggle","spin":"styles--danger-button__spin"};
styleInject(css_248z$a);

var css_248z$b = "@-webkit-keyframes styles--primary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes styles--primary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes styles--primary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes styles--primary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.styles--primary-button__primary {\n  background-color: #5644d8;\n  color: #ffffff; }\n  .styles--primary-button__primary:focus {\n    border-color: #c1b9f8;\n    outline: none; }\n  .styles--primary-button__primary:hover {\n    background-color: #392aa7; }\n  .styles--primary-button__primary:active {\n    background-color: #281c82; }\n  .styles--primary-button__primaryLabel {\n    background: rgba(255, 255, 255, 0.2);\n    color: #ffffff; }\n";
var primaryStyles = {"primary":"styles--primary-button__primary","primaryLabel":"styles--primary-button__primaryLabel","wiggle":"styles--primary-button__wiggle","spin":"styles--primary-button__spin"};
styleInject(css_248z$b);

var css_248z$c = "@-webkit-keyframes styles--secondary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes styles--secondary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes styles--secondary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes styles--secondary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.styles--secondary-button__secondary {\n  background-color: #ffffff;\n  box-shadow: 0 0 0 1px #e7ecf3;\n  color: #46597C; }\n  .styles--secondary-button__secondary:focus {\n    border-color: #c1b9f8;\n    box-shadow: none;\n    outline: none; }\n  .styles--secondary-button__secondary:hover {\n    background-color: #f5f7fa; }\n  .styles--secondary-button__secondary:active {\n    background-color: #e7ecf3;\n    border-color: transparent; }\n  .styles--secondary-button__secondaryLabel {\n    background: #f5f7fa; }\n";
var secondaryStyles = {"secondary":"styles--secondary-button__secondary","secondaryLabel":"styles--secondary-button__secondaryLabel","wiggle":"styles--secondary-button__wiggle","spin":"styles--secondary-button__spin"};
styleInject(css_248z$c);

var css_248z$d = "@-webkit-keyframes styles--tertiary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes styles--tertiary-button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes styles--tertiary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes styles--tertiary-button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.styles--tertiary-button__tertiary {\n  background-color: transparent;\n  color: #46597C; }\n  .styles--tertiary-button__tertiary:focus {\n    border-color: #c1b9f8;\n    outline: none; }\n  .styles--tertiary-button__tertiary:hover {\n    background-color: #f5f7fa; }\n  .styles--tertiary-button__tertiary:active {\n    background-color: #e7ecf3; }\n  .styles--tertiary-button__tertiaryLabel {\n    background: #f5f7fa; }\n";
var tertiaryStyles = {"tertiary":"styles--tertiary-button__tertiary","tertiaryLabel":"styles--tertiary-button__tertiaryLabel","wiggle":"styles--tertiary-button__wiggle","spin":"styles--tertiary-button__spin"};
styleInject(css_248z$d);

var sizeButtonClassNameMap = {
  normal: baseStyles.buttonNormal,
  large: baseStyles.buttonLarge
};
var variantButtonClassNameMap = {
  primary: primaryStyles.primary,
  secondary: secondaryStyles.secondary,
  tertiary: tertiaryStyles.tertiary,
  danger: dangerStyles.danger
};
var variantLabelClassNameMap = {
  primary: primaryStyles.primaryLabel,
  secondary: secondaryStyles.secondaryLabel,
  tertiary: tertiaryStyles.tertiaryLabel,
  danger: dangerStyles.dangerLabel
};

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Button.prototype.getClassName = function () {
    var _a;

    var _b = this.props,
        variant = _b.variant,
        size = _b.size,
        disabled = _b.disabled,
        isLoading = _b.isLoading,
        className = _b.className,
        label = _b.label;
    return classnames(baseStyles.button, variantButtonClassNameMap[variant], sizeButtonClassNameMap[size], (_a = {}, _a[baseStyles.buttonDisabled] = disabled, _a[baseStyles.buttonLoading] = isLoading, _a[baseStyles.buttonWithLabel] = Boolean(label), _a), className);
  };

  Button.prototype.render = function () {
    var _a = this.props,
        variant = _a.variant,
        size = _a.size,
        children = _a.children,
        className = _a.className,
        onClick = _a.onClick,
        disabled = _a.disabled,
        isLoading = _a.isLoading,
        type = _a.type,
        innerRef = _a.innerRef,
        label = _a.label,
        styleText = _a.styleText,
        loadingIndicator = _a.loadingIndicator,
        otherProps = __rest(_a, ["variant", "size", "children", "className", "onClick", "disabled", "isLoading", "type", "innerRef", "label", "styleText", "loadingIndicator"]);

    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      type: type,
      className: this.getClassName(),
      onClick: !disabled ? onClick : undefined,
      disabled: disabled,
      ref: innerRef
    }), isLoading ? loadingIndicator : /*#__PURE__*/React.createElement(React.Fragment, null, styleText ? /*#__PURE__*/React.createElement(Text.Paragraph, {
      as: "span",
      variant: "3",
      wrap: "nowrap",
      color: "inherit"
    }, children) : children, label && /*#__PURE__*/React.createElement(Text.Paragraph, {
      as: "span",
      variant: "4",
      wrap: "nowrap",
      color: "inherit",
      className: classnames(baseStyles.buttonLabel, variantLabelClassNameMap[variant])
    }, label)));
  };

  Button.defaultProps = {
    variant: 'primary',
    size: 'normal',
    type: 'button',
    disabled: false,
    isLoading: false,
    loadingIndicator: /*#__PURE__*/React.createElement(Text.Paragraph, {
      as: "span",
      variant: "3",
      wrap: "nowrap",
      color: "inherit"
    }, "Loading..."),
    styleText: true
  };
  return Button;
}(React.PureComponent);

var css_248z$e = "@-webkit-keyframes spinner--spinner__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes spinner--spinner__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes spinner--spinner__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes spinner--spinner__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.spinner--spinner__root {\n  border-radius: 50%;\n  border-style: solid;\n  border-color: #e7ecf3;\n  border-top-color: #5644d8;\n  -webkit-animation: spinner--spinner__spin 0.8s linear infinite;\n          animation: spinner--spinner__spin 0.8s linear infinite;\n  box-sizing: border-box; }\n";
var styles$7 = {"root":"spinner--spinner__root","spin":"spinner--spinner__spin","wiggle":"spinner--spinner__wiggle"};
styleInject(css_248z$e);

var Spinner =
/** @class */
function (_super) {
  __extends(Spinner, _super);

  function Spinner() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Spinner.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        size = _b.size,
        color = _b.color,
        trackColor = _b.trackColor,
        bgColor = _b.bgColor,
        otherProps = __rest(_b, ["className", "size", "color", "trackColor", "bgColor"]);

    var rootClass = classnames((_a = {}, _a[styles$7.root] = true, _a), className);
    var hwValue = typeof size === 'number' ? size : 32;
    var hwPixelValue = typeof size === 'number' ? hwValue + "px" : '32px';
    var borderSizePixelValue = Math.max(Math.floor(hwValue / 8), 1) + "px";
    var style = {
      height: hwPixelValue,
      width: hwPixelValue,
      borderWidth: borderSizePixelValue
    };

    if (trackColor && trackColor.length) {
      style.borderColor = trackColor;
    }

    if (color && color.length) {
      style.borderTopColor = color;
    }

    if (bgColor && bgColor.length) {
      style.backgroundColor = bgColor;
    }

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      style: style,
      className: rootClass
    }));
  };

  return Spinner;
}(PureComponent);

var css_248z$f = "@-webkit-keyframes iconButton--iconButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes iconButton--iconButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes iconButton--iconButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes iconButton--iconButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.iconButton--iconButton__iconButton {\n  padding: calc(8px - 2px); }\n\n.iconButton--iconButton__icon {\n  min-width: 16px; }\n";
var styles$8 = {"iconButton":"iconButton--iconButton__iconButton","icon":"iconButton--iconButton__icon","wiggle":"iconButton--iconButton__wiggle","spin":"iconButton--iconButton__spin"};
styleInject(css_248z$f);

var IconButton =
/** @class */
function (_super) {
  __extends(IconButton, _super);

  function IconButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IconButton.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        icon = _a.icon,
        iconProps = _a.iconProps,
        buttonProps = __rest(_a, ["children", "className", "icon", "iconProps"]);

    return /*#__PURE__*/React.createElement(Button, __assign({}, buttonProps, {
      className: classnames(styles$8.iconButton, className),
      loadingIndicator: /*#__PURE__*/React.createElement(Spinner, {
        size: 16
      }),
      styleText: false
    }), /*#__PURE__*/React.createElement(IconWithErrorBoundary, __assign({
      size: 16,
      name: icon,
      className: styles$8.icon
    }, iconProps)));
  };

  IconButton.defaultProps = {
    variant: 'primary'
  };
  return IconButton;
}(React.PureComponent);

var IconButtonWithErrorBoundary =
/** @class */
function (_super) {
  __extends(IconButtonWithErrorBoundary, _super);

  function IconButtonWithErrorBoundary() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IconButtonWithErrorBoundary.prototype.render = function () {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: null
    }, /*#__PURE__*/React.createElement(IconButton, __assign({}, this.props)));
  };

  IconButtonWithErrorBoundary.defaultProps = IconButton.defaultProps;
  return IconButtonWithErrorBoundary;
}(React.Component);

var IconButton$1 = hoistNonReactStatics_cjs(IconButtonWithErrorBoundary, IconButton);

var css_248z$g = "@-webkit-keyframes attachment--attachment__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes attachment--attachment__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes attachment--attachment__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes attachment--attachment__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.attachment--attachment__attachment {\n  display: inline-flex;\n  align-items: center;\n  background: #f5f7fa;\n  border-radius: 4px;\n  border: 1px solid #e7ecf3; }\n\n.attachment--attachment__icon {\n  color: #45587c;\n  margin: 12px 0 12px 8px; }\n\n.attachment--attachment__name {\n  font-size: 12px;\n  line-height: 16px;\n  color: #46597C;\n  padding: 8px; }\n\n.attachment--attachment__preview {\n  margin-right: 8px; }\n\n.attachment--attachment__download {\n  margin-right: 8px; }\n";
var styles$9 = {"attachment":"attachment--attachment__attachment","icon":"attachment--attachment__icon","name":"attachment--attachment__name","preview":"attachment--attachment__preview","download":"attachment--attachment__download","wiggle":"attachment--attachment__wiggle","spin":"attachment--attachment__spin"};
styleInject(css_248z$g);

var FILE_EXTENSION_TO_ICON = {
  /* images */
  jpg: 'file-image',
  jpeg: 'file-image',
  bmp: 'file-image',
  gif: 'file-image',
  tiff: 'file-image',
  png: 'file-image',

  /* video */
  mp4: 'file-video',
  m4v: 'file-video',
  mpeg: 'file-video',
  mov: 'file-video',
  avi: 'file-video',
  wmv: 'file-video',
  webm: 'file-video',
  flv: 'file-video',

  /* audio */
  wav: 'file-audio',
  mp3: 'file-audio',
  aiff: 'file-audio',
  acc: 'file-audio',
  ogg: 'file-audio',
  wma: 'file-audio',
  flac: 'file-audio',
  alac: 'file-audio',

  /* documents */
  pdf: 'file-pdf',
  csv: 'file-csv',
  doc: 'file-word',
  docx: 'file-word',
  xls: 'file-excel',
  xlsx: 'file-excel',
  ppt: 'file-powerpoint',
  pptx: 'file-powerpoint',

  /* archives */
  zip: 'file-archive',
  rar: 'file-archive',
  arc: 'file-archive',
  '7z': 'file-archive',
  s7z: 'file-archive',
  tar: 'file-archive',
  bz2: 'file-archive',
  gz: 'file-archive'
};

function getIconFromFileName(fileName) {
  var _a;

  var extension = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();

  if (!extension || !FILE_EXTENSION_TO_ICON[extension]) {
    return 'file';
  }

  return FILE_EXTENSION_TO_ICON[extension];
}

var Attachment =
/** @class */
function (_super) {
  __extends(Attachment, _super);

  function Attachment() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Attachment.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        fileName = _b.fileName,
        label = _b.label,
        onDownload = _b.onDownload,
        onPreview = _b.onPreview,
        isPreviewLoading = _b.isPreviewLoading,
        isDownloadLoading = _b.isDownloadLoading,
        otherProps = __rest(_b, ["className", "fileName", "label", "onDownload", "onPreview", "isPreviewLoading", "isDownloadLoading"]);

    var rootClass = classnames((_a = {}, _a[styles$9.attachment] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: classnames('icon-vertical-fix', styles$9.icon),
      name: getIconFromFileName(fileName),
      size: 24
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$9.name
    }, label || fileName), onPreview && /*#__PURE__*/React.createElement(IconButton$1, {
      isLoading: isPreviewLoading,
      variant: "secondary",
      className: styles$9.preview,
      icon: "eye",
      onClick: !isPreviewLoading ? onPreview : undefined
    }), onDownload && /*#__PURE__*/React.createElement(IconButton$1, {
      isLoading: isDownloadLoading,
      variant: "secondary",
      className: styles$9.download,
      icon: "download",
      onClick: !isDownloadLoading ? onDownload : undefined
    }));
  };

  return Attachment;
}(PureComponent);

var css_248z$h = "@-webkit-keyframes avatar--avatar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes avatar--avatar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes avatar--avatar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes avatar--avatar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.avatar--avatar__root {\n  border-radius: 4px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  overflow: hidden;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.avatar--avatar__avatar-24 {\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px;\n  height: 24px;\n  min-height: 24px;\n  max-height: 24px; }\n\n.avatar--avatar__avatar-32 {\n  width: 32px;\n  min-width: 32px;\n  max-width: 32px;\n  height: 32px;\n  min-height: 32px;\n  max-height: 32px; }\n\n.avatar--avatar__avatar-40 {\n  width: calc(4px * 10);\n  min-width: calc(4px * 10);\n  max-width: calc(4px * 10);\n  height: calc(4px * 10);\n  min-height: calc(4px * 10);\n  max-height: calc(4px * 10); }\n";
var styles$a = {"root":"avatar--avatar__root","avatar-24":"avatar--avatar__avatar-24","avatar-32":"avatar--avatar__avatar-32","avatar-40":"avatar--avatar__avatar-40","wiggle":"avatar--avatar__wiggle","spin":"avatar--avatar__spin"};
styleInject(css_248z$h);

var avatarSizeToIconSizeMap = {
  '24': 16,
  '32': 20,
  '40': 24
};
var IconAvatar = function IconAvatar(_a) {
  var icon = _a.icon,
      size = _a.size,
      _b = _a.color,
      color = _b === void 0 ? 'inherit' : _b;
  return /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
    name: icon,
    size: avatarSizeToIconSizeMap[size],
    color: color
  });
};

var css_248z$i = ".image--image__image {\n  transition: opacity 1s;\n  width: inherit;\n  opacity: 0; }\n\n.image--image__error {\n  opacity: 0; }\n\n.image--image__complete {\n  opacity: 1; }\n";
var styles$b = {"image":"image--image__image","error":"image--image__error","complete":"image--image__complete"};
styleInject(css_248z$i);

var Image =
/** @class */
function (_super) {
  __extends(Image, _super);

  function Image(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      imageSrc: '',
      loadingError: false,
      loadingComplete: false
    };
    _this.onLoad = _this.onLoad.bind(_this);
    _this.onError = _this.onError.bind(_this);
    _this.mounted = true;
    return _this;
  } // eslint-disable-next-line camelcase


  Image.prototype.UNSAFE_componentWillMount = function () {
    var src = this.props.src;
    this.handleSource(src);
  }; // eslint-disable-next-line camelcase


  Image.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
    var src = this.props.src;

    if (newProps.src !== src) {
      this.handleSource(newProps.src);
    }
  };

  Image.prototype.componentWillUnmount = function () {
    this.mounted = false;
  };

  Image.prototype.handleSource = function (src) {
    var _this = this;

    if (typeof src === 'string') {
      this.setState({
        imageSrc: src
      });
    } else {
      src().then(function (result) {
        if (_this.mounted) {
          _this.setState({
            imageSrc: result
          });
        }
      }).catch(function () {
        if (_this.mounted) {
          _this.setState({
            loadingError: true
          });
        }
      });
    }
  };

  Image.prototype.onLoad = function () {
    this.setState({
      loadingComplete: true,
      loadingError: false
    });
  };

  Image.prototype.onError = function () {
    this.setState({
      loadingError: true,
      loadingComplete: false
    });
  };

  Image.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        src = _b.src,
        alt = _b.alt,
        otherProps = __rest(_b, ["className", "src", "alt"]);

    var imageSrc = this.state.imageSrc;
    var _c = this.state,
        loadingError = _c.loadingError,
        loadingComplete = _c.loadingComplete;
    var rootClass = classnames((_a = {}, _a[styles$b.image] = true, _a[styles$b.error] = !!loadingError, _a[styles$b.complete] = !!loadingComplete, _a), className);
    return /*#__PURE__*/React.createElement("img", __assign({}, otherProps, {
      className: rootClass,
      onError: this.onError,
      onLoad: this.onLoad,
      src: imageSrc,
      alt: alt || ''
    }));
  };

  return Image;
}(React.Component);
Image.defaultProps = {
  className: '',
  alt: ''
};

var css_248z$j = ".components--imageAvatar__root {\n  width: 100%;\n  height: 100%;\n  text-align: center; }\n";
var styles$c = {"root":"components--imageAvatar__root"};
styleInject(css_248z$j);

var ImageAvatar = function ImageAvatar(_a) {
  var src = _a.src,
      _b = _a.alt,
      alt = _b === void 0 ? 'avatar' : _b;
  return /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt,
    className: styles$c.root
  });
};

var css_248z$k = "@-webkit-keyframes components--textAvatar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--textAvatar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--textAvatar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--textAvatar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--textAvatar__root {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: inherit;\n  text-align: center; }\n\n.components--textAvatar__avatar-24 {\n  font-size: 10px;\n  line-height: 16px;\n  font-weight: 600; }\n\n.components--textAvatar__avatar-32 {\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 600; }\n\n.components--textAvatar__avatar-40 {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  letter-spacing: -0.24px; }\n";
var styles$d = {"root":"components--textAvatar__root","avatar-24":"components--textAvatar__avatar-24","avatar-32":"components--textAvatar__avatar-32","avatar-40":"components--textAvatar__avatar-40","wiggle":"components--textAvatar__wiggle","spin":"components--textAvatar__spin"};
styleInject(css_248z$k);

var avatarSizeToClassNameMap = {
  '24': styles$d['avatar-24'],
  '32': styles$d['avatar-32'],
  '40': styles$d['avatar-40']
};
var TextAvatar = function TextAvatar(_a) {
  var _b = _a.text,
      text = _b === void 0 ? '' : _b,
      size = _a.size;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$d.root, avatarSizeToClassNameMap[size])
  }, text.trim().split(' ').map(function (subString, __, array) {
    return array.length === 1 ? subString : subString[0];
  }).join('').slice(0, 2));
};

var avatarColorOptions = [{
  contentColor: colors.green[900],
  backgroundColor: colors.green[200]
}, {
  contentColor: colors.purple[900],
  backgroundColor: colors.purple[200]
}, {
  contentColor: colors.blue[900],
  backgroundColor: colors.blue[200]
}, {
  contentColor: colors.orange[900],
  backgroundColor: colors.orange[200]
}, {
  contentColor: colors.red[900],
  backgroundColor: colors.red[200]
}];

var alea = createCommonjsModule(function (module) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -

// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



(function(global, module, define) {

function Alea(seed) {
  var me = this, mash = Mash();

  me.next = function() {
    var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
    me.s0 = me.s1;
    me.s1 = me.s2;
    return me.s2 = t - (me.c = t | 0);
  };

  // Apply the seeding algorithm from Baagoe.
  me.c = 1;
  me.s0 = mash(' ');
  me.s1 = mash(' ');
  me.s2 = mash(' ');
  me.s0 -= mash(seed);
  if (me.s0 < 0) { me.s0 += 1; }
  me.s1 -= mash(seed);
  if (me.s1 < 0) { me.s1 += 1; }
  me.s2 -= mash(seed);
  if (me.s2 < 0) { me.s2 += 1; }
  mash = null;
}

function copy(f, t) {
  t.c = f.c;
  t.s0 = f.s0;
  t.s1 = f.s1;
  t.s2 = f.s2;
  return t;
}

function impl(seed, opts) {
  var xg = new Alea(seed),
      state = opts && opts.state,
      prng = xg.next;
  prng.int32 = function() { return (xg.next() * 0x100000000) | 0; };
  prng.double = function() {
    return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
  };
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

function Mash() {
  var n = 0xefc8249d;

  var mash = function(data) {
    data = String(data);
    for (var i = 0; i < data.length; i++) {
      n += data.charCodeAt(i);
      var h = 0.02519603282416938 * n;
      n = h >>> 0;
      h -= n;
      h *= n;
      n = h >>> 0;
      h -= n;
      n += h * 0x100000000; // 2^32
    }
    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
  };

  return mash;
}


if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.alea = impl;
}

})(
  commonjsGlobal,
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

var xor128 = createCommonjsModule(function (module) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;

  // Set up generator function.
  me.next = function() {
    var t = me.x ^ (me.x << 11);
    me.x = me.y;
    me.y = me.z;
    me.z = me.w;
    return me.w ^= (me.w >>> 19) ^ t ^ (t >>> 8);
  };

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor128 = impl;
}

})(
  commonjsGlobal,
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

var xorwow = createCommonjsModule(function (module) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var t = (me.x ^ (me.x >>> 2));
    me.x = me.y; me.y = me.z; me.z = me.w; me.w = me.v;
    return (me.d = (me.d + 362437 | 0)) +
       (me.v = (me.v ^ (me.v << 4)) ^ (t ^ (t << 1))) | 0;
  };

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;
  me.v = 0;

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    if (k == strseed.length) {
      me.d = me.x << 10 ^ me.x >>> 4;
    }
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  t.v = f.v;
  t.d = f.d;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorwow = impl;
}

})(
  commonjsGlobal,
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

var xorshift7 = createCommonjsModule(function (module) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    // Update xor generator.
    var X = me.x, i = me.i, t, v;
    t = X[i]; t ^= (t >>> 7); v = t ^ (t << 24);
    t = X[(i + 1) & 7]; v ^= t ^ (t >>> 10);
    t = X[(i + 3) & 7]; v ^= t ^ (t >>> 3);
    t = X[(i + 4) & 7]; v ^= t ^ (t << 7);
    t = X[(i + 7) & 7]; t = t ^ (t << 13); v ^= t ^ (t << 9);
    X[i] = v;
    me.i = (i + 1) & 7;
    return v;
  };

  function init(me, seed) {
    var j, w, X = [];

    if (seed === (seed | 0)) {
      // Seed state array using a 32-bit integer.
      w = X[0] = seed;
    } else {
      // Seed state using a string.
      seed = '' + seed;
      for (j = 0; j < seed.length; ++j) {
        X[j & 7] = (X[j & 7] << 15) ^
            (seed.charCodeAt(j) + X[(j + 1) & 7] << 13);
      }
    }
    // Enforce an array length of 8, not all zeroes.
    while (X.length < 8) X.push(0);
    for (j = 0; j < 8 && X[j] === 0; ++j);
    if (j == 8) w = X[7] = -1; else w = X[j];

    me.x = X;
    me.i = 0;

    // Discard an initial 256 values.
    for (j = 256; j > 0; --j) {
      me.next();
    }
  }

  init(me, seed);
}

function copy(f, t) {
  t.x = f.x.slice();
  t.i = f.i;
  return t;
}

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.x) copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorshift7 = impl;
}

})(
  commonjsGlobal,
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

var xor4096 = createCommonjsModule(function (module) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    var w = me.w,
        X = me.X, i = me.i, t, v;
    // Update Weyl generator.
    me.w = w = (w + 0x61c88647) | 0;
    // Update xor generator.
    v = X[(i + 34) & 127];
    t = X[i = ((i + 1) & 127)];
    v ^= v << 13;
    t ^= t << 17;
    v ^= v >>> 15;
    t ^= t >>> 12;
    // Update Xor generator array state.
    v = X[i] = v ^ t;
    me.i = i;
    // Result is the combination.
    return (v + (w ^ (w >>> 16))) | 0;
  };

  function init(me, seed) {
    var t, v, i, j, w, X = [], limit = 128;
    if (seed === (seed | 0)) {
      // Numeric seeds initialize v, which is used to generates X.
      v = seed;
      seed = null;
    } else {
      // String seeds are mixed into v and X one character at a time.
      seed = seed + '\0';
      v = 0;
      limit = Math.max(limit, seed.length);
    }
    // Initialize circular array and weyl value.
    for (i = 0, j = -32; j < limit; ++j) {
      // Put the unicode characters into the array, and shuffle them.
      if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
      // After 32 shuffles, take v as the starting w value.
      if (j === 0) w = v;
      v ^= v << 10;
      v ^= v >>> 15;
      v ^= v << 4;
      v ^= v >>> 13;
      if (j >= 0) {
        w = (w + 0x61c88647) | 0;     // Weyl.
        t = (X[j & 127] ^= (v + w));  // Combine xor and weyl to init array.
        i = (0 == t) ? i + 1 : 0;     // Count zeroes.
      }
    }
    // We have detected all zeroes; make the key nonzero.
    if (i >= 128) {
      X[(seed && seed.length || 0) & 127] = -1;
    }
    // Run the generator 512 times to further mix the state before using it.
    // Factoring this as a function slows the main generator, so it is just
    // unrolled here.  The weyl generator is not advanced while warming up.
    i = 127;
    for (j = 4 * 128; j > 0; --j) {
      v = X[(i + 34) & 127];
      t = X[i = ((i + 1) & 127)];
      v ^= v << 13;
      t ^= t << 17;
      v ^= v >>> 15;
      t ^= t >>> 12;
      X[i] = v ^ t;
    }
    // Storing state as object members is faster than using closure variables.
    me.w = w;
    me.X = X;
    me.i = i;
  }

  init(me, seed);
}

function copy(f, t) {
  t.i = f.i;
  t.w = f.w;
  t.X = f.X.slice();
  return t;
}
function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.X) copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor4096 = impl;
}

})(
  commonjsGlobal,                                     // window object or global
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

var tychei = createCommonjsModule(function (module) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var b = me.b, c = me.c, d = me.d, a = me.a;
    b = (b << 25) ^ (b >>> 7) ^ c;
    c = (c - d) | 0;
    d = (d << 24) ^ (d >>> 8) ^ a;
    a = (a - b) | 0;
    me.b = b = (b << 20) ^ (b >>> 12) ^ c;
    me.c = c = (c - d) | 0;
    me.d = (d << 16) ^ (c >>> 16) ^ a;
    return me.a = (a - b) | 0;
  };

  /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */

  me.a = 0;
  me.b = 0;
  me.c = 2654435769 | 0;
  me.d = 1367130551;

  if (seed === Math.floor(seed)) {
    // Integer seed.
    me.a = (seed / 0x100000000) | 0;
    me.b = seed | 0;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 20; k++) {
    me.b ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.a = f.a;
  t.b = f.b;
  t.c = f.c;
  t.d = f.d;
  return t;
}
function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.tychei = impl;
}

})(
  commonjsGlobal,
   module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
});

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

var seedrandom = createCommonjsModule(function (module) {
(function (global, pool, math) {
//
// The following constants are related to IEEE 754 limits.
//

var width = 256,        // each RC4 output is 0 <= x < 256
    chunks = 6,         // at least six RC4 outputs for each double
    digits = 52,        // there are 52 significant digits in a double
    rngname = 'random', // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
    significance = math.pow(2, digits),
    overflow = significance * 2,
    mask = width - 1,
    nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
function seedrandom(seed, options, callback) {
  var key = [];
  options = (options == true) ? { entropy: true } : (options || {});

  // Flatten the seed string or build one from local entropy if needed.
  var shortseed = mixkey(flatten(
    options.entropy ? [seed, tostring(pool)] :
    (seed == null) ? autoseed() : seed, 3), key);

  // Use the seed to initialize an ARC4 generator.
  var arc4 = new ARC4(key);

  // This function returns a random double in [0, 1) that contains
  // randomness in every bit of the mantissa of the IEEE 754 value.
  var prng = function() {
    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
        d = startdenom,                 //   and denominator d = 2 ^ 48.
        x = 0;                          //   and no 'extra last byte'.
    while (n < significance) {          // Fill up all significant digits by
      n = (n + x) * width;              //   shifting numerator and
      d *= width;                       //   denominator and generating a
      x = arc4.g(1);                    //   new least-significant-byte.
    }
    while (n >= overflow) {             // To avoid rounding up, before adding
      n /= 2;                           //   last byte, shift everything
      d /= 2;                           //   right using integer math until
      x >>>= 1;                         //   we have exactly the desired bits.
    }
    return (n + x) / d;                 // Form the number within [0, 1).
  };

  prng.int32 = function() { return arc4.g(4) | 0; };
  prng.quick = function() { return arc4.g(4) / 0x100000000; };
  prng.double = prng;

  // Mix the randomness into accumulated entropy.
  mixkey(tostring(arc4.S), pool);

  // Calling convention: what to return as a function of prng, seed, is_math.
  return (options.pass || callback ||
      function(prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) { copy(state, arc4); }
          // Only provide the .state method if requested via options.state.
          prng.state = function() { return copy(arc4, {}); };
        }

        // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.
        if (is_math_call) { math[rngname] = prng; return seed; }

        // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(
  prng,
  shortseed,
  'global' in options ? options.global : (this == math),
  options.state);
}

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
function ARC4(key) {
  var t, keylen = key.length,
      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

  // The empty key [] is treated as [0].
  if (!keylen) { key = [keylen++]; }

  // Set up S using the standard key scheduling algorithm.
  while (i < width) {
    s[i] = i++;
  }
  for (i = 0; i < width; i++) {
    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
    s[j] = t;
  }

  // The "g" method returns the next (count) outputs as one number.
  (me.g = function(count) {
    // Using instance members instead of closure state nearly doubles speed.
    var t, r = 0,
        i = me.i, j = me.j, s = me.S;
    while (count--) {
      t = s[i = mask & (i + 1)];
      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
    }
    me.i = i; me.j = j;
    return r;
    // For robust unpredictability, the function call below automatically
    // discards an initial batch of values.  This is called RC4-drop[256].
    // See http://google.com/search?q=rsa+fluhrer+response&btnI
  })(width);
}

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
function copy(f, t) {
  t.i = f.i;
  t.j = f.j;
  t.S = f.S.slice();
  return t;
}
//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function flatten(obj, depth) {
  var result = [], typ = (typeof obj), prop;
  if (depth && typ == 'object') {
    for (prop in obj) {
      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
    }
  }
  return (result.length ? result : typ == 'string' ? obj : obj + '\0');
}

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function mixkey(seed, key) {
  var stringseed = seed + '', smear, j = 0;
  while (j < stringseed.length) {
    key[mask & j] =
      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
  }
  return tostring(key);
}

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
function autoseed() {
  try {
    var out;
    if (nodecrypto && (out = nodecrypto.randomBytes)) {
      // The use of 'out' to remember randomBytes makes tight minified code.
      out = out(width);
    } else {
      out = new Uint8Array(width);
      (global.crypto || global.msCrypto).getRandomValues(out);
    }
    return tostring(out);
  } catch (e) {
    var browser = global.navigator,
        plugins = browser && browser.plugins;
    return [+new Date, global, plugins, global.screen, tostring(pool)];
  }
}

//
// tostring()
// Converts an array of charcodes to a string
//
function tostring(a) {
  return String.fromCharCode.apply(0, a);
}

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//
if ( module.exports) {
  module.exports = seedrandom;
  // When in node.js, try using crypto package for autoseeding.
  try {
    nodecrypto = require$$0;
  } catch (ex) {}
} else {
  // When included as a plain script, set up Math.seedrandom global.
  math['seed' + rngname] = seedrandom;
}


// End anonymous scope, and pass initial values.
})(
  // global: `self` in browsers (including strict mode and web workers),
  // otherwise `this` in Node and other environments
  (typeof self !== 'undefined') ? self : commonjsGlobal,
  [],     // pool: entropy pool starts empty
  Math    // math: package containing random, pow, and seedrandom
);
});

// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.

// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.


// xor128, a pure xor-shift generator by George Marsaglia.
// Period: 2^128-1.
// Reported to fail: MatrixRank and LinearComp.


// xorwow, George Marsaglia's 160-bit xor-shift combined plus weyl.
// Period: 2^192-2^32
// Reported to fail: CollisionOver, SimpPoker, and LinearComp.


// xorshift7, by François Panneton and Pierre L'ecuyer, takes
// a different approach: it adds robustness by allowing more shifts
// than Marsaglia's original three.  It is a 7-shift generator
// with 256 bits, that passes BigCrush with no systmatic failures.
// Period 2^256-1.
// No systematic BigCrush failures reported.


// xor4096, by Richard Brent, is a 4096-bit xor-shift with a
// very long period that also adds a Weyl generator. It also passes
// BigCrush with no systematic failures.  Its long period may
// be useful if you have many generators and need to avoid
// collisions.
// Period: 2^4128-2^32.
// No systematic BigCrush failures reported.


// Tyche-i, by Samuel Neves and Filipe Araujo, is a bit-shifting random
// number generator derived from ChaCha, a modern stream cipher.
// https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
// Period: ~2^127
// No systematic BigCrush failures reported.


// The original ARC4-based prng included in this library.
// Period: ~2^1600


seedrandom.alea = alea;
seedrandom.xor128 = xor128;
seedrandom.xorwow = xorwow;
seedrandom.xorshift7 = xorshift7;
seedrandom.xor4096 = xor4096;
seedrandom.tychei = tychei;

var seedrandom$1 = seedrandom;

var RandomColorGenerator =
/** @class */
function () {
  function RandomColorGenerator(colors) {
    this.colors = colors;
    this.colors = colors;
  }

  RandomColorGenerator.prototype.generate = function (seed) {
    var randomIndex = this.getRandomIndex(seed);
    return this.colors[randomIndex];
  };

  RandomColorGenerator.prototype.getRandomIndex = function (seed) {
    var generateRandomNumber = seedrandom$1(seed);
    return Math.floor(generateRandomNumber() * this.colors.length);
  };

  return RandomColorGenerator;
}();

var AvatarTypes;

(function (AvatarTypes) {
  AvatarTypes["Icon"] = "Icon";
  AvatarTypes["Image"] = "Image";
  AvatarTypes["Text"] = "Text";
})(AvatarTypes || (AvatarTypes = {}));

function removeSpecialChars(value) {
  return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '');
}

function isValidString(value) {
  return !!value && value.trim().length !== 0;
}

function getAvatarTypeAndProps(props) {
  var _a, _b, _c, _d, _e, _f;

  if (props.icon) {
    return {
      type: AvatarTypes.Icon,
      icon: props.icon,
      backgroundColor: (_a = props.color) === null || _a === void 0 ? void 0 : _a.backgroundColor,
      iconColor: (_b = props.color) === null || _b === void 0 ? void 0 : _b.contentColor
    };
  }

  var user = props.user;

  if (!user) {
    return {
      type: AvatarTypes.Icon,
      icon: 'user-slash'
    };
  }

  if (isValidString(user.avatar_url)) {
    return {
      type: AvatarTypes.Image,
      src: user.avatar_url,
      alt: user.name || user.display_name || user.email || user.phone_number || user.given_name || user.family_name || ''
    };
  }

  if (isValidString(user.name)) {
    var words = removeSpecialChars(user.name.trim()).split(' '); // we have only one word in the name

    if (words.length === 1) {
      return {
        type: AvatarTypes.Text,
        text: (_d = (_c = words[0]) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : ''
      };
    } // we have more than one word


    var firstWord = words[0];
    var lastWord = words[words.length - 1];
    return {
      type: AvatarTypes.Text,
      text: ((_e = firstWord === null || firstWord === void 0 ? void 0 : firstWord[0]) !== null && _e !== void 0 ? _e : '') + ((_f = lastWord === null || lastWord === void 0 ? void 0 : lastWord[0]) !== null && _f !== void 0 ? _f : '')
    };
  }

  if (isValidString(user.display_name)) {
    return {
      type: AvatarTypes.Text,
      text: removeSpecialChars(user.display_name.trim())
    };
  }

  if (isValidString(user.given_name) && isValidString(user.family_name)) {
    return {
      type: AvatarTypes.Text,
      text: removeSpecialChars(user.given_name.trim())[0] + removeSpecialChars(user.family_name.trim())[0]
    };
  }

  if (isValidString(user.given_name) && !isValidString(user.family_name)) {
    return {
      type: AvatarTypes.Text,
      text: removeSpecialChars(user.given_name.trim())[0]
    };
  }

  if (!isValidString(user.given_name) && isValidString(user.family_name)) {
    return {
      type: AvatarTypes.Text,
      text: removeSpecialChars(user.family_name.trim())[0]
    };
  }

  if (isValidString(user.email)) {
    var accountName = user.email.split('@')[0];
    return {
      type: AvatarTypes.Text,
      text: accountName.trim()
    };
  }

  if (isValidString(user.phone_number)) {
    return {
      type: AvatarTypes.Text,
      text: user.phone_number.slice(-2)
    };
  }

  if (user.id) {
    return {
      type: AvatarTypes.Icon,
      icon: 'user-secret'
    };
  }

  return {
    type: AvatarTypes.Icon,
    icon: 'user-slash'
  };
}

var neutralColoredIcon = {
  backgroundColor: colors.neutral['200'],
  contentColor: colors.neutral['700']
};
var knownCustomColoredIcons = {
  shopify: {
    backgroundColor: 'rgba(148, 190, 69, 0.1)',
    contentColor: '#94BE45'
  },
  agillic: __assign(__assign({}, neutralColoredIcon), {
    contentColor: '#000'
  }),
  magento: {
    backgroundColor: 'rgba(193, 72, 0, 0.1)',
    contentColor: '#C14800'
  },
  salesforce: {
    backgroundColor: 'rgba(3, 161, 224, 0.1)',
    contentColor: '#03A1E0'
  },
  busylight: {
    backgroundColor: 'rgba(27, 190, 246, 0.1)',
    contentColor: '#1BBEF6'
  },
  podio: {
    backgroundColor: 'rgba(80, 145, 189, 0.1)',
    contentColor: '#5091BD'
  },
  'user-secret': neutralColoredIcon,
  'user-slash': neutralColoredIcon,
  'map-pin': neutralColoredIcon,
  'web-form': neutralColoredIcon,
  code: neutralColoredIcon,
  history: neutralColoredIcon,
  smile: neutralColoredIcon,
  key: neutralColoredIcon,
  webhooks: neutralColoredIcon,
  plug: neutralColoredIcon
};

var avatarSizeToClassNameMap$1 = {
  '24': styles$a['avatar-24'],
  '32': styles$a['avatar-32'],
  '40': styles$a['avatar-40']
};

var Avatar =
/** @class */
function (_super) {
  __extends(Avatar, _super);

  function Avatar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Avatar.prototype.getAvatarChild = function (typeAndProps, size) {
    if (typeAndProps.type === AvatarTypes.Icon) {
      return /*#__PURE__*/React.createElement(IconAvatar, {
        size: size,
        icon: typeAndProps.icon,
        color: typeAndProps.iconColor
      });
    }

    if (typeAndProps.type === AvatarTypes.Image) {
      return /*#__PURE__*/React.createElement(ImageAvatar, {
        src: typeAndProps.src,
        alt: typeAndProps.alt
      });
    }

    if (typeAndProps.type === AvatarTypes.Text) {
      return /*#__PURE__*/React.createElement(TextAvatar, {
        size: size,
        text: typeAndProps.text
      });
    }
  };

  Avatar.prototype.calculateColor = function (typeAndProps) {
    var _a;

    if (typeAndProps.type === AvatarTypes.Icon) {
      // if there's an icon with custom colors, it should override the random color
      if (typeAndProps.backgroundColor && typeAndProps.iconColor) {
        return {
          backgroundColor: typeAndProps.backgroundColor,
          contentColor: typeAndProps.iconColor
        };
      }

      if (knownCustomColoredIcons[typeAndProps.icon]) {
        return knownCustomColoredIcons[typeAndProps.icon];
      }
    }

    if (typeAndProps.type === AvatarTypes.Image) {
      return {
        backgroundColor: 'transparent',
        contentColor: 'initial'
      };
    }

    if ((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.id) {
      return this.props.colorGenerator.generate(this.props.user.id.toString());
    }

    if (this.props.icon) {
      return this.props.colorGenerator.generate(this.props.icon);
    }

    if (typeAndProps.type === AvatarTypes.Text) {
      return this.props.colorGenerator.generate(typeAndProps.text);
    }

    return this.props.colorGenerator.generate();
  };

  Avatar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        size = _a.size;
    var typeAndProps = getAvatarTypeAndProps(this.props);
    var child = this.getAvatarChild(typeAndProps, size);
    var color = this.calculateColor(typeAndProps);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: color.backgroundColor,
        color: color.contentColor
      },
      className: classnames(styles$a.root, avatarSizeToClassNameMap$1[size], className)
    }, child);
  };

  Avatar.defaultProps = {
    size: '32',
    colorGenerator: new RandomColorGenerator(avatarColorOptions)
  };
  return Avatar;
}(PureComponent);
var AvatarWithErrorBoundary = withErrorBoundary(Avatar, {
  fallback: null
});

var css_248z$l = "@-webkit-keyframes badge--badge__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes badge--badge__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes badge--badge__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes badge--badge__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.badge--badge__badge {\n  display: inline-block;\n  border-radius: 100px; }\n  .badge--badge__badgeSmall {\n    max-height: 16px;\n    padding: 0 8px;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 16px;\n    letter-spacing: 0.24px; }\n  .badge--badge__badgeMedium {\n    max-height: 24px;\n    padding: 4px 16px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    letter-spacing: -0.08px; }\n  .badge--badge__badgePrimary {\n    background-color: #f0f0ff;\n    color: #281c82; }\n  .badge--badge__badgeSecondary {\n    background-color: #f5f7fa;\n    color: #46597C; }\n  .badge--badge__badgeSuccess {\n    background-color: #dffbe9;\n    color: #196c39; }\n  .badge--badge__badgeInfo {\n    background-color: #e7f5fe;\n    color: #005893; }\n  .badge--badge__badgeWarning {\n    background-color: #ffeedd;\n    color: #a93900; }\n  .badge--badge__badgeError {\n    background-color: #fff2f2;\n    color: #b30908; }\n";
var styles$e = {"badge":"badge--badge__badge","badgeSmall":"badge--badge__badgeSmall","badgeMedium":"badge--badge__badgeMedium","badgePrimary":"badge--badge__badgePrimary","badgeSecondary":"badge--badge__badgeSecondary","badgeSuccess":"badge--badge__badgeSuccess","badgeInfo":"badge--badge__badgeInfo","badgeWarning":"badge--badge__badgeWarning","badgeError":"badge--badge__badgeError","wiggle":"badge--badge__wiggle","spin":"badge--badge__spin"};
styleInject(css_248z$l);

var sizeClassNameMap = {
  small: styles$e.badgeSmall,
  medium: styles$e.badgeMedium
};
var variantClassNameMap$3 = {
  primary: styles$e.badgePrimary,
  secondary: styles$e.badgeSecondary,
  success: styles$e.badgeSuccess,
  info: styles$e.badgeInfo,
  warning: styles$e.badgeWarning,
  error: styles$e.badgeError
};
var badgeTestId = 'badge';
function Badge(props) {
  var className = props.className,
      size = props.size,
      variant = props.variant,
      children = props.children,
      rest = __rest(props, ["className", "size", "variant", "children"]);

  var rootClass = classnames(styles$e.badge, sizeClassNameMap[size], variantClassNameMap$3[variant], className);
  return /*#__PURE__*/React.createElement("span", __assign({
    className: rootClass
  }, rest, {
    "data-testid": badgeTestId
  }), children);
}

var BodyPortal =
/** @class */
function (_super) {
  __extends(BodyPortal, _super);

  function BodyPortal(props) {
    var _this = _super.call(this, props) || this;

    _this.el = window.document.createElement('div');
    return _this;
  }

  BodyPortal.prototype.componentDidMount = function () {
    window.document.body.appendChild(this.el);
  };

  BodyPortal.prototype.componentWillUnmount = function () {
    window.document.body.removeChild(this.el);
  };

  BodyPortal.prototype.render = function () {
    var children = this.props.children;
    return /*#__PURE__*/_reactDom.createPortal(children, this.el);
  };

  return BodyPortal;
}(React.PureComponent);

var css_248z$m = "@charset \"UTF-8\";\n@-webkit-keyframes button--button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n@keyframes button--button__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes button--button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes button--button__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.button--button__button {\n  text-decoration: none;\n  padding: 8px;\n  height: 32px;\n  min-width: 100px;\n  flex: 0 0 auto;\n  line-height: 16px;\n  display: inline-flex;\n  align-items: center;\n  background-color: #5644d8;\n  border-radius: 4px;\n  color: #ffffff;\n  border: 0;\n  font-weight: 600;\n  font-size: 12px;\n  box-sizing: border-box;\n  justify-content: center;\n  white-space: nowrap;\n  cursor: pointer; }\n  .button--button__button:focus {\n    outline: none;\n    border: 2px solid #c1b9f8; }\n  .button--button__button.button--button__buttonForceHover, .button--button__button:hover {\n    background-color: #392aa7;\n    transition: background-color 0.15s linear; }\n  .button--button__button:active {\n    background-color: #281c82; }\n  .button--button__buttonSmall {\n    font-size: 12px;\n    line-height: 16px;\n    min-width: 0;\n    height: 24px;\n    padding: 4px 16px; }\n  .button--button__buttonLarge {\n    font-size: 14px;\n    line-height: 24px;\n    height: 40px;\n    min-width: 120px; }\n  .button--button__buttonXLarge {\n    font-size: 16px;\n    line-height: 32px;\n    height: 48px;\n    min-width: 140px;\n    padding-left: 16px;\n    padding-right: 16px; }\n  .button--button__buttonDanger {\n    background-color: #dc2626; }\n    .button--button__buttonDanger.button--button__buttonForceHover, .button--button__buttonDanger:hover {\n      background-color: #b21d1d; }\n    .button--button__buttonDanger:focus {\n      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3); }\n  .button--button__buttonWarning {\n    background-color: #fe8e00; }\n    .button--button__buttonWarning.button--button__buttonForceHover, .button--button__buttonWarning:hover {\n      background-color: #cb7100; }\n    .button--button__buttonWarning:focus {\n      box-shadow: 0 0 0 3px rgba(254, 142, 0, 0.3); }\n  .button--button__buttonSuccess {\n    background-color: #0aaf7a; }\n    .button--button__buttonSuccess.button--button__buttonForceHover, .button--button__buttonSuccess:hover {\n      background-color: #077f58; }\n    .button--button__buttonSuccess:focus {\n      box-shadow: 0 0 0 3px rgba(10, 175, 122, 0.3); }\n  .button--button__buttonInfo {\n    background-color: #0183fd; }\n    .button--button__buttonInfo.button--button__buttonForceHover, .button--button__buttonInfo:hover {\n      background-color: #0169ca; }\n    .button--button__buttonInfo:focus {\n      box-shadow: 0 0 0 3px rgba(1, 131, 253, 0.3); }\n  .button--button__buttonSecondary {\n    background-color: #f1f2f4;\n    color: #132244; }\n    .button--button__buttonSecondary.button--button__buttonForceHover, .button--button__buttonSecondary:hover {\n      background-color: #d4d7de;\n      background-color: #f5f7fa; }\n    .button--button__buttonSecondary:focus {\n      box-shadow: 0 0 0 3px rgba(90, 90, 90, 0.1);\n      border: 2px solid #c1b9f8; }\n    .button--button__buttonSecondary:active {\n      background-attachment: #e7ecf3; }\n  .button--button__buttonOutlined {\n    background-color: #fff;\n    border: 1px solid #5644d8;\n    color: #5644d8; }\n    .button--button__buttonOutlined.button--button__buttonForceHover, .button--button__buttonOutlined:hover {\n      background-color: #f5f5fa; }\n    .button--button__buttonOutlined.button--button__buttonSmall {\n      padding-top: 3px;\n      padding-bottom: 3px; }\n    .button--button__buttonOutlined.button--button__buttonSecondary {\n      border-color: #9b9b9b;\n      color: #9b9b9b;\n      background-color: #fff; }\n      .button--button__buttonOutlined.button--button__buttonSecondary.button--button__buttonForceHover, .button--button__buttonOutlined.button--button__buttonSecondary:hover {\n        background-color: rgba(130, 130, 130, 0.1); }\n    .button--button__buttonOutlined.button--button__buttonInfo {\n      border-color: #0183fd;\n      color: #0183fd; }\n      .button--button__buttonOutlined.button--button__buttonInfo.button--button__buttonForceHover, .button--button__buttonOutlined.button--button__buttonInfo:hover {\n        background-color: rgba(1, 105, 202, 0.06); }\n    .button--button__buttonOutlined.button--button__buttonSuccess {\n      border-color: #0aaf7a;\n      color: #0aaf7a; }\n      .button--button__buttonOutlined.button--button__buttonSuccess.button--button__buttonForceHover, .button--button__buttonOutlined.button--button__buttonSuccess:hover {\n        background-color: rgba(7, 127, 88, 0.06); }\n    .button--button__buttonOutlined.button--button__buttonWarning {\n      border-color: #fe8e00;\n      color: #fe8e00; }\n      .button--button__buttonOutlined.button--button__buttonWarning.button--button__buttonForceHover, .button--button__buttonOutlined.button--button__buttonWarning:hover {\n        background-color: rgba(203, 113, 0, 0.06); }\n    .button--button__buttonOutlined.button--button__buttonDanger {\n      border-color: #dc2626;\n      color: #dc2626; }\n      .button--button__buttonOutlined.button--button__buttonDanger.button--button__buttonForceHover, .button--button__buttonOutlined.button--button__buttonDanger:hover {\n        background-color: rgba(178, 29, 29, 0.06); }\n  .button--button__buttonNoText {\n    min-width: 0;\n    padding: 0;\n    width: 32px;\n    border-color: #fff; }\n    .button--button__buttonNoText.button--button__buttonOutlined {\n      border-color: #5644d8; }\n    .button--button__buttonNoText.button--button__buttonSmall {\n      width: 24px; }\n    .button--button__buttonNoText.button--button__buttonLarge {\n      width: 40px; }\n    .button--button__buttonNoText.button--button__buttonXLarge {\n      width: 48px; }\n  .button--button__buttonWithArrow.button--button__buttonNoText {\n    width: 38px; }\n  .button--button__buttonWide {\n    padding: 0 30px; }\n  .button--button__buttonDisabled, .button--button__button:disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.5; }\n  .button--button__buttonTransparent {\n    background: none;\n    color: #5644d8; }\n    .button--button__buttonTransparent.button--button__buttonSecondary {\n      color: #9b9b9b; }\n    .button--button__buttonTransparent.button--button__buttonInfo {\n      color: #0183fd; }\n    .button--button__buttonTransparent.button--button__buttonSuccess {\n      color: #0aaf7a; }\n    .button--button__buttonTransparent.button--button__buttonWarning {\n      color: #fe8e00; }\n    .button--button__buttonTransparent.button--button__buttonDanger {\n      color: #dc2626; }\n    .button--button__buttonTransparent.button--button__buttonForceHover, .button--button__buttonTransparent:hover {\n      background: none; }\n    .button--button__buttonTransparent.button--button__buttonDisabled, .button--button__buttonTransparent .button--button__button:disabled {\n      background: none;\n      color: #bbb; }\n  .button--button__buttonLoading {\n    cursor: not-allowed;\n    pointer-events: none;\n    position: relative;\n    background-clip: padding-box;\n    /* !importanté */\n    border-radius: 4px;\n    -webkit-animation: button--button__pulse 1.6s infinite ease-in-out;\n            animation: button--button__pulse 1.6s infinite ease-in-out; }\n    .button--button__buttonLoading.button--button__buttonOutlined {\n      cursor: not-allowed;\n      pointer-events: none;\n      position: relative;\n      background-clip: padding-box;\n      /* !importanté */\n      border: solid 1px transparent;\n      border-radius: 4px;\n      color: rgba(86, 68, 216, 0.6);\n      -webkit-animation: none;\n              animation: none; }\n      .button--button__buttonLoading.button--button__buttonOutlined::before {\n        -webkit-animation: button--button__loader 1s infinite ease;\n                animation: button--button__loader 1s infinite ease;\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: -1;\n        margin: -1px;\n        /* !importanté */\n        border-radius: inherit;\n        /* !importanté */\n        background-image: linear-gradient(to right, #5644d8, #eae8fd);\n        background-size: 200%; }\n      .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonDanger {\n        color: rgba(216, 72, 77, 0.6); }\n        .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonDanger::before {\n          background-image: linear-gradient(to right, #d8484d, #f2cbcc); }\n      .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonWarning {\n        color: rgba(234, 196, 53, 0.6); }\n        .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonWarning::before {\n          background-image: linear-gradient(to right, #eac435, #fcf2cf); }\n      .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonSecondary {\n        color: rgba(241, 242, 244, 0.6);\n        border: solid 1px transparent; }\n        .button--button__buttonLoading.button--button__buttonOutlined.button--button__buttonSecondary::before {\n          background-image: linear-gradient(to right, #f1f2f4, #f7f7f7); }\n\n.button--button__icon {\n  font-size: 16px;\n  display: flex;\n  align-items: center; }\n  .button--button__buttonOutlined .button--button__icon {\n    margin-top: -1px; }\n  .button--button__buttonIconPositionLeft .button--button__icon {\n    margin-right: 7px; }\n  .button--button__buttonIconPositionRight .button--button__icon {\n    margin-left: 7px; }\n  .button--button__buttonNoText .button--button__icon {\n    margin-right: 0;\n    margin-left: 0; }\n  .button--button__buttonSmall .button--button__icon {\n    font-size: 14px; }\n  .button--button__buttonSmall.button--button__buttonNoText .button--button__icon {\n    font-size: 16px; }\n  .button--button__buttonLarge .button--button__icon {\n    font-size: 16px; }\n  .button--button__buttonLarge.button--button__buttonNoText .button--button__icon {\n    font-size: 24px; }\n  .button--button__buttonXLarge .button--button__icon {\n    font-size: 18px; }\n  .button--button__buttonXLarge.button--button__buttonNoText .button--button__icon {\n    font-size: 32px; }\n\n.button--button__arrow {\n  font-size: 16px;\n  margin-right: -4px;\n  margin-left: 2px; }\n  .button--button__buttonWithArrow.button--button__buttonNoText .button--button__arrow {\n    margin-left: 0; }\n\n@-webkit-keyframes button--button__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n@keyframes button--button__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n@-webkit-keyframes button--button__pulseTxt {\n  0% {\n    color: rgba(86, 68, 216, 0.3); }\n  25% {\n    color: rgba(86, 68, 216, 0.3); }\n  50% {\n    color: rgba(86, 68, 216, 0.6); }\n  75% {\n    color: #5644d8; }\n  100% {\n    color: rgba(86, 68, 216, 0.3); } }\n\n@keyframes button--button__pulseTxt {\n  0% {\n    color: rgba(86, 68, 216, 0.3); }\n  25% {\n    color: rgba(86, 68, 216, 0.3); }\n  50% {\n    color: rgba(86, 68, 216, 0.6); }\n  75% {\n    color: #5644d8; }\n  100% {\n    color: rgba(86, 68, 216, 0.3); } }\n\n@-webkit-keyframes button--button__loader {\n  0% {\n    background-position: 0%; }\n  50% {\n    background-position: 50%; }\n  100% {\n    background-position: -100%; } }\n\n@keyframes button--button__loader {\n  0% {\n    background-position: 0%; }\n  50% {\n    background-position: 50%; }\n  100% {\n    background-position: -100%; } }\n";
var styles$f = {"button":"button--button__button","buttonForceHover":"button--button__buttonForceHover","buttonSmall":"button--button__buttonSmall","buttonLarge":"button--button__buttonLarge","buttonXLarge":"button--button__buttonXLarge","buttonDanger":"button--button__buttonDanger","buttonWarning":"button--button__buttonWarning","buttonSuccess":"button--button__buttonSuccess","buttonInfo":"button--button__buttonInfo","buttonSecondary":"button--button__buttonSecondary","buttonOutlined":"button--button__buttonOutlined","buttonNoText":"button--button__buttonNoText","buttonWithArrow":"button--button__buttonWithArrow","buttonWide":"button--button__buttonWide","buttonDisabled":"button--button__buttonDisabled","buttonTransparent":"button--button__buttonTransparent","buttonLoading":"button--button__buttonLoading","pulse":"button--button__pulse","loader":"button--button__loader","icon":"button--button__icon","buttonIconPositionLeft":"button--button__buttonIconPositionLeft","buttonIconPositionRight":"button--button__buttonIconPositionRight","arrow":"button--button__arrow","wiggle":"button--button__wiggle","spin":"button--button__spin","pulseTxt":"button--button__pulseTxt"};
styleInject(css_248z$m);

var ButtonSize;

(function (ButtonSize) {
  ButtonSize["small"] = "small";
  ButtonSize["medium"] = "medium";
  ButtonSize["large"] = "large";
  ButtonSize["xlarge"] = "xlarge";
})(ButtonSize || (ButtonSize = {}));

var ButtonColor;

(function (ButtonColor) {
  ButtonColor["default"] = "default";
  ButtonColor["secondary"] = "secondary";
  ButtonColor["transparent"] = "transparent";
  ButtonColor["info"] = "info";
  ButtonColor["success"] = "success";
  ButtonColor["warning"] = "warning";
  ButtonColor["danger"] = "danger";
})(ButtonColor || (ButtonColor = {}));

var ButtonIconPosition;

(function (ButtonIconPosition) {
  ButtonIconPosition["left"] = "left";
  ButtonIconPosition["right"] = "right";
})(ButtonIconPosition || (ButtonIconPosition = {}));

var deprecatedProps = ['danger', 'warning', 'secondary', 'icon', 'iconPosition', 'color', 'size', 'wide', 'outlined', 'small', 'transparent', 'arrow', 'arrowUp', 'useSVGIcon'];

var Button$1 =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button(props) {
    var _this = _super.call(this, props) || this;

    _this.getColor = function () {
      var _a = _this.props,
          color = _a.color,
          danger = _a.danger,
          warning = _a.warning,
          secondary = _a.secondary,
          transparent = _a.transparent;
      if (color && color in ButtonColor) return color;
      if (danger) return ButtonColor.danger;
      if (warning) return ButtonColor.warning;
      if (transparent) return ButtonColor.transparent;
      if (secondary) return ButtonColor.secondary;
      return ButtonColor.default;
    };

    _this.getSize = function () {
      var _a = _this.props,
          size = _a.size,
          small = _a.small;
      if (size && size in ButtonSize) return size;
      if (small) return ButtonSize.small;
      return ButtonSize.medium;
    };

    _this.buttonRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  Button.prototype.componentDidMount = function () {
    this.warnAboutDeprecatedProps();
  };

  Button.prototype.warnAboutDeprecatedProps = function () {
    var props = this.props;
    deprecatedProps.forEach(function (propName) {
      if (props[propName]) {
        if (!Button.warningDisplayed[propName]) {
          // eslint-disable-next-line no-console
          console.warn("Warning: Prop " + propName + " is deprecated on Button and will be removed soon. Please use the new Button.");
          Button.warningDisplayed[propName] = true;
        }
      }
    });
  };

  Button.prototype.focus = function () {
    if (this.buttonRef.current) {
      this.buttonRef.current.focus();
    }
  };

  Button.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        className = _c.className,
        onClick = _c.onClick,
        icon = _c.icon,
        iconPosition = _c.iconPosition,
        children = _c.children,
        notUsed = _c.color,
        deprecated1 = _c.danger,
        deprecated2 = _c.warning,
        deprecated3 = _c.secondary,
        transparent = _c.transparent,
        outlined = _c.outlined,
        deprecated5 = _c.small,
        notUsed2 = _c.size,
        arrow = _c.arrow,
        arrowUp = _c.arrowUp,
        disabled = _c.disabled,
        type = _c.type,
        component = _c.component,
        isLoading = _c.isLoading,
        forceHover = _c.forceHover,
        useSVGIcon = _c.useSVGIcon,
        otherProps = __rest(_c, ["className", "onClick", "icon", "iconPosition", "children", "color", "danger", "warning", "secondary", "transparent", "outlined", "small", "size", "arrow", "arrowUp", "disabled", "type", "component", "isLoading", "forceHover", "useSVGIcon"]);

    var color = this.getColor();
    var size = this.getSize();
    var isTransparent = transparent || color === ButtonColor.transparent;
    var rootClass = classnames((_a = {}, _a[styles$f.button] = true, _a[styles$f.buttonForceHover] = forceHover, _a[styles$f.buttonDanger] = color === ButtonColor.danger, _a[styles$f.buttonWarning] = color === ButtonColor.warning, _a[styles$f.buttonSecondary] = color === ButtonColor.secondary, _a[styles$f.buttonSuccess] = color === ButtonColor.success, _a[styles$f.buttonInfo] = color === ButtonColor.info, _a[styles$f.buttonOutlined] = outlined, _a[styles$f.buttonSmall] = size === ButtonSize.small, _a[styles$f.buttonLarge] = size === ButtonSize.large, _a[styles$f.buttonXLarge] = size === ButtonSize.xlarge, _a[styles$f.buttonTransparent] = isTransparent, _a[styles$f.buttonNoText] = !children && !component, _a[styles$f.buttonWithArrow] = arrow || arrowUp, _a[styles$f.buttonDisabled] = disabled, _a[styles$f.buttonLoading] = isLoading, _a[styles$f.buttonIconPositionLeft] = icon && iconPosition === ButtonIconPosition.left, _a[styles$f.buttonIconPositionRight] = icon && iconPosition === ButtonIconPosition.right, _a), className);

    if (component) {
      return /*#__PURE__*/React.cloneElement(component, {
        className: rootClass
      });
    }
    /** @TODO When Design fixes SVG exports for old icons so the strokes
     * don't bleed, we can remove this and always use SVG icons,
     * until then we have the option to use SVG when needed.  */


    var IconComponent = useSVGIcon ? IconWithErrorBoundary : DixaIcon;
    var iconCompProp = (_b = {}, _b[useSVGIcon ? 'name' : 'icon'] = icon, _b);
    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      type: type || 'button',
      className: rootClass,
      onClick: !disabled ? onClick : undefined,
      disabled: disabled,
      ref: this.buttonRef
    }), !!icon && iconPosition === ButtonIconPosition.left && /*#__PURE__*/React.createElement(IconComponent, __assign({}, iconCompProp, {
      className: styles$f.icon
    })), !isLoading && children, isLoading && /*#__PURE__*/React.createElement("span", null, "Loading..."), arrow && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-down",
      className: classnames('icon-vertical-fix', styles$f.arrow)
    }), arrowUp && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-up",
      className: classnames('icon-vertical-fix', styles$f.arrow)
    }), !!icon && iconPosition === ButtonIconPosition.right && /*#__PURE__*/React.createElement(IconComponent, __assign({}, iconCompProp, {
      className: styles$f.icon
    })));
  };

  Button.defaultProps = {
    type: 'button',
    iconPosition: 'left'
  };
  Button.warningDisplayed = {
    danger: false,
    warning: false,
    secondary: false,
    icon: false,
    iconPosition: false,
    color: false,
    size: false,
    wide: false,
    outlined: false,
    small: false,
    transparent: false,
    arrow: false,
    arrowUp: false,
    useSVGIcon: false
  };
  return Button;
}(PureComponent);

function Button$2(props) {
  function shouldRenderTheOldButton() {
    var oldButtonProps = ['icon', 'iconPosition', 'color', 'wide', 'danger', 'warning', 'secondary', 'outlined', 'small', 'transparent', 'arrow', 'arrowUp', 'component', 'forceHover', 'useSVGIcon'];
    var oldButtonPropIsUsed = Object.keys(props).some(function (prop) {
      return oldButtonProps.includes(prop);
    });
    return oldButtonPropIsUsed;
  }

  var fallback = /*#__PURE__*/React.createElement(Text.Paragraph, {
    variant: "2"
  }, "Something went wrong");

  if (shouldRenderTheOldButton()) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: fallback
    }, /*#__PURE__*/React.createElement(Button$1, __assign({}, props)));
  } else {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: fallback
    }, /*#__PURE__*/React.createElement(Button, __assign({}, props)));
  }
}

var css_248z$n = ".buttonGroup--buttonGroup__button {\n  position: relative;\n  z-index: 1;\n  border-radius: 0;\n  border-left-width: 0;\n  padding-left: 8px;\n  padding-right: 8px;\n  width: auto;\n  border-right-width: 1px;\n  border-right-style: solid; }\n  .buttonGroup--buttonGroup__button:focus {\n    z-index: 2; }\n  .buttonGroup--buttonGroup__button:first-child {\n    border-radius: 8px 0 0 8px;\n    border-left-width: 1px; }\n  .buttonGroup--buttonGroup__button:last-child {\n    border-radius: 0 8px 8px 0; }\n  .buttonGroup--buttonGroup__button:first-child:last-child {\n    border-radius: 8px; }\n";
var styles$g = {"button":"buttonGroup--buttonGroup__button"};
styleInject(css_248z$n);

var ButtonGroup =
/** @class */
function (_super) {
  __extends(ButtonGroup, _super);

  function ButtonGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ButtonGroup.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        otherProps = __rest(_a, ["className", "children"]);

    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, {
          className: classnames(child.className || '', styles$g.button)
        });
      }

      return child;
    }));
  };

  return ButtonGroup;
}(PureComponent);

var css_248z$o = "@-webkit-keyframes buttonList--buttonList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes buttonList--buttonList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes buttonList--buttonList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes buttonList--buttonList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.buttonList--buttonList__buttonList {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  background: #ffffff; }\n\n.buttonList--buttonList__inner {\n  margin: 0;\n  padding: 0; }\n";
var styles$h = {"buttonList":"buttonList--buttonList__buttonList","inner":"buttonList--buttonList__inner","wiggle":"buttonList--buttonList__wiggle","spin":"buttonList--buttonList__spin"};
styleInject(css_248z$o);

var css_248z$p = "@-webkit-keyframes divider--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes divider--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes divider--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes divider--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.divider--divider__divider {\n  display: block;\n  width: 100%;\n  padding: 1px;\n  background-color: #e7ecf3; }\n  .divider--divider__dividerXSmall {\n    height: 1px;\n    padding: 0; }\n  .divider--divider__dividerSmall {\n    padding: 1px;\n    width: 100%; }\n  .divider--divider__dividerMedium {\n    padding: 4px; }\n  .divider--divider__dividerVertical {\n    display: inline-block;\n    width: auto; }\n    .divider--divider__dividerVertical.divider--divider__dividerXSmall {\n      height: auto;\n      width: 1px;\n      border: 0;\n      padding: 0; }\n";
var styles$i = {"divider":"divider--divider__divider","dividerXSmall":"divider--divider__dividerXSmall","dividerSmall":"divider--divider__dividerSmall","dividerMedium":"divider--divider__dividerMedium","dividerVertical":"divider--divider__dividerVertical","wiggle":"divider--divider__wiggle","spin":"divider--divider__spin"};
styleInject(css_248z$p);

var Divider =
/** @class */
function (_super) {
  __extends(Divider, _super);

  function Divider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Divider.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        orientation = _b.orientation,
        size = _b.size,
        otherProps = __rest(_b, ["className", "orientation", "size"]);

    var rootClass = classnames((_a = {}, _a[styles$i.divider] = true, _a[styles$i.dividerXSmall] = size === 'xSmall', _a[styles$i.dividerSmall] = size === 'small', _a[styles$i.dividerMedium] = size === 'medium', _a[styles$i.dividerVertical] = orientation === 'vertical', _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }));
  };

  return Divider;
}(PureComponent);

var css_248z$q = "@-webkit-keyframes buttonList--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes buttonList--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes buttonList--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes buttonList--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.buttonList--divider__root {\n  display: block;\n  padding: 4px 0; }\n\n.buttonList--divider__divider {\n  background-color: #e7ecf3; }\n";
var styles$j = {"root":"buttonList--divider__root","divider":"buttonList--divider__divider","wiggle":"buttonList--divider__wiggle","spin":"buttonList--divider__spin"};
styleInject(css_248z$q);

var Divider$1 =
/** @class */
function (_super) {
  __extends(Divider$1, _super);

  function Divider$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Divider$1.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        otherProps = __rest(_a, ["className"]);

    var rootClass = classnames(styles$j.root, className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(Divider, {
      size: "xSmall",
      className: styles$j.divider
    }));
  };

  return Divider$1;
}(PureComponent);

var css_248z$r = "@-webkit-keyframes buttonList--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes buttonList--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes buttonList--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes buttonList--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n@-webkit-keyframes buttonList--header__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n@keyframes buttonList--header__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n.buttonList--header__header {\n  display: block;\n  text-align: center;\n  font-style: normal;\n  font-weight: 600;\n  padding: 8px;\n  cursor: default;\n  background-color: #f1f2f4;\n  font-size: 12px;\n  color: #7a7a7a;\n  position: relative;\n  white-space: nowrap;\n  border-radius: 3px; }\n";
var styles$k = {"header":"buttonList--header__header","wiggle":"buttonList--header__wiggle","spin":"buttonList--header__spin","pulse":"buttonList--header__pulse"};
styleInject(css_248z$r);

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Header.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        className = _b.className,
        otherProps = __rest(_b, ["children", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$k.header] = true, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return Header;
}(PureComponent);

var css_248z$s = "@-webkit-keyframes buttonList--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes buttonList--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes buttonList--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes buttonList--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.buttonList--item__item {\n  display: flex;\n  align-items: center;\n  position: relative;\n  min-width: 224px;\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .buttonList--item__item > a {\n    padding: 0;\n    color: inherit;\n    text-decoration: none; }\n    .buttonList--item__item > a::before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0; }\n\n.buttonList--item__icon {\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n  font-size: 16px; }\n\n.buttonList--item__button {\n  width: 100%;\n  white-space: nowrap;\n  padding: 8px 16px;\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  color: #263758;\n  background-color: transparent;\n  border: 0; }\n  .buttonList--item__button:not(.buttonList--item__buttonDisabled):hover {\n    background: #f5f7fa; }\n  .buttonList--item__button:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3);\n    z-index: 1; }\n  .buttonList--item__buttonIconPlaceholder {\n    padding-left: 49px; }\n  .buttonList--item__buttonLoading {\n    pointer-events: none;\n    cursor: not-allowed;\n    -webkit-animation: buttonList--item__pulse 1.6s infinite ease-in-out;\n            animation: buttonList--item__pulse 1.6s infinite ease-in-out; }\n  .buttonList--item__buttonDisabled {\n    pointer-events: none;\n    cursor: not-allowed;\n    opacity: 0.5; }\n\n@-webkit-keyframes buttonList--item__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n@keyframes buttonList--item__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n";
var styles$l = {"item":"buttonList--item__item","icon":"buttonList--item__icon","button":"buttonList--item__button","buttonDisabled":"buttonList--item__buttonDisabled","buttonIconPlaceholder":"buttonList--item__buttonIconPlaceholder","buttonLoading":"buttonList--item__buttonLoading","pulse":"buttonList--item__pulse","wiggle":"buttonList--item__wiggle","spin":"buttonList--item__spin"};
styleInject(css_248z$s);

var Item =
/** @class */
function (_super) {
  __extends(Item, _super);

  function Item() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Item.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        icon = _c.icon,
        children = _c.children,
        className = _c.className,
        isLoading = _c.isLoading,
        isDisabled = _c.isDisabled,
        iconPlaceholder = _c.iconPlaceholder,
        buttonClassName = _c.buttonClassName,
        buttonProps = _c.buttonProps,
        buttonOnClickhandler = _c.buttonOnClickhandler,
        otherProps = __rest(_c, ["icon", "children", "className", "isLoading", "isDisabled", "iconPlaceholder", "buttonClassName", "buttonProps", "buttonOnClickhandler"]);

    var rootClass = classnames((_a = {}, _a[styles$l.item] = true, _a), className);
    var buttonClass = classnames(styles$l.button, (_b = {}, _b[styles$l.buttonIconPlaceholder] = iconPlaceholder, _b[styles$l.buttonLoading] = isLoading, _b[styles$l.buttonDisabled] = isDisabled, _b), buttonClassName);
    var tabIndex = isDisabled ? {
      tabIndex: -1
    } : {};
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("button", __assign({}, tabIndex, buttonProps, {
      className: buttonClass,
      onClick: buttonOnClickhandler
    }), icon && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$l.icon,
      name: icon
    }), /*#__PURE__*/React.createElement(Text.Paragraph, {
      variant: "2"
    }, children)));
  };

  return Item;
}(PureComponent);

var ButtonList =
/** @class */
function (_super) {
  __extends(ButtonList, _super);

  function ButtonList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(ButtonList, "Item", {
    get: function get() {
      return Item;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonList, "Header", {
    get: function get() {
      return Header;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonList, "Divider", {
    get: function get() {
      return Divider$1;
    },
    enumerable: false,
    configurable: true
  });

  ButtonList.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        className = _b.className,
        otherProps = __rest(_b, ["children", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$h.buttonList] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("ul", {
      className: styles$h.inner
    }, children));
  };

  return ButtonList;
}(PureComponent);

var css_248z$t = "@-webkit-keyframes checkbox--checkbox__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes checkbox--checkbox__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes checkbox--checkbox__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes checkbox--checkbox__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkbox--checkbox__root {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  box-sizing: border-box;\n  border-radius: 4px; }\n  .checkbox--checkbox__root:active {\n    transform: scale(0.9); }\n  .checkbox--checkbox__rootDisabled {\n    opacity: 50%;\n    pointer-events: none; }\n\n.checkbox--checkbox__root:focus-within.checkbox--checkbox__rootChecked,\n.checkbox--checkbox__root:focus-within.checkbox--checkbox__rootIndeterminate {\n  box-shadow: 0 0 0 2px #c1b9f8; }\n\n.checkbox--checkbox__checkbox {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  color: #d7dfea;\n  border: 2px solid currentColor;\n  border-radius: 4px;\n  background: currentColor;\n  overflow: hidden;\n  transition: transform 0.1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  vertical-align: bottom;\n  box-sizing: border-box; }\n  .checkbox--checkbox__checkbox::after {\n    content: '';\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%) scale(1);\n    transition: transform 0.2s ease-out;\n    border-radius: 50%;\n    background-color: #ffffff; }\n  .checkbox--checkbox__checkbox::before {\n    content: '';\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    display: block;\n    transform: scale(0);\n    transition: transform 0.2s ease-in-out 0.05s;\n    position: relative; }\n  .checkbox--checkbox__rootChecked .checkbox--checkbox__checkbox,\n  .checkbox--checkbox__rootIndeterminate .checkbox--checkbox__checkbox {\n    color: #5644d8; }\n  .checkbox--checkbox__root:hover.checkbox--checkbox__rootChecked .checkbox--checkbox__checkbox,\n  .checkbox--checkbox__root:hover.checkbox--checkbox__rootIndeterminate .checkbox--checkbox__checkbox {\n    background-color: #392aa7;\n    border-color: #392aa7; }\n  .checkbox--checkbox__root:focus-within .checkbox--checkbox__checkbox {\n    border-color: #c1b9f8; }\n  .checkbox--checkbox__root:focus-within.checkbox--checkbox__rootChecked .checkbox--checkbox__checkbox,\n  .checkbox--checkbox__root:focus-within.checkbox--checkbox__rootIndeterminate .checkbox--checkbox__checkbox {\n    color: #392aa7;\n    border-color: #392aa7; }\n\n.checkbox--checkbox__root:hover .checkbox--checkbox__checkbox::after {\n  background-color: #f5f7fa; }\n\n.checkbox--checkbox__rootChecked .checkbox--checkbox__checkbox::after,\n.checkbox--checkbox__rootIndeterminate .checkbox--checkbox__checkbox::after {\n  transform: translate(-50%, -50%) scale(0); }\n\n.checkbox--checkbox__rootChecked .checkbox--checkbox__checkbox::before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNy43MDcxMSAwLjI5Mjg5M0M4LjA5NzYzIDAuNjgzNDE3IDguMDk3NjMgMS4zMTY1OCA3LjcwNzExIDEuNzA3MTFMMy43MDcxMSA1LjcwNzExQzMuMzE2NTggNi4wOTc2MyAyLjY4MzQyIDYuMDk3NjMgMi4yOTI4OSA1LjcwNzExTDAuMjkyODkzIDMuNzA3MTFDLTAuMDk3NjMxMSAzLjMxNjU4IC0wLjA5NzYzMTEgMi42ODM0MiAwLjI5Mjg5MyAyLjI5Mjg5QzAuNjgzNDE3IDEuOTAyMzcgMS4zMTY1OCAxLjkwMjM3IDEuNzA3MTEgMi4yOTI4OUwzIDMuNTg1NzlMNi4yOTI4OSAwLjI5Mjg5M0M2LjY4MzQyIC0wLjA5NzYzMTEgNy4zMTY1OCAtMC4wOTc2MzExIDcuNzA3MTEgMC4yOTI4OTNaIi8+Cjwvc3ZnPgo=);\n  transform: scale(1); }\n\n.checkbox--checkbox__rootIndeterminate .checkbox--checkbox__checkbox::before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEwIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMOSAwLjk5OTk5OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==);\n  transform: scale(1); }\n\n.checkbox--checkbox__input {\n  cursor: pointer;\n  position: absolute;\n  display: inline-block;\n  opacity: 0;\n  width: 20px;\n  height: 20px;\n  top: -2px;\n  left: -2px; }\n";
var styles$m = {"root":"checkbox--checkbox__root","rootDisabled":"checkbox--checkbox__rootDisabled","rootChecked":"checkbox--checkbox__rootChecked","rootIndeterminate":"checkbox--checkbox__rootIndeterminate","checkbox":"checkbox--checkbox__checkbox","input":"checkbox--checkbox__input","wiggle":"checkbox--checkbox__wiggle","spin":"checkbox--checkbox__spin"};
styleInject(css_248z$t);

var Checkbox =
/** @class */
function (_super) {
  __extends(Checkbox, _super);

  function Checkbox(props) {
    var _this = _super.call(this, props) || this;

    _this.inputRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  Checkbox.prototype.componentDidMount = function () {
    var inputElement = this.inputRef.current;

    if (inputElement) {
      inputElement.indeterminate = !!this.props.indeterminate;
    }
  };

  Checkbox.prototype.componentDidUpdate = function (prevProps) {
    var inputElement = this.inputRef.current;

    if (inputElement && prevProps.indeterminate !== this.props.indeterminate) {
      inputElement.indeterminate = !!this.props.indeterminate;
    }
  };

  Checkbox.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        onChange = _b.onChange,
        id = _b.id,
        name = _b.name,
        checked = _b.checked,
        indeterminate = _b.indeterminate,
        disabled = _b.disabled,
        otherProps = __rest(_b, ["className", "onChange", "id", "name", "checked", "indeterminate", "disabled"]);

    var rootClass = classnames((_a = {}, _a[styles$m.root] = true, _a[styles$m.rootDisabled] = disabled, _a[styles$m.rootChecked] = checked, _a[styles$m.rootIndeterminate] = indeterminate, _a), className);
    var fieldId = id || "checkbox_" + Math.random();
    return /*#__PURE__*/React.createElement("span", __assign({
      className: rootClass,
      "data-testid": "habla-checkbox"
    }, otherProps), /*#__PURE__*/React.createElement("span", {
      role: "checkbox",
      "aria-checked": indeterminate ? 'mixed' : checked,
      className: styles$m.checkbox
    }), /*#__PURE__*/React.createElement("input", {
      id: fieldId,
      type: "checkbox",
      "aria-hidden": "true",
      name: name,
      className: styles$m.input,
      onChange: onChange,
      checked: checked,
      disabled: disabled,
      ref: this.inputRef
    }));
  };

  return Checkbox;
}(PureComponent);

var css_248z$u = "@-webkit-keyframes collapseCard--collapseCard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes collapseCard--collapseCard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes collapseCard--collapseCard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes collapseCard--collapseCard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.collapseCard--collapseCard__card {\n  border-radius: 4px;\n  background: #ffffff;\n  padding: 0 24px; }\n";
var styles$n = {"card":"collapseCard--collapseCard__card","wiggle":"collapseCard--collapseCard__wiggle","spin":"collapseCard--collapseCard__spin"};
styleInject(css_248z$u);

var CollapseCardContext = /*#__PURE__*/React.createContext({
  isOpen: false,
  onToggle: noop$1
});

var css_248z$v = "@-webkit-keyframes components--content__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--content__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--content__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--content__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--content__content {\n  display: none;\n  padding: 0;\n  margin: 0;\n  list-style-type: none; }\n  .components--content__contentIsOpen {\n    display: block; }\n";
var styles$o = {"content":"components--content__content","contentIsOpen":"components--content__contentIsOpen","wiggle":"components--content__wiggle","spin":"components--content__spin"};
styleInject(css_248z$v);

var Content =
/** @class */
function (_super) {
  __extends(Content, _super);

  function Content() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Content.prototype.getRootClassName = function (isOpen) {
    var _a;

    return classnames(styles$o.content, this.props.className, (_a = {}, _a[styles$o.contentIsOpen] = isOpen, _a));
  };

  Content.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        otherProps = __rest(_a, ["children", "className"]);

    return /*#__PURE__*/React.createElement(CollapseCardContext.Consumer, null, function (_a) {
      var isOpen = _a.isOpen;
      if (!isOpen) return null;
      return /*#__PURE__*/React.createElement("ul", __assign({}, otherProps, {
        className: _this.getRootClassName(isOpen),
        "data-testid": "content"
      }), children);
    });
  };

  Content.displayName = 'CollapseCard.Content';
  return Content;
}(PureComponent);

function buttonize(fn) {
  return {
    role: 'button',
    onClick: fn,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        fn(e);
      }
    }
  };
}

var css_248z$w = "@-webkit-keyframes dropdown--dropdown__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes dropdown--dropdown__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes dropdown--dropdown__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dropdown--dropdown__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dropdown--dropdown__dropdown {\n  position: absolute;\n  display: none;\n  top: 100%;\n  left: 0;\n  margin-top: 8px;\n  z-index: 100;\n  box-sizing: border-box;\n  background: #ffffff;\n  border-radius: 4px;\n  border: 1px solid #e7ecf3;\n  box-shadow: 0px 4px 8px 0px rgba(97, 118, 152, 0.04), 0px 8px 16px 0px rgba(97, 118, 152, 0.1);\n  transition: none 0.2s ease-in-out;\n  transition-property: width, height; }\n  .dropdown--dropdown__dropdown > * {\n    transition: opacity 0.15s ease-in-out; }\n  .dropdown--dropdown__dropdownOpen {\n    display: block; }\n  .dropdown--dropdown__dropdownFromRight {\n    left: auto;\n    right: 0; }\n  .dropdown--dropdown__dropdownFromBottom {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: 8px; }\n  .dropdown--dropdown__dropdownAnimating > * {\n    transition: none;\n    opacity: 0; }\n  .dropdown--dropdown__dropdownFixed {\n    right: auto;\n    bottom: auto;\n    position: fixed; }\n\n.dropdown--dropdown__loader {\n  width: 100px;\n  height: 100px;\n  background-image: url(\"data:image/gif;base64,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\");\n  background-repeat: no-repeat;\n  background-position: center; }\n\n.dropdown--dropdown__error {\n  padding: 20px;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #d8484d;\n  text-align: center;\n  min-width: 200px; }\n\n.dropdown--dropdown__errorIcon {\n  font-size: 24px; }\n";
var styles$p = {"dropdown":"dropdown--dropdown__dropdown","dropdownOpen":"dropdown--dropdown__dropdownOpen","dropdownFromRight":"dropdown--dropdown__dropdownFromRight","dropdownFromBottom":"dropdown--dropdown__dropdownFromBottom","dropdownAnimating":"dropdown--dropdown__dropdownAnimating","dropdownFixed":"dropdown--dropdown__dropdownFixed","loader":"dropdown--dropdown__loader","error":"dropdown--dropdown__error","errorIcon":"dropdown--dropdown__errorIcon","wiggle":"dropdown--dropdown__wiggle","spin":"dropdown--dropdown__spin"};
styleInject(css_248z$w);

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      fromRight: false,
      fromBottom: false,
      width: null,
      height: null,
      animating: false
    };
    _this.timeoutAnimationStart = undefined;
    _this.timeoutAnimationEnd = undefined;
    _this.dropdownRef = /*#__PURE__*/React.createRef();
    _this.handleClickOutsideDropdown = _this.handleClickOutsideDropdown.bind(_this);
    _this.handleFixedScroll = _this.handleFixedScroll.bind(_this);
    _this.handleOnClose = _this.handleOnClose.bind(_this);
    return _this;
  }

  Dropdown.prototype.componentDidMount = function () {
    this.calculatePosition();
  };

  Dropdown.prototype.getSnapshotBeforeUpdate = function () {
    if (this.dropdownRef.current) {
      var bounds = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: bounds.width,
        oldHeight: bounds.height
      };
    }

    return null;
  };

  Dropdown.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    var _a = this.props,
        isOpen = _a.isOpen,
        isLoading = _a.isLoading,
        errorMessage = _a.errorMessage,
        fixed = _a.fixed,
        closeOnBlur = _a.closeOnBlur;

    if (snapshot && (isLoading !== prevProps.isLoading || errorMessage !== prevProps.errorMessage)) {
      var startedLoading = isLoading !== prevProps.isLoading && isLoading;
      this.animate(snapshot.oldWidth, snapshot.oldHeight, startedLoading);
    }

    if (isOpen) this.calculatePosition();

    if (isOpen !== prevProps.isOpen) {
      window[isOpen ? 'addEventListener' : 'removeEventListener']('click', this.handleClickOutsideDropdown);

      if (closeOnBlur) {
        window[isOpen ? 'addEventListener' : 'removeEventListener']('blur', this.handleOnClose);
      } // If we're using fixed position, we need to move the dropdown on scroll


      if (fixed) {
        window[isOpen ? 'addEventListener' : 'removeEventListener']('scroll', this.handleFixedScroll, true);
      }
    }
  };

  Dropdown.prototype.componentWillUnmount = function () {
    window.removeEventListener('click', this.handleClickOutsideDropdown);
    window.removeEventListener('scroll', this.handleFixedScroll);
    window.removeEventListener('blur', this.handleOnClose);
    window.clearInterval(this.timeoutAnimationStart);
    window.clearInterval(this.timeoutAnimationEnd);
  };

  Dropdown.prototype.handleOnClose = function () {
    var onClose = this.props.onClose;
    onClose();
  };

  Dropdown.prototype.animate = function (oldWidth, oldHeight, dontAnimate) {
    var _this = this;

    if (this.dropdownRef.current) {
      var bounds_1 = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: oldWidth,
        height: oldHeight,
        animating: !dontAnimate
      });
      this.timeoutAnimationStart = window.setTimeout(function () {
        _this.setState({
          width: bounds_1.width,
          height: bounds_1.height
        });

        _this.timeoutAnimationEnd = window.setTimeout(function () {
          _this.setState({
            width: null,
            height: null,
            animating: false
          });
        }, 200);
      });
    }
  };

  Dropdown.prototype.handleClickOutsideDropdown = function (event) {
    if (!this.dropdownRef || !(event.target instanceof Node)) return;
    var onClose = this.props.onClose;

    if (this.dropdownRef.current && event.target !== this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      onClose();
    }
  };

  Dropdown.prototype.handleFixedScroll = function () {
    this.forceUpdate();
  };

  Dropdown.prototype.calculatePosition = function () {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      var edges = this.dropdownRef.current.parentElement.getBoundingClientRect();
      var triggerCenterX = edges.left + edges.width / 2;
      var triggerCenterY = edges.top + edges.height / 2;
      var windowCenterX = window.innerWidth / 2;
      var windowCenterY = window.innerHeight / 2;
      this.setState({
        fromRight: triggerCenterX > windowCenterX,
        fromBottom: triggerCenterY > windowCenterY
      });
    }
  };

  Dropdown.prototype.handleOnClick = function (e) {
    e.stopPropagation();
  };

  Dropdown.prototype.getFixedPosition = function () {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      var _a = this.state,
          fromRight = _a.fromRight,
          fromBottom = _a.fromBottom;
      var bounds = this.dropdownRef.current.parentElement.getBoundingClientRect();
      var position = {};

      if (fromRight) {
        position.right = window.innerWidth - bounds.right + "px";
      } else {
        position.left = bounds.left + "px";
      }

      if (fromBottom) {
        position.bottom = window.innerHeight - bounds.top + "px";
      } else {
        position.top = bounds.top + bounds.height + "px";
      }

      return position;
    }

    return {};
  };

  Dropdown.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        onClose = _b.onClose,
        isOpen = _b.isOpen,
        isLoading = _b.isLoading,
        closeOnBlur = _b.closeOnBlur,
        errorMessage = _b.errorMessage,
        fixed = _b.fixed,
        style = _b.style,
        otherProps = __rest(_b, ["className", "children", "onClose", "isOpen", "isLoading", "closeOnBlur", "errorMessage", "fixed", "style"]);

    var _c = this.state,
        fromRight = _c.fromRight,
        fromBottom = _c.fromBottom,
        animating = _c.animating,
        width = _c.width,
        height = _c.height;
    var rootClass = classnames((_a = {}, _a[styles$p.dropdown] = true, _a[styles$p.dropdownOpen] = isOpen, _a[styles$p.dropdownFromRight] = fromRight, _a[styles$p.dropdownFromBottom] = fromBottom, _a[styles$p.dropdownAnimating] = animating, _a[styles$p.dropdownFixed] = fixed, _a), className);

    var styleOverrides = __assign({}, style);

    if (width && height) {
      styleOverrides.width = width + "px";
      styleOverrides.height = height + "px";
    }

    if (fixed) {
      styleOverrides = __assign(__assign({}, styleOverrides), this.getFixedPosition());
    }

    var showContent = !isLoading && !errorMessage;
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      ref: this.dropdownRef,
      style: styleOverrides,
      onClick: this.handleOnClick
    }), isLoading && /*#__PURE__*/React.createElement("div", {
      className: styles$p.loader
    }), !!errorMessage && !isLoading && /*#__PURE__*/React.createElement("div", {
      className: styles$p.error
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$p.errorIcon,
      name: "exclamation"
    }), /*#__PURE__*/React.createElement("span", null, errorMessage)), showContent && children);
  };

  Dropdown.defaultProps = {
    onClose: function onClose() {
      /* do nothing */
    },
    closeOnBlur: true
  };
  return Dropdown;
}(PureComponent);

var css_248z$x = "@-webkit-keyframes dropdownButton--dropdownButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes dropdownButton--dropdownButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes dropdownButton--dropdownButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dropdownButton--dropdownButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dropdownButton--dropdownButton__root {\n  display: inline-flex;\n  position: relative; }\n\n.dropdownButton--dropdownButton__wrapper {\n  position: relative;\n  display: inline-flex; }\n\n.dropdownButton--dropdownButton__button:active, .dropdownButton--dropdownButton__buttonActive {\n  background-color: #f5f7fa; }\n\n.dropdownButton--dropdownButton__buttonWithArrow {\n  padding-right: 8px; }\n  .dropdownButton--dropdownButton__buttonWithArrow > :first-child {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    grid-auto-flow: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    justify-items: center;\n    grid-gap: 4px; }\n";
var styles$q = {"root":"dropdownButton--dropdownButton__root","wrapper":"dropdownButton--dropdownButton__wrapper","button":"dropdownButton--dropdownButton__button","buttonActive":"dropdownButton--dropdownButton__buttonActive","buttonWithArrow":"dropdownButton--dropdownButton__buttonWithArrow","wiggle":"dropdownButton--dropdownButton__wiggle","spin":"dropdownButton--dropdownButton__spin"};
styleInject(css_248z$x);

var DropdownButtonContext = /*#__PURE__*/React.createContext({
  toggleDropdown: noop$1,
  openDropdown: noop$1,
  closeDropdown: noop$1,
  dropdownOpen: false
});

var DropdownButton =
/** @class */
function (_super) {
  __extends(DropdownButton, _super);

  function DropdownButton(props) {
    var _a;

    var _this = _super.call(this, props) || this;

    var dropdownInitiallyOpen = (_a = props.show) !== null && _a !== void 0 ? _a : false;
    _this.state = {
      dropdownOpen: dropdownInitiallyOpen,
      pristine: true,
      fromBottom: false
    };
    _this.timeoutId = null;
    _this.buttonRef = /*#__PURE__*/React.createRef();
    _this.handleDropdownToggle = _this.handleDropdownToggle.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.open = _this.open.bind(_this);
    _this.contextState = {
      toggleDropdown: _this.close,
      openDropdown: _this.open,
      closeDropdown: _this.close,
      dropdownOpen: dropdownInitiallyOpen
    };
    return _this;
  }

  DropdownButton.prototype.componentDidMount = function () {
    this.setState({
      fromBottom: this.shouldDropdownBeAboveButton()
    });
  };

  DropdownButton.prototype.componentDidUpdate = function (prevProps) {
    this.toggleDropdownIfNeeded(prevProps);
  };

  DropdownButton.prototype.componentWillUnmount = function () {
    if (this.timeoutId) {
      window.clearInterval(this.timeoutId);
    }
  };

  DropdownButton.prototype.shouldToggleDropdown = function (prevProps) {
    return prevProps.show !== this.props.show;
  };

  DropdownButton.prototype.toggleDropdownIfNeeded = function (prevProps) {
    if (this.shouldToggleDropdown(prevProps)) {
      if (this.props.show) {
        this.open();
      } else {
        this.close();
      }
    }
  };

  DropdownButton.prototype.handleDropdownToggle = function () {
    var _this = this;

    var _a = this.state,
        dropdownOpen = _a.dropdownOpen,
        pristine = _a.pristine;
    var onToggle = this.props.onToggle;

    var callToggleCallbacks = function callToggleCallbacks() {
      _this.timeoutId = setTimeout(function () {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!dropdownOpen, pristine);
        _this.contextState = __assign(__assign({}, _this.contextState), {
          dropdownOpen: !dropdownOpen
        });

        _this.setState({
          dropdownOpen: !dropdownOpen,
          pristine: false
        });
      });
    };

    var shouldRenderAboveButton = this.shouldDropdownBeAboveButton();

    if (!dropdownOpen) {
      this.setState({
        fromBottom: shouldRenderAboveButton
      }, callToggleCallbacks);
    } else {
      callToggleCallbacks();
    }
  };

  DropdownButton.prototype.handleClose = function () {
    var onToggle = this.props.onToggle;
    this.close();
    onToggle === null || onToggle === void 0 ? void 0 : onToggle(false, false);
  };

  DropdownButton.prototype.close = function () {
    this.contextState = __assign(__assign({}, this.contextState), {
      dropdownOpen: false
    });
    this.setState({
      dropdownOpen: false
    });
  };

  DropdownButton.prototype.open = function () {
    this.contextState = __assign(__assign({}, this.contextState), {
      dropdownOpen: true
    });
    this.setState({
      dropdownOpen: true
    });
  };

  DropdownButton.prototype.shouldDropdownBeAboveButton = function () {
    var _a;

    var edges = (_a = this.buttonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    return edges ? edges.bottom > window.innerHeight / 2 : false;
  };

  DropdownButton.prototype.renderTheTriggerButton = function () {
    var _a, _b;

    var _c = this.props,
        icon = _c.icon,
        buttonProps = _c.buttonProps,
        children = _c.children,
        noArrow = _c.noArrow,
        noStyle = _c.noStyle;
    var _d = this.state,
        fromBottom = _d.fromBottom,
        dropdownOpen = _d.dropdownOpen;

    if (noStyle) {
      return /*#__PURE__*/React.createElement("div", __assign({}, buttonize(this.handleDropdownToggle)), children);
    }

    if (icon) {
      return /*#__PURE__*/React.createElement(IconButton$1, __assign({
        icon: icon,
        variant: "secondary",
        className: classnames(styles$q.button, (_a = {}, _a[styles$q.buttonActive] = dropdownOpen, _a))
      }, buttonProps, {
        onClick: this.handleDropdownToggle
      }));
    }

    return /*#__PURE__*/React.createElement(Button, __assign({
      className: classnames(styles$q.button, (_b = {}, _b[styles$q.buttonActive] = dropdownOpen, _b[styles$q.buttonWithArrow] = !noArrow, _b)),
      variant: "secondary"
    }, buttonProps, {
      onClick: this.handleDropdownToggle
    }), children, !noArrow && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      size: 16,
      name: fromBottom ? 'angle-up' : 'angle-down'
    }));
  };

  DropdownButton.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        icon = _b.icon,
        dropdown = _b.dropdown,
        buttonProps = _b.buttonProps,
        dropdownProps = _b.dropdownProps,
        noArrow = _b.noArrow,
        noStyle = _b.noStyle,
        show = _b.show,
        onToggle = _b.onToggle,
        isLoading = _b.isLoading,
        errorMessage = _b.errorMessage,
        fixed = _b.fixed,
        divProps = __rest(_b, ["className", "children", "icon", "dropdown", "buttonProps", "dropdownProps", "noArrow", "noStyle", "show", "onToggle", "isLoading", "errorMessage", "fixed"]);

    var _c = this.state,
        dropdownOpen = _c.dropdownOpen,
        pristine = _c.pristine;
    var rootClass = classnames((_a = {}, _a[styles$q.root] = styles$q.root, _a), className);
    return /*#__PURE__*/React.createElement(DropdownButtonContext.Provider, {
      value: this.contextState
    }, /*#__PURE__*/React.createElement("div", __assign({}, divProps, {
      className: rootClass,
      ref: this.buttonRef
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$q.wrapper
    }, this.renderTheTriggerButton(), /*#__PURE__*/React.createElement(Dropdown, __assign({}, dropdownProps, {
      isOpen: dropdownOpen,
      onClose: this.handleClose,
      isLoading: isLoading,
      errorMessage: errorMessage,
      fixed: fixed
    }), (dropdownOpen || !pristine) && dropdown))));
  };

  return DropdownButton;
}(Component);

var FlexBox =
/** @class */
function (_super) {
  __extends(FlexBox, _super);

  function FlexBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FlexBox.prototype.render = function () {
    var _a = this.props,
        flexWrap = _a.flexWrap,
        flexDirection = _a.flexDirection,
        justifyItems = _a.justifyItems,
        justifyContent = _a.justifyContent,
        alignItems = _a.alignItems,
        alignContent = _a.alignContent,
        style = _a.style,
        otherProps = __rest(_a, ["flexWrap", "flexDirection", "justifyItems", "justifyContent", "alignItems", "alignContent", "style"]);

    var styleObj = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, flexWrap && {
      flexWrap: flexWrap
    }), flexDirection && {
      flexDirection: flexDirection
    }), justifyItems && {
      justifyItems: justifyItems
    }), justifyContent && {
      justifyContent: justifyContent
    }), alignItems && {
      alignItems: alignItems
    }), alignContent && {
      alignContent: alignContent
    }), {
      display: 'flex'
    }), style);

    return /*#__PURE__*/React.createElement(Box, __assign({}, otherProps, {
      style: styleObj
    }), this.props.children);
  };

  return FlexBox;
}(PureComponent);

var css_248z$y = "@-webkit-keyframes components--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--header__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer; }\n  .components--header__headerOpen {\n    cursor: pointer; }\n  .components--header__headerHasDropdown {\n    cursor: pointer; }\n\n.components--header__title {\n  margin-left: 16px;\n  margin-right: 32px; }\n";
var styles$r = {"header":"components--header__header","headerOpen":"components--header__headerOpen","headerHasDropdown":"components--header__headerHasDropdown","title":"components--header__title","wiggle":"components--header__wiggle","spin":"components--header__spin"};
styleInject(css_248z$y);

var Header$1 =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Header.prototype.getRootClassName = function (isOpen) {
    var _a;

    var _b = this.props,
        dropdown = _b.dropdown,
        className = _b.className;
    return classnames(styles$r.header, (_a = {}, _a[styles$r.headerOpen] = isOpen, _a[styles$r.headerHasDropdown] = !!dropdown, _a), className);
  };

  Header.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        title = _a.title,
        avatar = _a.avatar,
        dropdown = _a.dropdown,
        otherProps = __rest(_a, ["children", "className", "title", "avatar", "dropdown"]);

    return /*#__PURE__*/React.createElement(CollapseCardContext.Consumer, null, function (_a) {
      var isOpen = _a.isOpen,
          onToggle = _a.onToggle;

      var rootClass = _this.getRootClassName(isOpen);

      return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
        onClick: onToggle,
        className: rootClass,
        "data-testid": "header"
      }), /*#__PURE__*/React.createElement(FlexBox, {
        alignItems: "center",
        padding: "400 0"
      }, avatar, /*#__PURE__*/React.createElement("div", {
        onMouseDown: function onMouseDown(event) {
          return event.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement(Text.Paragraph, {
        variant: "1",
        wrap: "nowrap",
        className: styles$r.title
      }, children))), /*#__PURE__*/React.createElement(FlexBox, {
        alignItems: "center"
      }, !!dropdown && /*#__PURE__*/React.createElement(DropdownButton, {
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        icon: "dots-h",
        dropdown: dropdown,
        buttonProps: {
          variant: 'tertiary'
        }
      }), /*#__PURE__*/React.createElement(IconButton$1, {
        icon: isOpen ? 'angle-down' : 'angle-right',
        variant: "tertiary"
      })));
    });
  }; // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children


  Header.displayName = 'CollapseCard.Header';
  Header.defaultProps = {
    title: ''
  };
  return Header;
}(PureComponent);

var css_248z$z = "@-webkit-keyframes components--line__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--line__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--line__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--line__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--line__line {\n  border-bottom: 1px solid #e7ecf3;\n  padding-bottom: 16px; }\n  .components--line__lineHasLabel {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    grid-gap: 8px;\n    align-items: start;\n    padding: 16px 0; }\n    .components--line__lineHasLabel:first-child {\n      padding-top: 0; }\n    .components--line__lineHasLabel:last-child {\n      justify-content: end;\n      border-bottom: none; }\n\n.components--line__value {\n  font-size: 14px;\n  color: #5a5a5a;\n  display: block;\n  text-align: right;\n  line-height: 20px;\n  word-break: break-all;\n  margin-top: -1px; }\n  .components--line__lineHideOverflow .components--line__value {\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .components--line__value > a {\n    color: #5644d8;\n    text-decoration: none;\n    font-size: inherit;\n    line-height: inherit; }\n";
var styles$s = {"line":"components--line__line","lineHasLabel":"components--line__lineHasLabel","value":"components--line__value","lineHideOverflow":"components--line__lineHideOverflow","wiggle":"components--line__wiggle","spin":"components--line__spin"};
styleInject(css_248z$z);

var Line =
/** @class */
function (_super) {
  __extends(Line, _super);

  function Line() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Line.prototype.render = function () {
    var _a;

    var _b = this.props,
        label = _b.label,
        children = _b.children,
        className = _b.className,
        hideOverflow = _b.hideOverflow,
        otherProps = __rest(_b, ["label", "children", "className", "hideOverflow"]);

    var rootClass = classnames((_a = {}, _a[styles$s.line] = true, _a[styles$s.lineHasLabel] = !!label, _a[styles$s.lineHideOverflow] = hideOverflow, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), label && /*#__PURE__*/React.createElement(Text.Paragraph, {
      variant: "2",
      subdued: true,
      wrap: "nowrap"
    }, label), label ? /*#__PURE__*/React.createElement("span", {
      className: styles$s.value
    }, children) : children);
  };

  return Line;
}(PureComponent);

var css_248z$A = "@-webkit-keyframes components--readMore__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--readMore__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--readMore__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--readMore__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--readMore__readMore {\n  text-align: center;\n  font-size: 12px;\n  padding: 16px 0;\n  text-decoration: none;\n  color: #5644d8;\n  border: 0;\n  display: block;\n  width: 100%;\n  outline: none; }\n";
var styles$t = {"readMore":"components--readMore__readMore","wiggle":"components--readMore__wiggle","spin":"components--readMore__spin"};
styleInject(css_248z$A);

var ReadMore =
/** @class */
function (_super) {
  __extends(ReadMore, _super);

  function ReadMore() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ReadMore.prototype.render = function () {
    var _a;

    var _b = this.props,
        onClick = _b.onClick,
        url = _b.url,
        children = _b.children,
        className = _b.className,
        otherProps = __rest(_b, ["onClick", "url", "children", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$t.readMore] = true, _a), className);

    if (url) {
      return /*#__PURE__*/React.createElement(Text.ExternalLink, __assign({}, otherProps, {
        href: url,
        className: rootClass
      }), children);
    }

    return /*#__PURE__*/React.createElement(Button$2, __assign({
      variant: "secondary"
    }, otherProps, {
      onClick: onClick,
      className: rootClass
    }), children);
  };

  return ReadMore;
}(PureComponent);

var css_248z$B = "@-webkit-keyframes components--status__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes components--status__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes components--status__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes components--status__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--status__status {\n  font-size: 14px;\n  color: #bbb;\n  border-top: 1px solid #e3e4e6;\n  padding: 11px 0;\n  text-align: center;\n  margin: 0; }\n";
var styles$u = {"status":"components--status__status","wiggle":"components--status__wiggle","spin":"components--status__spin"};
styleInject(css_248z$B);

var Status =
/** @class */
function (_super) {
  __extends(Status, _super);

  function Status() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Status.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        className = _b.className,
        otherProps = __rest(_b, ["children", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$u.status] = true, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return Status;
}(PureComponent);

var CollapseCard =
/** @class */
function (_super) {
  __extends(CollapseCard, _super);

  function CollapseCard(props) {
    var _this = _super.call(this, props) || this;

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  CollapseCard.prototype.handleToggle = function () {
    this.props.onToggle(!this.props.isOpen);
  };

  CollapseCard.prototype.isHeader = function (child) {
    var _a;

    return ((_a = child === null || child === void 0 ? void 0 : child['type']) === null || _a === void 0 ? void 0 : _a.displayName) === 'CollapseCard.Header' && /*#__PURE__*/React.isValidElement(child);
  };

  CollapseCard.prototype.isContent = function (child) {
    var _a;

    return ((_a = child === null || child === void 0 ? void 0 : child['type']) === null || _a === void 0 ? void 0 : _a.displayName) === 'CollapseCard.Content' && /*#__PURE__*/React.isValidElement(child);
  };

  CollapseCard.prototype.getHeaderChildren = function () {
    return React.Children.toArray(this.props.children).filter(this.isHeader);
  };

  CollapseCard.prototype.getContentChildren = function () {
    return React.Children.toArray(this.props.children).filter(this.isContent);
  };

  CollapseCard.prototype.getRootClassName = function () {
    var className = this.props.className;
    return classnames(styles$n.card, className);
  };

  CollapseCard.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        onToggle = _a.onToggle,
        isOpen = _a.isOpen,
        children = _a.children,
        otherProps = __rest(_a, ["className", "onToggle", "isOpen", "children"]);

    return /*#__PURE__*/React.createElement(CollapseCardContext.Provider, {
      value: {
        isOpen: isOpen,
        onToggle: this.handleToggle
      }
    }, /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: this.getRootClassName()
    }), this.getHeaderChildren(), this.getContentChildren()));
  };

  CollapseCard.defaultProps = {
    isOpen: false
  };
  CollapseCard.Line = Line;
  CollapseCard.Header = Header$1;
  CollapseCard.Content = Content;
  CollapseCard.ReadMore = ReadMore;
  CollapseCard.Status = Status;
  return CollapseCard;
}(PureComponent);
var CollapseCardWithErrorBoundary = withErrorBoundary(CollapseCard, {
  fallback: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text.Paragraph, {
    variant: "2"
  }, "Something went wrong"))
});

var css_248z$C = "@-webkit-keyframes collapsible--collapsible__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes collapsible--collapsible__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes collapsible--collapsible__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes collapsible--collapsible__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.collapsible--collapsible__root {\n  box-sizing: border-box;\n  overflow: hidden;\n  border-radius: 6px;\n  border: 1px solid #e3e4e6; }\n\n.collapsible--collapsible__collapsible {\n  border-radius: 0 0 6px 6px;\n  transition: max-height 0.2s ease-out; }\n\n.collapsible--collapsible__children {\n  display: block;\n  border-top: 1px solid #e3e4e6; }\n";
var styles$v = {"root":"collapsible--collapsible__root","collapsible":"collapsible--collapsible__collapsible","children":"collapsible--collapsible__children","wiggle":"collapsible--collapsible__wiggle","spin":"collapsible--collapsible__spin"};
styleInject(css_248z$C);

var Collapsible =
/** @class */
function (_super) {
  __extends(Collapsible, _super);

  function Collapsible(props) {
    var _this = _super.call(this, props) || this;

    _this.childrenRef = /*#__PURE__*/React.createRef();
    _this.measureChildrenHeight = _this.measureChildrenHeight.bind(_this);
    _this.state = {
      childrenHeight: 0
    };
    return _this;
  }

  Collapsible.prototype.componentDidMount = function () {
    this.measureChildrenHeight();
  };

  Collapsible.prototype.componentDidUpdate = function () {
    this.measureChildrenHeight();
  };

  Collapsible.prototype.measureChildrenHeight = function () {
    var childrenElm = this.childrenRef.current;

    if (childrenElm) {
      this.setState({
        childrenHeight: childrenElm.offsetHeight
      });
    }
  };

  Collapsible.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        header = _b.header,
        isOpen = _b.isOpen,
        children = _b.children,
        otherProps = __rest(_b, ["className", "header", "isOpen", "children"]);

    var childrenHeight = this.state.childrenHeight;
    var rootClass = classnames((_a = {}, _a[styles$v.root] = true, _a), className);
    var childrenStyle = {
      maxHeight: isOpen ? childrenHeight : 0
    };
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, header)), !!children && /*#__PURE__*/React.createElement("div", {
      style: childrenStyle,
      className: styles$v.collapsible
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$v.children,
      ref: this.childrenRef
    }, children)));
  };

  return Collapsible;
}(PureComponent);

var css_248z$D = "@-webkit-keyframes copyToClipboard--copyToClipboard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes copyToClipboard--copyToClipboard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes copyToClipboard--copyToClipboard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes copyToClipboard--copyToClipboard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.copyToClipboard--copyToClipboard__copyToClipboard {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out; }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::before, .copyToClipboard--copyToClipboard__copyToClipboardTooltip::after {\n    box-sizing: border-box;\n    position: absolute;\n    display: inline-block;\n    opacity: 1;\n    visibility: visible; }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::before {\n    content: \"Copied!\";\n    z-index: 2000;\n    padding: 8px;\n    background-color: #000;\n    font-family: 'Open Sans', Helvetica, Arial, sans-serif;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 0.8;\n    color: #fff;\n    border-radius: 4px; }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::after {\n    content: \"\";\n    z-index: 2001;\n    border: 6px solid transparent;\n    background: transparent; }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::before, .copyToClipboard--copyToClipboard__copyToClipboardTooltip::after {\n    bottom: 100%;\n    left: 50%;\n    transform: translateY(-12px); }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::after {\n    margin-left: -6px;\n    margin-bottom: -12px;\n    border-top-color: #000; }\n  .copyToClipboard--copyToClipboard__copyToClipboardTooltip::before {\n    margin-left: -25px; }\n";
var styles$w = {"copyToClipboard":"copyToClipboard--copyToClipboard__copyToClipboard","copyToClipboardTooltip":"copyToClipboard--copyToClipboard__copyToClipboardTooltip","wiggle":"copyToClipboard--copyToClipboard__wiggle","spin":"copyToClipboard--copyToClipboard__spin"};
styleInject(css_248z$D);

var CopyToClipboard =
/** @class */
function (_super) {
  __extends(CopyToClipboard, _super);

  function CopyToClipboard(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      clicked: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  CopyToClipboard.prototype.componentWillUnmount = function () {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
    }
  };

  CopyToClipboard.prototype.handleClick = function (e) {
    var _this = this;

    var _a = this.props,
        disabled = _a.disabled,
        textToCopy = _a.textToCopy,
        transitionDuration = _a.transitionDuration,
        onClick = _a.onClick;
    if (disabled) return;
    if (typeof onClick === 'function') onClick(e);
    var current = textToCopy;
    var body = document.body;

    if (current && document.body) {
      var el = document.createElement('textarea');
      el.value = current;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      body.appendChild(el);
      el.select();
      document.execCommand('copy');
      body.removeChild(el);
    }

    this.setState({
      clicked: true
    });
    this.timerHandle = setTimeout(function () {
      _this.setState({
        clicked: false
      });
    }, transitionDuration || 2000);
  };

  CopyToClipboard.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        clickedProps = _b.clickedProps,
        tooltip = _b.tooltip;
    var clicked = this.state.clicked;
    var rootClass = classnames((_a = {}, _a[styles$w.copyToClipboard] = true, _a[styles$w.copyToClipboardTooltip] = clicked && tooltip, _a), className);
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, __assign({
          onClick: _this.handleClick.bind(_this)
        }, clicked ? clickedProps : {}));
      }

      return child;
    }));
  };

  return CopyToClipboard;
}(React.Component);
CopyToClipboard.defaultProps = {
  tooltip: true,
  disabled: false
};

var css_248z$E = "@-webkit-keyframes table--table__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes table--table__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes table--table__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes table--table__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.table--table__root {\n  position: relative;\n  width: 100%;\n  margin: 0;\n  color: #263758;\n  overflow: auto; }\n  .table--table__rootFramed {\n    border: 1px solid #e7ecf3;\n    border-radius: 4px; }\n\n.table--table__table {\n  width: 100%;\n  margin: 0;\n  border-collapse: collapse; }\n";
var styles$x = {"root":"table--table__root","rootFramed":"table--table__rootFramed","table":"table--table__table","wiggle":"table--table__wiggle","spin":"table--table__spin"};
styleInject(css_248z$E);

var Tbody =
/** @class */
function (_super) {
  __extends(Tbody, _super);

  function Tbody() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tbody.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        otherProps = __rest(_a, ["className", "children"]);

    return /*#__PURE__*/React.createElement("tbody", __assign({}, otherProps), children);
  };

  return Tbody;
}(PureComponent);

var css_248z$F = "@-webkit-keyframes table--td__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes table--td__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes table--td__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes table--td__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.table--td__root {\n  font-size: 14px;\n  line-height: 16px;\n  padding: 16px 8px;\n  border: 0;\n  border-bottom: 1px solid #e7ecf3;\n  background-color: #fff;\n  vertical-align: middle; }\n  .table--td__root:first-child {\n    padding-left: 16px; }\n  .table--td__root:last-child {\n    padding-right: 16px; }\n  tr:last-child .table--td__root {\n    border-bottom: 0; }\n";
var styles$y = {"root":"table--td__root","wiggle":"table--td__wiggle","spin":"table--td__spin"};
styleInject(css_248z$F);

var Td =
/** @class */
function (_super) {
  __extends(Td, _super);

  function Td() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Td.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        otherProps = __rest(_b, ["className", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$y.root] = styles$y.root, _a), className);
    return /*#__PURE__*/React.createElement(Box, __assign({
      as: "td"
    }, otherProps, {
      className: rootClass
    }), children);
  };

  return Td;
}(PureComponent);

var css_248z$G = "@-webkit-keyframes table--tfoot__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes table--tfoot__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes table--tfoot__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes table--tfoot__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.table--tfoot__root {\n  font-size: 14px;\n  line-height: 16px;\n  padding: 16px 8px;\n  background-color: #fff;\n  vertical-align: middle;\n  border: 0;\n  border-top: 1px solid #e7ecf3; }\n";
var styles$z = {"root":"table--tfoot__root","wiggle":"table--tfoot__wiggle","spin":"table--tfoot__spin"};
styleInject(css_248z$G);

var Tfoot =
/** @class */
function (_super) {
  __extends(Tfoot, _super);

  function Tfoot() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tfoot.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        otherProps = __rest(_b, ["className", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$z.root] = styles$z.root, _a), className);
    return /*#__PURE__*/React.createElement("tfoot", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return Tfoot;
}(PureComponent);

var css_248z$H = "@-webkit-keyframes table--th__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes table--th__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes table--th__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes table--th__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.table--th__root {\n  z-index: 1;\n  background: #fff;\n  font-size: 12px;\n  color: #45587c;\n  text-align: left;\n  border-bottom: 1px solid #e7ecf3;\n  font-weight: 600;\n  line-height: 16px;\n  padding: 16px 8px;\n  vertical-align: middle; }\n  .table--th__root:first-child {\n    padding-left: 16px; }\n  .table--th__root:last-child {\n    padding-right: 16px; }\n  .table--th__rootSticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    border: 0; }\n    .table--th__rootSticky::after {\n      content: '';\n      display: block;\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      height: 16px;\n      width: 100%;\n      border-bottom: 1px solid #e7ecf3; }\n  .table--th__rootShowBG {\n    background: #f5f7fa; }\n";
var styles$A = {"root":"table--th__root","rootSticky":"table--th__rootSticky","rootShowBG":"table--th__rootShowBG","wiggle":"table--th__wiggle","spin":"table--th__spin"};
styleInject(css_248z$H);

var Th =
/** @class */
function (_super) {
  __extends(Th, _super);

  function Th() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Th.prototype.render = function () {
    var _a;

    var _b = this.props,
        isSticky = _b.isSticky,
        showBG = _b.showBG,
        className = _b.className,
        children = _b.children,
        otherProps = __rest(_b, ["isSticky", "showBG", "className", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$A.root] = styles$A.root, _a[styles$A.rootSticky] = isSticky, _a[styles$A.rootShowBG] = showBG, _a), className);
    return /*#__PURE__*/React.createElement(Box, __assign({
      as: "th"
    }, otherProps, {
      className: rootClass
    }), children);
  };

  return Th;
}(PureComponent);

var Thead =
/** @class */
function (_super) {
  __extends(Thead, _super);

  function Thead() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Thead.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        otherProps = __rest(_a, ["children"]);

    return /*#__PURE__*/React.createElement("thead", __assign({}, otherProps), children);
  };

  return Thead;
}(PureComponent);

var Tr =
/** @class */
function (_super) {
  __extends(Tr, _super);

  function Tr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tr.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        otherProps = __rest(_a, ["children"]);

    return /*#__PURE__*/React.createElement("tr", __assign({}, otherProps), children);
  };

  return Tr;
}(PureComponent);

var Table =
/** @class */
function (_super) {
  __extends(Table, _super);

  function Table() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Table.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        framed = _c.framed,
        className = _c.className,
        tableProps = _c.tableProps,
        children = _c.children,
        otherProps = __rest(_c, ["framed", "className", "tableProps", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$x.root] = styles$x.root, _a[styles$x.rootFramed] = framed, _a), className);
    var tableClass = classnames((_b = {}, _b[styles$x.table] = styles$x.table, _b), tableProps === null || tableProps === void 0 ? void 0 : tableProps.className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("table", __assign({}, tableProps, {
      className: tableClass
    }), children));
  };

  Table.Thead = Thead;
  Table.Tbody = Tbody;
  Table.Tfoot = Tfoot;
  Table.Tr = Tr;
  Table.Th = Th;
  Table.Td = Td;
  return Table;
}(PureComponent);

var DataTable =
/** @class */
function (_super) {
  __extends(DataTable, _super);

  function DataTable() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataTable.renderHeadCell = function (cell, key) {
    return DataTable.renderCell('th', cell, key);
  };

  DataTable.renderBodyCell = function (cell, key) {
    return DataTable.renderCell('td', cell, key);
  };

  DataTable.isValidContent = function (content) {
    return typeof content === 'string' || /*#__PURE__*/React.isValidElement(content);
  };

  DataTable.renderCell = function (cellType, cell, key) {
    var _a;

    var content = null;
    var cellProps = {};

    if (DataTable.isValidContent(cell)) {
      content = cell;
    }

    if (DataTable.isValidContent((_a = cell) === null || _a === void 0 ? void 0 : _a.content)) {
      var cellStruct = cell;

      var structContent = cellStruct.content,
          otherRowProps = __rest(cellStruct, ["content"]);

      content = structContent;
      cellProps = otherRowProps;
    }

    var isHeader = cellType === 'th';
    var Comp = isHeader ? Table.Th : Table.Td;

    if (isHeader) {
      cellProps.isSticky = true;
    }

    return /*#__PURE__*/React.createElement(Comp, __assign({
      key: key
    }, cellProps), DataTable.renderContent(content));
  };

  DataTable.renderContent = function (content) {
    if (!content) {
      return null;
    }

    if ( /*#__PURE__*/React.isValidElement(content) || typeof content === 'string') {
      return content;
    }

    return null;
  };

  DataTable.renderBodyRow = function (row, key) {
    var cells = null;
    var rowProps = {};

    if (Array.isArray(row)) {
      cells = row;
    } else if (row.row) {
      var rowStruct = row;

      var structRow = rowStruct.row,
          otherRowProps = __rest(rowStruct, ["row"]);

      cells = structRow;
      rowProps = otherRowProps;
    }

    if (cells !== null) {
      return /*#__PURE__*/React.createElement(Table.Tr, __assign({
        key: key
      }, rowProps), cells.map(DataTable.renderBodyCell));
    }
  };

  DataTable.prototype.render = function () {
    var _a = this.props,
        data = _a.data,
        otherProps = __rest(_a, ["data"]);

    return /*#__PURE__*/React.createElement(Table, __assign({}, otherProps), /*#__PURE__*/React.createElement(Table.Thead, null, /*#__PURE__*/React.createElement(Table.Tr, null, data.head.map(DataTable.renderHeadCell))), /*#__PURE__*/React.createElement(Table.Tbody, null, data.body.map(DataTable.renderBodyRow)));
  };

  return DataTable;
}(PureComponent);

var css_248z$I = ".dataTable--dataTableIcon__root {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start; }\n\n.dataTable--dataTableIcon__icon {\n  margin-right: 16px; }\n\n.dataTable--dataTableIcon__text {\n  display: inline-block;\n  width: 100%; }\n";
var styles$B = {"root":"dataTable--dataTableIcon__root","icon":"dataTable--dataTableIcon__icon","text":"dataTable--dataTableIcon__text"};
styleInject(css_248z$I);

var DataTableIcon =
/** @class */
function (_super) {
  __extends(DataTableIcon, _super);

  function DataTableIcon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataTableIcon.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        icon = _b.icon,
        text = _b.text,
        otherProps = __rest(_b, ["className", "icon", "text"]);

    var rootClass = classnames((_a = {}, _a[styles$B.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$B.icon,
      name: icon
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$B.text
    }, text));
  };

  return DataTableIcon;
}(PureComponent);

var css_248z$J = "@-webkit-keyframes dataTable--dataTableTimestamp__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes dataTable--dataTableTimestamp__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes dataTable--dataTableTimestamp__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dataTable--dataTableTimestamp__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dataTable--dataTableTimestamp__root {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  text-align: right; }\n\n.dataTable--dataTableTimestamp__date {\n  color: #bbb; }\n\n.dataTable--dataTableTimestamp__time {\n  color: #5a5a5a; }\n";
var styles$C = {"root":"dataTable--dataTableTimestamp__root","date":"dataTable--dataTableTimestamp__date","time":"dataTable--dataTableTimestamp__time","wiggle":"dataTable--dataTableTimestamp__wiggle","spin":"dataTable--dataTableTimestamp__spin"};
styleInject(css_248z$J);

var DataTableTimestamp =
/** @class */
function (_super) {
  __extends(DataTableTimestamp, _super);

  function DataTableTimestamp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataTableTimestamp.prototype.render = function () {
    var _a;

    var _b = this.props,
        date = _b.date,
        className = _b.className,
        otherProps = __rest(_b, ["date", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$C.root] = styles$C.root, _a), className);

    if (date instanceof Date) {
      return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
        className: rootClass
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$C.date
      }, padStart(date.getDate().toString(), 2, '0') + " " + date.toLocaleDateString('en-US', {
        month: 'short'
      }) + " " + date.getFullYear()), /*#__PURE__*/React.createElement("div", {
        className: styles$C.time
      }, padStart(date.getHours().toString(), 2, '0') + ":" + padStart(date.getMinutes().toString(), 2, '0') + ":" + padStart(date.getSeconds().toString(), 2, '0')));
    }

    return null;
  };

  return DataTableTimestamp;
}(PureComponent);

var css_248z$K = "@-webkit-keyframes datePicker--datePicker__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes datePicker--datePicker__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes datePicker--datePicker__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes datePicker--datePicker__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.datePicker--datePicker__grid {\n  display: flex;\n  flex-wrap: wrap; }\n\n.datePicker--datePicker__gridItem {\n  width: 14.28571%;\n  margin: 3px 0;\n  display: flex;\n  justify-content: center; }\n\n.datePicker--datePicker__day {\n  max-width: 40px;\n  width: 100%; }\n\n.datePicker--datePicker__month {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111;\n  font-family: 'Montserrat', sans-serif;\n  background: #f1f2f4;\n  border-radius: 6px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.datePicker--datePicker__timeButtonContainerLeft {\n  display: flex; }\n\n.datePicker--datePicker__timeButtonContainerRight {\n  display: flex; }\n\n.datePicker--datePicker__arrow, .datePicker--datePicker__arrowTime {\n  background: none;\n  font-size: 32px;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  outline: none;\n  border: 1px solid transparent;\n  transition: box-shadow 0.15s ease-out, opacity 0.15s ease-out; }\n  .datePicker--datePicker__arrow:focus, .datePicker--datePicker__arrowTime:focus {\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n  .datePicker--datePicker__arrow[disabled], .datePicker--datePicker__arrowTime[disabled] {\n    opacity: 0; }\n\n.datePicker--datePicker__arrow {\n  line-height: 40px; }\n\n.datePicker--datePicker__arrowTime {\n  font-size: 22px;\n  line-height: 34px; }\n  .datePicker--datePicker__timeButtonContainerLeft .datePicker--datePicker__arrowTime:first-child {\n    border-radius: 6px 0 0 6px; }\n  .datePicker--datePicker__timeButtonContainerRight .datePicker--datePicker__arrowTime:last-child {\n    border-radius: 0 6px 6px 0; }\n\n.datePicker--datePicker__dayNames {\n  display: flex;\n  border-bottom: 1px solid #c8c9cc;\n  margin-bottom: 8px; }\n\n.datePicker--datePicker__dayName {\n  width: 14.28571%;\n  line-height: 40px;\n  text-align: center;\n  margin: 0 2.5px;\n  color: #c8c9cc;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-family: 'Montserrat', sans-serif; }\n\n.datePicker--datePicker__time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n  border: 1px solid #dcdcdc;\n  border-radius: 6px;\n  margin-top: 20px; }\n\n.datePicker--datePicker__timeDisplay {\n  font-size: 12px; }\n";
var styles$D = {"grid":"datePicker--datePicker__grid","gridItem":"datePicker--datePicker__gridItem","day":"datePicker--datePicker__day","month":"datePicker--datePicker__month","timeButtonContainerLeft":"datePicker--datePicker__timeButtonContainerLeft","timeButtonContainerRight":"datePicker--datePicker__timeButtonContainerRight","arrow":"datePicker--datePicker__arrow","arrowTime":"datePicker--datePicker__arrowTime","dayNames":"datePicker--datePicker__dayNames","dayName":"datePicker--datePicker__dayName","time":"datePicker--datePicker__time","timeDisplay":"datePicker--datePicker__timeDisplay","wiggle":"datePicker--datePicker__wiggle","spin":"datePicker--datePicker__spin"};
styleInject(css_248z$K);

var css_248z$L = "@-webkit-keyframes datePicker--datePickerDay__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes datePicker--datePickerDay__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes datePicker--datePickerDay__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes datePicker--datePickerDay__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.datePicker--datePickerDay__root {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 600;\n  color: #111;\n  font-family: 'Montserrat', sans-serif;\n  cursor: pointer;\n  transition: color 0.15s ease-out;\n  background: none;\n  border: none;\n  outline: none;\n  padding: 0; }\n  .datePicker--datePickerDay__root::before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n    width: 100%;\n    border-radius: 20px;\n    background: #5644d8;\n    z-index: 0;\n    transform: scale(0);\n    transition: transform 0.15s ease-out; }\n  .datePicker--datePickerDay__root::after {\n    content: '';\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    position: absolute;\n    z-index: 0;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3);\n    opacity: 0;\n    transition: opacity 0.1s ease-out; }\n  .datePicker--datePickerDay__root:focus::after, .datePicker--datePickerDay__root:hover::after {\n    opacity: 1; }\n  .datePicker--datePickerDay__rootActive {\n    color: #fff; }\n    .datePicker--datePickerDay__rootActive::before {\n      transform: scale(1); }\n  .datePicker--datePickerDay__rootDisabled {\n    color: #9b9b9b;\n    cursor: default;\n    position: relative; }\n    .datePicker--datePickerDay__rootDisabled::after {\n      content: '';\n      padding-top: 0;\n      box-shadow: none;\n      height: 2px;\n      width: 100%;\n      background-color: currentColor;\n      border-radius: 0;\n      opacity: 1;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 1;\n      transform: translate3d(-50%, 0, 0) rotate(-45deg) scale(0.7); }\n  .datePicker--datePickerDay__rootDim {\n    color: #e1e1e1; }\n\n.datePicker--datePickerDay__label {\n  position: absolute;\n  z-index: 1; }\n";
var styles$E = {"root":"datePicker--datePickerDay__root","rootActive":"datePicker--datePickerDay__rootActive","rootDisabled":"datePicker--datePickerDay__rootDisabled","rootDim":"datePicker--datePickerDay__rootDim","label":"datePicker--datePickerDay__label","wiggle":"datePicker--datePickerDay__wiggle","spin":"datePicker--datePickerDay__spin"};
styleInject(css_248z$L);

var DatePickerDay =
/** @class */
function (_super) {
  __extends(DatePickerDay, _super);

  function DatePickerDay() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DatePickerDay.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        dim = _b.dim,
        active = _b.active,
        disabled = _b.disabled,
        children = _b.children,
        onClick = _b.onClick,
        otherProps = __rest(_b, ["className", "dim", "active", "disabled", "children", "onClick"]);

    var rootClass = classnames((_a = {}, _a[styles$E.root] = true, _a[styles$E.rootDim] = dim, _a[styles$E.rootActive] = active, _a[styles$E.rootDisabled] = !active && disabled, _a), className);
    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      onClick: onClick,
      className: rootClass,
      disabled: disabled
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$E.label
    }, children));
  };

  return DatePickerDay;
}(PureComponent);

var datepickerDisableWeekends = function datepickerDisableWeekends(compareDate) {
  var weekendDays = [0, 6];
  return weekendDays.indexOf(compareDate.getDay()) !== -1;
};

var DatePicker =
/** @class */
function (_super) {
  __extends(DatePicker, _super);

  function DatePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.nextMonth = function (e) {
      e.preventDefault();

      _this.goToMonth(1);
    };

    _this.prevMonth = function (e) {
      e.preventDefault();

      _this.goToMonth(-1);
    };

    _this.nextMinutes = function (e) {
      e.preventDefault();

      _this.goToTime(e, 15, 'minutes');
    };

    _this.prevMinutes = function (e) {
      e.preventDefault();

      _this.goToTime(e, -15, 'minutes');
    };

    _this.nextHour = function (e) {
      e.preventDefault();

      _this.goToTime(e, 1);
    };

    _this.prevHour = function (e) {
      e.preventDefault();

      _this.goToTime(e, -1);
    };

    var selectedDate = DatePicker.getDateValue(props.input);
    _this.state = {
      selectedDate: selectedDate,
      showDate: selectedDate
    };
    return _this;
  }

  DatePicker.getDateValue = function (input) {
    var value = input.value instanceof Date ? input.value : new Date();
    var selectedDate = new Date(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes());
    return selectedDate;
  }; // eslint-disable-next-line camelcase


  DatePicker.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var input = this.props.input;

    if (nextProps.input !== input) {
      this.setState({
        selectedDate: DatePicker.getDateValue(nextProps.input)
      });
    }
  };

  DatePicker.prototype.generateGrid = function () {
    var _a = this.state,
        selectedDate = _a.selectedDate,
        showDate = _a.showDate;
    var _b = this.props,
        input = _b.input,
        disabled = _b.disabled,
        minDate = _b.minDate,
        maxDate = _b.maxDate;
    var gridItems = []; // Create a counter

    var counter = new Date(showDate.getFullYear(), showDate.getMonth(), 1, selectedDate.getHours(), selectedDate.getMinutes());
    var weekdayStart = counter.getDay() || 7; // Make sunday day 7 instead of 0

    var nextMonth = new Date(counter.getFullYear(), counter.getMonth() + 1, 1); // If the month starts on a monday/tuesday add an extra row in the beginning,

    if (weekdayStart < 3) {
      counter.setDate(counter.getDate() - 7);
    } // Go back to the start of the week


    counter.setDate(counter.getDate() - (weekdayStart - 1)); // Get exact time of the selection (for comparison)

    var selectedDateTime = DatePicker.getDateValue(input).getTime();
    var mondayCount = 0; // Loop until we hit a monday in the next month and we have atleast 6 rows/mondays

    while (counter < nextMonth || counter.getDay() !== 1 || mondayCount < 6) {
      var counterTime = counter.getTime();
      var itemDate = new Date(counterTime);
      gridItems.push({
        date: itemDate,
        label: counter.getDate().toString(),
        isThisMonth: counter.getMonth() === showDate.getMonth(),
        selected: counterTime === selectedDateTime,
        disabled: disabled(counter) || maxDate && itemDate > maxDate || minDate && itemDate < minDate
      });

      if (counter.getDay() === 1) {
        mondayCount += 1;
      }

      counter.setDate(counter.getDate() + 1);
    }

    return gridItems;
  };

  DatePicker.prototype.goToMonth = function (dir) {
    var showDate = this.state.showDate;
    var newDate = new Date(showDate.getTime());
    newDate.setMonth(showDate.getMonth() + dir);
    this.setState({
      showDate: newDate
    });
  };

  DatePicker.prototype.handleDateClick = function (e, date) {
    e.preventDefault();
    var onChange = this.props.input.onChange;
    var showDate = this.state.showDate;

    var newState = __assign(__assign({}, this.state), {
      selectedDate: date
    });

    if (showDate.getMonth() !== date.getMonth()) {
      newState.showDate = date;
    }

    this.setState(newState);
    onChange(date);
  };

  DatePicker.prototype.goToTime = function (_e, direction, type) {
    if (type === void 0) {
      type = 'hours';
    }

    var setter = type === 'minutes' ? 'setMinutes' : 'setHours';
    var getter = type === 'minutes' ? 'getMinutes' : 'getHours';
    var onChange = this.props.input.onChange;
    var selectedDate = this.state.selectedDate;
    var newDate = new Date(selectedDate.getTime()); // $FlowFixMe

    newDate[setter](newDate[getter]() + direction);
    this.setState({
      selectedDate: newDate
    });
    onChange(newDate);
  };

  DatePicker.prototype.canGoPrevMonth = function () {
    var minDate = this.props.minDate;
    var showDate = this.state.showDate;
    if (minDate === null) return true; // Start of day of first day of shown month

    var compareDate = new Date(showDate.getFullYear(), showDate.getMonth(), 1);
    return minDate < compareDate;
  };

  DatePicker.prototype.canGoNextMonth = function () {
    var maxDate = this.props.maxDate;
    var showDate = this.state.showDate;
    if (maxDate === null) return true; // End of last day of shown month

    var compareDate = new Date(showDate.getFullYear(), showDate.getMonth() + 1, 1, 0, 0, 0, -1);
    return maxDate > compareDate;
  };

  DatePicker.prototype.canGoDirection = function (type, adjustment) {
    if (type === void 0) {
      type = 'hours';
    }

    var setter = type === 'minutes' ? 'setMinutes' : 'setHours';
    var getter = type === 'minutes' ? 'getMinutes' : 'getHours';
    var maxDate = this.props.maxDate;
    var selectedDate = this.state.selectedDate;
    var compareDate = new Date(selectedDate.getTime()); // $FlowFixMe

    compareDate[setter](compareDate[getter]() + adjustment);
    var dateDiffers = compareDate.getDate() !== selectedDate.getDate();
    return !dateDiffers && (maxDate === null || maxDate >= compareDate);
  };

  DatePicker.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        input = _a.input,
        hasTime = _a.hasTime,
        disabled = _a.disabled,
        minDate = _a.minDate,
        maxDate = _a.maxDate,
        otherProps = __rest(_a, ["className", "input", "hasTime", "disabled", "minDate", "maxDate"]);

    var _b = this.state,
        selectedDate = _b.selectedDate,
        showDate = _b.showDate;
    var rootClass = classnames({}, className);
    var gridItems = this.generateGrid();
    var localDateOptions = {
      month: 'long',
      year: 'numeric'
    };
    var humanDate = null;

    try {
      humanDate = showDate.toLocaleDateString('en-US', localDateOptions);
    } catch (e) {
      humanDate = showDate.getMonth() + 1 + " / " + showDate.getFullYear(); // eslint-disable-next-line no-console

      console.warn('toLocaleDateString exception', e);
    }

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$D.month
    }, /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrow,
      disabled: !this.canGoPrevMonth(),
      onClick: this.prevMonth,
      "aria-label": "Previous month"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-left",
      className: "icon-vertical-fix"
    })), humanDate, /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrow,
      disabled: !this.canGoNextMonth(),
      onClick: this.nextMonth,
      "aria-label": "Next month"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-right",
      className: "icon-vertical-fix"
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$D.dayNames
    }, /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Mon"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Tue"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Wed"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Thu"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Fri"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Sat"), /*#__PURE__*/React.createElement("p", {
      className: styles$D.dayName
    }, "Sun")), /*#__PURE__*/React.createElement("div", {
      className: styles$D.grid
    }, gridItems.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$D.gridItem,
        key: item.date.getTime()
      }, /*#__PURE__*/React.createElement(DatePickerDay, {
        onClick: function onClick(e) {
          return _this.handleDateClick(e, item.date);
        },
        dim: !item.isThisMonth,
        active: item.selected,
        disabled: item.disabled,
        className: styles$D.day
      }, item.label));
    })), hasTime && /*#__PURE__*/React.createElement("div", {
      className: styles$D.time
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$D.timeButtonContainerLeft
    }, /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrowTime,
      disabled: !this.canGoDirection('hours', -1),
      onClick: this.prevHour,
      "aria-label": "Previous hour"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-double-left",
      className: "icon-vertical-fix"
    })), /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrowTime,
      disabled: !this.canGoDirection('minutes', -15),
      onClick: this.prevMinutes,
      "aria-label": "Previous hour"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-left",
      className: "icon-vertical-fix"
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$D.timeDisplay
    }, padStart(selectedDate.getHours().toString(), 2, '0') + ":" + padStart(selectedDate.getMinutes().toString(), 2, '0')), /*#__PURE__*/React.createElement("div", {
      className: styles$D.timeButtonContainerRight
    }, /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrowTime,
      disabled: !this.canGoDirection('minutes', 15),
      onClick: this.nextMinutes,
      "aria-label": "Next hour"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-right",
      className: "icon-vertical-fix"
    })), /*#__PURE__*/React.createElement("button", {
      className: styles$D.arrowTime,
      disabled: !this.canGoDirection('hours', 1),
      onClick: this.nextHour,
      "aria-label": "Next hour"
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-double-right",
      className: "icon-vertical-fix"
    })))));
  };

  return DatePicker;
}(React.PureComponent);
DatePicker.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: function disabled() {
    return false;
  },
  minDate: null,
  maxDate: null
};

var css_248z$M = ".PresetDateRangePicker_panel {\n  padding: 0 22px 11px\n}\n.PresetDateRangePicker_button {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  box-sizing: border-box;\n  cursor: pointer\n}\n.PresetDateRangePicker_button:active {\n  outline: 0\n}\n.PresetDateRangePicker_button__selected {\n  color: #fff;\n  background: #00a699\n}\n.SingleDatePickerInput {\n  display: inline-block;\n  background-color: #fff\n}\n.SingleDatePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.SingleDatePickerInput__rtl {\n  direction: rtl\n}\n.SingleDatePickerInput__disabled {\n  background-color: #f2f2f2\n}\n.SingleDatePickerInput__block {\n  display: block\n}\n.SingleDatePickerInput__showClearDate {\n  padding-right: 30px\n}\n.SingleDatePickerInput_clearDate {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%)\n}\n.SingleDatePickerInput_clearDate__default:focus,\n.SingleDatePickerInput_clearDate__default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.SingleDatePickerInput_clearDate__small {\n  padding: 6px\n}\n.SingleDatePickerInput_clearDate__hide {\n  visibility: hidden\n}\n.SingleDatePickerInput_clearDate_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.SingleDatePickerInput_clearDate_svg__small {\n  height: 9px\n}\n.SingleDatePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.SingleDatePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.SingleDatePicker {\n  position: relative;\n  display: inline-block\n}\n.SingleDatePicker__block {\n  display: block\n}\n.SingleDatePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.SingleDatePicker_picker__rtl {\n  direction: rtl\n}\n.SingleDatePicker_picker__directionLeft {\n  left: 0\n}\n.SingleDatePicker_picker__directionRight {\n  right: 0\n}\n.SingleDatePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.SingleDatePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.SingleDatePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.SingleDatePicker_closeButton:focus,\n.SingleDatePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.SingleDatePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_buttonReset {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_buttonReset:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_show {\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_show::before {\n  content: \"\";\n  display: block;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_show__bottomRight {\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topRight {\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight::before {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topLeft {\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft::before {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft:hover::before {\n  border-left: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_showSpan {\n  color: #fff;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_showSpan__bottomRight {\n  bottom: 0;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topRight {\n  top: 1px;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topLeft {\n  top: 1px;\n  left: 5px\n}\n.DayPickerKeyboardShortcuts_panel {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px;\n  text-align: left\n}\n.DayPickerKeyboardShortcuts_title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0\n}\n.DayPickerKeyboardShortcuts_list {\n  list-style: none;\n  padding: 0;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_close {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_close:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_closeSvg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_closeSvg:focus,\n.DayPickerKeyboardShortcuts_closeSvg:hover {\n  fill: #82888a\n}\n.CalendarDay {\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n.CalendarDay:active {\n  outline: 0\n}\n.CalendarDay__defaultCursor {\n  cursor: default\n}\n.CalendarDay__default {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff\n}\n.CalendarDay__default:hover {\n  background: #e4e7e7;\n  border: 1px solid #e4e7e7;\n  color: inherit\n}\n.CalendarDay__hovered_offset {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n.CalendarDay__outside {\n  border: 0;\n  background: #fff;\n  color: #484848\n}\n.CalendarDay__outside:hover {\n  border: 0\n}\n.CalendarDay__blocked_minimum_nights {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd\n}\n.CalendarDay__blocked_minimum_nights:active,\n.CalendarDay__blocked_minimum_nights:hover {\n  background: #fff;\n  color: #cacccd\n}\n.CalendarDay__highlighted_calendar {\n  background: #ffe8bc;\n  color: #484848\n}\n.CalendarDay__highlighted_calendar:active,\n.CalendarDay__highlighted_calendar:hover {\n  background: #ffce71;\n  color: #484848\n}\n.CalendarDay__selected_span {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n  background: #33dacd;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff\n}\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__hovered_span:active {\n  background: #80e8e0;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__blocked_calendar,\n.CalendarDay__blocked_calendar:active,\n.CalendarDay__blocked_calendar:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a\n}\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd\n}\n.CalendarDay__hovered_start_first_possible_end {\n  background: #eceeee;\n  border: 1px double #eceeee\n}\n.CalendarDay__hovered_start_blocked_min_nights {\n  background: #eceeee;\n  border: 1px double #e4e7e7\n}\n.CalendarMonth {\n  background: #fff;\n  text-align: center;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.CalendarMonth_table {\n  border-collapse: collapse;\n  border-spacing: 0\n}\n.CalendarMonth_verticalSpacing {\n  border-collapse: separate\n}\n.CalendarMonth_caption {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial\n}\n.CalendarMonth_caption__verticalScrollable {\n  padding-top: 12px;\n  padding-bottom: 7px\n}\n.CalendarMonthGrid {\n  background: #fff;\n  text-align: left;\n  z-index: 0\n}\n.CalendarMonthGrid__animating {\n  z-index: 1\n}\n.CalendarMonthGrid__horizontal {\n  position: absolute;\n  left: 9px\n}\n.CalendarMonthGrid__vertical,\n.CalendarMonthGrid__vertical_scrollable {\n  margin: 0 auto\n}\n.CalendarMonthGrid_month__horizontal {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%\n}\n.CalendarMonthGrid_month__hideForAnimation {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none\n}\n.CalendarMonthGrid_month__hidden {\n  visibility: hidden\n}\n.DayPickerNavigation {\n  position: relative;\n  z-index: 2\n}\n.DayPickerNavigation__horizontal {\n  height: 0\n}\n.DayPickerNavigation__verticalScrollable_prevNav {\n  z-index: 1\n}\n.DayPickerNavigation__verticalDefault {\n  position: absolute;\n  width: 100%;\n  height: 52px;\n  bottom: 0;\n  left: 0\n}\n.DayPickerNavigation__verticalScrollableDefault {\n  position: relative\n}\n.DayPickerNavigation__bottom {\n  height: auto\n}\n.DayPickerNavigation__bottomDefault {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  display: flex;\n  justify-content: space-between\n}\n.DayPickerNavigation_button {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 0;\n  padding: 0;\n  margin: 0\n}\n.DayPickerNavigation_button__default {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575\n}\n.DayPickerNavigation_button__default:focus,\n.DayPickerNavigation_button__default:hover {\n  border: 1px solid #c4c4c4\n}\n.DayPickerNavigation_button__default:active {\n  background: #f2f2f2\n}\n.DayPickerNavigation_button__disabled {\n  cursor: default;\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:focus,\n.DayPickerNavigation_button__disabled:hover {\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:active {\n  background: 0 0\n}\n.DayPickerNavigation_button__horizontalDefault {\n  position: absolute;\n  top: 18px;\n  line-height: .78;\n  border-radius: 3px;\n  padding: 6px 9px\n}\n.DayPickerNavigation_bottomButton__horizontalDefault {\n  position: static;\n  margin: -10px 22px 30px\n}\n.DayPickerNavigation_leftButton__horizontalDefault {\n  left: 22px\n}\n.DayPickerNavigation_rightButton__horizontalDefault {\n  right: 22px\n}\n.DayPickerNavigation_button__verticalDefault {\n  padding: 5px;\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0,0,0,.1);\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  width: 50%\n}\n.DayPickerNavigation_nextButton__verticalDefault {\n  border-left: 0\n}\n.DayPickerNavigation_nextButton__verticalScrollableDefault,\n.DayPickerNavigation_prevButton__verticalScrollableDefault {\n  width: 100%\n}\n.DayPickerNavigation_svg__horizontal {\n  height: 19px;\n  width: 19px;\n  fill: #82888a;\n  display: block\n}\n.DayPickerNavigation_svg__vertical {\n  height: 42px;\n  width: 42px;\n  fill: #484848\n}\n.DayPickerNavigation_svg__disabled {\n  fill: #f2f2f2\n}\n.DayPicker {\n  background: #fff;\n  position: relative;\n  text-align: left\n}\n.DayPicker__horizontal {\n  background: #fff\n}\n.DayPicker__verticalScrollable {\n  height: 100%\n}\n.DayPicker__hidden {\n  visibility: hidden\n}\n.DayPicker__withBorder {\n  box-shadow: 0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);\n  border-radius: 3px\n}\n.DayPicker_portal__horizontal {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%\n}\n.DayPicker_portal__vertical {\n  position: initial\n}\n.DayPicker_focusRegion {\n  outline: 0\n}\n.DayPicker_calendarInfo__horizontal,\n.DayPicker_wrapper__horizontal {\n  display: inline-block;\n  vertical-align: top\n}\n.DayPicker_weekHeaders {\n  position: relative\n}\n.DayPicker_weekHeaders__horizontal {\n  margin-left: 9px\n}\n.DayPicker_weekHeader {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  text-align: left\n}\n.DayPicker_weekHeader__vertical {\n  left: 50%\n}\n.DayPicker_weekHeader__verticalScrollable {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center\n}\n.DayPicker_weekHeader_ul {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px\n}\n.DayPicker_weekHeader_li {\n  display: inline-block;\n  text-align: center\n}\n.DayPicker_transitionContainer {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px\n}\n.DayPicker_transitionContainer__horizontal {\n  transition: height .2s ease-in-out\n}\n.DayPicker_transitionContainer__vertical {\n  width: 100%\n}\n.DayPicker_transitionContainer__verticalScrollable {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll\n}\n.DateInput {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle\n}\n.DateInput__small {\n  width: 97px\n}\n.DateInput__block {\n  width: 100%\n}\n.DateInput__disabled {\n  background: #f2f2f2;\n  color: #dbdbdb\n}\n.DateInput_input {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-left: 0;\n  border-radius: 0\n}\n.DateInput_input__small {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: .2px;\n  padding: 7px 7px 5px\n}\n.DateInput_input__regular {\n  font-weight: auto\n}\n.DateInput_input__readOnly {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.DateInput_input__focused {\n  outline: 0;\n  background: #fff;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid #008489;\n  border-left: 0\n}\n.DateInput_input__disabled {\n  background: #f2f2f2;\n  font-style: italic\n}\n.DateInput_screenReaderMessage {\n  border: 0;\n  clip: rect(0,0,0,0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px\n}\n.DateInput_fang {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2\n}\n.DateInput_fangShape {\n  fill: #fff\n}\n.DateInput_fangStroke {\n  stroke: #dbdbdb;\n  fill: transparent\n}\n.DateRangePickerInput {\n  background-color: #fff;\n  display: inline-block\n}\n.DateRangePickerInput__disabled {\n  background: #f2f2f2\n}\n.DateRangePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.DateRangePickerInput__rtl {\n  direction: rtl\n}\n.DateRangePickerInput__block {\n  display: block\n}\n.DateRangePickerInput__showClearDates {\n  padding-right: 30px\n}\n.DateRangePickerInput_arrow {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848\n}\n.DateRangePickerInput_arrow_svg {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px\n}\n.DateRangePickerInput_clearDates {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%)\n}\n.DateRangePickerInput_clearDates__small {\n  padding: 6px\n}\n.DateRangePickerInput_clearDates_default:focus,\n.DateRangePickerInput_clearDates_default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.DateRangePickerInput_clearDates__hide {\n  visibility: hidden\n}\n.DateRangePickerInput_clearDates_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.DateRangePickerInput_clearDates_svg__small {\n  height: 9px\n}\n.DateRangePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.DateRangePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.DateRangePicker {\n  position: relative;\n  display: inline-block\n}\n.DateRangePicker__block {\n  display: block\n}\n.DateRangePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.DateRangePicker_picker__rtl {\n  direction: rtl\n}\n.DateRangePicker_picker__directionLeft {\n  left: 0\n}\n.DateRangePicker_picker__directionRight {\n  right: 0\n}\n.DateRangePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.DateRangePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.DateRangePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.DateRangePicker_closeButton:focus,\n.DateRangePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.DateRangePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}";
styleInject(css_248z$M);

/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/

var undefined$2;

var $SyntaxError$1 = SyntaxError;
var $Function$1 = Function;
var $TypeError$e = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		// eslint-disable-next-line no-new-func
		return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
	try {
		$gOPD$2({}, '');
	} catch (e) {
		$gOPD$2 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError$1 = function () {
	throw new $TypeError$e();
};
var ThrowTypeError$1 = $gOPD$2
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError$1;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$2(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError$1;
			}
		}
	}())
	: throwTypeError$1;

var hasSymbols$4 = hasSymbols$1();

var getProto$1 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var asyncGenFunction$1 = getEvalledConstructor('async function* () {}');
var asyncGenFunctionPrototype = asyncGenFunction$1 ? asyncGenFunction$1.prototype : undefined$2;
var asyncGenPrototype = asyncGenFunctionPrototype ? asyncGenFunctionPrototype.prototype : undefined$2;

var TypedArray$1 = typeof Uint8Array === 'undefined' ? undefined$2 : getProto$1(Uint8Array);

var INTRINSICS$1 = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$2 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$2 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$4 ? getProto$1([][Symbol.iterator]()) : undefined$2,
	'%AsyncFromSyncIteratorPrototype%': undefined$2,
	'%AsyncFunction%': getEvalledConstructor('async function () {}'),
	'%AsyncGenerator%': asyncGenFunctionPrototype,
	'%AsyncGeneratorFunction%': asyncGenFunction$1,
	'%AsyncIteratorPrototype%': asyncGenPrototype ? getProto$1(asyncGenPrototype) : undefined$2,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$2 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$2 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$2 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$2 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$2 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$2 : FinalizationRegistry,
	'%Function%': $Function$1,
	'%GeneratorFunction%': getEvalledConstructor('function* () {}'),
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$2 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$2 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$2 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$4 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$2,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$2,
	'%Map%': typeof Map === 'undefined' ? undefined$2 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$4 ? undefined$2 : getProto$1(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$2 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$2 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$2 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$2 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$4 ? undefined$2 : getProto$1(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$2 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$4 ? getProto$1(''[Symbol.iterator]()) : undefined$2,
	'%Symbol%': hasSymbols$4 ? Symbol : undefined$2,
	'%SyntaxError%': $SyntaxError$1,
	'%ThrowTypeError%': ThrowTypeError$1,
	'%TypedArray%': TypedArray$1,
	'%TypeError%': $TypeError$e,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$2 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$2 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$2 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$2 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$2 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$2 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$2 : WeakSet
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$2 = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$1 = function stringToPath(string) {
	var result = [];
	$replace$2(string, rePropName$1, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$2(subString, reEscapeChar$1, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic$1 = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS$1, intrinsicName)) {
		var value = INTRINSICS$1[intrinsicName];
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$e('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$1('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$e('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$e('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$1(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic$1('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS$1, intrinsicRealName)) {
			value = INTRINSICS$1[intrinsicRealName];
		} else if (value != null) {
			if ($gOPD$2 && (i + 1) >= parts.length) {
				var desc = $gOPD$2(value, part);
				isOwn = !!desc;

				if (!allowMissing && !(part in value)) {
					throw new $TypeError$e('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS$1[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$1 = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $defineProperty = getIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind() {
	return $reflectApply(functionBind, $call, arguments);
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});

var numberIsNaN = function (value) {
	return value !== value;
};

var implementation$3 = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

var polyfill$2 = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation$3;
};

var shim$1 = function shimObjectIs() {
	var polyfill = polyfill$2();
	defineProperties_1(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$3 = callBind$1(polyfill$2(), Object);

defineProperties_1(polyfill$3, {
	getPolyfill: polyfill$2,
	implementation: implementation$3,
	shim: shim$1
});

var objectIs = polyfill$3;

var build = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = shallowEqual;



var _objectIs2 = _interopRequireDefault(objectIs);



var _has2 = _interopRequireDefault(src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// adapted from https://github.com/facebook/react/blob/144328fe81719e916b946e22660479e31561bb0b/packages/shared/shallowEqual.js#L36-L68
function shallowEqual(objA, objB) {
  if ((0, _objectIs2['default'])(objA, objB)) {
    return true;
  }

  if (!objA || !objB || (typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object') {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  keysA.sort();
  keysB.sort();

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i += 1) {
    if (!(0, _has2['default'])(objB, keysA[i]) || !(0, _objectIs2['default'])(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}


});

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized$1;

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$2 = _defineProperty;

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

function isValidMoment(testMoment) {
  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
    return false;
  }

  /* istanbul ignore else  */
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  /* istanbul ignore next */
  return !isNaN(testMoment);
}

var momentValidationWrapper = {
  isValidMoment : isValidMoment,
};

var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid ',
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` ' + messages.requiredCore +
    ' in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;

    var preValidationRequireCheckValue = preValidationRequireCheck(
      isRequired, componentName, propFullName, propValue
    );

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (!validator(propValue)) {
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  return constructPropValidatorVariations(propValidator);

}

var core = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages,
};

var src$1 = {

  momentObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : core.createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(moment(value));
    },
    'Moment'
  ),

  momentDurationObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return moment.isDuration(value);
    },
    'Duration'
  ),

};

function noop() {
  return null;
}

noop.isRequired = noop;

function noopThunk() {
  return noop;
}

var mocks = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  predicate: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringEndsWith: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
};

var $indexOf$1 = callBind$1(getIntrinsic('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf$1(name, '.prototype.') > -1) {
		return callBind$1(intrinsic);
	}
	return intrinsic;
};

// modified from https://github.com/es-shims/es6-shim

var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols$5 = shams();

var toObject = Object;
var $push = callBound$1('Array.prototype.push');
var $propIsEnumerable = callBound$1('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols$5 ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
var implementation$4 = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject(arguments[s]);
		props = objectKeys(source);
		var getSymbols = hasSymbols$5 && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if ($propIsEnumerable(source, key)) {
					$push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if ($propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

var polyfill$4 = function getPolyfill() {
	if (!Object.assign) {
		return implementation$4;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation$4;
	}
	if (assignHasPendingExceptions()) {
		return implementation$4;
	}
	return Object.assign;
};

var shim$2 = function shimAssign() {
	var polyfill = polyfill$4();
	defineProperties_1(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

var polyfill$5 = callBind$1.apply(polyfill$4());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill$5(Object, arguments);
};

defineProperties_1(bound, {
	getPolyfill: polyfill$4,
	implementation: implementation$4,
	shim: shim$2
});

var object_assign = bound;

var isPlainObject_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = isPlainObject;
function isPlainObject(x) {
  return x && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && !Array.isArray(x);
}
module.exports = exports['default'];

});

var build$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = forbidExtraProps;



var _object2 = _interopRequireDefault(object_assign);



var _has2 = _interopRequireDefault(src);



var _isPlainObject2 = _interopRequireDefault(isPlainObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zeroWidthSpace = '\u200B';
var specialProperty = 'prop-types-exact: ' + zeroWidthSpace;
var semaphore = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for'](specialProperty) : /* istanbul ignore next */specialProperty;

function brand(fn) {
  return (0, _object2['default'])(fn, _defineProperty({}, specialProperty, semaphore));
}

function isBranded(value) {
  return value && value[specialProperty] === semaphore;
}

function forbidExtraProps(propTypes) {
  if (!(0, _isPlainObject2['default'])(propTypes)) {
    throw new TypeError('given propTypes must be an object');
  }
  if ((0, _has2['default'])(propTypes, specialProperty) && !isBranded(propTypes[specialProperty])) {
    throw new TypeError('Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`');
  }

  return (0, _object2['default'])({}, propTypes, _defineProperty({}, specialProperty, brand(function () {
    function forbidUnknownProps(props, _, componentName) {
      var unknownProps = Object.keys(props).filter(function (prop) {
        return !(0, _has2['default'])(propTypes, prop);
      });
      if (unknownProps.length > 0) {
        return new TypeError(String(componentName) + ': unknown props found: ' + String(unknownProps.join(', ')));
      }
      return null;
    }

    return forbidUnknownProps;
  }())));
}
module.exports = exports['default'];

});

var wrapValidator_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapValidator;

var _object = _interopRequireDefault(object_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function wrapValidator(validator, typeName) {
  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _object["default"])(validator.bind(), {
    typeName: typeName,
    typeChecker: typeChecker,
    isRequired: (0, _object["default"])(validator.isRequired.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
}

});

var and = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = andValidator;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function andValidator(validators) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';

  if (!Array.isArray(validators)) {
    throw new TypeError('and: 2 or more validators are required');
  }

  if (validators.length <= 1) {
    throw new RangeError('and: 2 or more validators are required');
  }

  var validator = function and() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var firstError = null;
    validators.some(function (validatorFn) {
      firstError = validatorFn.apply(void 0, args);
      return firstError != null;
    });
    return firstError == null ? null : firstError;
  };

  validator.isRequired = function andIsRequired() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var firstError = null;
    validators.some(function (validatorFn) {
      firstError = validatorFn.isRequired.apply(validatorFn, args);
      return firstError != null;
    });
    return firstError == null ? null : firstError;
  };

  return (0, _wrapValidator["default"])(validator, name, validators);
}

});

/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/

var undefined$3;

var $SyntaxError$2 = SyntaxError;
var $Function$2 = Function;
var $TypeError$f = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor$1 = function (expressionSyntax) {
	try {
		// eslint-disable-next-line no-new-func
		return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$3 = Object.getOwnPropertyDescriptor;
if ($gOPD$3) {
	try {
		$gOPD$3({}, '');
	} catch (e) {
		$gOPD$3 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError$2 = function () { throw new $TypeError$f(); };
var ThrowTypeError$2 = $gOPD$3
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError$2;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$3(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError$2;
			}
		}
	}())
	: throwTypeError$2;

var hasSymbols$6 = hasSymbols$1();

var getProto$2 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var asyncGenFunction$2 = getEvalledConstructor$1('async function* () {}');
var asyncGenFunctionPrototype$1 = asyncGenFunction$2 ? asyncGenFunction$2.prototype : undefined$3;
var asyncGenPrototype$1 = asyncGenFunctionPrototype$1 ? asyncGenFunctionPrototype$1.prototype : undefined$3;

var TypedArray$2 = typeof Uint8Array === 'undefined' ? undefined$3 : getProto$2(Uint8Array);

var INTRINSICS$2 = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$3 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$3 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$6 ? getProto$2([][Symbol.iterator]()) : undefined$3,
	'%AsyncFromSyncIteratorPrototype%': undefined$3,
	'%AsyncFunction%': getEvalledConstructor$1('async function () {}'),
	'%AsyncGenerator%': asyncGenFunctionPrototype$1,
	'%AsyncGeneratorFunction%': asyncGenFunction$2,
	'%AsyncIteratorPrototype%': asyncGenPrototype$1 ? getProto$2(asyncGenPrototype$1) : undefined$3,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$3 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$3 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$3 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$3 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$3 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$3 : FinalizationRegistry,
	'%Function%': $Function$2,
	'%GeneratorFunction%': getEvalledConstructor$1('function* () {}'),
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$3 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$3 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$3 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$6 ? getProto$2(getProto$2([][Symbol.iterator]())) : undefined$3,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$3,
	'%Map%': typeof Map === 'undefined' ? undefined$3 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$6 ? undefined$3 : getProto$2(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$3 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$3 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$3 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$3 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$6 ? undefined$3 : getProto$2(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$3 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$6 ? getProto$2(''[Symbol.iterator]()) : undefined$3,
	'%Symbol%': hasSymbols$6 ? Symbol : undefined$3,
	'%SyntaxError%': $SyntaxError$2,
	'%ThrowTypeError%': ThrowTypeError$2,
	'%TypedArray%': TypedArray$2,
	'%TypeError%': $TypeError$f,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$3 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$3 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$3 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$3 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$3 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$3 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$3 : WeakSet
};

var LEGACY_ALIASES$1 = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply$1 = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$3 = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$2 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$2 = function stringToPath(string) {
	var result = [];
	$replace$3(string, rePropName$2, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$3(subString, reEscapeChar$2, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic$2 = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES$1, intrinsicName)) {
		alias = LEGACY_ALIASES$1[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS$2, intrinsicName)) {
		var value = INTRINSICS$2[intrinsicName];
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$f('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$2('intrinsic ' + name + ' does not exist!');
};

var GetIntrinsic$1 = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$f('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$f('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$2(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic$2('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply$1(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS$2, intrinsicRealName)) {
			value = INTRINSICS$2[intrinsicRealName];
		} else if (value != null) {
			if ($gOPD$3 && (i + 1) >= parts.length) {
				var desc = $gOPD$3(value, part);
				isOwn = !!desc;

				if (!allowMissing && !(part in value)) {
					throw new $TypeError$f('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS$2[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var $TypeError$g = GetIntrinsic$1('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

var CheckObjectCoercible$1 = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$g(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible$1 = CheckObjectCoercible$1;

var $isEnumerable$2 = callBound$1('Object.prototype.propertyIsEnumerable');

var implementation$5 = function entries(O) {
	var obj = RequireObjectCoercible$1(O);
	var entrys = [];
	for (var key in obj) {
		if (src(obj, key) && $isEnumerable$2(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};

var polyfill$6 = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation$5;
};

var shim$3 = function shimEntries() {
	var polyfill = polyfill$6();
	defineProperties_1(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$7 = callBind$1(polyfill$6(), Object);

defineProperties_1(polyfill$7, {
	getPolyfill: polyfill$6,
	implementation: implementation$5,
	shim: shim$3
});

var object_entries = polyfill$7;

var isPlainObject = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(isPlainObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _isPlainObject["default"];
exports["default"] = _default;

});

var shape = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shapeValidator;

var _isPlainObject = _interopRequireDefault(isPlainObject);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function shapeValidator(shapeTypes) {
  if (!(0, _isPlainObject["default"])(shapeTypes)) {
    throw new TypeError('shape must be a normal object');
  }

  function shape(props, propName, componentName, location) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    } // code adapted from PropTypes.shape: https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L381
    // eslint-disable-next-line guard-for-in, no-restricted-syntax


    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    for (var key in shapeTypes) {
      var checker = shapeTypes[key];

      if (checker) {
        var error = checker.apply(void 0, [propValue, key, componentName, location].concat(rest));

        if (error) {
          return error;
        }
      }
    }

    return null;
  }

  shape.isRequired = function shapeRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return shape.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(shape, 'shape', shapeTypes);
}

});

var isPrimitive_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrimitive;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isPrimitive(x) {
  return !x || _typeof(x) !== 'object' && typeof x !== 'function';
}

});

var valuesOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = valuesOfValidator;

var _isPrimitive = _interopRequireDefault(isPrimitive_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L307-L340
function valuesOfValidator(propType) {
  if (typeof propType !== 'function') {
    throw new TypeError('objectOf: propType must be a function');
  }

  var validator = function valuesOf(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];

    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
      return null;
    }

    var firstError;
    Object.keys(propValue).some(function (key) {
      firstError = propType.apply(void 0, [propValue, key, componentName, location, "".concat(propFullName, ".").concat(key)].concat(rest));
      return firstError;
    });
    return firstError || null;
  };

  validator.isRequired = function valuesOfRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'valuesOf', propType);
}

});

var between = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = betweenValidator;

var _object = _interopRequireDefault(object_entries);

var _shape = _interopRequireDefault(shape);

var _valuesOf = _interopRequireDefault(valuesOf);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function number(props, propName, componentName) {
  var value = props[propName];

  if (typeof value === 'number' && !isNaN(value)) {
    return null;
  }

  return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
}

function numberOrPropsFunc(props, propName) {
  var value = props[propName];

  if (typeof value === 'function') {
    return null;
  }

  if (typeof value === 'number' && !isNaN(value)) {
    return null;
  }

  return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
}

function lowerCompare(value, _ref) {
  var gt = _ref.gt,
      gte = _ref.gte;

  if (typeof gt === 'number') {
    return value > gt;
  }

  if (typeof gte === 'number') {
    return value >= gte;
  }

  return true;
}

function upperCompare(value, _ref2) {
  var lt = _ref2.lt,
      lte = _ref2.lte;

  if (typeof lt === 'number') {
    return value < lt;
  }

  if (typeof lte === 'number') {
    return value <= lte;
  }

  return true;
}

function greaterThanError(_ref3) {
  var gt = _ref3.gt,
      gte = _ref3.gte;

  if (typeof gt === 'number') {
    return "greater than ".concat(gt);
  }

  if (typeof gte === 'number') {
    return "greater than or equal to ".concat(gte);
  }

  return '';
}

function lessThanError(_ref4) {
  var lt = _ref4.lt,
      lte = _ref4.lte;

  if (typeof lt === 'number') {
    return "less than ".concat(lt);
  }

  if (typeof lte === 'number') {
    return "less than or equal to ".concat(lte);
  }

  return '';
}

function errorMessage(componentName, propName, opts) {
  var errors = [greaterThanError(opts), lessThanError(opts)].filter(Boolean).join(' and ');
  return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
}

function propsThunkify(opts) {
  return (0, _object["default"])(opts).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    var numberThunk = typeof value === 'number' ? function () {
      return value;
    } : value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, numberThunk));
  }, {});
}

function invokeWithProps(optsThunks, props) {
  return (0, _object["default"])(optsThunks).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        thunk = _ref8[1];

    var value = thunk(props);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});
}

var argValidators = [(0, _shape["default"])({
  lt: numberOrPropsFunc,
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc,
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lt: numberOrPropsFunc,
  gte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc,
  gte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  gte: numberOrPropsFunc
}).isRequired];

function argValidator(props, propName) {
  return argValidators.every(function (validator) {
    return !!validator(props, propName);
  });
}

var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;

function betweenValidator(options) {
  var argError = argValidator({
    options: options
  }, 'options');

  if (argError) {
    throw new TypeError('between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.');
  }

  var optsThunks = propsThunkify(options);

  var validator = function between(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    if (typeof propValue !== 'number') {
      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
    }

    var opts = invokeWithProps(optsThunks, props);

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

    if (thunkValuesError) {
      return thunkValuesError;
    }

    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
      return new RangeError(errorMessage(componentName, propName, opts));
    }

    return null;
  };

  validator.isRequired = function betweenRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (typeof propValue !== 'number') {
      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
    }

    var opts = invokeWithProps(optsThunks, props);

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

    if (thunkValuesError) {
      return thunkValuesError;
    }

    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
      return new RangeError(errorMessage(componentName, propName, opts));
    }

    return null;
  };

  return (0, _wrapValidator["default"])(validator, 'between', options);
}

});

var booleanSome = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = booleanSomeValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function booleanSomeValidator() {
  for (var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++) {
    notAllPropsFalse[_key] = arguments[_key];
  }

  if (notAllPropsFalse.length < 1) {
    throw new TypeError('at least one prop (one of which must be `true`) is required');
  }

  if (!notAllPropsFalse.every(function (x) {
    return typeof x === 'string';
  })) {
    throw new TypeError('all booleanSome props must be strings');
  }

  var propsList = notAllPropsFalse.join(', or ');

  var validator = function booleanSome(props, propName, componentName) {
    var countFalse = function countFalse(count, prop) {
      return count + (props[prop] === false ? 1 : 0);
    };

    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

    if (falsePropCount === notAllPropsFalse.length) {
      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function booleanSomeRequired(props, propName, componentName) {
    var countFalse = function countFalse(count, prop) {
      return count + (props[prop] === false ? 1 : 0);
    };

    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

    if (falsePropCount === notAllPropsFalse.length) {
      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "booleanSome: ".concat(propsList), notAllPropsFalse);
}

});

var childrenHavePropXorChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenHavePropXorChildren;

var _react = _interopRequireDefault(React);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function childrenHavePropXorChildren(prop) {
  if (typeof prop !== 'string' && _typeof(prop) !== 'symbol') {
    throw new TypeError('invalid prop: must be string or symbol');
  }

  var validator = function childrenHavePropXorChildrenWithProp(_ref, _, componentName) {
    var children = _ref.children;
    var truthyChildrenCount = 0;
    var propCount = 0;
    var grandchildrenCount = 0;

    _react["default"].Children.forEach(children, function (child) {
      if (!child) {
        return;
      }

      truthyChildrenCount += 1;

      if (child.props[prop]) {
        propCount += 1;
      }

      if (_react["default"].Children.count(child.props.children)) {
        grandchildrenCount += 1;
      }
    });

    if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) {
      return null;
    }

    return new TypeError("`".concat(componentName, "` requires children to all have prop \u201C").concat(prop, "\u201D, all have children, or all have neither."));
  };

  validator.isRequired = validator;
  return (0, _wrapValidator["default"])(validator, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
}

});

var renderableChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderableChildren;

var _react = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function renderableChildren(childrenProp) {
  return _react["default"].Children.toArray(childrenProp).filter(function (child) {
    return child === 0 || child;
  });
}

});

var childrenOf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenOf;

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function validateChildren(propType, children, props) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var error;
  children.some(function (child) {
    error = propType.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
      children: child
    }), 'children'].concat(rest));
    return error;
  });
  return error || null;
}

function childrenOf(propType) {
  function childrenOfPropType(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
  }

  childrenOfPropType.isRequired = function (props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
    }

    var children = (0, _renderableChildren["default"])(props[propName]);

    if (children.length === 0) {
      return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(childrenOfPropType, 'childrenOf', propType);
}

});

var implementation$6 = function find(predicate) {
	var list = ToObject(this);
	var length = ToLength(list.length);
	if (!IsCallable(predicate)) {
		throw new TypeError('Array#find: predicate must be a function');
	}
	if (length === 0) {
		return void 0;
	}
	var thisArg;
	if (arguments.length > 0) {
		thisArg = arguments[1];
	}

	for (var i = 0, value; i < length; i++) {
		value = list[i];
		// inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
		if (predicate.apply(thisArg, [value, i, list])) {
			return value;
		}
	}
	return void 0;
};

var polyfill$8 = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	// eslint-disable-next-line no-sparse-arrays
	var implemented = Array.prototype.find && [, 1].find(function () {
		return true;
	}) !== 1;

	// eslint-disable-next-line global-require
	return implemented ? Array.prototype.find : implementation$6;
};

var shim$4 = function shimArrayPrototypeFind() {
	var polyfill = polyfill$8();

	defineProperties_1(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};

var slice$2 = Array.prototype.slice;

var polyfill$9 = polyfill$8();

var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
	RequireObjectCoercible(array);
	var args = slice$2.call(arguments, 1);
	return polyfill$9.apply(array, args);
};

defineProperties_1(boundFindShim, {
	getPolyfill: polyfill$8,
	implementation: implementation$6,
	shim: shim$4
});

var array_prototype_find = boundFindShim;

var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD$1 = Object.getOwnPropertyDescriptor;
if (gOPD$1) {
	try {
		gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD$1 = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	return functionsHaveNames() && gOPD$1 && !!gOPD$1(function () {}, 'name').configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

var functionsHaveNames$1 = functionsHaveNames_1();

var $functionToString = callBound('Function.prototype.toString');
var $stringMatch = callBound('String.prototype.match');

var classRegex = /^class /;

var isClass = function isClassConstructor(fn) {
	if (IsCallable(fn)) {
		return false;
	}
	if (typeof fn !== 'function') {
		return false;
	}
	try {
		var match = $stringMatch($functionToString(fn), classRegex);
		return !!match;
	} catch (e) {}
	return false;
};

var regex = /\s*function\s+([^(\s]*)\s*/;

var functionProto = Function.prototype;

var implementation$7 = function getName() {
	if (!isClass(this) && !IsCallable(this)) {
		throw new TypeError('Function.prototype.name sham getter called on non-function');
	}
	if (functionsHaveNames$1) {
		return this.name;
	}
	if (this === functionProto) {
		return '';
	}
	var str = $functionToString(this);
	var match = $stringMatch(str, regex);
	var name = match && match[1];
	return name;
};

var polyfill$a = function getPolyfill() {
	return implementation$7;
};

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var functionsHaveNames$2 = functionsHaveNames_1();

var defineProperty$3 = Object.defineProperty;
var TypeErr = TypeError;

var shim$5 = function shimName() {
	var polyfill = polyfill$a();
	if (functionsHaveNames$2) {
		return polyfill;
	}
	if (!supportsDescriptors$1) {
		throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
	}
	var functionProto = Function.prototype;
	defineProperty$3(functionProto, 'name', {
		configurable: true,
		enumerable: false,
		get: function () {
			var name = polyfill.call(this);
			if (this !== functionProto) {
				defineProperty$3(this, 'name', {
					configurable: true,
					enumerable: false,
					value: name,
					writable: false
				});
			}
			return name;
		}
	});
	return polyfill;
};

var bound$1 = callBind(implementation$7);

defineProperties_1(bound$1, {
	getPolyfill: polyfill$a,
	implementation: implementation$7,
	shim: shim$5
});

var function_prototype_name = bound$1;

var getComponentName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getComponentName;

var _functionPrototype = _interopRequireDefault(function_prototype_name);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getComponentName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return Component.displayName || (0, _functionPrototype["default"])(Component);
  }

  if ((0, reactIs.isForwardRef)({
    type: Component,
    $$typeof: reactIs.Element
  })) {
    return Component.displayName;
  }

  if ((0, reactIs.isMemo)(Component)) {
    return getComponentName(Component.type);
  }

  return null;
}

});

var childrenOfType_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = _interopRequireDefault(array_prototype_find);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function onlyTypes(types, children, componentName) {
  if (!children.every(function (child) {
    return child && (0, _arrayPrototype["default"])(types, function (Type) {
      return Type === '*' || child.type === Type;
    });
  })) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
  }

  return null;
}

function isRequired(types, children, componentName) {
  if (children.length === 0) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
  }

  return null;
}

function childrenOfType() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  if (types.length < 1) {
    throw new TypeError('childrenOfType: at least 1 type is required');
  }

  function validator(props, propName, componentName) {
    return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
  }

  validator.isRequired = function (props, propName, componentName) {
    var children = (0, _renderableChildren["default"])(props[propName]);
    return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
  };

  return (0, _wrapValidator["default"])(validator, 'childrenOfType', types);
}

var _default = childrenOfType;
exports["default"] = _default;

});

var isInteger = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var floor = Math.floor;
var finite = isFinite;

var _default = Number.isInteger ||
/* istanbul ignore next */
function (x) {
  return typeof x === 'number' && finite(x) && floor(x) === x;
};

exports["default"] = _default;

});

var integer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isInteger = _interopRequireDefault(isInteger);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function requiredInteger(props, propName, componentName) {
  var propValue = props[propName];

  if (propValue == null || !(0, _isInteger["default"])(propValue)) {
    return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
  }

  return null;
}

var validator = function integer(props, propName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  return requiredInteger.apply(void 0, [props, propName].concat(rest));
};

validator.isRequired = requiredInteger;

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'integer');
};

exports["default"] = _default;

});

var nonNegativeNumber_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectIs = _interopRequireDefault(objectIs);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isNonNegative(x) {
  return typeof x === 'number' && isFinite(x) && x >= 0 && !(0, _objectIs["default"])(x, -0);
}

function nonNegativeNumber(props, propName, componentName) {
  var value = props[propName];

  if (value == null || isNonNegative(value)) {
    return null;
  }

  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
}

function requiredNonNegativeNumber(props, propName, componentName) {
  var value = props[propName];

  if (isNonNegative(value)) {
    return null;
  }

  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
}

nonNegativeNumber.isRequired = requiredNonNegativeNumber;

var _default = function _default() {
  return (0, _wrapValidator["default"])(nonNegativeNumber, 'nonNegativeNumber');
};

exports["default"] = _default;

});

var nonNegativeInteger = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _and = _interopRequireDefault(and);

var _integer = _interopRequireDefault(integer);

var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], 'nonNegativeInteger');

exports["default"] = _default;

});

var typeOf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = typeOf;

var _react = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function typeOf(child) {
  if (child === null) {
    return 'null';
  }

  if (Array.isArray(child)) {
    return 'array';
  }

  if (_typeof(child) !== 'object') {
    return _typeof(child);
  }

  if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
    return child.type;
  }

  return child;
}

});

var object_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(isPlainObject);

var _typeOf = _interopRequireDefault(typeOf_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
  code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L202-L206
  so that it can be called outside of React's normal PropType flow
*/
var ReactPropTypeLocationNames = {
  prop: 'prop',
  context: 'context',
  childContext: 'child context'
};

function object(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  if ((0, _isPlainObject["default"])(propValue)) {
    return null;
  }

  var locationName = ReactPropTypeLocationNames[location] || location;
  return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
}

object.isRequired = function objectRequired(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (propValue == null) {
    var locationName = ReactPropTypeLocationNames[location] || location;
    return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
  }

  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    rest[_key - 5] = arguments[_key];
  }

  return object.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(object, 'object');
};

exports["default"] = _default;

});

var withShape_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withShape;

var _and = _interopRequireDefault(and);

var _shape = _interopRequireDefault(shape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function withShape(type, shapeTypes) {
  if (typeof type !== 'function') {
    throw new TypeError('type must be a valid PropType');
  }

  var shapeValidator = (0, _shape["default"])(shapeTypes);
  return (0, _and["default"])([type, shapeValidator], 'withShape');
}

});

var sequenceOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sequenceOfValidator;



var _and = _interopRequireDefault(and);

var _between = _interopRequireDefault(between);

var _nonNegativeInteger = _interopRequireDefault(nonNegativeInteger);

var _object = _interopRequireDefault(object_1);

var _withShape = _interopRequireDefault(withShape_1);

var _typeOf = _interopRequireDefault(typeOf_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var minValidator = _nonNegativeInteger["default"];
var maxValidator = (0, _and["default"])([_nonNegativeInteger["default"], (0, _between["default"])({
  gte: 1
})]);

function validateRange(min, max) {
  if (typeof max !== 'number' || typeof min !== 'number') {
    return null; // no additional checking needed unless both are present
  }

  if (min <= max) {
    return null;
  }

  return new RangeError('min must be less than or equal to max');
}

var specifierShape = {
  validator: function validator(props, propName) {
    var propValue = props[propName];

    if (typeof propValue !== 'function') {
      return new TypeError('"validator" must be a propType validator function');
    }

    return null;
  },
  min: function min(props, propName) {
    return minValidator(props, propName) || validateRange(props.min, props.max);
  },
  max: function max(props, propName) {
    return maxValidator(props, propName) || validateRange(props.min, props.max);
  }
};

function getMinMax(_ref) {
  var min = _ref.min,
      max = _ref.max;
  var minimum;
  var maximum;

  if (typeof min !== 'number' && typeof max !== 'number') {
    // neither provided, default to "1"
    minimum = 1;
    maximum = 1;
  } else {
    minimum = typeof min === 'number' ? min : 1;
    maximum = typeof max === 'number' ? max : Infinity;
  }

  return {
    minimum: minimum,
    maximum: maximum
  };
}

function chunkByType(items) {
  var chunk = [];
  var lastType;
  return items.reduce(function (chunks, item) {
    var itemType = (0, _typeOf["default"])(item);

    if (!lastType || itemType === lastType) {
      chunk.push(item);
    } else {
      chunks.push(chunk);
      chunk = [item];
    }

    lastType = itemType;
    return chunks;
  }, []).concat(chunk.length > 0 ? [chunk] : []);
}

function validateChunks(specifiers, props, propName, componentName) {
  var items = props[propName];
  var chunks = chunkByType(items);

  for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    rest[_key - 4] = arguments[_key];
  }

  for (var i = 0; i < specifiers.length; i += 1) {
    var _specifiers$i = specifiers[i],
        validator = _specifiers$i.validator,
        min = _specifiers$i.min,
        max = _specifiers$i.max;

    var _getMinMax = getMinMax({
      min: min,
      max: max
    }),
        minimum = _getMinMax.minimum,
        maximum = _getMinMax.maximum;

    if (chunks.length === 0 && minimum === 0) {
      // no chunks left, but this specifier does not require any items
      continue; // eslint-disable-line no-continue
    }

    var arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;
    var chunk = chunks.shift(); // extract the next chunk to test

    var chunkError = arrayOfValidator.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, chunk)), propName, componentName].concat(rest));

    if (chunkError) {
      // this chunk is invalid
      if (minimum === 0) {
        // but, specifier has a min of 0 and can be skipped
        chunks.unshift(chunk); // put the chunk back, for the next iteration

        continue; // eslint-disable-line no-continue
      }

      return chunkError;
    } // chunk is valid!


    if (chunk.length < minimum) {
      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min, " items, but only has ").concat(chunk.length, "."));
    }

    if (chunk.length > maximum) {
      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max, " items, but has ").concat(chunk.length, "."));
    }
  }

  if (chunks.length > 0) {
    return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
  }

  return null;
}

var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;

function sequenceOfValidator() {
  for (var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    specifiers[_key2] = arguments[_key2];
  }

  if (specifiers.length === 0) {
    throw new RangeError('sequenceOf: at least one specifier is required');
  }

  var errors = specifiers.map(function (specifier, i) {
    return specifierValidator({
      specifier: specifier
    }, 'specifier', 'sequenceOf specifier', "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
  });

  if (errors.some(Boolean)) {
    throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function (e, i) {
      return " - Argument index ".concat(i, ": ").concat(e.message);
    }).join(',\n        '), "\n    "));
  }

  var validator = function sequenceOf(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      rest[_key3 - 2] = arguments[_key3];
    }

    var error = _propTypes.array.apply(void 0, [props, propName].concat(rest));

    if (error) {
      return error;
    }

    return validateChunks.apply(void 0, [specifiers, props, propName].concat(rest));
  };

  validator.isRequired = function sequenceOfRequired(props, propName, componentName) {
    for (var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
      rest[_key4 - 3] = arguments[_key4];
    }

    var error = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));

    if (error) {
      return error;
    }

    return validateChunks.apply(void 0, [specifiers, props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'sequenceOf', specifiers);
}

});

var childrenSequenceOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenSequenceOfValidator;

var _sequenceOf = _interopRequireDefault(sequenceOf);

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function childrenSequenceOfValidator() {
  for (var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++) {
    specifiers[_key] = arguments[_key];
  }

  var seq = _sequenceOf["default"].apply(void 0, specifiers);

  var validator = function childrenSequenceOf(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];
    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return seq.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
      children: children
    }), propName, componentName].concat(rest));
  };

  validator.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];
    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return new TypeError("".concat(componentName, ": renderable children are required."));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return seq.isRequired.apply(seq, [_objectSpread(_objectSpread({}, props), {}, {
      children: children
    }), propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'childrenSequenceOf', specifiers);
}

});

var hasSymbols$7 = hasSymbols$1();
var hasToStringTag$3 = hasSymbols$7 && typeof Symbol.toStringTag === 'symbol';
var regexExec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$3) {
	regexExec$1 = Function.call.bind(RegExp.prototype.exec);
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var toStr$9 = Object.prototype.toString;
var regexClass$1 = '[object RegExp]';

var isRegex$1 = hasToStringTag$3
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		try {
			regexExec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return toStr$9.call(value) === regexClass$1;
	};

var componentWithName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = componentWithName;

var _react = _interopRequireDefault(React);

var _isRegex = _interopRequireDefault(isRegex$1);

var _arrayPrototype = _interopRequireDefault(array_prototype_find);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stripHOCs(fullName, namesOfHOCsToStrip) {
  var innerName = fullName;

  while (/\([^()]*\)/g.test(innerName)) {
    var HOC = innerName;
    var previousHOC = void 0;

    do {
      previousHOC = HOC;
      HOC = previousHOC.replace(/\([^()]*\)/g, '');
    } while (previousHOC !== HOC);

    if (namesOfHOCsToStrip.indexOf(HOC) === -1) {
      return innerName;
    }

    innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), 'g'), '');
  }

  return innerName;
}

function hasName(name, namesOfHOCsToStrip, propValue, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    rest[_key - 5] = arguments[_key];
  }

  if (Array.isArray(propValue)) {
    return (0, _arrayPrototype["default"])(propValue.map(function (item) {
      return hasName.apply(void 0, [name, namesOfHOCsToStrip, item, propName, componentName].concat(rest));
    }), Boolean) || null;
  }

  if (! /*#__PURE__*/_react["default"].isValidElement(propValue)) {
    return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
  }

  var type = propValue.type;
  var componentNameFromType = (0, _getComponentName["default"])(type);
  var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;

  if ((0, _isRegex["default"])(name) && !name.test(innerComponentName)) {
    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name));
  }

  if (!(0, _isRegex["default"])(name) && innerComponentName !== name) {
    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name, ", got ").concat(innerComponentName));
  }

  return null;
}

function componentWithName(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof name !== 'string' && !(0, _isRegex["default"])(name)) {
    throw new TypeError('name must be a string or a regex');
  }

  var passedOptions = Object.keys(options);

  if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== 'stripHOCs') {
    throw new TypeError("The only options supported are: \u201CstripHOCs\u201D, got: \u201C".concat(passedOptions.join('”, “'), "\u201D"));
  }

  var _options$stripHOCs = options.stripHOCs,
      namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
  var allHOCNamesAreValid = namesOfHOCsToStrip.every(function (x) {
    if (typeof x !== 'string' || /[()]/g.test(x)) {
      return false;
    }

    return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x);
  });

  if (!allHOCNamesAreValid) {
    throw new TypeError('every provided HOC name must be a string with no parens, and in camelCase');
  }

  function componentWithNameValidator(props, propName, componentName) {
    var propValue = props[propName];

    if (props[propName] == null) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
  }

  componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name), name);
}

});

var disallowedIf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = disallowedIf;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function disallowedIf(propType, otherPropName, otherPropType) {
  if (typeof propType !== 'function' || typeof propType.isRequired !== 'function') {
    throw new TypeError('a propType validator is required; propType validators must also provide `.isRequired`');
  }

  if (typeof otherPropName !== 'string') {
    throw new TypeError('other prop name must be a string');
  }

  if (typeof otherPropType !== 'function') {
    throw new TypeError('other prop type validator is required');
  }

  function disallowedIfRequired(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var error = propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));

    if (error) {
      return error;
    }

    if (props[otherPropName] == null) {
      return null;
    }

    var otherError = otherPropType.apply(void 0, [props, otherPropName, componentName].concat(rest));

    if (otherError) {
      return null;
    }

    return new Error("prop \u201C".concat(propName, "\u201D is disallowed when \u201C").concat(otherPropName, "\u201D matches the provided validator"));
  }

  var validator = function disallowedIfPropType(props, propName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    return disallowedIfRequired.apply(void 0, [props, propName].concat(rest));
  };

  validator.isRequired = disallowedIfRequired;
  return (0, _wrapValidator["default"])(validator, 'disallowedIf', {
    propType: propType,
    otherPropName: otherPropName,
    otherPropType: otherPropType
  });
}

});

var elementType = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = elementTypeValidator;





var _and = _interopRequireDefault(and);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getTypeName(Type) {
  if (typeof Type === 'string') {
    return Type;
  }

  var type = (0, _getComponentName["default"])(Type);
  /* istanbul ignore next */
  // in environments where functions do not have names

  return type || 'Anonymous Component';
}

function validateElementType(Type, props, propName, componentName) {
  var type = props[propName].type;

  if (type === Type) {
    return null;
  }

  return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type)));
}

function elementTypeValidator(Type) {
  if (Type === '*') {
    return (0, _wrapValidator["default"])(_propTypes.element, 'elementType(*)', Type);
  }

  if (!(0, reactIs.isValidElementType)(Type)) {
    throw new TypeError("Type must be a React Component, an HTML element tag name, or \"*\". Got an ".concat(_typeof(Type)));
  }

  function elementType(props, propName, componentName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return validateElementType.apply(void 0, [Type, props, propName, componentName].concat(rest));
  }

  elementType.isRequired = elementType; // covered by and + element

  var typeName = getTypeName(Type);
  var validatorName = "elementType(".concat(typeName, ")");
  return (0, _wrapValidator["default"])((0, _and["default"])([_propTypes.element, elementType], validatorName), validatorName, Type);
}

});

var or_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = or;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function oneOfTypeValidator(validators) {
  var validator = function oneOfType(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var propValue = props[propName];

    if (typeof propValue === 'undefined') {
      return null;
    }

    var errors = validators.map(function (v) {
      return v.apply(void 0, [props, propName, componentName].concat(rest));
    }).filter(Boolean);

    if (errors.length < validators.length) {
      return null;
    }

    return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
  };

  validator.isRequired = function oneOfTypeRequired(props, propName, componentName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    var propValue = props[propName];

    if (typeof propValue === 'undefined') {
      return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
    }

    var errors = validators.map(function (v) {
      return v.apply(void 0, [props, propName, componentName].concat(rest));
    }).filter(Boolean);

    if (errors.length === validators.length) {
      return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
    }

    return null;
  };

  return (0, _wrapValidator["default"])(validator, 'oneOfType', validators);
}

function or(validators) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';

  if (!Array.isArray(validators)) {
    throw new TypeError('or: 2 or more validators are required');
  }

  if (validators.length <= 1) {
    throw new RangeError('or: 2 or more validators are required');
  }

  var validator = oneOfTypeValidator([(0, _propTypes.arrayOf)(oneOfTypeValidator(validators))].concat(_toConsumableArray(validators)));
  return (0, _wrapValidator["default"])(validator, name, validators);
}

});

var explicitNull_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function explicitNull(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null or undefined; received ").concat(_typeof(props[propName])));
}

explicitNull.isRequired = function explicitNullRequired(props, propName, componentName) {
  if (props[propName] === null) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null; received ").concat(_typeof(props[propName])));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(explicitNull, 'explicitNull');
};

exports["default"] = _default;

});

var empty = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _or = _interopRequireDefault(or_1);

var _explicitNull = _interopRequireDefault(explicitNull_1);

var _withShape = _interopRequireDefault(withShape_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var arrayOfValidator;
var validator = (0, _or["default"])([_explicitNull["default"], // null/undefined
(0, _propTypes.oneOf)([false, '', NaN]), (0, _withShape["default"])(_propTypes.array, {
  length: (0, _propTypes.oneOf)([0]).isRequired
}).isRequired, function () {
  return arrayOfValidator.apply(void 0, arguments);
}]);
arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'empty');
};

exports["default"] = _default;

});

var keysOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = keysOfValidator;

var _isPrimitive = _interopRequireDefault(isPrimitive_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function keysOfValidator(propType) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keysOf';

  if (typeof propType !== 'function') {
    throw new TypeError('argument to keysOf must be a valid PropType function');
  }

  var validator = function keysOf(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];

    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
      return null;
    }

    var firstError = null;
    Object.keys(propValue).some(function (key) {
      firstError = propType.apply(void 0, [_defineProperty({}, key, key), key, componentName, location, "(".concat(propFullName, ").").concat(key)].concat(rest));
      return firstError != null;
    });
    return firstError || null;
  };

  validator.isRequired = function keyedByRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, name, propType);
}

});

var mutuallyExclusiveProps = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mutuallyExclusiveOfType;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mutuallyExclusiveOfType(propType) {
  if (typeof propType !== 'function') {
    throw new TypeError('a propType is required');
  }

  for (var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    exclusiveProps[_key - 1] = arguments[_key];
  }

  if (exclusiveProps.length < 1) {
    throw new TypeError('at least one prop that is mutually exclusive with this propType is required');
  }

  var propList = exclusiveProps.join(', or ');
  var map = exclusiveProps.reduce(function (acc, prop) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prop, true));
  }, {});

  var countProps = function countProps(count, prop) {
    return count + (map[prop] ? 1 : 0);
  };

  var validator = function mutuallyExclusiveProps(props, propName, componentName) {
    var exclusivePropCount = Object.keys(props).filter(function (prop) {
      return props[prop] != null;
    }).reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
    var exclusivePropCount = Object.keys(props).filter(function (prop) {
      return prop === propName || props[prop] != null;
    }).reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
}

});

var mutuallyExclusiveTrueProps = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mutuallyExclusiveTrue;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function mutuallyExclusiveTrue() {
  for (var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++) {
    exclusiveProps[_key] = arguments[_key];
  }

  if (exclusiveProps.length < 1) {
    throw new TypeError('at least one prop that is mutually exclusive is required');
  }

  if (!exclusiveProps.every(function (x) {
    return typeof x === 'string';
  })) {
    throw new TypeError('all exclusive true props must be strings');
  }

  var propsList = exclusiveProps.join(', or ');

  var validator = function mutuallyExclusiveTrueProps(props, propName, componentName) {
    var countProps = function countProps(count, prop) {
      return count + (props[prop] ? 1 : 0);
    };

    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
    var countProps = function countProps(count, prop) {
      return count + (props[prop] ? 1 : 0);
    };

    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
}

});

var nChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = nChildren;

var _react = _interopRequireDefault(React);



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function nChildren(n) {
  var propType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _propTypes.node;

  if (typeof n !== 'number' || isNaN(n) || n < 0) {
    throw new TypeError('a non-negative number is required');
  }

  var validator = function nChildrenValidator(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
    }

    var children = props.children;

    var childrenCount = _react["default"].Children.count(children);

    if (childrenCount !== n) {
      return new RangeError("".concat(componentName, " expects to receive ").concat(n, " children, but received ").concat(childrenCount, " children."));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = validator;
  return (0, _wrapValidator["default"])(validator, "nChildren:".concat(n), n);
}

});

var numericString = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;

var validator = function numericString(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

  if (stringError) {
    return stringError;
  }

  var value = props[propName];
  var passesRegex = validNumericChars.test(value);

  if (passesRegex) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \"").concat(propName, "\" (value \"").concat(value, "\") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  "));
};

validator.isRequired = function numericStringRequired(props, propName, componentName) {
  if (props[propName] == null) {
    return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
  }

  for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  return validator.apply(void 0, [props, propName, componentName].concat(rest));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'numericString');
};

exports["default"] = _default;

});

var predicate_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = predicate;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function predicate(fn) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof fn !== 'function') {
    throw new TypeError('`fn` must be a function');
  }

  if (typeof message !== 'string') {
    throw new TypeError('`message`, if provided, must be a string');
  }

  function requiredValidator(props, propName, componentName) {
    var result = fn(props[propName]);

    if (result) {
      return null;
    }

    return new TypeError("`".concat(componentName, "` requires that `").concat(propName, "` pass a predicate function").concat(message ? ": ".concat(message) : '', "."));
  }

  function validator(props, propName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return requiredValidator.apply(void 0, [props, propName].concat(rest));
  }

  validator.isRequired = requiredValidator;
  return (0, _wrapValidator["default"])(validator, 'predicate', fn);
}

});

var range_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = range;

var _and = _interopRequireDefault(and);

var _between = _interopRequireDefault(between);

var _integer = _interopRequireDefault(integer);

var _isInteger = _interopRequireDefault(isInteger);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
/* istanbul ignore next */
Math.pow(2, 53) - 1;

function isValidLength(x) {
  return (0, _isInteger["default"])(x) && Math.abs(x) < MAX_SAFE_INTEGER;
}

function range(min, max) {
  if (!isValidLength(min) || !isValidLength(max)) {
    throw new RangeError("\"range\" requires two integers: ".concat(min, " and ").concat(max, " given"));
  }

  if (min === max) {
    throw new RangeError('min and max must not be the same');
  }

  return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
    gte: min,
    lt: max
  })], 'range'), 'range', {
    min: min,
    max: max
  });
}

});

var ref_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _isPlainObject = _interopRequireDefault(isPlainObject);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isPrototypeOf = Object.prototype.isPrototypeOf;

function isNewRef(prop) {
  if (!(0, _isPlainObject["default"])(prop)) {
    return false;
  }

  var ownProperties = Object.keys(prop);
  return ownProperties.length === 1 && ownProperties[0] === 'current';
}

function isCallbackRef(prop) {
  return typeof prop === 'function' && !isPrototypeOf.call(React.Component, prop) && (!React.PureComponent || !isPrototypeOf.call(React.PureComponent, prop));
}

function requiredRef(props, propName, componentName) {
  var propValue = props[propName];

  if (isCallbackRef(propValue) || isNewRef(propValue)) {
    return null;
  }

  return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
}

function ref(props, propName, componentName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
}

ref.isRequired = requiredRef;

var _default = function _default() {
  return (0, _wrapValidator["default"])(ref, 'ref');
};

exports["default"] = _default;

});

var requiredBy = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getRequiredBy;

var _objectIs = _interopRequireDefault(objectIs);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getRequiredBy(requiredByPropName, propType) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  function requiredBy(props, propName, componentName) {
    if (props[requiredByPropName]) {
      var propValue = props[propName];

      if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === 'undefined') {
        return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop \u201C").concat(propName, "\u201D must be present."));
      }
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  }

  requiredBy.isRequired = function requiredByRequired(props, propName, componentName) {
    var propValue = props[propName];

    if ((0, _objectIs["default"])(propValue, defaultValue)) {
      return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be present."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(requiredBy, "requiredBy \u201C".concat(requiredByPropName, "\u201D"), [requiredByPropName, defaultValue]);
}

});

var restrictedProp = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function customMessageWrapper(messsageFunction) {
  function restrictedProp(props, propName, componentName, location) {
    if (props[propName] == null) {
      return null;
    }

    if (messsageFunction && typeof messsageFunction === 'function') {
      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        rest[_key - 4] = arguments[_key];
      }

      return new TypeError(messsageFunction.apply(void 0, [props, propName, componentName, location].concat(rest)));
    }

    return new TypeError("The ".concat(propName, " ").concat(location, " on ").concat(componentName, " is not allowed."));
  }

  restrictedProp.isRequired = restrictedProp;
  return restrictedProp;
}

var _default = function _default() {
  var messsageFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), 'restrictedProp');
};

exports["default"] = _default;

});

var stringEndsWith = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringEndsWithValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stringEndsWithValidator(end) {
  if (typeof end !== 'string' || end.length === 0) {
    throw new TypeError('a non-empty string is required');
  }

  var validator = function stringEndsWith(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

    if (stringError) {
      return stringError;
    }

    if (!propValue.endsWith(end) || propValue.length <= end.length) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " does not end with \"").concat(end, "\""));
    }

    return null;
  };

  validator.isRequired = function requiredStringEndsWith() {
    var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);

    if (stringError) {
      return stringError;
    }

    return validator.apply(void 0, arguments);
  };

  return (0, _wrapValidator["default"])(validator, "stringEndsWith: ".concat(end));
}

});

var stringStartsWith = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringStartsWithValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stringStartsWithValidator(start) {
  if (typeof start !== 'string' || start.length === 0) {
    throw new TypeError('a non-empty string is required');
  }

  var validator = function stringStartsWith(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

    if (stringError) {
      return stringError;
    }

    if (!propValue.startsWith(start) || propValue.length <= start.length) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " does not start with \"").concat(start, "\""));
    }

    return null;
  };

  validator.isRequired = function requiredStringStartsWith() {
    var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);

    if (stringError) {
      return stringError;
    }

    return validator.apply(void 0, arguments);
  };

  return (0, _wrapValidator["default"])(validator, "stringStartsWith: ".concat(start));
}

});

var uniqueArray_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function uniqueCountWithSet(arr) {
  return new Set(arr).size;
}
/* istanbul ignore next */


function uniqueCountLegacy(arr) {
  var seen = [];
  arr.forEach(function (item) {
    if (seen.indexOf(item) === -1) {
      seen.push(item);
    }
  });
  return seen.length;
}

var getUniqueCount = typeof Set === 'function' ? uniqueCountWithSet :
/* istanbul ignore next */
uniqueCountLegacy;

function requiredUniqueArray(props, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var result = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));

  if (result != null) {
    return result;
  }

  var propValue = props[propName];
  var uniqueCount = getUniqueCount(propValue);

  if (uniqueCount !== propValue.length) {
    return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
  }

  return null;
}

function uniqueArray(props, propName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    rest[_key2 - 2] = arguments[_key2];
  }

  return requiredUniqueArray.apply(void 0, [props, propName].concat(rest));
}

uniqueArray.isRequired = requiredUniqueArray;

var _default = function _default() {
  return (0, _wrapValidator["default"])(uniqueArray, 'uniqueArray');
};

exports["default"] = _default;

});

var uniqueArrayOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uniqueArrayOfTypeValidator;



var _and = _interopRequireDefault(and);

var _uniqueArray = _interopRequireDefault(uniqueArray_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var unique = (0, _uniqueArray["default"])();

function uniqueArrayOfTypeValidator(type) {
  if (typeof type !== 'function') {
    throw new TypeError('type must be a validator function');
  }

  var mapper = null;
  var name = 'uniqueArrayOfType';

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  if (rest.length === 1) {
    if (typeof rest[0] === 'function') {
      mapper = rest[0];
    } else if (typeof rest[0] === 'string') {
      name = rest[0];
    } else {
      throw new TypeError('single input must either be string or function');
    }
  } else if (rest.length === 2) {
    if (typeof rest[0] === 'function' && typeof rest[1] === 'string') {
      mapper = rest[0];
      name = rest[1];
    } else {
      throw new TypeError('multiple inputs must be in [function, string] order');
    }
  } else if (rest.length > 2) {
    throw new TypeError('only [], [name], [mapper], and [mapper, name] are valid inputs');
  }

  function uniqueArrayOfMapped(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    var values = propValue.map(mapper);

    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return unique.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, values)), propName].concat(args));
  }

  uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
    var propValue = props[propName];

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (propValue == null) {
      return _propTypes.array.isRequired.apply(_propTypes.array, [props, propName].concat(args));
    }

    return uniqueArrayOfMapped.apply(void 0, [props, propName].concat(args));
  };

  var arrayValidator = (0, _propTypes.arrayOf)(type);
  var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
  var validator = (0, _and["default"])([arrayValidator, uniqueValidator], name);
  validator.isRequired = (0, _and["default"])([uniqueValidator.isRequired, arrayValidator.isRequired], "".concat(name, ".isRequired"));
  return validator;
}

});

var _propTypesExact = _interopRequireDefault$1(build$1);

var _and = _interopRequireDefault$1(and);

var _between = _interopRequireDefault$1(between);

var _booleanSome = _interopRequireDefault$1(booleanSome);

var _childrenHavePropXorChildren = _interopRequireDefault$1(childrenHavePropXorChildren_1);

var _childrenOf = _interopRequireDefault$1(childrenOf_1);

var _childrenOfType = _interopRequireDefault$1(childrenOfType_1);

var _childrenSequenceOf = _interopRequireDefault$1(childrenSequenceOf);

var _componentWithName = _interopRequireDefault$1(componentWithName_1);

var _disallowedIf = _interopRequireDefault$1(disallowedIf_1);

var _elementType = _interopRequireDefault$1(elementType);

var _empty = _interopRequireDefault$1(empty);

var _explicitNull = _interopRequireDefault$1(explicitNull_1);

var _integer = _interopRequireDefault$1(integer);

var _keysOf = _interopRequireDefault$1(keysOf);

var _mutuallyExclusiveProps = _interopRequireDefault$1(mutuallyExclusiveProps);

var _mutuallyExclusiveTrueProps = _interopRequireDefault$1(mutuallyExclusiveTrueProps);

var _nChildren = _interopRequireDefault$1(nChildren_1);

var _nonNegativeInteger = _interopRequireDefault$1(nonNegativeInteger);

var _nonNegativeNumber = _interopRequireDefault$1(nonNegativeNumber_1);

var _numericString = _interopRequireDefault$1(numericString);

var _object = _interopRequireDefault$1(object_1);

var _or = _interopRequireDefault$1(or_1);

var _predicate = _interopRequireDefault$1(predicate_1);

var _range = _interopRequireDefault$1(range_1);

var _ref = _interopRequireDefault$1(ref_1);

var _requiredBy = _interopRequireDefault$1(requiredBy);

var _restrictedProp = _interopRequireDefault$1(restrictedProp);

var _sequenceOf = _interopRequireDefault$1(sequenceOf);

var _shape = _interopRequireDefault$1(shape);

var _stringEndsWith = _interopRequireDefault$1(stringEndsWith);

var _stringStartsWith = _interopRequireDefault$1(stringStartsWith);

var _uniqueArray = _interopRequireDefault$1(uniqueArray_1);

var _uniqueArrayOf = _interopRequireDefault$1(uniqueArrayOf);

var _valuesOf = _interopRequireDefault$1(valuesOf);

var _withShape = _interopRequireDefault$1(withShape_1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var build$2 = {
  and: _and["default"],
  between: _between["default"],
  booleanSome: _booleanSome["default"],
  childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
  childrenOf: _childrenOf["default"],
  childrenOfType: _childrenOfType["default"],
  childrenSequenceOf: _childrenSequenceOf["default"],
  componentWithName: _componentWithName["default"],
  disallowedIf: _disallowedIf["default"],
  elementType: _elementType["default"],
  empty: _empty["default"],
  explicitNull: _explicitNull["default"],
  forbidExtraProps: _propTypesExact["default"],
  integer: _integer["default"],
  keysOf: _keysOf["default"],
  mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
  mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
  nChildren: _nChildren["default"],
  nonNegativeInteger: _nonNegativeInteger["default"],
  nonNegativeNumber: _nonNegativeNumber["default"],
  numericString: _numericString["default"],
  object: _object["default"],
  or: _or["default"],
  predicate: _predicate["default"],
  range: _range["default"],
  ref: _ref["default"],
  requiredBy: _requiredBy["default"],
  restrictedProp: _restrictedProp["default"],
  sequenceOf: _sequenceOf["default"],
  shape: _shape["default"],
  stringEndsWith: _stringEndsWith["default"],
  stringStartsWith: _stringStartsWith["default"],
  uniqueArray: _uniqueArray["default"],
  uniqueArrayOf: _uniqueArrayOf["default"],
  valuesOf: _valuesOf["default"],
  withShape: _withShape["default"]
};

var airbnbPropTypes = process.env.NODE_ENV === 'production' ? mocks : build$2;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof_1(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var interopRequireWildcard = _interopRequireWildcard;

var emptyStylesFn = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EMPTY_STYLES = {};

var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
  return EMPTY_STYLES;
};

var _default = EMPTY_STYLES_FN;
exports["default"] = _default;
});

var perf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.perfStart = perfStart;
exports.perfEnd = perfEnd;
exports["default"] = withPerf;

function perfStart(startMark) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function' && startMark) {
    performance.clearMarks(startMark);
    performance.mark(startMark);
  }
}

function perfEnd(startMark, endMark, measureName) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(endMark);
    performance.mark(endMark);
    performance.measure(measureName, startMark, endMark);
    performance.clearMarks(measureName);
  }
}

function withPerf(methodName) {
  var startMark = "react-with-styles.".concat(methodName, ".start");
  var endMark = "react-with-styles.".concat(methodName, ".end");
  var measureName = "\uD83D\uDC69\u200D\uD83C\uDFA8 [".concat(methodName, "]");
  return function (fn) {
    return function () {
      if (process.env.NODE_ENV !== 'production') {
        perfStart(startMark);
      }

      var result = fn.apply(void 0, arguments);

      if (process.env.NODE_ENV !== 'production') {
        perfEnd(startMark, endMark, measureName);
      }

      return result;
    };
  };
}
});

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': deepmerge_1
});

var constants$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANNEL = exports.CHANNEL = '__direction__';

var DIRECTIONS = exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};
});

var brcast = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].shape({
  getState: _propTypes2['default'].func,
  setState: _propTypes2['default'].func,
  subscribe: _propTypes2['default'].func
});
});

/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/

var undefined$4;

var $SyntaxError$3 = SyntaxError;
var $Function$3 = Function;
var $TypeError$h = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor$2 = function (expressionSyntax) {
	try {
		// eslint-disable-next-line no-new-func
		return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$4 = Object.getOwnPropertyDescriptor;
if ($gOPD$4) {
	try {
		$gOPD$4({}, '');
	} catch (e) {
		$gOPD$4 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError$3 = function () { throw new $TypeError$h(); };
var ThrowTypeError$3 = $gOPD$4
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError$3;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$4(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError$3;
			}
		}
	}())
	: throwTypeError$3;

var hasSymbols$8 = hasSymbols$1();

var getProto$3 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var asyncGenFunction$3 = getEvalledConstructor$2('async function* () {}');
var asyncGenFunctionPrototype$2 = asyncGenFunction$3 ? asyncGenFunction$3.prototype : undefined$4;
var asyncGenPrototype$2 = asyncGenFunctionPrototype$2 ? asyncGenFunctionPrototype$2.prototype : undefined$4;

var TypedArray$3 = typeof Uint8Array === 'undefined' ? undefined$4 : getProto$3(Uint8Array);

var INTRINSICS$3 = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$4 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$4 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$8 ? getProto$3([][Symbol.iterator]()) : undefined$4,
	'%AsyncFromSyncIteratorPrototype%': undefined$4,
	'%AsyncFunction%': getEvalledConstructor$2('async function () {}'),
	'%AsyncGenerator%': asyncGenFunctionPrototype$2,
	'%AsyncGeneratorFunction%': asyncGenFunction$3,
	'%AsyncIteratorPrototype%': asyncGenPrototype$2 ? getProto$3(asyncGenPrototype$2) : undefined$4,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$4 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$4 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$4 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$4 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$4 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$4 : FinalizationRegistry,
	'%Function%': $Function$3,
	'%GeneratorFunction%': getEvalledConstructor$2('function* () {}'),
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$4 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$4 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$4 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$8 ? getProto$3(getProto$3([][Symbol.iterator]())) : undefined$4,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$4,
	'%Map%': typeof Map === 'undefined' ? undefined$4 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$8 ? undefined$4 : getProto$3(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$4 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$4 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$4 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$4 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$8 ? undefined$4 : getProto$3(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$4 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$8 ? getProto$3(''[Symbol.iterator]()) : undefined$4,
	'%Symbol%': hasSymbols$8 ? Symbol : undefined$4,
	'%SyntaxError%': $SyntaxError$3,
	'%ThrowTypeError%': ThrowTypeError$3,
	'%TypedArray%': TypedArray$3,
	'%TypeError%': $TypeError$h,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$4 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$4 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$4 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$4 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$4 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$4 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$4 : WeakSet
};

var LEGACY_ALIASES$2 = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$2 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply$2 = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$4 = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$3 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$3 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$3 = function stringToPath(string) {
	var result = [];
	$replace$4(string, rePropName$3, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$4(subString, reEscapeChar$3, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic$3 = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES$2, intrinsicName)) {
		alias = LEGACY_ALIASES$2[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS$3, intrinsicName)) {
		var value = INTRINSICS$3[intrinsicName];
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$h('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$3('intrinsic ' + name + ' does not exist!');
};

var GetIntrinsic$2 = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$h('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$h('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$3(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic$3('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply$2(parts, $concat$2([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS$3, intrinsicRealName)) {
			value = INTRINSICS$3[intrinsicRealName];
		} else if (value != null) {
			if ($gOPD$4 && (i + 1) >= parts.length) {
				var desc = $gOPD$4(value, part);
				isOwn = !!desc;

				if (!allowMissing && !(part in value)) {
					throw new $TypeError$h('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS$3[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var $TypeError$i = GetIntrinsic$2('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

var CheckObjectCoercible$2 = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$i(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible$2 = CheckObjectCoercible$2;

var $isEnumerable$3 = callBound$1('Object.prototype.propertyIsEnumerable');

var implementation$8 = function values(O) {
	var obj = RequireObjectCoercible$2(O);
	var vals = [];
	for (var key in obj) {
		if (src(obj, key) && $isEnumerable$3(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};

var polyfill$b = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation$8;
};

var shim$6 = function shimValues() {
	var polyfill = polyfill$b();
	defineProperties_1(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$c = callBind$1(polyfill$b(), Object);

defineProperties_1(polyfill$c, {
	getPolyfill: polyfill$b,
	implementation: implementation$8,
	shim: shim$6
});

var object_values = polyfill$c;

var direction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _object2 = _interopRequireDefault(object_values);



var _propTypes2 = _interopRequireDefault(_propTypes);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf((0, _object2['default'])(constants$1.DIRECTIONS));
});

var _deepmerge = /*@__PURE__*/getAugmentedNamespace(es);

var withDirection_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDirectionPropTypes = exports.DIRECTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = withDirection;



var _react2 = _interopRequireDefault(React);



var _hoistNonReactStatics2 = _interopRequireDefault(hoistNonReactStatics_cjs);



var _deepmerge2 = _interopRequireDefault(_deepmerge);



var _getComponentName2 = _interopRequireDefault(getComponentName_1);





var _brcast2 = _interopRequireDefault(brcast);



var _direction2 = _interopRequireDefault(direction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/forbid-foreign-prop-types */
// This higher-order component consumes a string from React context that is
// provided by the DirectionProvider component.
// We can use this to conditionally switch layout/direction for right-to-left layouts.

var contextTypes = _defineProperty({}, constants$1.CHANNEL, _brcast2['default']);

exports.DIRECTIONS = constants$1.DIRECTIONS;

// set a default direction so that a component wrapped with this HOC can be
// used even without a DirectionProvider ancestor in its react tree.

var defaultDirection = constants$1.DIRECTIONS.LTR;

// export for convenience, in order for components to spread these onto their propTypes
var withDirectionPropTypes = exports.withDirectionPropTypes = {
  direction: _direction2['default'].isRequired
};

function withDirection(WrappedComponent) {
  var WithDirection = function (_React$Component) {
    _inherits(WithDirection, _React$Component);

    function WithDirection(props, context) {
      _classCallCheck(this, WithDirection);

      var _this = _possibleConstructorReturn(this, (WithDirection.__proto__ || Object.getPrototypeOf(WithDirection)).call(this, props, context));

      _this.state = {
        direction: context[constants$1.CHANNEL] ? context[constants$1.CHANNEL].getState() : defaultDirection
      };
      return _this;
    }

    _createClass(WithDirection, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          if (this.context[constants$1.CHANNEL]) {
            // subscribe to future direction changes
            this.channelUnsubscribe = this.context[constants$1.CHANNEL].subscribe(function (direction) {
              _this2.setState({ direction: direction });
            });
          }
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (this.channelUnsubscribe) {
            this.channelUnsubscribe();
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var direction = this.state.direction;


          return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
            direction: direction
          }));
        }

        return render;
      }()
    }]);

    return WithDirection;
  }(_react2['default'].Component);

  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';

  WithDirection.WrappedComponent = WrappedComponent;
  WithDirection.contextTypes = contextTypes;
  WithDirection.displayName = 'withDirection(' + String(wrappedComponentName) + ')';
  if (WrappedComponent.propTypes) {
    WithDirection.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
    delete WithDirection.propTypes.direction;
  }
  if (WrappedComponent.defaultProps) {
    WithDirection.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
  }

  return (0, _hoistNonReactStatics2['default'])(WithDirection, WrappedComponent);
}
});

var WithStylesContext_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DIRECTIONS", {
  enumerable: true,
  get: function get() {
    return withDirection_1.DIRECTIONS;
  }
});
exports["default"] = void 0;



var _propTypes$1 = interopRequireDefault(_propTypes);



function detectAndCreateContext(defaultValue) {
  if (React.createContext) {
    return (0, React.createContext)(defaultValue);
  }

  return {
    Provider: function Provider() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    },
    Consumer: function Consumer() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    }
  };
}

var WithStylesContext = detectAndCreateContext({
  stylesInterface: null,
  stylesTheme: null,
  direction: null
});
WithStylesContext.Provider.propTypes = {
  stylesInterface: _propTypes$1["default"].object,
  // eslint-disable-line react/forbid-prop-types
  stylesTheme: _propTypes$1["default"].object,
  // eslint-disable-line react/forbid-prop-types
  direction: _propTypes$1["default"].oneOf([withDirection_1.DIRECTIONS.LTR, withDirection_1.DIRECTIONS.RTL])
};
var _default = WithStylesContext;
exports["default"] = _default;
});

var withStylesPropTypes_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withStylesPropTypes = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);

var withStylesPropTypes = {
  styles: _propTypes$1["default"].object.isRequired,
  theme: _propTypes$1["default"].object.isRequired,
  css: _propTypes$1["default"].func.isRequired
};
exports.withStylesPropTypes = withStylesPropTypes;
var _default = withStylesPropTypes;
exports["default"] = _default;
});

var withStyles_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = withStyles;
Object.defineProperty(exports, "withStylesPropTypes", {
  enumerable: true,
  get: function get() {
    return withStylesPropTypes_1.withStylesPropTypes;
  }
});
exports.css = exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React);

var _hoistNonReactStatics = interopRequireDefault(hoistNonReactStatics_cjs);

var _getComponentName = interopRequireDefault(getComponentName_1);

var _emptyStylesFn = interopRequireDefault(emptyStylesFn);

var _perf = interopRequireDefault(perf);

var _WithStylesContext = interopRequireWildcard(WithStylesContext_1);

var _ThemedStyleSheet = interopRequireWildcard(ThemedStyleSheet);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A higher order function that returns a higher order class component that injects
 * CSS-in-JS props derived from the react-with-styles theme, interface, and
 * direction provided through the WithStylesContext provider.
 *
 * The function should be used as follows:
 * `withStyles((theme) => styles, options)(Component)`
 *
 * Options can be used to rename the injected props, memoize the component, and flush
 * the styles to the styles tag (or whatever the interface implements as flush) before
 * rendering.
 *
 * @export
 * @param {Function|null|undefined} [stylesFn=EMPTY_STYLES_FN]
 * @param {Object} [{
 *     stylesPropName = 'styles',
 *     themePropName = 'theme',
 *     cssPropName = 'css',
 *     flushBefore = false,
 *     pureComponent = false,
 *   }={}]
 * @returns a higher order component that wraps the provided component and injects
 * the react-with-styles css, styles, and theme props.
 */
function withStyles() {
  var stylesFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyStylesFn["default"];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stylesPropName = _ref.stylesPropName,
      stylesPropName = _ref$stylesPropName === void 0 ? 'styles' : _ref$stylesPropName,
      _ref$themePropName = _ref.themePropName,
      themePropName = _ref$themePropName === void 0 ? 'theme' : _ref$themePropName,
      _ref$cssPropName = _ref.cssPropName,
      cssPropName = _ref$cssPropName === void 0 ? 'css' : _ref$cssPropName,
      _ref$flushBefore = _ref.flushBefore,
      flushBefore = _ref$flushBefore === void 0 ? false : _ref$flushBefore,
      _ref$pureComponent = _ref.pureComponent,
      pureComponent = _ref$pureComponent === void 0 ? false : _ref$pureComponent;

  stylesFn = stylesFn || _emptyStylesFn["default"];
  var BaseClass = pureComponent ? _react["default"].PureComponent : _react["default"].Component;
  /** Cache for storing the result of stylesFn(theme) for all themes. */

  var stylesFnResultCacheMap = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getOrCreateStylesFnResultCache(theme) {
    // Get and store the result in the stylesFnResultsCache for the component
    // -- not the instance -- so we only apply the theme to the stylesFn
    // once per theme for this component.
    var cachedResultForTheme = stylesFnResultCacheMap.get(theme);
    var stylesFnResult = cachedResultForTheme || stylesFn(theme) || {};
    stylesFnResultCacheMap.set(theme, stylesFnResult); // cache the result of stylesFn(theme)

    return stylesFnResult;
  }
  /**
   * Cache for storing the results of computations:
   * `WeakMap<Theme, WeakMap<typeof WithStyles, { ltr: {}, rtl: {} }>>`
   * Falling back to `Map` whenever `WeakMap` is not supported
   */


  var withStylesCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getComponentCache(theme, component, direction) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      return null;
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      return null;
    }

    return componentCache[direction];
  }

  function updateComponentCache(theme, component, direction, results) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      themeCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();
      withStylesCache.set(theme, themeCache);
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      componentCache = {
        ltr: {},
        rtl: {}
      };
      themeCache.set(component, componentCache);
    }

    componentCache[direction] = results;
  }
  /** Derive the create function from the interface and direction */


  function makeCreateFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var create = stylesInterface["create".concat(directionSelector)] || stylesInterface.create;

    if (process.env.NODE_ENV !== 'production') {
      create = (0, _perf["default"])('create')(create);
    }

    return create;
  }
  /** Derive the resolve function from the interface and direction */


  function makeResolveFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var resolve = stylesInterface["resolve".concat(directionSelector)] || stylesInterface.resolve;

    if (process.env.NODE_ENV !== 'production') {
      resolve = (0, _perf["default"])('resolve')(resolve);
    }

    return resolve;
  } // The function that wraps the provided component in a wrapper
  // component that injects the withStyles props


  return function withStylesHOC(WrappedComponent) {
    var wrappedComponentName = (0, _getComponentName["default"])(WrappedComponent); // The wrapper component that injects the withStyles props

    var WithStyles =
    /*#__PURE__*/
    function (_BaseClass) {
      (0, _inheritsLoose2["default"])(WithStyles, _BaseClass);

      function WithStyles() {
        return _BaseClass.apply(this, arguments) || this;
      }

      var _proto = WithStyles.prototype;

      _proto.getCurrentInterface = function getCurrentInterface() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesInterface || (0, _ThemedStyleSheet._getInterface)();
      };

      _proto.getCurrentTheme = function getCurrentTheme() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesTheme || (0, _ThemedStyleSheet._getTheme)();
      };

      _proto.getCurrentDirection = function getCurrentDirection() {
        return this.context && this.context.direction || _WithStylesContext.DIRECTIONS.LTR;
      };

      _proto.getProps = function getProps() {
        // Get the styles interface, theme, and direction from context
        var stylesInterface = this.getCurrentInterface();
        var theme = this.getCurrentTheme();
        var direction = this.getCurrentDirection(); // Use a cache to store the interface methods and created styles by direction.
        // This way, if the theme and the interface don't change, we do not recalculate
        // styles or any other interface derivations. They are effectively only calculated
        // once per direction, until the theme or interface change.
        // Assume: always an object.

        var componentCache = getComponentCache(theme, WithStyles, direction); // Determine what's changed

        var interfaceChanged = !componentCache || !componentCache.stylesInterface || stylesInterface && componentCache.stylesInterface !== stylesInterface;
        var themeChanged = !componentCache || componentCache.theme !== theme; // If the interface and theme haven't changed for this direction,
        // we return the cached props immediately.

        if (!interfaceChanged && !themeChanged) {
          return componentCache.props;
        } // If the theme or the interface changed, then there are some values
        // we need to recalculate. We avoid recalculating the ones we already
        // calculated in the past if the objects they're derived from have not
        // changed.


        var create = interfaceChanged && makeCreateFn(direction, stylesInterface) || componentCache.create;
        var resolve = interfaceChanged && makeResolveFn(direction, stylesInterface) || componentCache.resolve; // Derive the css function prop

        var css = interfaceChanged && function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return resolve(args);
        } || componentCache.props.css; // Get or calculate the themed styles from the stylesFn:
        // Uses a separate cache at the component level, not at the instance level,
        // to only apply the theme to the stylesFn once per component class per theme.


        var stylesFnResult = getOrCreateStylesFnResultCache(theme); // Derive the styles prop: recalculate it if create changed, or stylesFnResult changed

        var styles = (interfaceChanged || stylesFnResult !== componentCache.stylesFnResult) && create(stylesFnResult) || componentCache.props.styles; // Put the new props together

        var props = {
          css: css,
          styles: styles,
          theme: theme
        }; // Update the cache with all the new values

        updateComponentCache(theme, WithStyles, direction, {
          stylesInterface: stylesInterface,
          theme: theme,
          create: create,
          resolve: resolve,
          stylesFnResult: stylesFnResult,
          props: props
        });
        return props;
      };

      _proto.flush = function flush() {
        var stylesInterface = this.getCurrentInterface();

        if (stylesInterface && stylesInterface.flush) {
          stylesInterface.flush();
        }
      };

      _proto.render = function render() {
        var _ref2;

        // We only want to re-render if the theme, stylesInterface, or direction change.
        // These values are in context so we're listening for their updates.
        // this.getProps() derives the props from the theme, stylesInterface, and direction in
        // context, and memoizes them on the instance per direction.
        var _this$getProps = this.getProps(),
            theme = _this$getProps.theme,
            styles = _this$getProps.styles,
            css = _this$getProps.css; // Flush if specified


        if (flushBefore) {
          this.flush();
        }

        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, this.props, (_ref2 = {}, (0, _defineProperty2["default"])(_ref2, themePropName, theme), (0, _defineProperty2["default"])(_ref2, stylesPropName, styles), (0, _defineProperty2["default"])(_ref2, cssPropName, css), _ref2)));
      };

      return WithStyles;
    }(BaseClass); // Copy the wrapped component's prop types and default props on WithStyles


    if (WrappedComponent.propTypes) {
      WithStyles.propTypes = _objectSpread({}, WrappedComponent.propTypes);
      delete WithStyles.propTypes[stylesPropName];
      delete WithStyles.propTypes[themePropName];
      delete WithStyles.propTypes[cssPropName];
    }

    if (WrappedComponent.defaultProps) {
      WithStyles.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }

    WithStyles.contextType = _WithStylesContext["default"];
    WithStyles.WrappedComponent = WrappedComponent;
    WithStyles.displayName = "withStyles(".concat(wrappedComponentName, ")");
    return (0, _hoistNonReactStatics["default"])(WithStyles, WrappedComponent);
  };
}

var _default = withStyles;
/**
 * Deprecated: Do not use directly. Please wrap your component in `withStyles` and use the `css`
 * prop injected via props instead.
 */

exports["default"] = _default;
var css = _ThemedStyleSheet["default"].resolveLTR;
exports.css = css;
});

var performanceNow = createCommonjsModule(function (module) {
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);


});

var root = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = performanceNow()
        , next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

var raf_1 = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
};
var cancel = function() {
  caf.apply(root, arguments);
};
var polyfill$d = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill$d;

var defaultPhrases = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = exports["default"] = void 0;
var calendarLabel = 'Calendar';
var roleDescription = 'datepicker';
var closeDatePicker = 'Close';
var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
var clearDate = 'Clear Date';
var clearDates = 'Clear Dates';
var jumpToPrevMonth = 'Move backward to switch to the previous month.';
var jumpToNextMonth = 'Move forward to switch to the next month.';
var keyboardShortcuts = 'Keyboard Shortcuts';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
var openThisPanel = 'Open this panel.';
var enterKey = 'Enter key';
var leftArrowRightArrow = 'Right and left arrow keys';
var upArrowDownArrow = 'up and down arrow keys';
var pageUpPageDown = 'page up and page down keys';
var homeEnd = 'Home and end keys';
var escape = 'Escape key';
var questionMark = 'Question mark';
var selectFocusedDate = 'Select the date in focus.';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
var moveFocusByOneMonth = 'Switch months.';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
var returnFocusToInput = 'Return to the date input field.';
var keyboardForwardNavigationInstructions = 'Navigate forward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
var keyboardBackwardNavigationInstructions = 'Navigate backward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';

var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return "Choose ".concat(date, " as your check-in date. It\u2019s available.");
};

var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return "Choose ".concat(date, " as your check-out date. It\u2019s available.");
};

var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};

var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return "Not available. ".concat(date);
};

var dateIsSelected = function dateIsSelected(_ref5) {
  var date = _ref5.date;
  return "Selected. ".concat(date);
};

var dateIsSelectedAsStartDate = function dateIsSelectedAsStartDate(_ref6) {
  var date = _ref6.date;
  return "Selected as start date. ".concat(date);
};

var dateIsSelectedAsEndDate = function dateIsSelectedAsEndDate(_ref7) {
  var date = _ref7.date;
  return "Selected as end date. ".concat(date);
};

var _default = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  focusStartDate: focusStartDate,
  clearDate: clearDate,
  clearDates: clearDates,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports["default"] = _default;
var DateRangePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDates: clearDates,
  focusStartDate: focusStartDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DateRangePickerPhrases = DateRangePickerPhrases;
var DateRangePickerInputPhrases = {
  focusStartDate: focusStartDate,
  clearDates: clearDates,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.DateRangePickerInputPhrases = DateRangePickerInputPhrases;
var SingleDatePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDate: clearDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected
};
exports.SingleDatePickerPhrases = SingleDatePickerPhrases;
var SingleDatePickerInputPhrases = {
  clearDate: clearDate,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.SingleDatePickerInputPhrases = SingleDatePickerInputPhrases;
var DayPickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DayPickerPhrases = DayPickerPhrases;
var DayPickerKeyboardShortcutsPhrases = {
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput
};
exports.DayPickerKeyboardShortcutsPhrases = DayPickerKeyboardShortcutsPhrases;
var DayPickerNavigationPhrases = {
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth
};
exports.DayPickerNavigationPhrases = DayPickerNavigationPhrases;
var CalendarDayPhrases = {
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.CalendarDayPhrases = CalendarDayPhrases;
});

var getPhrasePropTypes_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrasePropTypes;

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _propTypes$1 = interopRequireDefault(_propTypes);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return _objectSpread({}, phrases, (0, _defineProperty2["default"])({}, key, _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].func, _propTypes$1["default"].node])));
  }, {});
}
});

var getPhrase_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrase;

function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}
});

var constants$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODIFIER_KEY_NAMES = exports.DEFAULT_VERTICAL_SPACING = exports.FANG_HEIGHT_PX = exports.FANG_WIDTH_PX = exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.INFO_POSITION_AFTER = exports.INFO_POSITION_BEFORE = exports.INFO_POSITION_BOTTOM = exports.INFO_POSITION_TOP = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.NAV_POSITION_TOP = exports.NAV_POSITION_BOTTOM = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = void 0;
var DISPLAY_FORMAT = 'L';
exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
var ISO_FORMAT = 'YYYY-MM-DD';
exports.ISO_FORMAT = ISO_FORMAT;
var ISO_MONTH_FORMAT = 'YYYY-MM'; // TODO delete this line of dead code on next breaking change

exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
var START_DATE = 'startDate';
exports.START_DATE = START_DATE;
var END_DATE = 'endDate';
exports.END_DATE = END_DATE;
var HORIZONTAL_ORIENTATION = 'horizontal';
exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
var VERTICAL_ORIENTATION = 'vertical';
exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
var VERTICAL_SCROLLABLE = 'verticalScrollable';
exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
var NAV_POSITION_BOTTOM = 'navPositionBottom';
exports.NAV_POSITION_BOTTOM = NAV_POSITION_BOTTOM;
var NAV_POSITION_TOP = 'navPositionTop';
exports.NAV_POSITION_TOP = NAV_POSITION_TOP;
var ICON_BEFORE_POSITION = 'before';
exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
var ICON_AFTER_POSITION = 'after';
exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
var INFO_POSITION_TOP = 'top';
exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
var INFO_POSITION_BOTTOM = 'bottom';
exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
var INFO_POSITION_BEFORE = 'before';
exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
var INFO_POSITION_AFTER = 'after';
exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
var ANCHOR_LEFT = 'left';
exports.ANCHOR_LEFT = ANCHOR_LEFT;
var ANCHOR_RIGHT = 'right';
exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
var OPEN_DOWN = 'down';
exports.OPEN_DOWN = OPEN_DOWN;
var OPEN_UP = 'up';
exports.OPEN_UP = OPEN_UP;
var DAY_SIZE = 39;
exports.DAY_SIZE = DAY_SIZE;
var BLOCKED_MODIFIER = 'blocked';
exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
exports.WEEKDAYS = WEEKDAYS;
var FANG_WIDTH_PX = 20;
exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
var FANG_HEIGHT_PX = 10;
exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
var DEFAULT_VERTICAL_SPACING = 22;
exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;
});

var getCalendarDaySettings_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarDaySettings;

var _getPhrase = interopRequireDefault(getPhrase_1);



function isSelected(modifiers) {
  return modifiers.has('selected') || modifiers.has('selected-span') || modifiers.has('selected-start') || modifiers.has('selected-end');
}

function shouldUseDefaultCursor(modifiers) {
  return modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
}

function isHoveredSpan(modifiers) {
  if (isSelected(modifiers)) return false;
  return modifiers.has('hovered-span') || modifiers.has('after-hovered-start') || modifiers.has('before-hovered-end');
}

function getAriaLabel(phrases, modifiers, day, ariaLabelFormat) {
  var chooseAvailableDate = phrases.chooseAvailableDate,
      dateIsUnavailable = phrases.dateIsUnavailable,
      dateIsSelected = phrases.dateIsSelected,
      dateIsSelectedAsStartDate = phrases.dateIsSelectedAsStartDate,
      dateIsSelectedAsEndDate = phrases.dateIsSelectedAsEndDate;
  var formattedDate = {
    date: day.format(ariaLabelFormat)
  };

  if (modifiers.has('selected-start') && dateIsSelectedAsStartDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsStartDate, formattedDate);
  }

  if (modifiers.has('selected-end') && dateIsSelectedAsEndDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsEndDate, formattedDate);
  }

  if (isSelected(modifiers) && dateIsSelected) {
    return (0, _getPhrase["default"])(dateIsSelected, formattedDate);
  }

  if (modifiers.has(constants$2.BLOCKED_MODIFIER)) {
    return (0, _getPhrase["default"])(dateIsUnavailable, formattedDate);
  }

  return (0, _getPhrase["default"])(chooseAvailableDate, formattedDate);
}

function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
  return {
    ariaLabel: getAriaLabel(phrases, modifiers, day, ariaLabelFormat),
    hoveredSpan: isHoveredSpan(modifiers),
    isOutsideRange: modifiers.has('blocked-out-of-range'),
    selected: isSelected(modifiers),
    useDefaultCursor: shouldUseDefaultCursor(modifiers),
    daySizeStyles: {
      width: daySize,
      height: daySize - 1
    }
  };
}
});

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

var ModifiersShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = (0, airbnbPropTypes.and)([_propTypes$1["default"].instanceOf(Set), function modifiers(props, propName) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  var propValue = props[propName];
  var firstError;
  (0, _toConsumableArray2["default"])(propValue).some(function (v, i) {
    var _PropTypes$string;

    var fakePropName = "".concat(propName, ": index ").concat(i);
    firstError = (_PropTypes$string = _propTypes$1["default"].string).isRequired.apply(_PropTypes$string, [(0, _defineProperty2["default"])({}, fakePropName, v), fakePropName].concat(rest));
    return firstError != null;
  });
  return firstError == null ? null : firstError;
}], 'Modifiers (Set of Strings)');

exports["default"] = _default;
});

var CalendarDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureCalendarDay = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(moment);

var _raf = interopRequireDefault(raf_1);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _getCalendarDaySettings = interopRequireDefault(getCalendarDaySettings_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  day: _reactMomentProptypes["default"].momentObj,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isOutsideDay: _propTypes$1["default"].bool,
  modifiers: _ModifiersShape["default"],
  isFocused: _propTypes$1["default"].bool,
  tabIndex: _propTypes$1["default"].oneOf([0, -1]),
  onDayClick: _propTypes$1["default"].func,
  onDayMouseEnter: _propTypes$1["default"].func,
  onDayMouseLeave: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  ariaLabelFormat: _propTypes$1["default"].string,
  // internationalization
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases))
})) : {};
var defaultProps = {
  day: (0, _moment["default"])(),
  daySize: constants$2.DAY_SIZE,
  isOutsideDay: false,
  modifiers: new Set(),
  isFocused: false,
  tabIndex: -1,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  renderDayContents: null,
  ariaLabelFormat: 'dddd, LL',
  // internationalization
  phrases: defaultPhrases.CalendarDayPhrases
};

var CalendarDay =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarDay, _ref);
  var _proto = CalendarDay.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarDay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    _this.setButtonRef = _this.setButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var _this$props = this.props,
        isFocused = _this$props.isFocused,
        tabIndex = _this$props.tabIndex;

    if (tabIndex === 0) {
      if (isFocused || tabIndex !== prevProps.tabIndex) {
        (0, _raf["default"])(function () {
          if (_this2.buttonRef) {
            _this2.buttonRef.focus();
          }
        });
      }
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var onDayClick = this.props.onDayClick;
    onDayClick(day, e);
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day, e) {
    var onDayMouseEnter = this.props.onDayMouseEnter;
    onDayMouseEnter(day, e);
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day, e) {
    var onDayMouseLeave = this.props.onDayMouseLeave;
    onDayMouseLeave(day, e);
  };

  _proto.onKeyDown = function onKeyDown(day, e) {
    var onDayClick = this.props.onDayClick;
    var key = e.key;

    if (key === 'Enter' || key === ' ') {
      onDayClick(day, e);
    }
  };

  _proto.setButtonRef = function setButtonRef(ref) {
    this.buttonRef = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        day = _this$props2.day,
        ariaLabelFormat = _this$props2.ariaLabelFormat,
        daySize = _this$props2.daySize,
        isOutsideDay = _this$props2.isOutsideDay,
        modifiers = _this$props2.modifiers,
        renderDayContents = _this$props2.renderDayContents,
        tabIndex = _this$props2.tabIndex,
        styles = _this$props2.styles,
        phrases = _this$props2.phrases;
    if (!day) return _react["default"].createElement("td", null);

    var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
        daySizeStyles = _getCalendarDaySettin.daySizeStyles,
        useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
        selected = _getCalendarDaySettin.selected,
        hoveredSpan = _getCalendarDaySettin.hoveredSpan,
        isOutsideRange = _getCalendarDaySettin.isOutsideRange,
        ariaLabel = _getCalendarDaySettin.ariaLabel;

    return _react["default"].createElement("td", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('hovered-start-first-possible-end') && styles.CalendarDay__hovered_start_first_possible_end, modifiers.has('hovered-start-blocked-minimum-nights') && styles.CalendarDay__hovered_start_blocked_min_nights, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('after-hovered-start') && styles.CalendarDay__after_hovered_start, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && !modifiers.has('selected-span') && styles.CalendarDay__selected, modifiers.has('before-hovered-end') && styles.CalendarDay__before_hovered_end, modifiers.has('no-selected-start-before-selected-end') && styles.CalendarDay__no_selected_start_before_selected_end, modifiers.has('selected-start-in-hovered-span') && styles.CalendarDay__selected_start_in_hovered_span, modifiers.has('selected-end-in-hovered-span') && styles.CalendarDay__selected_end_in_hovered_span, modifiers.has('selected-start-no-selected-end') && styles.CalendarDay__selected_start_no_selected_end, modifiers.has('selected-end-no-selected-start') && styles.CalendarDay__selected_end_no_selected_start, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
      role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
      ,
      ref: this.setButtonRef,
      "aria-disabled": modifiers.has('blocked'),
      "aria-label": ariaLabel,
      onMouseEnter: function onMouseEnter(e) {
        _this3.onDayMouseEnter(day, e);
      },
      onMouseLeave: function onMouseLeave(e) {
        _this3.onDayMouseLeave(day, e);
      },
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      },
      onClick: function onClick(e) {
        _this3.onDayClick(day, e);
      },
      onKeyDown: function onKeyDown(e) {
        _this3.onKeyDown(day, e);
      },
      tabIndex: tabIndex
    }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
  };

  return CalendarDay;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureCalendarDay = CalendarDay;
CalendarDay.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarDay.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font;
  return {
    CalendarDay: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      fontSize: font.size,
      textAlign: 'center',
      ':active': {
        outline: 0
      }
    },
    CalendarDay__defaultCursor: {
      cursor: 'default'
    },
    CalendarDay__default: {
      border: "1px solid ".concat(color.core.borderLight),
      color: color.text,
      background: color.background,
      ':hover': {
        background: color.core.borderLight,
        border: "1px solid ".concat(color.core.borderLight),
        color: 'inherit'
      }
    },
    CalendarDay__hovered_offset: {
      background: color.core.borderBright,
      border: "1px double ".concat(color.core.borderLight),
      color: 'inherit'
    },
    CalendarDay__outside: {
      border: 0,
      background: color.outside.backgroundColor,
      color: color.outside.color,
      ':hover': {
        border: 0
      }
    },
    CalendarDay__blocked_minimum_nights: {
      background: color.minimumNights.backgroundColor,
      border: "1px solid ".concat(color.minimumNights.borderColor),
      color: color.minimumNights.color,
      ':hover': {
        background: color.minimumNights.backgroundColor_hover,
        color: color.minimumNights.color_active
      },
      ':active': {
        background: color.minimumNights.backgroundColor_active,
        color: color.minimumNights.color_active
      }
    },
    CalendarDay__highlighted_calendar: {
      background: color.highlighted.backgroundColor,
      color: color.highlighted.color,
      ':hover': {
        background: color.highlighted.backgroundColor_hover,
        color: color.highlighted.color_active
      },
      ':active': {
        background: color.highlighted.backgroundColor_active,
        color: color.highlighted.color_active
      }
    },
    CalendarDay__selected_span: {
      background: color.selectedSpan.backgroundColor,
      border: "1px double ".concat(color.selectedSpan.borderColor),
      color: color.selectedSpan.color,
      ':hover': {
        background: color.selectedSpan.backgroundColor_hover,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      },
      ':active': {
        background: color.selectedSpan.backgroundColor_active,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      }
    },
    CalendarDay__selected: {
      background: color.selected.backgroundColor,
      border: "1px double ".concat(color.selected.borderColor),
      color: color.selected.color,
      ':hover': {
        background: color.selected.backgroundColor_hover,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      },
      ':active': {
        background: color.selected.backgroundColor_active,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      }
    },
    CalendarDay__hovered_span: {
      background: color.hoveredSpan.backgroundColor,
      border: "1px double ".concat(color.hoveredSpan.borderColor),
      color: color.hoveredSpan.color,
      ':hover': {
        background: color.hoveredSpan.backgroundColor_hover,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      },
      ':active': {
        background: color.hoveredSpan.backgroundColor_active,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      }
    },
    CalendarDay__blocked_calendar: {
      background: color.blocked_calendar.backgroundColor,
      border: "1px solid ".concat(color.blocked_calendar.borderColor),
      color: color.blocked_calendar.color,
      ':hover': {
        background: color.blocked_calendar.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      },
      ':active': {
        background: color.blocked_calendar.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      }
    },
    CalendarDay__blocked_out_of_range: {
      background: color.blocked_out_of_range.backgroundColor,
      border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
      color: color.blocked_out_of_range.color,
      ':hover': {
        background: color.blocked_out_of_range.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      },
      ':active': {
        background: color.blocked_out_of_range.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      }
    },
    CalendarDay__hovered_start_first_possible_end: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLighter)
    },
    CalendarDay__hovered_start_blocked_min_nights: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLight)
    },
    CalendarDay__selected_start: {},
    CalendarDay__selected_end: {},
    CalendarDay__today: {},
    CalendarDay__firstDayOfWeek: {},
    CalendarDay__lastDayOfWeek: {},
    CalendarDay__after_hovered_start: {},
    CalendarDay__before_hovered_end: {},
    CalendarDay__no_selected_start_before_selected_end: {},
    CalendarDay__selected_start_in_hovered_span: {},
    CalendarDay__selected_end_in_hovered_span: {},
    CalendarDay__selected_start_no_selected_end: {},
    CalendarDay__selected_end_no_selected_start: {}
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarDay);

exports["default"] = _default;
});

var CalendarWeek_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CalendarWeek;

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes$1["default"].node.isRequired
}) : {};

function CalendarWeek(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("tr", null, children);
}

CalendarWeek.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
});

var calculateDimension_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateDimension;

function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom'; // Only read styles if we need to

  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null; // Offset includes border and padding

  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  var size = axis === 'width' ? offsetWidth : offsetHeight; // Get the inner size

  if (!borderBox) {
    size -= parseFloat(style["padding".concat(axisStart)]) + parseFloat(style["padding".concat(axisEnd)]) + parseFloat(style["border".concat(axisStart, "Width")]) + parseFloat(style["border".concat(axisEnd, "Width")]);
  } // Apply margin


  if (withMargin) {
    size += parseFloat(style["margin".concat(axisStart)]) + parseFloat(style["margin".concat(axisEnd)]);
  }

  return size;
}
});

var getCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWeeks;

var _moment = interopRequireDefault(moment);



function getCalendarMonthWeeks(month, enableOutsideDays) {
  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment["default"].localeData().firstDayOfWeek();

  if (!_moment["default"].isMoment(month) || !month.isValid()) {
    throw new TypeError('`month` must be a valid moment object');
  }

  if (constants$2.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
  } // set utc offset to get correct dates in future (when timezone changes)


  var firstOfMonth = month.clone().startOf('month').hour(12);
  var lastOfMonth = month.clone().endOf('month').hour(12); // calculate the exact first and last days to fill the entire matrix
  // (considering days outside month)

  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
  var totalDays = lastDay.diff(firstDay, 'days') + 1;
  var currentDay = firstDay.clone();
  var weeksInMonth = [];

  for (var i = 0; i < totalDays; i += 1) {
    if (i % 7 === 0) {
      weeksInMonth.push([]);
    }

    var day = null;

    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
      day = currentDay.clone();
    }

    weeksInMonth[weeksInMonth.length - 1].push(day);
    currentDay.add(1, 'day');
  }

  return weeksInMonth;
}
});

var isSameDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameDay;

var _moment = interopRequireDefault(moment);

function isSameDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}
});

var toMomentObject_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toMomentObject;

var _moment = interopRequireDefault(moment);



function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, constants$2.DISPLAY_FORMAT, constants$2.ISO_FORMAT] : [constants$2.DISPLAY_FORMAT, constants$2.ISO_FORMAT];
  var date = (0, _moment["default"])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}
});

var toISODateString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISODateString;

var _moment = interopRequireDefault(moment);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

function toISODateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0') + '-' + String(dateObj.date()).padStart(2, '0');
}
});

var ScrollableOrientationShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.HORIZONTAL_ORIENTATION, constants$2.VERTICAL_ORIENTATION, constants$2.VERTICAL_SCROLLABLE]);

exports["default"] = _default;
});

var DayOfWeekShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf(constants$2.WEEKDAYS);

exports["default"] = _default;
});

var CalendarMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(moment);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _CalendarWeek = interopRequireDefault(CalendarWeek_1);

var _CalendarDay = interopRequireDefault(CalendarDay_1);

var _calculateDimension = interopRequireDefault(calculateDimension_1);

var _getCalendarMonthWeeks = interopRequireDefault(getCalendarMonthWeeks_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  month: _reactMomentProptypes["default"].momentObj,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  isVisible: _propTypes$1["default"].bool,
  enableOutsideDays: _propTypes$1["default"].bool,
  modifiers: _propTypes$1["default"].objectOf(_ModifiersShape["default"]),
  orientation: _ScrollableOrientationShape["default"],
  daySize: airbnbPropTypes.nonNegativeInteger,
  onDayClick: _propTypes$1["default"].func,
  onDayMouseEnter: _propTypes$1["default"].func,
  onDayMouseLeave: _propTypes$1["default"].func,
  onMonthSelect: _propTypes$1["default"].func,
  onYearSelect: _propTypes$1["default"].func,
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes$1["default"].func,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes$1["default"].bool,
  // indicates whether or not to move focus to focusable day
  // i18n
  monthFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string
})) : {};
var defaultProps = {
  month: (0, _moment["default"])(),
  horizontalMonthPadding: 13,
  isVisible: true,
  enableOutsideDays: false,
  modifiers: {},
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  daySize: constants$2.DAY_SIZE,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthSelect: function onMonthSelect() {},
  onYearSelect: function onYearSelect() {},
  renderMonthText: null,
  renderCalendarDay: function renderCalendarDay(props) {
    return _react["default"].createElement(_CalendarDay["default"], props);
  },
  renderDayContents: null,
  renderMonthElement: null,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  focusedDate: null,
  isFocused: false,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined,
  verticalBorderSpacing: undefined
};

var CalendarMonth =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonth, _ref);
  var _proto = CalendarMonth.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonth(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      weeks: (0, _getCalendarMonthWeeks["default"])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : props.firstDayOfWeek)
    };
    _this.setCaptionRef = _this.setCaptionRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var month = nextProps.month,
        enableOutsideDays = nextProps.enableOutsideDays,
        firstDayOfWeek = nextProps.firstDayOfWeek;
    var _this$props = this.props,
        prevMonth = _this$props.month,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevFirstDayOfWeek = _this$props.firstDayOfWeek;

    if (!month.isSame(prevMonth) || enableOutsideDays !== prevEnableOutsideDays || firstDayOfWeek !== prevFirstDayOfWeek) {
      this.setState({
        weeks: (0, _getCalendarMonthWeeks["default"])(month, enableOutsideDays, firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : firstDayOfWeek)
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.setMonthTitleHeightTimeout) {
      clearTimeout(this.setMonthTitleHeightTimeout);
    }
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight() {
    var setMonthTitleHeight = this.props.setMonthTitleHeight;

    if (setMonthTitleHeight) {
      var captionHeight = (0, _calculateDimension["default"])(this.captionRef, 'height', true, true);
      setMonthTitleHeight(captionHeight);
    }
  };

  _proto.setCaptionRef = function setCaptionRef(ref) {
    this.captionRef = ref;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        dayAriaLabelFormat = _this$props2.dayAriaLabelFormat,
        daySize = _this$props2.daySize,
        focusedDate = _this$props2.focusedDate,
        horizontalMonthPadding = _this$props2.horizontalMonthPadding,
        isFocused = _this$props2.isFocused,
        isVisible = _this$props2.isVisible,
        modifiers = _this$props2.modifiers,
        month = _this$props2.month,
        monthFormat = _this$props2.monthFormat,
        onDayClick = _this$props2.onDayClick,
        onDayMouseEnter = _this$props2.onDayMouseEnter,
        onDayMouseLeave = _this$props2.onDayMouseLeave,
        onMonthSelect = _this$props2.onMonthSelect,
        onYearSelect = _this$props2.onYearSelect,
        orientation = _this$props2.orientation,
        phrases = _this$props2.phrases,
        renderCalendarDay = _this$props2.renderCalendarDay,
        renderDayContents = _this$props2.renderDayContents,
        renderMonthElement = _this$props2.renderMonthElement,
        renderMonthText = _this$props2.renderMonthText,
        styles = _this$props2.styles,
        verticalBorderSpacing = _this$props2.verticalBorderSpacing;
    var weeks = this.state.weeks;
    var monthTitle = renderMonthText ? renderMonthText(month) : month.format(monthFormat);
    var verticalScrollable = orientation === constants$2.VERTICAL_SCROLLABLE;
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarMonth, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      "data-visible": isVisible
    }), _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCaptionRef
    }, (0, withStyles_1.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)), renderMonthElement ? renderMonthElement({
      month: month,
      onMonthSelect: onMonthSelect,
      onYearSelect: onYearSelect,
      isVisible: isVisible
    }) : _react["default"].createElement("strong", null, monthTitle)), _react["default"].createElement("table", (0, _extends2["default"])({}, (0, withStyles_1.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && {
      borderSpacing: "0px ".concat(verticalBorderSpacing, "px")
    }), {
      role: "presentation"
    }), _react["default"].createElement("tbody", null, weeks.map(function (week, i) {
      return _react["default"].createElement(_CalendarWeek["default"], {
        key: i
      }, week.map(function (day, dayOfWeek) {
        return renderCalendarDay({
          key: dayOfWeek,
          day: day,
          daySize: daySize,
          isOutsideDay: !day || day.month() !== month.month(),
          tabIndex: isVisible && (0, _isSameDay["default"])(day, focusedDate) ? 0 : -1,
          isFocused: isFocused,
          onDayMouseEnter: onDayMouseEnter,
          onDayMouseLeave: onDayMouseLeave,
          onDayClick: onDayClick,
          renderDayContents: renderDayContents,
          phrases: phrases,
          modifiers: modifiers[(0, _toISODateString["default"])(day)],
          ariaLabelFormat: dayAriaLabelFormat
        });
      }));
    }))));
  };

  return CalendarMonth;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonth.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarMonth.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font,
      spacing = _ref2$reactDates.spacing;
  return {
    CalendarMonth: {
      background: color.background,
      textAlign: 'center',
      verticalAlign: 'top',
      userSelect: 'none'
    },
    CalendarMonth_table: {
      borderCollapse: 'collapse',
      borderSpacing: 0
    },
    CalendarMonth_verticalSpacing: {
      borderCollapse: 'separate'
    },
    CalendarMonth_caption: {
      color: color.text,
      fontSize: font.captionSize,
      textAlign: 'center',
      paddingTop: spacing.captionPaddingTop,
      paddingBottom: spacing.captionPaddingBottom,
      captionSide: 'initial'
    },
    CalendarMonth_caption__verticalScrollable: {
      paddingTop: 12,
      paddingBottom: 7
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonth);

exports["default"] = _default;
});

var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

var addEventListener_1 = addEventListener;

var lib = /*#__PURE__*/Object.defineProperty({
	addEventListener: addEventListener_1
}, '__esModule', {value: true});

var noflip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = noflip;
var NOFLIP = '/* @noflip */'; // Appends a noflip comment to a style rule in order to prevent it from being automatically
// flipped in RTL contexts. This should be used only in situations where the style must remain
// unflipped regardless of direction context. See: https://github.com/kentcdodds/rtl-css-js#usage

function noflip(value) {
  if (typeof value === 'number') return "".concat(value, "px ").concat(NOFLIP);
  if (typeof value === 'string') return "".concat(value, " ").concat(NOFLIP);
  throw new TypeError('noflip expects a string or a number');
}
});

var isTransitionEndSupported_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTransitionEndSupported;

function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}
});

var getTransformStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;

function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}
});

var getCalendarMonthWidth_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;

function getCalendarMonthWidth(daySize) {
  var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return 7 * daySize + 2 * calendarMonthPadding + 1;
}
});

var toISOMonthString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISOMonthString;

var _moment = interopRequireDefault(moment);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

function toISOMonthString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0');
}
});

var isSameMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameMonth;

var _moment = interopRequireDefault(moment);

function isSameMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.month() === b.month() && a.year() === b.year();
}
});

var isPrevMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrevMonth;

var _moment = interopRequireDefault(moment);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

function isPrevMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
}
});

var isNextMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextMonth;

var _moment = interopRequireDefault(moment);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

function isNextMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().add(1, 'month'), b);
}
});

var CalendarMonthGrid_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(moment);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _CalendarMonth = interopRequireDefault(CalendarMonth_1);

var _isTransitionEndSupported = interopRequireDefault(isTransitionEndSupported_1);

var _getTransformStyles = interopRequireDefault(getTransformStyles_1);

var _getCalendarMonthWidth = interopRequireDefault(getCalendarMonthWidth_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var _isPrevMonth = interopRequireDefault(isPrevMonth_1);

var _isNextMonth = interopRequireDefault(isNextMonth_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  enableOutsideDays: _propTypes$1["default"].bool,
  firstVisibleMonthIndex: _propTypes$1["default"].number,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  initialMonth: _reactMomentProptypes["default"].momentObj,
  isAnimating: _propTypes$1["default"].bool,
  numberOfMonths: _propTypes$1["default"].number,
  modifiers: _propTypes$1["default"].objectOf(_propTypes$1["default"].objectOf(_ModifiersShape["default"])),
  orientation: _ScrollableOrientationShape["default"],
  onDayClick: _propTypes$1["default"].func,
  onDayMouseEnter: _propTypes$1["default"].func,
  onDayMouseLeave: _propTypes$1["default"].func,
  onMonthTransitionEnd: _propTypes$1["default"].func,
  onMonthChange: _propTypes$1["default"].func,
  onYearChange: _propTypes$1["default"].func,
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  translationValue: _propTypes$1["default"].number,
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  daySize: airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes$1["default"].bool,
  // indicates whether or not to move focus to focusable day
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes$1["default"].func,
  isRTL: _propTypes$1["default"].bool,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  // i18n
  monthFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string
})) : {};
var defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  horizontalMonthPadding: 13,
  initialMonth: (0, _moment["default"])(),
  isAnimating: false,
  numberOfMonths: 1,
  modifiers: {},
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onMonthTransitionEnd: function onMonthTransitionEnd() {},
  renderMonthText: null,
  renderCalendarDay: undefined,
  renderDayContents: null,
  translationValue: null,
  renderMonthElement: null,
  daySize: constants$2.DAY_SIZE,
  focusedDate: null,
  isFocused: false,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  isRTL: false,
  transitionDuration: 200,
  verticalBorderSpacing: undefined,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined
};

function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
  var months = [];

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
}

var CalendarMonthGrid =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonthGrid, _ref);
  var _proto = CalendarMonthGrid.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonthGrid(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var withoutTransitionMonths = props.orientation === constants$2.VERTICAL_SCROLLABLE;
    _this.state = {
      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
    };
    _this.isTransitionEndSupported = (0, _isTransitionEndSupported["default"])();
    _this.onTransitionEnd = _this.onTransitionEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.locale = _moment["default"].locale();
    _this.onMonthSelect = _this.onMonthSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearSelect = _this.onYearSelect.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, lib.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var initialMonth = nextProps.initialMonth,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation;
    var months = this.state.months;
    var _this$props = this.props,
        prevInitialMonth = _this$props.initialMonth,
        prevNumberOfMonths = _this$props.numberOfMonths;
    var hasMonthChanged = !prevInitialMonth.isSame(initialMonth, 'month');
    var hasNumberOfMonthsChanged = prevNumberOfMonths !== numberOfMonths;
    var newMonths = months;

    if (hasMonthChanged && !hasNumberOfMonthsChanged) {
      if ((0, _isNextMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(1);
        newMonths.push(months[months.length - 1].clone().add(1, 'month'));
      } else if ((0, _isPrevMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(0, months.length - 1);
        newMonths.unshift(months[0].clone().subtract(1, 'month'));
      } else {
        var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
        newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
      }
    }

    if (hasNumberOfMonthsChanged) {
      var _withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;

      newMonths = getMonths(initialMonth, numberOfMonths, _withoutTransitionMonths);
    }

    var momentLocale = _moment["default"].locale();

    if (this.locale !== momentLocale) {
      this.locale = momentLocale;
      newMonths = newMonths.map(function (m) {
        return m.locale(_this2.locale);
      });
    }

    this.setState({
      months: newMonths
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props2 = this.props,
        isAnimating = _this$props2.isAnimating,
        transitionDuration = _this$props2.transitionDuration,
        onMonthTransitionEnd = _this$props2.onMonthTransitionEnd; // For IE9, immediately call onMonthTransitionEnd instead of
    // waiting for the animation to complete. Similarly, if transitionDuration
    // is set to 0, also immediately invoke the onMonthTransitionEnd callback

    if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
      onMonthTransitionEnd();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeEventListener) this.removeEventListener();
  };

  _proto.onTransitionEnd = function onTransitionEnd() {
    var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
    onMonthTransitionEnd();
  };

  _proto.onMonthSelect = function onMonthSelect(currentMonth, newMonthVal) {
    var newMonth = currentMonth.clone();
    var _this$props3 = this.props,
        onMonthChange = _this$props3.onMonthChange,
        orientation = _this$props3.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('month', newMonthVal).subtract(initialMonthSubtraction, 'months');
    onMonthChange(newMonth);
  };

  _proto.onYearSelect = function onYearSelect(currentMonth, newYearVal) {
    var newMonth = currentMonth.clone();
    var _this$props4 = this.props,
        onYearChange = _this$props4.onYearChange,
        orientation = _this$props4.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('year', newYearVal).subtract(initialMonthSubtraction, 'months');
    onYearChange(newMonth);
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props5 = this.props,
        enableOutsideDays = _this$props5.enableOutsideDays,
        firstVisibleMonthIndex = _this$props5.firstVisibleMonthIndex,
        horizontalMonthPadding = _this$props5.horizontalMonthPadding,
        isAnimating = _this$props5.isAnimating,
        modifiers = _this$props5.modifiers,
        numberOfMonths = _this$props5.numberOfMonths,
        monthFormat = _this$props5.monthFormat,
        orientation = _this$props5.orientation,
        translationValue = _this$props5.translationValue,
        daySize = _this$props5.daySize,
        onDayMouseEnter = _this$props5.onDayMouseEnter,
        onDayMouseLeave = _this$props5.onDayMouseLeave,
        onDayClick = _this$props5.onDayClick,
        renderMonthText = _this$props5.renderMonthText,
        renderCalendarDay = _this$props5.renderCalendarDay,
        renderDayContents = _this$props5.renderDayContents,
        renderMonthElement = _this$props5.renderMonthElement,
        onMonthTransitionEnd = _this$props5.onMonthTransitionEnd,
        firstDayOfWeek = _this$props5.firstDayOfWeek,
        focusedDate = _this$props5.focusedDate,
        isFocused = _this$props5.isFocused,
        isRTL = _this$props5.isRTL,
        styles = _this$props5.styles,
        phrases = _this$props5.phrases,
        dayAriaLabelFormat = _this$props5.dayAriaLabelFormat,
        transitionDuration = _this$props5.transitionDuration,
        verticalBorderSpacing = _this$props5.verticalBorderSpacing,
        setMonthTitleHeight = _this$props5.setMonthTitleHeight;
    var months = this.state.months;
    var isVertical = orientation === constants$2.VERTICAL_ORIENTATION;
    var isVerticalScrollable = orientation === constants$2.VERTICAL_SCROLLABLE;
    var isHorizontal = orientation === constants$2.HORIZONTAL_ORIENTATION;
    var calendarMonthWidth = (0, _getCalendarMonthWidth["default"])(daySize, horizontalMonthPadding);
    var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
    var transformType = isVertical || isVerticalScrollable ? 'translateY' : 'translateX';
    var transformValue = "".concat(transformType, "(").concat(translationValue, "px)");
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
      transition: "transform ".concat(transitionDuration, "ms ease-in-out")
    }, _objectSpread({}, (0, _getTransformStyles["default"])(transformValue), {
      width: width
    })), {
      ref: this.setContainerRef,
      onTransitionEnd: onMonthTransitionEnd
    }), months.map(function (month, i) {
      var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
      var hideForAnimation = i === 0 && !isVisible;
      var showForAnimation = i === 0 && isAnimating && isVisible;
      var monthString = (0, _toISOMonthString["default"])(month);
      return _react["default"].createElement("div", (0, _extends2["default"])({
        key: monthString
      }, (0, withStyles_1.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
        position: 'absolute',
        left: -calendarMonthWidth
      }, showForAnimation && !isVertical && isRTL && {
        position: 'absolute',
        right: 0
      }, showForAnimation && isVertical && {
        position: 'absolute',
        top: -translationValue
      }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)), _react["default"].createElement(_CalendarMonth["default"], {
        month: month,
        isVisible: isVisible,
        enableOutsideDays: enableOutsideDays,
        modifiers: modifiers[monthString],
        monthFormat: monthFormat,
        orientation: orientation,
        onDayMouseEnter: onDayMouseEnter,
        onDayMouseLeave: onDayMouseLeave,
        onDayClick: onDayClick,
        onMonthSelect: _this3.onMonthSelect,
        onYearSelect: _this3.onYearSelect,
        renderMonthText: renderMonthText,
        renderCalendarDay: renderCalendarDay,
        renderDayContents: renderDayContents,
        renderMonthElement: renderMonthElement,
        firstDayOfWeek: firstDayOfWeek,
        daySize: daySize,
        focusedDate: isVisible ? focusedDate : null,
        isFocused: isFocused,
        phrases: phrases,
        setMonthTitleHeight: setMonthTitleHeight,
        dayAriaLabelFormat: dayAriaLabelFormat,
        verticalBorderSpacing: verticalBorderSpacing,
        horizontalMonthPadding: horizontalMonthPadding
      }));
    }));
  };

  return CalendarMonthGrid;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonthGrid.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarMonthGrid.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      spacing = _ref2$reactDates.spacing,
      zIndex = _ref2$reactDates.zIndex;
  return {
    CalendarMonthGrid: {
      background: color.background,
      textAlign: (0, _noflip["default"])('left'),
      zIndex: zIndex
    },
    CalendarMonthGrid__animating: {
      zIndex: zIndex + 1
    },
    CalendarMonthGrid__horizontal: {
      position: 'absolute',
      left: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    CalendarMonthGrid__vertical: {
      margin: '0 auto'
    },
    CalendarMonthGrid__vertical_scrollable: {
      margin: '0 auto'
    },
    CalendarMonthGrid_month__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top',
      minHeight: '100%'
    },
    CalendarMonthGrid_month__hideForAnimation: {
      position: 'absolute',
      zIndex: zIndex - 1,
      opacity: 0,
      pointerEvents: 'none'
    },
    CalendarMonthGrid_month__hidden: {
      visibility: 'hidden'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonthGrid);

exports["default"] = _default;
});

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault$2(React);



var _propTypes2 = _interopRequireDefault$2(_propTypes);



var _reactDom2 = _interopRequireDefault$2(_reactDom);



function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$1 = function (_React$Component) {
  _inherits$1(Portal, _React$Component);

  function Portal() {
    _classCallCheck$1(this, Portal);

    return _possibleConstructorReturn$1(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!utils.canUseDOM) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(_react2.default.Component);

Portal$1.propTypes = {
  children: _propTypes2.default.node.isRequired,
  node: _propTypes2.default.any
};

var _default = Portal$1;

var Portal_1 = /*#__PURE__*/Object.defineProperty({
	default: _default
}, '__esModule', {value: true});

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2$1 = _interopRequireDefault$3(React);



var _reactDom2$1 = _interopRequireDefault$3(_reactDom);



var _propTypes2$1 = _interopRequireDefault$3(_propTypes);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16

var Portal$2 = function (_React$Component) {
  _inherits$2(Portal, _React$Component);

  function Portal() {
    _classCallCheck$2(this, Portal);

    return _possibleConstructorReturn$2(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$1(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _reactDom2$1.default.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = _react2$1.default.cloneElement(this.props.children);
      }

      this.portal = _reactDom2$1.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react2$1.default.Component);

var _default$1 = Portal$2;


Portal$2.propTypes = {
  children: _propTypes2$1.default.node.isRequired,
  node: _propTypes2$1.default.any
};

var LegacyPortal = /*#__PURE__*/Object.defineProperty({
	default: _default$1
}, '__esModule', {value: true});

var _reactDom2$2 = _interopRequireDefault$4(_reactDom);



var _Portal2 = _interopRequireDefault$4(Portal_1);



var _LegacyPortal2 = _interopRequireDefault$4(LegacyPortal);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Portal$3 = void 0;

if (_reactDom2$2.default.createPortal) {
  Portal$3 = _Portal2.default;
} else {
  Portal$3 = _LegacyPortal2.default;
}

var _default$2 = Portal$3;

var PortalCompat = /*#__PURE__*/Object.defineProperty({
	default: _default$2
}, '__esModule', {value: true});

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2$2 = _interopRequireDefault$5(React);



var _propTypes2$2 = _interopRequireDefault$5(_propTypes);



var _PortalCompat2 = _interopRequireDefault$5(PortalCompat);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits$3(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck$3(this, PortalWithState);

    var _this = _possibleConstructorReturn$3(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass$2(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return _react2$2.default.createElement(
        _PortalCompat2.default,
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(_react2$2.default.Component);

PortalWithState.propTypes = {
  children: _propTypes2$2.default.func.isRequired,
  defaultOpen: _propTypes2$2.default.bool,
  node: _propTypes2$2.default.any,
  closeOnEsc: _propTypes2$2.default.bool,
  closeOnOutsideClick: _propTypes2$2.default.bool,
  onOpen: _propTypes2$2.default.func,
  onClose: _propTypes2$2.default.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

var _default$3 = PortalWithState;

var PortalWithState_1 = /*#__PURE__*/Object.defineProperty({
	default: _default$3
}, '__esModule', {value: true});

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalWithState = exports.Portal = undefined;



var _PortalCompat2 = _interopRequireDefault(PortalCompat);



var _PortalWithState2 = _interopRequireDefault(PortalWithState_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Portal = _PortalCompat2.default;
exports.PortalWithState = _PortalWithState2.default;
});

var build$3 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
module.exports = exports['default'];
});

var implementation$9 = function contains(other) {
	if (arguments.length < 1) {
		throw new TypeError('1 argument is required');
	}
	if (typeof other !== 'object') {
		throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
	}

	var node = other;
	do {
		if (this === node) {
			return true;
		}
		if (node) {
			node = node.parentNode;
		}
	} while (node);

	return false;
};

var polyfill$e = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			try {
				if (typeof document.body.contains.call(document, '') === 'boolean') {
					return document.body.contains;
				}
			} catch (e) { /**/ }
		}
	}
	return implementation$9;
};

var shim$7 = function shimContains() {
	var polyfill = polyfill$e();
	if (typeof document !== 'undefined') {
		defineProperties_1(
			document,
			{ contains: polyfill },
			{ contains: function () { return document.contains !== polyfill; } }
		);
		if (typeof Element !== 'undefined') {
			defineProperties_1(
				Element.prototype,
				{ contains: polyfill },
				{ contains: function () { return Element.prototype.contains !== polyfill; } }
			);
		}
	}
	return polyfill;
};

var polyfill$f = polyfill$e();


var boundContains = function contains(node, other) {
	return polyfill$f.apply(node, [other]);
};

defineProperties_1(boundContains, {
	getPolyfill: polyfill$e,
	implementation: implementation$9,
	shim: shim$7
});

var document_contains = boundContains;

var OutsideClickHandler_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(_propTypes);







var _object2 = _interopRequireDefault(object_values);



var _document2 = _interopRequireDefault(document_contains);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISPLAY = {
  BLOCK: 'block',
  FLEX: 'flex',
  INLINE: 'inline',
  INLINE_BLOCK: 'inline-block',
  CONTENTS: 'contents'
};

var propTypes = (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes2['default'].node.isRequired,
  onOutsideClick: _propTypes2['default'].func.isRequired,
  disabled: _propTypes2['default'].bool,
  useCapture: _propTypes2['default'].bool,
  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
});

var defaultProps = {
  disabled: false,

  // `useCapture` is set to true by default so that a `stopPropagation` in the
  // children will not prevent all outside click handlers from firing - maja
  useCapture: true,
  display: DISPLAY.BLOCK
};

var OutsideClickHandler = function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _ref;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _props = this.props,
            disabled = _props.disabled,
            useCapture = _props.useCapture;


        if (!disabled) this.addMouseDownEventListener(useCapture);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(_ref2) {
        var prevDisabled = _ref2.disabled;
        var _props2 = this.props,
            disabled = _props2.disabled,
            useCapture = _props2.useCapture;

        if (prevDisabled !== disabled) {
          if (disabled) {
            this.removeEventListeners();
          } else {
            this.addMouseDownEventListener(useCapture);
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.removeEventListeners();
      }

      return componentWillUnmount;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseDown',
    value: function () {
      function onMouseDown(e) {
        var useCapture = this.props.useCapture;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (!isDescendantOfRoot) {
          if (this.removeMouseUp) {
            this.removeMouseUp();
            this.removeMouseUp = null;
          }
          this.removeMouseUp = (0, lib.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
        }
      }

      return onMouseDown;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseUp',
    value: function () {
      function onMouseUp(e) {
        var onOutsideClick = this.props.onOutsideClick;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (this.removeMouseUp) {
          this.removeMouseUp();
          this.removeMouseUp = null;
        }

        if (!isDescendantOfRoot) {
          onOutsideClick(e);
        }
      }

      return onMouseUp;
    }()
  }, {
    key: 'setChildNodeRef',
    value: function () {
      function setChildNodeRef(ref) {
        this.childNode = ref;
      }

      return setChildNodeRef;
    }()
  }, {
    key: 'addMouseDownEventListener',
    value: function () {
      function addMouseDownEventListener(useCapture) {
        this.removeMouseDown = (0, lib.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
      }

      return addMouseDownEventListener;
    }()
  }, {
    key: 'removeEventListeners',
    value: function () {
      function removeEventListeners() {
        if (this.removeMouseDown) this.removeMouseDown();
        if (this.removeMouseUp) this.removeMouseUp();
      }

      return removeEventListeners;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props3 = this.props,
            children = _props3.children,
            display = _props3.display;


        return _react2['default'].createElement(
          'div',
          {
            ref: this.setChildNodeRef,
            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
          },
          children
        );
      }

      return render;
    }()
  }]);

  return OutsideClickHandler;
}(_react2['default'].Component);

exports['default'] = OutsideClickHandler;


OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;
});

// eslint-disable-next-line import/no-unresolved
var reactOutsideClickHandler = OutsideClickHandler_1;

var FocusedInputShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.START_DATE, constants$2.END_DATE]);

exports["default"] = _default;
});

var IconPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.ICON_BEFORE_POSITION, constants$2.ICON_AFTER_POSITION]);

exports["default"] = _default;
});

var OrientationShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.HORIZONTAL_ORIENTATION, constants$2.VERTICAL_ORIENTATION]);

exports["default"] = _default;
});

var DisabledShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOfType([_propTypes$1["default"].bool, _propTypes$1["default"].oneOf([constants$2.START_DATE, constants$2.END_DATE])]);

exports["default"] = _default;
});

var AnchorDirectionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.ANCHOR_LEFT, constants$2.ANCHOR_RIGHT]);

exports["default"] = _default;
});

var OpenDirectionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.OPEN_DOWN, constants$2.OPEN_UP]);

exports["default"] = _default;
});

var CalendarInfoPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.INFO_POSITION_TOP, constants$2.INFO_POSITION_BOTTOM, constants$2.INFO_POSITION_BEFORE, constants$2.INFO_POSITION_AFTER]);

exports["default"] = _default;
});

var NavPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);



var _default = _propTypes$1["default"].oneOf([constants$2.NAV_POSITION_BOTTOM, constants$2.NAV_POSITION_TOP]);

exports["default"] = _default;
});

var DateRangePickerShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _FocusedInputShape = interopRequireDefault(FocusedInputShape);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _OrientationShape = interopRequireDefault(OrientationShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _AnchorDirectionShape = interopRequireDefault(AnchorDirectionShape);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _default = {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes$1["default"].func.isRequired,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes$1["default"].func.isRequired,
  onClose: _propTypes$1["default"].func,
  // input related props
  startDateId: _propTypes$1["default"].string.isRequired,
  startDatePlaceholderText: _propTypes$1["default"].string,
  startDateOffset: _propTypes$1["default"].func,
  endDateOffset: _propTypes$1["default"].func,
  endDateId: _propTypes$1["default"].string.isRequired,
  endDatePlaceholderText: _propTypes$1["default"].string,
  startDateAriaLabel: _propTypes$1["default"].string,
  endDateAriaLabel: _propTypes$1["default"].string,
  disabled: _DisabledShape["default"],
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  screenReaderInputMessage: _propTypes$1["default"].string,
  showClearDates: _propTypes$1["default"].bool,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes$1["default"].node,
  customArrowIcon: _propTypes$1["default"].node,
  customCloseIcon: _propTypes$1["default"].node,
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  keepFocusOnInput: _propTypes$1["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes$1["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes$1["default"].number,
  withPortal: _propTypes$1["default"].bool,
  withFullScreenPortal: _propTypes$1["default"].bool,
  appendToBody: _propTypes$1["default"].bool,
  disableScroll: _propTypes$1["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes$1["default"].bool,
  firstDayOfWeek: _DayOfWeekShape["default"],
  initialVisibleMonth: _propTypes$1["default"].func,
  numberOfMonths: _propTypes$1["default"].number,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  reopenPickerOnClearDates: _propTypes$1["default"].bool,
  renderCalendarInfo: _propTypes$1["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes$1["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  minimumNights: _propTypes$1["default"].number,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  enableOutsideDays: _propTypes$1["default"].bool,
  isDayBlocked: _propTypes$1["default"].func,
  isOutsideRange: _propTypes$1["default"].func,
  isDayHighlighted: _propTypes$1["default"].func,
  // internationalization props
  displayFormat: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].func]),
  monthFormat: _propTypes$1["default"].string,
  weekDayFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string
};
exports["default"] = _default;
});

var getResponsiveContainerStyles_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getResponsiveContainerStyles;

var _defineProperty2 = interopRequireDefault(defineProperty$2);



function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var calculatedOffset = anchorDirection === constants$2.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
  var calculatedMargin = margin || 0;
  return (0, _defineProperty2["default"])({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
}
});

var getDetachedContainerStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDetachedContainerStyles;



/**
 * Calculate and return a CSS transform style to position a detached element
 * next to a reference element. The open and anchor direction indicate wether
 * it should be positioned above/below and/or to the left/right of the
 * reference element.
 *
 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
 * corners of the reference and detached elements, respectively:
 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
 *
 * By using a CSS transform, we allow to further position it using
 * top/bottom CSS properties for the anchor gutter.
 *
 * @param {string} openDirection The vertical positioning of the popup
 * @param {string} anchorDirection The horizontal position of the popup
 * @param {HTMLElement} referenceEl The reference element
 */
function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
  var referenceRect = referenceEl.getBoundingClientRect();
  var offsetX = referenceRect.left;
  var offsetY = referenceRect.top;

  if (openDirection === constants$2.OPEN_UP) {
    offsetY = -(window.innerHeight - referenceRect.bottom);
  }

  if (anchorDirection === constants$2.ANCHOR_RIGHT) {
    offsetX = -(window.innerWidth - referenceRect.right);
  }

  return {
    transform: "translate3d(".concat(Math.round(offsetX), "px, ").concat(Math.round(offsetY), "px, 0)")
  };
}
});

var getInputHeight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInputHeight;

/* eslint-disable camelcase */
function getPadding(vertical, top, bottom) {
  var isTopDefined = typeof top === 'number';
  var isBottomDefined = typeof bottom === 'number';
  var isVerticalDefined = typeof vertical === 'number';

  if (isTopDefined && isBottomDefined) {
    return top + bottom;
  }

  if (isTopDefined && isVerticalDefined) {
    return top + vertical;
  }

  if (isTopDefined) {
    return top;
  }

  if (isBottomDefined && isVerticalDefined) {
    return bottom + vertical;
  }

  if (isBottomDefined) {
    return bottom;
  }

  if (isVerticalDefined) {
    return 2 * vertical;
  }

  return 0;
}

function getInputHeight(_ref, small) {
  var _ref$font$input = _ref.font.input,
      lineHeight = _ref$font$input.lineHeight,
      lineHeight_small = _ref$font$input.lineHeight_small,
      _ref$spacing = _ref.spacing,
      inputPadding = _ref$spacing.inputPadding,
      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
  var calcLineHeight = small ? lineHeight_small : lineHeight;
  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
}
});

var isBeforeDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBeforeDay;

var _moment = interopRequireDefault(moment);

function isBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var aYear = a.year();
  var aMonth = a.month();
  var bYear = b.year();
  var bMonth = b.month();
  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;
  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
}
});

var isInclusivelyAfterDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyAfterDay;

var _moment = interopRequireDefault(moment);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

function isInclusivelyAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b);
}
});

var disableScroll_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = getScrollParent;
exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
exports["default"] = disableScroll;

var getScrollingRoot = function getScrollingRoot() {
  return document.scrollingElement || document.documentElement;
};
/**
 * Recursively finds the scroll parent of a node. The scroll parrent of a node
 * is the closest node that is scrollable. A node is scrollable if:
 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
 *  - and its children/content are "bigger" than the node's box height.
 *
 * The root of the document always scrolls by default.
 *
 * @param {HTMLElement} node Any DOM element.
 * @return {HTMLElement} The scroll parent element.
 */


function getScrollParent(node) {
  var parent = node.parentElement;
  if (parent == null) return getScrollingRoot();

  var _window$getComputedSt = window.getComputedStyle(parent),
      overflowY = _window$getComputedSt.overflowY;

  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';

  if (canScroll && parent.scrollHeight > parent.clientHeight) {
    return parent;
  }

  return getScrollParent(parent);
}
/**
 * Recursively traverses the tree upwards from the given node, capturing all
 * ancestor nodes that scroll along with their current 'overflow-y' CSS
 * property.
 *
 * @param {HTMLElement} node Any DOM element.
 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
 */


function getScrollAncestorsOverflowY(node) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  var scrollingRoot = getScrollingRoot();
  var scrollParent = getScrollParent(node);
  acc.set(scrollParent, scrollParent.style.overflowY);
  if (scrollParent === scrollingRoot) return acc;
  return getScrollAncestorsOverflowY(scrollParent, acc);
}
/**
 * Disabling the scroll on a node involves finding all the scrollable ancestors
 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
 * 'overflow-y: hidden' (up to the document element) there is no scroll
 * container, thus all the scroll outside of the node is disabled. In order to
 * enable scroll again, we store the previous value of the 'overflow-y' for
 * every ancestor in a closure and reset it back.
 *
 * @param {HTMLElement} node Any DOM element.
 */


function disableScroll(node) {
  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);

  var toggle = function toggle(on) {
    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
    });
  };

  toggle(true);
  return function () {
    return toggle(false);
  };
}
});

var DateInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);





var _throttle = interopRequireDefault(require$$7);

var _isTouchDevice = interopRequireDefault(build$3);

var _noflip = interopRequireDefault(noflip_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FANG_PATH_TOP = "M0,".concat(constants$2.FANG_HEIGHT_PX, " ").concat(constants$2.FANG_WIDTH_PX, ",").concat(constants$2.FANG_HEIGHT_PX, " ").concat(constants$2.FANG_WIDTH_PX / 2, ",0z");
var FANG_STROKE_TOP = "M0,".concat(constants$2.FANG_HEIGHT_PX, " ").concat(constants$2.FANG_WIDTH_PX / 2, ",0 ").concat(constants$2.FANG_WIDTH_PX, ",").concat(constants$2.FANG_HEIGHT_PX);
var FANG_PATH_BOTTOM = "M0,0 ".concat(constants$2.FANG_WIDTH_PX, ",0 ").concat(constants$2.FANG_WIDTH_PX / 2, ",").concat(constants$2.FANG_HEIGHT_PX, "z");
var FANG_STROKE_BOTTOM = "M0,0 ".concat(constants$2.FANG_WIDTH_PX / 2, ",").concat(constants$2.FANG_HEIGHT_PX, " ").concat(constants$2.FANG_WIDTH_PX, ",0");
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  id: _propTypes$1["default"].string.isRequired,
  placeholder: _propTypes$1["default"].string,
  displayValue: _propTypes$1["default"].string,
  ariaLabel: _propTypes$1["default"].string,
  screenReaderMessage: _propTypes$1["default"].string,
  focused: _propTypes$1["default"].bool,
  disabled: _propTypes$1["default"].bool,
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  small: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  onChange: _propTypes$1["default"].func,
  onFocus: _propTypes$1["default"].func,
  onKeyDownShiftTab: _propTypes$1["default"].func,
  onKeyDownTab: _propTypes$1["default"].func,
  onKeyDownArrowDown: _propTypes$1["default"].func,
  onKeyDownQuestionMark: _propTypes$1["default"].func,
  // accessibility
  isFocused: _propTypes$1["default"].bool // describes actual DOM focus

})) : {};
var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  ariaLabel: undefined,
  screenReaderMessage: '',
  focused: false,
  disabled: false,
  required: false,
  readOnly: null,
  openDirection: constants$2.OPEN_DOWN,
  showCaret: false,
  verticalSpacing: constants$2.DEFAULT_VERTICAL_SPACING,
  small: false,
  block: false,
  regular: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // accessibility
  isFocused: false
};

var DateInput =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateInput, _ref);
  var _proto = DateInput.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateInput(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dateString: '',
      isTouchDevice: false
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInputRef = _this.setInputRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 300, {
      trailing: false
    });
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])()
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dateString = this.state.dateString;

    if (dateString && nextProps.displayValue) {
      this.setState({
        dateString: ''
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        focused = _this$props.focused,
        isFocused = _this$props.isFocused;
    if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

    if (focused && isFocused) {
      this.inputRef.focus();
    }
  };

  _proto.onChange = function onChange(e) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onKeyDownQuestionMark = _this$props2.onKeyDownQuestionMark;
    var dateString = e.target.value; // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
    // special case the `?` key so that it always triggers the appropriate callback, instead of
    // modifying the input value

    if (dateString[dateString.length - 1] === '?') {
      onKeyDownQuestionMark(e);
    } else {
      this.setState({
        dateString: dateString
      }, function () {
        return onChange(dateString);
      });
    }
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!constants$2.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    var _this$props3 = this.props,
        onKeyDownShiftTab = _this$props3.onKeyDownShiftTab,
        onKeyDownTab = _this$props3.onKeyDownTab,
        onKeyDownArrowDown = _this$props3.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props3.onKeyDownQuestionMark;
    var key = e.key;

    if (key === 'Tab') {
      if (e.shiftKey) {
        onKeyDownShiftTab(e);
      } else {
        onKeyDownTab(e);
      }
    } else if (key === 'ArrowDown') {
      onKeyDownArrowDown(e);
    } else if (key === '?') {
      e.preventDefault();
      onKeyDownQuestionMark(e);
    }
  };

  _proto.setInputRef = function setInputRef(ref) {
    this.inputRef = ref;
  };

  _proto.render = function render() {
    var _this$state = this.state,
        dateString = _this$state.dateString,
        isTouch = _this$state.isTouchDevice;
    var _this$props4 = this.props,
        id = _this$props4.id,
        placeholder = _this$props4.placeholder,
        ariaLabel = _this$props4.ariaLabel,
        displayValue = _this$props4.displayValue,
        screenReaderMessage = _this$props4.screenReaderMessage,
        focused = _this$props4.focused,
        showCaret = _this$props4.showCaret,
        onFocus = _this$props4.onFocus,
        disabled = _this$props4.disabled,
        required = _this$props4.required,
        readOnly = _this$props4.readOnly,
        openDirection = _this$props4.openDirection,
        verticalSpacing = _this$props4.verticalSpacing,
        small = _this$props4.small,
        regular = _this$props4.regular,
        block = _this$props4.block,
        styles = _this$props4.styles,
        reactDates = _this$props4.theme.reactDates;
    var value = dateString || displayValue || '';
    var screenReaderMessageId = "DateInput__screen-reader-message-".concat(id);
    var withFang = showCaret && focused;
    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === constants$2.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === constants$2.OPEN_UP && styles.DateInput__openUp), _react["default"].createElement("input", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
      "aria-label": ariaLabel === undefined ? placeholder : ariaLabel,
      type: "text",
      id: id,
      name: id,
      ref: this.setInputRef,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onFocus: onFocus,
      placeholder: placeholder,
      autoComplete: "off",
      disabled: disabled,
      readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
      required: required,
      "aria-describedby": screenReaderMessage && screenReaderMessageId
    })), withFang && _react["default"].createElement("svg", (0, _extends2["default"])({
      role: "presentation",
      focusable: "false"
    }, (0, withStyles_1.css)(styles.DateInput_fang, openDirection === constants$2.OPEN_DOWN && {
      top: inputHeight + verticalSpacing - constants$2.FANG_HEIGHT_PX - 1
    }, openDirection === constants$2.OPEN_UP && {
      bottom: inputHeight + verticalSpacing - constants$2.FANG_HEIGHT_PX - 1
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_fangShape), {
      d: openDirection === constants$2.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_fangStroke), {
      d: openDirection === constants$2.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
    }))), screenReaderMessage && _react["default"].createElement("p", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_screenReaderMessage), {
      id: screenReaderMessageId
    }), screenReaderMessage));
  };

  return DateInput;
}(_react["default"].PureComponent || _react["default"].Component);

DateInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing,
      spacing = _ref2$reactDates.spacing,
      font = _ref2$reactDates.font,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateInput: {
      margin: 0,
      padding: spacing.inputPadding,
      background: color.background,
      position: 'relative',
      display: 'inline-block',
      width: sizing.inputWidth,
      verticalAlign: 'middle'
    },
    DateInput__small: {
      width: sizing.inputWidth_small
    },
    DateInput__block: {
      width: '100%'
    },
    DateInput__disabled: {
      background: color.disabled,
      color: color.textDisabled
    },
    DateInput_input: {
      fontWeight: font.input.weight,
      fontSize: font.input.size,
      lineHeight: font.input.lineHeight,
      color: color.text,
      backgroundColor: color.background,
      width: '100%',
      padding: "".concat(spacing.displayTextPaddingVertical, "px ").concat(spacing.displayTextPaddingHorizontal, "px"),
      paddingTop: spacing.displayTextPaddingTop,
      paddingBottom: spacing.displayTextPaddingBottom,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight),
      border: border.input.border,
      borderTop: border.input.borderTop,
      borderRight: (0, _noflip["default"])(border.input.borderRight),
      borderBottom: border.input.borderBottom,
      borderLeft: (0, _noflip["default"])(border.input.borderLeft),
      borderRadius: border.input.borderRadius
    },
    DateInput_input__small: {
      fontSize: font.input.size_small,
      lineHeight: font.input.lineHeight_small,
      letterSpacing: font.input.letterSpacing_small,
      padding: "".concat(spacing.displayTextPaddingVertical_small, "px ").concat(spacing.displayTextPaddingHorizontal_small, "px"),
      paddingTop: spacing.displayTextPaddingTop_small,
      paddingBottom: spacing.displayTextPaddingBottom_small,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft_small),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight_small)
    },
    DateInput_input__regular: {
      fontWeight: 'auto'
    },
    DateInput_input__readOnly: {
      userSelect: 'none'
    },
    DateInput_input__focused: {
      outline: border.input.outlineFocused,
      background: color.backgroundFocused,
      border: border.input.borderFocused,
      borderTop: border.input.borderTopFocused,
      borderRight: (0, _noflip["default"])(border.input.borderRightFocused),
      borderBottom: border.input.borderBottomFocused,
      borderLeft: (0, _noflip["default"])(border.input.borderLeftFocused)
    },
    DateInput_input__disabled: {
      background: color.disabled,
      fontStyle: font.input.styleDisabled
    },
    DateInput_screenReaderMessage: {
      border: 0,
      clip: 'rect(0, 0, 0, 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    },
    DateInput_fang: {
      position: 'absolute',
      width: constants$2.FANG_WIDTH_PX,
      height: constants$2.FANG_HEIGHT_PX,
      left: 22,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      zIndex: zIndex + 2
    },
    DateInput_fangShape: {
      fill: color.background
    },
    DateInput_fangStroke: {
      stroke: color.core.border,
      fill: 'transparent'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateInput);

exports["default"] = _default;
});

var RightArrow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var RightArrow = function RightArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z"
  }));
};

RightArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = RightArrow;
exports["default"] = _default;
});

var LeftArrow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var LeftArrow = function LeftArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z"
  }));
};

LeftArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = LeftArrow;
exports["default"] = _default;
});

var CloseButton_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var CloseButton = function CloseButton(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
  }));
};

CloseButton.defaultProps = {
  focusable: "false",
  viewBox: "0 0 12 12"
};
var _default = CloseButton;
exports["default"] = _default;
});

var CalendarIcon_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var CalendarIcon = function CalendarIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "m107 1393h241v-241h-241zm295 0h268v-241h-268zm-295-295h241v-268h-241zm295 0h268v-268h-268zm-295-321h241v-241h-241zm616 616h268v-241h-268zm-321-616h268v-241h-268zm643 616h241v-241h-241zm-322-295h268v-268h-268zm-294-723v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm616 723h241v-268h-241zm-322-321h268v-241h-268zm322 0h241v-241h-241zm27-402v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm321-54v1072c0 29-11 54-32 75s-46 32-75 32h-1179c-29 0-54-11-75-32s-32-46-32-75v-1072c0-29 11-54 32-75s46-32 75-32h107v-80c0-37 13-68 40-95s57-39 94-39h54c37 0 68 13 95 39 26 26 39 58 39 95v80h321v-80c0-37 13-69 40-95 26-26 57-39 94-39h54c37 0 68 13 94 39s40 58 40 95v80h107c29 0 54 11 75 32s32 46 32 75z"
  }));
};

CalendarIcon.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1393.1 1500"
};
var _default = CalendarIcon;
exports["default"] = _default;
});

var DateRangePickerInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DateInput = interopRequireDefault(DateInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _RightArrow = interopRequireDefault(RightArrow_1);

var _LeftArrow = interopRequireDefault(LeftArrow_1);

var _CloseButton = interopRequireDefault(CloseButton_1);

var _CalendarIcon = interopRequireDefault(CalendarIcon_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  children: _propTypes$1["default"].node,
  startDateId: _propTypes$1["default"].string,
  startDatePlaceholderText: _propTypes$1["default"].string,
  startDateAriaLabel: _propTypes$1["default"].string,
  screenReaderMessage: _propTypes$1["default"].string,
  endDateId: _propTypes$1["default"].string,
  endDatePlaceholderText: _propTypes$1["default"].string,
  endDateAriaLabel: _propTypes$1["default"].string,
  onStartDateFocus: _propTypes$1["default"].func,
  onEndDateFocus: _propTypes$1["default"].func,
  onStartDateChange: _propTypes$1["default"].func,
  onEndDateChange: _propTypes$1["default"].func,
  onStartDateShiftTab: _propTypes$1["default"].func,
  onEndDateTab: _propTypes$1["default"].func,
  onClearDates: _propTypes$1["default"].func,
  onKeyDownArrowDown: _propTypes$1["default"].func,
  onKeyDownQuestionMark: _propTypes$1["default"].func,
  startDate: _propTypes$1["default"].string,
  endDate: _propTypes$1["default"].string,
  isStartDateFocused: _propTypes$1["default"].bool,
  isEndDateFocused: _propTypes$1["default"].bool,
  showClearDates: _propTypes$1["default"].bool,
  disabled: _DisabledShape["default"],
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes$1["default"].bool,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes$1["default"].node,
  customArrowIcon: _propTypes$1["default"].node,
  customCloseIcon: _propTypes$1["default"].node,
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  // accessibility
  isFocused: _propTypes$1["default"].bool,
  // describes actual DOM focus
  // i18n
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes$1["default"].bool
})) : {};
var defaultProps = {
  children: null,
  startDateId: constants$2.START_DATE,
  endDateId: constants$2.END_DATE,
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  onStartDateFocus: function onStartDateFocus() {},
  onEndDateFocus: function onEndDateFocus() {},
  onStartDateChange: function onStartDateChange() {},
  onEndDateChange: function onEndDateChange() {},
  onStartDateShiftTab: function onStartDateShiftTab() {},
  onEndDateTab: function onEndDateTab() {},
  onClearDates: function onClearDates() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  startDate: '',
  endDate: '',
  isStartDateFocused: false,
  isEndDateFocused: false,
  showClearDates: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$2.OPEN_DOWN,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

function DateRangePickerInput(_ref) {
  var children = _ref.children,
      startDate = _ref.startDate,
      startDateId = _ref.startDateId,
      startDatePlaceholderText = _ref.startDatePlaceholderText,
      screenReaderMessage = _ref.screenReaderMessage,
      isStartDateFocused = _ref.isStartDateFocused,
      onStartDateChange = _ref.onStartDateChange,
      onStartDateFocus = _ref.onStartDateFocus,
      onStartDateShiftTab = _ref.onStartDateShiftTab,
      startDateAriaLabel = _ref.startDateAriaLabel,
      endDate = _ref.endDate,
      endDateId = _ref.endDateId,
      endDatePlaceholderText = _ref.endDatePlaceholderText,
      isEndDateFocused = _ref.isEndDateFocused,
      onEndDateChange = _ref.onEndDateChange,
      onEndDateFocus = _ref.onEndDateFocus,
      onEndDateTab = _ref.onEndDateTab,
      endDateAriaLabel = _ref.endDateAriaLabel,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      onClearDates = _ref.onClearDates,
      showClearDates = _ref.showClearDates,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      openDirection = _ref.openDirection,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      customInputIcon = _ref.customInputIcon,
      customArrowIcon = _ref.customArrowIcon,
      customCloseIcon = _ref.customCloseIcon,
      isFocused = _ref.isFocused,
      phrases = _ref.phrases,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      verticalSpacing = _ref.verticalSpacing,
      small = _ref.small,
      regular = _ref.regular,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon_svg));

  var arrowIcon = customArrowIcon || _react["default"].createElement(_RightArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));

  if (isRTL) arrowIcon = _react["default"].createElement(_LeftArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));
  if (small) arrowIcon = '-';

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));

  var screenReaderStartDateText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;
  var screenReaderEndDateText = screenReaderMessage || phrases.keyboardBackwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onKeyDownArrowDown
  }), calendarIcon);

  var startDateDisabled = disabled === constants$2.START_DATE || disabled === true;
  var endDateDisabled = disabled === constants$2.END_DATE || disabled === true;
  return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates), inputIconPosition === constants$2.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: startDateId,
    placeholder: startDatePlaceholderText,
    ariaLabel: startDateAriaLabel,
    displayValue: startDate,
    screenReaderMessage: screenReaderStartDateText,
    focused: isStartDateFocused,
    isFocused: isFocused,
    disabled: startDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onStartDateChange,
    onFocus: onStartDateFocus,
    onKeyDownShiftTab: onStartDateShiftTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), children, _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePickerInput_arrow), {
    "aria-hidden": "true",
    role: "presentation"
  }), arrowIcon), _react["default"].createElement(_DateInput["default"], {
    id: endDateId,
    placeholder: endDatePlaceholderText,
    ariaLabel: endDateAriaLabel,
    displayValue: endDate,
    screenReaderMessage: screenReaderEndDateText,
    focused: isEndDateFocused,
    isFocused: isFocused,
    disabled: endDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onEndDateChange,
    onFocus: onEndDateFocus,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    onKeyDownTab: onEndDateTab,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), showClearDates && _react["default"].createElement("button", (0, _extends2["default"])({
    type: "button",
    "aria-label": phrases.clearDates
  }, (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
    onClick: onClearDates,
    disabled: disabled
  }), closeIcon), inputIconPosition === constants$2.ICON_AFTER_POSITION && inputIcon);
}

DateRangePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePickerInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing;
  return {
    DateRangePickerInput: {
      backgroundColor: color.background,
      display: 'inline-block'
    },
    DateRangePickerInput__disabled: {
      background: color.disabled
    },
    DateRangePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    DateRangePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePickerInput__block: {
      display: 'block'
    },
    DateRangePickerInput__showClearDates: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_arrow: {
      display: 'inline-block',
      verticalAlign: 'middle',
      color: color.text
    },
    DateRangePickerInput_arrow_svg: {
      verticalAlign: 'middle',
      fill: color.text,
      height: sizing.arrowWidth,
      width: sizing.arrowWidth
    },
    DateRangePickerInput_clearDates: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    DateRangePickerInput_clearDates__small: {
      padding: 6
    },
    DateRangePickerInput_clearDates_default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    DateRangePickerInput_clearDates__hide: {
      visibility: 'hidden'
    },
    DateRangePickerInput_clearDates_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    DateRangePickerInput_clearDates_svg__small: {
      height: 9
    },
    DateRangePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePickerInput);

exports["default"] = _default;
});

var toLocalizedDateString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toLocalizedDateString;

var _moment = interopRequireDefault(moment);

var _toMomentObject = interopRequireDefault(toMomentObject_1);



function toLocalizedDateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null;
  return dateObj.format(constants$2.DISPLAY_FORMAT);
}
});

var DateRangePickerInputController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _moment = interopRequireDefault(moment);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _DateRangePickerInput = interopRequireDefault(DateRangePickerInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes$1["default"].node,
  startDate: _reactMomentProptypes["default"].momentObj,
  startDateId: _propTypes$1["default"].string,
  startDatePlaceholderText: _propTypes$1["default"].string,
  isStartDateFocused: _propTypes$1["default"].bool,
  startDateAriaLabel: _propTypes$1["default"].string,
  endDate: _reactMomentProptypes["default"].momentObj,
  endDateId: _propTypes$1["default"].string,
  endDatePlaceholderText: _propTypes$1["default"].string,
  isEndDateFocused: _propTypes$1["default"].bool,
  endDateAriaLabel: _propTypes$1["default"].string,
  screenReaderMessage: _propTypes$1["default"].string,
  showClearDates: _propTypes$1["default"].bool,
  showCaret: _propTypes$1["default"].bool,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  reopenPickerOnClearDates: _propTypes$1["default"].bool,
  withFullScreenPortal: _propTypes$1["default"].bool,
  minimumNights: airbnbPropTypes.nonNegativeInteger,
  isOutsideRange: _propTypes$1["default"].func,
  displayFormat: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].func]),
  onFocusChange: _propTypes$1["default"].func,
  onClose: _propTypes$1["default"].func,
  onDatesChange: _propTypes$1["default"].func,
  onKeyDownArrowDown: _propTypes$1["default"].func,
  onKeyDownQuestionMark: _propTypes$1["default"].func,
  customInputIcon: _propTypes$1["default"].node,
  customArrowIcon: _propTypes$1["default"].node,
  customCloseIcon: _propTypes$1["default"].node,
  // accessibility
  isFocused: _propTypes$1["default"].bool,
  // i18n
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes$1["default"].bool
}) : {};
var defaultProps = {
  children: null,
  startDate: null,
  startDateId: constants$2.START_DATE,
  startDatePlaceholderText: 'Start Date',
  isStartDateFocused: false,
  startDateAriaLabel: undefined,
  endDate: null,
  endDateId: constants$2.END_DATE,
  endDatePlaceholderText: 'End Date',
  isEndDateFocused: false,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  showClearDates: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$2.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  withFullScreenPortal: false,
  minimumNights: 1,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  onDatesChange: function onDatesChange() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

var DateRangePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePickerInputController, _ref);
  var _proto = DateRangePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateChange = _this.onStartDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateFocus = _this.onStartDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateChange = _this.onEndDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateFocus = _this.onEndDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDates = _this.clearDates.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onClearFocus = function onClearFocus() {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onEndDateChange = function onEndDateChange(endDateString) {
    var _this$props2 = this.props,
        startDate = _this$props2.startDate,
        isOutsideRange = _this$props2.isOutsideRange,
        minimumNights = _this$props2.minimumNights,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onDatesChange = _this$props2.onDatesChange;
    var endDate = (0, _toMomentObject["default"])(endDateString, this.getDisplayFormat());
    var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days')));

    if (isEndDateValid) {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      if (!keepOpenOnDateSelect) this.onClearFocus();
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: null
      });
    }
  };

  _proto.onEndDateFocus = function onEndDateFocus() {
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        onFocusChange = _this$props3.onFocusChange,
        withFullScreenPortal = _this$props3.withFullScreenPortal,
        disabled = _this$props3.disabled;

    if (!startDate && withFullScreenPortal && (!disabled || disabled === constants$2.END_DATE)) {
      // When the datepicker is full screen, we never want to focus the end date first
      // because there's no indication that that is the case once the datepicker is open and it
      // might confuse the user
      onFocusChange(constants$2.START_DATE);
    } else if (!disabled || disabled === constants$2.START_DATE) {
      onFocusChange(constants$2.END_DATE);
    }
  };

  _proto.onStartDateChange = function onStartDateChange(startDateString) {
    var endDate = this.props.endDate;
    var _this$props4 = this.props,
        isOutsideRange = _this$props4.isOutsideRange,
        minimumNights = _this$props4.minimumNights,
        onDatesChange = _this$props4.onDatesChange,
        onFocusChange = _this$props4.onFocusChange,
        disabled = _this$props4.disabled;
    var startDate = (0, _toMomentObject["default"])(startDateString, this.getDisplayFormat());
    var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days'));
    var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === constants$2.END_DATE && isEndDateBeforeStartDate);

    if (isStartDateValid) {
      if (isEndDateBeforeStartDate) {
        endDate = null;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      onFocusChange(constants$2.END_DATE);
    } else {
      onDatesChange({
        startDate: null,
        endDate: endDate
      });
    }
  };

  _proto.onStartDateFocus = function onStartDateFocus() {
    var _this$props5 = this.props,
        disabled = _this$props5.disabled,
        onFocusChange = _this$props5.onFocusChange;

    if (!disabled || disabled === constants$2.END_DATE) {
      onFocusChange(constants$2.START_DATE);
    }
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDates = function clearDates() {
    var _this$props6 = this.props,
        onDatesChange = _this$props6.onDatesChange,
        reopenPickerOnClearDates = _this$props6.reopenPickerOnClearDates,
        onFocusChange = _this$props6.onFocusChange;
    onDatesChange({
      startDate: null,
      endDate: null
    });

    if (reopenPickerOnClearDates) {
      onFocusChange(constants$2.START_DATE);
    }
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        children = _this$props7.children,
        startDate = _this$props7.startDate,
        startDateId = _this$props7.startDateId,
        startDatePlaceholderText = _this$props7.startDatePlaceholderText,
        isStartDateFocused = _this$props7.isStartDateFocused,
        startDateAriaLabel = _this$props7.startDateAriaLabel,
        endDate = _this$props7.endDate,
        endDateId = _this$props7.endDateId,
        endDatePlaceholderText = _this$props7.endDatePlaceholderText,
        endDateAriaLabel = _this$props7.endDateAriaLabel,
        isEndDateFocused = _this$props7.isEndDateFocused,
        screenReaderMessage = _this$props7.screenReaderMessage,
        showClearDates = _this$props7.showClearDates,
        showCaret = _this$props7.showCaret,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customInputIcon = _this$props7.customInputIcon,
        customArrowIcon = _this$props7.customArrowIcon,
        customCloseIcon = _this$props7.customCloseIcon,
        disabled = _this$props7.disabled,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        isFocused = _this$props7.isFocused,
        phrases = _this$props7.phrases,
        onKeyDownArrowDown = _this$props7.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props7.onKeyDownQuestionMark,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing;
    var startDateString = this.getDateString(startDate);
    var endDateString = this.getDateString(endDate);
    return _react["default"].createElement(_DateRangePickerInput["default"], {
      startDate: startDateString,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: isStartDateFocused,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDateString,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: isEndDateFocused,
      endDateAriaLabel: endDateAriaLabel,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      phrases: phrases,
      onStartDateChange: this.onStartDateChange,
      onStartDateFocus: this.onStartDateFocus,
      onStartDateShiftTab: this.onClearFocus,
      onEndDateChange: this.onEndDateChange,
      onEndDateFocus: this.onEndDateFocus,
      showClearDates: showClearDates,
      onClearDates: this.clearDates,
      screenReaderMessage: screenReaderMessage,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return DateRangePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DateRangePickerInputController;
DateRangePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePickerInputController.defaultProps = defaultProps;
});

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

var isNextDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextDay;

var _moment = interopRequireDefault(moment);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isNextDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var nextDay = (0, _moment["default"])(a).add(1, 'day');
  return (0, _isSameDay["default"])(nextDay, b);
}
});

var isAfterDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAfterDay;

var _moment = interopRequireDefault(moment);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
}
});

var isPreviousDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPreviousDay;

var _moment = interopRequireDefault(moment);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isPreviousDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var dayBefore = (0, _moment["default"])(a).subtract(1, 'day');
  return (0, _isSameDay["default"])(dayBefore, b);
}
});

var getVisibleDays_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getVisibleDays;

var _moment = interopRequireDefault(moment);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
  if (!_moment["default"].isMoment(month)) return {};
  var visibleDaysByMonth = {};
  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    var visibleDays = []; // set utc offset to get correct dates in future (when timezone changes)

    var baseDate = currentMonth.clone();
    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
    var currentDay = firstOfMonth.clone(); // days belonging to the previous month

    if (enableOutsideDays) {
      for (var j = 0; j < currentDay.weekday(); j += 1) {
        var prevDay = currentDay.clone().subtract(j + 1, 'day');
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(currentDay.clone());
      currentDay.add(1, 'day');
    }

    if (enableOutsideDays) {
      // weekday() returns the index of the day of the week according to the locale
      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
      if (currentDay.weekday() !== 0) {
        // days belonging to the next month
        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
          var nextDay = currentDay.clone().add(count, 'day');
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[(0, _toISOMonthString["default"])(currentMonth)] = visibleDays;
    currentMonth = currentMonth.clone().add(1, 'month');
  }

  return visibleDaysByMonth;
}
});

var isDayVisible_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDayVisible;

var _moment = interopRequireDefault(moment);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var startCacheOutsideDays = new Map();
var endCacheOutsideDays = new Map();
var startCacheInsideDays = new Map();
var endCacheInsideDays = new Map();

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  if (!_moment["default"].isMoment(day)) return false; // Cloning is a little expensive, so we want to do it as little as possible.

  var startKey = (0, _toISOMonthString["default"])(month); // eslint-disable-next-line prefer-template

  var endKey = startKey + '+' + numberOfMonths;

  if (enableOutsideDays) {
    if (!startCacheOutsideDays.has(startKey)) {
      startCacheOutsideDays.set(startKey, month.clone().startOf('month').startOf('week'));
    }

    if ((0, _isBeforeDay["default"])(day, startCacheOutsideDays.get(startKey))) return false;

    if (!endCacheOutsideDays.has(endKey)) {
      endCacheOutsideDays.set(endKey, month.clone().endOf('week').add(numberOfMonths - 1, 'months').endOf('month').endOf('week'));
    }

    return !(0, _isAfterDay["default"])(day, endCacheOutsideDays.get(endKey));
  } // !enableOutsideDays


  if (!startCacheInsideDays.has(startKey)) {
    startCacheInsideDays.set(startKey, month.clone().startOf('month'));
  }

  if ((0, _isBeforeDay["default"])(day, startCacheInsideDays.get(startKey))) return false;

  if (!endCacheInsideDays.has(endKey)) {
    endCacheInsideDays.set(endKey, month.clone().add(numberOfMonths - 1, 'months').endOf('month'));
  }

  return !(0, _isAfterDay["default"])(day, endCacheInsideDays.get(endKey));
}
});

var getSelectedDateOffset_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedDateOffset;

var defaultModifier = function defaultModifier(day) {
  return day;
};

function getSelectedDateOffset(fn, day) {
  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
  if (!fn) return day;
  return modifier(fn(day.clone()));
}
});

var getPreviousMonthMemoLast_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPreviousMonthMemoLast;
var getPreviousMonthMemoKey;
var getPreviousMonthMemoValue;

function getPreviousMonthMemoLast(month) {
  if (month !== getPreviousMonthMemoKey) {
    getPreviousMonthMemoKey = month;
    getPreviousMonthMemoValue = month.clone().subtract(1, 'month');
  }

  return getPreviousMonthMemoValue;
}
});

var addModifier_1 = addModifier;
var deleteModifier_1 = deleteModifier;

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var _getPreviousMonthMemoLast = interopRequireDefault(getPreviousMonthMemoLast_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function addModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === constants$2.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterAddition = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (!month[iso] || !month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers.add(modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterAddition);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (!month[iso] || !month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers.add(modifier);
      updatedDaysAfterAddition[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterAddition;
}

function deleteModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === constants$2.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterDeletion = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (month[iso] && month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers["delete"](modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterDeletion);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (month[iso] && month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers["delete"](modifier);
      updatedDaysAfterDeletion[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterDeletion;
}

var modifiers = /*#__PURE__*/Object.defineProperty({
	addModifier: addModifier_1,
	deleteModifier: deleteModifier_1
}, '__esModule', {value: true});

var ChevronUp_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var ChevronUp = function ChevronUp(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M32 713l453-453c11-11 21-11 32 0l453 453c5 5 7 10 7 16 0 13-10 23-22 23-7 0-12-2-16-7L501 309 64 745c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32z"
  }));
};

ChevronUp.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronUp;
exports["default"] = _default;
});

var ChevronDown_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React);

var ChevronDown = function ChevronDown(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M968 289L514 741c-11 11-21 11-32 0L29 289c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437 436 438-436c4-5 9-7 16-7 6 0 11 2 16 7 9 10 9 21 0 32z"
  }));
};

ChevronDown.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronDown;
exports["default"] = _default;
});

var DayPickerNavigation_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _LeftArrow = interopRequireDefault(LeftArrow_1);

var _RightArrow = interopRequireDefault(RightArrow_1);

var _ChevronUp = interopRequireDefault(ChevronUp_1);

var _ChevronDown = interopRequireDefault(ChevronDown_1);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  disablePrev: _propTypes$1["default"].bool,
  disableNext: _propTypes$1["default"].bool,
  inlineStyles: _propTypes$1["default"].object,
  isRTL: _propTypes$1["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  orientation: _ScrollableOrientationShape["default"],
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  // internationalization
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerNavigationPhrases)),
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  showNavPrevButton: _propTypes$1["default"].bool,
  showNavNextButton: _propTypes$1["default"].bool
})) : {};
var defaultProps = {
  disablePrev: false,
  disableNext: false,
  inlineStyles: null,
  isRTL: false,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  phrases: defaultPhrases.DayPickerNavigationPhrases,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  showNavPrevButton: true,
  showNavNextButton: true
};

var DayPickerNavigation =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerNavigation, _ref);

  function DayPickerNavigation() {
    return _ref.apply(this, arguments) || this;
  }

  var _proto = DayPickerNavigation.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        inlineStyles = _this$props.inlineStyles,
        isRTL = _this$props.isRTL,
        disablePrev = _this$props.disablePrev,
        disableNext = _this$props.disableNext,
        navPosition = _this$props.navPosition,
        navPrev = _this$props.navPrev,
        navNext = _this$props.navNext,
        onPrevMonthClick = _this$props.onPrevMonthClick,
        onNextMonthClick = _this$props.onNextMonthClick,
        orientation = _this$props.orientation,
        phrases = _this$props.phrases,
        renderNavPrevButton = _this$props.renderNavPrevButton,
        renderNavNextButton = _this$props.renderNavNextButton,
        showNavPrevButton = _this$props.showNavPrevButton,
        showNavNextButton = _this$props.showNavNextButton,
        styles = _this$props.styles;

    if (!showNavNextButton && !showNavPrevButton) {
      return null;
    }

    var isHorizontal = orientation === constants$2.HORIZONTAL_ORIENTATION;
    var isVertical = orientation !== constants$2.HORIZONTAL_ORIENTATION;
    var isVerticalScrollable = orientation === constants$2.VERTICAL_SCROLLABLE;
    var isBottomNavPosition = navPosition === constants$2.NAV_POSITION_BOTTOM;
    var hasInlineStyles = !!inlineStyles;
    var navPrevIcon = navPrev;
    var navNextIcon = navNext;
    var isDefaultNavPrev = false;
    var isDefaultNavNext = false;
    var navPrevTabIndex = {};
    var navNextTabIndex = {};

    if (!navPrevIcon && !renderNavPrevButton && showNavPrevButton) {
      navPrevTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavPrev = true;
      var Icon = isVertical ? _ChevronUp["default"] : _LeftArrow["default"];

      if (isRTL && !isVertical) {
        Icon = _RightArrow["default"];
      }

      navPrevIcon = _react["default"].createElement(Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disablePrev && styles.DayPickerNavigation_svg__disabled));
    }

    if (!navNextIcon && !renderNavNextButton && showNavNextButton) {
      navNextTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavNext = true;

      var _Icon = isVertical ? _ChevronDown["default"] : _RightArrow["default"];

      if (isRTL && !isVertical) {
        _Icon = _LeftArrow["default"];
      }

      navNextIcon = _react["default"].createElement(_Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disableNext && styles.DayPickerNavigation_svg__disabled));
    }

    var isDefaultNav = isDefaultNavNext || isDefaultNavPrev;
    return _react["default"].createElement("div", withStyles_1.css.apply(void 0, [styles.DayPickerNavigation, isHorizontal && styles.DayPickerNavigation__horizontal].concat((0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation__vertical, isDefaultNav && styles.DayPickerNavigation__verticalDefault] : []), (0, _toConsumableArray2["default"])(isVerticalScrollable ? [styles.DayPickerNavigation__verticalScrollable, isDefaultNav && styles.DayPickerNavigation__verticalScrollableDefault, showNavPrevButton && styles.DayPickerNavigation__verticalScrollable_prevNav] : []), (0, _toConsumableArray2["default"])(isBottomNavPosition ? [styles.DayPickerNavigation__bottom, isDefaultNav && styles.DayPickerNavigation__bottomDefault] : []), [hasInlineStyles && inlineStyles])), showNavPrevButton && (renderNavPrevButton ? renderNavPrevButton({
      ariaLabel: phrases.jumpToPrevMonth,
      disabled: disablePrev,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navPrevTabIndex, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default, disablePrev && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_prevButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_prevButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disablePrev ? true : undefined,
      "aria-label": phrases.jumpToPrevMonth,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navPrevIcon)), showNavNextButton && (renderNavNextButton ? renderNavNextButton({
      ariaLabel: phrases.jumpToNextMonth,
      disabled: disableNext,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navNextTabIndex, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default, disableNext && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_nextButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disableNext ? true : undefined,
      "aria-label": phrases.jumpToNextMonth,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navNextIcon)));
  };

  return DayPickerNavigation;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerNavigation.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerNavigation.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DayPickerNavigation: {
      position: 'relative',
      zIndex: zIndex + 2
    },
    DayPickerNavigation__horizontal: {
      height: 0
    },
    DayPickerNavigation__vertical: {},
    DayPickerNavigation__verticalScrollable: {},
    DayPickerNavigation__verticalScrollable_prevNav: {
      zIndex: zIndex + 1 // zIndex + 2 causes the button to show on top of the day of week headers

    },
    DayPickerNavigation__verticalDefault: {
      position: 'absolute',
      width: '100%',
      height: 52,
      bottom: 0,
      left: (0, _noflip["default"])(0)
    },
    DayPickerNavigation__verticalScrollableDefault: {
      position: 'relative'
    },
    DayPickerNavigation__bottom: {
      height: 'auto'
    },
    DayPickerNavigation__bottomDefault: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    DayPickerNavigation_button: {
      cursor: 'pointer',
      userSelect: 'none',
      border: 0,
      padding: 0,
      margin: 0
    },
    DayPickerNavigation_button__default: {
      border: "1px solid ".concat(color.core.borderLight),
      backgroundColor: color.background,
      color: color.placeholderText,
      ':focus': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':hover': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':active': {
        background: color.backgroundDark
      }
    },
    DayPickerNavigation_button__disabled: {
      cursor: 'default',
      border: "1px solid ".concat(color.disabled),
      ':focus': {
        border: "1px solid ".concat(color.disabled)
      },
      ':hover': {
        border: "1px solid ".concat(color.disabled)
      },
      ':active': {
        background: 'none'
      }
    },
    DayPickerNavigation_button__horizontal: {},
    DayPickerNavigation_button__horizontalDefault: {
      position: 'absolute',
      top: 18,
      lineHeight: 0.78,
      borderRadius: 3,
      padding: '6px 9px'
    },
    DayPickerNavigation_bottomButton__horizontalDefault: {
      position: 'static',
      marginLeft: 22,
      marginRight: 22,
      marginBottom: 30,
      marginTop: -10
    },
    DayPickerNavigation_leftButton__horizontalDefault: {
      left: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_rightButton__horizontalDefault: {
      right: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_button__vertical: {},
    DayPickerNavigation_button__verticalDefault: {
      padding: 5,
      background: color.background,
      boxShadow: (0, _noflip["default"])('0 0 5px 2px rgba(0, 0, 0, 0.1)'),
      position: 'relative',
      display: 'inline-block',
      textAlign: 'center',
      height: '100%',
      width: '50%'
    },
    DayPickerNavigation_prevButton__verticalDefault: {},
    DayPickerNavigation_nextButton__verticalDefault: {
      borderLeft: (0, _noflip["default"])(0)
    },
    DayPickerNavigation_nextButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_prevButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_svg__horizontal: {
      height: 19,
      width: 19,
      fill: color.core.grayLight,
      display: 'block'
    },
    DayPickerNavigation_svg__vertical: {
      height: 42,
      width: 42,
      fill: color.text
    },
    DayPickerNavigation_svg__disabled: {
      fill: color.disabled
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerNavigation);

exports["default"] = _default;
});

var KeyboardShortcutRow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  unicode: _propTypes$1["default"].string.isRequired,
  label: _propTypes$1["default"].string.isRequired,
  action: _propTypes$1["default"].string.isRequired,
  block: _propTypes$1["default"].bool
})) : {};
var defaultProps = {
  block: false
};

function KeyboardShortcutRow(_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action,
      block = _ref.block,
      styles = _ref.styles;
  return _react["default"].createElement("li", (0, withStyles_1.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block), _react["default"].createElement("span", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.KeyboardShortcutRow_key), {
    role: "img",
    "aria-label": "".concat(label, ",") // add comma so screen readers will pause before reading action

  }), unicode)), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_action), action));
}

KeyboardShortcutRow.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
KeyboardShortcutRow.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var color = _ref2.reactDates.color;
  return {
    KeyboardShortcutRow: {
      listStyle: 'none',
      margin: '6px 0'
    },
    KeyboardShortcutRow__block: {
      marginBottom: 16
    },
    KeyboardShortcutRow_keyContainer: {
      display: 'inline-block',
      whiteSpace: 'nowrap',
      textAlign: 'right',
      // is not handled by isRTL
      marginRight: 6 // is not handled by isRTL

    },
    KeyboardShortcutRow_keyContainer__block: {
      textAlign: 'left',
      // is not handled by isRTL
      display: 'inline'
    },
    KeyboardShortcutRow_key: {
      fontFamily: 'monospace',
      fontSize: 12,
      textTransform: 'uppercase',
      background: color.core.grayLightest,
      padding: '2px 6px'
    },
    KeyboardShortcutRow_action: {
      display: 'inline',
      wordBreak: 'break-word',
      marginLeft: 8 // is not handled by isRTL

    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(KeyboardShortcutRow);

exports["default"] = _default;
});

var DayPickerKeyboardShortcuts_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _KeyboardShortcutRow = interopRequireDefault(KeyboardShortcutRow_1);

var _CloseButton = interopRequireDefault(CloseButton_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TOP_LEFT = 'top-left';
exports.TOP_LEFT = TOP_LEFT;
var TOP_RIGHT = 'top-right';
exports.TOP_RIGHT = TOP_RIGHT;
var BOTTOM_RIGHT = 'bottom-right';
exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  block: _propTypes$1["default"].bool,
  // TODO: rename button location to be direction-agnostic
  buttonLocation: _propTypes$1["default"].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  openKeyboardShortcutsPanel: _propTypes$1["default"].func,
  closeKeyboardShortcutsPanel: _propTypes$1["default"].func,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerKeyboardShortcutsPhrases)),
  renderKeyboardShortcutsButton: _propTypes$1["default"].func,
  renderKeyboardShortcutsPanel: _propTypes$1["default"].func
})) : {};
var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function openKeyboardShortcutsPanel() {},
  closeKeyboardShortcutsPanel: function closeKeyboardShortcutsPanel() {},
  phrases: defaultPhrases.DayPickerKeyboardShortcutsPhrases,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined
};

function getKeyboardShortcuts(phrases) {
  return [{
    unicode: '↵',
    label: phrases.enterKey,
    action: phrases.selectFocusedDate
  }, {
    unicode: '←/→',
    label: phrases.leftArrowRightArrow,
    action: phrases.moveFocusByOneDay
  }, {
    unicode: '↑/↓',
    label: phrases.upArrowDownArrow,
    action: phrases.moveFocusByOneWeek
  }, {
    unicode: 'PgUp/PgDn',
    label: phrases.pageUpPageDown,
    action: phrases.moveFocusByOneMonth
  }, {
    unicode: 'Home/End',
    label: phrases.homeEnd,
    action: phrases.moveFocustoStartAndEndOfWeek
  }, {
    unicode: 'Esc',
    label: phrases.escape,
    action: phrases.returnFocusToInput
  }, {
    unicode: '?',
    label: phrases.questionMark,
    action: phrases.openThisPanel
  }];
}

var DayPickerKeyboardShortcuts =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerKeyboardShortcuts, _ref);
  var _proto = DayPickerKeyboardShortcuts.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerKeyboardShortcuts() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    var phrases = _this.props.phrases;
    _this.keyboardShortcuts = getKeyboardShortcuts(phrases);
    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var phrases = this.props.phrases;

    if (nextProps.phrases !== phrases) {
      this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.handleFocus();
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();
    var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel; // Because the close button is the only focusable element inside of the panel, this
    // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
    // close button or hitting escape

    switch (e.key) {
      case 'Escape':
        closeKeyboardShortcutsPanel();
        break;
      // do nothing - this allows the up and down arrows continue their
      // default behavior of scrolling the content of the Keyboard Shortcuts Panel
      // which is needed when only a single month is shown for instance.

      case 'ArrowUp':
      case 'ArrowDown':
        break;
      // completely block the rest of the keys that have functionality outside of this panel

      case 'Tab':
      case 'Home':
      case 'End':
      case 'PageUp':
      case 'PageDown':
      case 'ArrowLeft':
      case 'ArrowRight':
        e.preventDefault();
        break;
    }
  };

  _proto.onShowKeyboardShortcutsButtonClick = function onShowKeyboardShortcutsButtonClick() {
    var _this2 = this;

    var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel; // we want to return focus to this button after closing the keyboard shortcuts panel

    openKeyboardShortcutsPanel(function () {
      _this2.showKeyboardShortcutsButton.focus();
    });
  };

  _proto.setShowKeyboardShortcutsButtonRef = function setShowKeyboardShortcutsButtonRef(ref) {
    this.showKeyboardShortcutsButton = ref;
  };

  _proto.setHideKeyboardShortcutsButtonRef = function setHideKeyboardShortcutsButtonRef(ref) {
    this.hideKeyboardShortcutsButton = ref;
  };

  _proto.handleFocus = function handleFocus() {
    if (this.hideKeyboardShortcutsButton) {
      // automatically move focus into the dialog by moving
      // to the only interactive element, the hide button
      this.hideKeyboardShortcutsButton.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        buttonLocation = _this$props.buttonLocation,
        showKeyboardShortcutsPanel = _this$props.showKeyboardShortcutsPanel,
        closeKeyboardShortcutsPanel = _this$props.closeKeyboardShortcutsPanel,
        styles = _this$props.styles,
        phrases = _this$props.phrases,
        renderKeyboardShortcutsButton = _this$props.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props.renderKeyboardShortcutsPanel;
    var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
    var bottomRight = buttonLocation === BOTTOM_RIGHT;
    var topRight = buttonLocation === TOP_RIGHT;
    var topLeft = buttonLocation === TOP_LEFT;
    return _react["default"].createElement("div", null, renderKeyboardShortcutsButton && renderKeyboardShortcutsButton({
      // passing in context-specific props
      ref: this.setShowKeyboardShortcutsButtonRef,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      ariaLabel: toggleButtonText
    }), !renderKeyboardShortcutsButton && _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setShowKeyboardShortcutsButtonRef
    }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
      type: "button",
      "aria-label": toggleButtonText,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      }
    }), _react["default"].createElement("span", (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), showKeyboardShortcutsPanel && (renderKeyboardShortcutsPanel ? renderKeyboardShortcutsPanel({
      closeButtonAriaLabel: phrases.hideKeyboardShortcutsPanel,
      keyboardShortcuts: this.keyboardShortcuts,
      onCloseButtonClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown,
      title: phrases.keyboardShortcuts
    }) : _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_panel), {
      role: "dialog",
      "aria-labelledby": "DayPickerKeyboardShortcuts_title",
      "aria-describedby": "DayPickerKeyboardShortcuts_description"
    }), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_title), {
      id: "DayPickerKeyboardShortcuts_title"
    }), phrases.keyboardShortcuts), _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setHideKeyboardShortcutsButtonRef
    }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
      type: "button",
      tabIndex: "0",
      "aria-label": phrases.hideKeyboardShortcutsPanel,
      onClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown
    }), _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_closeSvg))), _react["default"].createElement("ul", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_list), {
      id: "DayPickerKeyboardShortcuts_description"
    }), this.keyboardShortcuts.map(function (_ref2) {
      var unicode = _ref2.unicode,
          label = _ref2.label,
          action = _ref2.action;
      return _react["default"].createElement(_KeyboardShortcutRow["default"], {
        key: label,
        unicode: unicode,
        label: label,
        action: action,
        block: block
      });
    })))));
  };

  return DayPickerKeyboardShortcuts;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerKeyboardShortcuts.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerKeyboardShortcuts.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      font = _ref3$reactDates.font,
      zIndex = _ref3$reactDates.zIndex;
  return {
    DayPickerKeyboardShortcuts_buttonReset: {
      background: 'none',
      border: 0,
      borderRadius: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      padding: 0,
      cursor: 'pointer',
      fontSize: font.size,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_show: {
      width: 33,
      height: 26,
      position: 'absolute',
      zIndex: zIndex + 2,
      '::before': {
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    },
    DayPickerKeyboardShortcuts_show__bottomRight: {
      bottom: 0,
      right: 0,
      '::before': {
        borderTop: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        bottom: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topRight: {
      top: 0,
      right: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        top: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topLeft: {
      top: 0,
      left: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderLeft: "33px solid ".concat(color.core.primary),
        top: 0,
        left: 0
      },
      ':hover::before': {
        borderLeft: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_showSpan: {
      color: color.core.white,
      position: 'absolute'
    },
    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
      bottom: 0,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topRight: {
      top: 1,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topLeft: {
      top: 1,
      left: 5
    },
    DayPickerKeyboardShortcuts_panel: {
      overflow: 'auto',
      background: color.background,
      border: "1px solid ".concat(color.core.border),
      borderRadius: 2,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: zIndex + 2,
      padding: 22,
      margin: 33,
      textAlign: 'left' // TODO: investigate use of text-align throughout the library

    },
    DayPickerKeyboardShortcuts_title: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: 0
    },
    DayPickerKeyboardShortcuts_list: {
      listStyle: 'none',
      padding: 0,
      fontSize: font.size
    },
    DayPickerKeyboardShortcuts_close: {
      position: 'absolute',
      right: 22,
      top: 22,
      zIndex: zIndex + 2,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_closeSvg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter,
      ':hover': {
        fill: color.core.grayLight
      },
      ':focus': {
        fill: color.core.grayLight
      }
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerKeyboardShortcuts);

exports["default"] = _default;
});

var getNumberOfCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumberOfCalendarMonthWeeks;

var _moment = interopRequireDefault(moment);

function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
  var weekDayDiff = firstDayOfMonth.day() - firstDayOfWeek;
  return (weekDayDiff + 7) % 7;
}

function getNumberOfCalendarMonthWeeks(month) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment["default"].localeData().firstDayOfWeek();
  var firstDayOfMonth = month.clone().startOf('month');
  var numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
  return Math.ceil((numBlankDays + month.daysInMonth()) / 7);
}
});

var getActiveElement_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}
});

var DayPicker_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDayPicker = exports.defaultProps = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);





var _moment = interopRequireDefault(moment);

var _throttle = interopRequireDefault(require$$7);

var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _CalendarMonthGrid = interopRequireDefault(CalendarMonthGrid_1);

var _DayPickerNavigation = interopRequireDefault(DayPickerNavigation_1);

var _DayPickerKeyboardShortcuts = interopRequireWildcard(DayPickerKeyboardShortcuts_1);

var _getNumberOfCalendarMonthWeeks = interopRequireDefault(getNumberOfCalendarMonthWeeks_1);

var _getCalendarMonthWidth = interopRequireDefault(getCalendarMonthWidth_1);

var _calculateDimension = interopRequireDefault(calculateDimension_1);

var _getActiveElement = interopRequireDefault(getActiveElement_1);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MONTH_PADDING = 23;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';
var MONTH_SELECTION_TRANSITION = 'month_selection';
var YEAR_SELECTION_TRANSITION = 'year_selection';
var PREV_NAV = 'prev_nav';
var NEXT_NAV = 'next_nav';
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  // calendar presentation props
  enableOutsideDays: _propTypes$1["default"].bool,
  numberOfMonths: _propTypes$1["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes$1["default"].bool,
  onOutsideClick: _propTypes$1["default"].func,
  hidden: _propTypes$1["default"].bool,
  initialVisibleMonth: _propTypes$1["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  renderCalendarInfo: _propTypes$1["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes$1["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes$1["default"].bool,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  renderKeyboardShortcutsButton: _propTypes$1["default"].func,
  renderKeyboardShortcutsPanel: _propTypes$1["default"].func,
  // navigation props
  dayPickerNavigationInlineStyles: _propTypes$1["default"].object,
  disablePrev: _propTypes$1["default"].bool,
  disableNext: _propTypes$1["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  noNavButtons: _propTypes$1["default"].bool,
  noNavNextButton: _propTypes$1["default"].bool,
  noNavPrevButton: _propTypes$1["default"].bool,
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  onMonthChange: _propTypes$1["default"].func,
  onYearChange: _propTypes$1["default"].func,
  onGetNextScrollableMonths: _propTypes$1["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  onGetPrevScrollableMonths: _propTypes$1["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  // month props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes$1["default"].func,
  // day props
  modifiers: _propTypes$1["default"].objectOf(_propTypes$1["default"].objectOf(_ModifiersShape["default"])),
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  onDayClick: _propTypes$1["default"].func,
  onDayMouseEnter: _propTypes$1["default"].func,
  onDayMouseLeave: _propTypes$1["default"].func,
  // accessibility props
  isFocused: _propTypes$1["default"].bool,
  getFirstFocusableDay: _propTypes$1["default"].func,
  onBlur: _propTypes$1["default"].func,
  showKeyboardShortcuts: _propTypes$1["default"].bool,
  onTab: _propTypes$1["default"].func,
  onShiftTab: _propTypes$1["default"].func,
  // internationalization
  monthFormat: _propTypes$1["default"].string,
  weekDayFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string
})) : {};
var defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function onOutsideClick() {},
  hidden: false,
  initialVisibleMonth: function initialVisibleMonth() {
    return (0, _moment["default"])();
  },
  firstDayOfWeek: null,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$2.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$2.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  // navigation props
  dayPickerNavigationInlineStyles: null,
  disablePrev: false,
  disableNext: false,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onGetNextScrollableMonths: function onGetNextScrollableMonths() {},
  onGetPrevScrollableMonths: function onGetPrevScrollableMonths() {},
  // month props
  renderMonthText: null,
  renderMonthElement: null,
  renderWeekHeaderElement: null,
  // day props
  modifiers: {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  // accessibility props
  isFocused: false,
  getFirstFocusableDay: null,
  onBlur: function onBlur() {},
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // internationalization
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined
};
exports.defaultProps = defaultProps;

var DayPicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPicker, _ref);
  var _proto = DayPicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var currentMonth = props.hidden ? (0, _moment["default"])() : props.initialVisibleMonth();
    var focusedDate = currentMonth.clone().startOf('month');

    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var horizontalMonthPadding = props.horizontalMonthPadding;
    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding) : 0;
    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonthScrollTop: null,
      currentMonth: currentMonth,
      monthTransition: null,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
      nextFocusedDate: null,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function onKeyboardShortcutsPanelClose() {},
      isTouchDevice: (0, _isTouchDevice["default"])(),
      withMouseInteractions: true,
      calendarInfoWidth: 0,
      monthTitleHeight: null,
      hasSetHeight: false
    };

    _this.setCalendarMonthWeeks(currentMonth);

    _this.calendarMonthGridHeight = 0;
    _this.setCalendarInfoWidthTimeout = null;
    _this.setCalendarMonthGridHeightTimeout = null;
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 200, {
      trailing: false
    });
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthTransition = _this.onPrevMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthTransition = _this.onNextMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNextScrollableMonths = _this.getNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPrevScrollableMonths = _this.getPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    var orientation = this.props.orientation;
    var currentMonth = this.state.currentMonth;
    var calendarInfoWidth = this.calendarInfo ? (0, _calculateDimension["default"])(this.calendarInfo, 'width', true, true) : 0;
    var currentMonthScrollTop = this.transitionContainer && orientation === constants$2.VERTICAL_SCROLLABLE ? this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop : null;
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])(),
      calendarInfoWidth: calendarInfoWidth,
      currentMonthScrollTop: currentMonthScrollTop
    });
    this.setCalendarMonthWeeks(currentMonth);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var hidden = nextProps.hidden,
        isFocused = nextProps.isFocused,
        showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
        onBlur = nextProps.onBlur,
        orientation = nextProps.orientation,
        renderMonthText = nextProps.renderMonthText,
        horizontalMonthPadding = nextProps.horizontalMonthPadding;
    var currentMonth = this.state.currentMonth;
    var nextCurrentMonth = nextState.currentMonth;

    if (!hidden) {
      if (!this.hasSetInitialVisibleMonth) {
        this.hasSetInitialVisibleMonth = true;
        this.setState({
          currentMonth: nextProps.initialVisibleMonth()
        });
      }
    }

    var _this$props = this.props,
        daySize = _this$props.daySize,
        prevIsFocused = _this$props.isFocused,
        prevRenderMonthText = _this$props.renderMonthText;

    if (nextProps.daySize !== daySize) {
      this.setState({
        calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(nextProps.daySize, horizontalMonthPadding)
      });
    }

    if (isFocused !== prevIsFocused) {
      if (isFocused) {
        var focusedDate = this.getFocusedDay(currentMonth);
        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

        if (nextProps.showKeyboardShortcuts) {
          // the ? shortcut came from the input and we should return input there once it is close
          onKeyboardShortcutsPanelClose = onBlur;
        }

        this.setState({
          showKeyboardShortcuts: showKeyboardShortcuts,
          onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
          focusedDate: focusedDate,
          withMouseInteractions: false
        });
      } else {
        this.setState({
          focusedDate: null
        });
      }
    }

    if (renderMonthText !== prevRenderMonthText) {
      this.setState({
        monthTitleHeight: null
      });
    } // Capture the scroll position so when previous months are rendered above the current month
    // we can adjust scroll after the component has updated and the previous current month
    // stays in view.


    if (orientation === constants$2.VERTICAL_SCROLLABLE && this.transitionContainer && !(0, _isSameMonth["default"])(currentMonth, nextCurrentMonth)) {
      this.setState({
        currentMonthScrollTop: this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    var _this2 = this;

    var transitionDuration = this.props.transitionDuration; // Calculating the dimensions trigger a DOM repaint which
    // breaks the CSS transition.
    // The setTimeout will wait until the transition ends.

    if (this.calendarInfo) {
      this.setCalendarInfoWidthTimeout = setTimeout(function () {
        var calendarInfoWidth = _this2.state.calendarInfoWidth;
        var calendarInfoPanelWidth = (0, _calculateDimension["default"])(_this2.calendarInfo, 'width', true, true);

        if (calendarInfoWidth !== calendarInfoPanelWidth) {
          _this2.setState({
            calendarInfoWidth: calendarInfoPanelWidth
          });
        }
      }, transitionDuration);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
        orientation = _this$props2.orientation,
        daySize = _this$props2.daySize,
        isFocused = _this$props2.isFocused,
        numberOfMonths = _this$props2.numberOfMonths;
    var _this$state = this.state,
        currentMonth = _this$state.currentMonth,
        currentMonthScrollTop = _this$state.currentMonthScrollTop,
        focusedDate = _this$state.focusedDate,
        monthTitleHeight = _this$state.monthTitleHeight;

    if (this.isHorizontal() && (orientation !== prevProps.orientation || daySize !== prevProps.daySize)) {
      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
      var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
      var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    if (!prevProps.isFocused && isFocused && !focusedDate) {
      this.container.focus();
    } // If orientation is VERTICAL_SCROLLABLE and currentMonth has changed adjust scrollTop so the
    // new months rendered above the current month don't push the current month out of view.


    if (orientation === constants$2.VERTICAL_SCROLLABLE && !(0, _isSameMonth["default"])(prevState.currentMonth, currentMonth) && currentMonthScrollTop && this.transitionContainer) {
      this.transitionContainer.scrollTop = this.transitionContainer.scrollHeight - currentMonthScrollTop;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.setCalendarInfoWidthTimeout);
    clearTimeout(this.setCalendarMonthGridHeightTimeout);
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!constants$2.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    this.setState({
      withMouseInteractions: false
    });
    var _this$props3 = this.props,
        onBlur = _this$props3.onBlur,
        onTab = _this$props3.onTab,
        onShiftTab = _this$props3.onShiftTab,
        isRTL = _this$props3.isRTL;
    var _this$state2 = this.state,
        focusedDate = _this$state2.focusedDate,
        showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
    if (!focusedDate) return;
    var newFocusedDate = focusedDate.clone();
    var didTransitionMonth = false; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
    // return it to wherever it was before when the panel was opened

    var activeElement = (0, _getActiveElement["default"])();

    var onKeyboardShortcutsPanelClose = function onKeyboardShortcutsPanelClose() {
      if (activeElement) activeElement.focus();
    };

    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowLeft':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.add(1, 'day');
        } else {
          newFocusedDate.subtract(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'Home':
        e.preventDefault();
        newFocusedDate.startOf('week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'PageUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'month');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowDown':
        e.preventDefault();
        newFocusedDate.add(1, 'week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'ArrowRight':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.subtract(1, 'day');
        } else {
          newFocusedDate.add(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'End':
        e.preventDefault();
        newFocusedDate.endOf('week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'PageDown':
        e.preventDefault();
        newFocusedDate.add(1, 'month');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case '?':
        this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
        break;

      case 'Escape':
        if (showKeyboardShortcuts) {
          this.closeKeyboardShortcutsPanel();
        } else {
          onBlur(e);
        }

        break;

      case 'Tab':
        if (e.shiftKey) {
          onShiftTab();
        } else {
          onTab(e);
        }

        break;
    } // If there was a month transition, do not update the focused date until the transition has
    // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
    // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition


    if (!didTransitionMonth) {
      this.setState({
        focusedDate: newFocusedDate
      });
    }
  };

  _proto.onPrevMonthClick = function onPrevMonthClick(e) {
    if (e) e.preventDefault();
    this.onPrevMonthTransition();
  };

  _proto.onPrevMonthTransition = function onPrevMonthTransition(nextFocusedDate) {
    var _this$props4 = this.props,
        daySize = _this$props4.daySize,
        isRTL = _this$props4.isRTL,
        numberOfMonths = _this$props4.numberOfMonths;
    var _this$state3 = this.state,
        calendarMonthWidth = _this$state3.calendarMonthWidth,
        monthTitleHeight = _this$state3.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var calendarMonthWeeksHeight = this.calendarMonthWeeks[0] * (daySize - 1);
      translationValue = monthTitleHeight + calendarMonthWeeksHeight + 1;
    } else if (this.isHorizontal()) {
      translationValue = calendarMonthWidth;

      if (isRTL) {
        translationValue = -2 * calendarMonthWidth;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(0, numberOfMonths);

      var _calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: PREV_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.onMonthChange = function onMonthChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: MONTH_SELECTION_TRANSITION,
      translationValue: 0.00001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onYearChange = function onYearChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: YEAR_SELECTION_TRANSITION,
      translationValue: 0.0001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick(e) {
    if (e) e.preventDefault();
    this.onNextMonthTransition();
  };

  _proto.onNextMonthTransition = function onNextMonthTransition(nextFocusedDate) {
    var _this$props5 = this.props,
        isRTL = _this$props5.isRTL,
        numberOfMonths = _this$props5.numberOfMonths,
        daySize = _this$props5.daySize;
    var _this$state4 = this.state,
        calendarMonthWidth = _this$state4.calendarMonthWidth,
        monthTitleHeight = _this$state4.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var firstVisibleMonthWeeks = this.calendarMonthWeeks[1];
      var calendarMonthWeeksHeight = firstVisibleMonthWeeks * (daySize - 1);
      translationValue = -(monthTitleHeight + calendarMonthWeeksHeight + 1);
    }

    if (this.isHorizontal()) {
      translationValue = -calendarMonthWidth;

      if (isRTL) {
        translationValue = 0;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(2, numberOfMonths + 2);

      var _calendarMonthWeeksHeight2 = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight2 + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: NEXT_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.getFirstDayOfWeek = function getFirstDayOfWeek() {
    var firstDayOfWeek = this.props.firstDayOfWeek;

    if (firstDayOfWeek == null) {
      return _moment["default"].localeData().firstDayOfWeek();
    }

    return firstDayOfWeek;
  };

  _proto.getWeekHeaders = function getWeekHeaders() {
    var weekDayFormat = this.props.weekDayFormat;
    var currentMonth = this.state.currentMonth;
    var firstDayOfWeek = this.getFirstDayOfWeek();
    var weekHeaders = [];

    for (var i = 0; i < 7; i += 1) {
      weekHeaders.push(currentMonth.clone().day((i + firstDayOfWeek) % 7).format(weekDayFormat));
    }

    return weekHeaders;
  };

  _proto.getFirstVisibleIndex = function getFirstVisibleIndex() {
    var orientation = this.props.orientation;
    var monthTransition = this.state.monthTransition;
    if (orientation === constants$2.VERTICAL_SCROLLABLE) return 0;
    var firstVisibleMonthIndex = 1;

    if (monthTransition === PREV_TRANSITION) {
      firstVisibleMonthIndex -= 1;
    } else if (monthTransition === NEXT_TRANSITION) {
      firstVisibleMonthIndex += 1;
    }

    return firstVisibleMonthIndex;
  };

  _proto.getFocusedDay = function getFocusedDay(newMonth) {
    var _this$props6 = this.props,
        getFirstFocusableDay = _this$props6.getFirstFocusableDay,
        numberOfMonths = _this$props6.numberOfMonths;
    var focusedDate;

    if (getFirstFocusableDay) {
      focusedDate = getFirstFocusableDay(newMonth);
    }

    if (newMonth && (!focusedDate || !(0, _isDayVisible["default"])(focusedDate, newMonth, numberOfMonths))) {
      focusedDate = newMonth.clone().startOf('month');
    }

    return focusedDate;
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight(monthTitleHeight) {
    var _this3 = this;

    this.setState({
      monthTitleHeight: monthTitleHeight
    }, function () {
      _this3.calculateAndSetDayPickerHeight();
    });
  };

  _proto.setCalendarMonthWeeks = function setCalendarMonthWeeks(currentMonth) {
    var numberOfMonths = this.props.numberOfMonths;
    this.calendarMonthWeeks = [];
    var month = currentMonth.clone().subtract(1, 'months');
    var firstDayOfWeek = this.getFirstDayOfWeek();

    for (var i = 0; i < numberOfMonths + 2; i += 1) {
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(month, firstDayOfWeek);
      this.calendarMonthWeeks.push(numberOfWeeks);
      month = month.add(1, 'months');
    }
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.setCalendarInfoRef = function setCalendarInfoRef(ref) {
    this.calendarInfo = ref;
  };

  _proto.setTransitionContainerRef = function setTransitionContainerRef(ref) {
    this.transitionContainer = ref;
  };

  _proto.getNextScrollableMonths = function getNextScrollableMonths(e) {
    var onGetNextScrollableMonths = this.props.onGetNextScrollableMonths;
    if (e) e.preventDefault();
    if (onGetNextScrollableMonths) onGetNextScrollableMonths(e);
    this.setState(function (_ref2) {
      var scrollableMonthMultiple = _ref2.scrollableMonthMultiple;
      return {
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.getPrevScrollableMonths = function getPrevScrollableMonths(e) {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        onGetPrevScrollableMonths = _this$props7.onGetPrevScrollableMonths;
    if (e) e.preventDefault();
    if (onGetPrevScrollableMonths) onGetPrevScrollableMonths(e);
    this.setState(function (_ref3) {
      var currentMonth = _ref3.currentMonth,
          scrollableMonthMultiple = _ref3.scrollableMonthMultiple;
      return {
        currentMonth: currentMonth.clone().subtract(numberOfMonths, 'month'),
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.maybeTransitionNextMonth = function maybeTransitionNextMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        focusedDate = _this$state5.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onNextMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.maybeTransitionPrevMonth = function maybeTransitionPrevMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        focusedDate = _this$state6.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onPrevMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.isHorizontal = function isHorizontal() {
    var orientation = this.props.orientation;
    return orientation === constants$2.HORIZONTAL_ORIENTATION;
  };

  _proto.isVertical = function isVertical() {
    var orientation = this.props.orientation;
    return orientation === constants$2.VERTICAL_ORIENTATION || orientation === constants$2.VERTICAL_SCROLLABLE;
  };

  _proto.updateStateAfterMonthTransition = function updateStateAfterMonthTransition() {
    var _this4 = this;

    var _this$props8 = this.props,
        onPrevMonthClick = _this$props8.onPrevMonthClick,
        onNextMonthClick = _this$props8.onNextMonthClick,
        numberOfMonths = _this$props8.numberOfMonths,
        onMonthChange = _this$props8.onMonthChange,
        onYearChange = _this$props8.onYearChange,
        isRTL = _this$props8.isRTL;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        monthTransition = _this$state7.monthTransition,
        focusedDate = _this$state7.focusedDate,
        nextFocusedDate = _this$state7.nextFocusedDate,
        withMouseInteractions = _this$state7.withMouseInteractions,
        calendarMonthWidth = _this$state7.calendarMonthWidth;
    if (!monthTransition) return;
    var newMonth = currentMonth.clone();
    var firstDayOfWeek = this.getFirstDayOfWeek();

    if (monthTransition === PREV_TRANSITION) {
      newMonth.subtract(1, 'month');
      if (onPrevMonthClick) onPrevMonthClick(newMonth);
      var newInvisibleMonth = newMonth.clone().subtract(1, 'month');
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(newInvisibleMonth, firstDayOfWeek);
      this.calendarMonthWeeks = [numberOfWeeks].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(0, -1)));
    } else if (monthTransition === NEXT_TRANSITION) {
      newMonth.add(1, 'month');
      if (onNextMonthClick) onNextMonthClick(newMonth);

      var _newInvisibleMonth = newMonth.clone().add(numberOfMonths, 'month');

      var _numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(_newInvisibleMonth, firstDayOfWeek);

      this.calendarMonthWeeks = [].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(1)), [_numberOfWeeks]);
    } else if (monthTransition === MONTH_SELECTION_TRANSITION) {
      if (onMonthChange) onMonthChange(newMonth);
    } else if (monthTransition === YEAR_SELECTION_TRANSITION) {
      if (onYearChange) onYearChange(newMonth);
    }

    var newFocusedDate = null;

    if (nextFocusedDate) {
      newFocusedDate = nextFocusedDate;
    } else if (!focusedDate && !withMouseInteractions) {
      newFocusedDate = this.getFocusedDay(newMonth);
    }

    this.setState({
      currentMonth: newMonth,
      monthTransition: null,
      translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
      nextFocusedDate: null,
      focusedDate: newFocusedDate
    }, function () {
      // we don't want to focus on the relevant calendar day after a month transition
      // if the user is navigating around using a mouse
      if (withMouseInteractions) {
        var activeElement = (0, _getActiveElement["default"])();

        if (activeElement && activeElement !== document.body && _this4.container.contains(activeElement) && activeElement.blur) {
          activeElement.blur();
        }
      }
    });
  };

  _proto.adjustDayPickerHeight = function adjustDayPickerHeight(newMonthHeight) {
    var _this5 = this;

    var monthHeight = newMonthHeight + MONTH_PADDING;

    if (monthHeight !== this.calendarMonthGridHeight) {
      this.transitionContainer.style.height = "".concat(monthHeight, "px");

      if (!this.calendarMonthGridHeight) {
        this.setCalendarMonthGridHeightTimeout = setTimeout(function () {
          _this5.setState({
            hasSetHeight: true
          });
        }, 0);
      }

      this.calendarMonthGridHeight = monthHeight;
    }
  };

  _proto.calculateAndSetDayPickerHeight = function calculateAndSetDayPickerHeight() {
    var _this$props9 = this.props,
        daySize = _this$props9.daySize,
        numberOfMonths = _this$props9.numberOfMonths;
    var monthTitleHeight = this.state.monthTitleHeight;
    var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
    var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
    var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;

    if (this.isHorizontal()) {
      this.adjustDayPickerHeight(newMonthHeight);
    }
  };

  _proto.openKeyboardShortcutsPanel = function openKeyboardShortcutsPanel(onCloseCallBack) {
    this.setState({
      showKeyboardShortcuts: true,
      onKeyboardShortcutsPanelClose: onCloseCallBack
    });
  };

  _proto.closeKeyboardShortcutsPanel = function closeKeyboardShortcutsPanel() {
    var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

    if (onKeyboardShortcutsPanelClose) {
      onKeyboardShortcutsPanelClose();
    }

    this.setState({
      onKeyboardShortcutsPanelClose: null,
      showKeyboardShortcuts: false
    });
  };

  _proto.renderNavigation = function renderNavigation(navDirection) {
    var _this$props10 = this.props,
        dayPickerNavigationInlineStyles = _this$props10.dayPickerNavigationInlineStyles,
        disablePrev = _this$props10.disablePrev,
        disableNext = _this$props10.disableNext,
        navPosition = _this$props10.navPosition,
        navPrev = _this$props10.navPrev,
        navNext = _this$props10.navNext,
        noNavButtons = _this$props10.noNavButtons,
        noNavNextButton = _this$props10.noNavNextButton,
        noNavPrevButton = _this$props10.noNavPrevButton,
        orientation = _this$props10.orientation,
        phrases = _this$props10.phrases,
        renderNavPrevButton = _this$props10.renderNavPrevButton,
        renderNavNextButton = _this$props10.renderNavNextButton,
        isRTL = _this$props10.isRTL;

    if (noNavButtons) {
      return null;
    }

    var onPrevMonthClick = orientation === constants$2.VERTICAL_SCROLLABLE ? this.getPrevScrollableMonths : this.onPrevMonthClick;
    var onNextMonthClick = orientation === constants$2.VERTICAL_SCROLLABLE ? this.getNextScrollableMonths : this.onNextMonthClick;
    return _react["default"].createElement(_DayPickerNavigation["default"], {
      disablePrev: disablePrev,
      disableNext: disableNext,
      inlineStyles: dayPickerNavigationInlineStyles,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      orientation: orientation,
      phrases: phrases,
      isRTL: isRTL,
      showNavNextButton: !(noNavNextButton || orientation === constants$2.VERTICAL_SCROLLABLE && navDirection === PREV_NAV),
      showNavPrevButton: !(noNavPrevButton || orientation === constants$2.VERTICAL_SCROLLABLE && navDirection === NEXT_NAV)
    });
  };

  _proto.renderWeekHeader = function renderWeekHeader(index) {
    var _this$props11 = this.props,
        daySize = _this$props11.daySize,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding,
        orientation = _this$props11.orientation,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        styles = _this$props11.styles;
    var calendarMonthWidth = this.state.calendarMonthWidth;
    var verticalScrollable = orientation === constants$2.VERTICAL_SCROLLABLE;
    var horizontalStyle = {
      left: index * calendarMonthWidth
    };
    var verticalStyle = {
      marginLeft: -calendarMonthWidth / 2
    };
    var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation

    if (this.isHorizontal()) {
      weekHeaderStyle = horizontalStyle;
    } else if (this.isVertical() && !verticalScrollable) {
      weekHeaderStyle = verticalStyle;
    }

    var weekHeaders = this.getWeekHeaders();
    var header = weekHeaders.map(function (day) {
      return _react["default"].createElement("li", (0, _extends2["default"])({
        key: day
      }, (0, withStyles_1.css)(styles.DayPicker_weekHeader_li, {
        width: daySize
      })), renderWeekHeaderElement ? renderWeekHeaderElement(day) : _react["default"].createElement("small", null, day));
    });
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      key: "week-".concat(index)
    }), _react["default"].createElement("ul", (0, withStyles_1.css)(styles.DayPicker_weekHeader_ul), header));
  };

  _proto.render = function render() {
    var _this6 = this;

    var _this$state8 = this.state,
        calendarMonthWidth = _this$state8.calendarMonthWidth,
        currentMonth = _this$state8.currentMonth,
        monthTransition = _this$state8.monthTransition,
        translationValue = _this$state8.translationValue,
        scrollableMonthMultiple = _this$state8.scrollableMonthMultiple,
        focusedDate = _this$state8.focusedDate,
        showKeyboardShortcuts = _this$state8.showKeyboardShortcuts,
        isTouch = _this$state8.isTouchDevice,
        hasSetHeight = _this$state8.hasSetHeight,
        calendarInfoWidth = _this$state8.calendarInfoWidth,
        monthTitleHeight = _this$state8.monthTitleHeight;
    var _this$props12 = this.props,
        enableOutsideDays = _this$props12.enableOutsideDays,
        numberOfMonths = _this$props12.numberOfMonths,
        orientation = _this$props12.orientation,
        modifiers = _this$props12.modifiers,
        withPortal = _this$props12.withPortal,
        onDayClick = _this$props12.onDayClick,
        onDayMouseEnter = _this$props12.onDayMouseEnter,
        onDayMouseLeave = _this$props12.onDayMouseLeave,
        firstDayOfWeek = _this$props12.firstDayOfWeek,
        renderMonthText = _this$props12.renderMonthText,
        renderCalendarDay = _this$props12.renderCalendarDay,
        renderDayContents = _this$props12.renderDayContents,
        renderCalendarInfo = _this$props12.renderCalendarInfo,
        renderMonthElement = _this$props12.renderMonthElement,
        renderKeyboardShortcutsButton = _this$props12.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props12.renderKeyboardShortcutsPanel,
        calendarInfoPosition = _this$props12.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props12.hideKeyboardShortcutsPanel,
        onOutsideClick = _this$props12.onOutsideClick,
        monthFormat = _this$props12.monthFormat,
        daySize = _this$props12.daySize,
        isFocused = _this$props12.isFocused,
        isRTL = _this$props12.isRTL,
        styles = _this$props12.styles,
        theme = _this$props12.theme,
        phrases = _this$props12.phrases,
        verticalHeight = _this$props12.verticalHeight,
        dayAriaLabelFormat = _this$props12.dayAriaLabelFormat,
        noBorder = _this$props12.noBorder,
        transitionDuration = _this$props12.transitionDuration,
        verticalBorderSpacing = _this$props12.verticalBorderSpacing,
        horizontalMonthPadding = _this$props12.horizontalMonthPadding,
        navPosition = _this$props12.navPosition;
    var dayPickerHorizontalPadding = theme.reactDates.spacing.dayPickerHorizontalPadding;
    var isHorizontal = this.isHorizontal();
    var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
    var weekHeaders = [];

    for (var i = 0; i < numOfWeekHeaders; i += 1) {
      weekHeaders.push(this.renderWeekHeader(i));
    }

    var verticalScrollable = orientation === constants$2.VERTICAL_SCROLLABLE;
    var height;

    if (isHorizontal) {
      height = this.calendarMonthGridHeight;
    } else if (this.isVertical() && !verticalScrollable && !withPortal) {
      // If the user doesn't set a desired height,
      // we default back to this kind of made-up value that generally looks good
      height = verticalHeight || 1.75 * calendarMonthWidth;
    }

    var isCalendarMonthGridAnimating = monthTransition !== null;
    var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
    var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;

    if (this.isVertical()) {
      keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
    }

    var shouldAnimateHeight = isHorizontal && hasSetHeight;
    var calendarInfoPositionTop = calendarInfoPosition === constants$2.INFO_POSITION_TOP;
    var calendarInfoPositionBottom = calendarInfoPosition === constants$2.INFO_POSITION_BOTTOM;
    var calendarInfoPositionBefore = calendarInfoPosition === constants$2.INFO_POSITION_BEFORE;
    var calendarInfoPositionAfter = calendarInfoPosition === constants$2.INFO_POSITION_AFTER;
    var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;

    var calendarInfo = renderCalendarInfo && _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCalendarInfoRef
    }, (0, withStyles_1.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)), renderCalendarInfo());

    var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
    var firstVisibleMonthIndex = this.getFirstVisibleIndex();
    var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * dayPickerHorizontalPadding; // Adding `1px` because of whitespace between 2 inline-block

    var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
    var transitionContainerStyle = {
      width: isHorizontal && wrapperHorizontalWidth,
      height: height
    };
    var dayPickerWrapperStyle = {
      width: isHorizontal && wrapperHorizontalWidth
    };
    var dayPickerStyle = {
      width: isHorizontal && fullHorizontalWidth,
      // These values are to center the datepicker (approximately) on the page
      marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
      marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
    };
    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !monthTitleHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder), _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: onOutsideClick
    }, (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo, _react["default"].createElement("div", (0, withStyles_1.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
      "aria-hidden": "true",
      role: "presentation"
    }), weekHeaders), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_focusRegion), {
      ref: this.setContainerRef,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      onKeyDown: this.onKeyDown,
      onMouseUp: function onMouseUp() {
        _this6.setState({
          withMouseInteractions: true
        });
      },
      tabIndex: -1,
      role: "application",
      "aria-roledescription": phrases.roleDescription,
      "aria-label": phrases.calendarLabel
    }), !verticalScrollable && navPosition === constants$2.NAV_POSITION_TOP && this.renderNavigation(), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_transitionContainer, shouldAnimateHeight && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
      ref: this.setTransitionContainerRef
    }), verticalScrollable && this.renderNavigation(PREV_NAV), _react["default"].createElement(_CalendarMonthGrid["default"], {
      setMonthTitleHeight: !monthTitleHeight ? this.setMonthTitleHeight : undefined,
      translationValue: translationValue,
      enableOutsideDays: enableOutsideDays,
      firstVisibleMonthIndex: firstVisibleMonthIndex,
      initialMonth: currentMonth,
      isAnimating: isCalendarMonthGridAnimating,
      modifiers: modifiers,
      orientation: orientation,
      numberOfMonths: numberOfMonths * scrollableMonthMultiple,
      onDayClick: onDayClick,
      onDayMouseEnter: onDayMouseEnter,
      onDayMouseLeave: onDayMouseLeave,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      renderMonthText: renderMonthText,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderMonthElement: renderMonthElement,
      onMonthTransitionEnd: this.updateStateAfterMonthTransition,
      monthFormat: monthFormat,
      daySize: daySize,
      firstDayOfWeek: firstDayOfWeek,
      isFocused: shouldFocusDate,
      focusedDate: focusedDate,
      phrases: phrases,
      isRTL: isRTL,
      dayAriaLabelFormat: dayAriaLabelFormat,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    }), verticalScrollable && this.renderNavigation(NEXT_NAV)), !verticalScrollable && navPosition === constants$2.NAV_POSITION_BOTTOM && this.renderNavigation(), !isTouch && !hideKeyboardShortcutsPanel && _react["default"].createElement(_DayPickerKeyboardShortcuts["default"], {
      block: this.isVertical() && !withPortal,
      buttonLocation: keyboardShortcutButtonLocation,
      showKeyboardShortcutsPanel: showKeyboardShortcuts,
      openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
      closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
      phrases: phrases,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel
    }))), (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo));
  };

  return DayPicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDayPicker = DayPicker;
DayPicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref4) {
  var _ref4$reactDates = _ref4.reactDates,
      color = _ref4$reactDates.color,
      font = _ref4$reactDates.font,
      noScrollBarOnVerticalScrollable = _ref4$reactDates.noScrollBarOnVerticalScrollable,
      spacing = _ref4$reactDates.spacing,
      zIndex = _ref4$reactDates.zIndex;
  return {
    DayPicker: {
      background: color.background,
      position: 'relative',
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker__horizontal: {
      background: color.background
    },
    DayPicker__verticalScrollable: {
      height: '100%'
    },
    DayPicker__hidden: {
      visibility: 'hidden'
    },
    DayPicker__withBorder: {
      boxShadow: (0, _noflip["default"])('0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)'),
      borderRadius: 3
    },
    DayPicker_portal__horizontal: {
      boxShadow: 'none',
      position: 'absolute',
      left: (0, _noflip["default"])('50%'),
      top: '50%'
    },
    DayPicker_portal__vertical: {
      position: 'initial'
    },
    DayPicker_focusRegion: {
      outline: 'none'
    },
    DayPicker_calendarInfo__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_wrapper__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_weekHeaders: {
      position: 'relative'
    },
    DayPicker_weekHeaders__horizontal: {
      marginLeft: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    DayPicker_weekHeader: {
      color: color.placeholderText,
      position: 'absolute',
      top: 62,
      zIndex: zIndex + 2,
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker_weekHeader__vertical: {
      left: (0, _noflip["default"])('50%')
    },
    DayPicker_weekHeader__verticalScrollable: {
      top: 0,
      display: 'table-row',
      borderBottom: "1px solid ".concat(color.core.border),
      background: color.background,
      marginLeft: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      width: '100%',
      textAlign: 'center'
    },
    DayPicker_weekHeader_ul: {
      listStyle: 'none',
      margin: '1px 0',
      paddingLeft: (0, _noflip["default"])(0),
      paddingRight: (0, _noflip["default"])(0),
      fontSize: font.size
    },
    DayPicker_weekHeader_li: {
      display: 'inline-block',
      textAlign: 'center'
    },
    DayPicker_transitionContainer: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 3
    },
    DayPicker_transitionContainer__horizontal: {
      transition: 'height 0.2s ease-in-out'
    },
    DayPicker_transitionContainer__vertical: {
      width: '100%'
    },
    DayPicker_transitionContainer__verticalScrollable: _objectSpread({
      paddingTop: 20,
      height: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      overflowY: 'scroll'
    }, noScrollBarOnVerticalScrollable && {
      '-webkitOverflowScrolling': 'touch',
      '::-webkit-scrollbar': {
        '-webkit-appearance': 'none',
        display: 'none'
      }
    })
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPicker);

exports["default"] = _default;
});

var getPooledMoment_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPooledMoment;

var _moment = interopRequireDefault(moment);

var momentPool = new Map();

function getPooledMoment(dayString) {
  if (!momentPool.has(dayString)) {
    momentPool.set(dayString, (0, _moment["default"])(dayString));
  }

  return momentPool.get(dayString);
}
});

var DayPickerRangeController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _slicedToArray2 = interopRequireDefault(slicedToArray);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _moment = interopRequireDefault(moment);

var _object = interopRequireDefault(object_values);

var _isTouchDevice = interopRequireDefault(build$3);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isNextDay = interopRequireDefault(isNextDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isPreviousDay = interopRequireDefault(isPreviousDay_1);

var _getVisibleDays = interopRequireDefault(getVisibleDays_1);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _getSelectedDateOffset = interopRequireDefault(getSelectedDateOffset_1);

var _toISODateString = interopRequireDefault(toISODateString_1);



var _DisabledShape = interopRequireDefault(DisabledShape);

var _FocusedInputShape = interopRequireDefault(FocusedInputShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);



var _DayPicker = interopRequireDefault(DayPicker_1);

var _getPooledMoment = interopRequireDefault(getPooledMoment_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes$1["default"].func,
  startDateOffset: _propTypes$1["default"].func,
  endDateOffset: _propTypes$1["default"].func,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes$1["default"].func,
  onClose: _propTypes$1["default"].func,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  minimumNights: _propTypes$1["default"].number,
  disabled: _DisabledShape["default"],
  isOutsideRange: _propTypes$1["default"].func,
  isDayBlocked: _propTypes$1["default"].func,
  isDayHighlighted: _propTypes$1["default"].func,
  getMinNightsForHoverDate: _propTypes$1["default"].func,
  daysViolatingMinNightsCanBeClicked: _propTypes$1["default"].bool,
  // DayPicker props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes$1["default"].func,
  enableOutsideDays: _propTypes$1["default"].bool,
  numberOfMonths: _propTypes$1["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes$1["default"].bool,
  initialVisibleMonth: _propTypes$1["default"].func,
  hideKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes$1["default"].bool,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes$1["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  noNavButtons: _propTypes$1["default"].bool,
  noNavNextButton: _propTypes$1["default"].bool,
  noNavPrevButton: _propTypes$1["default"].bool,
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  onOutsideClick: _propTypes$1["default"].func,
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  renderCalendarInfo: _propTypes$1["default"].func,
  renderKeyboardShortcutsButton: _propTypes$1["default"].func,
  renderKeyboardShortcutsPanel: _propTypes$1["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  firstDayOfWeek: _DayOfWeekShape["default"],
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  // accessibility
  onBlur: _propTypes$1["default"].func,
  isFocused: _propTypes$1["default"].bool,
  showKeyboardShortcuts: _propTypes$1["default"].bool,
  onTab: _propTypes$1["default"].func,
  onShiftTab: _propTypes$1["default"].func,
  // i18n
  monthFormat: _propTypes$1["default"].string,
  weekDayFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string,
  isRTL: _propTypes$1["default"].bool
}) : {};
var defaultProps = {
  startDate: undefined,
  // TODO: use null
  endDate: undefined,
  // TODO: use null
  minDate: null,
  maxDate: null,
  onDatesChange: function onDatesChange() {},
  startDateOffset: undefined,
  endDateOffset: undefined,
  focusedInput: null,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  disabled: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  getMinNightsForHoverDate: function getMinNightsForHoverDate() {},
  daysViolatingMinNightsCanBeClicked: false,
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: constants$2.DAY_SIZE,
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  calendarInfoPosition: constants$2.INFO_POSITION_BOTTOM,
  firstDayOfWeek: null,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
  if (focusedInput === constants$2.START_DATE) {
    return phrases.chooseAvailableStartDate;
  }

  if (focusedInput === constants$2.END_DATE) {
    return phrases.chooseAvailableEndDate;
  }

  return phrases.chooseAvailableDate;
};

var DayPickerRangeController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerRangeController, _ref);
  var _proto = DayPickerRangeController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerRangeController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = (0, _isTouchDevice["default"])();
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      'selected-start': function selectedStart(day) {
        return _this.isStartDate(day);
      },
      'selected-end': function selectedEnd(day) {
        return _this.isEndDate(day);
      },
      'blocked-minimum-nights': function blockedMinimumNights(day) {
        return _this.doesNotMeetMinimumNights(day);
      },
      'selected-span': function selectedSpan(day) {
        return _this.isInSelectedSpan(day);
      },
      'last-in-range': function lastInRange(day) {
        return _this.isLastInRange(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      'hovered-span': function hoveredSpan(day) {
        return _this.isInHoveredSpan(day);
      },
      'hovered-offset': function hoveredOffset(day) {
        return _this.isInHoveredSpan(day);
      },
      'after-hovered-start': function afterHoveredStart(day) {
        return _this.isDayAfterHoveredStartDate(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      },
      'hovered-start-first-possible-end': function hoveredStartFirstPossibleEnd(day, hoverDate) {
        return _this.isFirstPossibleEndDateForHoveredStartDate(day, hoverDate);
      },
      'hovered-start-blocked-minimum-nights': function hoveredStartBlockedMinimumNights(day, hoverDate) {
        return _this.doesNotMeetMinNightsForHoveredStartDate(day, hoverDate);
      },
      'before-hovered-end': function beforeHoveredEnd(day) {
        return _this.isDayBeforeHoveredEndDate(day);
      },
      'no-selected-start-before-selected-end': function noSelectedStartBeforeSelectedEnd(day) {
        return _this.beforeSelectedEnd(day) && !props.startDate;
      },
      'selected-start-in-hovered-span': function selectedStartInHoveredSpan(day, hoverDate) {
        return _this.isStartDate(day) && (0, _isAfterDay["default"])(hoverDate, day);
      },
      'selected-start-no-selected-end': function selectedStartNoSelectedEnd(day) {
        return _this.isStartDate(day) && !props.endDate;
      },
      'selected-end-no-selected-start': function selectedEndNoSelectedStart(day) {
        return _this.isEndDate(day) && !props.startDate;
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays; // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      phrases: _objectSpread({}, props.phrases, {
        chooseAvailableDate: chooseAvailableDate
      }),
      visibleDays: visibleDays,
      disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
      disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth)
    };
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var startDate = nextProps.startDate,
        endDate = nextProps.endDate,
        focusedInput = nextProps.focusedInput,
        getMinNightsForHoverDate = nextProps.getMinNightsForHoverDate,
        minimumNights = nextProps.minimumNights,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        phrases = nextProps.phrases,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevStartDate = _this$props.startDate,
        prevEndDate = _this$props.endDate,
        prevFocusedInput = _this$props.focusedInput,
        prevMinimumNights = _this$props.minimumNights,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevPhrases = _this$props.phrases,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays;
    var hoverDate = this.state.hoverDate;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
    var didStartDateChange = startDate !== prevStartDate;
    var didEndDateChange = endDate !== prevEndDate;
    var didFocusChange = focusedInput !== prevFocusedInput;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var modifiers = {};

    if (didStartDateChange) {
      modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
      modifiers = this.addModifier(modifiers, startDate, 'selected-start');

      if (prevStartDate) {
        var startSpan = prevStartDate.clone().add(1, 'day');
        var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
        modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');

        if (!endDate || !prevEndDate) {
          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start-no-selected-end');
        }
      }

      if (!prevStartDate && endDate && startDate) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-no-selected-start');
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
          });
        });
      }
    }

    if (didEndDateChange) {
      modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
      modifiers = this.addModifier(modifiers, endDate, 'selected-end');

      if (prevEndDate && (!startDate || !prevStartDate)) {
        modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end-no-selected-start');
      }
    }

    if (didStartDateChange || didEndDateChange) {
      if (prevStartDate && prevEndDate) {
        modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
      }

      if (startDate && endDate) {
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
        modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
      }

      if (startDate && !endDate) {
        modifiers = this.addModifier(modifiers, startDate, 'selected-start-no-selected-end');
      }

      if (endDate && !startDate) {
        modifiers = this.addModifier(modifiers, endDate, 'selected-end-no-selected-start');
      }

      if (!startDate && endDate) {
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);

            if ((0, _isBeforeDay["default"])(momentObj, endDate)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
            }
          });
        });
      }
    }

    if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
      var _startSpan = startDate.clone().add(1, 'day');

      var _endSpan = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
    }

    if (!this.isTouchDevice && didEndDateChange && !startDate && endDate) {
      var _startSpan2 = endDate.clone().subtract(minimumNights, 'days');

      var _endSpan2 = endDate.clone();

      modifiers = this.addModifierToRange(modifiers, _startSpan2, _endSpan2, 'before-hovered-end');
    }

    if (prevMinimumNights > 0) {
      if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
        var _startSpan3 = prevStartDate || this.today;

        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked');
      }
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);
          var isBlocked = false;

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (isBlocked) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    if (!this.isTouchDevice && didFocusChange && hoverDate && !this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === constants$2.END_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }

      if (minNightsForHoverDate > 0 && focusedInput === constants$2.START_DATE) {
        modifiers = this.addModifierToRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.addModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    if (minimumNights > 0 && startDate && focusedInput === constants$2.END_DATE) {
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }

    if (didFocusChange || phrases !== prevPhrases) {
      // set the appropriate CalendarDay phrase based on focusedInput
      var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
      this.setState({
        phrases: _objectSpread({}, phrases, {
          chooseAvailableDate: chooseAvailableDate
        })
      });
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var _this$props2 = this.props,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        minimumNights = _this$props2.minimumNights,
        onBlur = _this$props2.onBlur,
        focusedInput = _this$props2.focusedInput,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose,
        onDatesChange = _this$props2.onDatesChange,
        startDateOffset = _this$props2.startDateOffset,
        endDateOffset = _this$props2.endDateOffset,
        disabled = _this$props2.disabled,
        daysViolatingMinNightsCanBeClicked = _this$props2.daysViolatingMinNightsCanBeClicked;
    if (e) e.preventDefault();
    if (this.isBlocked(day, !daysViolatingMinNightsCanBeClicked)) return;
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate;

    if (startDateOffset || endDateOffset) {
      startDate = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
      endDate = (0, _getSelectedDateOffset["default"])(endDateOffset, day);

      if (this.isBlocked(startDate) || this.isBlocked(endDate)) {
        return;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (!keepOpenOnDateSelect) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else if (focusedInput === constants$2.START_DATE) {
      var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
      var isStartDateAfterEndDate = (0, _isBeforeDay["default"])(lastAllowedStartDate, day) || (0, _isAfterDay["default"])(startDate, endDate);
      var isEndDateDisabled = disabled === constants$2.END_DATE;

      if (!isEndDateDisabled || !isStartDateAfterEndDate) {
        startDate = day;

        if (isStartDateAfterEndDate) {
          endDate = null;
        }
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (isEndDateDisabled && !isStartDateAfterEndDate) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      } else if (!isEndDateDisabled) {
        onFocusChange(constants$2.END_DATE);
      }
    } else if (focusedInput === constants$2.END_DATE) {
      var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

      if (!startDate) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
        onFocusChange(constants$2.START_DATE);
      } else if ((0, _isInclusivelyAfterDay["default"])(day, firstAllowedEndDate)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });

        if (!keepOpenOnDateSelect) {
          onFocusChange(null);
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }
      } else if (daysViolatingMinNightsCanBeClicked && this.doesNotMeetMinimumNights(day)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else if (disabled !== constants$2.START_DATE) {
        startDate = day;
        endDate = null;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else {
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
    }

    onBlur();
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    /* eslint react/destructuring-assignment: 1 */
    if (this.isTouchDevice) return;
    var _this$props4 = this.props,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate,
        focusedInput = _this$props4.focusedInput,
        getMinNightsForHoverDate = _this$props4.getMinNightsForHoverDate,
        minimumNights = _this$props4.minimumNights,
        startDateOffset = _this$props4.startDateOffset,
        endDateOffset = _this$props4.endDateOffset;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays,
        dateOffset = _this$state.dateOffset;
    var nextDateOffset = null;

    if (focusedInput) {
      var hasOffset = startDateOffset || endDateOffset;
      var modifiers = {};

      if (hasOffset) {
        var start = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
        var end = (0, _getSelectedDateOffset["default"])(endDateOffset, day, function (rangeDay) {
          return rangeDay.add(1, 'day');
        });
        nextDateOffset = {
          start: start,
          end: end
        }; // eslint-disable-next-line react/destructuring-assignment

        if (dateOffset && dateOffset.start && dateOffset.end) {
          modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
        }

        modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
      }

      if (!hasOffset) {
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
        modifiers = this.addModifier(modifiers, day, 'hovered');

        if (startDate && !endDate && focusedInput === constants$2.END_DATE) {
          if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
            var endSpan = hoverDate.clone().add(1, 'day');
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
          }

          if ((0, _isBeforeDay["default"])(day, startDate) || (0, _isSameDay["default"])(day, startDate)) {
            modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isAfterDay["default"])(day, startDate)) {
            var _endSpan3 = day.clone().add(1, 'day');

            modifiers = this.addModifierToRange(modifiers, startDate, _endSpan3, 'hovered-span');
            modifiers = this.addModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }
        }

        if (!startDate && endDate && focusedInput === constants$2.START_DATE) {
          if ((0, _isBeforeDay["default"])(hoverDate, endDate)) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
          }

          if ((0, _isAfterDay["default"])(day, endDate) || (0, _isSameDay["default"])(day, endDate)) {
            modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isBeforeDay["default"])(day, endDate)) {
            modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
            modifiers = this.addModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }
        }

        if (startDate) {
          var startSpan = startDate.clone().add(1, 'day');

          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');

          if ((0, _isSameDay["default"])(day, startDate)) {
            var newStartSpan = startDate.clone().add(1, 'day');
            var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
            modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
          }
        }

        if (endDate) {
          var _startSpan4 = endDate.clone().subtract(minimumNights, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, _startSpan4, endDate, 'before-hovered-end');

          if ((0, _isSameDay["default"])(day, endDate)) {
            var _newStartSpan = endDate.clone().subtract(minimumNights, 'days');

            modifiers = this.addModifierToRange(modifiers, _newStartSpan, endDate, 'before-hovered-end');
          }
        }

        if (hoverDate && !this.isBlocked(hoverDate)) {
          var minNightsForPrevHoverDate = getMinNightsForHoverDate(hoverDate);

          if (minNightsForPrevHoverDate > 0 && focusedInput === constants$2.START_DATE) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }

        if (!this.isBlocked(day)) {
          var minNightsForHoverDate = getMinNightsForHoverDate(day);

          if (minNightsForHoverDate > 0 && focusedInput === constants$2.START_DATE) {
            modifiers = this.addModifierToRange(modifiers, day.clone().add(1, 'days'), day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.addModifier(modifiers, day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }
      }

      this.setState({
        hoverDate: day,
        dateOffset: nextDateOffset,
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day) {
    var _this$props5 = this.props,
        startDate = _this$props5.startDate,
        endDate = _this$props5.endDate,
        focusedInput = _this$props5.focusedInput,
        getMinNightsForHoverDate = _this$props5.getMinNightsForHoverDate,
        minimumNights = _this$props5.minimumNights;
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays,
        dateOffset = _this$state2.dateOffset;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = {};
    modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

    if (dateOffset) {
      modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
    }

    if (startDate && !endDate) {
      if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
        var endSpan = hoverDate.clone().add(1, 'day');
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
      }

      if ((0, _isAfterDay["default"])(day, startDate)) {
        modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
      }
    }

    if (!startDate && endDate) {
      if ((0, _isAfterDay["default"])(endDate, hoverDate)) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
      }

      if ((0, _isBeforeDay["default"])(day, endDate)) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
      }
    }

    if (startDate && (0, _isSameDay["default"])(day, startDate)) {
      var startSpan = startDate.clone().add(1, 'day');

      var _endSpan5 = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan5, 'after-hovered-start');
    }

    if (endDate && (0, _isSameDay["default"])(day, endDate)) {
      var _startSpan5 = endDate.clone().subtract(minimumNights, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, _startSpan5, endDate, 'before-hovered-end');
    }

    if (!this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === constants$2.START_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props6 = this.props,
        enableOutsideDays = _this$props6.enableOutsideDays,
        maxDate = _this$props6.maxDate,
        minDate = _this$props6.minDate,
        numberOfMonths = _this$props6.numberOfMonths,
        onPrevMonthClick = _this$props6.onPrevMonthClick;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(2, 'months');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props7 = this.props,
        enableOutsideDays = _this$props7.enableOutsideDays,
        maxDate = _this$props7.maxDate,
        minDate = _this$props7.minDate,
        numberOfMonths = _this$props7.numberOfMonths,
        onNextMonthClick = _this$props7.onNextMonthClick;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays,
        orientation = _this$props8.orientation;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props9 = this.props,
        numberOfMonths = _this$props9.numberOfMonths,
        enableOutsideDays = _this$props9.enableOutsideDays,
        orientation = _this$props9.orientation;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props10 = this.props,
        numberOfMonths = _this$props10.numberOfMonths,
        enableOutsideDays = _this$props10.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        enableOutsideDays = _this$props11.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props12 = this.props,
        startDate = _this$props12.startDate,
        endDate = _this$props12.endDate,
        focusedInput = _this$props12.focusedInput,
        minimumNights = _this$props12.minimumNights,
        numberOfMonths = _this$props12.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (focusedInput === constants$2.START_DATE && startDate) {
      focusedDate = startDate.clone();
    } else if (focusedInput === constants$2.END_DATE && !endDate && startDate) {
      focusedDate = startDate.clone().add(minimumNights, 'days');
    } else if (focusedInput === constants$2.END_DATE && endDate) {
      focusedDate = endDate.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays,
        orientation = nextProps.orientation,
        startDate = nextProps.startDate;
    var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
      return startDate;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.shouldDisableMonthNavigation = function shouldDisableMonthNavigation(date, visibleMonth) {
    if (!date) return false;
    var _this$props13 = this.props,
        numberOfMonths = _this$props13.numberOfMonths,
        enableOutsideDays = _this$props13.enableOutsideDays;
    return (0, _isDayVisible["default"])(date, visibleMonth, numberOfMonths, enableOutsideDays);
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, modifiers.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.addModifierToRange = function addModifierToRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.addModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, modifiers.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifierFromRange = function deleteModifierFromRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.deleteModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.doesNotMeetMinimumNights = function doesNotMeetMinimumNights(day) {
    var _this$props14 = this.props,
        startDate = _this$props14.startDate,
        isOutsideRange = _this$props14.isOutsideRange,
        focusedInput = _this$props14.focusedInput,
        minimumNights = _this$props14.minimumNights;
    if (focusedInput !== constants$2.END_DATE) return false;

    if (startDate) {
      var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minimumNights && dayDiff >= 0;
    }

    return isOutsideRange((0, _moment["default"])(day).subtract(minimumNights, 'days'));
  };

  _proto.doesNotMeetMinNightsForHoveredStartDate = function doesNotMeetMinNightsForHoveredStartDate(day, hoverDate) {
    var _this$props15 = this.props,
        focusedInput = _this$props15.focusedInput,
        getMinNightsForHoverDate = _this$props15.getMinNightsForHoverDate;
    if (focusedInput !== constants$2.END_DATE) return false;

    if (hoverDate && !this.isBlocked(hoverDate)) {
      var minNights = getMinNightsForHoverDate(hoverDate);
      var dayDiff = day.diff(hoverDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minNights && dayDiff >= 0;
    }

    return false;
  };

  _proto.isDayAfterHoveredStartDate = function isDayAfterHoveredStartDate(day) {
    var _this$props16 = this.props,
        startDate = _this$props16.startDate,
        endDate = _this$props16.endDate,
        minimumNights = _this$props16.minimumNights;

    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, startDate);
  };

  _proto.isEndDate = function isEndDate(day) {
    var endDate = this.props.endDate;
    return (0, _isSameDay["default"])(day, endDate);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref3 = this.state || {},
        hoverDate = _ref3.hoverDate;

    var focusedInput = this.props.focusedInput;
    return !!focusedInput && (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isInHoveredSpan = function isInHoveredSpan(day) {
    var _this$props17 = this.props,
        startDate = _this$props17.startDate,
        endDate = _this$props17.endDate;

    var _ref4 = this.state || {},
        hoverDate = _ref4.hoverDate;

    var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
    return (isForwardRange || isBackwardRange) && isValidDayHovered;
  };

  _proto.isInSelectedSpan = function isInSelectedSpan(day) {
    var _this$props18 = this.props,
        startDate = _this$props18.startDate,
        endDate = _this$props18.endDate;
    return day.isBetween(startDate, endDate, 'days');
  };

  _proto.isLastInRange = function isLastInRange(day) {
    var endDate = this.props.endDate;
    return this.isInSelectedSpan(day) && (0, _isNextDay["default"])(day, endDate);
  };

  _proto.isStartDate = function isStartDate(day) {
    var startDate = this.props.startDate;
    return (0, _isSameDay["default"])(day, startDate);
  };

  _proto.isBlocked = function isBlocked(day) {
    var blockDaysViolatingMinNights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _this$props19 = this.props,
        isDayBlocked = _this$props19.isDayBlocked,
        isOutsideRange = _this$props19.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day) || blockDaysViolatingMinNights && this.doesNotMeetMinimumNights(day);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.isFirstPossibleEndDateForHoveredStartDate = function isFirstPossibleEndDateForHoveredStartDate(day, hoverDate) {
    var _this$props20 = this.props,
        focusedInput = _this$props20.focusedInput,
        getMinNightsForHoverDate = _this$props20.getMinNightsForHoverDate;
    if (focusedInput !== constants$2.END_DATE || !hoverDate || this.isBlocked(hoverDate)) return false;
    var minNights = getMinNightsForHoverDate(hoverDate);
    var firstAvailableEndDate = hoverDate.clone().add(minNights, 'days');
    return (0, _isSameDay["default"])(day, firstAvailableEndDate);
  };

  _proto.beforeSelectedEnd = function beforeSelectedEnd(day) {
    var endDate = this.props.endDate;
    return (0, _isBeforeDay["default"])(day, endDate);
  };

  _proto.isDayBeforeHoveredEndDate = function isDayBeforeHoveredEndDate(day) {
    var _this$props21 = this.props,
        startDate = _this$props21.startDate,
        endDate = _this$props21.endDate,
        minimumNights = _this$props21.minimumNights;

    var _ref5 = this.state || {},
        hoverDate = _ref5.hoverDate;

    return !!endDate && !startDate && !this.isBlocked(day) && (0, _isPreviousDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, endDate);
  };

  _proto.render = function render() {
    var _this$props22 = this.props,
        numberOfMonths = _this$props22.numberOfMonths,
        orientation = _this$props22.orientation,
        monthFormat = _this$props22.monthFormat,
        renderMonthText = _this$props22.renderMonthText,
        renderWeekHeaderElement = _this$props22.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props22.dayPickerNavigationInlineStyles,
        navPosition = _this$props22.navPosition,
        navPrev = _this$props22.navPrev,
        navNext = _this$props22.navNext,
        renderNavPrevButton = _this$props22.renderNavPrevButton,
        renderNavNextButton = _this$props22.renderNavNextButton,
        noNavButtons = _this$props22.noNavButtons,
        noNavNextButton = _this$props22.noNavNextButton,
        noNavPrevButton = _this$props22.noNavPrevButton,
        onOutsideClick = _this$props22.onOutsideClick,
        withPortal = _this$props22.withPortal,
        enableOutsideDays = _this$props22.enableOutsideDays,
        firstDayOfWeek = _this$props22.firstDayOfWeek,
        renderKeyboardShortcutsButton = _this$props22.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props22.renderKeyboardShortcutsPanel,
        hideKeyboardShortcutsPanel = _this$props22.hideKeyboardShortcutsPanel,
        daySize = _this$props22.daySize,
        focusedInput = _this$props22.focusedInput,
        renderCalendarDay = _this$props22.renderCalendarDay,
        renderDayContents = _this$props22.renderDayContents,
        renderCalendarInfo = _this$props22.renderCalendarInfo,
        renderMonthElement = _this$props22.renderMonthElement,
        calendarInfoPosition = _this$props22.calendarInfoPosition,
        onBlur = _this$props22.onBlur,
        onShiftTab = _this$props22.onShiftTab,
        onTab = _this$props22.onTab,
        isFocused = _this$props22.isFocused,
        showKeyboardShortcuts = _this$props22.showKeyboardShortcuts,
        isRTL = _this$props22.isRTL,
        weekDayFormat = _this$props22.weekDayFormat,
        dayAriaLabelFormat = _this$props22.dayAriaLabelFormat,
        verticalHeight = _this$props22.verticalHeight,
        noBorder = _this$props22.noBorder,
        transitionDuration = _this$props22.transitionDuration,
        verticalBorderSpacing = _this$props22.verticalBorderSpacing,
        horizontalMonthPadding = _this$props22.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        phrases = _this$state7.phrases,
        visibleDays = _this$state7.visibleDays,
        disablePrev = _this$state7.disablePrev,
        disableNext = _this$state7.disableNext;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onTab: onTab,
      onShiftTab: onShiftTab,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withPortal,
      hidden: !focusedInput,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      daySize: daySize,
      onOutsideClick: onOutsideClick,
      disablePrev: disablePrev,
      disableNext: disableNext,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavPrevButton: noNavPrevButton,
      noNavNextButton: noNavNextButton,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel,
      calendarInfoPosition: calendarInfoPosition,
      firstDayOfWeek: firstDayOfWeek,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      showKeyboardShortcuts: showKeyboardShortcuts,
      phrases: phrases,
      isRTL: isRTL,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      verticalBorderSpacing: verticalBorderSpacing,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerRangeController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerRangeController;
DayPickerRangeController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerRangeController.defaultProps = defaultProps;
});

var DateRangePicker_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDateRangePicker = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _moment = interopRequireDefault(moment);









var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);

var _DateRangePickerShape = interopRequireDefault(DateRangePickerShape);



var _getResponsiveContainerStyles = interopRequireDefault(getResponsiveContainerStyles_1);

var _getDetachedContainerStyles = interopRequireDefault(getDetachedContainerStyles_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _disableScroll2 = interopRequireDefault(disableScroll_1);

var _noflip = interopRequireDefault(noflip_1);

var _DateRangePickerInputController = interopRequireDefault(DateRangePickerInputController_1);

var _DayPickerRangeController = interopRequireDefault(DayPickerRangeController_1);

var _CloseButton = interopRequireDefault(CloseButton_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {}, _DateRangePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive DateRangePicker
  startDate: null,
  endDate: null,
  focusedInput: null,
  // input related props
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  startDateOffset: undefined,
  endDateOffset: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  anchorDirection: constants$2.ANCHOR_LEFT,
  openDirection: constants$2.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$2.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$2.DAY_SIZE,
  isRTL: false,
  firstDayOfWeek: null,
  verticalHeight: null,
  transitionDuration: undefined,
  verticalSpacing: constants$2.DEFAULT_VERTICAL_SPACING,
  horizontalMonthPadding: undefined,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  minDate: undefined,
  maxDate: undefined,
  // internationalization
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DateRangePickerPhrases,
  dayAriaLabelFormat: undefined
};

var DateRangePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePicker, _ref);
  var _proto = DateRangePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dayPickerContainerStyles: {},
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    };
    _this.isTouchDevice = false;
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocusOut = _this.onDayPickerFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, lib.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focusedInput = this.props.focusedInput;

    if (focusedInput) {
      this.setState({
        isDateRangePickerInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focusedInput = this.props.focusedInput;

    if (!prevProps.focusedInput && focusedInput && this.isOpened()) {
      // The date picker just changed from being closed to being open.
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focusedInput && !focusedInput && !this.isOpened()) {
      // The date picker just changed from being open to being closed.
      if (this.enableScroll) this.enableScroll();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeDayPickerEventListeners();
    if (this.removeEventListener) this.removeEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        appendToBody = _this$props.appendToBody;
    if (!this.isOpened()) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onDateRangePickerInputFocus = function onDateRangePickerInputFocus(focusedInput) {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focusedInput) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange(focusedInput);
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    var _this$props3 = this.props,
        focusedInput = _this$props3.focusedInput,
        onFocusChange = _this$props3.onFocusChange;
    if (!focusedInput) onFocusChange(constants$2.START_DATE);
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerFocusOut = function onDayPickerFocusOut(event) {
    // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.
    var relatedTarget = event.relatedTarget === document.body ? event.target : event.relatedTarget || event.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    this.onOutsideClick(event);
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isDateRangePickerInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    if (this.dayPickerContainer) this.removeDayPickerEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addDayPickerEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addDayPickerEventListeners = function addDayPickerEventListeners() {
    // NOTE: We are using a manual event listener here, because React doesn't
    // provide FocusOut, while blur and keydown don't provide the information
    // needed in order to know whether we have left focus or not.
    //
    // For reference, this issue is further described here:
    // - https://github.com/facebook/react/issues/6410
    this.removeDayPickerFocusOut = (0, lib.addEventListener)(this.dayPickerContainer, 'focusout', this.onDayPickerFocusOut);
  };

  _proto.removeDayPickerEventListeners = function removeDayPickerEventListeners() {
    if (this.removeDayPickerFocusOut) this.removeDayPickerFocusOut();
  };

  _proto.isOpened = function isOpened() {
    var focusedInput = this.props.focusedInput;
    return focusedInput === constants$2.START_DATE || focusedInput === constants$2.END_DATE;
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props4 = this.props,
        appendToBody = _this$props4.appendToBody,
        propDisableScroll = _this$props4.disableScroll;
    if (!appendToBody && !propDisableScroll) return;
    if (!this.isOpened()) return; // Disable scroll for every ancestor of this DateRangePicker up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  };

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (Object.keys(dayPickerContainerStyles).length > 0) {
      this.setState({
        dayPickerContainerStyles: {}
      });
    }

    if (!this.isOpened()) {
      return;
    }

    var _this$props5 = this.props,
        openDirection = _this$props5.openDirection,
        anchorDirection = _this$props5.anchorDirection,
        horizontalMargin = _this$props5.horizontalMargin,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;
    var isAnchoredLeft = anchorDirection === constants$2.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[constants$2.ANCHOR_RIGHT] : containerRect[constants$2.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props6 = this.props,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        appendToBody = _this$props6.appendToBody;

    if (!this.isOpened()) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(lib$1.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props7 = this.props,
        anchorDirection = _this$props7.anchorDirection,
        openDirection = _this$props7.openDirection,
        isDayBlocked = _this$props7.isDayBlocked,
        isDayHighlighted = _this$props7.isDayHighlighted,
        isOutsideRange = _this$props7.isOutsideRange,
        numberOfMonths = _this$props7.numberOfMonths,
        orientation = _this$props7.orientation,
        monthFormat = _this$props7.monthFormat,
        renderMonthText = _this$props7.renderMonthText,
        renderWeekHeaderElement = _this$props7.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props7.dayPickerNavigationInlineStyles,
        navPosition = _this$props7.navPosition,
        navPrev = _this$props7.navPrev,
        navNext = _this$props7.navNext,
        renderNavPrevButton = _this$props7.renderNavPrevButton,
        renderNavNextButton = _this$props7.renderNavNextButton,
        onPrevMonthClick = _this$props7.onPrevMonthClick,
        onNextMonthClick = _this$props7.onNextMonthClick,
        onDatesChange = _this$props7.onDatesChange,
        onFocusChange = _this$props7.onFocusChange,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        daySize = _this$props7.daySize,
        enableOutsideDays = _this$props7.enableOutsideDays,
        focusedInput = _this$props7.focusedInput,
        startDate = _this$props7.startDate,
        startDateOffset = _this$props7.startDateOffset,
        endDate = _this$props7.endDate,
        endDateOffset = _this$props7.endDateOffset,
        minDate = _this$props7.minDate,
        maxDate = _this$props7.maxDate,
        minimumNights = _this$props7.minimumNights,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        renderCalendarDay = _this$props7.renderCalendarDay,
        renderDayContents = _this$props7.renderDayContents,
        renderCalendarInfo = _this$props7.renderCalendarInfo,
        renderMonthElement = _this$props7.renderMonthElement,
        calendarInfoPosition = _this$props7.calendarInfoPosition,
        firstDayOfWeek = _this$props7.firstDayOfWeek,
        initialVisibleMonth = _this$props7.initialVisibleMonth,
        hideKeyboardShortcutsPanel = _this$props7.hideKeyboardShortcutsPanel,
        customCloseIcon = _this$props7.customCloseIcon,
        onClose = _this$props7.onClose,
        phrases = _this$props7.phrases,
        dayAriaLabelFormat = _this$props7.dayAriaLabelFormat,
        isRTL = _this$props7.isRTL,
        weekDayFormat = _this$props7.weekDayFormat,
        styles = _this$props7.styles,
        verticalHeight = _this$props7.verticalHeight,
        transitionDuration = _this$props7.transitionDuration,
        verticalSpacing = _this$props7.verticalSpacing,
        horizontalMonthPadding = _this$props7.horizontalMonthPadding,
        small = _this$props7.small,
        disabled = _this$props7.disabled,
        reactDates = _this$props7.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var initialVisibleMonthThunk = initialVisibleMonth || function () {
      return startDate || endDate || (0, _moment["default"])();
    };

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePicker_closeButton_svg));

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, withStyles_1.css)(styles.DateRangePicker_picker, anchorDirection === constants$2.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === constants$2.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === constants$2.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === constants$2.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === constants$2.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === constants$2.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerRangeController["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onDatesChange: onDatesChange,
      onFocusChange: onFocusChange,
      onClose: onClose,
      focusedInput: focusedInput,
      startDate: startDate,
      startDateOffset: startDateOffset,
      endDate: endDate,
      endDateOffset: endDateOffset,
      minDate: minDate,
      maxDate: maxDate,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withAnyPortal,
      daySize: daySize,
      initialVisibleMonth: initialVisibleMonthThunk,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      minimumNights: minimumNights,
      isOutsideRange: isOutsideRange,
      isDayHighlighted: isDayHighlighted,
      isDayBlocked: isDayBlocked,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      isRTL: isRTL,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      disabled: disabled,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePicker_closeButton), {
      type: "button",
      onClick: this.onOutsideClick,
      "aria-label": phrases.closeDatePicker
    }), closeIcon));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props8 = this.props,
        startDate = _this$props8.startDate,
        startDateId = _this$props8.startDateId,
        startDatePlaceholderText = _this$props8.startDatePlaceholderText,
        startDateAriaLabel = _this$props8.startDateAriaLabel,
        endDate = _this$props8.endDate,
        endDateId = _this$props8.endDateId,
        endDatePlaceholderText = _this$props8.endDatePlaceholderText,
        endDateAriaLabel = _this$props8.endDateAriaLabel,
        focusedInput = _this$props8.focusedInput,
        screenReaderInputMessage = _this$props8.screenReaderInputMessage,
        showClearDates = _this$props8.showClearDates,
        showDefaultInputIcon = _this$props8.showDefaultInputIcon,
        inputIconPosition = _this$props8.inputIconPosition,
        customInputIcon = _this$props8.customInputIcon,
        customArrowIcon = _this$props8.customArrowIcon,
        customCloseIcon = _this$props8.customCloseIcon,
        disabled = _this$props8.disabled,
        required = _this$props8.required,
        readOnly = _this$props8.readOnly,
        openDirection = _this$props8.openDirection,
        phrases = _this$props8.phrases,
        isOutsideRange = _this$props8.isOutsideRange,
        minimumNights = _this$props8.minimumNights,
        withPortal = _this$props8.withPortal,
        withFullScreenPortal = _this$props8.withFullScreenPortal,
        displayFormat = _this$props8.displayFormat,
        reopenPickerOnClearDates = _this$props8.reopenPickerOnClearDates,
        keepOpenOnDateSelect = _this$props8.keepOpenOnDateSelect,
        onDatesChange = _this$props8.onDatesChange,
        onClose = _this$props8.onClose,
        isRTL = _this$props8.isRTL,
        noBorder = _this$props8.noBorder,
        block = _this$props8.block,
        verticalSpacing = _this$props8.verticalSpacing,
        small = _this$props8.small,
        regular = _this$props8.regular,
        styles = _this$props8.styles;
    var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < constants$2.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_DateRangePickerInputController["default"], {
      startDate: startDate,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: focusedInput === constants$2.START_DATE,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDate,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: focusedInput === constants$2.END_DATE,
      endDateAriaLabel: endDateAriaLabel,
      displayFormat: displayFormat,
      showClearDates: showClearDates,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      reopenPickerOnClearDates: reopenPickerOnClearDates,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      isOutsideRange: isOutsideRange,
      minimumNights: minimumNights,
      withFullScreenPortal: withFullScreenPortal,
      onDatesChange: onDatesChange,
      onFocusChange: this.onDateRangePickerInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      onClose: onClose,
      phrases: phrases,
      screenReaderMessage: screenReaderInputMessage,
      isFocused: isDateRangePickerInputFocused,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, withStyles_1.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return DateRangePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDateRangePicker = DateRangePicker;
DateRangePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateRangePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    DateRangePicker__block: {
      display: 'block'
    },
    DateRangePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    DateRangePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    DateRangePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    DateRangePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    DateRangePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePicker);

exports["default"] = _default;
});

var DayPickerSingleDateController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _slicedToArray2 = interopRequireDefault(slicedToArray);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _moment = interopRequireDefault(moment);

var _object = interopRequireDefault(object_values);

var _isTouchDevice = interopRequireDefault(build$3);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _getVisibleDays = interopRequireDefault(getVisibleDays_1);

var _toISODateString = interopRequireDefault(toISODateString_1);



var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);



var _DayPicker = interopRequireDefault(DayPicker_1);

var _getPooledMoment = interopRequireDefault(getPooledMoment_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes$1["default"].func,
  focused: _propTypes$1["default"].bool,
  onFocusChange: _propTypes$1["default"].func,
  onClose: _propTypes$1["default"].func,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  isOutsideRange: _propTypes$1["default"].func,
  isDayBlocked: _propTypes$1["default"].func,
  isDayHighlighted: _propTypes$1["default"].func,
  // DayPicker props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes$1["default"].func,
  enableOutsideDays: _propTypes$1["default"].bool,
  numberOfMonths: _propTypes$1["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes$1["default"].bool,
  initialVisibleMonth: _propTypes$1["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  hideKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes$1["default"].bool,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes$1["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  noNavButtons: _propTypes$1["default"].bool,
  noNavNextButton: _propTypes$1["default"].bool,
  noNavPrevButton: _propTypes$1["default"].bool,
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  onOutsideClick: _propTypes$1["default"].func,
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  renderCalendarInfo: _propTypes$1["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  // accessibility
  onBlur: _propTypes$1["default"].func,
  isFocused: _propTypes$1["default"].bool,
  showKeyboardShortcuts: _propTypes$1["default"].bool,
  onTab: _propTypes$1["default"].func,
  onShiftTab: _propTypes$1["default"].func,
  // i18n
  monthFormat: _propTypes$1["default"].string,
  weekDayFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string,
  isRTL: _propTypes$1["default"].bool
}) : {};
var defaultProps = {
  date: undefined,
  // TODO: use null
  onDateChange: function onDateChange() {},
  focused: false,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  daySize: constants$2.DAY_SIZE,
  verticalHeight: null,
  noBorder: false,
  verticalBorderSpacing: undefined,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  calendarInfoPosition: constants$2.INFO_POSITION_BOTTOM,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var DayPickerSingleDateController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerSingleDateController, _ref);
  var _proto = DayPickerSingleDateController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerSingleDateController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      selected: function selected(day) {
        return _this.isSelected(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var date = nextProps.date,
        focused = nextProps.focused,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevFocused = _this$props.focused,
        prevDate = _this$props.date;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocused && focused) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var didDateChange = date !== prevDate;
    var didFocusChange = focused !== prevFocused;
    var modifiers = {};

    if (didDateChange) {
      modifiers = this.deleteModifier(modifiers, prevDate, 'selected');
      modifiers = this.addModifier(modifiers, date, 'selected');
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);

          if (_this2.isBlocked(momentObj)) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    this.today = (0, _moment["default"])();
  };

  _proto.onDayClick = function onDayClick(day, e) {
    if (e) e.preventDefault();
    if (this.isBlocked(day)) return;
    var _this$props2 = this.props,
        onDateChange = _this$props2.onDateChange,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose;
    onDateChange(day);

    if (!keepOpenOnDateSelect) {
      onFocusChange({
        focused: false
      });
      onClose({
        date: day
      });
    }
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    if (this.isTouchDevice) return;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    modifiers = this.addModifier(modifiers, day, 'hovered');
    this.setState({
      hoverDate: day,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onDayMouseLeave = function onDayMouseLeave() {
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props3 = this.props,
        onPrevMonthClick = _this$props3.onPrevMonthClick,
        numberOfMonths = _this$props3.numberOfMonths,
        enableOutsideDays = _this$props3.enableOutsideDays;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(1, 'month');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays);
    this.setState({
      currentMonth: prevMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(prevMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props4 = this.props,
        onNextMonthClick = _this$props4.onNextMonthClick,
        numberOfMonths = _this$props4.numberOfMonths,
        enableOutsideDays = _this$props4.enableOutsideDays;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props5 = this.props,
        numberOfMonths = _this$props5.numberOfMonths,
        enableOutsideDays = _this$props5.enableOutsideDays,
        orientation = _this$props5.orientation;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props6 = this.props,
        numberOfMonths = _this$props6.numberOfMonths,
        enableOutsideDays = _this$props6.enableOutsideDays,
        orientation = _this$props6.orientation;
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        enableOutsideDays = _this$props7.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props9 = this.props,
        date = _this$props9.date,
        numberOfMonths = _this$props9.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (date) {
      focusedDate = date.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day) && (0, _isAfterDay["default"])(day, focusedDate);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        date = nextProps.date,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation,
        enableOutsideDays = nextProps.enableOutsideDays;
    var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
      return date;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === constants$2.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, modifiers.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, modifiers.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.isBlocked = function isBlocked(day) {
    var _this$props10 = this.props,
        isDayBlocked = _this$props10.isDayBlocked,
        isOutsideRange = _this$props10.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isSelected = function isSelected(day) {
    var date = this.props.date;
    return (0, _isSameDay["default"])(day, date);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.render = function render() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        orientation = _this$props11.orientation,
        monthFormat = _this$props11.monthFormat,
        renderMonthText = _this$props11.renderMonthText,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props11.dayPickerNavigationInlineStyles,
        navPosition = _this$props11.navPosition,
        navPrev = _this$props11.navPrev,
        navNext = _this$props11.navNext,
        renderNavPrevButton = _this$props11.renderNavPrevButton,
        renderNavNextButton = _this$props11.renderNavNextButton,
        noNavButtons = _this$props11.noNavButtons,
        noNavPrevButton = _this$props11.noNavPrevButton,
        noNavNextButton = _this$props11.noNavNextButton,
        onOutsideClick = _this$props11.onOutsideClick,
        onShiftTab = _this$props11.onShiftTab,
        onTab = _this$props11.onTab,
        withPortal = _this$props11.withPortal,
        focused = _this$props11.focused,
        enableOutsideDays = _this$props11.enableOutsideDays,
        hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
        daySize = _this$props11.daySize,
        firstDayOfWeek = _this$props11.firstDayOfWeek,
        renderCalendarDay = _this$props11.renderCalendarDay,
        renderDayContents = _this$props11.renderDayContents,
        renderCalendarInfo = _this$props11.renderCalendarInfo,
        renderMonthElement = _this$props11.renderMonthElement,
        calendarInfoPosition = _this$props11.calendarInfoPosition,
        isFocused = _this$props11.isFocused,
        isRTL = _this$props11.isRTL,
        phrases = _this$props11.phrases,
        dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
        onBlur = _this$props11.onBlur,
        showKeyboardShortcuts = _this$props11.showKeyboardShortcuts,
        weekDayFormat = _this$props11.weekDayFormat,
        verticalHeight = _this$props11.verticalHeight,
        noBorder = _this$props11.noBorder,
        transitionDuration = _this$props11.transitionDuration,
        verticalBorderSpacing = _this$props11.verticalBorderSpacing,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        visibleDays = _this$state7.visibleDays;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      withPortal: withPortal,
      hidden: !focused,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      firstDayOfWeek: firstDayOfWeek,
      onOutsideClick: onOutsideClick,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavNextButton: noNavNextButton,
      noNavPrevButton: noNavPrevButton,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      onTab: onTab,
      onShiftTab: onShiftTab,
      phrases: phrases,
      daySize: daySize,
      isRTL: isRTL,
      showKeyboardShortcuts: showKeyboardShortcuts,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerSingleDateController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerSingleDateController;
DayPickerSingleDateController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerSingleDateController.defaultProps = defaultProps;
});

var SingleDatePickerShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes$1 = interopRequireDefault(_propTypes);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _OrientationShape = interopRequireDefault(OrientationShape);

var _AnchorDirectionShape = interopRequireDefault(AnchorDirectionShape);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _default = {
  // required props for a functional interactive SingleDatePicker
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes$1["default"].func.isRequired,
  focused: _propTypes$1["default"].bool,
  onFocusChange: _propTypes$1["default"].func.isRequired,
  // input related props
  id: _propTypes$1["default"].string.isRequired,
  placeholder: _propTypes$1["default"].string,
  ariaLabel: _propTypes$1["default"].string,
  disabled: _propTypes$1["default"].bool,
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  screenReaderInputMessage: _propTypes$1["default"].string,
  showClearDate: _propTypes$1["default"].bool,
  customCloseIcon: _propTypes$1["default"].node,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes$1["default"].node,
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepFocusOnInput: _propTypes$1["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes$1["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes$1["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes$1["default"].number,
  withPortal: _propTypes$1["default"].bool,
  withFullScreenPortal: _propTypes$1["default"].bool,
  appendToBody: _propTypes$1["default"].bool,
  disableScroll: _propTypes$1["default"].bool,
  initialVisibleMonth: _propTypes$1["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  numberOfMonths: _propTypes$1["default"].number,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  reopenPickerOnClearDate: _propTypes$1["default"].bool,
  renderCalendarInfo: _propTypes$1["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes$1["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes$1["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes$1["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes$1["default"].node,
  navNext: _propTypes$1["default"].node,
  renderNavPrevButton: _propTypes$1["default"].func,
  renderNavNextButton: _propTypes$1["default"].func,
  onPrevMonthClick: _propTypes$1["default"].func,
  onNextMonthClick: _propTypes$1["default"].func,
  onClose: _propTypes$1["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes$1["default"].func,
  renderDayContents: _propTypes$1["default"].func,
  enableOutsideDays: _propTypes$1["default"].bool,
  isDayBlocked: _propTypes$1["default"].func,
  isOutsideRange: _propTypes$1["default"].func,
  isDayHighlighted: _propTypes$1["default"].func,
  // internationalization props
  displayFormat: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].func]),
  monthFormat: _propTypes$1["default"].string,
  weekDayFormat: _propTypes$1["default"].string,
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerPhrases)),
  dayAriaLabelFormat: _propTypes$1["default"].string
};
exports["default"] = _default;
});

var SingleDatePickerInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _DateInput = interopRequireDefault(DateInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _CloseButton = interopRequireDefault(CloseButton_1);

var _CalendarIcon = interopRequireDefault(CalendarIcon_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  id: _propTypes$1["default"].string.isRequired,
  children: _propTypes$1["default"].node,
  placeholder: _propTypes$1["default"].string,
  ariaLabel: _propTypes$1["default"].string,
  displayValue: _propTypes$1["default"].string,
  screenReaderMessage: _propTypes$1["default"].string,
  focused: _propTypes$1["default"].bool,
  isFocused: _propTypes$1["default"].bool,
  // describes actual DOM focus
  disabled: _propTypes$1["default"].bool,
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes$1["default"].bool,
  showClearDate: _propTypes$1["default"].bool,
  customCloseIcon: _propTypes$1["default"].node,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes$1["default"].node,
  isRTL: _propTypes$1["default"].bool,
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  onChange: _propTypes$1["default"].func,
  onClearDate: _propTypes$1["default"].func,
  onFocus: _propTypes$1["default"].func,
  onKeyDownShiftTab: _propTypes$1["default"].func,
  onKeyDownTab: _propTypes$1["default"].func,
  onKeyDownArrowDown: _propTypes$1["default"].func,
  onKeyDownQuestionMark: _propTypes$1["default"].func,
  // i18n
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases))
})) : {};
var defaultProps = {
  children: null,
  placeholder: 'Select Date',
  ariaLabel: undefined,
  displayValue: '',
  screenReaderMessage: '',
  focused: false,
  isFocused: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$2.OPEN_DOWN,
  showCaret: false,
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  customCloseIcon: null,
  customInputIcon: null,
  isRTL: false,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  onChange: function onChange() {},
  onClearDate: function onClearDate() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // i18n
  phrases: defaultPhrases.SingleDatePickerInputPhrases
};

function SingleDatePickerInput(_ref) {
  var id = _ref.id,
      children = _ref.children,
      placeholder = _ref.placeholder,
      ariaLabel = _ref.ariaLabel,
      displayValue = _ref.displayValue,
      focused = _ref.focused,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      showClearDate = _ref.showClearDate,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      phrases = _ref.phrases,
      onClearDate = _ref.onClearDate,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
      onKeyDownTab = _ref.onKeyDownTab,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      screenReaderMessage = _ref.screenReaderMessage,
      customCloseIcon = _ref.customCloseIcon,
      customInputIcon = _ref.customInputIcon,
      openDirection = _ref.openDirection,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      small = _ref.small,
      regular = _ref.regular,
      verticalSpacing = _ref.verticalSpacing,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon_svg));

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));

  var screenReaderText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onFocus
  }), calendarIcon);

  return _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate), inputIconPosition === constants$2.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: id,
    placeholder: placeholder,
    ariaLabel: ariaLabel,
    displayValue: displayValue,
    screenReaderMessage: screenReaderText,
    focused: focused,
    isFocused: isFocused,
    disabled: disabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDownShiftTab: onKeyDownShiftTab,
    onKeyDownTab: onKeyDownTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    openDirection: openDirection,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular,
    block: block
  }), children, showClearDate && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
    type: "button",
    "aria-label": phrases.clearDate,
    disabled: disabled,
    onClick: onClearDate
  }), closeIcon), inputIconPosition === constants$2.ICON_AFTER_POSITION && inputIcon);
}

SingleDatePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePickerInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color;
  return {
    SingleDatePickerInput: {
      display: 'inline-block',
      backgroundColor: color.background
    },
    SingleDatePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    SingleDatePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePickerInput__disabled: {
      backgroundColor: color.disabled
    },
    SingleDatePickerInput__block: {
      display: 'block'
    },
    SingleDatePickerInput__showClearDate: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_clearDate: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    SingleDatePickerInput_clearDate__default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    SingleDatePickerInput_clearDate__small: {
      padding: 6
    },
    SingleDatePickerInput_clearDate__hide: {
      visibility: 'hidden'
    },
    SingleDatePickerInput_clearDate_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    SingleDatePickerInput_clearDate_svg__small: {
      height: 9
    },
    SingleDatePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePickerInput);

exports["default"] = _default;
});

var SingleDatePickerInputController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React);

var _propTypes$1 = interopRequireDefault(_propTypes);

var _moment = interopRequireDefault(moment);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _SingleDatePickerInput = interopRequireDefault(SingleDatePickerInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes$1["default"].node,
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes$1["default"].func.isRequired,
  focused: _propTypes$1["default"].bool,
  onFocusChange: _propTypes$1["default"].func.isRequired,
  id: _propTypes$1["default"].string.isRequired,
  placeholder: _propTypes$1["default"].string,
  ariaLabel: _propTypes$1["default"].string,
  screenReaderMessage: _propTypes$1["default"].string,
  showClearDate: _propTypes$1["default"].bool,
  showCaret: _propTypes$1["default"].bool,
  showDefaultInputIcon: _propTypes$1["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes$1["default"].bool,
  readOnly: _propTypes$1["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes$1["default"].bool,
  block: _propTypes$1["default"].bool,
  small: _propTypes$1["default"].bool,
  regular: _propTypes$1["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes$1["default"].bool,
  reopenPickerOnClearDate: _propTypes$1["default"].bool,
  isOutsideRange: _propTypes$1["default"].func,
  displayFormat: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].func]),
  onClose: _propTypes$1["default"].func,
  onKeyDownArrowDown: _propTypes$1["default"].func,
  onKeyDownQuestionMark: _propTypes$1["default"].func,
  customInputIcon: _propTypes$1["default"].node,
  customCloseIcon: _propTypes$1["default"].node,
  // accessibility
  isFocused: _propTypes$1["default"].bool,
  // i18n
  phrases: _propTypes$1["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases)),
  isRTL: _propTypes$1["default"].bool
}) : {};
var defaultProps = {
  children: null,
  date: null,
  focused: false,
  placeholder: '',
  ariaLabel: undefined,
  screenReaderMessage: 'Date',
  showClearDate: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$2.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onClose: function onClose() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.SingleDatePickerInputPhrases,
  isRTL: false
};

var SingleDatePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePickerInputController, _ref);
  var _proto = SingleDatePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDate = _this.clearDate.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onChange = function onChange(dateString) {
    var _this$props = this.props,
        isOutsideRange = _this$props.isOutsideRange,
        keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
        onDateChange = _this$props.onDateChange,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose;
    var newDate = (0, _toMomentObject["default"])(dateString, this.getDisplayFormat());
    var isValid = newDate && !isOutsideRange(newDate);

    if (isValid) {
      onDateChange(newDate);

      if (!keepOpenOnDateSelect) {
        onFocusChange({
          focused: false
        });
        onClose({
          date: newDate
        });
      }
    } else {
      onDateChange(null);
    }
  };

  _proto.onFocus = function onFocus() {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        disabled = _this$props2.disabled;

    if (!disabled) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.onClearFocus = function onClearFocus() {
    var _this$props3 = this.props,
        focused = _this$props3.focused,
        onFocusChange = _this$props3.onFocusChange,
        onClose = _this$props3.onClose,
        date = _this$props3.date;
    if (!focused) return;
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDate = function clearDate() {
    var _this$props4 = this.props,
        onDateChange = _this$props4.onDateChange,
        reopenPickerOnClearDate = _this$props4.reopenPickerOnClearDate,
        onFocusChange = _this$props4.onFocusChange;
    onDateChange(null);

    if (reopenPickerOnClearDate) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        id = _this$props5.id,
        placeholder = _this$props5.placeholder,
        ariaLabel = _this$props5.ariaLabel,
        disabled = _this$props5.disabled,
        focused = _this$props5.focused,
        isFocused = _this$props5.isFocused,
        required = _this$props5.required,
        readOnly = _this$props5.readOnly,
        openDirection = _this$props5.openDirection,
        showClearDate = _this$props5.showClearDate,
        showCaret = _this$props5.showCaret,
        showDefaultInputIcon = _this$props5.showDefaultInputIcon,
        inputIconPosition = _this$props5.inputIconPosition,
        customCloseIcon = _this$props5.customCloseIcon,
        customInputIcon = _this$props5.customInputIcon,
        date = _this$props5.date,
        phrases = _this$props5.phrases,
        onKeyDownArrowDown = _this$props5.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props5.onKeyDownQuestionMark,
        screenReaderMessage = _this$props5.screenReaderMessage,
        isRTL = _this$props5.isRTL,
        noBorder = _this$props5.noBorder,
        block = _this$props5.block,
        small = _this$props5.small,
        regular = _this$props5.regular,
        verticalSpacing = _this$props5.verticalSpacing;
    var displayValue = this.getDateString(date);
    return _react["default"].createElement(_SingleDatePickerInput["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      onClearDate: this.clearDate,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      displayValue: displayValue,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onKeyDownShiftTab: this.onClearFocus,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      screenReaderMessage: screenReaderMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return SingleDatePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = SingleDatePickerInputController;
SingleDatePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePickerInputController.defaultProps = defaultProps;
});

var SingleDatePicker_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureSingleDatePicker = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$2);

var _react = interopRequireDefault(React);

var _moment = interopRequireDefault(moment);









var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);

var _SingleDatePickerShape = interopRequireDefault(SingleDatePickerShape);



var _getResponsiveContainerStyles = interopRequireDefault(getResponsiveContainerStyles_1);

var _getDetachedContainerStyles = interopRequireDefault(getDetachedContainerStyles_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _disableScroll2 = interopRequireDefault(disableScroll_1);

var _noflip = interopRequireDefault(noflip_1);

var _SingleDatePickerInputController = interopRequireDefault(SingleDatePickerInputController_1);

var _DayPickerSingleDateController = interopRequireDefault(DayPickerSingleDateController_1);

var _CloseButton = interopRequireDefault(CloseButton_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {}, _SingleDatePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive SingleDatePicker
  date: null,
  focused: false,
  // input related props
  id: 'date',
  placeholder: 'Date',
  ariaLabel: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$2.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: constants$2.DEFAULT_VERTICAL_SPACING,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  orientation: constants$2.HORIZONTAL_ORIENTATION,
  anchorDirection: constants$2.ANCHOR_LEFT,
  openDirection: constants$2.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$2.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$2.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$2.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // month presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {},
  // internationalization props
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.SingleDatePickerPhrases,
  dayAriaLabelFormat: undefined
};

var SingleDatePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePicker, _ref);
  var _proto = SingleDatePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.state = {
      dayPickerContainerStyles: {},
      isDayPickerFocused: false,
      isInputFocused: false,
      showKeyboardShortcuts: false
    };
    _this.onFocusOut = _this.onFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onInputFocus = _this.onInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  /* istanbul ignore next */


  _proto.componentDidMount = function componentDidMount() {
    this.removeResizeEventListener = (0, lib.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focused = this.props.focused;

    if (focused) {
      this.setState({
        isInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focused = this.props.focused;

    if (!prevProps.focused && focused) {
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focused && !focused) {
      if (this.enableScroll) this.enableScroll();
    }
  }
  /* istanbul ignore next */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeResizeEventListener) this.removeResizeEventListener();
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        focused = _this$props.focused,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        date = _this$props.date,
        appendToBody = _this$props.appendToBody;
    if (!focused) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.onInputFocus = function onInputFocus(_ref2) {
    var focused = _ref2.focused;
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focused) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange({
      focused: focused
    });
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.onFocusOut = function onFocusOut(e) {
    var onFocusChange = this.props.onFocusChange; // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.

    var relatedTarget = e.relatedTarget === document.body ? e.target : e.relatedTarget || e.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    onFocusChange({
      focused: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    this.removeEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addEventListeners = function addEventListeners() {
    // We manually set event because React has not implemented onFocusIn/onFocusOut.
    // Keep an eye on https://github.com/facebook/react/issues/6410 for updates
    // We use "blur w/ useCapture param" vs "onfocusout" for FF browser support
    this.removeFocusOutEventListener = (0, lib.addEventListener)(this.dayPickerContainer, 'focusout', this.onFocusOut);
  };

  _proto.removeEventListeners = function removeEventListeners() {
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props3 = this.props,
        appendToBody = _this$props3.appendToBody,
        propDisableScroll = _this$props3.disableScroll,
        focused = _this$props3.focused;
    if (!appendToBody && !propDisableScroll) return;
    if (!focused) return; // Disable scroll for every ancestor of this <SingleDatePicker> up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  }
  /* istanbul ignore next */
  ;

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    this.setState({
      dayPickerContainerStyles: {}
    });
    var _this$props4 = this.props,
        openDirection = _this$props4.openDirection,
        anchorDirection = _this$props4.anchorDirection,
        horizontalMargin = _this$props4.horizontalMargin,
        withPortal = _this$props4.withPortal,
        withFullScreenPortal = _this$props4.withFullScreenPortal,
        appendToBody = _this$props4.appendToBody,
        focused = _this$props4.focused;
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (!focused) {
      return;
    }

    var isAnchoredLeft = anchorDirection === constants$2.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[constants$2.ANCHOR_RIGHT] : containerRect[constants$2.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props5 = this.props,
        focused = _this$props5.focused,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;

    if (!focused) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(lib$1.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props6 = this.props,
        anchorDirection = _this$props6.anchorDirection,
        openDirection = _this$props6.openDirection,
        onDateChange = _this$props6.onDateChange,
        date = _this$props6.date,
        onFocusChange = _this$props6.onFocusChange,
        focused = _this$props6.focused,
        enableOutsideDays = _this$props6.enableOutsideDays,
        numberOfMonths = _this$props6.numberOfMonths,
        orientation = _this$props6.orientation,
        monthFormat = _this$props6.monthFormat,
        dayPickerNavigationInlineStyles = _this$props6.dayPickerNavigationInlineStyles,
        navPosition = _this$props6.navPosition,
        navPrev = _this$props6.navPrev,
        navNext = _this$props6.navNext,
        renderNavPrevButton = _this$props6.renderNavPrevButton,
        renderNavNextButton = _this$props6.renderNavNextButton,
        onPrevMonthClick = _this$props6.onPrevMonthClick,
        onNextMonthClick = _this$props6.onNextMonthClick,
        onClose = _this$props6.onClose,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
        initialVisibleMonth = _this$props6.initialVisibleMonth,
        renderMonthText = _this$props6.renderMonthText,
        renderWeekHeaderElement = _this$props6.renderWeekHeaderElement,
        renderCalendarDay = _this$props6.renderCalendarDay,
        renderDayContents = _this$props6.renderDayContents,
        renderCalendarInfo = _this$props6.renderCalendarInfo,
        renderMonthElement = _this$props6.renderMonthElement,
        calendarInfoPosition = _this$props6.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
        firstDayOfWeek = _this$props6.firstDayOfWeek,
        customCloseIcon = _this$props6.customCloseIcon,
        phrases = _this$props6.phrases,
        dayAriaLabelFormat = _this$props6.dayAriaLabelFormat,
        daySize = _this$props6.daySize,
        isRTL = _this$props6.isRTL,
        isOutsideRange = _this$props6.isOutsideRange,
        isDayBlocked = _this$props6.isDayBlocked,
        isDayHighlighted = _this$props6.isDayHighlighted,
        weekDayFormat = _this$props6.weekDayFormat,
        styles = _this$props6.styles,
        verticalHeight = _this$props6.verticalHeight,
        transitionDuration = _this$props6.transitionDuration,
        verticalSpacing = _this$props6.verticalSpacing,
        horizontalMonthPadding = _this$props6.horizontalMonthPadding,
        small = _this$props6.small,
        reactDates = _this$props6.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], null);

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, withStyles_1.css)(styles.SingleDatePicker_picker, anchorDirection === constants$2.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === constants$2.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === constants$2.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === constants$2.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === constants$2.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === constants$2.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, orientation === constants$2.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === constants$2.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerSingleDateController["default"], {
      date: date,
      onDateChange: onDateChange,
      onFocusChange: onFocusChange,
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      monthFormat: monthFormat,
      withPortal: withAnyPortal,
      focused: focused,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: initialVisibleMonth,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onClose: onClose,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      daySize: daySize,
      isRTL: isRTL,
      isOutsideRange: isOutsideRange,
      isDayBlocked: isDayBlocked,
      isDayHighlighted: isDayHighlighted,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePicker_closeButton), {
      "aria-label": phrases.closeDatePicker,
      type: "button",
      onClick: this.onOutsideClick
    }), _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePicker_closeButton_svg), closeIcon)));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        id = _this$props7.id,
        placeholder = _this$props7.placeholder,
        ariaLabel = _this$props7.ariaLabel,
        disabled = _this$props7.disabled,
        focused = _this$props7.focused,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        showClearDate = _this$props7.showClearDate,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customCloseIcon = _this$props7.customCloseIcon,
        customInputIcon = _this$props7.customInputIcon,
        date = _this$props7.date,
        onDateChange = _this$props7.onDateChange,
        displayFormat = _this$props7.displayFormat,
        phrases = _this$props7.phrases,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        screenReaderInputMessage = _this$props7.screenReaderInputMessage,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing,
        reopenPickerOnClearDate = _this$props7.reopenPickerOnClearDate,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        styles = _this$props7.styles,
        isOutsideRange = _this$props7.isOutsideRange;
    var isInputFocused = this.state.isInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < constants$2.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_SingleDatePickerInputController["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isInputFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      isOutsideRange: isOutsideRange,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      date: date,
      onDateChange: onDateChange,
      displayFormat: displayFormat,
      onFocusChange: this.onInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      screenReaderMessage: screenReaderInputMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing,
      reopenPickerOnClearDate: reopenPickerOnClearDate,
      keepOpenOnDateSelect: keepOpenOnDateSelect
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, withStyles_1.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return SingleDatePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureSingleDatePicker = SingleDatePicker;
SingleDatePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      zIndex = _ref3$reactDates.zIndex;
  return {
    SingleDatePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    SingleDatePicker__block: {
      display: 'block'
    },
    SingleDatePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    SingleDatePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    SingleDatePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    SingleDatePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    SingleDatePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePicker);

exports["default"] = _default;
});

var isInclusivelyBeforeDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyBeforeDay;

var _moment = interopRequireDefault(moment);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

function isInclusivelyBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isAfterDay["default"])(a, b);
}
});

var lib$2 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CalendarDay", {
  enumerable: true,
  get: function get() {
    return _CalendarDay["default"];
  }
});
Object.defineProperty(exports, "CalendarMonth", {
  enumerable: true,
  get: function get() {
    return _CalendarMonth["default"];
  }
});
Object.defineProperty(exports, "CalendarMonthGrid", {
  enumerable: true,
  get: function get() {
    return _CalendarMonthGrid["default"];
  }
});
Object.defineProperty(exports, "DateRangePicker", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInput", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInput["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInputController", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInputController["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerShape", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerShape["default"];
  }
});
Object.defineProperty(exports, "DayPicker", {
  enumerable: true,
  get: function get() {
    return _DayPicker["default"];
  }
});
Object.defineProperty(exports, "DayPickerRangeController", {
  enumerable: true,
  get: function get() {
    return _DayPickerRangeController["default"];
  }
});
Object.defineProperty(exports, "DayPickerSingleDateController", {
  enumerable: true,
  get: function get() {
    return _DayPickerSingleDateController["default"];
  }
});
Object.defineProperty(exports, "SingleDatePicker", {
  enumerable: true,
  get: function get() {
    return _SingleDatePicker["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerInput", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerInput["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerShape", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerShape["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyAfterDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyAfterDay["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyBeforeDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyBeforeDay["default"];
  }
});
Object.defineProperty(exports, "isNextDay", {
  enumerable: true,
  get: function get() {
    return _isNextDay["default"];
  }
});
Object.defineProperty(exports, "isSameDay", {
  enumerable: true,
  get: function get() {
    return _isSameDay["default"];
  }
});
Object.defineProperty(exports, "toISODateString", {
  enumerable: true,
  get: function get() {
    return _toISODateString["default"];
  }
});
Object.defineProperty(exports, "toLocalizedDateString", {
  enumerable: true,
  get: function get() {
    return _toLocalizedDateString["default"];
  }
});
Object.defineProperty(exports, "toMomentObject", {
  enumerable: true,
  get: function get() {
    return _toMomentObject["default"];
  }
});

var _CalendarDay = interopRequireDefault(CalendarDay_1);

var _CalendarMonth = interopRequireDefault(CalendarMonth_1);

var _CalendarMonthGrid = interopRequireDefault(CalendarMonthGrid_1);

var _DateRangePicker = interopRequireDefault(DateRangePicker_1);

var _DateRangePickerInput = interopRequireDefault(DateRangePickerInput_1);

var _DateRangePickerInputController = interopRequireDefault(DateRangePickerInputController_1);

var _DateRangePickerShape = interopRequireDefault(DateRangePickerShape);

var _DayPicker = interopRequireDefault(DayPicker_1);

var _DayPickerRangeController = interopRequireDefault(DayPickerRangeController_1);

var _DayPickerSingleDateController = interopRequireDefault(DayPickerSingleDateController_1);

var _SingleDatePicker = interopRequireDefault(SingleDatePicker_1);

var _SingleDatePickerInput = interopRequireDefault(SingleDatePickerInput_1);

var _SingleDatePickerShape = interopRequireDefault(SingleDatePickerShape);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isInclusivelyBeforeDay = interopRequireDefault(isInclusivelyBeforeDay_1);

var _isNextDay = interopRequireDefault(isNextDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _toMomentObject = interopRequireDefault(toMomentObject_1);
});

// eslint-disable-next-line import/no-unresolved
var reactDates = lib$2;

var css_248z$N = "@-webkit-keyframes tooltip--tooltip__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes tooltip--tooltip__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes tooltip--tooltip__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes tooltip--tooltip__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tooltip--tooltip__root {\n  display: block;\n  position: absolute;\n  background-color: #fff;\n  box-shadow: 0 2px 20px rgba(15, 31, 66, 0.16);\n  border-radius: 6px;\n  overflow: visible;\n  top: 0;\n  left: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n  padding: 8px 16px;\n  pointer-events: none;\n  transform: translate(-50%, calc(-100% - 16px)) scale(0.9);\n  opacity: 0;\n  transition: opacity 90ms ease-out, transform 90ms ease-out;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  z-index: 10600; }\n  .tooltip--tooltip__root::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    display: block;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 8px 8px 0;\n    border-color: #fff transparent transparent; }\n  .tooltip--tooltip__rootDark {\n    background-color: #393939;\n    color: #fff; }\n    .tooltip--tooltip__rootDark::after {\n      border-color: #393939 transparent transparent; }\n  .tooltip--tooltip__rootShow {\n    opacity: 1;\n    transform: translate(-50%, calc(-100% - 8px)) scale(1); }\n  .tooltip--tooltip__rootHasHead {\n    max-width: 250px;\n    text-align: left; }\n  .tooltip--tooltip__rootHasClickClose {\n    pointer-events: auto; }\n  .tooltip--tooltip__rootBottom {\n    box-shadow: 0 -2px 20px rgba(15, 31, 66, 0.25);\n    transform: translate(-50%, 16px) scale(0.9); }\n    .tooltip--tooltip__rootBottom.tooltip--tooltip__rootShow {\n      transform: translate(-50%, 8px) scale(1); }\n    .tooltip--tooltip__rootBottom::after {\n      top: unset;\n      bottom: 100%;\n      border-width: 0 8px 8px;\n      border-color: transparent transparent #fff; }\n    .tooltip--tooltip__rootBottom.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent transparent #f7f7f7; }\n    .tooltip--tooltip__rootBottom.tooltip--tooltip__rootDark::after {\n      border-color: transparent transparent #393939; }\n    .tooltip--tooltip__rootBottom.tooltip--tooltip__rootDark.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent transparent #5a5a5a; }\n  .tooltip--tooltip__rootRight {\n    transform: translate(-16px, -50%) scale(0.9); }\n    .tooltip--tooltip__rootRight.tooltip--tooltip__rootShow {\n      transform: translate(16px, -50%) scale(1); }\n    .tooltip--tooltip__rootRight::after {\n      top: 50%;\n      left: 0%;\n      transform: translate(-100%, -50%);\n      border-width: 8px 8px 8px 0;\n      border-color: transparent #fff transparent transparent; }\n    .tooltip--tooltip__rootRight.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent #f7f7f7 transparent transparent; }\n    .tooltip--tooltip__rootRight.tooltip--tooltip__rootDark::after {\n      border-color: transparent #393939 transparent transparent; }\n    .tooltip--tooltip__rootRight.tooltip--tooltip__rootDark.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent #5a5a5a transparent transparent; }\n  .tooltip--tooltip__rootLeft {\n    transform: translate(calc(-100% + 16px), -50%) scale(0.9); }\n    .tooltip--tooltip__rootLeft.tooltip--tooltip__rootShow {\n      transform: translate(calc(-100% - 16px), -50%) scale(1); }\n    .tooltip--tooltip__rootLeft::after {\n      top: 50%;\n      left: 100%;\n      transform: translateY(-50%);\n      border-width: 8px 0 8px 8px;\n      border-color: transparent transparent transparent #fff; }\n    .tooltip--tooltip__rootLeft.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent transparent transparent #f7f7f7; }\n    .tooltip--tooltip__rootLeft.tooltip--tooltip__rootDark::after {\n      border-color: transparent transparent transparent #393939; }\n    .tooltip--tooltip__rootLeft.tooltip--tooltip__rootDark.tooltip--tooltip__rootHasHead::after {\n      border-color: transparent transparent transparent #5a5a5a; }\n\n.tooltip--tooltip__head {\n  border-radius: 6px 6px 0 0;\n  padding: 8px 16px;\n  margin: -8px -16px 8px -16px;\n  color: #5a5a5a;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  background-color: rgba(0, 0, 0, 0.036);\n  text-align: center; }\n  .tooltip--tooltip__rootDark .tooltip--tooltip__head {\n    background-color: rgba(255, 255, 255, 0.146);\n    color: #fff; }\n";
var styles$F = {"root":"tooltip--tooltip__root","rootDark":"tooltip--tooltip__rootDark","rootShow":"tooltip--tooltip__rootShow","rootHasHead":"tooltip--tooltip__rootHasHead","rootHasClickClose":"tooltip--tooltip__rootHasClickClose","rootBottom":"tooltip--tooltip__rootBottom","rootRight":"tooltip--tooltip__rootRight","rootLeft":"tooltip--tooltip__rootLeft","head":"tooltip--tooltip__head","wiggle":"tooltip--tooltip__wiggle","spin":"tooltip--tooltip__spin"};
styleInject(css_248z$N);

var PLACEMENT_TOP = 'top';
var PLACEMENT_BOTTOM = 'bottom';
var PLACEMENT_LEFT = 'left';
var PLACEMENT_RIGHT = 'right';
var ALL_PLACEMENTS = [PLACEMENT_TOP, PLACEMENT_BOTTOM, PLACEMENT_LEFT, PLACEMENT_RIGHT];

var Tooltip =
/** @class */
function (_super) {
  __extends(Tooltip, _super);

  function Tooltip(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      placement: props.placement || null,
      showTooltip: false,
      offsetX: 0,
      offsetY: 0
    };
    _this.handleShowEvent = _this.handleShowEvent.bind(_this);
    _this.handleOnMouseLeave = _this.handleOnMouseLeave.bind(_this);
    _this.handleClickOutsideTooltip = _this.handleClickOutsideTooltip.bind(_this);
    _this.handleClickTooltip = _this.handleClickTooltip.bind(_this);
    _this.showTimer = null;
    _this.hideTimer = null;
    _this.tooltipContainerRef = /*#__PURE__*/React.createRef();
    _this.childRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  Tooltip.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a, _b;

    var _c = this.props,
        alwaysShow = _c.alwaysShow,
        requireClick = _c.requireClick;
    var showTooltip = this.state.showTooltip;

    if (alwaysShow && !showTooltip && ((_a = this.childRef) === null || _a === void 0 ? void 0 : _a.current)) {
      this.show((_b = this.childRef) === null || _b === void 0 ? void 0 : _b.current);
    }

    if (requireClick && showTooltip != prevState.showTooltip) {
      window[requireClick ? 'addEventListener' : 'removeEventListener']('click', this.handleClickOutsideTooltip);
    }
  };

  Tooltip.prototype.componentWillUnmount = function () {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
    }

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    window.removeEventListener('click', this.handleClickOutsideTooltip);
  };

  Tooltip.prototype.handleClickOutsideTooltip = function () {
    this.setState({
      showTooltip: false
    });
  };

  Tooltip.prototype.handleClickTooltip = function (event) {
    var _a = this.props,
        alwaysShow = _a.alwaysShow,
        requireClick = _a.requireClick;

    if (!requireClick && !alwaysShow) {
      this.setState({
        showTooltip: false
      });
    } else {
      // We prevent default to stop
      event.preventDefault();
      event.stopPropagation();
    }
  }; // eslint-disable-next-line class-methods-use-this


  Tooltip.prototype.getCoords = function (elem) {
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var docEl = document.documentElement;

    if (docEl && body) {
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
      var clientTop = docEl.clientTop || body.clientTop || 0;
      var clientLeft = docEl.clientLeft || body.clientLeft || 0;
      var top_1 = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;
      return {
        top: Math.round(top_1),
        left: Math.round(left)
      };
    }

    return {
      top: 0,
      left: 0
    };
  };

  Tooltip.prototype.getPlacement = function (coords) {
    var _a;

    var placement = (_a = this.props.placement) !== null && _a !== void 0 ? _a : null;

    if (placement && ALL_PLACEMENTS.includes(placement)) {
      return placement;
    }

    if (this.tooltipContainerRef && this.tooltipContainerRef.current) {
      var pageYOffset_1 = window.pageYOffset,
          pageXOffset_1 = window.pageXOffset,
          innerWidth_1 = window.innerWidth;
      var relativeTop = coords.top - pageYOffset_1;
      var relativeLeft = coords.left - pageXOffset_1;
      var _b = this.tooltipContainerRef.current,
          clientHeight = _b.clientHeight,
          clientWidth = _b.clientWidth;
      var verticalPlacement = relativeTop > clientHeight ? PLACEMENT_TOP : PLACEMENT_BOTTOM;

      if (relativeLeft - clientWidth / 2 < 0) {
        return PLACEMENT_RIGHT;
      }

      if (relativeLeft + clientWidth / 2 > innerWidth_1) {
        return PLACEMENT_LEFT;
      }

      return verticalPlacement;
    }

    return PLACEMENT_TOP;
  };

  Tooltip.prototype.show = function (el) {
    var _this = this;

    var coords = this.getCoords(el);
    var placement = this.getPlacement(coords);
    var offsetY;
    var offsetX;

    switch (placement) {
      case PLACEMENT_BOTTOM:
        offsetY = el.offsetHeight + coords.top;
        offsetX = coords.left + el.offsetWidth / 2;
        break;

      case PLACEMENT_LEFT:
        offsetY = coords.top + el.offsetHeight / 2;
        offsetX = coords.left;
        break;

      case PLACEMENT_RIGHT:
        offsetY = coords.top + el.offsetHeight / 2;
        offsetX = coords.left + el.offsetWidth;
        break;

      case PLACEMENT_TOP: // falls through

      default:
        offsetY = coords.top;
        offsetX = coords.left + el.offsetWidth / 2;
    }

    this.setState({
      offsetX: offsetX,
      offsetY: offsetY,
      placement: placement
    });
    this.showTimer = setTimeout(function () {
      _this.setState({
        showTooltip: true
      });
    }, 10);
  };

  Tooltip.prototype.handleShowEvent = function (e) {
    var currentTarget = e.currentTarget;

    if (currentTarget instanceof HTMLElement) {
      this.show(currentTarget);
    }
  };

  Tooltip.prototype.handleOnMouseLeave = function () {
    var _this = this;

    var requireClick = this.props.requireClick;

    if (!requireClick) {
      this.hideTimer = setTimeout(function () {
        _this.setState({
          showTooltip: false
        });
      }, 10);
    }
  };

  Tooltip.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        className = _c.className,
        children = _c.children,
        content = _c.content,
        head = _c.head,
        wrap = _c.wrap,
        wrapProps = _c.wrapProps,
        requireClick = _c.requireClick,
        disabled = _c.disabled,
        dark = _c.dark,
        alwaysShow = _c.alwaysShow,
        propPlacement = _c.placement,
        otherProps = __rest(_c, ["className", "children", "content", "head", "wrap", "wrapProps", "requireClick", "disabled", "dark", "alwaysShow", "placement"]);

    if (disabled) {
      return children;
    }

    var _d = this.state,
        showTooltip = _d.showTooltip,
        offsetX = _d.offsetX,
        offsetY = _d.offsetY,
        placement = _d.placement;
    var hasHead = !!head;
    var rootClass = classnames((_a = {}, _a[styles$F.root] = true, _a[styles$F.rootShow] = showTooltip, _a[styles$F.rootDark] = dark, _a[styles$F.rootBottom] = placement === PLACEMENT_BOTTOM, _a[styles$F.rootLeft] = placement === PLACEMENT_LEFT, _a[styles$F.rootRight] = placement === PLACEMENT_RIGHT, _a[styles$F.rootHasHead] = hasHead, _a[styles$F.rootHasClickClose] = requireClick, _a), className);
    var showEvent = requireClick ? 'onClick' : 'onMouseEnter';

    var newChildProps = __assign((_b = {}, _b[showEvent] = alwaysShow ? undefined : this.handleShowEvent, _b.onMouseLeave = alwaysShow ? undefined : this.handleOnMouseLeave, _b.ref = alwaysShow ? this.childRef : undefined, _b), otherProps);

    return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(children, function (child) {
      if (wrap) {
        var Wrap = wrap === 'div' ? 'div' : 'span';
        return /*#__PURE__*/React.createElement(Wrap, __assign({}, wrapProps, newChildProps), child);
      }

      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, newChildProps);
      }

      return child;
    }), /*#__PURE__*/React.createElement(BodyPortal, null, /*#__PURE__*/React.createElement("div", {
      onClick: this.handleClickTooltip,
      ref: this.tooltipContainerRef,
      className: rootClass,
      style: {
        top: offsetY + "px",
        left: offsetX + "px"
      }
    }, head && /*#__PURE__*/React.createElement("div", {
      className: styles$F.head
    }, head), content)));
  };

  Tooltip.defaultProps = {
    placement: null
  };
  return Tooltip;
}(PureComponent);

var css_248z$O = "@-webkit-keyframes helpIcon--helpIcon__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes helpIcon--helpIcon__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes helpIcon--helpIcon__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes helpIcon--helpIcon__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.helpIcon--helpIcon__infoIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  color: #9b9b9b;\n  align-self: stretch;\n  padding: 2px;\n  margin: 0; }\n";
var styles$G = {"infoIcon":"helpIcon--helpIcon__infoIcon","wiggle":"helpIcon--helpIcon__wiggle","spin":"helpIcon--helpIcon__spin"};
styleInject(css_248z$O);

var HelpIcon =
/** @class */
function (_super) {
  __extends(HelpIcon, _super);

  function HelpIcon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HelpIcon.prototype.render = function () {
    var _a = this.props,
        placement = _a.placement,
        text = _a.text,
        title = _a.title,
        disabled = _a.disabled,
        requireClick = _a.requireClick,
        className = _a.className,
        otherProps = __rest(_a, ["placement", "text", "title", "disabled", "requireClick", "className"]);

    return /*#__PURE__*/React.createElement(Tooltip, __assign({
      head: title,
      content: text,
      disabled: disabled,
      placement: placement,
      requireClick: requireClick
    }, otherProps), /*#__PURE__*/React.createElement("span", {
      className: classnames(styles$G.infoIcon, className)
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "info"
    })));
  };

  HelpIcon.defaultProps = {
    disabled: false,
    requireClick: false
  };
  return HelpIcon;
}(PureComponent);

var css_248z$P = "@-webkit-keyframes helperField--helperField__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes helperField--helperField__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes helperField--helperField__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes helperField--helperField__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.helperField--helperField__root {\n  display: flex;\n  flex-wrap: wrap; }\n\n.helperField--helperField__label,\n.helperField--helperField__helpIcon {\n  line-height: 16px;\n  margin-bottom: 8px; }\n\n.helperField--helperField__label,\n.helperField--helperField__error {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px; }\n\n.helperField--helperField__label {\n  color: #bbb; }\n  .helperField--helperField__rootRequired .helperField--helperField__label::after {\n    content: '*';\n    color: #d8484d;\n    margin-left: 4px; }\n\n.helperField--helperField__helpIcon {\n  margin-left: 8px; }\n\n.helperField--helperField__error {\n  color: #d8484d;\n  margin: 0 0 8px 4px; }\n  .helperField--helperField__error:first-child {\n    margin-left: 0; }\n";
var styles$H = {"root":"helperField--helperField__root","label":"helperField--helperField__label","helpIcon":"helperField--helperField__helpIcon","error":"helperField--helperField__error","rootRequired":"helperField--helperField__rootRequired","wiggle":"helperField--helperField__wiggle","spin":"helperField--helperField__spin"};
styleInject(css_248z$P);

var HelperField =
/** @class */
function (_super) {
  __extends(HelperField, _super);

  function HelperField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HelperField.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        label = _b.label,
        required = _b.required,
        disabled = _b.disabled,
        errorMessage = _b.errorMessage,
        fieldId = _b.fieldId,
        children = _b.children,
        helpIconText = _b.helpIconText,
        helpIconTitle = _b.helpIconTitle,
        otherProps = __rest(_b, ["className", "label", "required", "disabled", "errorMessage", "fieldId", "children", "helpIconText", "helpIconTitle"]);

    var rootClass = classnames((_a = {}, _a[styles$H.root] = true, _a[styles$H.rootRequired] = required, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), !!label && /*#__PURE__*/React.createElement("label", {
      className: styles$H.label,
      htmlFor: fieldId,
      id: fieldId + "-label"
    }, label), !!helpIconText && /*#__PURE__*/React.createElement(HelpIcon, {
      text: helpIconText,
      title: helpIconTitle,
      className: styles$H.helpIcon
    }), !!errorMessage && /*#__PURE__*/React.createElement("p", {
      className: styles$H.error
    }, errorMessage), children);
  };

  return HelperField;
}(PureComponent);

var css_248z$Q = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableBaseItem--checkableBaseItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.checkableBaseItem--checkableBaseItem__root:hover, .checkableBaseItem--checkableBaseItem__root:focus, .checkableBaseItem--checkableBaseItem__rootActive {\n  background-color: #f5f7fa; }\n\n.checkableBaseItem--checkableBaseItem__root:disabled, .checkableBaseItem--checkableBaseItem__rootDisabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.checkableBaseItem--checkableBaseItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableBaseItem--checkableBaseItem__checkbox {\n  flex: 0 0 16px;\n  margin: 0; }\n\n.checkableBaseItem--checkableBaseItem__content {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  overflow: hidden; }\n\n.checkableBaseItem--checkableBaseItem__icon {\n  font-size: 24px; }\n";
var styles$I = {"root":"checkableBaseItem--checkableBaseItem__root","rootActive":"checkableBaseItem--checkableBaseItem__rootActive","rootDisabled":"checkableBaseItem--checkableBaseItem__rootDisabled","name":"checkableBaseItem--checkableBaseItem__name","checkbox":"checkableBaseItem--checkableBaseItem__checkbox","content":"checkableBaseItem--checkableBaseItem__content","icon":"checkableBaseItem--checkableBaseItem__icon"};
styleInject(css_248z$Q);

var CheckableBaseItem =
/** @class */
function (_super) {
  __extends(CheckableBaseItem, _super);

  function CheckableBaseItem(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  CheckableBaseItem.prototype.handleChange = function () {
    var _a = this.props,
        onChange = _a.onChange,
        item = _a.item,
        checked = _a.checked;

    if (typeof onChange === 'function') {
      onChange(item, !checked);
    }
  };

  CheckableBaseItem.prototype.noop = function (event) {
    event.preventDefault();
  };

  CheckableBaseItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        item = _b.item,
        onChange = _b.onChange,
        clearSearch = _b.clearSearch,
        checked = _b.checked,
        disabled = _b.disabled,
        isLoading = _b.isLoading,
        children = _b.children,
        active = _b.active,
        otherProps = __rest(_b, ["item", "onChange", "clearSearch", "checked", "disabled", "isLoading", "children", "active"]);

    var rootClass = classnames(styles$I.root, (_a = {}, _a[styles$I.rootDisabled] = disabled, _a[styles$I.rootActive] = active, _a));
    var handleChange = disabled ? noop$1 : this.handleChange;
    return /*#__PURE__*/React.createElement("label", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(Checkbox, {
      id: item === null || item === void 0 ? void 0 : item.id,
      name: "",
      className: styles$I.checkbox,
      checked: checked,
      onChange: handleChange
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$I.content
    }, children));
  };

  return CheckableBaseItem;
}(PureComponent);

var css_248z$R = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emptySelectItem--emptySelectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.emptySelectItem--emptySelectItem__root:hover, .emptySelectItem--emptySelectItem__root:focus {\n  background-color: #f5f7fa; }\n\n.emptySelectItem--emptySelectItem__root:disabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.emptySelectItem--emptySelectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.emptySelectItem--emptySelectItem__name {\n  color: #617598; }\n\n.emptySelectItem--emptySelectItem__root {\n  cursor: auto; }\n  .emptySelectItem--emptySelectItem__root:hover, .emptySelectItem--emptySelectItem__root:focus {\n    background-color: transparent; }\n";
var styles$J = {"root":"emptySelectItem--emptySelectItem__root","name":"emptySelectItem--emptySelectItem__name"};
styleInject(css_248z$R);

var EmptySelectItem =
/** @class */
function (_super) {
  __extends(EmptySelectItem, _super);

  function EmptySelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EmptySelectItem.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        otherProps = __rest(_a, ["label"]);

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: styles$J.root
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$J.name
    }, label));
  };

  return EmptySelectItem;
}(PureComponent);

var css_248z$S = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.selectItem--selectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.selectItem--selectItem__root:hover, .selectItem--selectItem__root:focus, .selectItem--selectItem__rootActive {\n  background-color: #f5f7fa; }\n\n.selectItem--selectItem__root:disabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.selectItem--selectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.selectItem--selectItem__nameBold {\n  font-weight: 600; }\n\n.selectItem--selectItem__icon {\n  margin: 0 8px; }\n";
var styles$K = {"root":"selectItem--selectItem__root","rootActive":"selectItem--selectItem__rootActive","name":"selectItem--selectItem__name","nameBold":"selectItem--selectItem__nameBold","icon":"selectItem--selectItem__icon"};
styleInject(css_248z$S);

var SelectItem =
/** @class */
function (_super) {
  __extends(SelectItem, _super);

  function SelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SelectItem.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        item = _c.item,
        onSelect = _c.onSelect,
        clearSearch = _c.clearSearch,
        _d = _c.checked,
        checked = _d === void 0 ? false : _d,
        disabled = _c.disabled,
        active = _c.active,
        otherProps = __rest(_c, ["item", "onSelect", "clearSearch", "checked", "disabled", "active"]);

    var name = item.name,
        icon = item.icon,
        iconSize = item.iconSize;
    var rootClass = classnames(styles$K.root, (_a = {}, _a[styles$K.rootActive] = active, _a));
    var nameClass = classnames(styles$K.name, (_b = {}, _b[styles$K.nameBold] = checked, _b));
    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      type: "button",
      className: rootClass,
      disabled: disabled,
      onClick: function onClick() {
        onSelect(item);
      }
    }), icon ? /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$K.icon,
      name: icon,
      size: iconSize !== null && iconSize !== void 0 ? iconSize : 16
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: nameClass
    }, name), checked && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "done",
      size: 20,
      color: colors.purple['500']
    }));
  };

  return SelectItem;
}(Component);

var css_248z$T = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableSelectItem--checkableSelectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableSelectItem--checkableSelectItem__name {\n  margin-left: 16px; }\n";
var styles$L = {"name":"checkableSelectItem--checkableSelectItem__name"};
styleInject(css_248z$T);

var CheckableSelectItem =
/** @class */
function (_super) {
  __extends(CheckableSelectItem, _super);

  function CheckableSelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CheckableSelectItem.prototype.render = function () {
    var _a = this.props,
        item = _a.item,
        isLoading = _a.isLoading;
    var name = (isLoading ? {
      id: '',
      name: 'Loading...'
    } // Display skeleton while loading
    : item).name;
    return /*#__PURE__*/React.createElement(CheckableBaseItem, __assign({}, this.props), /*#__PURE__*/React.createElement("span", {
      className: styles$L.name
    }, name));
  };

  return CheckableSelectItem;
}(PureComponent);

var css_248z$U = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tagSelectItem--tagSelectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.tagSelectItem--tagSelectItem__root:hover, .tagSelectItem--tagSelectItem__root:focus, .tagSelectItem--tagSelectItem__rootActive {\n  background-color: #f5f7fa; }\n\n.tagSelectItem--tagSelectItem__root:disabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.tagSelectItem--tagSelectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.tagSelectItem--tagSelectItem__nameBold {\n  font-weight: 600; }\n\n.tagSelectItem--tagSelectItem__dotContainer {\n  flex: 0 0 8px; }\n\n.tagSelectItem--tagSelectItem__dot {\n  width: 8px;\n  min-width: 8px;\n  max-width: 8px;\n  height: 8px;\n  min-height: 8px;\n  max-height: 8px;\n  border-radius: 50%;\n  margin-right: 16px; }\n";
var styles$M = {"root":"tagSelectItem--tagSelectItem__root","rootActive":"tagSelectItem--tagSelectItem__rootActive","name":"tagSelectItem--tagSelectItem__name","nameBold":"tagSelectItem--tagSelectItem__nameBold","dotContainer":"tagSelectItem--tagSelectItem__dotContainer","dot":"tagSelectItem--tagSelectItem__dot"};
styleInject(css_248z$U);

var TagSelectItem =
/** @class */
function (_super) {
  __extends(TagSelectItem, _super);

  function TagSelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TagSelectItem.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        item = _c.item,
        onSelect = _c.onSelect,
        clearSearch = _c.clearSearch,
        _d = _c.checked,
        checked = _d === void 0 ? false : _d,
        disabled = _c.disabled,
        isLoading = _c.isLoading,
        active = _c.active,
        otherProps = __rest(_c, ["item", "onSelect", "clearSearch", "checked", "disabled", "isLoading", "active"]);

    var name = item.name,
        _e = item.color,
        color = _e === void 0 ? '#000' : _e;
    var rootClass = classnames(styles$M.root, (_a = {}, _a[styles$M.rootActive] = active, _a));
    var nameClass = classnames(styles$M.name, (_b = {}, _b[styles$M.nameBold] = checked, _b));
    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      type: "button",
      className: rootClass,
      onClick: function onClick() {
        onSelect(item);
        clearSearch();
      },
      tabIndex: 0,
      title: typeof name === 'string' ? name : name.toString(),
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$M.dotContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$M.dot,
      style: {
        backgroundColor: color
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: nameClass
    }, name), checked && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "done",
      size: 20,
      color: colors.purple['500']
    }));
  };

  return TagSelectItem;
}(PureComponent);

var css_248z$V = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableTagSelectItem--checkableTagSelectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.checkableTagSelectItem--checkableTagSelectItem__dotContainer {\n  flex: 0 0 8px; }\n\n.checkableTagSelectItem--checkableTagSelectItem__dot {\n  width: 8px;\n  min-width: 8px;\n  max-width: 8px;\n  height: 8px;\n  min-height: 8px;\n  max-height: 8px;\n  border-radius: 50%;\n  margin-right: 16px; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.checkableTagSelectItem--checkableTagSelectItem__nameContainer {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  overflow: hidden;\n  margin-left: 16px; }\n";
var styles$N = {"name":"checkableTagSelectItem--checkableTagSelectItem__name","dotContainer":"checkableTagSelectItem--checkableTagSelectItem__dotContainer","dot":"checkableTagSelectItem--checkableTagSelectItem__dot","nameContainer":"checkableTagSelectItem--checkableTagSelectItem__nameContainer"};
styleInject(css_248z$V);

var CheckableTagSelectItem =
/** @class */
function (_super) {
  __extends(CheckableTagSelectItem, _super);

  function CheckableTagSelectItem(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  CheckableTagSelectItem.prototype.handleChange = function () {
    var _a = this.props,
        onChange = _a.onChange,
        item = _a.item,
        checked = _a.checked;

    if (typeof onChange === 'function') {
      onChange(item, !checked);
    }
  };

  CheckableTagSelectItem.prototype.render = function () {
    var _a = this.props,
        item = _a.item,
        isLoading = _a.isLoading;

    var _b = isLoading ? {
      id: '',
      name: 'Loading...',
      color: '#000'
    } // Display skeleton while loading
    : item,
        name = _b.name,
        color = _b.color;

    return /*#__PURE__*/React.createElement(CheckableBaseItem, __assign({}, this.props), /*#__PURE__*/React.createElement("div", {
      className: styles$N.nameContainer
    }, color && /*#__PURE__*/React.createElement("div", {
      className: styles$N.dotContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$N.dot,
      style: {
        backgroundColor: color
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: styles$N.name
    }, name)));
  };

  return CheckableTagSelectItem;
}(PureComponent);

var css_248z$W = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.avatarSelectItem--avatarSelectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.avatarSelectItem--avatarSelectItem__root:hover, .avatarSelectItem--avatarSelectItem__root:focus, .avatarSelectItem--avatarSelectItem__rootActive {\n  background-color: #f5f7fa; }\n\n.avatarSelectItem--avatarSelectItem__root:disabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.avatarSelectItem--avatarSelectItem__names, .avatarSelectItem--avatarSelectItem__primaryName, .avatarSelectItem--avatarSelectItem__secondaryName {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.avatarSelectItem--avatarSelectItem__container {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 8px;\n  align-items: center;\n  overflow: hidden; }\n  .avatarSelectItem--avatarSelectItem__containerCheckable {\n    margin-left: 16px; }\n\n.avatarSelectItem--avatarSelectItem__names {\n  display: flex;\n  flex-direction: column;\n  line-height: 12px; }\n\n.avatarSelectItem--avatarSelectItem__secondaryName {\n  color: #617598;\n  margin-top: 2px; }\n";
var styles$O = {"root":"avatarSelectItem--avatarSelectItem__root","rootActive":"avatarSelectItem--avatarSelectItem__rootActive","names":"avatarSelectItem--avatarSelectItem__names","primaryName":"avatarSelectItem--avatarSelectItem__primaryName","secondaryName":"avatarSelectItem--avatarSelectItem__secondaryName","container":"avatarSelectItem--avatarSelectItem__container","containerCheckable":"avatarSelectItem--avatarSelectItem__containerCheckable"};
styleInject(css_248z$W);

var AvatarSelectItem =
/** @class */
function (_super) {
  __extends(AvatarSelectItem, _super);

  function AvatarSelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AvatarSelectItem.prototype.getNames = function (item) {
    var uniqueNames = new Set();

    if (typeof item.name === 'string') {
      uniqueNames.add(item.name);
    }

    if (typeof item.name !== 'string' && typeof item.display_name === 'string') {
      uniqueNames.add(item.display_name);
    }

    if (typeof item.phone_number === 'string') {
      uniqueNames.add(item.phone_number);
    }

    if (typeof item.email === 'string') {
      uniqueNames.add(item.email);
    }

    var names = Array.from(uniqueNames);
    return {
      primaryName: names.length > 0 ? names[0] : 'No name',
      secondaryName: names.length > 1 ? names[1] : null
    };
  };

  AvatarSelectItem.prototype.getAvatar = function (useItem) {
    if (typeof useItem.icon === 'string') {
      return /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
        name: useItem.icon,
        size: 16
      });
    }

    return /*#__PURE__*/React.createElement(AvatarWithErrorBoundary, {
      user: useItem
    });
  };

  AvatarSelectItem.prototype.renderContent = function () {
    var _a;

    var useItem = this.props.isLoading ? {
      id: '',
      name: 'Loading...'
    } : this.props.item;
    var avatar = this.getAvatar(useItem);
    var names = this.getNames(useItem);
    var containerClass = classnames(styles$O.container, (_a = {}, _a[styles$O.containerCheckable] = this.props.checkable, _a));
    return /*#__PURE__*/React.createElement("div", {
      className: containerClass
    }, avatar, /*#__PURE__*/React.createElement("div", {
      className: styles$O.names
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$O.primaryName
    }, names.primaryName), names.secondaryName !== null && /*#__PURE__*/React.createElement("div", {
      className: styles$O.secondaryName
    }, names.secondaryName)));
  };

  AvatarSelectItem.prototype.render = function () {
    var _a;

    var content = this.renderContent();

    var _b = this.props,
        checkable = _b.checkable,
        itemProps = __rest(_b, ["checkable"]);

    if (checkable) {
      var checkableItemProps = itemProps;
      return /*#__PURE__*/React.createElement(CheckableBaseItem, __assign({}, checkableItemProps), content);
    } else {
      var simpleItemProps = itemProps;

      var item_1 = simpleItemProps.item,
          disabled = simpleItemProps.disabled,
          onSelect_1 = simpleItemProps.onSelect,
          active = simpleItemProps.active,
          rest = __rest(simpleItemProps, ["item", "disabled", "onSelect", "active"]);

      var rootClass = classnames(styles$O.root, (_a = {}, _a[styles$O.rootActive] = active, _a));
      return /*#__PURE__*/React.createElement("button", __assign({}, rest, {
        type: "button",
        className: rootClass,
        disabled: disabled,
        onClick: function onClick() {
          onSelect_1(item_1);
        }
      }), content);
    }
  };

  return AvatarSelectItem;
}(PureComponent);

var CheckableAvatarSelectItem =
/** @class */
function (_super) {
  __extends(CheckableAvatarSelectItem, _super);

  function CheckableAvatarSelectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CheckableAvatarSelectItem.prototype.render = function () {
    return /*#__PURE__*/React.createElement(AvatarSelectItem, __assign({
      checkable: true
    }, this.props));
  };

  return CheckableAvatarSelectItem;
}(PureComponent);

var css_248z$X = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tagSelectSuggestion--tagSelectSuggestion__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.tagSelectSuggestion--tagSelectSuggestion__root:hover, .tagSelectSuggestion--tagSelectSuggestion__root:focus {\n  background-color: #f5f7fa; }\n\n.tagSelectSuggestion--tagSelectSuggestion__root:disabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.tagSelectSuggestion--tagSelectSuggestion__suggestion {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.tagSelectSuggestion--tagSelectSuggestion__suggestion {\n  color: #617598; }\n\n.tagSelectSuggestion--tagSelectSuggestion__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 1 48px;\n  height: 48px;\n  color: #5644d8;\n  font-size: 16px;\n  background: transparent;\n  border: none;\n  outline: 0; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tagSelectSuggestion--tagSelectSuggestion__root {\n  border-bottom: 1px solid #e7ecf3;\n  margin-bottom: -1px; }\n";
var styles$P = {"root":"tagSelectSuggestion--tagSelectSuggestion__root","suggestion":"tagSelectSuggestion--tagSelectSuggestion__suggestion","icon":"tagSelectSuggestion--tagSelectSuggestion__icon"};
styleInject(css_248z$X);

var TagSelectSuggestion =
/** @class */
function (_super) {
  __extends(TagSelectSuggestion, _super);

  function TagSelectSuggestion(props) {
    var _this = _super.call(this, props) || this;

    _this.onSuggest = _this.onSuggest.bind(_this);
    return _this;
  }

  TagSelectSuggestion.prototype.onSuggest = function () {
    var _a = this.props,
        triggerClose = _a.triggerClose,
        onSuggest = _a.onSuggest,
        searched = _a.searched;
    triggerClose();
    onSuggest(searched);
  };

  TagSelectSuggestion.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        triggerClose = _b.triggerClose,
        onSuggest = _b.onSuggest,
        searched = _b.searched,
        items = _b.items,
        clearSearch = _b.clearSearch,
        otherProps = __rest(_b, ["className", "triggerClose", "onSuggest", "searched", "items", "clearSearch"]);

    if (!searched || items.find(function (item) {
      return item.name === searched;
    })) {
      return null;
    }

    var rootClass = classnames((_a = {}, _a[styles$P.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("button", __assign({}, otherProps, {
      type: "button",
      className: rootClass,
      onClick: this.onSuggest,
      tabIndex: 0
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$P.suggestion
    }, "Add \u201C" + searched + "\u201D tag"), /*#__PURE__*/React.createElement("div", {
      className: styles$P.icon
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "plus"
    })));
  };

  return TagSelectSuggestion;
}(React.Component);
TagSelectSuggestion.defaultProps = {
  className: ''
};

var css_248z$Y = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.deselectItem--deselectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.deselectItem--deselectItem__root:hover, .deselectItem--deselectItem__root:focus {\n  background-color: #f5f7fa; }\n\n.deselectItem--deselectItem__root:disabled, .deselectItem--deselectItem__rootDisabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.deselectItem--deselectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.deselectItem--deselectItem__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 1 48px;\n  height: 48px;\n  color: #5644d8;\n  font-size: 16px;\n  background: transparent;\n  border: none;\n  outline: 0; }\n";
var styles$Q = {"root":"deselectItem--deselectItem__root","rootDisabled":"deselectItem--deselectItem__rootDisabled","name":"deselectItem--deselectItem__name","icon":"deselectItem--deselectItem__icon"};
styleInject(css_248z$Y);

var DeselectItem =
/** @class */
function (_super) {
  __extends(DeselectItem, _super);

  function DeselectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DeselectItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        item = _b.item,
        onSelect = _b.onSelect,
        clearSearch = _b.clearSearch,
        disabled = _b.disabled,
        otherProps = __rest(_b, ["item", "onSelect", "clearSearch", "disabled"]);

    var name = item.name;
    var rootClass = classnames(styles$Q.root, (_a = {}, _a[styles$Q.rootDisabled] = disabled, _a));
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$Q.name
    }, name), /*#__PURE__*/React.createElement("button", {
      className: styles$Q.icon,
      onClick: function onClick() {
        onSelect(item);
      },
      disabled: disabled
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "close"
    })));
  };

  return DeselectItem;
}(PureComponent);

var css_248z$Z = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tagDeselectItem--tagDeselectItem__root {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n  border: 0;\n  color: #132243;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: 12px;\n  line-height: 32px;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  cursor: pointer; }\n\n.tagDeselectItem--tagDeselectItem__root:hover, .tagDeselectItem--tagDeselectItem__root:focus {\n  background-color: #f5f7fa; }\n\n.tagDeselectItem--tagDeselectItem__root:disabled, .tagDeselectItem--tagDeselectItem__rootDisabled {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.tagDeselectItem--tagDeselectItem__name {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.tagDeselectItem--tagDeselectItem__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 1 48px;\n  height: 48px;\n  color: #5644d8;\n  font-size: 16px;\n  background: transparent;\n  border: none;\n  outline: 0; }\n\n.tagDeselectItem--tagDeselectItem__dotContainer {\n  flex: 0 0 8px; }\n\n.tagDeselectItem--tagDeselectItem__dot {\n  width: 8px;\n  min-width: 8px;\n  max-width: 8px;\n  height: 8px;\n  min-height: 8px;\n  max-height: 8px;\n  border-radius: 50%;\n  margin-right: 16px; }\n";
var styles$R = {"root":"tagDeselectItem--tagDeselectItem__root","rootDisabled":"tagDeselectItem--tagDeselectItem__rootDisabled","name":"tagDeselectItem--tagDeselectItem__name","icon":"tagDeselectItem--tagDeselectItem__icon","dotContainer":"tagDeselectItem--tagDeselectItem__dotContainer","dot":"tagDeselectItem--tagDeselectItem__dot"};
styleInject(css_248z$Z);

var TagDeselectItem =
/** @class */
function (_super) {
  __extends(TagDeselectItem, _super);

  function TagDeselectItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TagDeselectItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        item = _b.item,
        onSelect = _b.onSelect,
        clearSearch = _b.clearSearch,
        disabled = _b.disabled,
        otherProps = __rest(_b, ["item", "onSelect", "clearSearch", "disabled"]);

    var name = item.name,
        color = item.color;
    var rootClass = classnames(styles$R.root, (_a = {}, _a[styles$R.rootDisabled] = disabled, _a));
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$R.dotContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$R.dot,
      style: {
        backgroundColor: color
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$R.name
    }, name), /*#__PURE__*/React.createElement("button", {
      className: styles$R.icon,
      onClick: function onClick() {
        onSelect(item);
      },
      disabled: disabled
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "close"
    })));
  };

  return TagDeselectItem;
}(PureComponent);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

if (process.env.NODE_ENV !== 'production') ;

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName$1 =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class, _temp;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose$1(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized$2(_assertThisInitialized$2(_this)));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized$2(_assertThisInitialized$2(_this)),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          initialScrollOffset = _this$props2.initialScrollOffset,
          layout = _this$props2.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          layout = _this$props3.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemCount = _this$props4.itemCount,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey,
          layout = _this$props4.layout,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, createElement(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props,
          itemCount = _this$props5.itemCount,
          overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _temp;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (process.env.NODE_ENV !== 'production') {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var FixedSizeList =
/*#__PURE__*/
createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

function isInteger$1(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function isRangeVisible(_ref) {
  var lastRenderedStartIndex = _ref.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref.lastRenderedStopIndex,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

function scanForUnloadedRanges(_ref) {
  var isItemLoaded = _ref.isItemLoaded,
      itemCount = _ref.itemCount,
      minimumBatchSize = _ref.minimumBatchSize,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var _index = startIndex; _index <= stopIndex; _index++) {
    var loaded = isItemLoaded(_index);

    if (!loaded) {
      rangeStopIndex = _index;
      if (rangeStartIndex === null) {
        rangeStartIndex = _index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push([rangeStartIndex, rangeStopIndex]);

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);

    for (var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++) {
      if (!isItemLoaded(_index2)) {
        rangeStopIndex = _index2;
      } else {
        break;
      }
    }

    unloadedRanges.push([rangeStartIndex, rangeStopIndex]);
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstRange = unloadedRanges[0];

    while (firstRange[1] - firstRange[0] + 1 < minimumBatchSize && firstRange[0] > 0) {
      var _index3 = firstRange[0] - 1;

      if (!isItemLoaded(_index3)) {
        firstRange[0] = _index3;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits$1 = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray$1 = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var InfiniteLoader = function (_PureComponent) {
  inherits$1(InfiniteLoader, _PureComponent);

  function InfiniteLoader() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InfiniteLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [this].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function (_ref2) {
      var visibleStartIndex = _ref2.visibleStartIndex,
          visibleStopIndex = _ref2.visibleStopIndex;

      if (process.env.NODE_ENV !== 'production') {
        if (!isInteger$1(visibleStartIndex) || !isInteger$1(visibleStopIndex)) {
          console.warn('Invalid onItemsRendered signature; please refer to InfiniteLoader documentation.');
        }

        if (typeof _this.props.loadMoreRows === 'function') {
          console.warn('InfiniteLoader "loadMoreRows" prop has been renamed to "loadMoreItems".');
        }
      }

      _this._lastRenderedStartIndex = visibleStartIndex;
      _this._lastRenderedStopIndex = visibleStopIndex;

      _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
    }, _this._setRef = function (listRef) {
      _this._listRef = listRef;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InfiniteLoader, [{
    key: 'resetloadMoreItemsCache',
    value: function resetloadMoreItemsCache() {
      var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this._memoizedUnloadedRanges = [];

      if (autoReload) {
        this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== 'production') {
        if (this._listRef == null) {
          console.warn('Invalid list ref; please refer to InfiniteLoader documentation.');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onItemsRendered: this._onItemsRendered,
        ref: this._setRef
      });
    }
  }, {
    key: '_ensureRowsLoaded',
    value: function _ensureRowsLoaded(startIndex, stopIndex) {
      var _props = this.props,
          isItemLoaded = _props.isItemLoaded,
          itemCount = _props.itemCount,
          _props$minimumBatchSi = _props.minimumBatchSize,
          minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi,
          _props$threshold = _props.threshold,
          threshold = _props$threshold === undefined ? 15 : _props$threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isItemLoaded: isItemLoaded,
        itemCount: itemCount,
        minimumBatchSize: minimumBatchSize,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
      });

      // Avoid calling load-rows unless range has changed.
      // This shouldn't be strictly necsesary, but is maybe nice to do.
      if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function (_ref3, index) {
        var _ref4 = slicedToArray$1(_ref3, 2),
            startIndex = _ref4[0],
            stopIndex = _ref4[1];

        return unloadedRanges[index][0] !== startIndex || unloadedRanges[index][1] !== stopIndex;
      })) {
        this._memoizedUnloadedRanges = unloadedRanges;
        this._loadUnloadedRanges(unloadedRanges);
      }
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
      var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;

      unloadedRanges.forEach(function (_ref5) {
        var _ref6 = slicedToArray$1(_ref5, 2),
            startIndex = _ref6[0],
            stopIndex = _ref6[1];

        var promise = loadMoreItems(startIndex, stopIndex);
        if (promise != null) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: startIndex,
              stopIndex: stopIndex
            })) {
              // Handle an unmount while promises are still in flight.
              if (_this2._listRef == null) {
                return;
              }

              // Resize cached row sizes for VariableSizeList,
              // otherwise just re-render the list.
              if (typeof _this2._listRef.resetAfterIndex === 'function') {
                _this2._listRef.resetAfterIndex(startIndex, true);
              } else {
                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                // This is pretty gross, but I'm okay with it for now.
                // Don't judge me.
                if (typeof _this2._listRef._getItemStyleCache === 'function') {
                  _this2._listRef._getItemStyleCache(-1);
                }
                _this2._listRef.forceUpdate();
              }
            }
          });
        }
      });
    }
  }]);
  return InfiniteLoader;
}(PureComponent);

var css_248z$_ = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--dropdownInfinite__item {\n  overflow: 'hidden';\n  white-space: 'pre'; }\n\n.components--dropdownInfinite__list {\n  overflow: hidden;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin: 0;\n  overflow-y: overlay; }\n  .components--dropdownInfinite__list::-webkit-scrollbar {\n    width: 7px;\n    height: 7px; }\n  .components--dropdownInfinite__list::-webkit-scrollbar-track {\n    background-color: rgba(255, 255, 255, 0.1); }\n  .components--dropdownInfinite__list::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 5px; }\n  .components--dropdownInfinite__listEmpty {\n    overflow: auto;\n    overflow-x: auto;\n    overflow-y: auto; }\n";
var styles$S = {"item":"components--dropdownInfinite__item","list":"components--dropdownInfinite__list","listEmpty":"components--dropdownInfinite__listEmpty"};
styleInject(css_248z$_);

var DropdownItem =
/** @class */
function (_super) {
  __extends(DropdownItem, _super);

  function DropdownItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DropdownItem.prototype.render = function () {
    var _a = this.props,
        item = _a.item,
        ItemComponent = _a.itemComponent,
        tooltip = _a.tooltip,
        onSelect = _a.onSelect,
        onChange = _a.onChange,
        onKeyDown = _a.onKeyDown,
        clearSearch = _a.clearSearch,
        checked = _a.checked,
        disabled = _a.disabled,
        isLoading = _a.isLoading,
        active = _a.active,
        id = _a.id;
    var itemComponent = /*#__PURE__*/React.createElement(ItemComponent, {
      item: item,
      onSelect: onSelect,
      onChange: onChange,
      onKeyDown: onKeyDown,
      clearSearch: clearSearch,
      checked: checked,
      disabled: disabled,
      isLoading: isLoading,
      active: active,
      tabIndex: -1,
      id: id,
      role: "option",
      "aria-disabled": disabled,
      "aria-selected": checked
    });

    if (!tooltip) {
      return itemComponent;
    }

    return /*#__PURE__*/React.createElement(Tooltip, __assign({
      key: item.id
    }, tooltip), itemComponent);
  };

  return DropdownItem;
}(PureComponent);

var INFINITE_DISPLAY_NUMBER_ITEMS = 6;
var INFINITE_DISPLAY_ITEM_HEIGHT = 48;

var DropdownInfinite =
/** @class */
function (_super) {
  __extends(DropdownInfinite, _super);

  function DropdownInfinite(props) {
    var _this = _super.call(this, props) || this;

    _this.isItemLoaded = _this.isItemLoaded.bind(_this);
    _this.listRef = /*#__PURE__*/React.createRef();
    _this.infiniteListRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  DropdownInfinite.prototype.isItemLoaded = function (index) {
    var items = this.props.items;
    return index < items.length;
  };

  DropdownInfinite.prototype.isItemActive = function (item) {
    if (!item) return false;
    var activeItem = this.props.activeItem;
    return item === activeItem || item.id === activeItem;
  };

  DropdownInfinite.prototype.isItemChecked = function (item) {
    if (!item) return false;
    var selectedItems = this.props.selectedItems;
    var index = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.findIndex(function (itemToFind) {
      if (_typeof(itemToFind) === 'object') {
        return itemToFind.id === item.id;
      }

      return itemToFind === item.id;
    });
    return (index !== null && index !== void 0 ? index : -1) > -1;
  };

  DropdownInfinite.prototype.isItemDisabled = function (item) {
    var _a, _b;

    if (!item) return true;
    var index = (_b = (_a = this.props.disabledItems) === null || _a === void 0 ? void 0 : _a.indexOf(item.id)) !== null && _b !== void 0 ? _b : -1;
    return index >= 0;
  };

  DropdownInfinite.prototype.getTooltip = function (item) {
    var _a;

    var tooltipItems = this.props.tooltipItems;

    if (!item || isEmpty(tooltipItems === null || tooltipItems === void 0 ? void 0 : tooltipItems[item.id])) {
      return null;
    }

    return (_a = tooltipItems === null || tooltipItems === void 0 ? void 0 : tooltipItems[item.id]) !== null && _a !== void 0 ? _a : null;
  };

  DropdownInfinite.prototype.goToTop = function () {
    if (this.infiniteListRef.current) {
      this.infiniteListRef.current.scrollTo(0);
    }

    if (this.listRef.current) {
      this.listRef.current.scrollTop = 0;
    }
  };

  DropdownInfinite.prototype.getItemId = function (index) {
    var id = this.props.id;
    return id ? id + "-option-" + index : undefined;
  };

  DropdownInfinite.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        items = _b.items,
        pagination = _b.pagination,
        itemComponent = _b.itemComponent,
        onSelect = _b.onSelect,
        onChange = _b.onChange,
        onKeyDown = _b.onKeyDown,
        clearSearch = _b.clearSearch,
        _c = _b.itemsDisplayCount,
        itemsDisplayCount = _c === void 0 ? INFINITE_DISPLAY_NUMBER_ITEMS : _c,
        _d = _b.itemHeight,
        itemHeight = _d === void 0 ? INFINITE_DISPLAY_ITEM_HEIGHT : _d,
        id = _b.id,
        ariaLabelledby = _b.ariaLabelledby;

    if (!pagination || !pagination.infinite || !pagination.onNext) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          maxHeight: itemsDisplayCount * itemHeight + "px"
        },
        className: classnames((_a = {}, _a[styles$S.list] = true, _a[styles$S.listEmpty] = items.length === 0, _a)),
        ref: this.listRef,
        role: "listbox",
        id: id,
        "aria-labelledby": ariaLabelledby
      }, items.map(function (item, index) {
        var key = isString$1(item) // Sometimes item type is not as expected!
        ? item // E.g. Emoji item
        : item.id.toString() || item.name.toString() || item.toString();
        return /*#__PURE__*/React.createElement(DropdownItem, {
          id: _this.getItemId(index),
          key: key,
          checked: _this.isItemChecked(item),
          clearSearch: clearSearch,
          disabled: _this.isItemDisabled(item),
          item: item,
          itemComponent: itemComponent,
          onChange: onChange,
          onSelect: onSelect,
          onKeyDown: onKeyDown,
          tooltip: _this.getTooltip(item),
          active: _this.isItemActive(item)
        });
      }));
    }

    var nextEnable = pagination.nextEnable,
        onNext = pagination.onNext,
        fixedItemCount = pagination.itemCount;
    var itemCount = fixedItemCount || (nextEnable ? items.length + itemsDisplayCount : items.length);

    var Item = function Item(_a) {
      var index = _a.index,
          style = _a.style;
      var _b = _this.props,
          items = _b.items,
          itemComponent = _b.itemComponent,
          onSelect = _b.onSelect,
          onChange = _b.onChange,
          clearSearch = _b.clearSearch;
      var item = _this.isItemLoaded(index) ? items[index] : {
        id: uuid(),
        name: 'Loading...'
      };
      return /*#__PURE__*/React.createElement("div", {
        style: style,
        className: styles$S.item
      }, /*#__PURE__*/React.createElement(DropdownItem, {
        id: _this.getItemId(index),
        checked: _this.isItemChecked(item),
        clearSearch: clearSearch,
        disabled: _this.isItemDisabled(item),
        isLoading: !_this.isItemLoaded(index),
        item: item,
        itemComponent: itemComponent,
        onChange: onChange,
        onSelect: onSelect,
        tooltip: _this.getTooltip(item),
        active: _this.isItemActive(item)
      }));
    };

    return /*#__PURE__*/React.createElement(InfiniteLoader, {
      isItemLoaded: this.isItemLoaded,
      itemCount: itemCount,
      loadMoreItems: onNext
    }, function (_a) {
      var onItemsRendered = _a.onItemsRendered,
          setListRef = _a.ref;
      return /*#__PURE__*/React.createElement(FixedSizeList, {
        ref: function ref(_ref) {
          if (typeof setListRef === 'function') {
            setListRef(_ref);
          }

          _this.infiniteListRef = {
            current: _ref
          };
        },
        height: Math.min(itemCount * itemHeight, itemsDisplayCount * itemHeight),
        width: "100%",
        itemCount: itemCount,
        itemSize: itemHeight,
        onItemsRendered: onItemsRendered,
        "aria-labelledby": ariaLabelledby
      }, Item);
    });
  };

  DropdownInfinite.defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  return DropdownInfinite;
}(PureComponent);

var css_248z$$ = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--dropdownSelectContainer__search {\n  margin: 16px; }\n\n.components--dropdownSelectContainer__pagination {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 8px;\n  padding: 8px 0;\n  border-top: 1px solid #e7ecf3; }\n\n.components--dropdownSelectContainer__selectionActions {\n  padding: 16px;\n  border-top: 1px solid #e7ecf3; }\n";
var styles$T = {"search":"components--dropdownSelectContainer__search","pagination":"components--dropdownSelectContainer__pagination","selectionActions":"components--dropdownSelectContainer__selectionActions"};
styleInject(css_248z$$);

var DROP_SEARCH_INPUT = 'DROP_SEARCH_INPUT';

var DropdownSelectContainer =
/** @class */
function (_super) {
  __extends(DropdownSelectContainer, _super);

  function DropdownSelectContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.clearSearch = function () {
      var onSearch = _this.props.onSearch;
      var searchValue = _this.state.searchValue;

      if (searchValue) {
        if (typeof onSearch === 'function') {
          onSearch('');
        }

        _this.setState({
          searchValue: ''
        });
      }
    };

    _this.state = {
      searchValue: ''
    };
    _this.search = _this.search.bind(_this);
    _this.searchKeyDown = _this.searchKeyDown.bind(_this);
    _this.onSelect = _this.onSelect.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.listRef = /*#__PURE__*/React.createRef();
    _this.searchRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  DropdownSelectContainer.getDerivedStateFromProps = function (props, state) {
    var dropdownOpen = props.dropdownOpen;

    var newState = __assign({}, state);

    if (!dropdownOpen) {
      newState.searchValue = '';
    }

    return newState;
  };

  DropdownSelectContainer.prototype.componentDidMount = function () {
    this.onOpen();
  };

  DropdownSelectContainer.prototype.componentDidUpdate = function (prevProps) {
    var dropdownOpen = this.props.dropdownOpen;

    if (!prevProps.dropdownOpen && dropdownOpen) {
      this.onOpen();
    }
  };

  DropdownSelectContainer.prototype.getInput = function () {
    var searchValue = this.state.searchValue;
    return {
      name: DROP_SEARCH_INPUT,
      value: searchValue,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: 'off',
      'aria-label': 'Search'
    };
  };

  DropdownSelectContainer.prototype.searchKeyDown = function (e) {
    var keyCode = e.keyCode;
    var searchValue = this.state.searchValue;
    var triggerClose = this.props.triggerClose;

    if (keyCode === 27 && searchValue === '') {
      triggerClose();
    } else if (keyCode === 27) {
      this.clearSearch();
    } else if (keyCode === 13) {
      e.preventDefault();
    }
  };

  DropdownSelectContainer.prototype.search = function (e) {
    if (e.target instanceof HTMLInputElement) {
      var onSearch = this.props.onSearch;
      var value = e.target.value;

      if (typeof onSearch === 'function') {
        onSearch(value);
      }

      if (value && this.listRef.current) {
        this.listRef.current.goToTop();
      }

      this.setState({
        searchValue: value
      });
    }
  };

  DropdownSelectContainer.prototype.onSelect = function (value) {
    var _a = this.props,
        onSelect = _a.onSelect,
        keepOpen = _a.keepOpen,
        triggerClose = _a.triggerClose;

    if (typeof onSelect === 'function') {
      onSelect(value);
    }

    if (keepOpen) {
      this.focusSearch();
    }

    if (!keepOpen && typeof triggerClose === 'function') {
      triggerClose();
    }
  };

  DropdownSelectContainer.prototype.onChange = function (value, checked) {
    var _a = this.props,
        onChange = _a.onChange,
        keepOpen = _a.keepOpen,
        triggerClose = _a.triggerClose;

    if (typeof onChange === 'function') {
      onChange(value, checked);
    }

    if (keepOpen) {
      this.focusSearch();
    }

    if (!keepOpen && typeof triggerClose === 'function') {
      triggerClose();
    }
  };

  DropdownSelectContainer.prototype.onOpen = function () {
    this.focusSearch();
  };

  DropdownSelectContainer.prototype.focusSearch = function () {
    var hasSearch = this.props.hasSearch;

    if (hasSearch && this.searchRef.current) {
      var input = this.searchRef.current.querySelector('input');

      if (input) {
        input.focus();
      }
    }
  };

  DropdownSelectContainer.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        ItemComponent = _a.itemComponent,
        EmptyComponent = _a.emptyComponent,
        items = _a.items,
        hasSearch = _a.hasSearch,
        searchPlaceholder = _a.searchPlaceholder,
        pagination = _a.pagination,
        keepOpen = _a.keepOpen,
        onSelect = _a.onSelect,
        onSearch = _a.onSearch,
        onSuggest = _a.onSuggest,
        onChange = _a.onChange,
        onClear = _a.onClear,
        triggerClose = _a.triggerClose,
        dropdownOpen = _a.dropdownOpen,
        emptyMessage = _a.emptyMessage,
        selectedItems = _a.selectedItems,
        disabledItems = _a.disabledItems,
        tooltipItems = _a.tooltipItems,
        activeItem = _a.activeItem,
        itemsDisplayCount = _a.itemsDisplayCount,
        itemHeight = _a.itemHeight,
        otherProps = __rest(_a, ["className", "itemComponent", "emptyComponent", "items", "hasSearch", "searchPlaceholder", "pagination", "keepOpen", "onSelect", "onSearch", "onSuggest", "onChange", "onClear", "triggerClose", "dropdownOpen", "emptyMessage", "selectedItems", "disabledItems", "tooltipItems", "activeItem", "itemsDisplayCount", "itemHeight"]);

    var SuggestionComponent = this.props.suggestionComponent;

    if (!dropdownOpen) {
      return null;
    }

    var searchValue = this.state.searchValue;
    var IS_EMPTY = items.length === 0;
    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$T.search,
      ref: this.searchRef
    }, hasSearch && /*#__PURE__*/React.createElement(FieldText, {
      input: this.getInput(),
      meta: {
        error: null,
        touched: true
      },
      small: true,
      icon: "search",
      placeholder: searchPlaceholder
    })), /*#__PURE__*/React.createElement("div", null, hasSearch && typeof SuggestionComponent === 'function' && /*#__PURE__*/React.createElement(SuggestionComponent, {
      searched: searchValue,
      onSuggest: onSuggest,
      triggerClose: triggerClose,
      clearSearch: this.clearSearch,
      items: items
    }), !IS_EMPTY && /*#__PURE__*/React.createElement(DropdownInfinite, {
      ref: this.listRef,
      pagination: pagination,
      items: items,
      onSelect: this.onSelect,
      onChange: this.onChange,
      clearSearch: this.clearSearch,
      selectedItems: selectedItems,
      disabledItems: disabledItems,
      itemComponent: ItemComponent,
      tooltipItems: tooltipItems,
      itemsDisplayCount: itemsDisplayCount,
      itemHeight: itemHeight,
      activeItem: activeItem
    }), IS_EMPTY && typeof EmptyComponent === 'function' && /*#__PURE__*/React.createElement(EmptyComponent, {
      label: emptyMessage || ''
    })), typeof onClear === 'function' && /*#__PURE__*/React.createElement("div", {
      className: styles$T.selectionActions
    }, /*#__PURE__*/React.createElement(Button$2, {
      variant: "secondary",
      disabled: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) === 0,
      onClick: onClear
    }, "Clear")), !!pagination && !pagination.infinite && /*#__PURE__*/React.createElement("div", {
      className: styles$T.pagination
    }, /*#__PURE__*/React.createElement(Button$2, {
      variant: "secondary",
      disabled: !pagination.previousEnable,
      onClick: pagination.onPrevious
    }, "Prev page"), /*#__PURE__*/React.createElement(Button$2, {
      variant: "secondary",
      disabled: !pagination.nextEnable,
      onClick: pagination.onNext
    }, "Next page")));
  };

  return DropdownSelectContainer;
}(Component);

var DropdownSelect =
/** @class */
function (_super) {
  __extends(DropdownSelect, _super);

  function DropdownSelect() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DropdownSelect.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        items = _a.items,
        onSelect = _a.onSelect,
        onChange = _a.onChange,
        onSearch = _a.onSearch,
        onClear = _a.onClear,
        onKeyDown = _a.onKeyDown,
        hasSearch = _a.hasSearch,
        _b = _a.searchPlaceholder,
        searchPlaceholder = _b === void 0 ? 'Search...' : _b,
        onSuggest = _a.onSuggest,
        keepOpen = _a.keepOpen,
        itemComponent = _a.itemComponent,
        suggestionComponent = _a.suggestionComponent,
        children = _a.children,
        buttonProps = _a.buttonProps,
        dropdownProps = _a.dropdownProps,
        containerProps = _a.containerProps,
        pagination = _a.pagination,
        emptyComponent = _a.emptyComponent,
        emptyMessage = _a.emptyMessage,
        selectedItems = _a.selectedItems,
        disabledItems = _a.disabledItems,
        tooltipItems = _a.tooltipItems,
        activeItem = _a.activeItem,
        itemsDisplayCount = _a.itemsDisplayCount,
        itemHeight = _a.itemHeight,
        otherProps = __rest(_a, ["className", "items", "onSelect", "onChange", "onSearch", "onClear", "onKeyDown", "hasSearch", "searchPlaceholder", "onSuggest", "keepOpen", "itemComponent", "suggestionComponent", "children", "buttonProps", "dropdownProps", "containerProps", "pagination", "emptyComponent", "emptyMessage", "selectedItems", "disabledItems", "tooltipItems", "activeItem", "itemsDisplayCount", "itemHeight"]);

    return /*#__PURE__*/React.createElement(DropdownButton, __assign({}, otherProps, {
      className: className,
      buttonProps: __assign({
        variant: 'secondary'
      }, buttonProps),
      dropdownProps: dropdownProps,
      dropdown: /*#__PURE__*/React.createElement(DropdownButtonContext.Consumer, null, function (_a) {
        var toggleDropdown = _a.toggleDropdown,
            dropdownOpen = _a.dropdownOpen;
        return /*#__PURE__*/React.createElement(DropdownSelectContainer, __assign({}, containerProps, {
          items: items,
          itemComponent: itemComponent,
          hasSearch: hasSearch,
          searchPlaceholder: searchPlaceholder,
          suggestionComponent: suggestionComponent,
          onSuggest: onSuggest,
          keepOpen: keepOpen,
          onSearch: onSearch,
          onSelect: onSelect,
          onChange: onChange,
          onClear: onClear,
          onKeyDown: onKeyDown,
          triggerClose: toggleDropdown,
          dropdownOpen: dropdownOpen,
          pagination: pagination,
          emptyComponent: emptyComponent,
          emptyMessage: emptyMessage,
          selectedItems: selectedItems,
          disabledItems: disabledItems,
          tooltipItems: tooltipItems,
          activeItem: activeItem,
          itemsDisplayCount: itemsDisplayCount,
          itemHeight: itemHeight
        }));
      })
    }), children);
  };

  DropdownSelect.defaultProps = {
    className: '',
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: true,
    hasSearch: false,
    searchPlaceholder: 'Search...',
    pagination: false,
    keepOpen: false,
    onSearch: function onSearch() {
      /* do nothing */
    },
    onSuggest: function onSuggest() {
      /* do nothing */
    },
    onChange: function onChange() {
      /* do nothing */
    },
    onSelect: function onSelect() {
      /* do nothing */
    },
    onToggle: function onToggle() {
      /* do nothing */
    },
    onKeyDown: function onKeyDown() {
      /* do nothing */
    },
    emptyComponent: EmptySelectItem,
    emptyMessage: 'No items found',
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  return DropdownSelect;
}(PureComponent);

var css_248z$10 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.components--fieldTextDropdown__root:focus, .components--fieldTextDropdown__root:hover {\n  background-color: #e7ecf3; }\n\n.components--fieldTextDropdown__angleDown {\n  font-size: 16px;\n  margin-right: -4px;\n  margin-left: 2px;\n  margin-top: 2px; }\n";
var styles$U = {"root":"components--fieldTextDropdown__root","angleDown":"components--fieldTextDropdown__angleDown"};
styleInject(css_248z$10);

function FieldTextDropdown(_a) {
  var className = _a.className,
      dropdownProps = __rest(_a, ["className"]);

  if (isEmpty(dropdownProps)) return null;
  var rootClass = classnames(styles$U.root, className);
  return /*#__PURE__*/React.createElement(DropdownSelect, __assign({}, omit(dropdownProps, 'meta'), {
    noStyle: true,
    itemComponent: SelectItem
  }), /*#__PURE__*/React.createElement("button", {
    className: rootClass,
    disabled: dropdownProps.meta.disabled
  }, /*#__PURE__*/React.createElement("span", null, dropdownProps.meta.selectedValue), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
    name: "angle-down",
    className: classnames('icon-vertical-fix', styles$U.angleDown)
  })));
}

var css_248z$11 = "@-webkit-keyframes fieldText--fieldText__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldText--fieldText__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldText--fieldText__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldText--fieldText__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldText--fieldText__wrap {\n  width: 100%;\n  display: flex;\n  position: relative; }\n\n.fieldText--fieldText__input {\n  border: 1px solid #e3e4e6;\n  border-radius: 6px;\n  height: 40px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  display: block;\n  width: 100%;\n  min-width: 0;\n  outline: none;\n  transition: all 0.15s ease-out; }\n  .fieldText--fieldText__input::-moz-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldText--fieldText__input:-ms-input-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldText--fieldText__input::placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldText--fieldText__input::-ms-input-placeholder {\n    color: #bbb; }\n  .fieldText--fieldText__rootWithPrefix .fieldText--fieldText__input {\n    border-radius: 0 6px 6px 0; }\n  .fieldText--fieldText__rootWithSuffix .fieldText--fieldText__input {\n    border-radius: 6px 0 0 6px;\n    text-align: right; }\n  .fieldText--fieldText__rootWithSuffix.fieldText--fieldText__rootWithPrefix .fieldText--fieldText__input {\n    border-radius: 0;\n    text-align: left; }\n  .fieldText--fieldText__rootWithDropdownPrefix .fieldText--fieldText__input {\n    border-radius: 6px 0 0 6px;\n    border-radius: 0 6px 6px 0;\n    text-align: left; }\n  .fieldText--fieldText__rootWithDropdownSuffix .fieldText--fieldText__input {\n    border-radius: 6px 0 0 6px;\n    text-align: left; }\n  .fieldText--fieldText__rootIsSmall .fieldText--fieldText__input {\n    height: 32px; }\n\n.fieldText--fieldText__prefix,\n.fieldText--fieldText__suffix {\n  background: #e3e4e6;\n  height: 40px;\n  border-radius: 6px 0 0 6px;\n  line-height: 40px;\n  padding: 0 8px;\n  font-size: 14px;\n  color: #7a7a7a;\n  font-weight: 600; }\n  .fieldText--fieldText__rootIsSmall .fieldText--fieldText__prefix, .fieldText--fieldText__rootIsSmall\n  .fieldText--fieldText__suffix {\n    height: 32px; }\n\n.fieldText--fieldText__suffix {\n  border-radius: 0 6px 6px 0; }\n\n.fieldText--fieldText__selection {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  border-radius: 6px;\n  box-sizing: border-box; }\n  .fieldText--fieldText__input:focus + .fieldText--fieldText__selection {\n    border: 1px solid #5644d8;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n    .fieldText--fieldText__rootHasError .fieldText--fieldText__input:focus + .fieldText--fieldText__selection {\n      border-color: #d8484d;\n      box-shadow: 0 0 0 3px rgba(216, 72, 77, 0.3); }\n\n.fieldText--fieldText__inputDropdownButtonPrefix {\n  min-width: 92px;\n  height: 40px;\n  padding: 8px;\n  color: #45587c;\n  background-color: #f5f7fa;\n  border: 1px solid #e3e4e6;\n  outline: none;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px 0 0 6px;\n  border-right: none; }\n\n.fieldText--fieldText__inputDropdownButtonSuffix {\n  min-width: 92px;\n  height: 40px;\n  padding: 8px;\n  color: #45587c;\n  background-color: #f5f7fa;\n  border: 1px solid #e3e4e6;\n  outline: none;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0 6px 6px 0;\n  border-left: none; }\n\n.fieldText--fieldText__icon {\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  color: #000; }\n  .fieldText--fieldText__rootIsSmall .fieldText--fieldText__icon {\n    top: 8px; }\n";
var styles$V = {"wrap":"fieldText--fieldText__wrap","input":"fieldText--fieldText__input","rootWithPrefix":"fieldText--fieldText__rootWithPrefix","rootWithSuffix":"fieldText--fieldText__rootWithSuffix","rootWithDropdownPrefix":"fieldText--fieldText__rootWithDropdownPrefix","rootWithDropdownSuffix":"fieldText--fieldText__rootWithDropdownSuffix","rootIsSmall":"fieldText--fieldText__rootIsSmall","prefix":"fieldText--fieldText__prefix","suffix":"fieldText--fieldText__suffix","selection":"fieldText--fieldText__selection","rootHasError":"fieldText--fieldText__rootHasError","inputDropdownButtonPrefix":"fieldText--fieldText__inputDropdownButtonPrefix","inputDropdownButtonSuffix":"fieldText--fieldText__inputDropdownButtonSuffix","icon":"fieldText--fieldText__icon","wiggle":"fieldText--fieldText__wiggle","spin":"fieldText--fieldText__spin"};
styleInject(css_248z$11);

var FieldText =
/** @class */
function (_super) {
  __extends(FieldText, _super);

  function FieldText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldText.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return (meta === null || meta === void 0 ? void 0 : meta.touched) === undefined || meta.touched === true;
    }

    return false;
  };

  FieldText.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  FieldText.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        input = _b.input,
        label = _b.label,
        meta = _b.meta,
        placeholder = _b.placeholder,
        required = _b.required,
        disabled = _b.disabled,
        type = _b.type,
        min = _b.min,
        max = _b.max,
        step = _b.step,
        prefix = _b.prefix,
        suffix = _b.suffix,
        dropdown = _b.dropdown,
        icon = _b.icon,
        small = _b.small,
        helpIconText = _b.helpIconText,
        helpIconTitle = _b.helpIconTitle,
        onChangeAction = _b.onChangeAction,
        otherProps = __rest(_b, ["className", "input", "label", "meta", "placeholder", "required", "disabled", "type", "min", "max", "step", "prefix", "suffix", "dropdown", "icon", "small", "helpIconText", "helpIconTitle", "onChangeAction"]);

    var range = {};
    if (min) range.min = min;
    if (max) range.max = max;
    if (step) range.step = step;
    var rootClass = classnames((_a = {}, _a[styles$V.rootHasError] = this.hasError(), _a[styles$V.rootWithPrefix] = !!prefix, _a[styles$V.rootWithSuffix] = !!suffix, _a[styles$V.rootWithDropdownPrefix] = (dropdown === null || dropdown === void 0 ? void 0 : dropdown.meta.position) === 'prefix', _a[styles$V.rootWithDropdownSuffix] = (dropdown === null || dropdown === void 0 ? void 0 : dropdown.meta.position) === 'suffix', _a[styles$V.rootIsSmall] = !!small, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      required: required,
      fieldId: input.name,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$V.wrap
    }, !!prefix && /*#__PURE__*/React.createElement("div", {
      className: styles$V.prefix
    }, prefix), (dropdown === null || dropdown === void 0 ? void 0 : dropdown.meta.position) === 'prefix' && /*#__PURE__*/React.createElement(FieldTextDropdown, __assign({}, dropdown, {
      className: styles$V.inputDropdownButtonPrefix
    })), /*#__PURE__*/React.createElement("input", __assign({
      className: styles$V.input,
      type: type || 'text',
      dir: "auto"
    }, range, input, {
      id: input.name,
      onChange: function onChange(e) {
        if (typeof onChangeAction === 'function') {
          onChangeAction(e);
        }

        input.onChange(e);
      },
      placeholder: placeholder,
      disabled: disabled
    })), /*#__PURE__*/React.createElement("span", {
      className: styles$V.selection
    }), !!icon && !suffix && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: icon,
      className: styles$V.icon
    }), !!suffix && /*#__PURE__*/React.createElement("div", {
      className: styles$V.suffix
    }, suffix), (dropdown === null || dropdown === void 0 ? void 0 : dropdown.meta.position) === 'suffix' && /*#__PURE__*/React.createElement(FieldTextDropdown, __assign({}, dropdown, {
      className: styles$V.inputDropdownButtonSuffix
    })))));
  };

  return FieldText;
}(PureComponent);

var css_248z$12 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.inputWrapper--inputWrapper__root {\n  width: 100%;\n  display: flex;\n  position: relative;\n  border: 1px solid #e7ecf3;\n  border-radius: 4px;\n  height: 40px;\n  box-sizing: border-box;\n  background-color: #ffffff; }\n  .inputWrapper--inputWrapper__root:hover {\n    border: 1px solid #d7dfea; }\n  .inputWrapper--inputWrapper__rootDisabled {\n    pointer-events: none;\n    opacity: 0.5; }\n\n.inputWrapper--inputWrapper__rootActive,\n.inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__root:hover,\n.inputWrapper--inputWrapper__root:focus-within {\n  border: 1px solid #5644d8;\n  box-shadow: 0 0 0 2px #c1b9f8; }\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__rootHasError,\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__root:hover.inputWrapper--inputWrapper__rootHasError,\n  .inputWrapper--inputWrapper__root:focus-within.inputWrapper--inputWrapper__rootHasError {\n    border-color: #c11d1d;\n    box-shadow: 0 0 0 2px #f5cccb; }\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__rootHasWarning,\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__root:hover.inputWrapper--inputWrapper__rootHasWarning,\n  .inputWrapper--inputWrapper__root:focus-within.inputWrapper--inputWrapper__rootHasWarning {\n    border-color: #e56500;\n    box-shadow: 0 0 0 2px #ffdcaf; }\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__rootHasSuccess,\n  .inputWrapper--inputWrapper__rootActive.inputWrapper--inputWrapper__root:hover.inputWrapper--inputWrapper__rootHasSuccess,\n  .inputWrapper--inputWrapper__root:focus-within.inputWrapper--inputWrapper__rootHasSuccess {\n    border-color: #23924e;\n    box-shadow: 0 0 0 2px #c6f5d6; }\n\n.inputWrapper--inputWrapper__rootHasSuccess,\n.inputWrapper--inputWrapper__rootHasSuccess.inputWrapper--inputWrapper__root:hover {\n  border: 1px solid #23924e; }\n\n.inputWrapper--inputWrapper__rootHasWarning,\n.inputWrapper--inputWrapper__rootHasWarning.inputWrapper--inputWrapper__root:hover {\n  border: 1px solid #e56500; }\n\n.inputWrapper--inputWrapper__rootHasError,\n.inputWrapper--inputWrapper__rootHasError.inputWrapper--inputWrapper__root:hover {\n  border: 1px solid #c11d1d; }\n\n.inputWrapper--inputWrapper__inputWrapper {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 0;\n  border-radius: 4px;\n  outline: none;\n  transition: all 0.15s ease-out; }\n  .inputWrapper--inputWrapper__rootWithPrefix .inputWrapper--inputWrapper__inputWrapper {\n    border-radius: 0 4px 4px 0; }\n  .inputWrapper--inputWrapper__rootWithSuffix .inputWrapper--inputWrapper__inputWrapper {\n    border-radius: 4px 0 0 4px; }\n  .inputWrapper--inputWrapper__rootWithSuffix.inputWrapper--inputWrapper__rootWithPrefix .inputWrapper--inputWrapper__inputWrapper {\n    border-radius: 0; }\n\n.inputWrapper--inputWrapper__suffixesContainer {\n  position: relative;\n  display: flex; }\n\n.inputWrapper--inputWrapper__prefix,\n.inputWrapper--inputWrapper__suffix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  padding: 12px;\n  border: 0;\n  box-sizing: border-box;\n  color: #45587c;\n  background-color: #f5f7fa;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  white-space: nowrap; }\n  .inputWrapper--inputWrapper__prefixDropdownButton,\n  .inputWrapper--inputWrapper__suffixDropdownButton {\n    min-width: 40px;\n    height: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px; }\n  .inputWrapper--inputWrapper__prefixButton,\n  .inputWrapper--inputWrapper__suffixButton {\n    min-width: 40px;\n    height: 100%;\n    transition: none; }\n    .inputWrapper--inputWrapper__prefixButton:focus, .inputWrapper--inputWrapper__prefixButton:hover,\n    .inputWrapper--inputWrapper__suffixButton:focus,\n    .inputWrapper--inputWrapper__suffixButton:hover {\n      background-color: #e7ecf3; }\n    .inputWrapper--inputWrapper__prefixButton:active,\n    .inputWrapper--inputWrapper__suffixButton:active {\n      background-color: #d7dfea; }\n  .inputWrapper--inputWrapper__rootDisabled .inputWrapper--inputWrapper__prefixButton, .inputWrapper--inputWrapper__rootDisabled\n  .inputWrapper--inputWrapper__suffixButton {\n    opacity: 1; }\n\n.inputWrapper--inputWrapper__prefix {\n  border-radius: 4px 0 0 4px;\n  border-right: 1px solid #e7ecf3; }\n\n.inputWrapper--inputWrapper__suffix {\n  border-radius: 0 4px 4px 0;\n  border-left: 1px solid #e7ecf3; }\n\n.inputWrapper--inputWrapper__icon {\n  position: absolute;\n  top: 12px;\n  left: -28px; }\n  .inputWrapper--inputWrapper__rootHasError .inputWrapper--inputWrapper__icon {\n    color: #c11d1d; }\n  .inputWrapper--inputWrapper__rootHasWarning .inputWrapper--inputWrapper__icon {\n    color: #e56500; }\n  .inputWrapper--inputWrapper__rootHasSuccess .inputWrapper--inputWrapper__icon {\n    color: #23924e; }\n";
var styles$W = {"root":"inputWrapper--inputWrapper__root","rootDisabled":"inputWrapper--inputWrapper__rootDisabled","rootActive":"inputWrapper--inputWrapper__rootActive","rootHasError":"inputWrapper--inputWrapper__rootHasError","rootHasWarning":"inputWrapper--inputWrapper__rootHasWarning","rootHasSuccess":"inputWrapper--inputWrapper__rootHasSuccess","inputWrapper":"inputWrapper--inputWrapper__inputWrapper","rootWithPrefix":"inputWrapper--inputWrapper__rootWithPrefix","rootWithSuffix":"inputWrapper--inputWrapper__rootWithSuffix","suffixesContainer":"inputWrapper--inputWrapper__suffixesContainer","prefix":"inputWrapper--inputWrapper__prefix","suffix":"inputWrapper--inputWrapper__suffix","prefixDropdownButton":"inputWrapper--inputWrapper__prefixDropdownButton","suffixDropdownButton":"inputWrapper--inputWrapper__suffixDropdownButton","prefixButton":"inputWrapper--inputWrapper__prefixButton","suffixButton":"inputWrapper--inputWrapper__suffixButton","icon":"inputWrapper--inputWrapper__icon"};
styleInject(css_248z$12);

var inputWrapperTestId = 'inputWrapper';

var InputWrapper =
/** @class */
function (_super) {
  __extends(InputWrapper, _super);

  function InputWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputWrapper.prototype.renderIcon = function () {
    var icon = this.props.icon;

    if (!icon) {
      return null;
    }

    return /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$W.icon,
      name: icon
    });
  };

  InputWrapper.prototype.isButtonAddon = function (addon) {
    return !!addon && 'type' in addon && addon.type === 'button';
  };

  InputWrapper.prototype.isDropdownAddon = function (addon) {
    return !!addon && 'type' in addon && addon.type === 'dropdown';
  };

  InputWrapper.prototype.isCustomAddon = function (addon) {
    return !!addon && 'type' in addon && (!addon.type || addon.type === 'custom');
  };

  InputWrapper.prototype.renderAddon = function (position) {
    var _a, _b;

    var addon = this.props[position];
    var disabled = this.props.disabled;

    if (!addon) {
      return null;
    }

    var element;

    if (_typeof(addon) !== 'object' || !('type' in addon)) {
      element = /*#__PURE__*/React.createElement("div", {
        className: classnames(styles$W[position])
      }, addon);
    } else if (this.isCustomAddon(addon)) {
      element = addon.noWrap ? addon.value : /*#__PURE__*/React.createElement("div", {
        className: styles$W[position]
      }, addon.value);
    } else if (this.isButtonAddon(addon)) {
      var _c = addon.button,
          className = _c.className,
          otherProps = __rest(_c, ["className"]);

      element = /*#__PURE__*/React.createElement(IconButton$1, __assign({
        className: classnames((_a = {}, _a[styles$W[position]] = !addon.noStyle, _a[styles$W[position + "Button"]] = !addon.noStyle, _a), className)
      }, otherProps, {
        disabled: disabled
      }));
    } else if (this.isDropdownAddon(addon)) {
      var _d = addon.dropdown,
          className = _d.className,
          meta = _d.meta,
          otherProps = __rest(_d, ["className", "meta"]);

      element = /*#__PURE__*/React.createElement(FieldTextDropdown, __assign({}, otherProps, {
        meta: __assign(__assign({}, meta), {
          disabled: disabled
        }),
        className: classnames((_b = {}, _b[styles$W[position]] = !addon.noStyle, _b[styles$W[position + "DropdownButton"]] = !addon.noStyle, _b), className)
      }));
    }

    return element;
  };

  InputWrapper.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        disabled = _b.disabled,
        active = _b.active,
        status = _b.status,
        prefix = _b.prefix,
        suffix = _b.suffix,
        icon = _b.icon,
        children = _b.children,
        otherProps = __rest(_b, ["className", "disabled", "active", "status", "prefix", "suffix", "icon", "children"]);

    var rootClass = classnames(styles$W.root, (_a = {}, _a[styles$W.rootActive] = active, _a[styles$W.rootDisabled] = disabled, _a[styles$W.rootHasError] = status === 'error', _a[styles$W.rootHasWarning] = status === 'warning', _a[styles$W.rootHasSuccess] = status === 'success', _a[styles$W.rootWithPrefix] = !!prefix, _a[styles$W.rootWithSuffix] = !!suffix, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({
      "data-testid": inputWrapperTestId,
      className: rootClass
    }, otherProps), this.renderAddon('prefix'), /*#__PURE__*/React.createElement("div", {
      className: styles$W.inputWrapper
    }, children), /*#__PURE__*/React.createElement("span", {
      className: styles$W.suffixesContainer
    }, this.renderIcon(), this.renderAddon('suffix')));
  };

  return InputWrapper;
}(PureComponent);

var css_248z$13 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tag--tag__tag {\n  border: 1px solid #e7ecf3;\n  height: 24px;\n  border-radius: 24px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 12px;\n  color: #132243;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 24px;\n  overflow: hidden;\n  max-width: 100%;\n  background-color: #ffffff; }\n  .tag--tag__tagLight {\n    color: #ffffff; }\n  .tag--tag__tagNoBorder {\n    border: 0;\n    line-height: 24px; }\n  .tag--tag__tagDisabled {\n    opacity: 50%;\n    cursor: not-allowed; }\n\n.tag--tag__tagName {\n  display: inline-block; }\n  .tag--tag__tagNameTruncated {\n    word-break: break-all;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 110px;\n    min-width: 10px; }\n\n.tag--tag__icon {\n  display: block;\n  height: 8px;\n  width: 8px;\n  border-radius: 4px;\n  margin-right: 8px;\n  margin-left: 0;\n  flex-shrink: 0; }\n  .tag--tag__tagNoBorder + .tag--tag__tagNoBorder .tag--tag__icon {\n    margin-left: 8px; }\n\n.tag--tag__deleteButton {\n  border: 0;\n  outline: none;\n  background: none;\n  margin: 0;\n  padding: 0 4px;\n  display: inline-flex;\n  margin-right: -8px;\n  color: #8193b0;\n  transition: color 0.15s ease-in-out; }\n  .tag--tag__deleteButton:hover:not(.tag--tag__deleteButtonDisabled) {\n    background-color: transparent; }\n  .tag--tag__deleteButton .tag--tag__deleteIcon {\n    color: #8193b0;\n    border-radius: 2px;\n    background: transparent;\n    transition: background 0.15s ease-in-out; }\n    .tag--tag__deleteButton .tag--tag__deleteIcon:hover {\n      background: #e7ecf3; }\n";
var styles$X = {"tag":"tag--tag__tag","tagLight":"tag--tag__tagLight","tagNoBorder":"tag--tag__tagNoBorder","tagDisabled":"tag--tag__tagDisabled","tagName":"tag--tag__tagName","tagNameTruncated":"tag--tag__tagNameTruncated","icon":"tag--tag__icon","deleteButton":"tag--tag__deleteButton","deleteButtonDisabled":"tag--tag__deleteButtonDisabled","deleteIcon":"tag--tag__deleteIcon"};
styleInject(css_248z$13);

var Tag =
/** @class */
function (_super) {
  __extends(Tag, _super);

  function Tag() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tag.prototype.render = function () {
    var _a, _b, _c;

    var _d = this.props,
        className = _d.className,
        deleteButtonClassName = _d.deleteButtonClassName,
        children = _d.children,
        onDelete = _d.onDelete,
        color = _d.color,
        tip = _d.tip,
        light = _d.light,
        noBorder = _d.noBorder,
        _e = _d.noTruncation,
        noTruncation = _e === void 0 ? false : _e,
        disabled = _d.disabled,
        otherProps = __rest(_d, ["className", "deleteButtonClassName", "children", "onDelete", "color", "tip", "light", "noBorder", "noTruncation", "disabled"]);

    var rootClass = classnames((_a = {}, _a[styles$X.tag] = true, _a[styles$X.tagLight] = light, _a[styles$X.tagNoBorder] = noBorder, _a[styles$X.tagDisabled] = disabled, _a), className);
    var tagNameClass = classnames((_b = {}, _b[styles$X.tagName] = true, _b[styles$X.tagNameTruncated] = !noTruncation, _b));
    var deleteButtonClass = classnames(styles$X.deleteButton, (_c = {}, _c[styles$X.deleteDisabled] = disabled, _c), deleteButtonClassName);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      "data-tip": tip
    }), color && /*#__PURE__*/React.createElement("span", {
      className: styles$X.icon,
      style: {
        backgroundColor: color
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: tagNameClass
    }, children), !!onDelete && /*#__PURE__*/React.createElement("button", {
      className: deleteButtonClass,
      type: "button",
      onClick: onDelete,
      disabled: disabled
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "close",
      className: styles$X.deleteIcon
    })));
  };

  return Tag;
}(PureComponent);

var css_248z$14 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.select--select__root {\n  position: relative;\n  border-radius: inherit; }\n  .select--select__rootDisabled {\n    pointer-events: none; }\n\n.select--select__inputWrapper {\n  height: auto;\n  min-height: 40px; }\n\n.select--select__control {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  min-height: 100%;\n  width: 100%;\n  min-width: 0;\n  border-radius: inherit;\n  outline: none;\n  padding: 4px;\n  box-sizing: border-box;\n  color: #132244;\n  font-family: Open Sans, Arial, sans-serif;\n  font-size: 14px;\n  letter-spacing: 0.16px;\n  line-height: 16px;\n  transition: all 0.15s ease-out; }\n  .select--select__control:hover, .select--select__control:focus-within {\n    cursor: pointer; }\n  .select--select__rootDisabled .select--select__control {\n    pointer-events: none; }\n  .select--select__rootHasIcon .select--select__control {\n    padding-right: 32px; }\n\n.select--select__selection {\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  align-items: center;\n  position: relative;\n  height: 100%; }\n\n.select--select__tag {\n  margin: 2px;\n  background-color: #f5f7fa;\n  cursor: default;\n  border: 1px solid #e7ecf3; }\n  .select--select__tagLimiter {\n    transition: background 0.15s ease-in-out; }\n    .select--select__tagLimiter:hover {\n      background: #e7ecf3;\n      cursor: pointer; }\n\n.select--select__text {\n  outline: 0;\n  margin-left: 4px; }\n  .select--select__rootSearchable.select--select__rootDropdownOpen .select--select__text {\n    color: #8294B0;\n    pointer-events: none; }\n  .select--select__rootIsSearching .select--select__text {\n    visibility: hidden; }\n\n.select--select__search {\n  flex-grow: 1;\n  border: 0;\n  box-shadow: none;\n  outline: none;\n  background-color: transparent;\n  padding: 0 4px;\n  margin: 0;\n  width: auto;\n  max-width: inherit;\n  cursor: pointer;\n  letter-spacing: 0.16px;\n  line-height: 16px; }\n  .select--select__rootSearchable .select--select__search {\n    cursor: text; }\n  .select--select__rootSearchable.select--select__rootSingle .select--select__search {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n  .select--select__search::-moz-placeholder {\n    color: #8294B0;\n    opacity: 1; }\n  .select--select__search:-ms-input-placeholder {\n    color: #8294B0;\n    opacity: 1; }\n  .select--select__search::placeholder {\n    color: #8294B0;\n    opacity: 1; }\n  .select--select__search::-ms-input-placeholder {\n    color: #8294B0; }\n  .select--select__search:focus {\n    outline: none; }\n\n.select--select__indicators {\n  display: flex;\n  align-items: center;\n  align-self: flex-start;\n  margin-top: 3px; }\n\n.select--select__spinner {\n  margin-right: 4px; }\n\n.select--select__clearIndicator,\n.select--select__dropdownIndicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  padding: 0;\n  color: #45587c; }\n\n.select--select__dropdown:not(.select--select__dropdownFixed) {\n  width: 100%; }\n\n.select--select__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-top: 1px solid #e7ecf3; }\n";
var styles$Y = {"root":"select--select__root","rootDisabled":"select--select__rootDisabled","inputWrapper":"select--select__inputWrapper","control":"select--select__control","rootHasIcon":"select--select__rootHasIcon","selection":"select--select__selection","tag":"select--select__tag","tagLimiter":"select--select__tagLimiter","text":"select--select__text","rootSearchable":"select--select__rootSearchable","rootDropdownOpen":"select--select__rootDropdownOpen","rootIsSearching":"select--select__rootIsSearching","search":"select--select__search","rootSingle":"select--select__rootSingle","indicators":"select--select__indicators","spinner":"select--select__spinner","clearIndicator":"select--select__clearIndicator","dropdownIndicator":"select--select__dropdownIndicator","dropdown":"select--select__dropdown","dropdownFixed":"select--select__dropdownFixed","pagination":"select--select__pagination"};
styleInject(css_248z$14);

var Select =
/** @class */
function (_super) {
  __extends(Select, _super);

  function Select(props) {
    var _this = _super.call(this, props) || this;

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleDropdown = _this.handleDropdown.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRemove = _this.handleRemove.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    _this.resolveItem = _this.resolveItem.bind(_this);
    _this.controlRef = /*#__PURE__*/React.createRef();
    _this.searchRef = /*#__PURE__*/React.createRef();
    _this.listRef = /*#__PURE__*/React.createRef();

    var selectedItems = _this.initSelectedItems();

    var highlightedIndex = _this.initHighlightedIndex(selectedItems);

    _this.state = {
      dropdownOpen: false,
      search: '',
      selectedItems: selectedItems,
      highlightedIndex: highlightedIndex
    };
    return _this;
  }

  Select.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a, _b;

    var dropdownOpen = this.state.dropdownOpen;

    if (dropdownOpen !== prevState.dropdownOpen) {
      window[dropdownOpen ? 'addEventListener' : 'removeEventListener']('click', this.handleClickOutside);

      if (dropdownOpen) {
        (_a = this.searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        var highlightedIndex = this.initHighlightedIndex();
        this.highlightIndex(highlightedIndex, 'auto');
      } else {
        (_b = this.searchRef.current) === null || _b === void 0 ? void 0 : _b.blur();
      }
    }

    if (!isEqual(prevProps.selectedItems, this.props.selectedItems)) {
      this.setState({
        selectedItems: this.initSelectedItems()
      });
    }
  };

  Object.defineProperty(Select.prototype, "a11y", {
    get: function get() {
      var id = this.props.id;
      var highlightedIndex = this.state.highlightedIndex;
      var label = id + "-label";
      var dropdown = id + "-dropdown";
      var option = highlightedIndex !== null ? dropdown + "-option-" + highlightedIndex : '';
      return {
        label: label,
        dropdown: dropdown,
        option: option
      };
    },
    enumerable: false,
    configurable: true
  });

  Select.prototype.isItemIdType = function (item) {
    return typeof item === 'string' || typeof item === 'number';
  };

  Select.prototype.initSelectedItems = function () {
    var _a = this.props.selectedItems,
        selectedItems = _a === void 0 ? [] : _a;
    return selectedItems.map(this.resolveItem);
  };

  Select.prototype.initHighlightedIndex = function (selectedItems) {
    if (selectedItems === void 0) {
      selectedItems = this.state.selectedItems;
    }

    var _a = this.props,
        multiple = _a.multiple,
        items = _a.items,
        hideSelectedItems = _a.hideSelectedItems;

    if (!multiple && !hideSelectedItems && selectedItems.length) {
      var item = this.resolveItem(selectedItems[0]);
      return items.indexOf(item);
    }

    return null;
  };

  Select.prototype.resolveItem = function (item) {
    if (this.isItemIdType(item)) {
      var matchedItem = this.props.items.find(function (i) {
        return i.id === item;
      });
      return matchedItem;
    }

    return item;
  };

  Select.prototype.handleSearch = function (event) {
    var _this = this;

    var onSearch = this.props.onSearch;
    var value = event.target.value;
    this.setState({
      search: value
    }, function () {
      var _a;

      onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);

      if (value) {
        _this.highlightIndex(0);

        (_a = _this.listRef.current) === null || _a === void 0 ? void 0 : _a.goToTop();
      }
    });
  };

  Select.prototype.handleDropdown = function (action) {
    var _a, _b;

    if (action === void 0) {
      action = 'toggle';
    }

    var keepOpen = this.props.keepOpen;

    if (keepOpen) {
      return this.setState({
        dropdownOpen: true
      });
    }

    if (action === 'toggle') {
      (_a = this.controlRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      return this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }

    if (action === 'open') {
      return this.setState({
        dropdownOpen: true
      });
    }

    if (action === 'close' && this.state.dropdownOpen) {
      (_b = this.controlRef.current) === null || _b === void 0 ? void 0 : _b.blur();
      return this.setState({
        dropdownOpen: false,
        search: ''
      });
    }
  };

  Select.prototype.handleClickOutside = function (event) {
    if (!this.controlRef || !(event.target instanceof Node)) return;
    var control = this.controlRef.current;
    var target = event.target;

    if (target && target !== control && !(control === null || control === void 0 ? void 0 : control.contains(target))) {
      this.handleDropdown('close');
    }
  };

  Select.prototype.highlightIndex = function (index, behavior) {
    var _this = this;

    if (behavior === void 0) {
      behavior = 'smooth';
    }

    this.setState({
      highlightedIndex: index
    }, function () {
      var _a, _b, _c, _d;

      if (index === null) return;
      var items = (_c = (_b = (_a = _this.listRef.current) === null || _a === void 0 ? void 0 : _a.listRef.current) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
      var itemEl = items[index];
      (_d = itemEl) === null || _d === void 0 ? void 0 : _d.scrollIntoView({
        behavior: behavior,
        block: 'nearest',
        inline: 'start'
      });
    });
  };

  Select.prototype.handleKeyDown = function (event) {
    var _a = this.state,
        search = _a.search,
        dropdownOpen = _a.dropdownOpen,
        highlightedIndex = _a.highlightedIndex,
        selectedItems = _a.selectedItems;
    var _b = this.props,
        multiple = _b.multiple,
        hideSelectedItems = _b.hideSelectedItems;
    var items = this.getAvailableItems();
    var escape = event.key === 'Escape';
    var enter = event.key === 'Enter';
    var arrowUp = event.key === 'ArrowUp';
    var arrowDown = event.key === 'ArrowDown';
    var backspace = event.key === 'Backspace';

    if (enter || arrowUp || arrowDown) {
      event.preventDefault();
    } // Open the dropdown


    if (arrowDown && !dropdownOpen) {
      event.preventDefault();
      return this.handleDropdown('open');
    } // Close the dropdown


    if (escape) {
      this.handleDropdown('close');
    } // Delete the last selected item


    if (backspace && multiple && !search) {
      var item = selectedItems[selectedItems.length - 1];
      if (item) this.handleRemove(item);
    } // Focus the first item


    if (arrowDown && highlightedIndex === null) {
      return this.highlightIndex(0);
    }

    if (highlightedIndex === null) return; // Go to the top of the list

    if (arrowDown && highlightedIndex === items.length - 1) {
      return this.highlightIndex(0);
    } // Move down the list


    if (arrowDown) {
      this.highlightIndex(highlightedIndex + 1);
    } // Move up the list


    if (arrowUp && highlightedIndex > 0) {
      this.highlightIndex(highlightedIndex - 1);
    } // Go to the bottom of the list


    if (arrowUp && highlightedIndex === 0) {
      this.highlightIndex(items.length - 1);
    } // Select or deselect an item


    if (enter) {
      var item = items[highlightedIndex];
      var isDisabled = item && this.isItemDisabled(item);

      if (item && !isDisabled) {
        this.handleSelect(item); // Highlight the next index depending on the current position

        var index = Math.min(hideSelectedItems ? highlightedIndex : highlightedIndex + 1, items.length - 2);
        this.highlightIndex(index);
      }
    }
  };

  Select.prototype.handleSelect = function (item) {
    var _a;

    var _b = this.props,
        multiple = _b.multiple,
        keepOpen = _b.keepOpen,
        onSelect = _b.onSelect;

    if (multiple) {
      var isSelected = this.isItemSelected(item);
      this.handleChange(item, !isSelected);
    } else {
      this.setState({
        selectedItems: [item],
        dropdownOpen: keepOpen !== null && keepOpen !== void 0 ? keepOpen : false
      });
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(item);
    }

    this.setState({
      search: ''
    });
    (_a = this.searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  Select.prototype.handleChange = function (item, checked) {
    var onChange = this.props.onChange;
    var selectedItems = this.state.selectedItems;
    this.setState({
      selectedItems: checked ? __spreadArrays(selectedItems, [item]) : selectedItems.filter(function (i) {
        return i.id !== item.id;
      })
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(item, checked);
  };

  Select.prototype.handleRemove = function (item, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.handleChange(item, false);
  };

  Select.prototype.handleClear = function (event) {
    event.stopPropagation();
    var _a = this.props,
        multiple = _a.multiple,
        onClear = _a.onClear,
        onChange = _a.onChange;
    var selectedItems = this.state.selectedItems;
    onClear === null || onClear === void 0 ? void 0 : onClear();

    if (multiple) {
      selectedItems.forEach(function (item) {
        return onChange === null || onChange === void 0 ? void 0 : onChange(item, false);
      });
    }

    this.setState({
      selectedItems: []
    });
  };

  Select.prototype.getPlaceholder = function () {
    return !this.state.selectedItems.length ? this.props.placeholder : '';
  };

  Select.prototype.getInputSize = function () {
    var _a, _b;

    var defaultSize = 5;

    if (this.state.search) {
      return this.state.search.length;
    }

    if (!((_a = this.state.selectedItems) === null || _a === void 0 ? void 0 : _a.length)) {
      return ((_b = this.props.placeholder) === null || _b === void 0 ? void 0 : _b.length) || defaultSize;
    }

    return defaultSize;
  };

  Select.prototype.getItemName = function (item) {
    return item.name.toString().trim();
  };

  Select.prototype.getAvailableItems = function () {
    var _this = this;

    var search = this.state.search;
    var _a = this.props,
        items = _a.items,
        hideSelectedItems = _a.hideSelectedItems,
        onSearch = _a.onSearch,
        searchFn = _a.searchFn;
    var regexp = new RegExp(search, 'i');
    var availableItems = items.filter(function (item) {
      var conditions = [];

      if (search && !onSearch) {
        conditions.push(searchFn ? searchFn(item, search) : regexp.test(_this.getItemName(item)));
      }

      if (hideSelectedItems) {
        conditions.push(!_this.isItemSelected(item));
      }

      return conditions.every(function (condition) {
        return condition;
      });
    });
    return availableItems;
  };

  Select.prototype.isItemSelected = function (item) {
    return this.state.selectedItems.some(function (selectedItem) {
      return selectedItem.id === item.id;
    });
  };

  Select.prototype.isItemDisabled = function (item) {
    var _a;

    return (_a = this.props.disabledItems) === null || _a === void 0 ? void 0 : _a.includes(item.id);
  };

  Select.prototype.isEmpty = function () {
    return this.state.selectedItems.length === 0;
  };

  Select.prototype.renderHiddenItems = function () {
    var _this = this;

    var limit = this.props.limit;
    var selectedItems = this.state.selectedItems;

    if (limit && limit > 0) {
      return /*#__PURE__*/React.createElement(FlexBox, {
        flexDirection: "column"
      }, selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.slice(limit).map(function (item) {
        return /*#__PURE__*/React.createElement(FlexBox, {
          key: item.id,
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item"
        }, /*#__PURE__*/React.createElement(Box, {
          margin: "0 400 0 0"
        }, _this.getItemName(item)), /*#__PURE__*/React.createElement(IconButton$1, {
          icon: "close",
          variant: "tertiary",
          onClick: function onClick(event) {
            return _this.handleRemove(item, event);
          }
        }));
      }));
    }
  };

  Select.prototype.renderSelection = function (item) {
    var _a, _b, _c;

    return (_c = (_b = (_a = this.props).renderSelection) === null || _b === void 0 ? void 0 : _b.call(_a, item)) !== null && _c !== void 0 ? _c : this.getItemName(item);
  };

  Select.prototype.renderMultipleSelection = function () {
    var _this = this;

    var selectedItems = this.state.selectedItems;
    var limit = this.props.limit || selectedItems.length;
    var isLimited = limit < selectedItems.length;
    var tags = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.slice(0, limit).map(function (item) {
      var label = _this.renderSelection(item);

      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        "data-testid": "select-selection"
      }, /*#__PURE__*/React.createElement(Tag, {
        className: styles$Y.tag,
        deleteButtonClassName: styles$Y.tagButton,
        onDelete: function onDelete(event) {
          return _this.handleRemove(item, event);
        },
        color: item.color,
        noTruncation: true,
        "data-testid": "select-tag"
      }, label));
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, tags, isLimited && /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(event) {
        return event.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: this.renderHiddenItems(),
      requireClick: true,
      "data-testid": "select-limiter"
    }, /*#__PURE__*/React.createElement(Tag, {
      className: classnames(styles$Y.tag, styles$Y.tagLimiter),
      noTruncation: true
    }, "+", selectedItems.length - limit))));
  };

  Select.prototype.renderSingleSelection = function () {
    var _a = this.state,
        search = _a.search,
        selectedItems = _a.selectedItems;
    var item = selectedItems[0]; // We render an empty element when there is no selection, so that
    // the absolutely positioned search input is displayed correctly

    var placeholder = /*#__PURE__*/React.createElement("span", {
      style: {
        width: 0
      },
      "data-testid": "select-selection-empty"
    }, "\xA0");
    if (!item) return placeholder;
    return /*#__PURE__*/React.createElement("span", {
      className: styles$Y.text,
      "aria-hidden": !!search,
      "data-testid": "select-selection"
    }, this.renderSelection(item));
  };

  Select.prototype.renderSearch = function () {
    var searchable = this.props.searchable;

    if (!searchable && !this.isEmpty()) {
      return null;
    }

    return /*#__PURE__*/React.createElement("input", {
      className: styles$Y.search,
      ref: this.searchRef,
      tabIndex: -1,
      onFocus: function onFocus(event) {
        return event.stopPropagation();
      },
      value: this.state.search,
      size: this.getInputSize(),
      onChange: this.handleSearch,
      placeholder: this.getPlaceholder(),
      autoComplete: "off",
      readOnly: !searchable,
      "aria-autocomplete": "list",
      "aria-controls": this.a11y.dropdown,
      "aria-labelledby": this.a11y.label,
      "data-testid": "select-input"
    });
  };

  Select.prototype.renderDropdown = function () {
    var _a;

    var _b;

    var _c = this.state,
        dropdownOpen = _c.dropdownOpen,
        highlightedIndex = _c.highlightedIndex;
    var _d = this.props,
        disabledItems = _d.disabledItems,
        tooltipItems = _d.tooltipItems,
        EmptyComponent = _d.emptyComponent,
        emptyMessage = _d.emptyMessage,
        pagination = _d.pagination,
        dropdownProps = _d.dropdownProps;
    var dropdownClassName = classnames((_a = {}, _a[styles$Y.dropdown] = true, _a[styles$Y.dropdownFixed] = (_b = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.fixed) !== null && _b !== void 0 ? _b : false, _a), dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.className);
    var items = this.getAvailableItems();
    var activeItem = highlightedIndex !== null ? items[highlightedIndex] : null;
    var isEmpty = !items.length;
    return /*#__PURE__*/React.createElement(Dropdown, __assign({}, dropdownProps, {
      className: dropdownClassName,
      isOpen: dropdownOpen,
      "data-testid": "select-dropdown"
    }), isEmpty && typeof EmptyComponent === 'function' && /*#__PURE__*/React.createElement(EmptyComponent, {
      label: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : 'No options',
      "data-testid": "select-dropdown-empty"
    }), !isEmpty && /*#__PURE__*/React.createElement(DropdownInfinite, {
      id: this.a11y.dropdown,
      ariaLabelledby: this.a11y.label,
      ref: this.listRef,
      pagination: pagination,
      items: items,
      onSelect: this.handleSelect,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      selectedItems: this.state.selectedItems,
      disabledItems: disabledItems,
      tooltipItems: tooltipItems,
      activeItem: activeItem,
      itemComponent: this.props.itemComponent
    }), !!pagination && !pagination.infinite && /*#__PURE__*/React.createElement("div", {
      className: styles$Y.pagination,
      "data-testid": "select-dropdown-pagination"
    }, /*#__PURE__*/React.createElement(Button$2, {
      variant: "secondary",
      disabled: !pagination.previousEnable,
      onClick: pagination.onPrevious
    }, "Prev page"), /*#__PURE__*/React.createElement(Button$2, {
      variant: "secondary",
      disabled: !pagination.nextEnable,
      onClick: pagination.onNext
    }, "Next page")));
  };

  Select.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        className = _b.className,
        disabled = _b.disabled,
        loading = _b.loading,
        multiple = _b.multiple,
        searchable = _b.searchable,
        clearable = _b.clearable,
        prefix = _b.prefix,
        suffix = _b.suffix,
        icon = _b.icon,
        status = _b.status;
    var _c = this.state,
        search = _c.search,
        dropdownOpen = _c.dropdownOpen;
    var rootClass = classnames((_a = {}, _a[styles$Y.root] = true, _a[styles$Y.rootSingle] = !multiple, _a[styles$Y.rootDisabled] = disabled, _a[styles$Y.rootSearchable] = searchable, _a[styles$Y.rootDropdownOpen] = dropdownOpen, _a[styles$Y.rootIsSearching] = !!search, _a[styles$Y.rootHasIcon] = !!icon, _a), className);
    var onClickControl = !search ? function () {
      return _this.handleDropdown('toggle');
    } : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass,
      role: "combobox",
      "aria-expanded": dropdownOpen,
      "aria-owns": this.a11y.dropdown,
      "aria-haspopup": "listbox",
      "data-testid": "select-root"
    }, /*#__PURE__*/React.createElement(InputWrapper, {
      prefix: prefix,
      suffix: suffix,
      icon: icon,
      status: status,
      active: dropdownOpen,
      disabled: disabled,
      className: styles$Y.inputWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$Y.control,
      ref: this.controlRef,
      onKeyDown: this.handleKeyDown,
      onClick: onClickControl,
      tabIndex: disabled ? -1 : 0,
      "aria-activedescendant": this.a11y.option,
      "data-testid": "select-control"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$Y.selection
    }, multiple ? this.renderMultipleSelection() : this.renderSingleSelection(), this.renderSearch()), /*#__PURE__*/React.createElement("div", {
      className: styles$Y.indicators
    }, loading && /*#__PURE__*/React.createElement(Spinner, {
      className: styles$Y.spinner,
      size: 16,
      "aria-label": "Loading",
      "data-testid": "select-loading"
    }), !this.isEmpty() && clearable && /*#__PURE__*/React.createElement(IconButton$1, {
      tabIndex: -1,
      className: styles$Y.clearIndicator,
      icon: "close",
      variant: "tertiary",
      onClick: this.handleClear,
      "aria-label": "Clear",
      "data-testid": "select-clear"
    }), /*#__PURE__*/React.createElement(IconButton$1, {
      tabIndex: -1,
      className: styles$Y.dropdownIndicator,
      icon: dropdownOpen ? 'angle-up' : 'angle-down',
      variant: "tertiary",
      onClick: function onClick(event) {
        event.stopPropagation();

        _this.handleDropdown('toggle');
      },
      "aria-label": dropdownOpen ? 'Close' : 'Open',
      "data-testid": "select-toggle"
    })))), !disabled && dropdownOpen && this.renderDropdown());
  };

  Select.defaultProps = {
    id: uniqueId('select'),
    selectedItems: [],
    disabledItems: [],
    itemComponent: SelectItem,
    emptyComponent: EmptySelectItem,
    emptyMessage: 'No options',
    placeholder: '',
    disabled: false,
    loading: false,
    multiple: false,
    searchable: false,
    clearable: false,
    keepOpen: false,
    hideSelectedItems: false
  };
  return Select;
}(React.PureComponent);
var SelectWithErrorBoundary = withErrorBoundary(Select, {
  fallback: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text.Paragraph, {
    variant: "2"
  }, "Something went wrong"))
});

var DateRangeValidators =
/** @class */
function () {
  function DateRangeValidators(dateFormat, dateParser, dateRangeConstraint) {
    this.dateFormat = dateFormat;
    this.dateParser = dateParser;
    this.dateRangeConstraint = dateRangeConstraint;
    this.dateFormat = dateFormat;
    this.dateParser = dateParser;
    this.dateRangeConstraint = dateRangeConstraint;
  }

  DateRangeValidators.prototype.isValidDate = function (dateString) {
    try {
      var dateMoment = this.dateParser(dateString);
      return dateMoment.isValid();
    } catch (error) {
      return false;
    }
  };
  /**
   * Mind that this is dependant on end date as well because it's a range
   */


  DateRangeValidators.prototype.startDateIsValid = function (_a) {
    var startDateInputValue = _a.startDateInputValue,
        endDateInputValue = _a.endDateInputValue;
    var minDate = this.dateRangeConstraint.minDate;

    if (startDateInputValue === '') {
      return {
        isValid: true,
        error: null
      };
    }

    if (!this.isValidDate(startDateInputValue)) {
      return {
        isValid: false,
        error: 'Start date is not valid'
      };
    }

    var startDateMoment = this.dateParser(startDateInputValue);
    var endDateMoment = this.dateParser(endDateInputValue); // if there's no end value, then it only needs to be after min

    if (!endDateInputValue || !this.isValidDate(endDateInputValue)) {
      var isAfterMinDate = startDateMoment.isSameOrAfter(minDate, 'day');
      if (isAfterMinDate) return DateRangeValidators.validationOK;
      return {
        isValid: false,
        error: "Start must be after " + minDate.format(this.dateFormat)
      };
    } // if there's an end value it needs to be between min and end


    return startDateMoment.isBetween(minDate, endDateMoment, 'day', '(]') ? DateRangeValidators.validationOK : {
      isValid: false,
      error: "Start must be between " + minDate.format(this.dateFormat) + " and " + endDateMoment.format(this.dateFormat)
    };
  };
  /**
   * Mind that this is dependant on start date as well because it's a range
   */


  DateRangeValidators.prototype.endDateIsValid = function (_a) {
    var startDateInputValue = _a.startDateInputValue,
        endDateInputValue = _a.endDateInputValue;
    var maxDate = this.dateRangeConstraint.maxDate;

    if (endDateInputValue === '') {
      return {
        isValid: true,
        error: null
      };
    }

    if (!this.isValidDate(endDateInputValue)) {
      return {
        isValid: false,
        error: 'End date is not valid'
      };
    }

    var startDateMoment = this.dateParser(startDateInputValue);
    var endDateMoment = this.dateParser(endDateInputValue); // if there's no start value, then it only needs to be before max

    if (!startDateInputValue || !this.isValidDate(startDateInputValue)) {
      var isBeforeMaxDate = endDateMoment.isSameOrBefore(maxDate, 'day');
      if (isBeforeMaxDate) return DateRangeValidators.validationOK;
      return {
        isValid: false,
        error: "End must be before " + maxDate.format(this.dateFormat)
      };
    } // if there's an start value it needs to be between start and max


    return endDateMoment.isBetween(startDateMoment, maxDate, 'day', '[)') ? DateRangeValidators.validationOK : {
      isValid: false,
      error: "End must be between " + startDateMoment.format(this.dateFormat) + " and " + maxDate.format(this.dateFormat)
    };
  };

  DateRangeValidators.validationOK = {
    isValid: true,
    error: null
  };
  return DateRangeValidators;
}();

var css_248z$15 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dateRangePickerInputFields--index__inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 8px;\n  margin-bottom: 8px; }\n\n.dateRangePickerInputFields--index__input {\n  position: relative; }\n  .dateRangePickerInputFields--index__input .helperField--helperField__label {\n    color: #45587c; }\n  .dateRangePickerInputFields--index__input .helperField--helperField__error {\n    display: none; }\n\n.dateRangePickerInputFields--index__inputLabel {\n  font-size: 11px;\n  line-height: 16px;\n  grid-gap: 8px; }\n\n.dateRangePickerInputFields--index__inputLabelExampleDateFormat {\n  color: #8193b0;\n  font-size: inherit; }\n\n.dateRangePickerInputFields--index__errorsWrapper {\n  min-height: 14px;\n  grid-column: 1 / -1;\n  font-size: 10px;\n  color: red; }\n";
var styles$Z = {"inputs":"dateRangePickerInputFields--index__inputs","input":"dateRangePickerInputFields--index__input","inputLabel":"dateRangePickerInputFields--index__inputLabel","inputLabelExampleDateFormat":"dateRangePickerInputFields--index__inputLabelExampleDateFormat","errorsWrapper":"dateRangePickerInputFields--index__errorsWrapper"};
styleInject(css_248z$15);

var DateRangePickerInputFields =
/** @class */
function (_super) {
  __extends(DateRangePickerInputFields, _super);

  function DateRangePickerInputFields(props) {
    var _a, _b, _c, _d;

    var _this = _super.call(this, props) || this;

    var dateFormat = props.dateFormat;
    _this.state = {
      startDateInputValue: (_b = (_a = _this.props.startDate) === null || _a === void 0 ? void 0 : _a.format(dateFormat)) !== null && _b !== void 0 ? _b : '',
      startDateError: null,
      endDateInputValue: (_d = (_c = _this.props.endDate) === null || _c === void 0 ? void 0 : _c.format(dateFormat)) !== null && _d !== void 0 ? _d : '',
      endDateError: null
    };
    _this.handleInputValueChange = _this.handleInputValueChange.bind(_this);
    _this.parseDateString = _this.parseDateString.bind(_this);
    _this.propagateStartDateChangeEvent = _this.propagateStartDateChangeEvent.bind(_this);
    _this.propagateEndDateChangeEvent = _this.propagateEndDateChangeEvent.bind(_this);
    _this.dateRangeValidators = new DateRangeValidators(props.dateFormat, _this.parseDateString, {
      maxDate: props.maxDate,
      minDate: props.minDate
    });
    _this.timeOptions = _this.getTimeOptions(props.timeFormat);
    return _this;
  }

  DateRangePickerInputFields.prototype.componentDidUpdate = function (prevProps) {
    this.syncStartDateWithProps(prevProps);
    this.syncEndDateWithProps(prevProps);
  };

  DateRangePickerInputFields.prototype.getTimeOptions = function (timeFormat) {
    var hours = [];
    var minutes = [0, 15, 30, 45];

    var _loop_1 = function _loop_1(hour) {
      minutes.forEach(function (minute) {
        var d = moment$1({
          hour: hour,
          minute: minute
        });
        hours.push({
          id: d.format('HH:mm'),
          name: d.format(timeFormat)
        });
      });
    };

    for (var hour = 0; hour < 24; hour++) {
      _loop_1(hour);
    }

    return hours;
  };

  DateRangePickerInputFields.prototype.syncEndDateWithProps = function (prevProps) {
    var endDate = this.props.endDate;
    var hasNotChanged = endDate === prevProps.endDate || (endDate === null || endDate === void 0 ? void 0 : endDate.isSame(prevProps.endDate, 'day'));
    if (hasNotChanged) return;

    if (!this.props.endDate) {
      return this.setState({
        endDateError: null,
        endDateInputValue: ''
      });
    }

    return this.setState({
      endDateError: null,
      endDateInputValue: this.props.endDate.format(this.props.dateFormat)
    });
  };

  DateRangePickerInputFields.prototype.syncStartDateWithProps = function (prevProps) {
    var startDate = this.props.startDate;
    var hasNotChanged = startDate === prevProps.startDate || (startDate === null || startDate === void 0 ? void 0 : startDate.isSame(prevProps.startDate, 'day'));
    if (hasNotChanged) return;

    if (!this.props.startDate) {
      return this.setState({
        startDateError: null,
        startDateInputValue: ''
      });
    }

    return this.setState({
      startDateError: null,
      startDateInputValue: this.props.startDate.format(this.props.dateFormat)
    });
  };

  DateRangePickerInputFields.prototype.handleInputValueChange = function (event) {
    var inputName = event.target.name;
    var value = event.target.value;

    switch (inputName) {
      case 'startDate':
        this.setState({
          startDateInputValue: this.ensureValidChars(value)
        }, this.propagateStartDateChangeEvent);
        break;

      case 'endDate':
        this.setState({
          endDateInputValue: this.ensureValidChars(value)
        }, this.propagateEndDateChangeEvent);
        break;
    }
  };

  DateRangePickerInputFields.prototype.propagateStartDateChangeEvent = function () {
    var _this = this;

    var _a = this.state,
        startDateInputValue = _a.startDateInputValue,
        endDateInputValue = _a.endDateInputValue;

    if (startDateInputValue === '') {
      this.props.onStartDateChange(null);
      return;
    }

    var _b = this.dateRangeValidators.startDateIsValid({
      startDateInputValue: startDateInputValue,
      endDateInputValue: endDateInputValue
    }),
        isValid = _b.isValid,
        error = _b.error;

    if (!isValid) {
      this.setState({
        startDateError: error
      });
      return;
    }

    var _c = this.dateRangeValidators.endDateIsValid({
      startDateInputValue: startDateInputValue,
      endDateInputValue: endDateInputValue
    }),
        isEndDateValid = _c.isValid,
        endDateError = _c.error; // if end date field is empty, disregard the validation result of that field


    var endDateErrorMessage = endDateInputValue !== '' && !isEndDateValid ? endDateError : null;
    this.setState({
      startDateError: null,
      endDateError: endDateErrorMessage
    }, function () {
      return _this.props.onStartDateChange(_this.parseDateString(startDateInputValue));
    });
  };

  DateRangePickerInputFields.prototype.propagateEndDateChangeEvent = function () {
    var _this = this;

    var _a = this.state,
        startDateInputValue = _a.startDateInputValue,
        endDateInputValue = _a.endDateInputValue;

    if (endDateInputValue === '') {
      this.props.onEndDateChange(null);
      return;
    }

    var _b = this.dateRangeValidators.endDateIsValid({
      startDateInputValue: startDateInputValue,
      endDateInputValue: endDateInputValue
    }),
        isValid = _b.isValid,
        error = _b.error;

    if (!isValid) {
      this.setState({
        endDateError: error
      });
      return;
    }

    var _c = this.dateRangeValidators.startDateIsValid({
      startDateInputValue: startDateInputValue,
      endDateInputValue: endDateInputValue
    }),
        isStartDateValid = _c.isValid,
        startDateError = _c.error; // if start date field is empty, disregard the validation result of that field


    var startDateErrorMessage = startDateInputValue !== '' && !isStartDateValid ? startDateError : null;
    this.setState({
      endDateError: null,
      startDateError: startDateErrorMessage
    }, function () {
      return _this.props.onEndDateChange(_this.parseDateString(endDateInputValue));
    });
  };

  DateRangePickerInputFields.prototype.parseDateString = function (date) {
    return moment$1(date, this.props.dateFormat, true);
  };

  DateRangePickerInputFields.prototype.ensureValidChars = function (value) {
    return value.replace(/[^0-9/]/g, '');
  };

  DateRangePickerInputFields.prototype.getAvailableTimeOptions = function (key) {
    var _a = this.props,
        startDate = _a.startDate,
        endDate = _a.endDate,
        startTime = _a.startTime;

    switch (key) {
      case 'startTime':
        {
          return this.timeOptions;
        }

      case 'endTime':
        {
          var endTimeOptions = __spreadArrays(this.timeOptions, [{
            id: '23:59',
            name: '11:59 PM'
          }]);

          if (startDate === null || startDate === void 0 ? void 0 : startDate.isSame(endDate, 'day')) {
            var startTimeIndex = endTimeOptions.findIndex(function (o) {
              return o.id === startTime;
            });
            return endTimeOptions.slice(startTimeIndex + 1);
          } else {
            return endTimeOptions;
          }
        }
    }
  };

  DateRangePickerInputFields.prototype.renderDateInputLabelWithFormat = function (label) {
    return /*#__PURE__*/React.createElement("span", {
      className: styles$Z.inputLabel
    }, label, ' ', /*#__PURE__*/React.createElement("span", {
      className: styles$Z.inputLabelExampleDateFormat
    }, "(", this.props.dateFormat.toLowerCase(), ")"));
  };

  DateRangePickerInputFields.prototype.renderDateInputs = function () {
    var _a = this.props,
        isDisabled = _a.isDisabled,
        dateFormat = _a.dateFormat,
        onFocusChange = _a.onFocusChange;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$Z.inputs
    }, /*#__PURE__*/React.createElement(FieldText, {
      className: styles$Z.input,
      label: this.renderDateInputLabelWithFormat('From'),
      placeholder: moment$1().subtract(1, 'day').format(dateFormat),
      input: {
        name: 'startDate',
        value: this.state.startDateInputValue,
        onChange: this.handleInputValueChange,
        onFocus: function onFocus() {
          return onFocusChange('startDate');
        },
        autoComplete: 'off'
      },
      meta: {
        error: this.state.startDateError,
        touched: Boolean(this.state.startDateInputValue)
      },
      disabled: isDisabled
    }), /*#__PURE__*/React.createElement(FieldText, {
      className: styles$Z.input,
      label: this.renderDateInputLabelWithFormat('To'),
      placeholder: moment$1().format(dateFormat),
      input: {
        name: 'endDate',
        value: this.state.endDateInputValue,
        onChange: this.handleInputValueChange,
        onFocus: function onFocus() {
          return onFocusChange('endDate');
        },
        autoComplete: 'off'
      },
      meta: {
        error: this.state.endDateError,
        touched: Boolean(this.state.endDateInputValue)
      },
      disabled: isDisabled
    }));
  };

  DateRangePickerInputFields.prototype.renderTimeInputs = function () {
    var _a = this.props,
        startDate = _a.startDate,
        endDate = _a.endDate,
        startTime = _a.startTime,
        endTime = _a.endTime,
        withTimePicker = _a.withTimePicker,
        _b = _a.timePickerProps,
        timePickerProps = _b === void 0 ? {
      start: {},
      end: {}
    } : _b,
        onTimeChange = _a.onTimeChange;
    if (!withTimePicker) return;
    var commonProps = {
      searchable: true,
      searchFn: function searchFn(item, search) {
        return item.name.startsWith(search.toUpperCase());
      }
    };
    var showTimeTooltip = !(startDate || endDate);
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: "Please select a date first.",
      disabled: !showTimeTooltip,
      placement: "right"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$Z.inputs
    }, /*#__PURE__*/React.createElement(SelectWithErrorBoundary, __assign({
      placeholder: "12:00 AM"
    }, commonProps, timePickerProps.start, {
      disabled: !startDate,
      items: this.getAvailableTimeOptions('startTime'),
      selectedItems: startTime ? [startTime] : undefined,
      onSelect: function onSelect(item) {
        return onTimeChange('startTime', item.id);
      },
      onClear: function onClear() {
        return onTimeChange('startTime', null);
      }
    })), /*#__PURE__*/React.createElement(SelectWithErrorBoundary, __assign({
      placeholder: "11:59 PM"
    }, commonProps, timePickerProps.end, {
      disabled: !endDate,
      items: this.getAvailableTimeOptions('endTime'),
      selectedItems: endTime ? [endTime] : undefined,
      onSelect: function onSelect(item) {
        return onTimeChange('endTime', item.id);
      },
      onClear: function onClear() {
        return onTimeChange('endTime', null);
      }
    }))));
  };

  DateRangePickerInputFields.prototype.renderErrors = function () {
    var _a = this.state,
        startDateError = _a.startDateError,
        endDateError = _a.endDateError;

    if (startDateError || endDateError) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$Z.errorsWrapper
      }, /*#__PURE__*/React.createElement("div", null, this.state.startDateError), /*#__PURE__*/React.createElement("div", null, this.state.endDateError));
    }
  };

  DateRangePickerInputFields.prototype.render = function () {
    var className = this.props.className;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, this.renderDateInputs(), this.renderTimeInputs(), this.renderErrors());
  };

  return DateRangePickerInputFields;
}(React.PureComponent);

var css_248z$16 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dateRangePicker--date-range-picker__root {\n  width: -webkit-min-content;\n  width: -moz-min-content;\n  width: min-content;\n  box-sizing: border-box; }\n\n.dateRangePicker--date-range-picker__inputsWrapper {\n  padding: 16px;\n  padding-bottom: 0; }\n\n.dateRangePicker--date-range-picker__navigationButton {\n  position: absolute;\n  top: 17px;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  transition: 0.2s all;\n  height: 24px; }\n  .dateRangePicker--date-range-picker__navigationButton:hover {\n    border-color: #e7ecf3;\n    background-color: #f5f7fa; }\n  .dateRangePicker--date-range-picker__navigationButton:active {\n    background-color: #f5f7fa; }\n\n.dateRangePicker--date-range-picker__nextMonthButton {\n  right: 22px; }\n\n.dateRangePicker--date-range-picker__prevMonthButton {\n  left: 22px; }\n";
var styles$_ = {"root":"dateRangePicker--date-range-picker__root","inputsWrapper":"dateRangePicker--date-range-picker__inputsWrapper","navigationButton":"dateRangePicker--date-range-picker__navigationButton","nextMonthButton":"dateRangePicker--date-range-picker__nextMonthButton","prevMonthButton":"dateRangePicker--date-range-picker__prevMonthButton"};
styleInject(css_248z$16);

var renderArrow = {
  previousMonth: function previousMonth(_a) {
    var ariaLabel = _a.ariaLabel,
        rest = __rest(_a, ["ariaLabel"]);

    var className = classnames(styles$_.navigationButton, styles$_.prevMonthButton);
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, __assign({}, rest, {
      "aria-label": ariaLabel,
      size: 24,
      name: "angle-left"
    })));
  },
  nextMonth: function nextMonth(_a) {
    var ariaLabel = _a.ariaLabel,
        rest = __rest(_a, ["ariaLabel"]);

    var className = classnames(styles$_.navigationButton, styles$_.nextMonthButton);
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, __assign({}, rest, {
      "aria-label": ariaLabel,
      size: 24,
      name: "angle-right"
    })));
  }
};
var renderCalendarDayContent = function renderCalendarDayContent(day) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "date-number-container"
  }, day.date()), /*#__PURE__*/React.createElement("span", {
    className: "day-complimentary-highlight"
  }));
};
var renderMonthTitle = function renderMonthTitle(_a) {
  var month = _a.month;
  return /*#__PURE__*/React.createElement("span", null, month.format('MMMM YYYY'));
};

var css_248z$17 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.CalendarDay__selected_start .date-number-container, .CalendarDay__selected_end .date-number-container {\n  background: #5644d8;\n  color: white;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%; }\n\n.DayPicker_transitionContainer {\n  border-radius: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.CalendarMonth_table {\n  border-collapse: separate;\n  border-spacing: 0 2px; }\n\n.CalendarMonth_caption {\n  color: #132243;\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: normal; }\n\n.DayPicker_weekHeader {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  top: 48px;\n  color: #8193b0; }\n\n.CalendarDay {\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  color: #45587c;\n  transition: 0.2s all; }\n  .CalendarDay:hover {\n    border: none; }\n  .CalendarDay__today {\n    font-weight: 600; }\n    .CalendarDay__today::after {\n      content: '';\n      position: absolute;\n      bottom: 10%;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 4px;\n      height: 4px;\n      border-radius: 50%;\n      background-color: black; }\n  .CalendarDay__selected_start::after, .CalendarDay__selected_end::after {\n    background-color: white; }\n  .CalendarDay:first-child {\n    border-top-left-radius: 50%;\n    border-bottom-left-radius: 50%; }\n  .CalendarDay:last-child {\n    border-top-right-radius: 50%;\n    border-bottom-right-radius: 50%; }\n\n.CalendarDay__default:hover {\n  background-color: #f0f0ff;\n  border-radius: 50%; }\n\n.CalendarDay__selected_span {\n  background: #ddd8fd;\n  border-radius: 0; }\n\n.CalendarDay__selected_span:hover {\n  background: #c1b9f8;\n  border-radius: 0; }\n\n.CalendarDay__selected {\n  background-color: transparent;\n  z-index: 0; }\n  .CalendarDay__selected:hover {\n    background-color: transparent; }\n    .CalendarDay__selected:hover .date-number-container {\n      background-color: #392aa7; }\n\n.CalendarDay__selected_start:not(.CalendarDay__selected_end) .day-complimentary-highlight {\n  position: absolute;\n  background-color: #ddd8fd;\n  left: 50%;\n  top: 0;\n  height: 100%;\n  width: 50%;\n  z-index: -1; }\n\n.CalendarDay__selected_end:not(:first-child):not(.CalendarDay__selected_start) .day-complimentary-highlight {\n  position: absolute;\n  background-color: #ddd8fd;\n  right: 50%;\n  top: 0;\n  height: 100%;\n  width: 50%;\n  z-index: -1; }\n\n.CalendarDay__hovered_span:hover,\n.CalendarDay__hovered_span {\n  background: #ddd8fd;\n  border-radius: 0; }\n\n.CalendarDay__blocked_out_of_range {\n  color: #b5c1d4; }\n  .CalendarDay__blocked_out_of_range:hover {\n    background-color: transparent; }\n";
styleInject(css_248z$17);

var DateRangePicker =
/** @class */
function (_super) {
  __extends(DateRangePicker, _super);

  function DateRangePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.visibleCalendarMonthRef = /*#__PURE__*/React.createRef();
    var startDate = props.startDate,
        endDate = props.endDate;
    _this.state = {
      startTime: startDate ? moment$1(startDate).format('HH:mm') : null,
      endTime: endDate ? moment$1(endDate).format('HH:mm') : null,
      focusedInput: 'startDate',
      dateRangePickerKey: 0
    };
    _this.onDatesChange = _this.onDatesChange.bind(_this);
    _this.handleFocusChange = _this.handleFocusChange.bind(_this);
    _this.handleTimeChange = _this.handleTimeChange.bind(_this);
    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
    _this.isDateOutsideOfSelectableRange = _this.isDateOutsideOfSelectableRange.bind(_this);
    return _this;
  }

  DateRangePicker.prototype.componentDidUpdate = function (prevProps) {
    this.recalculateDatePickerKey(prevProps);
  };

  DateRangePicker.prototype.getDateConstraints = function () {
    var _a = this.props,
        maxDate = _a.maxDate,
        minDate = _a.minDate;
    return {
      minDate: minDate ? moment$1(minDate, this.props.dateFormat) : moment$1('1970-01-01'),
      maxDate: maxDate ? moment$1(maxDate, this.props.dateFormat) : moment$1('9999-12-31')
    };
  };

  DateRangePicker.prototype.onStartDateChange = function (startDate) {
    this.onDatesChange({
      startDate: startDate,
      endDate: this.props.endDate
    });
  };

  DateRangePicker.prototype.onEndDateChange = function (endDate) {
    this.onDatesChange({
      endDate: endDate,
      startDate: this.props.startDate
    });
  };

  DateRangePicker.prototype.onDatesChange = function (values) {
    var _a, _b;

    var _c = this.state,
        startTime = _c.startTime,
        endTime = _c.endTime;
    var startDate = startTime ? this.addTimeToDate(values.startDate, startTime) : ((_a = values.startDate) === null || _a === void 0 ? void 0 : _a.startOf('day')) || null;
    var endDate = endTime ? this.addTimeToDate(values.endDate, endTime) : ((_b = values.endDate) === null || _b === void 0 ? void 0 : _b.endOf('day')) || null;
    this.props.onChange({
      startDate: startDate,
      endDate: endDate
    });
  };

  DateRangePicker.prototype.handleTimeChange = function (key, time) {
    var _this = this;

    var _a = this.props,
        startDate = _a.startDate,
        endDate = _a.endDate;
    this.setState(function (prevState) {
      var _a;

      return __assign(__assign({}, prevState), (_a = {}, _a[key] = time, _a));
    }, function () {
      return _this.onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
    });
  };

  DateRangePicker.prototype.handleFocusChange = function (focusedInput) {
    this.setState({
      focusedInput: focusedInput !== null && focusedInput !== void 0 ? focusedInput : 'startDate'
    });
  };

  DateRangePicker.prototype.addTimeToDate = function (date, time) {
    if (!date) return null;

    var _a = time.split(':'),
        hours = _a[0],
        minutes = _a[1];

    if (!hours || !minutes) return date;
    return date.set({
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
      seconds: 0,
      milliseconds: 0
    });
  };

  DateRangePicker.prototype.isDateOutsideOfSelectableRange = function (day) {
    if (this.props.isDisabled) {
      // all dates should be disallowed if the input is disabled
      return true;
    }

    var _a = this.getDateConstraints(),
        minDate = _a.minDate,
        maxDate = _a.maxDate;

    return !day.isBetween(minDate, maxDate, 'day');
  };

  DateRangePicker.prototype.recalculateDatePickerKey = function (_a) {
    var _b;

    var prevStartDate = _a.startDate,
        prevEndDate = _a.endDate;
    var _c = this.props,
        currentStartDate = _c.startDate,
        currentEndDate = _c.endDate; // this is a hack to make sure when start date changes we jump to the month that contains the start date.
    // as of now, there is no cleaner way to do this.
    // see https://github.com/airbnb/react-dates/pull/1487#issuecomment-482725001
    // detect when values are cleared.

    if (prevEndDate && prevStartDate && !currentStartDate && !currentEndDate) {
      return this.setState({
        dateRangePickerKey: this.generateRandomKey()
      });
    } // the months under focus depends on the start date. so if there's no start date, don't do anything.


    if (!currentEndDate && !prevEndDate) {
      return;
    } // we don't have a start date now but we used to have one, no need to update.


    if (!currentEndDate && prevEndDate) {
      return;
    } // if there's start value but it was not present on prevProps then update the calendar


    if (currentEndDate && !prevEndDate) {
      var visibleMonthOnCalendar = (_b = this.visibleCalendarMonthRef.current) === null || _b === void 0 ? void 0 : _b.state.currentMonth; // the newly selected value is in the visible month

      if (this.visibleCalendarMonthRef.current && currentEndDate.isSame(visibleMonthOnCalendar, 'month')) {
        return;
      }

      this.setState({
        dateRangePickerKey: this.generateRandomKey()
      });
    }

    if (currentEndDate && prevEndDate) {
      // If we are already on the current month don't do anything
      if (currentEndDate.isSame(prevEndDate, 'month')) {
        return;
      } else {
        // we want the calendar to be re-instantiated
        this.setState({
          dateRangePickerKey: this.generateRandomKey()
        });
      }
    }
  };

  DateRangePicker.prototype.generateRandomKey = function () {
    return Math.floor(Math.random() * 100000);
  };

  DateRangePicker.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        dateFormat = _a.dateFormat,
        timeFormat = _a.timeFormat,
        className = _a.className,
        withInputFields = _a.withInputFields,
        withTimePicker = _a.withTimePicker,
        timePickerProps = _a.timePickerProps,
        calendarProps = _a.calendarProps,
        isDisabled = _a.isDisabled,
        startDate = _a.startDate,
        endDate = _a.endDate;
    var _b = this.state,
        startTime = _b.startTime,
        endTime = _b.endTime;

    var _c = this.getDateConstraints(),
        minDate = _c.minDate,
        maxDate = _c.maxDate;

    var nextMonthButtonRenderer = !isDisabled ? renderArrow.previousMonth : function () {
      return /*#__PURE__*/React.createElement("span", null);
    };
    var prevMonthButtonRenderer = !isDisabled ? renderArrow.nextMonth : function () {
      return /*#__PURE__*/React.createElement("span", null);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$_.root, className)
    }, withInputFields && /*#__PURE__*/React.createElement(DateRangePickerInputFields, {
      dateFormat: dateFormat,
      timeFormat: timeFormat,
      className: styles$_.inputsWrapper,
      onStartDateChange: this.onStartDateChange,
      onEndDateChange: this.onEndDateChange,
      onTimeChange: this.handleTimeChange,
      onFocusChange: this.handleFocusChange,
      startDate: startDate,
      endDate: endDate,
      startTime: startTime,
      endTime: endTime,
      minDate: minDate,
      maxDate: maxDate,
      isDisabled: isDisabled,
      withTimePicker: withTimePicker,
      timePickerProps: timePickerProps
    }), /*#__PURE__*/React.createElement(FlexBox, {
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(reactDates.DayPickerRangeController, __assign({
      key: this.state.dateRangePickerKey,
      ref: this.visibleCalendarMonthRef,
      startDate: startDate,
      endDate: endDate,
      onDatesChange: this.onDatesChange,
      onFocusChange: this.handleFocusChange,
      focusedInput: this.state.focusedInput,
      isOutsideRange: this.isDateOutsideOfSelectableRange,
      numberOfMonths: 1,
      hideKeyboardShortcutsPanel: true,
      noBorder: true,
      renderDayContents: renderCalendarDayContent,
      daySize: 32,
      minimumNights: 0,
      disabled: isDisabled,
      renderNavPrevButton: nextMonthButtonRenderer,
      renderNavNextButton: prevMonthButtonRenderer,
      renderMonthElement: renderMonthTitle,
      initialVisibleMonth: function initialVisibleMonth() {
        return _this.props.endDate || _this.props.startDate || moment$1();
      }
    }, calendarProps))));
  };

  DateRangePicker.defaultProps = {
    dateFormat: moment$1.localeData().longDateFormat('L'),
    timeFormat: moment$1.localeData().longDateFormat('LT'),
    withInputFields: true,
    withTimePicker: false,
    timePickerProps: {
      start: {},
      end: {}
    }
  };
  return DateRangePicker;
}(PureComponent);

var css_248z$18 = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dialer--dialer__dialer {\n  box-sizing: content-box;\n  width: 240px;\n  min-width: 240px;\n  height: 320px;\n  min-height: 320px;\n  padding: 8px;\n  display: grid;\n  grid-template-columns: repeat(3, 80px);\n  grid-template-rows: repeat(4, 80px); }\n\n.dialer--dialer__number {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  box-sizing: border-box;\n  border-left: 1px solid #e7ecf3;\n  color: #45587c;\n  cursor: pointer; }\n  .dialer--dialer__number:nth-child(n + 4) {\n    border-top: 1px solid #e7ecf3; }\n  .dialer--dialer__number:nth-child(3n + 1) {\n    border-left: 0; }\n  .dialer--dialer__number:hover {\n    background: #f5f7fa; }\n\n.dialer--dialer__letters {\n  display: block;\n  margin-top: 8px;\n  text-transform: uppercase; }\n\n.dialer--dialer__asterisk {\n  font-size: 24px;\n  position: relative;\n  top: 4px; }\n";
var styles$$ = {"dialer":"dialer--dialer__dialer","number":"dialer--dialer__number","letters":"dialer--dialer__letters","asterisk":"dialer--dialer__asterisk"};
styleInject(css_248z$18);

var NUMBERS = [{
  value: '1',
  letters: ' '
}, {
  value: '2',
  letters: 'abc'
}, {
  value: '3',
  letters: 'def'
}, {
  value: '4',
  letters: 'ghi'
}, {
  value: '5',
  letters: 'jkl'
}, {
  value: '6',
  letters: 'mno'
}, {
  value: '7',
  letters: 'pqrs'
}, {
  value: '8',
  letters: 'tuv'
}, {
  value: '9',
  letters: 'wxyz'
}, {
  value: '*',
  letters: null,
  classNames: styles$$.asterisk
}, {
  value: '0',
  letters: null
}, {
  value: '#',
  letters: null
}];

var Dialer =
/** @class */
function (_super) {
  __extends(Dialer, _super);

  function Dialer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Dialer.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        onInput = _a.onInput,
        otherProps = __rest(_a, ["className", "onInput"]);

    var rootClass = classnames(styles$$.dialer, className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), NUMBERS.map(function (number) {
      var _a;

      return /*#__PURE__*/React.createElement("div", __assign({
        className: classnames(styles$$.number)
      }, buttonize(function () {
        return onInput(number.value);
      }), {
        key: number.value
      }), /*#__PURE__*/React.createElement(Text.Heading, {
        variant: "heading-1",
        color: colors.neutral['700']
      }, /*#__PURE__*/React.createElement("span", {
        className: (_a = number.classNames) !== null && _a !== void 0 ? _a : ''
      }, number.value)), /*#__PURE__*/React.createElement(Text.Paragraph, {
        variant: "1",
        color: colors.neutral['700']
      }, !!number.letters && /*#__PURE__*/React.createElement("span", {
        className: styles$$.letters
      }, number.letters)));
    }));
  };

  return Dialer;
}(PureComponent);

var css_248z$19 = "@-webkit-keyframes donutChart--donutChart__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes donutChart--donutChart__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes donutChart--donutChart__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes donutChart--donutChart__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.donutChart--donutChart__root {\n  position: relative;\n  width: 72px;\n  height: 72px; }\n\n.donutChart--donutChart__counter {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 18px;\n  line-height: 24px;\n  color: #ff9430; }\n  .donutChart--donutChart__rootNoWaiting .donutChart--donutChart__counter {\n    color: #dcdcdc; }\n";
var styles$10 = {"root":"donutChart--donutChart__root","counter":"donutChart--donutChart__counter","rootNoWaiting":"donutChart--donutChart__rootNoWaiting","wiggle":"donutChart--donutChart__wiggle","spin":"donutChart--donutChart__spin"};
styleInject(css_248z$19);

var RADIUS = 30;
var STROKE = 12;
var CIRCUMFERENCE = RADIUS * Math.PI * 2;

function calculateDasharray(pct) {
  var paintedPart = CIRCUMFERENCE * pct / 100;
  return paintedPart + " " + (CIRCUMFERENCE - paintedPart);
}

function calculateOffset(pct) {
  return CIRCUMFERENCE * (25 - pct) / 100;
}

var DonutChart =
/** @class */
function (_super) {
  __extends(DonutChart, _super);

  function DonutChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DonutChart.prototype.getSlicesAsPercentages = function () {
    var data = this.props.data;
    var total = data.reduce(function (acc, item) {
      return acc + item.value;
    }, 0);
    if (total === 0) return [];
    return data.map(function (item) {
      return {
        color: item.color,
        pct: item.value / total * 100
      };
    });
  };

  DonutChart.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        data = _b.data,
        count = _b.count,
        otherProps = __rest(_b, ["className", "data", "count"]);

    var rootClass = classnames((_a = {}, _a[styles$10.root] = true, _a[styles$10.rootNoWaiting] = count === '0', _a), className);
    var total = 0;
    var slices = this.getSlicesAsPercentages();
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$10.counter
    }, count), /*#__PURE__*/React.createElement("svg", {
      height: RADIUS * 2 + STROKE,
      width: RADIUS * 2 + STROKE
    }, slices.map(function (slice) {
      var offset = total;
      total += slice.pct;
      return /*#__PURE__*/React.createElement("circle", {
        key: offset,
        r: RADIUS,
        fill: "none",
        cx: RADIUS + STROKE / 2,
        cy: RADIUS + STROKE / 2,
        stroke: slice.color,
        strokeDasharray: calculateDasharray(slice.pct),
        strokeWidth: STROKE,
        strokeDashoffset: calculateOffset(offset)
      });
    }), slices.length === 0 && /*#__PURE__*/React.createElement("circle", {
      r: RADIUS,
      fill: "none",
      cx: RADIUS + STROKE / 2,
      cy: RADIUS + STROKE / 2,
      stroke: "#dcdcdc",
      strokeWidth: STROKE
    })));
  };

  return DonutChart;
}(PureComponent);

var css_248z$1a = ".dropdownSelectMultiple--dropdownSelectMultiple__items {\n  display: flex;\n  flex-wrap: wrap; }\n  .dropdownSelectMultiple--dropdownSelectMultiple__items > * {\n    margin: 4px; }\n\n.dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown {\n  width: 288px;\n  max-height: 320px;\n  overflow: auto; }\n";
var styles$11 = {"items":"dropdownSelectMultiple--dropdownSelectMultiple__items","moreItemsDropdown":"dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown"};
styleInject(css_248z$1a);

var DropdownSelectWrapper =
/** @class */
function (_super) {
  __extends(DropdownSelectWrapper, _super);

  function DropdownSelectWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DropdownSelectWrapper.prototype.getItems = function () {
    var items = this.props.items;
    return items;
  };

  DropdownSelectWrapper.prototype.render = function () {
    var _a = this.props,
        items = _a.items,
        itemComponent = _a.itemComponent,
        onSelect = _a.onSelect,
        onChange = _a.onChange,
        onSearch = _a.onSearch,
        onClear = _a.onClear,
        hasSearch = _a.hasSearch,
        searchPlaceholder = _a.searchPlaceholder,
        onSuggest = _a.onSuggest,
        suggestionComponent = _a.suggestionComponent,
        emptyComponent = _a.emptyComponent,
        emptyMessage = _a.emptyMessage,
        keepOpen = _a.keepOpen,
        containerProps = _a.containerProps,
        buttonText = _a.buttonText,
        selectedItems = _a.selectedItems,
        otherProps = __rest(_a, ["items", "itemComponent", "onSelect", "onChange", "onSearch", "onClear", "hasSearch", "searchPlaceholder", "onSuggest", "suggestionComponent", "emptyComponent", "emptyMessage", "keepOpen", "containerProps", "buttonText", "selectedItems"]);

    return /*#__PURE__*/React.createElement(DropdownSelect, __assign({}, otherProps, {
      containerProps: containerProps,
      items: this.getItems(),
      itemComponent: itemComponent,
      hasSearch: hasSearch,
      searchPlaceholder: searchPlaceholder,
      suggestionComponent: suggestionComponent,
      onSuggest: onSuggest,
      keepOpen: keepOpen,
      onSearch: onSearch,
      onSelect: onSelect,
      onChange: onChange,
      onClear: onClear,
      emptyComponent: emptyComponent,
      emptyMessage: emptyMessage,
      selectedItems: selectedItems
    }), buttonText);
  };

  DropdownSelectWrapper.defaultProps = {
    noArrow: true,
    hasSearch: false,
    searchPlaceholder: 'Search...',
    keepOpen: false,
    onSearch: function onSearch() {
      /* do nothing */
    },
    onSuggest: function onSuggest() {
      /* do nothing */
    },
    onChange: function onChange() {
      /* do nothing */
    },
    onSelect: function onSelect() {
      /* do nothing */
    },
    emptyComponent: EmptySelectItem,
    emptyMessage: 'No items found',
    buttonText: '+Select item',
    selectedItems: []
  };
  return DropdownSelectWrapper;
}(Component);

var DropdownSelectMultiple =
/** @class */
function (_super) {
  __extends(DropdownSelectMultiple, _super);

  function DropdownSelectMultiple(props) {
    var _this = _super.call(this, props) || this;

    _this.getListItem = _this.getListItem.bind(_this);
    _this.getListMoreItem = _this.getListMoreItem.bind(_this);
    return _this;
  }

  DropdownSelectMultiple.prototype.resolveItem = function (itemOrID) {
    if (_typeof(itemOrID) === 'object') {
      return itemOrID;
    }

    var foundItem = this.props.items.find(function (item) {
      return item.id === itemOrID;
    });

    if (foundItem) {
      return foundItem;
    }

    return {
      id: uniqueId(),
      name: 'Unknown'
    };
  };

  DropdownSelectMultiple.prototype.getItemName = function (listItem) {
    return listItem.name.toString().trim();
  };

  DropdownSelectMultiple.prototype.isItemDisabled = function (item) {
    if (this.props.disabledItems) {
      return this.props.disabledItems.indexOf(item.id) >= 0;
    }

    return false;
  };

  DropdownSelectMultiple.prototype.getTooltip = function (item) {
    var tooltipItems = this.props.tooltipItems;

    if (!tooltipItems) {
      return null;
    }

    if (isEmpty(tooltipItems[item.id])) {
      return null;
    }

    return tooltipItems[item.id];
  };

  DropdownSelectMultiple.prototype.getListItem = function (item, index) {
    var onRemove = this.props.onRemove;
    var resolvedItem = this.resolveItem(item);
    var itemName = this.getItemName(resolvedItem);
    var tooltip = this.getTooltip(resolvedItem);
    var tag = /*#__PURE__*/React.createElement(Tag, {
      onDelete: function onDelete() {
        return onRemove(resolvedItem);
      },
      key: resolvedItem.id,
      color: resolvedItem.color,
      disabled: this.isItemDisabled(resolvedItem)
    }, itemName);

    if (!tooltip) {
      return tag;
    }

    return /*#__PURE__*/React.createElement(Tooltip, __assign({
      key: index
    }, tooltip), tag);
  };

  DropdownSelectMultiple.prototype.getListMoreItem = function (item) {
    var _a = this.props,
        MoreItemsItemComponent = _a.MoreItemsItemComponent,
        onRemove = _a.onRemove;
    var resolvedItem = this.resolveItem(item);
    var tooltip = this.getTooltip(resolvedItem);
    var moreItemComponent = /*#__PURE__*/React.createElement(MoreItemsItemComponent, {
      key: resolvedItem.id,
      item: resolvedItem,
      onSelect: onRemove,
      disabled: this.isItemDisabled(resolvedItem),
      clearSearch: noop$1,
      isLoading: false,
      checked: false
    });

    if (!tooltip) {
      return moreItemComponent;
    }

    return /*#__PURE__*/React.createElement(Tooltip, __assign({
      key: resolvedItem.id
    }, tooltip), moreItemComponent);
  };

  DropdownSelectMultiple.prototype.getPreviewItems = function () {
    var _a = this.props,
        selectedItems = _a.selectedItems,
        previewItemsNumber = _a.previewItemsNumber,
        _b = _a.moreItemsDropdownProps,
        moreItemsDropdownProps = _b === void 0 ? {} : _b;
    var addedItems = [];
    var moreItems = [];
    var howManyMore = '';

    if (previewItemsNumber && selectedItems) {
      if (selectedItems.length > 0 && selectedItems.length < previewItemsNumber) {
        addedItems = selectedItems.map(this.getListItem);
      } else if (selectedItems.length >= previewItemsNumber) {
        var itemsPreviewList = selectedItems.slice(0, previewItemsNumber);
        var itemsMoreList = selectedItems.slice(previewItemsNumber, selectedItems.length);
        addedItems = itemsPreviewList.map(this.getListItem);
        moreItems = itemsMoreList.map(this.getListMoreItem);
        howManyMore = itemsMoreList.length.toString();
      }
    } else {
      addedItems = selectedItems.map(this.getListItem);
    }

    var className = moreItemsDropdownProps.className,
        restOfMoreItemsDropdownProps = __rest(moreItemsDropdownProps, ["className"]);

    var moreItemsDropdown = /*#__PURE__*/React.createElement("div", __assign({}, restOfMoreItemsDropdownProps, {
      className: classnames(styles$11.moreItemsDropdown, className)
    }), moreItems);
    return /*#__PURE__*/React.createElement(React.Fragment, null, addedItems, previewItemsNumber && selectedItems.length > previewItemsNumber ? /*#__PURE__*/React.createElement(DropdownButton, {
      noArrow: true,
      buttonProps: {
        variant: 'tertiary'
      },
      dropdown: moreItemsDropdown
    }, "+\xA0", howManyMore, /*#__PURE__*/React.createElement("span", null, "\xA0selected")) : null);
  };

  DropdownSelectMultiple.prototype.render = function () {
    var _a;

    var _b = this.props,
        items = _b.items,
        selectedItems = _b.selectedItems,
        previewItemsNumber = _b.previewItemsNumber,
        className = _b.className,
        onSelect = _b.onSelect,
        onChange = _b.onChange,
        onSearch = _b.onSearch,
        hasSearch = _b.hasSearch,
        searchPlaceholder = _b.searchPlaceholder,
        onSuggest = _b.onSuggest,
        onRemove = _b.onRemove,
        keepOpen = _b.keepOpen,
        itemComponent = _b.itemComponent,
        suggestionComponent = _b.suggestionComponent,
        pagination = _b.pagination,
        emptyComponent = _b.emptyComponent,
        emptyMessage = _b.emptyMessage,
        containerProps = _b.containerProps,
        moreItemsDropdownProps = _b.moreItemsDropdownProps,
        MoreItemsItemComponent = _b.MoreItemsItemComponent,
        hideSelectedItems = _b.hideSelectedItems,
        disabledItems = _b.disabledItems,
        tooltipItems = _b.tooltipItems,
        otherProps = __rest(_b, ["items", "selectedItems", "previewItemsNumber", "className", "onSelect", "onChange", "onSearch", "hasSearch", "searchPlaceholder", "onSuggest", "onRemove", "keepOpen", "itemComponent", "suggestionComponent", "pagination", "emptyComponent", "emptyMessage", "containerProps", "moreItemsDropdownProps", "MoreItemsItemComponent", "hideSelectedItems", "disabledItems", "tooltipItems"]);

    var rootClass = classnames((_a = {}, _a[styles$11.items] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, /*#__PURE__*/React.createElement(DropdownSelectWrapper, __assign({
      items: items,
      itemComponent: itemComponent,
      hasSearch: hasSearch,
      searchPlaceholder: searchPlaceholder,
      suggestionComponent: suggestionComponent,
      onSuggest: onSuggest,
      keepOpen: keepOpen,
      onSearch: onSearch,
      onSelect: onSelect,
      onChange: onChange,
      pagination: pagination,
      emptyComponent: emptyComponent,
      emptyMessage: emptyMessage,
      containerProps: containerProps,
      selectedItems: selectedItems,
      disabledItems: disabledItems,
      tooltipItems: tooltipItems
    }, otherProps)), !hideSelectedItems && this.getPreviewItems());
  };

  DropdownSelectMultiple.defaultProps = {
    MoreItemsItemComponent: DeselectItem,
    hideSelectedItems: false,
    disabledItems: [],
    tooltipItems: {}
  };
  return DropdownSelectMultiple;
}(Component);

var css_248z$1b = "@-webkit-keyframes emojiPicker--emojiCategory__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes emojiPicker--emojiCategory__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes emojiPicker--emojiCategory__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes emojiPicker--emojiCategory__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emojiPicker--emojiCategory__root {\n  position: relative;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 36px;\n  height: 36px;\n  width: 36px;\n  background: #fff;\n  color: #7a7a7a; }\n  .emojiPicker--emojiCategory__root::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #5644d8;\n    opacity: 0;\n    transition: opacity 100ms linear; }\n  .emojiPicker--emojiCategory__rootActive {\n    color: #393939; }\n    .emojiPicker--emojiCategory__rootActive::after {\n      opacity: 1; }\n";
var styles$12 = {"root":"emojiPicker--emojiCategory__root","rootActive":"emojiPicker--emojiCategory__rootActive","wiggle":"emojiPicker--emojiCategory__wiggle","spin":"emojiPicker--emojiCategory__spin"};
styleInject(css_248z$1b);

var EmojiCategory = function EmojiCategory(_a) {
  var _b;

  var category = _a.category,
      active = _a.active,
      gotoCategory = _a.gotoCategory;
  var rootClass = classnames((_b = {}, _b[styles$12.root] = true, _b[styles$12.rootActive] = active, _b));
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    key: category.key,
    className: rootClass,
    title: category.name,
    onClick: function onClick() {
      return gotoCategory(category.key);
    }
  }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
    name: category.icon
  }));
};
EmojiCategory.displayName = 'EmojiCategory';

var css_248z$1c = "@-webkit-keyframes emojiPicker--emojiPicker__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes emojiPicker--emojiPicker__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes emojiPicker--emojiPicker__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes emojiPicker--emojiPicker__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emojiPicker--emojiPicker__root {\n  position: relative;\n  box-shadow: 0 0 1px 0 rgba(15, 31, 66, 0.08), 0 8px 10px 0 rgba(15, 31, 66, 0.1);\n  border-radius: 6px;\n  background: #fff;\n  width: 100vw;\n  height: 100vh;\n  max-width: 374px;\n  max-height: 350px;\n  overflow: hidden; }\n\n.emojiPicker--emojiPicker__categories {\n  display: block;\n  height: 42px;\n  max-height: 42px;\n  padding: 5px 0 0 5px;\n  border-bottom: 1px solid #bbb;\n  box-sizing: border-box; }\n\n.emojiPicker--emojiPicker__container {\n  position: relative;\n  max-height: 308px;\n  height: 308px; }\n\n.emojiPicker--emojiPicker__grid {\n  overflow: hidden;\n  overflow-y: auto;\n  overflow-x: auto;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 308px;\n  height: 308px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 0 20px 10px; }\n  .emojiPicker--emojiPicker__grid::-webkit-scrollbar {\n    width: 7px;\n    height: 7px; }\n  .emojiPicker--emojiPicker__grid::-webkit-scrollbar-track {\n    background-color: #fff; }\n  .emojiPicker--emojiPicker__grid::-webkit-scrollbar-thumb {\n    background-color: #dcdcdc;\n    border-radius: 5px; }\n";
var styles$13 = {"root":"emojiPicker--emojiPicker__root","categories":"emojiPicker--emojiPicker__categories","container":"emojiPicker--emojiPicker__container","grid":"emojiPicker--emojiPicker__grid","wiggle":"emojiPicker--emojiPicker__wiggle","spin":"emojiPicker--emojiPicker__spin"};
styleInject(css_248z$1c);

var css_248z$1d = "@-webkit-keyframes emojiPicker--emojiButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes emojiPicker--emojiButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes emojiPicker--emojiButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes emojiPicker--emojiButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emojiPicker--emojiButton__root {\n  outline: 0;\n  border: 0;\n  border-radius: 3px;\n  margin: 0 2px 0 0;\n  padding: 0;\n  height: 30px;\n  width: 30px;\n  font-size: 22px;\n  line-height: 30px;\n  text-align: center;\n  display: inline-block;\n  background: transparent;\n  cursor: pointer; }\n  .emojiPicker--emojiButton__root:hover {\n    background-color: #dad5e7; }\n";
var styles$14 = {"root":"emojiPicker--emojiButton__root","wiggle":"emojiPicker--emojiButton__wiggle","spin":"emojiPicker--emojiButton__spin"};
styleInject(css_248z$1d);

var EmojiButton = function EmojiButton(_a) {
  var emoji = _a.emoji,
      onSelect = _a.onSelect;
  var emojiUnicode = emoji.emoji;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onSelect(emojiUnicode);
    },
    className: styles$14.root
  }, emojiUnicode);
};
EmojiButton.displayName = 'Emoji';

var css_248z$1e = "@-webkit-keyframes emojiPicker--emojiSection__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes emojiPicker--emojiSection__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes emojiPicker--emojiSection__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes emojiPicker--emojiSection__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emojiPicker--emojiSection__sectionHeader {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  flex: 1 0 100%;\n  color: #9b9b9b;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 700;\n  padding: 10px 5px 2px 5px;\n  margin: 0; }\n  .emojiPicker--emojiSection__sectionHeader:first-child {\n    margin-top: 5px; }\n";
var styles$15 = {"sectionHeader":"emojiPicker--emojiSection__sectionHeader","wiggle":"emojiPicker--emojiSection__wiggle","spin":"emojiPicker--emojiSection__spin"};
styleInject(css_248z$1e);

/* eslint arrow-parens: ["error", "always"] */
var EmojiSection = function EmojiSection(_a) {
  var emojis = _a.emojis,
      category = _a.category,
      onSelect = _a.onSelect,
      sectionRef = _a.sectionRef;
  return /*#__PURE__*/React.createElement("div", {
    key: category.key
  }, /*#__PURE__*/React.createElement("div", {
    ref: sectionRef,
    "data-ref": category.key,
    className: "tracker"
  }), !!emojis.length && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$15.sectionHeader
  }, category.name), emojis.map(function (emoji) {
    return /*#__PURE__*/React.createElement(EmojiButton, {
      key: emoji.emoji,
      emoji: emoji,
      onSelect: onSelect
    });
  })));
};
EmojiSection.displayName = 'EmojiSection';

var categories = [
	{
		key: 0,
		name: "Frequently used",
		icon: "clock"
	},
	{
		key: 1,
		name: "Smileys & People",
		icon: "smile"
	},
	{
		key: 2,
		name: "Animals & Nature",
		icon: "sun"
	},
	{
		key: 3,
		name: "Food & Drink",
		icon: "hamburger"
	},
	{
		key: 4,
		name: "Activities",
		icon: "american-football"
	},
	{
		key: 5,
		name: "Travel & Places",
		icon: "plane"
	},
	{
		key: 6,
		name: "Objects",
		icon: "lightbulb"
	},
	{
		key: 7,
		name: "Symbols",
		icon: "info"
	},
	{
		key: 8,
		name: "Flags",
		icon: "flag"
	}
];
var emojis = [
	[
	],
	[
		{
			emoji: "😀",
			name: "GRINNING FACE",
			added_in: "6.1",
			shortName: "grinning",
			shortNames: [
				"grinning"
			],
			category: 1
		},
		{
			emoji: "😁",
			name: "GRINNING FACE WITH SMILING EYES",
			added_in: "6.0",
			shortName: "grin",
			shortNames: [
				"grin"
			],
			category: 1
		},
		{
			emoji: "😂",
			name: "FACE WITH TEARS OF JOY",
			added_in: "6.0",
			shortName: "joy",
			shortNames: [
				"joy"
			],
			category: 1
		},
		{
			emoji: "😃",
			name: "SMILING FACE WITH OPEN MOUTH",
			added_in: "6.0",
			shortName: "smiley",
			shortNames: [
				"smiley"
			],
			category: 1
		},
		{
			emoji: "😄",
			name: "SMILING FACE WITH OPEN MOUTH AND SMILING EYES",
			added_in: "6.0",
			shortName: "smile",
			shortNames: [
				"smile"
			],
			category: 1
		},
		{
			emoji: "😅",
			name: "SMILING FACE WITH OPEN MOUTH AND COLD SWEAT",
			added_in: "6.0",
			shortName: "sweat_smile",
			shortNames: [
				"sweat_smile"
			],
			category: 1
		},
		{
			emoji: "😆",
			name: "SMILING FACE WITH OPEN MOUTH AND TIGHTLY-CLOSED EYES",
			added_in: "6.0",
			shortName: "laughing",
			shortNames: [
				"laughing",
				"satisfied"
			],
			category: 1
		},
		{
			emoji: "😇",
			name: "SMILING FACE WITH HALO",
			added_in: "6.0",
			shortName: "innocent",
			shortNames: [
				"innocent"
			],
			category: 1
		},
		{
			emoji: "😉",
			name: "WINKING FACE",
			added_in: "6.0",
			shortName: "wink",
			shortNames: [
				"wink"
			],
			category: 1
		},
		{
			emoji: "😊",
			name: "SMILING FACE WITH SMILING EYES",
			added_in: "6.0",
			shortName: "blush",
			shortNames: [
				"blush"
			],
			category: 1
		},
		{
			emoji: "😋",
			name: "FACE SAVOURING DELICIOUS FOOD",
			added_in: "6.0",
			shortName: "yum",
			shortNames: [
				"yum"
			],
			category: 1
		},
		{
			emoji: "😌",
			name: "RELIEVED FACE",
			added_in: "6.0",
			shortName: "relieved",
			shortNames: [
				"relieved"
			],
			category: 1
		},
		{
			emoji: "😍",
			name: "SMILING FACE WITH HEART-SHAPED EYES",
			added_in: "6.0",
			shortName: "heart_eyes",
			shortNames: [
				"heart_eyes"
			],
			category: 1
		},
		{
			emoji: "😎",
			name: "SMILING FACE WITH SUNGLASSES",
			added_in: "6.0",
			shortName: "sunglasses",
			shortNames: [
				"sunglasses"
			],
			category: 1
		},
		{
			emoji: "😏",
			name: "SMIRKING FACE",
			added_in: "6.0",
			shortName: "smirk",
			shortNames: [
				"smirk"
			],
			category: 1
		},
		{
			emoji: "😐",
			name: "NEUTRAL FACE",
			added_in: "6.0",
			shortName: "neutral_face",
			shortNames: [
				"neutral_face"
			],
			category: 1
		},
		{
			emoji: "😑",
			name: "EXPRESSIONLESS FACE",
			added_in: "6.1",
			shortName: "expressionless",
			shortNames: [
				"expressionless"
			],
			category: 1
		},
		{
			emoji: "😒",
			name: "UNAMUSED FACE",
			added_in: "6.0",
			shortName: "unamused",
			shortNames: [
				"unamused"
			],
			category: 1
		},
		{
			emoji: "😓",
			name: "FACE WITH COLD SWEAT",
			added_in: "6.0",
			shortName: "sweat",
			shortNames: [
				"sweat"
			],
			category: 1
		},
		{
			emoji: "😔",
			name: "PENSIVE FACE",
			added_in: "6.0",
			shortName: "pensive",
			shortNames: [
				"pensive"
			],
			category: 1
		},
		{
			emoji: "😕",
			name: "CONFUSED FACE",
			added_in: "6.1",
			shortName: "confused",
			shortNames: [
				"confused"
			],
			category: 1
		},
		{
			emoji: "😖",
			name: "CONFOUNDED FACE",
			added_in: "6.0",
			shortName: "confounded",
			shortNames: [
				"confounded"
			],
			category: 1
		},
		{
			emoji: "😗",
			name: "KISSING FACE",
			added_in: "6.1",
			shortName: "kissing",
			shortNames: [
				"kissing"
			],
			category: 1
		},
		{
			emoji: "😘",
			name: "FACE THROWING A KISS",
			added_in: "6.0",
			shortName: "kissing_heart",
			shortNames: [
				"kissing_heart"
			],
			category: 1
		},
		{
			emoji: "😙",
			name: "KISSING FACE WITH SMILING EYES",
			added_in: "6.1",
			shortName: "kissing_smiling_eyes",
			shortNames: [
				"kissing_smiling_eyes"
			],
			category: 1
		},
		{
			emoji: "😚",
			name: "KISSING FACE WITH CLOSED EYES",
			added_in: "6.0",
			shortName: "kissing_closed_eyes",
			shortNames: [
				"kissing_closed_eyes"
			],
			category: 1
		},
		{
			emoji: "😛",
			name: "FACE WITH STUCK-OUT TONGUE",
			added_in: "6.1",
			shortName: "stuck_out_tongue",
			shortNames: [
				"stuck_out_tongue"
			],
			category: 1
		},
		{
			emoji: "😜",
			name: "FACE WITH STUCK-OUT TONGUE AND WINKING EYE",
			added_in: "6.0",
			shortName: "stuck_out_tongue_winking_eye",
			shortNames: [
				"stuck_out_tongue_winking_eye"
			],
			category: 1
		},
		{
			emoji: "😝",
			name: "FACE WITH STUCK-OUT TONGUE AND TIGHTLY-CLOSED EYES",
			added_in: "6.0",
			shortName: "stuck_out_tongue_closed_eyes",
			shortNames: [
				"stuck_out_tongue_closed_eyes"
			],
			category: 1
		},
		{
			emoji: "😞",
			name: "DISAPPOINTED FACE",
			added_in: "6.0",
			shortName: "disappointed",
			shortNames: [
				"disappointed"
			],
			category: 1
		},
		{
			emoji: "😟",
			name: "WORRIED FACE",
			added_in: "6.1",
			shortName: "worried",
			shortNames: [
				"worried"
			],
			category: 1
		},
		{
			emoji: "😠",
			name: "ANGRY FACE",
			added_in: "6.0",
			shortName: "angry",
			shortNames: [
				"angry"
			],
			category: 1
		},
		{
			emoji: "😡",
			name: "POUTING FACE",
			added_in: "6.0",
			shortName: "rage",
			shortNames: [
				"rage"
			],
			category: 1
		},
		{
			emoji: "😢",
			name: "CRYING FACE",
			added_in: "6.0",
			shortName: "cry",
			shortNames: [
				"cry"
			],
			category: 1
		},
		{
			emoji: "😣",
			name: "PERSEVERING FACE",
			added_in: "6.0",
			shortName: "persevere",
			shortNames: [
				"persevere"
			],
			category: 1
		},
		{
			emoji: "😤",
			name: "FACE WITH LOOK OF TRIUMPH",
			added_in: "6.0",
			shortName: "triumph",
			shortNames: [
				"triumph"
			],
			category: 1
		},
		{
			emoji: "😥",
			name: "DISAPPOINTED BUT RELIEVED FACE",
			added_in: "6.0",
			shortName: "disappointed_relieved",
			shortNames: [
				"disappointed_relieved"
			],
			category: 1
		},
		{
			emoji: "😦",
			name: "FROWNING FACE WITH OPEN MOUTH",
			added_in: "6.1",
			shortName: "frowning",
			shortNames: [
				"frowning"
			],
			category: 1
		},
		{
			emoji: "😧",
			name: "ANGUISHED FACE",
			added_in: "6.1",
			shortName: "anguished",
			shortNames: [
				"anguished"
			],
			category: 1
		},
		{
			emoji: "😨",
			name: "FEARFUL FACE",
			added_in: "6.0",
			shortName: "fearful",
			shortNames: [
				"fearful"
			],
			category: 1
		},
		{
			emoji: "😩",
			name: "WEARY FACE",
			added_in: "6.0",
			shortName: "weary",
			shortNames: [
				"weary"
			],
			category: 1
		},
		{
			emoji: "😪",
			name: "SLEEPY FACE",
			added_in: "6.0",
			shortName: "sleepy",
			shortNames: [
				"sleepy"
			],
			category: 1
		},
		{
			emoji: "😫",
			name: "TIRED FACE",
			added_in: "6.0",
			shortName: "tired_face",
			shortNames: [
				"tired_face"
			],
			category: 1
		},
		{
			emoji: "😬",
			name: "GRIMACING FACE",
			added_in: "6.1",
			shortName: "grimacing",
			shortNames: [
				"grimacing"
			],
			category: 1
		},
		{
			emoji: "😭",
			name: "LOUDLY CRYING FACE",
			added_in: "6.0",
			shortName: "sob",
			shortNames: [
				"sob"
			],
			category: 1
		},
		{
			emoji: "😮",
			name: "FACE WITH OPEN MOUTH",
			added_in: "6.1",
			shortName: "open_mouth",
			shortNames: [
				"open_mouth"
			],
			category: 1
		},
		{
			emoji: "😯",
			name: "HUSHED FACE",
			added_in: "6.1",
			shortName: "hushed",
			shortNames: [
				"hushed"
			],
			category: 1
		},
		{
			emoji: "😰",
			name: "FACE WITH OPEN MOUTH AND COLD SWEAT",
			added_in: "6.0",
			shortName: "cold_sweat",
			shortNames: [
				"cold_sweat"
			],
			category: 1
		},
		{
			emoji: "😱",
			name: "FACE SCREAMING IN FEAR",
			added_in: "6.0",
			shortName: "scream",
			shortNames: [
				"scream"
			],
			category: 1
		},
		{
			emoji: "😲",
			name: "ASTONISHED FACE",
			added_in: "6.0",
			shortName: "astonished",
			shortNames: [
				"astonished"
			],
			category: 1
		},
		{
			emoji: "😳",
			name: "FLUSHED FACE",
			added_in: "6.0",
			shortName: "flushed",
			shortNames: [
				"flushed"
			],
			category: 1
		},
		{
			emoji: "😴",
			name: "SLEEPING FACE",
			added_in: "6.1",
			shortName: "sleeping",
			shortNames: [
				"sleeping"
			],
			category: 1
		},
		{
			emoji: "😵",
			name: "DIZZY FACE",
			added_in: "6.0",
			shortName: "dizzy_face",
			shortNames: [
				"dizzy_face"
			],
			category: 1
		},
		{
			emoji: "😶",
			name: "FACE WITHOUT MOUTH",
			added_in: "6.0",
			shortName: "no_mouth",
			shortNames: [
				"no_mouth"
			],
			category: 1
		},
		{
			emoji: "😷",
			name: "FACE WITH MEDICAL MASK",
			added_in: "6.0",
			shortName: "mask",
			shortNames: [
				"mask"
			],
			category: 1
		},
		{
			emoji: "🙂",
			name: "SLIGHTLY SMILING FACE",
			added_in: "7.0",
			shortName: "slightly_smiling_face",
			shortNames: [
				"slightly_smiling_face"
			],
			category: 1
		},
		{
			emoji: "👿",
			name: "IMP",
			added_in: "6.0",
			shortName: "imp",
			shortNames: [
				"imp"
			],
			category: 1
		},
		{
			emoji: "😈",
			name: "SMILING FACE WITH HORNS",
			added_in: "6.0",
			shortName: "smiling_imp",
			shortNames: [
				"smiling_imp"
			],
			category: 1
		},
		{
			emoji: "👆",
			name: "WHITE UP POINTING BACKHAND INDEX",
			added_in: "6.0",
			shortName: "point_up_2",
			shortNames: [
				"point_up_2"
			],
			category: 1
		},
		{
			emoji: "👇",
			name: "WHITE DOWN POINTING BACKHAND INDEX",
			added_in: "6.0",
			shortName: "point_down",
			shortNames: [
				"point_down"
			],
			category: 1
		},
		{
			emoji: "👈",
			name: "WHITE LEFT POINTING BACKHAND INDEX",
			added_in: "6.0",
			shortName: "point_left",
			shortNames: [
				"point_left"
			],
			category: 1
		},
		{
			emoji: "👉",
			name: "WHITE RIGHT POINTING BACKHAND INDEX",
			added_in: "6.0",
			shortName: "point_right",
			shortNames: [
				"point_right"
			],
			category: 1
		},
		{
			emoji: "👊",
			name: "FISTED HAND SIGN",
			added_in: "6.0",
			shortName: "facepunch",
			shortNames: [
				"facepunch",
				"punch"
			],
			category: 1
		},
		{
			emoji: "👋",
			name: "WAVING HAND SIGN",
			added_in: "6.0",
			shortName: "wave",
			shortNames: [
				"wave"
			],
			category: 1
		},
		{
			emoji: "👌",
			name: "OK HAND SIGN",
			added_in: "6.0",
			shortName: "ok_hand",
			shortNames: [
				"ok_hand"
			],
			category: 1
		},
		{
			emoji: "👍",
			name: "THUMBS UP SIGN",
			added_in: "6.0",
			shortName: "+1",
			shortNames: [
				"+1",
				"thumbsup"
			],
			category: 1
		},
		{
			emoji: "👎",
			name: "THUMBS DOWN SIGN",
			added_in: "6.0",
			shortName: "-1",
			shortNames: [
				"-1",
				"thumbsdown"
			],
			category: 1
		},
		{
			emoji: "👏",
			name: "CLAPPING HANDS SIGN",
			added_in: "6.0",
			shortName: "clap",
			shortNames: [
				"clap"
			],
			category: 1
		},
		{
			emoji: "👐",
			name: "OPEN HANDS SIGN",
			added_in: "6.0",
			shortName: "open_hands",
			shortNames: [
				"open_hands"
			],
			category: 1
		},
		{
			emoji: "🙌",
			name: "PERSON RAISING BOTH HANDS IN CELEBRATION",
			added_in: "6.0",
			shortName: "raised_hands",
			shortNames: [
				"raised_hands"
			],
			category: 1
		},
		{
			emoji: "🙏",
			name: "PERSON WITH FOLDED HANDS",
			added_in: "6.0",
			shortName: "pray",
			shortNames: [
				"pray"
			],
			category: 1
		},
		{
			emoji: "☝️",
			name: "WHITE UP POINTING INDEX",
			added_in: "1.1",
			shortName: "point_up",
			shortNames: [
				"point_up"
			],
			category: 1
		},
		{
			emoji: "✊",
			name: "RAISED FIST",
			added_in: "6.0",
			shortName: "fist",
			shortNames: [
				"fist"
			],
			category: 1
		},
		{
			emoji: "✋",
			name: "RAISED HAND",
			added_in: "6.0",
			shortName: "hand",
			shortNames: [
				"hand",
				"raised_hand"
			],
			category: 1
		},
		{
			emoji: "✌️",
			name: "VICTORY HAND",
			added_in: "1.1",
			shortName: "v",
			shortNames: [
				"v"
			],
			category: 1
		},
		{
			emoji: "😸",
			name: "GRINNING CAT FACE WITH SMILING EYES",
			added_in: "6.0",
			shortName: "smile_cat",
			shortNames: [
				"smile_cat"
			],
			category: 1
		},
		{
			emoji: "😹",
			name: "CAT FACE WITH TEARS OF JOY",
			added_in: "6.0",
			shortName: "joy_cat",
			shortNames: [
				"joy_cat"
			],
			category: 1
		},
		{
			emoji: "😺",
			name: "SMILING CAT FACE WITH OPEN MOUTH",
			added_in: "6.0",
			shortName: "smiley_cat",
			shortNames: [
				"smiley_cat"
			],
			category: 1
		},
		{
			emoji: "😻",
			name: "SMILING CAT FACE WITH HEART-SHAPED EYES",
			added_in: "6.0",
			shortName: "heart_eyes_cat",
			shortNames: [
				"heart_eyes_cat"
			],
			category: 1
		},
		{
			emoji: "😼",
			name: "CAT FACE WITH WRY SMILE",
			added_in: "6.0",
			shortName: "smirk_cat",
			shortNames: [
				"smirk_cat"
			],
			category: 1
		},
		{
			emoji: "😽",
			name: "KISSING CAT FACE WITH CLOSED EYES",
			added_in: "6.0",
			shortName: "kissing_cat",
			shortNames: [
				"kissing_cat"
			],
			category: 1
		},
		{
			emoji: "😾",
			name: "POUTING CAT FACE",
			added_in: "6.0",
			shortName: "pouting_cat",
			shortNames: [
				"pouting_cat"
			],
			category: 1
		},
		{
			emoji: "😿",
			name: "CRYING CAT FACE",
			added_in: "6.0",
			shortName: "crying_cat_face",
			shortNames: [
				"crying_cat_face"
			],
			category: 1
		},
		{
			emoji: "🙀",
			name: "WEARY CAT FACE",
			added_in: "6.0",
			shortName: "scream_cat",
			shortNames: [
				"scream_cat"
			],
			category: 1
		},
		{
			emoji: "🙈",
			name: "SEE-NO-EVIL MONKEY",
			added_in: "6.0",
			shortName: "see_no_evil",
			shortNames: [
				"see_no_evil"
			],
			category: 1
		},
		{
			emoji: "🙉",
			name: "HEAR-NO-EVIL MONKEY",
			added_in: "6.0",
			shortName: "hear_no_evil",
			shortNames: [
				"hear_no_evil"
			],
			category: 1
		},
		{
			emoji: "🙊",
			name: "SPEAK-NO-EVIL MONKEY",
			added_in: "6.0",
			shortName: "speak_no_evil",
			shortNames: [
				"speak_no_evil"
			],
			category: 1
		},
		{
			emoji: "🎅",
			name: "FATHER CHRISTMAS",
			added_in: "6.0",
			shortName: "santa",
			shortNames: [
				"santa"
			],
			category: 1
		},
		{
			emoji: "👦",
			name: "BOY",
			added_in: "6.0",
			shortName: "boy",
			shortNames: [
				"boy"
			],
			category: 1
		},
		{
			emoji: "👧",
			name: "GIRL",
			added_in: "6.0",
			shortName: "girl",
			shortNames: [
				"girl"
			],
			category: 1
		},
		{
			emoji: "👨‍👨‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-man-boy",
			shortNames: [
				"man-man-boy"
			],
			category: 1
		},
		{
			emoji: "👨‍👨‍👦‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-man-boy-boy",
			shortNames: [
				"man-man-boy-boy"
			],
			category: 1
		},
		{
			emoji: "👨‍👨‍👧",
			name: null,
			added_in: "6.0",
			shortName: "man-man-girl",
			shortNames: [
				"man-man-girl"
			],
			category: 1
		},
		{
			emoji: "👨‍👨‍👧‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-man-girl-boy",
			shortNames: [
				"man-man-girl-boy"
			],
			category: 1
		},
		{
			emoji: "👨‍👨‍👧‍👧",
			name: null,
			added_in: "6.0",
			shortName: "man-man-girl-girl",
			shortNames: [
				"man-man-girl-girl"
			],
			category: 1
		},
		{
			emoji: "👨‍👩‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-woman-boy",
			shortNames: [
				"man-woman-boy",
				"family"
			],
			category: 1
		},
		{
			emoji: "👨‍👩‍👦‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-woman-boy-boy",
			shortNames: [
				"man-woman-boy-boy"
			],
			category: 1
		},
		{
			emoji: "👨‍👩‍👧",
			name: null,
			added_in: "6.0",
			shortName: "man-woman-girl",
			shortNames: [
				"man-woman-girl"
			],
			category: 1
		},
		{
			emoji: "👨‍👩‍👧‍👦",
			name: null,
			added_in: "6.0",
			shortName: "man-woman-girl-boy",
			shortNames: [
				"man-woman-girl-boy"
			],
			category: 1
		},
		{
			emoji: "👨‍👩‍👧‍👧",
			name: null,
			added_in: "6.0",
			shortName: "man-woman-girl-girl",
			shortNames: [
				"man-woman-girl-girl"
			],
			category: 1
		},
		{
			emoji: "👨‍❤️‍👨",
			name: null,
			added_in: "6.0",
			shortName: "man-heart-man",
			shortNames: [
				"man-heart-man"
			],
			category: 1
		},
		{
			emoji: "👨‍❤️‍💋‍👨",
			name: null,
			added_in: "6.0",
			shortName: "man-kiss-man",
			shortNames: [
				"man-kiss-man"
			],
			category: 1
		},
		{
			emoji: "👨",
			name: "MAN",
			added_in: "6.0",
			shortName: "man",
			shortNames: [
				"man"
			],
			category: 1
		},
		{
			emoji: "👩‍👩‍👦",
			name: null,
			added_in: "6.0",
			shortName: "woman-woman-boy",
			shortNames: [
				"woman-woman-boy"
			],
			category: 1
		},
		{
			emoji: "👩‍👩‍👦‍👦",
			name: null,
			added_in: "6.0",
			shortName: "woman-woman-boy-boy",
			shortNames: [
				"woman-woman-boy-boy"
			],
			category: 1
		},
		{
			emoji: "👩‍👩‍👧",
			name: null,
			added_in: "6.0",
			shortName: "woman-woman-girl",
			shortNames: [
				"woman-woman-girl"
			],
			category: 1
		},
		{
			emoji: "👩‍👩‍👧‍👦",
			name: null,
			added_in: "6.0",
			shortName: "woman-woman-girl-boy",
			shortNames: [
				"woman-woman-girl-boy"
			],
			category: 1
		},
		{
			emoji: "👩‍👩‍👧‍👧",
			name: null,
			added_in: "6.0",
			shortName: "woman-woman-girl-girl",
			shortNames: [
				"woman-woman-girl-girl"
			],
			category: 1
		},
		{
			emoji: "👩‍❤️‍👩",
			name: null,
			added_in: "6.0",
			shortName: "woman-heart-woman",
			shortNames: [
				"woman-heart-woman"
			],
			category: 1
		},
		{
			emoji: "👩‍❤️‍💋‍👩",
			name: null,
			added_in: "6.0",
			shortName: "woman-kiss-woman",
			shortNames: [
				"woman-kiss-woman"
			],
			category: 1
		},
		{
			emoji: "👩",
			name: "WOMAN",
			added_in: "6.0",
			shortName: "woman",
			shortNames: [
				"woman"
			],
			category: 1
		},
		{
			emoji: "👫",
			name: "MAN AND WOMAN HOLDING HANDS",
			added_in: "6.0",
			shortName: "couple",
			shortNames: [
				"couple",
				"man_and_woman_holding_hands"
			],
			category: 1
		},
		{
			emoji: "👬",
			name: "TWO MEN HOLDING HANDS",
			added_in: "6.0",
			shortName: "two_men_holding_hands",
			shortNames: [
				"two_men_holding_hands"
			],
			category: 1
		},
		{
			emoji: "👭",
			name: "TWO WOMEN HOLDING HANDS",
			added_in: "6.0",
			shortName: "two_women_holding_hands",
			shortNames: [
				"two_women_holding_hands"
			],
			category: 1
		},
		{
			emoji: "👲",
			name: "MAN WITH GUA PI MAO",
			added_in: "6.0",
			shortName: "man_with_gua_pi_mao",
			shortNames: [
				"man_with_gua_pi_mao"
			],
			category: 1
		},
		{
			emoji: "👴",
			name: "OLDER MAN",
			added_in: "6.0",
			shortName: "older_man",
			shortNames: [
				"older_man"
			],
			category: 1
		},
		{
			emoji: "👵",
			name: "OLDER WOMAN",
			added_in: "6.0",
			shortName: "older_woman",
			shortNames: [
				"older_woman"
			],
			category: 1
		},
		{
			emoji: "👰",
			name: "BRIDE WITH VEIL",
			added_in: "6.0",
			shortName: "bride_with_veil",
			shortNames: [
				"bride_with_veil"
			],
			category: 1
		},
		{
			emoji: "👶",
			name: "BABY",
			added_in: "6.0",
			shortName: "baby",
			shortNames: [
				"baby"
			],
			category: 1
		},
		{
			emoji: "👸",
			name: "PRINCESS",
			added_in: "6.0",
			shortName: "princess",
			shortNames: [
				"princess"
			],
			category: 1
		},
		{
			emoji: "👼",
			name: "BABY ANGEL",
			added_in: "6.0",
			shortName: "angel",
			shortNames: [
				"angel"
			],
			category: 1
		},
		{
			emoji: "🎩",
			name: "TOP HAT",
			added_in: "6.0",
			shortName: "tophat",
			shortNames: [
				"tophat"
			],
			category: 1
		},
		{
			emoji: "👒",
			name: "WOMANS HAT",
			added_in: "6.0",
			shortName: "womans_hat",
			shortNames: [
				"womans_hat"
			],
			category: 1
		},
		{
			emoji: "👕",
			name: "T-SHIRT",
			added_in: "6.0",
			shortName: "shirt",
			shortNames: [
				"shirt",
				"tshirt"
			],
			category: 1
		},
		{
			emoji: "👚",
			name: "WOMANS CLOTHES",
			added_in: "6.0",
			shortName: "womans_clothes",
			shortNames: [
				"womans_clothes"
			],
			category: 1
		},
		{
			emoji: "👜",
			name: "HANDBAG",
			added_in: "6.0",
			shortName: "handbag",
			shortNames: [
				"handbag"
			],
			category: 1
		},
		{
			emoji: "👞",
			name: "MANS SHOE",
			added_in: "6.0",
			shortName: "mans_shoe",
			shortNames: [
				"mans_shoe",
				"shoe"
			],
			category: 1
		},
		{
			emoji: "👟",
			name: "ATHLETIC SHOE",
			added_in: "6.0",
			shortName: "athletic_shoe",
			shortNames: [
				"athletic_shoe"
			],
			category: 1
		},
		{
			emoji: "👠",
			name: "HIGH-HEELED SHOE",
			added_in: "6.0",
			shortName: "high_heel",
			shortNames: [
				"high_heel"
			],
			category: 1
		},
		{
			emoji: "👡",
			name: "WOMANS SANDAL",
			added_in: "6.0",
			shortName: "sandal",
			shortNames: [
				"sandal"
			],
			category: 1
		},
		{
			emoji: "👢",
			name: "WOMANS BOOTS",
			added_in: "6.0",
			shortName: "boot",
			shortNames: [
				"boot"
			],
			category: 1
		},
		{
			emoji: "🎒",
			name: "SCHOOL SATCHEL",
			added_in: "6.0",
			shortName: "school_satchel",
			shortNames: [
				"school_satchel"
			],
			category: 1
		},
		{
			emoji: "🎓",
			name: "GRADUATION CAP",
			added_in: "6.0",
			shortName: "mortar_board",
			shortNames: [
				"mortar_board"
			],
			category: 1
		},
		{
			emoji: "🏂",
			name: "SNOWBOARDER",
			added_in: "6.0",
			shortName: "snowboarder",
			shortNames: [
				"snowboarder"
			],
			category: 1
		},
		{
			emoji: "🏇",
			name: "HORSE RACING",
			added_in: "6.0",
			shortName: "horse_racing",
			shortNames: [
				"horse_racing"
			],
			category: 1
		},
		{
			emoji: "👀",
			name: "EYES",
			added_in: "6.0",
			shortName: "eyes",
			shortNames: [
				"eyes"
			],
			category: 1
		},
		{
			emoji: "👂",
			name: "EAR",
			added_in: "6.0",
			shortName: "ear",
			shortNames: [
				"ear"
			],
			category: 1
		},
		{
			emoji: "👃",
			name: "NOSE",
			added_in: "6.0",
			shortName: "nose",
			shortNames: [
				"nose"
			],
			category: 1
		},
		{
			emoji: "👄",
			name: "MOUTH",
			added_in: "6.0",
			shortName: "lips",
			shortNames: [
				"lips"
			],
			category: 1
		},
		{
			emoji: "👅",
			name: "TONGUE",
			added_in: "6.0",
			shortName: "tongue",
			shortNames: [
				"tongue"
			],
			category: 1
		},
		{
			emoji: "👑",
			name: "CROWN",
			added_in: "6.0",
			shortName: "crown",
			shortNames: [
				"crown"
			],
			category: 1
		},
		{
			emoji: "👓",
			name: "EYEGLASSES",
			added_in: "6.0",
			shortName: "eyeglasses",
			shortNames: [
				"eyeglasses"
			],
			category: 1
		},
		{
			emoji: "👔",
			name: "NECKTIE",
			added_in: "6.0",
			shortName: "necktie",
			shortNames: [
				"necktie"
			],
			category: 1
		},
		{
			emoji: "👖",
			name: "JEANS",
			added_in: "6.0",
			shortName: "jeans",
			shortNames: [
				"jeans"
			],
			category: 1
		},
		{
			emoji: "👗",
			name: "DRESS",
			added_in: "6.0",
			shortName: "dress",
			shortNames: [
				"dress"
			],
			category: 1
		},
		{
			emoji: "👘",
			name: "KIMONO",
			added_in: "6.0",
			shortName: "kimono",
			shortNames: [
				"kimono"
			],
			category: 1
		},
		{
			emoji: "👙",
			name: "BIKINI",
			added_in: "6.0",
			shortName: "bikini",
			shortNames: [
				"bikini"
			],
			category: 1
		},
		{
			emoji: "👛",
			name: "PURSE",
			added_in: "6.0",
			shortName: "purse",
			shortNames: [
				"purse"
			],
			category: 1
		},
		{
			emoji: "👝",
			name: "POUCH",
			added_in: "6.0",
			shortName: "pouch",
			shortNames: [
				"pouch"
			],
			category: 1
		},
		{
			emoji: "👣",
			name: "FOOTPRINTS",
			added_in: "6.0",
			shortName: "footprints",
			shortNames: [
				"footprints"
			],
			category: 1
		},
		{
			emoji: "👤",
			name: "BUST IN SILHOUETTE",
			added_in: "6.0",
			shortName: "bust_in_silhouette",
			shortNames: [
				"bust_in_silhouette"
			],
			category: 1
		},
		{
			emoji: "👥",
			name: "BUSTS IN SILHOUETTE",
			added_in: "6.0",
			shortName: "busts_in_silhouette",
			shortNames: [
				"busts_in_silhouette"
			],
			category: 1
		},
		{
			emoji: "👹",
			name: "JAPANESE OGRE",
			added_in: "6.0",
			shortName: "japanese_ogre",
			shortNames: [
				"japanese_ogre"
			],
			category: 1
		},
		{
			emoji: "👺",
			name: "JAPANESE GOBLIN",
			added_in: "6.0",
			shortName: "japanese_goblin",
			shortNames: [
				"japanese_goblin"
			],
			category: 1
		},
		{
			emoji: "👻",
			name: "GHOST",
			added_in: "6.0",
			shortName: "ghost",
			shortNames: [
				"ghost"
			],
			category: 1
		},
		{
			emoji: "👽",
			name: "EXTRATERRESTRIAL ALIEN",
			added_in: "6.0",
			shortName: "alien",
			shortNames: [
				"alien"
			],
			category: 1
		},
		{
			emoji: "👾",
			name: "ALIEN MONSTER",
			added_in: "6.0",
			shortName: "space_invader",
			shortNames: [
				"space_invader"
			],
			category: 1
		},
		{
			emoji: "💀",
			name: "SKULL",
			added_in: "6.0",
			shortName: "skull",
			shortNames: [
				"skull"
			],
			category: 1
		},
		{
			emoji: "💃",
			name: "DANCER",
			added_in: "6.0",
			shortName: "dancer",
			shortNames: [
				"dancer"
			],
			category: 1
		},
		{
			emoji: "💄",
			name: "LIPSTICK",
			added_in: "6.0",
			shortName: "lipstick",
			shortNames: [
				"lipstick"
			],
			category: 1
		},
		{
			emoji: "💅",
			name: "NAIL POLISH",
			added_in: "6.0",
			shortName: "nail_care",
			shortNames: [
				"nail_care"
			],
			category: 1
		},
		{
			emoji: "💋",
			name: "KISS MARK",
			added_in: "6.0",
			shortName: "kiss",
			shortNames: [
				"kiss"
			],
			category: 1
		},
		{
			emoji: "💌",
			name: "LOVE LETTER",
			added_in: "6.0",
			shortName: "love_letter",
			shortNames: [
				"love_letter"
			],
			category: 1
		},
		{
			emoji: "💍",
			name: "RING",
			added_in: "6.0",
			shortName: "ring",
			shortNames: [
				"ring"
			],
			category: 1
		},
		{
			emoji: "💎",
			name: "GEM STONE",
			added_in: "6.0",
			shortName: "gem",
			shortNames: [
				"gem"
			],
			category: 1
		},
		{
			emoji: "💓",
			name: "BEATING HEART",
			added_in: "6.0",
			shortName: "heartbeat",
			shortNames: [
				"heartbeat"
			],
			category: 1
		},
		{
			emoji: "💔",
			name: "BROKEN HEART",
			added_in: "6.0",
			shortName: "broken_heart",
			shortNames: [
				"broken_heart"
			],
			category: 1
		},
		{
			emoji: "💕",
			name: "TWO HEARTS",
			added_in: "6.0",
			shortName: "two_hearts",
			shortNames: [
				"two_hearts"
			],
			category: 1
		},
		{
			emoji: "💖",
			name: "SPARKLING HEART",
			added_in: "6.0",
			shortName: "sparkling_heart",
			shortNames: [
				"sparkling_heart"
			],
			category: 1
		},
		{
			emoji: "💗",
			name: "GROWING HEART",
			added_in: "6.0",
			shortName: "heartpulse",
			shortNames: [
				"heartpulse"
			],
			category: 1
		},
		{
			emoji: "💘",
			name: "HEART WITH ARROW",
			added_in: "6.0",
			shortName: "cupid",
			shortNames: [
				"cupid"
			],
			category: 1
		},
		{
			emoji: "💙",
			name: "BLUE HEART",
			added_in: "6.0",
			shortName: "blue_heart",
			shortNames: [
				"blue_heart"
			],
			category: 1
		},
		{
			emoji: "💚",
			name: "GREEN HEART",
			added_in: "6.0",
			shortName: "green_heart",
			shortNames: [
				"green_heart"
			],
			category: 1
		},
		{
			emoji: "💛",
			name: "YELLOW HEART",
			added_in: "6.0",
			shortName: "yellow_heart",
			shortNames: [
				"yellow_heart"
			],
			category: 1
		},
		{
			emoji: "💜",
			name: "PURPLE HEART",
			added_in: "6.0",
			shortName: "purple_heart",
			shortNames: [
				"purple_heart"
			],
			category: 1
		},
		{
			emoji: "💝",
			name: "HEART WITH RIBBON",
			added_in: "6.0",
			shortName: "gift_heart",
			shortNames: [
				"gift_heart"
			],
			category: 1
		},
		{
			emoji: "💞",
			name: "REVOLVING HEARTS",
			added_in: "6.0",
			shortName: "revolving_hearts",
			shortNames: [
				"revolving_hearts"
			],
			category: 1
		},
		{
			emoji: "💟",
			name: "HEART DECORATION",
			added_in: "6.0",
			shortName: "heart_decoration",
			shortNames: [
				"heart_decoration"
			],
			category: 1
		},
		{
			emoji: "💢",
			name: "ANGER SYMBOL",
			added_in: "6.0",
			shortName: "anger",
			shortNames: [
				"anger"
			],
			category: 1
		},
		{
			emoji: "💣",
			name: "BOMB",
			added_in: "6.0",
			shortName: "bomb",
			shortNames: [
				"bomb"
			],
			category: 1
		},
		{
			emoji: "💤",
			name: "SLEEPING SYMBOL",
			added_in: "6.0",
			shortName: "zzz",
			shortNames: [
				"zzz"
			],
			category: 1
		},
		{
			emoji: "💥",
			name: "COLLISION SYMBOL",
			added_in: "6.0",
			shortName: "boom",
			shortNames: [
				"boom",
				"collision"
			],
			category: 1
		},
		{
			emoji: "💦",
			name: "SPLASHING SWEAT SYMBOL",
			added_in: "6.0",
			shortName: "sweat_drops",
			shortNames: [
				"sweat_drops"
			],
			category: 1
		},
		{
			emoji: "💨",
			name: "DASH SYMBOL",
			added_in: "6.0",
			shortName: "dash",
			shortNames: [
				"dash"
			],
			category: 1
		},
		{
			emoji: "💩",
			name: "PILE OF POO",
			added_in: "6.0",
			shortName: "hankey",
			shortNames: [
				"hankey",
				"poop",
				"shit"
			],
			category: 1
		},
		{
			emoji: "💪",
			name: "FLEXED BICEPS",
			added_in: "6.0",
			shortName: "muscle",
			shortNames: [
				"muscle"
			],
			category: 1
		},
		{
			emoji: "💫",
			name: "DIZZY SYMBOL",
			added_in: "6.0",
			shortName: "dizzy",
			shortNames: [
				"dizzy"
			],
			category: 1
		},
		{
			emoji: "💬",
			name: "SPEECH BALLOON",
			added_in: "6.0",
			shortName: "speech_balloon",
			shortNames: [
				"speech_balloon"
			],
			category: 1
		},
		{
			emoji: "💭",
			name: "THOUGHT BALLOON",
			added_in: "6.0",
			shortName: "thought_balloon",
			shortNames: [
				"thought_balloon"
			],
			category: 1
		},
		{
			emoji: "🛀",
			name: "BATH",
			added_in: "6.0",
			shortName: "bath",
			shortNames: [
				"bath"
			],
			category: 1
		},
		{
			emoji: "❤️",
			name: "HEAVY BLACK HEART",
			added_in: "1.1",
			shortName: "heart",
			shortNames: [
				"heart"
			],
			category: 1
		}
	],
	[
		{
			emoji: "🐭",
			name: "MOUSE FACE",
			added_in: "6.0",
			shortName: "mouse",
			shortNames: [
				"mouse"
			],
			category: 2
		},
		{
			emoji: "🐮",
			name: "COW FACE",
			added_in: "6.0",
			shortName: "cow",
			shortNames: [
				"cow"
			],
			category: 2
		},
		{
			emoji: "🐯",
			name: "TIGER FACE",
			added_in: "6.0",
			shortName: "tiger",
			shortNames: [
				"tiger"
			],
			category: 2
		},
		{
			emoji: "🐰",
			name: "RABBIT FACE",
			added_in: "6.0",
			shortName: "rabbit",
			shortNames: [
				"rabbit"
			],
			category: 2
		},
		{
			emoji: "🐲",
			name: "DRAGON FACE",
			added_in: "6.0",
			shortName: "dragon_face",
			shortNames: [
				"dragon_face"
			],
			category: 2
		},
		{
			emoji: "🐴",
			name: "HORSE FACE",
			added_in: "6.0",
			shortName: "horse",
			shortNames: [
				"horse"
			],
			category: 2
		},
		{
			emoji: "🐵",
			name: "MONKEY FACE",
			added_in: "6.0",
			shortName: "monkey_face",
			shortNames: [
				"monkey_face"
			],
			category: 2
		},
		{
			emoji: "🐶",
			name: "DOG FACE",
			added_in: "6.0",
			shortName: "dog",
			shortNames: [
				"dog"
			],
			category: 2
		},
		{
			emoji: "🐷",
			name: "PIG FACE",
			added_in: "6.0",
			shortName: "pig",
			shortNames: [
				"pig"
			],
			category: 2
		},
		{
			emoji: "🐸",
			name: "FROG FACE",
			added_in: "6.0",
			shortName: "frog",
			shortNames: [
				"frog"
			],
			category: 2
		},
		{
			emoji: "🐹",
			name: "HAMSTER FACE",
			added_in: "6.0",
			shortName: "hamster",
			shortNames: [
				"hamster"
			],
			category: 2
		},
		{
			emoji: "🐺",
			name: "WOLF FACE",
			added_in: "6.0",
			shortName: "wolf",
			shortNames: [
				"wolf"
			],
			category: 2
		},
		{
			emoji: "🐻",
			name: "BEAR FACE",
			added_in: "6.0",
			shortName: "bear",
			shortNames: [
				"bear"
			],
			category: 2
		},
		{
			emoji: "🐼",
			name: "PANDA FACE",
			added_in: "6.0",
			shortName: "panda_face",
			shortNames: [
				"panda_face"
			],
			category: 2
		},
		{
			emoji: "🐱",
			name: "CAT FACE",
			added_in: "6.0",
			shortName: "cat",
			shortNames: [
				"cat"
			],
			category: 2
		},
		{
			emoji: "🐒",
			name: "MONKEY",
			added_in: "6.0",
			shortName: "monkey",
			shortNames: [
				"monkey"
			],
			category: 2
		},
		{
			emoji: "🐤",
			name: "BABY CHICK",
			added_in: "6.0",
			shortName: "baby_chick",
			shortNames: [
				"baby_chick"
			],
			category: 2
		},
		{
			emoji: "🐥",
			name: "FRONT-FACING BABY CHICK",
			added_in: "6.0",
			shortName: "hatched_chick",
			shortNames: [
				"hatched_chick"
			],
			category: 2
		},
		{
			emoji: "🐣",
			name: "HATCHING CHICK",
			added_in: "6.0",
			shortName: "hatching_chick",
			shortNames: [
				"hatching_chick"
			],
			category: 2
		},
		{
			emoji: "🌱",
			name: "SEEDLING",
			added_in: "6.0",
			shortName: "seedling",
			shortNames: [
				"seedling"
			],
			category: 2
		},
		{
			emoji: "🌲",
			name: "EVERGREEN TREE",
			added_in: "6.0",
			shortName: "evergreen_tree",
			shortNames: [
				"evergreen_tree"
			],
			category: 2
		},
		{
			emoji: "🌳",
			name: "DECIDUOUS TREE",
			added_in: "6.0",
			shortName: "deciduous_tree",
			shortNames: [
				"deciduous_tree"
			],
			category: 2
		},
		{
			emoji: "🌴",
			name: "PALM TREE",
			added_in: "6.0",
			shortName: "palm_tree",
			shortNames: [
				"palm_tree"
			],
			category: 2
		},
		{
			emoji: "🌵",
			name: "CACTUS",
			added_in: "6.0",
			shortName: "cactus",
			shortNames: [
				"cactus"
			],
			category: 2
		},
		{
			emoji: "🌷",
			name: "TULIP",
			added_in: "6.0",
			shortName: "tulip",
			shortNames: [
				"tulip"
			],
			category: 2
		},
		{
			emoji: "🌸",
			name: "CHERRY BLOSSOM",
			added_in: "6.0",
			shortName: "cherry_blossom",
			shortNames: [
				"cherry_blossom"
			],
			category: 2
		},
		{
			emoji: "🌹",
			name: "ROSE",
			added_in: "6.0",
			shortName: "rose",
			shortNames: [
				"rose"
			],
			category: 2
		},
		{
			emoji: "🌺",
			name: "HIBISCUS",
			added_in: "6.0",
			shortName: "hibiscus",
			shortNames: [
				"hibiscus"
			],
			category: 2
		},
		{
			emoji: "🌻",
			name: "SUNFLOWER",
			added_in: "6.0",
			shortName: "sunflower",
			shortNames: [
				"sunflower"
			],
			category: 2
		},
		{
			emoji: "🌼",
			name: "BLOSSOM",
			added_in: "6.0",
			shortName: "blossom",
			shortNames: [
				"blossom"
			],
			category: 2
		},
		{
			emoji: "🌾",
			name: "EAR OF RICE",
			added_in: "6.0",
			shortName: "ear_of_rice",
			shortNames: [
				"ear_of_rice"
			],
			category: 2
		},
		{
			emoji: "🌿",
			name: "HERB",
			added_in: "6.0",
			shortName: "herb",
			shortNames: [
				"herb"
			],
			category: 2
		},
		{
			emoji: "🍀",
			name: "FOUR LEAF CLOVER",
			added_in: "6.0",
			shortName: "four_leaf_clover",
			shortNames: [
				"four_leaf_clover"
			],
			category: 2
		},
		{
			emoji: "🍁",
			name: "MAPLE LEAF",
			added_in: "6.0",
			shortName: "maple_leaf",
			shortNames: [
				"maple_leaf"
			],
			category: 2
		},
		{
			emoji: "🍂",
			name: "FALLEN LEAF",
			added_in: "6.0",
			shortName: "fallen_leaf",
			shortNames: [
				"fallen_leaf"
			],
			category: 2
		},
		{
			emoji: "🍃",
			name: "LEAF FLUTTERING IN WIND",
			added_in: "6.0",
			shortName: "leaves",
			shortNames: [
				"leaves"
			],
			category: 2
		},
		{
			emoji: "🐀",
			name: "RAT",
			added_in: "6.0",
			shortName: "rat",
			shortNames: [
				"rat"
			],
			category: 2
		},
		{
			emoji: "🐁",
			name: "MOUSE",
			added_in: "6.0",
			shortName: "mouse2",
			shortNames: [
				"mouse2"
			],
			category: 2
		},
		{
			emoji: "🐂",
			name: "OX",
			added_in: "6.0",
			shortName: "ox",
			shortNames: [
				"ox"
			],
			category: 2
		},
		{
			emoji: "🐃",
			name: "WATER BUFFALO",
			added_in: "6.0",
			shortName: "water_buffalo",
			shortNames: [
				"water_buffalo"
			],
			category: 2
		},
		{
			emoji: "🐄",
			name: "COW",
			added_in: "6.0",
			shortName: "cow2",
			shortNames: [
				"cow2"
			],
			category: 2
		},
		{
			emoji: "🐅",
			name: "TIGER",
			added_in: "6.0",
			shortName: "tiger2",
			shortNames: [
				"tiger2"
			],
			category: 2
		},
		{
			emoji: "🐆",
			name: "LEOPARD",
			added_in: "6.0",
			shortName: "leopard",
			shortNames: [
				"leopard"
			],
			category: 2
		},
		{
			emoji: "🐇",
			name: "RABBIT",
			added_in: "6.0",
			shortName: "rabbit2",
			shortNames: [
				"rabbit2"
			],
			category: 2
		},
		{
			emoji: "🐈",
			name: "CAT",
			added_in: "6.0",
			shortName: "cat2",
			shortNames: [
				"cat2"
			],
			category: 2
		},
		{
			emoji: "🐉",
			name: "DRAGON",
			added_in: "6.0",
			shortName: "dragon",
			shortNames: [
				"dragon"
			],
			category: 2
		},
		{
			emoji: "🐊",
			name: "CROCODILE",
			added_in: "6.0",
			shortName: "crocodile",
			shortNames: [
				"crocodile"
			],
			category: 2
		},
		{
			emoji: "🐋",
			name: "WHALE",
			added_in: "6.0",
			shortName: "whale2",
			shortNames: [
				"whale2"
			],
			category: 2
		},
		{
			emoji: "🐌",
			name: "SNAIL",
			added_in: "6.0",
			shortName: "snail",
			shortNames: [
				"snail"
			],
			category: 2
		},
		{
			emoji: "🐍",
			name: "SNAKE",
			added_in: "6.0",
			shortName: "snake",
			shortNames: [
				"snake"
			],
			category: 2
		},
		{
			emoji: "🐎",
			name: "HORSE",
			added_in: "6.0",
			shortName: "racehorse",
			shortNames: [
				"racehorse"
			],
			category: 2
		},
		{
			emoji: "🐏",
			name: "RAM",
			added_in: "6.0",
			shortName: "ram",
			shortNames: [
				"ram"
			],
			category: 2
		},
		{
			emoji: "🐐",
			name: "GOAT",
			added_in: "6.0",
			shortName: "goat",
			shortNames: [
				"goat"
			],
			category: 2
		},
		{
			emoji: "🐑",
			name: "SHEEP",
			added_in: "6.0",
			shortName: "sheep",
			shortNames: [
				"sheep"
			],
			category: 2
		},
		{
			emoji: "🐓",
			name: "ROOSTER",
			added_in: "6.0",
			shortName: "rooster",
			shortNames: [
				"rooster"
			],
			category: 2
		},
		{
			emoji: "🐔",
			name: "CHICKEN",
			added_in: "6.0",
			shortName: "chicken",
			shortNames: [
				"chicken"
			],
			category: 2
		},
		{
			emoji: "🐕",
			name: "DOG",
			added_in: "6.0",
			shortName: "dog2",
			shortNames: [
				"dog2"
			],
			category: 2
		},
		{
			emoji: "🐖",
			name: "PIG",
			added_in: "6.0",
			shortName: "pig2",
			shortNames: [
				"pig2"
			],
			category: 2
		},
		{
			emoji: "🐗",
			name: "BOAR",
			added_in: "6.0",
			shortName: "boar",
			shortNames: [
				"boar"
			],
			category: 2
		},
		{
			emoji: "🐘",
			name: "ELEPHANT",
			added_in: "6.0",
			shortName: "elephant",
			shortNames: [
				"elephant"
			],
			category: 2
		},
		{
			emoji: "🐙",
			name: "OCTOPUS",
			added_in: "6.0",
			shortName: "octopus",
			shortNames: [
				"octopus"
			],
			category: 2
		},
		{
			emoji: "🐚",
			name: "SPIRAL SHELL",
			added_in: "6.0",
			shortName: "shell",
			shortNames: [
				"shell"
			],
			category: 2
		},
		{
			emoji: "🐛",
			name: "BUG",
			added_in: "6.0",
			shortName: "bug",
			shortNames: [
				"bug"
			],
			category: 2
		},
		{
			emoji: "🐜",
			name: "ANT",
			added_in: "6.0",
			shortName: "ant",
			shortNames: [
				"ant"
			],
			category: 2
		},
		{
			emoji: "🐝",
			name: "HONEYBEE",
			added_in: "6.0",
			shortName: "bee",
			shortNames: [
				"bee",
				"honeybee"
			],
			category: 2
		},
		{
			emoji: "🐞",
			name: "LADY BEETLE",
			added_in: "6.0",
			shortName: "beetle",
			shortNames: [
				"beetle"
			],
			category: 2
		},
		{
			emoji: "🐟",
			name: "FISH",
			added_in: "6.0",
			shortName: "fish",
			shortNames: [
				"fish"
			],
			category: 2
		},
		{
			emoji: "🐠",
			name: "TROPICAL FISH",
			added_in: "6.0",
			shortName: "tropical_fish",
			shortNames: [
				"tropical_fish"
			],
			category: 2
		},
		{
			emoji: "🐡",
			name: "BLOWFISH",
			added_in: "6.0",
			shortName: "blowfish",
			shortNames: [
				"blowfish"
			],
			category: 2
		},
		{
			emoji: "🐢",
			name: "TURTLE",
			added_in: "6.0",
			shortName: "turtle",
			shortNames: [
				"turtle"
			],
			category: 2
		},
		{
			emoji: "🐦",
			name: "BIRD",
			added_in: "6.0",
			shortName: "bird",
			shortNames: [
				"bird"
			],
			category: 2
		},
		{
			emoji: "🐧",
			name: "PENGUIN",
			added_in: "6.0",
			shortName: "penguin",
			shortNames: [
				"penguin"
			],
			category: 2
		},
		{
			emoji: "🐨",
			name: "KOALA",
			added_in: "6.0",
			shortName: "koala",
			shortNames: [
				"koala"
			],
			category: 2
		},
		{
			emoji: "🐩",
			name: "POODLE",
			added_in: "6.0",
			shortName: "poodle",
			shortNames: [
				"poodle"
			],
			category: 2
		},
		{
			emoji: "🐪",
			name: "DROMEDARY CAMEL",
			added_in: "6.0",
			shortName: "dromedary_camel",
			shortNames: [
				"dromedary_camel"
			],
			category: 2
		},
		{
			emoji: "🐫",
			name: "BACTRIAN CAMEL",
			added_in: "6.0",
			shortName: "camel",
			shortNames: [
				"camel"
			],
			category: 2
		},
		{
			emoji: "🐬",
			name: "DOLPHIN",
			added_in: "6.0",
			shortName: "dolphin",
			shortNames: [
				"dolphin",
				"flipper"
			],
			category: 2
		},
		{
			emoji: "🐳",
			name: "SPOUTING WHALE",
			added_in: "6.0",
			shortName: "whale",
			shortNames: [
				"whale"
			],
			category: 2
		},
		{
			emoji: "🐽",
			name: "PIG NOSE",
			added_in: "6.0",
			shortName: "pig_nose",
			shortNames: [
				"pig_nose"
			],
			category: 2
		},
		{
			emoji: "🐾",
			name: "PAW PRINTS",
			added_in: "6.0",
			shortName: "feet",
			shortNames: [
				"feet",
				"paw_prints"
			],
			category: 2
		},
		{
			emoji: "💐",
			name: "BOUQUET",
			added_in: "6.0",
			shortName: "bouquet",
			shortNames: [
				"bouquet"
			],
			category: 2
		},
		{
			emoji: "💮",
			name: "WHITE FLOWER",
			added_in: "6.0",
			shortName: "white_flower",
			shortNames: [
				"white_flower"
			],
			category: 2
		}
	],
	[
		{
			emoji: "🍤",
			name: "FRIED SHRIMP",
			added_in: "6.0",
			shortName: "fried_shrimp",
			shortNames: [
				"fried_shrimp"
			],
			category: 3
		},
		{
			emoji: "🍗",
			name: "POULTRY LEG",
			added_in: "6.0",
			shortName: "poultry_leg",
			shortNames: [
				"poultry_leg"
			],
			category: 3
		},
		{
			emoji: "🍵",
			name: "TEACUP WITHOUT HANDLE",
			added_in: "6.0",
			shortName: "tea",
			shortNames: [
				"tea"
			],
			category: 3
		},
		{
			emoji: "🍼",
			name: "BABY BOTTLE",
			added_in: "6.0",
			shortName: "baby_bottle",
			shortNames: [
				"baby_bottle"
			],
			category: 3
		},
		{
			emoji: "🌰",
			name: "CHESTNUT",
			added_in: "6.0",
			shortName: "chestnut",
			shortNames: [
				"chestnut"
			],
			category: 3
		},
		{
			emoji: "🌽",
			name: "EAR OF MAIZE",
			added_in: "6.0",
			shortName: "corn",
			shortNames: [
				"corn"
			],
			category: 3
		},
		{
			emoji: "🍄",
			name: "MUSHROOM",
			added_in: "6.0",
			shortName: "mushroom",
			shortNames: [
				"mushroom"
			],
			category: 3
		},
		{
			emoji: "🍅",
			name: "TOMATO",
			added_in: "6.0",
			shortName: "tomato",
			shortNames: [
				"tomato"
			],
			category: 3
		},
		{
			emoji: "🍆",
			name: "AUBERGINE",
			added_in: "6.0",
			shortName: "eggplant",
			shortNames: [
				"eggplant"
			],
			category: 3
		},
		{
			emoji: "🍇",
			name: "GRAPES",
			added_in: "6.0",
			shortName: "grapes",
			shortNames: [
				"grapes"
			],
			category: 3
		},
		{
			emoji: "🍈",
			name: "MELON",
			added_in: "6.0",
			shortName: "melon",
			shortNames: [
				"melon"
			],
			category: 3
		},
		{
			emoji: "🍉",
			name: "WATERMELON",
			added_in: "6.0",
			shortName: "watermelon",
			shortNames: [
				"watermelon"
			],
			category: 3
		},
		{
			emoji: "🍊",
			name: "TANGERINE",
			added_in: "6.0",
			shortName: "tangerine",
			shortNames: [
				"tangerine"
			],
			category: 3
		},
		{
			emoji: "🍋",
			name: "LEMON",
			added_in: "6.0",
			shortName: "lemon",
			shortNames: [
				"lemon"
			],
			category: 3
		},
		{
			emoji: "🍌",
			name: "BANANA",
			added_in: "6.0",
			shortName: "banana",
			shortNames: [
				"banana"
			],
			category: 3
		},
		{
			emoji: "🍍",
			name: "PINEAPPLE",
			added_in: "6.0",
			shortName: "pineapple",
			shortNames: [
				"pineapple"
			],
			category: 3
		},
		{
			emoji: "🍎",
			name: "RED APPLE",
			added_in: "6.0",
			shortName: "apple",
			shortNames: [
				"apple"
			],
			category: 3
		},
		{
			emoji: "🍏",
			name: "GREEN APPLE",
			added_in: "6.0",
			shortName: "green_apple",
			shortNames: [
				"green_apple"
			],
			category: 3
		},
		{
			emoji: "🍐",
			name: "PEAR",
			added_in: "6.0",
			shortName: "pear",
			shortNames: [
				"pear"
			],
			category: 3
		},
		{
			emoji: "🍑",
			name: "PEACH",
			added_in: "6.0",
			shortName: "peach",
			shortNames: [
				"peach"
			],
			category: 3
		},
		{
			emoji: "🍒",
			name: "CHERRIES",
			added_in: "6.0",
			shortName: "cherries",
			shortNames: [
				"cherries"
			],
			category: 3
		},
		{
			emoji: "🍓",
			name: "STRAWBERRY",
			added_in: "6.0",
			shortName: "strawberry",
			shortNames: [
				"strawberry"
			],
			category: 3
		},
		{
			emoji: "🍔",
			name: "HAMBURGER",
			added_in: "6.0",
			shortName: "hamburger",
			shortNames: [
				"hamburger"
			],
			category: 3
		},
		{
			emoji: "🍕",
			name: "SLICE OF PIZZA",
			added_in: "6.0",
			shortName: "pizza",
			shortNames: [
				"pizza"
			],
			category: 3
		},
		{
			emoji: "🍖",
			name: "MEAT ON BONE",
			added_in: "6.0",
			shortName: "meat_on_bone",
			shortNames: [
				"meat_on_bone"
			],
			category: 3
		},
		{
			emoji: "🍘",
			name: "RICE CRACKER",
			added_in: "6.0",
			shortName: "rice_cracker",
			shortNames: [
				"rice_cracker"
			],
			category: 3
		},
		{
			emoji: "🍙",
			name: "RICE BALL",
			added_in: "6.0",
			shortName: "rice_ball",
			shortNames: [
				"rice_ball"
			],
			category: 3
		},
		{
			emoji: "🍚",
			name: "COOKED RICE",
			added_in: "6.0",
			shortName: "rice",
			shortNames: [
				"rice"
			],
			category: 3
		},
		{
			emoji: "🍛",
			name: "CURRY AND RICE",
			added_in: "6.0",
			shortName: "curry",
			shortNames: [
				"curry"
			],
			category: 3
		},
		{
			emoji: "🍜",
			name: "STEAMING BOWL",
			added_in: "6.0",
			shortName: "ramen",
			shortNames: [
				"ramen"
			],
			category: 3
		},
		{
			emoji: "🍝",
			name: "SPAGHETTI",
			added_in: "6.0",
			shortName: "spaghetti",
			shortNames: [
				"spaghetti"
			],
			category: 3
		},
		{
			emoji: "🍞",
			name: "BREAD",
			added_in: "6.0",
			shortName: "bread",
			shortNames: [
				"bread"
			],
			category: 3
		},
		{
			emoji: "🍟",
			name: "FRENCH FRIES",
			added_in: "6.0",
			shortName: "fries",
			shortNames: [
				"fries"
			],
			category: 3
		},
		{
			emoji: "🍠",
			name: "ROASTED SWEET POTATO",
			added_in: "6.0",
			shortName: "sweet_potato",
			shortNames: [
				"sweet_potato"
			],
			category: 3
		},
		{
			emoji: "🍡",
			name: "DANGO",
			added_in: "6.0",
			shortName: "dango",
			shortNames: [
				"dango"
			],
			category: 3
		},
		{
			emoji: "🍢",
			name: "ODEN",
			added_in: "6.0",
			shortName: "oden",
			shortNames: [
				"oden"
			],
			category: 3
		},
		{
			emoji: "🍣",
			name: "SUSHI",
			added_in: "6.0",
			shortName: "sushi",
			shortNames: [
				"sushi"
			],
			category: 3
		},
		{
			emoji: "🍥",
			name: "FISH CAKE WITH SWIRL DESIGN",
			added_in: "6.0",
			shortName: "fish_cake",
			shortNames: [
				"fish_cake"
			],
			category: 3
		},
		{
			emoji: "🍦",
			name: "SOFT ICE CREAM",
			added_in: "6.0",
			shortName: "icecream",
			shortNames: [
				"icecream"
			],
			category: 3
		},
		{
			emoji: "🍧",
			name: "SHAVED ICE",
			added_in: "6.0",
			shortName: "shaved_ice",
			shortNames: [
				"shaved_ice"
			],
			category: 3
		},
		{
			emoji: "🍨",
			name: "ICE CREAM",
			added_in: "6.0",
			shortName: "ice_cream",
			shortNames: [
				"ice_cream"
			],
			category: 3
		},
		{
			emoji: "🍩",
			name: "DOUGHNUT",
			added_in: "6.0",
			shortName: "doughnut",
			shortNames: [
				"doughnut"
			],
			category: 3
		},
		{
			emoji: "🍪",
			name: "COOKIE",
			added_in: "6.0",
			shortName: "cookie",
			shortNames: [
				"cookie"
			],
			category: 3
		},
		{
			emoji: "🍫",
			name: "CHOCOLATE BAR",
			added_in: "6.0",
			shortName: "chocolate_bar",
			shortNames: [
				"chocolate_bar"
			],
			category: 3
		},
		{
			emoji: "🍬",
			name: "CANDY",
			added_in: "6.0",
			shortName: "candy",
			shortNames: [
				"candy"
			],
			category: 3
		},
		{
			emoji: "🍭",
			name: "LOLLIPOP",
			added_in: "6.0",
			shortName: "lollipop",
			shortNames: [
				"lollipop"
			],
			category: 3
		},
		{
			emoji: "🍮",
			name: "CUSTARD",
			added_in: "6.0",
			shortName: "custard",
			shortNames: [
				"custard"
			],
			category: 3
		},
		{
			emoji: "🍯",
			name: "HONEY POT",
			added_in: "6.0",
			shortName: "honey_pot",
			shortNames: [
				"honey_pot"
			],
			category: 3
		},
		{
			emoji: "🍰",
			name: "SHORTCAKE",
			added_in: "6.0",
			shortName: "cake",
			shortNames: [
				"cake"
			],
			category: 3
		},
		{
			emoji: "🍱",
			name: "BENTO BOX",
			added_in: "6.0",
			shortName: "bento",
			shortNames: [
				"bento"
			],
			category: 3
		},
		{
			emoji: "🍲",
			name: "POT OF FOOD",
			added_in: "6.0",
			shortName: "stew",
			shortNames: [
				"stew"
			],
			category: 3
		},
		{
			emoji: "🍳",
			name: "COOKING",
			added_in: "6.0",
			shortName: "fried_egg",
			shortNames: [
				"fried_egg",
				"cooking"
			],
			category: 3
		},
		{
			emoji: "🍴",
			name: "FORK AND KNIFE",
			added_in: "6.0",
			shortName: "fork_and_knife",
			shortNames: [
				"fork_and_knife"
			],
			category: 3
		},
		{
			emoji: "🍶",
			name: "SAKE BOTTLE AND CUP",
			added_in: "6.0",
			shortName: "sake",
			shortNames: [
				"sake"
			],
			category: 3
		},
		{
			emoji: "🍷",
			name: "WINE GLASS",
			added_in: "6.0",
			shortName: "wine_glass",
			shortNames: [
				"wine_glass"
			],
			category: 3
		},
		{
			emoji: "🍸",
			name: "COCKTAIL GLASS",
			added_in: "6.0",
			shortName: "cocktail",
			shortNames: [
				"cocktail"
			],
			category: 3
		},
		{
			emoji: "🍹",
			name: "TROPICAL DRINK",
			added_in: "6.0",
			shortName: "tropical_drink",
			shortNames: [
				"tropical_drink"
			],
			category: 3
		},
		{
			emoji: "🍺",
			name: "BEER MUG",
			added_in: "6.0",
			shortName: "beer",
			shortNames: [
				"beer"
			],
			category: 3
		},
		{
			emoji: "🍻",
			name: "CLINKING BEER MUGS",
			added_in: "6.0",
			shortName: "beers",
			shortNames: [
				"beers"
			],
			category: 3
		},
		{
			emoji: "🎂",
			name: "BIRTHDAY CAKE",
			added_in: "6.0",
			shortName: "birthday",
			shortNames: [
				"birthday"
			],
			category: 3
		},
		{
			emoji: "🔪",
			name: "HOCHO",
			added_in: "6.0",
			shortName: "hocho",
			shortNames: [
				"hocho",
				"knife"
			],
			category: 3
		},
		{
			emoji: "☕",
			name: "HOT BEVERAGE",
			added_in: "4.0",
			shortName: "coffee",
			shortNames: [
				"coffee"
			],
			category: 3
		}
	],
	[
		{
			emoji: "🎽",
			name: "RUNNING SHIRT WITH SASH",
			added_in: "6.0",
			shortName: "running_shirt_with_sash",
			shortNames: [
				"running_shirt_with_sash"
			],
			category: 4
		},
		{
			emoji: "🀄",
			name: "MAHJONG TILE RED DRAGON",
			added_in: "5.1",
			shortName: "mahjong",
			shortNames: [
				"mahjong"
			],
			category: 4
		},
		{
			emoji: "🃏",
			name: "PLAYING CARD BLACK JOKER",
			added_in: "6.0",
			shortName: "black_joker",
			shortNames: [
				"black_joker"
			],
			category: 4
		},
		{
			emoji: "🎀",
			name: "RIBBON",
			added_in: "6.0",
			shortName: "ribbon",
			shortNames: [
				"ribbon"
			],
			category: 4
		},
		{
			emoji: "🎁",
			name: "WRAPPED PRESENT",
			added_in: "6.0",
			shortName: "gift",
			shortNames: [
				"gift"
			],
			category: 4
		},
		{
			emoji: "🎃",
			name: "JACK-O-LANTERN",
			added_in: "6.0",
			shortName: "jack_o_lantern",
			shortNames: [
				"jack_o_lantern"
			],
			category: 4
		},
		{
			emoji: "🎄",
			name: "CHRISTMAS TREE",
			added_in: "6.0",
			shortName: "christmas_tree",
			shortNames: [
				"christmas_tree"
			],
			category: 4
		},
		{
			emoji: "🎆",
			name: "FIREWORKS",
			added_in: "6.0",
			shortName: "fireworks",
			shortNames: [
				"fireworks"
			],
			category: 4
		},
		{
			emoji: "🎇",
			name: "FIREWORK SPARKLER",
			added_in: "6.0",
			shortName: "sparkler",
			shortNames: [
				"sparkler"
			],
			category: 4
		},
		{
			emoji: "🎈",
			name: "BALLOON",
			added_in: "6.0",
			shortName: "balloon",
			shortNames: [
				"balloon"
			],
			category: 4
		},
		{
			emoji: "🎉",
			name: "PARTY POPPER",
			added_in: "6.0",
			shortName: "tada",
			shortNames: [
				"tada"
			],
			category: 4
		},
		{
			emoji: "🎊",
			name: "CONFETTI BALL",
			added_in: "6.0",
			shortName: "confetti_ball",
			shortNames: [
				"confetti_ball"
			],
			category: 4
		},
		{
			emoji: "🎋",
			name: "TANABATA TREE",
			added_in: "6.0",
			shortName: "tanabata_tree",
			shortNames: [
				"tanabata_tree"
			],
			category: 4
		},
		{
			emoji: "🎍",
			name: "PINE DECORATION",
			added_in: "6.0",
			shortName: "bamboo",
			shortNames: [
				"bamboo"
			],
			category: 4
		},
		{
			emoji: "🎎",
			name: "JAPANESE DOLLS",
			added_in: "6.0",
			shortName: "dolls",
			shortNames: [
				"dolls"
			],
			category: 4
		},
		{
			emoji: "🎏",
			name: "CARP STREAMER",
			added_in: "6.0",
			shortName: "flags",
			shortNames: [
				"flags"
			],
			category: 4
		},
		{
			emoji: "🎐",
			name: "WIND CHIME",
			added_in: "6.0",
			shortName: "wind_chime",
			shortNames: [
				"wind_chime"
			],
			category: 4
		},
		{
			emoji: "🎑",
			name: "MOON VIEWING CEREMONY",
			added_in: "6.0",
			shortName: "rice_scene",
			shortNames: [
				"rice_scene"
			],
			category: 4
		},
		{
			emoji: "🎣",
			name: "FISHING POLE AND FISH",
			added_in: "6.0",
			shortName: "fishing_pole_and_fish",
			shortNames: [
				"fishing_pole_and_fish"
			],
			category: 4
		},
		{
			emoji: "🎫",
			name: "TICKET",
			added_in: "6.0",
			shortName: "ticket",
			shortNames: [
				"ticket"
			],
			category: 4
		},
		{
			emoji: "🎮",
			name: "VIDEO GAME",
			added_in: "6.0",
			shortName: "video_game",
			shortNames: [
				"video_game"
			],
			category: 4
		},
		{
			emoji: "🎯",
			name: "DIRECT HIT",
			added_in: "6.0",
			shortName: "dart",
			shortNames: [
				"dart"
			],
			category: 4
		},
		{
			emoji: "🎱",
			name: "BILLIARDS",
			added_in: "6.0",
			shortName: "8ball",
			shortNames: [
				"8ball"
			],
			category: 4
		},
		{
			emoji: "🎲",
			name: "GAME DIE",
			added_in: "6.0",
			shortName: "game_die",
			shortNames: [
				"game_die"
			],
			category: 4
		},
		{
			emoji: "🎳",
			name: "BOWLING",
			added_in: "6.0",
			shortName: "bowling",
			shortNames: [
				"bowling"
			],
			category: 4
		},
		{
			emoji: "🎴",
			name: "FLOWER PLAYING CARDS",
			added_in: "6.0",
			shortName: "flower_playing_cards",
			shortNames: [
				"flower_playing_cards"
			],
			category: 4
		},
		{
			emoji: "🎾",
			name: "TENNIS RACQUET AND BALL",
			added_in: "6.0",
			shortName: "tennis",
			shortNames: [
				"tennis"
			],
			category: 4
		},
		{
			emoji: "🎿",
			name: "SKI AND SKI BOOT",
			added_in: "6.0",
			shortName: "ski",
			shortNames: [
				"ski"
			],
			category: 4
		},
		{
			emoji: "🏀",
			name: "BASKETBALL AND HOOP",
			added_in: "6.0",
			shortName: "basketball",
			shortNames: [
				"basketball"
			],
			category: 4
		},
		{
			emoji: "🏆",
			name: "TROPHY",
			added_in: "6.0",
			shortName: "trophy",
			shortNames: [
				"trophy"
			],
			category: 4
		},
		{
			emoji: "🏈",
			name: "AMERICAN FOOTBALL",
			added_in: "6.0",
			shortName: "football",
			shortNames: [
				"football"
			],
			category: 4
		},
		{
			emoji: "🏉",
			name: "RUGBY FOOTBALL",
			added_in: "6.0",
			shortName: "rugby_football",
			shortNames: [
				"rugby_football"
			],
			category: 4
		},
		{
			emoji: "♠️",
			name: "BLACK SPADE SUIT",
			added_in: "1.1",
			shortName: "spades",
			shortNames: [
				"spades"
			],
			category: 4
		},
		{
			emoji: "♣️",
			name: "BLACK CLUB SUIT",
			added_in: "1.1",
			shortName: "clubs",
			shortNames: [
				"clubs"
			],
			category: 4
		},
		{
			emoji: "♥️",
			name: "BLACK HEART SUIT",
			added_in: "1.1",
			shortName: "hearts",
			shortNames: [
				"hearts"
			],
			category: 4
		},
		{
			emoji: "♦️",
			name: "BLACK DIAMOND SUIT",
			added_in: "1.1",
			shortName: "diamonds",
			shortNames: [
				"diamonds"
			],
			category: 4
		},
		{
			emoji: "⚽",
			name: "SOCCER BALL",
			added_in: "5.2",
			shortName: "soccer",
			shortNames: [
				"soccer"
			],
			category: 4
		},
		{
			emoji: "⚾",
			name: "BASEBALL",
			added_in: "5.2",
			shortName: "baseball",
			shortNames: [
				"baseball"
			],
			category: 4
		},
		{
			emoji: "⛳",
			name: "FLAG IN HOLE",
			added_in: "5.2",
			shortName: "golf",
			shortNames: [
				"golf"
			],
			category: 4
		},
		{
			emoji: "✨",
			name: "SPARKLES",
			added_in: "6.0",
			shortName: "sparkles",
			shortNames: [
				"sparkles"
			],
			category: 4
		}
	],
	[
		{
			emoji: "🌚",
			name: "NEW MOON WITH FACE",
			added_in: "6.0",
			shortName: "new_moon_with_face",
			shortNames: [
				"new_moon_with_face"
			],
			category: 5
		},
		{
			emoji: "🌛",
			name: "FIRST QUARTER MOON WITH FACE",
			added_in: "6.0",
			shortName: "first_quarter_moon_with_face",
			shortNames: [
				"first_quarter_moon_with_face"
			],
			category: 5
		},
		{
			emoji: "🌜",
			name: "LAST QUARTER MOON WITH FACE",
			added_in: "6.0",
			shortName: "last_quarter_moon_with_face",
			shortNames: [
				"last_quarter_moon_with_face"
			],
			category: 5
		},
		{
			emoji: "🌝",
			name: "FULL MOON WITH FACE",
			added_in: "6.0",
			shortName: "full_moon_with_face",
			shortNames: [
				"full_moon_with_face"
			],
			category: 5
		},
		{
			emoji: "🌞",
			name: "SUN WITH FACE",
			added_in: "6.0",
			shortName: "sun_with_face",
			shortNames: [
				"sun_with_face"
			],
			category: 5
		},
		{
			emoji: "🕐",
			name: "CLOCK FACE ONE OCLOCK",
			added_in: "6.0",
			shortName: "clock1",
			shortNames: [
				"clock1"
			],
			category: 5
		},
		{
			emoji: "🕑",
			name: "CLOCK FACE TWO OCLOCK",
			added_in: "6.0",
			shortName: "clock2",
			shortNames: [
				"clock2"
			],
			category: 5
		},
		{
			emoji: "🕒",
			name: "CLOCK FACE THREE OCLOCK",
			added_in: "6.0",
			shortName: "clock3",
			shortNames: [
				"clock3"
			],
			category: 5
		},
		{
			emoji: "🕓",
			name: "CLOCK FACE FOUR OCLOCK",
			added_in: "6.0",
			shortName: "clock4",
			shortNames: [
				"clock4"
			],
			category: 5
		},
		{
			emoji: "🕔",
			name: "CLOCK FACE FIVE OCLOCK",
			added_in: "6.0",
			shortName: "clock5",
			shortNames: [
				"clock5"
			],
			category: 5
		},
		{
			emoji: "🕕",
			name: "CLOCK FACE SIX OCLOCK",
			added_in: "6.0",
			shortName: "clock6",
			shortNames: [
				"clock6"
			],
			category: 5
		},
		{
			emoji: "🕖",
			name: "CLOCK FACE SEVEN OCLOCK",
			added_in: "6.0",
			shortName: "clock7",
			shortNames: [
				"clock7"
			],
			category: 5
		},
		{
			emoji: "🕗",
			name: "CLOCK FACE EIGHT OCLOCK",
			added_in: "6.0",
			shortName: "clock8",
			shortNames: [
				"clock8"
			],
			category: 5
		},
		{
			emoji: "🕘",
			name: "CLOCK FACE NINE OCLOCK",
			added_in: "6.0",
			shortName: "clock9",
			shortNames: [
				"clock9"
			],
			category: 5
		},
		{
			emoji: "🕙",
			name: "CLOCK FACE TEN OCLOCK",
			added_in: "6.0",
			shortName: "clock10",
			shortNames: [
				"clock10"
			],
			category: 5
		},
		{
			emoji: "🕚",
			name: "CLOCK FACE ELEVEN OCLOCK",
			added_in: "6.0",
			shortName: "clock11",
			shortNames: [
				"clock11"
			],
			category: 5
		},
		{
			emoji: "🕛",
			name: "CLOCK FACE TWELVE OCLOCK",
			added_in: "6.0",
			shortName: "clock12",
			shortNames: [
				"clock12"
			],
			category: 5
		},
		{
			emoji: "🕜",
			name: "CLOCK FACE ONE-THIRTY",
			added_in: "6.0",
			shortName: "clock130",
			shortNames: [
				"clock130"
			],
			category: 5
		},
		{
			emoji: "🕝",
			name: "CLOCK FACE TWO-THIRTY",
			added_in: "6.0",
			shortName: "clock230",
			shortNames: [
				"clock230"
			],
			category: 5
		},
		{
			emoji: "🕞",
			name: "CLOCK FACE THREE-THIRTY",
			added_in: "6.0",
			shortName: "clock330",
			shortNames: [
				"clock330"
			],
			category: 5
		},
		{
			emoji: "🕟",
			name: "CLOCK FACE FOUR-THIRTY",
			added_in: "6.0",
			shortName: "clock430",
			shortNames: [
				"clock430"
			],
			category: 5
		},
		{
			emoji: "🕠",
			name: "CLOCK FACE FIVE-THIRTY",
			added_in: "6.0",
			shortName: "clock530",
			shortNames: [
				"clock530"
			],
			category: 5
		},
		{
			emoji: "🕡",
			name: "CLOCK FACE SIX-THIRTY",
			added_in: "6.0",
			shortName: "clock630",
			shortNames: [
				"clock630"
			],
			category: 5
		},
		{
			emoji: "🕢",
			name: "CLOCK FACE SEVEN-THIRTY",
			added_in: "6.0",
			shortName: "clock730",
			shortNames: [
				"clock730"
			],
			category: 5
		},
		{
			emoji: "🕣",
			name: "CLOCK FACE EIGHT-THIRTY",
			added_in: "6.0",
			shortName: "clock830",
			shortNames: [
				"clock830"
			],
			category: 5
		},
		{
			emoji: "🕤",
			name: "CLOCK FACE NINE-THIRTY",
			added_in: "6.0",
			shortName: "clock930",
			shortNames: [
				"clock930"
			],
			category: 5
		},
		{
			emoji: "🕥",
			name: "CLOCK FACE TEN-THIRTY",
			added_in: "6.0",
			shortName: "clock1030",
			shortNames: [
				"clock1030"
			],
			category: 5
		},
		{
			emoji: "🕦",
			name: "CLOCK FACE ELEVEN-THIRTY",
			added_in: "6.0",
			shortName: "clock1130",
			shortNames: [
				"clock1130"
			],
			category: 5
		},
		{
			emoji: "🕧",
			name: "CLOCK FACE TWELVE-THIRTY",
			added_in: "6.0",
			shortName: "clock1230",
			shortNames: [
				"clock1230"
			],
			category: 5
		},
		{
			emoji: "⛄",
			name: "SNOWMAN WITHOUT SNOW",
			added_in: "5.2",
			shortName: "snowman_without_snow",
			shortNames: [
				"snowman_without_snow"
			],
			category: 5
		},
		{
			emoji: "🌀",
			name: "CYCLONE",
			added_in: "6.0",
			shortName: "cyclone",
			shortNames: [
				"cyclone"
			],
			category: 5
		},
		{
			emoji: "🌁",
			name: "FOGGY",
			added_in: "6.0",
			shortName: "foggy",
			shortNames: [
				"foggy"
			],
			category: 5
		},
		{
			emoji: "🌂",
			name: "CLOSED UMBRELLA",
			added_in: "6.0",
			shortName: "closed_umbrella",
			shortNames: [
				"closed_umbrella"
			],
			category: 5
		},
		{
			emoji: "🌃",
			name: "NIGHT WITH STARS",
			added_in: "6.0",
			shortName: "night_with_stars",
			shortNames: [
				"night_with_stars"
			],
			category: 5
		},
		{
			emoji: "🌄",
			name: "SUNRISE OVER MOUNTAINS",
			added_in: "6.0",
			shortName: "sunrise_over_mountains",
			shortNames: [
				"sunrise_over_mountains"
			],
			category: 5
		},
		{
			emoji: "🌅",
			name: "SUNRISE",
			added_in: "6.0",
			shortName: "sunrise",
			shortNames: [
				"sunrise"
			],
			category: 5
		},
		{
			emoji: "🌆",
			name: "CITYSCAPE AT DUSK",
			added_in: "6.0",
			shortName: "city_sunset",
			shortNames: [
				"city_sunset"
			],
			category: 5
		},
		{
			emoji: "🌇",
			name: "SUNSET OVER BUILDINGS",
			added_in: "6.0",
			shortName: "city_sunrise",
			shortNames: [
				"city_sunrise"
			],
			category: 5
		},
		{
			emoji: "🌈",
			name: "RAINBOW",
			added_in: "6.0",
			shortName: "rainbow",
			shortNames: [
				"rainbow"
			],
			category: 5
		},
		{
			emoji: "🌉",
			name: "BRIDGE AT NIGHT",
			added_in: "6.0",
			shortName: "bridge_at_night",
			shortNames: [
				"bridge_at_night"
			],
			category: 5
		},
		{
			emoji: "🌊",
			name: "WATER WAVE",
			added_in: "6.0",
			shortName: "ocean",
			shortNames: [
				"ocean"
			],
			category: 5
		},
		{
			emoji: "🌋",
			name: "VOLCANO",
			added_in: "6.0",
			shortName: "volcano",
			shortNames: [
				"volcano"
			],
			category: 5
		},
		{
			emoji: "🌌",
			name: "MILKY WAY",
			added_in: "6.0",
			shortName: "milky_way",
			shortNames: [
				"milky_way"
			],
			category: 5
		},
		{
			emoji: "🌍",
			name: "EARTH GLOBE EUROPE-AFRICA",
			added_in: "6.0",
			shortName: "earth_africa",
			shortNames: [
				"earth_africa"
			],
			category: 5
		},
		{
			emoji: "🌎",
			name: "EARTH GLOBE AMERICAS",
			added_in: "6.0",
			shortName: "earth_americas",
			shortNames: [
				"earth_americas"
			],
			category: 5
		},
		{
			emoji: "🌏",
			name: "EARTH GLOBE ASIA-AUSTRALIA",
			added_in: "6.0",
			shortName: "earth_asia",
			shortNames: [
				"earth_asia"
			],
			category: 5
		},
		{
			emoji: "🌐",
			name: "GLOBE WITH MERIDIANS",
			added_in: "6.0",
			shortName: "globe_with_meridians",
			shortNames: [
				"globe_with_meridians"
			],
			category: 5
		},
		{
			emoji: "🌑",
			name: "NEW MOON SYMBOL",
			added_in: "6.0",
			shortName: "new_moon",
			shortNames: [
				"new_moon"
			],
			category: 5
		},
		{
			emoji: "🌒",
			name: "WAXING CRESCENT MOON SYMBOL",
			added_in: "6.0",
			shortName: "waxing_crescent_moon",
			shortNames: [
				"waxing_crescent_moon"
			],
			category: 5
		},
		{
			emoji: "🌓",
			name: "FIRST QUARTER MOON SYMBOL",
			added_in: "6.0",
			shortName: "first_quarter_moon",
			shortNames: [
				"first_quarter_moon"
			],
			category: 5
		},
		{
			emoji: "🌔",
			name: "WAXING GIBBOUS MOON SYMBOL",
			added_in: "6.0",
			shortName: "moon",
			shortNames: [
				"moon",
				"waxing_gibbous_moon"
			],
			category: 5
		},
		{
			emoji: "🌕",
			name: "FULL MOON SYMBOL",
			added_in: "6.0",
			shortName: "full_moon",
			shortNames: [
				"full_moon"
			],
			category: 5
		},
		{
			emoji: "🌖",
			name: "WANING GIBBOUS MOON SYMBOL",
			added_in: "6.0",
			shortName: "waning_gibbous_moon",
			shortNames: [
				"waning_gibbous_moon"
			],
			category: 5
		},
		{
			emoji: "🌗",
			name: "LAST QUARTER MOON SYMBOL",
			added_in: "6.0",
			shortName: "last_quarter_moon",
			shortNames: [
				"last_quarter_moon"
			],
			category: 5
		},
		{
			emoji: "🌘",
			name: "WANING CRESCENT MOON SYMBOL",
			added_in: "6.0",
			shortName: "waning_crescent_moon",
			shortNames: [
				"waning_crescent_moon"
			],
			category: 5
		},
		{
			emoji: "🌙",
			name: "CRESCENT MOON",
			added_in: "6.0",
			shortName: "crescent_moon",
			shortNames: [
				"crescent_moon"
			],
			category: 5
		},
		{
			emoji: "🌟",
			name: "GLOWING STAR",
			added_in: "6.0",
			shortName: "star2",
			shortNames: [
				"star2"
			],
			category: 5
		},
		{
			emoji: "🌠",
			name: "SHOOTING STAR",
			added_in: "6.0",
			shortName: "stars",
			shortNames: [
				"stars"
			],
			category: 5
		},
		{
			emoji: "🎠",
			name: "CAROUSEL HORSE",
			added_in: "6.0",
			shortName: "carousel_horse",
			shortNames: [
				"carousel_horse"
			],
			category: 5
		},
		{
			emoji: "🎡",
			name: "FERRIS WHEEL",
			added_in: "6.0",
			shortName: "ferris_wheel",
			shortNames: [
				"ferris_wheel"
			],
			category: 5
		},
		{
			emoji: "🎢",
			name: "ROLLER COASTER",
			added_in: "6.0",
			shortName: "roller_coaster",
			shortNames: [
				"roller_coaster"
			],
			category: 5
		},
		{
			emoji: "🎨",
			name: "ARTIST PALETTE",
			added_in: "6.0",
			shortName: "art",
			shortNames: [
				"art"
			],
			category: 5
		},
		{
			emoji: "🎪",
			name: "CIRCUS TENT",
			added_in: "6.0",
			shortName: "circus_tent",
			shortNames: [
				"circus_tent"
			],
			category: 5
		},
		{
			emoji: "🎭",
			name: "PERFORMING ARTS",
			added_in: "6.0",
			shortName: "performing_arts",
			shortNames: [
				"performing_arts"
			],
			category: 5
		},
		{
			emoji: "🎰",
			name: "SLOT MACHINE",
			added_in: "6.0",
			shortName: "slot_machine",
			shortNames: [
				"slot_machine"
			],
			category: 5
		},
		{
			emoji: "🏠",
			name: "HOUSE BUILDING",
			added_in: "6.0",
			shortName: "house",
			shortNames: [
				"house"
			],
			category: 5
		},
		{
			emoji: "🏡",
			name: "HOUSE WITH GARDEN",
			added_in: "6.0",
			shortName: "house_with_garden",
			shortNames: [
				"house_with_garden"
			],
			category: 5
		},
		{
			emoji: "🏢",
			name: "OFFICE BUILDING",
			added_in: "6.0",
			shortName: "office",
			shortNames: [
				"office"
			],
			category: 5
		},
		{
			emoji: "🏣",
			name: "JAPANESE POST OFFICE",
			added_in: "6.0",
			shortName: "post_office",
			shortNames: [
				"post_office"
			],
			category: 5
		},
		{
			emoji: "🏤",
			name: "EUROPEAN POST OFFICE",
			added_in: "6.0",
			shortName: "european_post_office",
			shortNames: [
				"european_post_office"
			],
			category: 5
		},
		{
			emoji: "🏥",
			name: "HOSPITAL",
			added_in: "6.0",
			shortName: "hospital",
			shortNames: [
				"hospital"
			],
			category: 5
		},
		{
			emoji: "🏦",
			name: "BANK",
			added_in: "6.0",
			shortName: "bank",
			shortNames: [
				"bank"
			],
			category: 5
		},
		{
			emoji: "🏨",
			name: "HOTEL",
			added_in: "6.0",
			shortName: "hotel",
			shortNames: [
				"hotel"
			],
			category: 5
		},
		{
			emoji: "🏩",
			name: "LOVE HOTEL",
			added_in: "6.0",
			shortName: "love_hotel",
			shortNames: [
				"love_hotel"
			],
			category: 5
		},
		{
			emoji: "🏪",
			name: "CONVENIENCE STORE",
			added_in: "6.0",
			shortName: "convenience_store",
			shortNames: [
				"convenience_store"
			],
			category: 5
		},
		{
			emoji: "🏫",
			name: "SCHOOL",
			added_in: "6.0",
			shortName: "school",
			shortNames: [
				"school"
			],
			category: 5
		},
		{
			emoji: "🏬",
			name: "DEPARTMENT STORE",
			added_in: "6.0",
			shortName: "department_store",
			shortNames: [
				"department_store"
			],
			category: 5
		},
		{
			emoji: "🏭",
			name: "FACTORY",
			added_in: "6.0",
			shortName: "factory",
			shortNames: [
				"factory"
			],
			category: 5
		},
		{
			emoji: "🏯",
			name: "JAPANESE CASTLE",
			added_in: "6.0",
			shortName: "japanese_castle",
			shortNames: [
				"japanese_castle"
			],
			category: 5
		},
		{
			emoji: "🏰",
			name: "EUROPEAN CASTLE",
			added_in: "6.0",
			shortName: "european_castle",
			shortNames: [
				"european_castle"
			],
			category: 5
		},
		{
			emoji: "💈",
			name: "BARBER POLE",
			added_in: "6.0",
			shortName: "barber",
			shortNames: [
				"barber"
			],
			category: 5
		},
		{
			emoji: "💒",
			name: "WEDDING",
			added_in: "6.0",
			shortName: "wedding",
			shortNames: [
				"wedding"
			],
			category: 5
		},
		{
			emoji: "💧",
			name: "DROPLET",
			added_in: "6.0",
			shortName: "droplet",
			shortNames: [
				"droplet"
			],
			category: 5
		},
		{
			emoji: "💺",
			name: "SEAT",
			added_in: "6.0",
			shortName: "seat",
			shortNames: [
				"seat"
			],
			category: 5
		},
		{
			emoji: "🔥",
			name: "FIRE",
			added_in: "6.0",
			shortName: "fire",
			shortNames: [
				"fire"
			],
			category: 5
		},
		{
			emoji: "🗻",
			name: "MOUNT FUJI",
			added_in: "6.0",
			shortName: "mount_fuji",
			shortNames: [
				"mount_fuji"
			],
			category: 5
		},
		{
			emoji: "🗼",
			name: "TOKYO TOWER",
			added_in: "6.0",
			shortName: "tokyo_tower",
			shortNames: [
				"tokyo_tower"
			],
			category: 5
		},
		{
			emoji: "🗽",
			name: "STATUE OF LIBERTY",
			added_in: "6.0",
			shortName: "statue_of_liberty",
			shortNames: [
				"statue_of_liberty"
			],
			category: 5
		},
		{
			emoji: "🗾",
			name: "SILHOUETTE OF JAPAN",
			added_in: "6.0",
			shortName: "japan",
			shortNames: [
				"japan"
			],
			category: 5
		},
		{
			emoji: "🚀",
			name: "ROCKET",
			added_in: "6.0",
			shortName: "rocket",
			shortNames: [
				"rocket"
			],
			category: 5
		},
		{
			emoji: "🚁",
			name: "HELICOPTER",
			added_in: "6.0",
			shortName: "helicopter",
			shortNames: [
				"helicopter"
			],
			category: 5
		},
		{
			emoji: "🚂",
			name: "STEAM LOCOMOTIVE",
			added_in: "6.0",
			shortName: "steam_locomotive",
			shortNames: [
				"steam_locomotive"
			],
			category: 5
		},
		{
			emoji: "🚃",
			name: "RAILWAY CAR",
			added_in: "6.0",
			shortName: "railway_car",
			shortNames: [
				"railway_car"
			],
			category: 5
		},
		{
			emoji: "🚄",
			name: "HIGH-SPEED TRAIN",
			added_in: "6.0",
			shortName: "bullettrain_side",
			shortNames: [
				"bullettrain_side"
			],
			category: 5
		},
		{
			emoji: "🚅",
			name: "HIGH-SPEED TRAIN WITH BULLET NOSE",
			added_in: "6.0",
			shortName: "bullettrain_front",
			shortNames: [
				"bullettrain_front"
			],
			category: 5
		},
		{
			emoji: "🚆",
			name: "TRAIN",
			added_in: "6.0",
			shortName: "train2",
			shortNames: [
				"train2"
			],
			category: 5
		},
		{
			emoji: "🚇",
			name: "METRO",
			added_in: "6.0",
			shortName: "metro",
			shortNames: [
				"metro"
			],
			category: 5
		},
		{
			emoji: "🚈",
			name: "LIGHT RAIL",
			added_in: "6.0",
			shortName: "light_rail",
			shortNames: [
				"light_rail"
			],
			category: 5
		},
		{
			emoji: "🚉",
			name: "STATION",
			added_in: "6.0",
			shortName: "station",
			shortNames: [
				"station"
			],
			category: 5
		},
		{
			emoji: "🚊",
			name: "TRAM",
			added_in: "6.0",
			shortName: "tram",
			shortNames: [
				"tram"
			],
			category: 5
		},
		{
			emoji: "🚋",
			name: "TRAM CAR",
			added_in: "6.0",
			shortName: "train",
			shortNames: [
				"train"
			],
			category: 5
		},
		{
			emoji: "🚌",
			name: "BUS",
			added_in: "6.0",
			shortName: "bus",
			shortNames: [
				"bus"
			],
			category: 5
		},
		{
			emoji: "🚍",
			name: "ONCOMING BUS",
			added_in: "6.0",
			shortName: "oncoming_bus",
			shortNames: [
				"oncoming_bus"
			],
			category: 5
		},
		{
			emoji: "🚎",
			name: "TROLLEYBUS",
			added_in: "6.0",
			shortName: "trolleybus",
			shortNames: [
				"trolleybus"
			],
			category: 5
		},
		{
			emoji: "🚏",
			name: "BUS STOP",
			added_in: "6.0",
			shortName: "busstop",
			shortNames: [
				"busstop"
			],
			category: 5
		},
		{
			emoji: "🚐",
			name: "MINIBUS",
			added_in: "6.0",
			shortName: "minibus",
			shortNames: [
				"minibus"
			],
			category: 5
		},
		{
			emoji: "🚑",
			name: "AMBULANCE",
			added_in: "6.0",
			shortName: "ambulance",
			shortNames: [
				"ambulance"
			],
			category: 5
		},
		{
			emoji: "🚒",
			name: "FIRE ENGINE",
			added_in: "6.0",
			shortName: "fire_engine",
			shortNames: [
				"fire_engine"
			],
			category: 5
		},
		{
			emoji: "🚓",
			name: "POLICE CAR",
			added_in: "6.0",
			shortName: "police_car",
			shortNames: [
				"police_car"
			],
			category: 5
		},
		{
			emoji: "🚔",
			name: "ONCOMING POLICE CAR",
			added_in: "6.0",
			shortName: "oncoming_police_car",
			shortNames: [
				"oncoming_police_car"
			],
			category: 5
		},
		{
			emoji: "🚕",
			name: "TAXI",
			added_in: "6.0",
			shortName: "taxi",
			shortNames: [
				"taxi"
			],
			category: 5
		},
		{
			emoji: "🚖",
			name: "ONCOMING TAXI",
			added_in: "6.0",
			shortName: "oncoming_taxi",
			shortNames: [
				"oncoming_taxi"
			],
			category: 5
		},
		{
			emoji: "🚗",
			name: "AUTOMOBILE",
			added_in: "6.0",
			shortName: "car",
			shortNames: [
				"car",
				"red_car"
			],
			category: 5
		},
		{
			emoji: "🚘",
			name: "ONCOMING AUTOMOBILE",
			added_in: "6.0",
			shortName: "oncoming_automobile",
			shortNames: [
				"oncoming_automobile"
			],
			category: 5
		},
		{
			emoji: "🚙",
			name: "RECREATIONAL VEHICLE",
			added_in: "6.0",
			shortName: "blue_car",
			shortNames: [
				"blue_car"
			],
			category: 5
		},
		{
			emoji: "🚚",
			name: "DELIVERY TRUCK",
			added_in: "6.0",
			shortName: "truck",
			shortNames: [
				"truck"
			],
			category: 5
		},
		{
			emoji: "🚛",
			name: "ARTICULATED LORRY",
			added_in: "6.0",
			shortName: "articulated_lorry",
			shortNames: [
				"articulated_lorry"
			],
			category: 5
		},
		{
			emoji: "🚜",
			name: "TRACTOR",
			added_in: "6.0",
			shortName: "tractor",
			shortNames: [
				"tractor"
			],
			category: 5
		},
		{
			emoji: "🚝",
			name: "MONORAIL",
			added_in: "6.0",
			shortName: "monorail",
			shortNames: [
				"monorail"
			],
			category: 5
		},
		{
			emoji: "🚞",
			name: "MOUNTAIN RAILWAY",
			added_in: "6.0",
			shortName: "mountain_railway",
			shortNames: [
				"mountain_railway"
			],
			category: 5
		},
		{
			emoji: "🚟",
			name: "SUSPENSION RAILWAY",
			added_in: "6.0",
			shortName: "suspension_railway",
			shortNames: [
				"suspension_railway"
			],
			category: 5
		},
		{
			emoji: "🚠",
			name: "MOUNTAIN CABLEWAY",
			added_in: "6.0",
			shortName: "mountain_cableway",
			shortNames: [
				"mountain_cableway"
			],
			category: 5
		},
		{
			emoji: "🚡",
			name: "AERIAL TRAMWAY",
			added_in: "6.0",
			shortName: "aerial_tramway",
			shortNames: [
				"aerial_tramway"
			],
			category: 5
		},
		{
			emoji: "🚢",
			name: "SHIP",
			added_in: "6.0",
			shortName: "ship",
			shortNames: [
				"ship"
			],
			category: 5
		},
		{
			emoji: "🚤",
			name: "SPEEDBOAT",
			added_in: "6.0",
			shortName: "speedboat",
			shortNames: [
				"speedboat"
			],
			category: 5
		},
		{
			emoji: "🚥",
			name: "HORIZONTAL TRAFFIC LIGHT",
			added_in: "6.0",
			shortName: "traffic_light",
			shortNames: [
				"traffic_light"
			],
			category: 5
		},
		{
			emoji: "🚦",
			name: "VERTICAL TRAFFIC LIGHT",
			added_in: "6.0",
			shortName: "vertical_traffic_light",
			shortNames: [
				"vertical_traffic_light"
			],
			category: 5
		},
		{
			emoji: "🚧",
			name: "CONSTRUCTION SIGN",
			added_in: "6.0",
			shortName: "construction",
			shortNames: [
				"construction"
			],
			category: 5
		},
		{
			emoji: "🚨",
			name: "POLICE CARS REVOLVING LIGHT",
			added_in: "6.0",
			shortName: "rotating_light",
			shortNames: [
				"rotating_light"
			],
			category: 5
		},
		{
			emoji: "🚪",
			name: "DOOR",
			added_in: "6.0",
			shortName: "door",
			shortNames: [
				"door"
			],
			category: 5
		},
		{
			emoji: "🚲",
			name: "BICYCLE",
			added_in: "6.0",
			shortName: "bike",
			shortNames: [
				"bike"
			],
			category: 5
		},
		{
			emoji: "🚽",
			name: "TOILET",
			added_in: "6.0",
			shortName: "toilet",
			shortNames: [
				"toilet"
			],
			category: 5
		},
		{
			emoji: "🚿",
			name: "SHOWER",
			added_in: "6.0",
			shortName: "shower",
			shortNames: [
				"shower"
			],
			category: 5
		},
		{
			emoji: "🛁",
			name: "BATHTUB",
			added_in: "6.0",
			shortName: "bathtub",
			shortNames: [
				"bathtub"
			],
			category: 5
		},
		{
			emoji: "⌚",
			name: "WATCH",
			added_in: "1.1",
			shortName: "watch",
			shortNames: [
				"watch"
			],
			category: 5
		},
		{
			emoji: "⌛",
			name: "HOURGLASS",
			added_in: "1.1",
			shortName: "hourglass",
			shortNames: [
				"hourglass"
			],
			category: 5
		},
		{
			emoji: "⏰",
			name: "ALARM CLOCK",
			added_in: "6.0",
			shortName: "alarm_clock",
			shortNames: [
				"alarm_clock"
			],
			category: 5
		},
		{
			emoji: "⏳",
			name: "HOURGLASS WITH FLOWING SAND",
			added_in: "6.0",
			shortName: "hourglass_flowing_sand",
			shortNames: [
				"hourglass_flowing_sand"
			],
			category: 5
		},
		{
			emoji: "☀️",
			name: "BLACK SUN WITH RAYS",
			added_in: "1.1",
			shortName: "sunny",
			shortNames: [
				"sunny"
			],
			category: 5
		},
		{
			emoji: "☁️",
			name: "CLOUD",
			added_in: "1.1",
			shortName: "cloud",
			shortNames: [
				"cloud"
			],
			category: 5
		},
		{
			emoji: "☔",
			name: "UMBRELLA WITH RAIN DROPS",
			added_in: "4.0",
			shortName: "umbrella_with_rain_drops",
			shortNames: [
				"umbrella_with_rain_drops"
			],
			category: 5
		},
		{
			emoji: "♨️",
			name: "HOT SPRINGS",
			added_in: "1.1",
			shortName: "hotsprings",
			shortNames: [
				"hotsprings"
			],
			category: 5
		},
		{
			emoji: "⚓",
			name: "ANCHOR",
			added_in: "4.1",
			shortName: "anchor",
			shortNames: [
				"anchor"
			],
			category: 5
		},
		{
			emoji: "⚡",
			name: "HIGH VOLTAGE SIGN",
			added_in: "4.0",
			shortName: "zap",
			shortNames: [
				"zap"
			],
			category: 5
		},
		{
			emoji: "⛅",
			name: "SUN BEHIND CLOUD",
			added_in: "5.2",
			shortName: "partly_sunny",
			shortNames: [
				"partly_sunny"
			],
			category: 5
		},
		{
			emoji: "⛪",
			name: "CHURCH",
			added_in: "5.2",
			shortName: "church",
			shortNames: [
				"church"
			],
			category: 5
		},
		{
			emoji: "⛲",
			name: "FOUNTAIN",
			added_in: "5.2",
			shortName: "fountain",
			shortNames: [
				"fountain"
			],
			category: 5
		},
		{
			emoji: "⛵",
			name: "SAILBOAT",
			added_in: "5.2",
			shortName: "boat",
			shortNames: [
				"boat",
				"sailboat"
			],
			category: 5
		},
		{
			emoji: "⛺",
			name: "TENT",
			added_in: "5.2",
			shortName: "tent",
			shortNames: [
				"tent"
			],
			category: 5
		},
		{
			emoji: "⛽",
			name: "FUEL PUMP",
			added_in: "5.2",
			shortName: "fuelpump",
			shortNames: [
				"fuelpump"
			],
			category: 5
		},
		{
			emoji: "✈️",
			name: "AIRPLANE",
			added_in: "1.1",
			shortName: "airplane",
			shortNames: [
				"airplane"
			],
			category: 5
		},
		{
			emoji: "❄️",
			name: "SNOWFLAKE",
			added_in: "1.1",
			shortName: "snowflake",
			shortNames: [
				"snowflake"
			],
			category: 5
		},
		{
			emoji: "⭐",
			name: "WHITE MEDIUM STAR",
			added_in: "5.1",
			shortName: "star",
			shortNames: [
				"star"
			],
			category: 5
		}
	],
	[
		{
			emoji: "📇",
			name: "CARD INDEX",
			added_in: "6.0",
			shortName: "card_index",
			shortNames: [
				"card_index"
			],
			category: 6
		},
		{
			emoji: "🎤",
			name: "MICROPHONE",
			added_in: "6.0",
			shortName: "microphone",
			shortNames: [
				"microphone"
			],
			category: 6
		},
		{
			emoji: "🎥",
			name: "MOVIE CAMERA",
			added_in: "6.0",
			shortName: "movie_camera",
			shortNames: [
				"movie_camera"
			],
			category: 6
		},
		{
			emoji: "🎧",
			name: "HEADPHONE",
			added_in: "6.0",
			shortName: "headphones",
			shortNames: [
				"headphones"
			],
			category: 6
		},
		{
			emoji: "🎬",
			name: "CLAPPER BOARD",
			added_in: "6.0",
			shortName: "clapper",
			shortNames: [
				"clapper"
			],
			category: 6
		},
		{
			emoji: "🎵",
			name: "MUSICAL NOTE",
			added_in: "6.0",
			shortName: "musical_note",
			shortNames: [
				"musical_note"
			],
			category: 6
		},
		{
			emoji: "🎶",
			name: "MULTIPLE MUSICAL NOTES",
			added_in: "6.0",
			shortName: "notes",
			shortNames: [
				"notes"
			],
			category: 6
		},
		{
			emoji: "🎷",
			name: "SAXOPHONE",
			added_in: "6.0",
			shortName: "saxophone",
			shortNames: [
				"saxophone"
			],
			category: 6
		},
		{
			emoji: "🎸",
			name: "GUITAR",
			added_in: "6.0",
			shortName: "guitar",
			shortNames: [
				"guitar"
			],
			category: 6
		},
		{
			emoji: "🎹",
			name: "MUSICAL KEYBOARD",
			added_in: "6.0",
			shortName: "musical_keyboard",
			shortNames: [
				"musical_keyboard"
			],
			category: 6
		},
		{
			emoji: "🎺",
			name: "TRUMPET",
			added_in: "6.0",
			shortName: "trumpet",
			shortNames: [
				"trumpet"
			],
			category: 6
		},
		{
			emoji: "🎻",
			name: "VIOLIN",
			added_in: "6.0",
			shortName: "violin",
			shortNames: [
				"violin"
			],
			category: 6
		},
		{
			emoji: "🎼",
			name: "MUSICAL SCORE",
			added_in: "6.0",
			shortName: "musical_score",
			shortNames: [
				"musical_score"
			],
			category: 6
		},
		{
			emoji: "🏮",
			name: "IZAKAYA LANTERN",
			added_in: "6.0",
			shortName: "izakaya_lantern",
			shortNames: [
				"izakaya_lantern",
				"lantern"
			],
			category: 6
		},
		{
			emoji: "💉",
			name: "SYRINGE",
			added_in: "6.0",
			shortName: "syringe",
			shortNames: [
				"syringe"
			],
			category: 6
		},
		{
			emoji: "💊",
			name: "PILL",
			added_in: "6.0",
			shortName: "pill",
			shortNames: [
				"pill"
			],
			category: 6
		},
		{
			emoji: "💡",
			name: "ELECTRIC LIGHT BULB",
			added_in: "6.0",
			shortName: "bulb",
			shortNames: [
				"bulb"
			],
			category: 6
		},
		{
			emoji: "💰",
			name: "MONEY BAG",
			added_in: "6.0",
			shortName: "moneybag",
			shortNames: [
				"moneybag"
			],
			category: 6
		},
		{
			emoji: "💱",
			name: "CURRENCY EXCHANGE",
			added_in: "6.0",
			shortName: "currency_exchange",
			shortNames: [
				"currency_exchange"
			],
			category: 6
		},
		{
			emoji: "💲",
			name: "HEAVY DOLLAR SIGN",
			added_in: "6.0",
			shortName: "heavy_dollar_sign",
			shortNames: [
				"heavy_dollar_sign"
			],
			category: 6
		},
		{
			emoji: "💳",
			name: "CREDIT CARD",
			added_in: "6.0",
			shortName: "credit_card",
			shortNames: [
				"credit_card"
			],
			category: 6
		},
		{
			emoji: "💴",
			name: "BANKNOTE WITH YEN SIGN",
			added_in: "6.0",
			shortName: "yen",
			shortNames: [
				"yen"
			],
			category: 6
		},
		{
			emoji: "💵",
			name: "BANKNOTE WITH DOLLAR SIGN",
			added_in: "6.0",
			shortName: "dollar",
			shortNames: [
				"dollar"
			],
			category: 6
		},
		{
			emoji: "💶",
			name: "BANKNOTE WITH EURO SIGN",
			added_in: "6.0",
			shortName: "euro",
			shortNames: [
				"euro"
			],
			category: 6
		},
		{
			emoji: "💷",
			name: "BANKNOTE WITH POUND SIGN",
			added_in: "6.0",
			shortName: "pound",
			shortNames: [
				"pound"
			],
			category: 6
		},
		{
			emoji: "💸",
			name: "MONEY WITH WINGS",
			added_in: "6.0",
			shortName: "money_with_wings",
			shortNames: [
				"money_with_wings"
			],
			category: 6
		},
		{
			emoji: "💹",
			name: "CHART WITH UPWARDS TREND AND YEN SIGN",
			added_in: "6.0",
			shortName: "chart",
			shortNames: [
				"chart"
			],
			category: 6
		},
		{
			emoji: "💻",
			name: "PERSONAL COMPUTER",
			added_in: "6.0",
			shortName: "computer",
			shortNames: [
				"computer"
			],
			category: 6
		},
		{
			emoji: "💼",
			name: "BRIEFCASE",
			added_in: "6.0",
			shortName: "briefcase",
			shortNames: [
				"briefcase"
			],
			category: 6
		},
		{
			emoji: "💽",
			name: "MINIDISC",
			added_in: "6.0",
			shortName: "minidisc",
			shortNames: [
				"minidisc"
			],
			category: 6
		},
		{
			emoji: "💾",
			name: "FLOPPY DISK",
			added_in: "6.0",
			shortName: "floppy_disk",
			shortNames: [
				"floppy_disk"
			],
			category: 6
		},
		{
			emoji: "💿",
			name: "OPTICAL DISC",
			added_in: "6.0",
			shortName: "cd",
			shortNames: [
				"cd"
			],
			category: 6
		},
		{
			emoji: "📀",
			name: "DVD",
			added_in: "6.0",
			shortName: "dvd",
			shortNames: [
				"dvd"
			],
			category: 6
		},
		{
			emoji: "📁",
			name: "FILE FOLDER",
			added_in: "6.0",
			shortName: "file_folder",
			shortNames: [
				"file_folder"
			],
			category: 6
		},
		{
			emoji: "📂",
			name: "OPEN FILE FOLDER",
			added_in: "6.0",
			shortName: "open_file_folder",
			shortNames: [
				"open_file_folder"
			],
			category: 6
		},
		{
			emoji: "📃",
			name: "PAGE WITH CURL",
			added_in: "6.0",
			shortName: "page_with_curl",
			shortNames: [
				"page_with_curl"
			],
			category: 6
		},
		{
			emoji: "📄",
			name: "PAGE FACING UP",
			added_in: "6.0",
			shortName: "page_facing_up",
			shortNames: [
				"page_facing_up"
			],
			category: 6
		},
		{
			emoji: "📅",
			name: "CALENDAR",
			added_in: "6.0",
			shortName: "date",
			shortNames: [
				"date"
			],
			category: 6
		},
		{
			emoji: "📆",
			name: "TEAR-OFF CALENDAR",
			added_in: "6.0",
			shortName: "calendar",
			shortNames: [
				"calendar"
			],
			category: 6
		},
		{
			emoji: "📈",
			name: "CHART WITH UPWARDS TREND",
			added_in: "6.0",
			shortName: "chart_with_upwards_trend",
			shortNames: [
				"chart_with_upwards_trend"
			],
			category: 6
		},
		{
			emoji: "📉",
			name: "CHART WITH DOWNWARDS TREND",
			added_in: "6.0",
			shortName: "chart_with_downwards_trend",
			shortNames: [
				"chart_with_downwards_trend"
			],
			category: 6
		},
		{
			emoji: "📊",
			name: "BAR CHART",
			added_in: "6.0",
			shortName: "bar_chart",
			shortNames: [
				"bar_chart"
			],
			category: 6
		},
		{
			emoji: "📋",
			name: "CLIPBOARD",
			added_in: "6.0",
			shortName: "clipboard",
			shortNames: [
				"clipboard"
			],
			category: 6
		},
		{
			emoji: "📌",
			name: "PUSHPIN",
			added_in: "6.0",
			shortName: "pushpin",
			shortNames: [
				"pushpin"
			],
			category: 6
		},
		{
			emoji: "📍",
			name: "ROUND PUSHPIN",
			added_in: "6.0",
			shortName: "round_pushpin",
			shortNames: [
				"round_pushpin"
			],
			category: 6
		},
		{
			emoji: "📎",
			name: "PAPERCLIP",
			added_in: "6.0",
			shortName: "paperclip",
			shortNames: [
				"paperclip"
			],
			category: 6
		},
		{
			emoji: "📏",
			name: "STRAIGHT RULER",
			added_in: "6.0",
			shortName: "straight_ruler",
			shortNames: [
				"straight_ruler"
			],
			category: 6
		},
		{
			emoji: "📐",
			name: "TRIANGULAR RULER",
			added_in: "6.0",
			shortName: "triangular_ruler",
			shortNames: [
				"triangular_ruler"
			],
			category: 6
		},
		{
			emoji: "📑",
			name: "BOOKMARK TABS",
			added_in: "6.0",
			shortName: "bookmark_tabs",
			shortNames: [
				"bookmark_tabs"
			],
			category: 6
		},
		{
			emoji: "📒",
			name: "LEDGER",
			added_in: "6.0",
			shortName: "ledger",
			shortNames: [
				"ledger"
			],
			category: 6
		},
		{
			emoji: "📓",
			name: "NOTEBOOK",
			added_in: "6.0",
			shortName: "notebook",
			shortNames: [
				"notebook"
			],
			category: 6
		},
		{
			emoji: "📔",
			name: "NOTEBOOK WITH DECORATIVE COVER",
			added_in: "6.0",
			shortName: "notebook_with_decorative_cover",
			shortNames: [
				"notebook_with_decorative_cover"
			],
			category: 6
		},
		{
			emoji: "📕",
			name: "CLOSED BOOK",
			added_in: "6.0",
			shortName: "closed_book",
			shortNames: [
				"closed_book"
			],
			category: 6
		},
		{
			emoji: "📖",
			name: "OPEN BOOK",
			added_in: "6.0",
			shortName: "book",
			shortNames: [
				"book",
				"open_book"
			],
			category: 6
		},
		{
			emoji: "📗",
			name: "GREEN BOOK",
			added_in: "6.0",
			shortName: "green_book",
			shortNames: [
				"green_book"
			],
			category: 6
		},
		{
			emoji: "📘",
			name: "BLUE BOOK",
			added_in: "6.0",
			shortName: "blue_book",
			shortNames: [
				"blue_book"
			],
			category: 6
		},
		{
			emoji: "📙",
			name: "ORANGE BOOK",
			added_in: "6.0",
			shortName: "orange_book",
			shortNames: [
				"orange_book"
			],
			category: 6
		},
		{
			emoji: "📚",
			name: "BOOKS",
			added_in: "6.0",
			shortName: "books",
			shortNames: [
				"books"
			],
			category: 6
		},
		{
			emoji: "📜",
			name: "SCROLL",
			added_in: "6.0",
			shortName: "scroll",
			shortNames: [
				"scroll"
			],
			category: 6
		},
		{
			emoji: "📝",
			name: "MEMO",
			added_in: "6.0",
			shortName: "memo",
			shortNames: [
				"memo",
				"pencil"
			],
			category: 6
		},
		{
			emoji: "📞",
			name: "TELEPHONE RECEIVER",
			added_in: "6.0",
			shortName: "telephone_receiver",
			shortNames: [
				"telephone_receiver"
			],
			category: 6
		},
		{
			emoji: "📟",
			name: "PAGER",
			added_in: "6.0",
			shortName: "pager",
			shortNames: [
				"pager"
			],
			category: 6
		},
		{
			emoji: "📠",
			name: "FAX MACHINE",
			added_in: "6.0",
			shortName: "fax",
			shortNames: [
				"fax"
			],
			category: 6
		},
		{
			emoji: "📡",
			name: "SATELLITE ANTENNA",
			added_in: "6.0",
			shortName: "satellite_antenna",
			shortNames: [
				"satellite_antenna"
			],
			category: 6
		},
		{
			emoji: "📢",
			name: "PUBLIC ADDRESS LOUDSPEAKER",
			added_in: "6.0",
			shortName: "loudspeaker",
			shortNames: [
				"loudspeaker"
			],
			category: 6
		},
		{
			emoji: "📣",
			name: "CHEERING MEGAPHONE",
			added_in: "6.0",
			shortName: "mega",
			shortNames: [
				"mega"
			],
			category: 6
		},
		{
			emoji: "📤",
			name: "OUTBOX TRAY",
			added_in: "6.0",
			shortName: "outbox_tray",
			shortNames: [
				"outbox_tray"
			],
			category: 6
		},
		{
			emoji: "📥",
			name: "INBOX TRAY",
			added_in: "6.0",
			shortName: "inbox_tray",
			shortNames: [
				"inbox_tray"
			],
			category: 6
		},
		{
			emoji: "📦",
			name: "PACKAGE",
			added_in: "6.0",
			shortName: "package",
			shortNames: [
				"package"
			],
			category: 6
		},
		{
			emoji: "📧",
			name: "E-MAIL SYMBOL",
			added_in: "6.0",
			shortName: "e-mail",
			shortNames: [
				"e-mail"
			],
			category: 6
		},
		{
			emoji: "📨",
			name: "INCOMING ENVELOPE",
			added_in: "6.0",
			shortName: "incoming_envelope",
			shortNames: [
				"incoming_envelope"
			],
			category: 6
		},
		{
			emoji: "📩",
			name: "ENVELOPE WITH DOWNWARDS ARROW ABOVE",
			added_in: "6.0",
			shortName: "envelope_with_arrow",
			shortNames: [
				"envelope_with_arrow"
			],
			category: 6
		},
		{
			emoji: "📪",
			name: "CLOSED MAILBOX WITH LOWERED FLAG",
			added_in: "6.0",
			shortName: "mailbox_closed",
			shortNames: [
				"mailbox_closed"
			],
			category: 6
		},
		{
			emoji: "📫",
			name: "CLOSED MAILBOX WITH RAISED FLAG",
			added_in: "6.0",
			shortName: "mailbox",
			shortNames: [
				"mailbox"
			],
			category: 6
		},
		{
			emoji: "📬",
			name: "OPEN MAILBOX WITH RAISED FLAG",
			added_in: "6.0",
			shortName: "mailbox_with_mail",
			shortNames: [
				"mailbox_with_mail"
			],
			category: 6
		},
		{
			emoji: "📭",
			name: "OPEN MAILBOX WITH LOWERED FLAG",
			added_in: "6.0",
			shortName: "mailbox_with_no_mail",
			shortNames: [
				"mailbox_with_no_mail"
			],
			category: 6
		},
		{
			emoji: "📮",
			name: "POSTBOX",
			added_in: "6.0",
			shortName: "postbox",
			shortNames: [
				"postbox"
			],
			category: 6
		},
		{
			emoji: "📯",
			name: "POSTAL HORN",
			added_in: "6.0",
			shortName: "postal_horn",
			shortNames: [
				"postal_horn"
			],
			category: 6
		},
		{
			emoji: "📰",
			name: "NEWSPAPER",
			added_in: "6.0",
			shortName: "newspaper",
			shortNames: [
				"newspaper"
			],
			category: 6
		},
		{
			emoji: "📱",
			name: "MOBILE PHONE",
			added_in: "6.0",
			shortName: "iphone",
			shortNames: [
				"iphone"
			],
			category: 6
		},
		{
			emoji: "📲",
			name: "MOBILE PHONE WITH RIGHTWARDS ARROW AT LEFT",
			added_in: "6.0",
			shortName: "calling",
			shortNames: [
				"calling"
			],
			category: 6
		},
		{
			emoji: "📷",
			name: "CAMERA",
			added_in: "6.0",
			shortName: "camera",
			shortNames: [
				"camera"
			],
			category: 6
		},
		{
			emoji: "📹",
			name: "VIDEO CAMERA",
			added_in: "6.0",
			shortName: "video_camera",
			shortNames: [
				"video_camera"
			],
			category: 6
		},
		{
			emoji: "📺",
			name: "TELEVISION",
			added_in: "6.0",
			shortName: "tv",
			shortNames: [
				"tv"
			],
			category: 6
		},
		{
			emoji: "📻",
			name: "RADIO",
			added_in: "6.0",
			shortName: "radio",
			shortNames: [
				"radio"
			],
			category: 6
		},
		{
			emoji: "📼",
			name: "VIDEOCASSETTE",
			added_in: "6.0",
			shortName: "vhs",
			shortNames: [
				"vhs"
			],
			category: 6
		},
		{
			emoji: "🔇",
			name: "SPEAKER WITH CANCELLATION STROKE",
			added_in: "6.0",
			shortName: "mute",
			shortNames: [
				"mute"
			],
			category: 6
		},
		{
			emoji: "🔈",
			name: "SPEAKER",
			added_in: "6.0",
			shortName: "speaker",
			shortNames: [
				"speaker"
			],
			category: 6
		},
		{
			emoji: "🔉",
			name: "SPEAKER WITH ONE SOUND WAVE",
			added_in: "6.0",
			shortName: "sound",
			shortNames: [
				"sound"
			],
			category: 6
		},
		{
			emoji: "🔊",
			name: "SPEAKER WITH THREE SOUND WAVES",
			added_in: "6.0",
			shortName: "loud_sound",
			shortNames: [
				"loud_sound"
			],
			category: 6
		},
		{
			emoji: "🔋",
			name: "BATTERY",
			added_in: "6.0",
			shortName: "battery",
			shortNames: [
				"battery"
			],
			category: 6
		},
		{
			emoji: "🔌",
			name: "ELECTRIC PLUG",
			added_in: "6.0",
			shortName: "electric_plug",
			shortNames: [
				"electric_plug"
			],
			category: 6
		},
		{
			emoji: "🔍",
			name: "LEFT-POINTING MAGNIFYING GLASS",
			added_in: "6.0",
			shortName: "mag",
			shortNames: [
				"mag"
			],
			category: 6
		},
		{
			emoji: "🔎",
			name: "RIGHT-POINTING MAGNIFYING GLASS",
			added_in: "6.0",
			shortName: "mag_right",
			shortNames: [
				"mag_right"
			],
			category: 6
		},
		{
			emoji: "🔏",
			name: "LOCK WITH INK PEN",
			added_in: "6.0",
			shortName: "lock_with_ink_pen",
			shortNames: [
				"lock_with_ink_pen"
			],
			category: 6
		},
		{
			emoji: "🔐",
			name: "CLOSED LOCK WITH KEY",
			added_in: "6.0",
			shortName: "closed_lock_with_key",
			shortNames: [
				"closed_lock_with_key"
			],
			category: 6
		},
		{
			emoji: "🔑",
			name: "KEY",
			added_in: "6.0",
			shortName: "key",
			shortNames: [
				"key"
			],
			category: 6
		},
		{
			emoji: "🔒",
			name: "LOCK",
			added_in: "6.0",
			shortName: "lock",
			shortNames: [
				"lock"
			],
			category: 6
		},
		{
			emoji: "🔓",
			name: "OPEN LOCK",
			added_in: "6.0",
			shortName: "unlock",
			shortNames: [
				"unlock"
			],
			category: 6
		},
		{
			emoji: "🔔",
			name: "BELL",
			added_in: "6.0",
			shortName: "bell",
			shortNames: [
				"bell"
			],
			category: 6
		},
		{
			emoji: "🔕",
			name: "BELL WITH CANCELLATION STROKE",
			added_in: "6.0",
			shortName: "no_bell",
			shortNames: [
				"no_bell"
			],
			category: 6
		},
		{
			emoji: "🔖",
			name: "BOOKMARK",
			added_in: "6.0",
			shortName: "bookmark",
			shortNames: [
				"bookmark"
			],
			category: 6
		},
		{
			emoji: "🔗",
			name: "LINK SYMBOL",
			added_in: "6.0",
			shortName: "link",
			shortNames: [
				"link"
			],
			category: 6
		},
		{
			emoji: "🔦",
			name: "ELECTRIC TORCH",
			added_in: "6.0",
			shortName: "flashlight",
			shortNames: [
				"flashlight"
			],
			category: 6
		},
		{
			emoji: "🔧",
			name: "WRENCH",
			added_in: "6.0",
			shortName: "wrench",
			shortNames: [
				"wrench"
			],
			category: 6
		},
		{
			emoji: "🔨",
			name: "HAMMER",
			added_in: "6.0",
			shortName: "hammer",
			shortNames: [
				"hammer"
			],
			category: 6
		},
		{
			emoji: "🔩",
			name: "NUT AND BOLT",
			added_in: "6.0",
			shortName: "nut_and_bolt",
			shortNames: [
				"nut_and_bolt"
			],
			category: 6
		},
		{
			emoji: "🔫",
			name: "PISTOL",
			added_in: "6.0",
			shortName: "gun",
			shortNames: [
				"gun"
			],
			category: 6
		},
		{
			emoji: "🔬",
			name: "MICROSCOPE",
			added_in: "6.0",
			shortName: "microscope",
			shortNames: [
				"microscope"
			],
			category: 6
		},
		{
			emoji: "🔭",
			name: "TELESCOPE",
			added_in: "6.0",
			shortName: "telescope",
			shortNames: [
				"telescope"
			],
			category: 6
		},
		{
			emoji: "🔮",
			name: "CRYSTAL BALL",
			added_in: "6.0",
			shortName: "crystal_ball",
			shortNames: [
				"crystal_ball"
			],
			category: 6
		},
		{
			emoji: "🗿",
			name: "MOYAI",
			added_in: "6.0",
			shortName: "moyai",
			shortNames: [
				"moyai"
			],
			category: 6
		},
		{
			emoji: "🚬",
			name: "SMOKING SYMBOL",
			added_in: "6.0",
			shortName: "smoking",
			shortNames: [
				"smoking"
			],
			category: 6
		},
		{
			emoji: "☎️",
			name: "BLACK TELEPHONE",
			added_in: "1.1",
			shortName: "phone",
			shortNames: [
				"phone",
				"telephone"
			],
			category: 6
		},
		{
			emoji: "✂️",
			name: "BLACK SCISSORS",
			added_in: "1.1",
			shortName: "scissors",
			shortNames: [
				"scissors"
			],
			category: 6
		},
		{
			emoji: "✉️",
			name: "ENVELOPE",
			added_in: "1.1",
			shortName: "email",
			shortNames: [
				"email",
				"envelope"
			],
			category: 6
		},
		{
			emoji: "✏️",
			name: "PENCIL",
			added_in: "1.1",
			shortName: "pencil2",
			shortNames: [
				"pencil2"
			],
			category: 6
		},
		{
			emoji: "✒️",
			name: "BLACK NIB",
			added_in: "1.1",
			shortName: "black_nib",
			shortNames: [
				"black_nib"
			],
			category: 6
		}
	],
	[
		{
			emoji: "🚼",
			name: "BABY SYMBOL",
			added_in: "6.0",
			shortName: "baby_symbol",
			shortNames: [
				"baby_symbol"
			],
			category: 7
		},
		{
			emoji: "🅰️",
			name: "NEGATIVE SQUARED LATIN CAPITAL LETTER A",
			added_in: "6.0",
			shortName: "a",
			shortNames: [
				"a"
			],
			category: 7
		},
		{
			emoji: "🅱️",
			name: "NEGATIVE SQUARED LATIN CAPITAL LETTER B",
			added_in: "6.0",
			shortName: "b",
			shortNames: [
				"b"
			],
			category: 7
		},
		{
			emoji: "🅾️",
			name: "NEGATIVE SQUARED LATIN CAPITAL LETTER O",
			added_in: "6.0",
			shortName: "o2",
			shortNames: [
				"o2"
			],
			category: 7
		},
		{
			emoji: "🅿️",
			name: "NEGATIVE SQUARED LATIN CAPITAL LETTER P",
			added_in: "5.2",
			shortName: "parking",
			shortNames: [
				"parking"
			],
			category: 7
		},
		{
			emoji: "🆎",
			name: "NEGATIVE SQUARED AB",
			added_in: "6.0",
			shortName: "ab",
			shortNames: [
				"ab"
			],
			category: 7
		},
		{
			emoji: "🆑",
			name: "SQUARED CL",
			added_in: "6.0",
			shortName: "cl",
			shortNames: [
				"cl"
			],
			category: 7
		},
		{
			emoji: "🆒",
			name: "SQUARED COOL",
			added_in: "6.0",
			shortName: "cool",
			shortNames: [
				"cool"
			],
			category: 7
		},
		{
			emoji: "🆓",
			name: "SQUARED FREE",
			added_in: "6.0",
			shortName: "free",
			shortNames: [
				"free"
			],
			category: 7
		},
		{
			emoji: "🆔",
			name: "SQUARED ID",
			added_in: "6.0",
			shortName: "id",
			shortNames: [
				"id"
			],
			category: 7
		},
		{
			emoji: "🆕",
			name: "SQUARED NEW",
			added_in: "6.0",
			shortName: "new",
			shortNames: [
				"new"
			],
			category: 7
		},
		{
			emoji: "🆖",
			name: "SQUARED NG",
			added_in: "6.0",
			shortName: "ng",
			shortNames: [
				"ng"
			],
			category: 7
		},
		{
			emoji: "🆗",
			name: "SQUARED OK",
			added_in: "6.0",
			shortName: "ok",
			shortNames: [
				"ok"
			],
			category: 7
		},
		{
			emoji: "🆘",
			name: "SQUARED SOS",
			added_in: "6.0",
			shortName: "sos",
			shortNames: [
				"sos"
			],
			category: 7
		},
		{
			emoji: "🆙",
			name: "SQUARED UP WITH EXCLAMATION MARK",
			added_in: "6.0",
			shortName: "up",
			shortNames: [
				"up"
			],
			category: 7
		},
		{
			emoji: "🆚",
			name: "SQUARED VS",
			added_in: "6.0",
			shortName: "vs",
			shortNames: [
				"vs"
			],
			category: 7
		},
		{
			emoji: "🈁",
			name: "SQUARED KATAKANA KOKO",
			added_in: "6.0",
			shortName: "koko",
			shortNames: [
				"koko"
			],
			category: 7
		},
		{
			emoji: "🈂️",
			name: "SQUARED KATAKANA SA",
			added_in: "6.0",
			shortName: "sa",
			shortNames: [
				"sa"
			],
			category: 7
		},
		{
			emoji: "🈚",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-7121",
			added_in: "5.2",
			shortName: "u7121",
			shortNames: [
				"u7121"
			],
			category: 7
		},
		{
			emoji: "🈯",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-6307",
			added_in: "5.2",
			shortName: "u6307",
			shortNames: [
				"u6307"
			],
			category: 7
		},
		{
			emoji: "🈲",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-7981",
			added_in: "6.0",
			shortName: "u7981",
			shortNames: [
				"u7981"
			],
			category: 7
		},
		{
			emoji: "🈳",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-7A7A",
			added_in: "6.0",
			shortName: "u7a7a",
			shortNames: [
				"u7a7a"
			],
			category: 7
		},
		{
			emoji: "🈴",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-5408",
			added_in: "6.0",
			shortName: "u5408",
			shortNames: [
				"u5408"
			],
			category: 7
		},
		{
			emoji: "🈵",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-6E80",
			added_in: "6.0",
			shortName: "u6e80",
			shortNames: [
				"u6e80"
			],
			category: 7
		},
		{
			emoji: "🈶",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-6709",
			added_in: "6.0",
			shortName: "u6709",
			shortNames: [
				"u6709"
			],
			category: 7
		},
		{
			emoji: "🈷️",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-6708",
			added_in: "6.0",
			shortName: "u6708",
			shortNames: [
				"u6708"
			],
			category: 7
		},
		{
			emoji: "🈸",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-7533",
			added_in: "6.0",
			shortName: "u7533",
			shortNames: [
				"u7533"
			],
			category: 7
		},
		{
			emoji: "🈹",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-5272",
			added_in: "6.0",
			shortName: "u5272",
			shortNames: [
				"u5272"
			],
			category: 7
		},
		{
			emoji: "🈺",
			name: "SQUARED CJK UNIFIED IDEOGRAPH-55B6",
			added_in: "6.0",
			shortName: "u55b6",
			shortNames: [
				"u55b6"
			],
			category: 7
		},
		{
			emoji: "🉐",
			name: "CIRCLED IDEOGRAPH ADVANTAGE",
			added_in: "6.0",
			shortName: "ideograph_advantage",
			shortNames: [
				"ideograph_advantage"
			],
			category: 7
		},
		{
			emoji: "🉑",
			name: "CIRCLED IDEOGRAPH ACCEPT",
			added_in: "6.0",
			shortName: "accept",
			shortNames: [
				"accept"
			],
			category: 7
		},
		{
			emoji: "🎦",
			name: "CINEMA",
			added_in: "6.0",
			shortName: "cinema",
			shortNames: [
				"cinema"
			],
			category: 7
		},
		{
			emoji: "🏧",
			name: "AUTOMATED TELLER MACHINE",
			added_in: "6.0",
			shortName: "atm",
			shortNames: [
				"atm"
			],
			category: 7
		},
		{
			emoji: "💠",
			name: "DIAMOND SHAPE WITH A DOT INSIDE",
			added_in: "6.0",
			shortName: "diamond_shape_with_a_dot_inside",
			shortNames: [
				"diamond_shape_with_a_dot_inside"
			],
			category: 7
		},
		{
			emoji: "💯",
			name: "HUNDRED POINTS SYMBOL",
			added_in: "6.0",
			shortName: "100",
			shortNames: [
				"100"
			],
			category: 7
		},
		{
			emoji: "📛",
			name: "NAME BADGE",
			added_in: "6.0",
			shortName: "name_badge",
			shortNames: [
				"name_badge"
			],
			category: 7
		},
		{
			emoji: "📳",
			name: "VIBRATION MODE",
			added_in: "6.0",
			shortName: "vibration_mode",
			shortNames: [
				"vibration_mode"
			],
			category: 7
		},
		{
			emoji: "📴",
			name: "MOBILE PHONE OFF",
			added_in: "6.0",
			shortName: "mobile_phone_off",
			shortNames: [
				"mobile_phone_off"
			],
			category: 7
		},
		{
			emoji: "📵",
			name: "NO MOBILE PHONES",
			added_in: "6.0",
			shortName: "no_mobile_phones",
			shortNames: [
				"no_mobile_phones"
			],
			category: 7
		},
		{
			emoji: "📶",
			name: "ANTENNA WITH BARS",
			added_in: "6.0",
			shortName: "signal_strength",
			shortNames: [
				"signal_strength"
			],
			category: 7
		},
		{
			emoji: "🔀",
			name: "TWISTED RIGHTWARDS ARROWS",
			added_in: "6.0",
			shortName: "twisted_rightwards_arrows",
			shortNames: [
				"twisted_rightwards_arrows"
			],
			category: 7
		},
		{
			emoji: "🔁",
			name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS",
			added_in: "6.0",
			shortName: "repeat",
			shortNames: [
				"repeat"
			],
			category: 7
		},
		{
			emoji: "🔂",
			name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS WITH CIRCLED ONE OVERLAY",
			added_in: "6.0",
			shortName: "repeat_one",
			shortNames: [
				"repeat_one"
			],
			category: 7
		},
		{
			emoji: "🔃",
			name: "CLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
			added_in: "6.0",
			shortName: "arrows_clockwise",
			shortNames: [
				"arrows_clockwise"
			],
			category: 7
		},
		{
			emoji: "🔄",
			name: "ANTICLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
			added_in: "6.0",
			shortName: "arrows_counterclockwise",
			shortNames: [
				"arrows_counterclockwise"
			],
			category: 7
		},
		{
			emoji: "🔅",
			name: "LOW BRIGHTNESS SYMBOL",
			added_in: "6.0",
			shortName: "low_brightness",
			shortNames: [
				"low_brightness"
			],
			category: 7
		},
		{
			emoji: "🔆",
			name: "HIGH BRIGHTNESS SYMBOL",
			added_in: "6.0",
			shortName: "high_brightness",
			shortNames: [
				"high_brightness"
			],
			category: 7
		},
		{
			emoji: "🔘",
			name: "RADIO BUTTON",
			added_in: "6.0",
			shortName: "radio_button",
			shortNames: [
				"radio_button"
			],
			category: 7
		},
		{
			emoji: "🔙",
			name: "BACK WITH LEFTWARDS ARROW ABOVE",
			added_in: "6.0",
			shortName: "back",
			shortNames: [
				"back"
			],
			category: 7
		},
		{
			emoji: "🔚",
			name: "END WITH LEFTWARDS ARROW ABOVE",
			added_in: "6.0",
			shortName: "end",
			shortNames: [
				"end"
			],
			category: 7
		},
		{
			emoji: "🔛",
			name: "ON WITH EXCLAMATION MARK WITH LEFT RIGHT ARROW ABOVE",
			added_in: "6.0",
			shortName: "on",
			shortNames: [
				"on"
			],
			category: 7
		},
		{
			emoji: "🔜",
			name: "SOON WITH RIGHTWARDS ARROW ABOVE",
			added_in: "6.0",
			shortName: "soon",
			shortNames: [
				"soon"
			],
			category: 7
		},
		{
			emoji: "🔝",
			name: "TOP WITH UPWARDS ARROW ABOVE",
			added_in: "6.0",
			shortName: "top",
			shortNames: [
				"top"
			],
			category: 7
		},
		{
			emoji: "🔞",
			name: "NO ONE UNDER EIGHTEEN SYMBOL",
			added_in: "6.0",
			shortName: "underage",
			shortNames: [
				"underage"
			],
			category: 7
		},
		{
			emoji: "🔟",
			name: "KEYCAP TEN",
			added_in: "6.0",
			shortName: "keycap_ten",
			shortNames: [
				"keycap_ten"
			],
			category: 7
		},
		{
			emoji: "🔠",
			name: "INPUT SYMBOL FOR LATIN CAPITAL LETTERS",
			added_in: "6.0",
			shortName: "capital_abcd",
			shortNames: [
				"capital_abcd"
			],
			category: 7
		},
		{
			emoji: "🔡",
			name: "INPUT SYMBOL FOR LATIN SMALL LETTERS",
			added_in: "6.0",
			shortName: "abcd",
			shortNames: [
				"abcd"
			],
			category: 7
		},
		{
			emoji: "🔢",
			name: "INPUT SYMBOL FOR NUMBERS",
			added_in: "6.0",
			shortName: "1234",
			shortNames: [
				"1234"
			],
			category: 7
		},
		{
			emoji: "🔣",
			name: "INPUT SYMBOL FOR SYMBOLS",
			added_in: "6.0",
			shortName: "symbols",
			shortNames: [
				"symbols"
			],
			category: 7
		},
		{
			emoji: "🔤",
			name: "INPUT SYMBOL FOR LATIN LETTERS",
			added_in: "6.0",
			shortName: "abc",
			shortNames: [
				"abc"
			],
			category: 7
		},
		{
			emoji: "🔯",
			name: "SIX POINTED STAR WITH MIDDLE DOT",
			added_in: "6.0",
			shortName: "six_pointed_star",
			shortNames: [
				"six_pointed_star"
			],
			category: 7
		},
		{
			emoji: "🔰",
			name: "JAPANESE SYMBOL FOR BEGINNER",
			added_in: "6.0",
			shortName: "beginner",
			shortNames: [
				"beginner"
			],
			category: 7
		},
		{
			emoji: "🔱",
			name: "TRIDENT EMBLEM",
			added_in: "6.0",
			shortName: "trident",
			shortNames: [
				"trident"
			],
			category: 7
		},
		{
			emoji: "🔲",
			name: "BLACK SQUARE BUTTON",
			added_in: "6.0",
			shortName: "black_square_button",
			shortNames: [
				"black_square_button"
			],
			category: 7
		},
		{
			emoji: "🔳",
			name: "WHITE SQUARE BUTTON",
			added_in: "6.0",
			shortName: "white_square_button",
			shortNames: [
				"white_square_button"
			],
			category: 7
		},
		{
			emoji: "🔴",
			name: "LARGE RED CIRCLE",
			added_in: "6.0",
			shortName: "red_circle",
			shortNames: [
				"red_circle"
			],
			category: 7
		},
		{
			emoji: "🔵",
			name: "LARGE BLUE CIRCLE",
			added_in: "6.0",
			shortName: "large_blue_circle",
			shortNames: [
				"large_blue_circle"
			],
			category: 7
		},
		{
			emoji: "🔶",
			name: "LARGE ORANGE DIAMOND",
			added_in: "6.0",
			shortName: "large_orange_diamond",
			shortNames: [
				"large_orange_diamond"
			],
			category: 7
		},
		{
			emoji: "🔷",
			name: "LARGE BLUE DIAMOND",
			added_in: "6.0",
			shortName: "large_blue_diamond",
			shortNames: [
				"large_blue_diamond"
			],
			category: 7
		},
		{
			emoji: "🔸",
			name: "SMALL ORANGE DIAMOND",
			added_in: "6.0",
			shortName: "small_orange_diamond",
			shortNames: [
				"small_orange_diamond"
			],
			category: 7
		},
		{
			emoji: "🔹",
			name: "SMALL BLUE DIAMOND",
			added_in: "6.0",
			shortName: "small_blue_diamond",
			shortNames: [
				"small_blue_diamond"
			],
			category: 7
		},
		{
			emoji: "🔺",
			name: "UP-POINTING RED TRIANGLE",
			added_in: "6.0",
			shortName: "small_red_triangle",
			shortNames: [
				"small_red_triangle"
			],
			category: 7
		},
		{
			emoji: "🔻",
			name: "DOWN-POINTING RED TRIANGLE",
			added_in: "6.0",
			shortName: "small_red_triangle_down",
			shortNames: [
				"small_red_triangle_down"
			],
			category: 7
		},
		{
			emoji: "🔼",
			name: "UP-POINTING SMALL RED TRIANGLE",
			added_in: "6.0",
			shortName: "arrow_up_small",
			shortNames: [
				"arrow_up_small"
			],
			category: 7
		},
		{
			emoji: "🔽",
			name: "DOWN-POINTING SMALL RED TRIANGLE",
			added_in: "6.0",
			shortName: "arrow_down_small",
			shortNames: [
				"arrow_down_small"
			],
			category: 7
		},
		{
			emoji: "🚫",
			name: "NO ENTRY SIGN",
			added_in: "6.0",
			shortName: "no_entry_sign",
			shortNames: [
				"no_entry_sign"
			],
			category: 7
		},
		{
			emoji: "🚭",
			name: "NO SMOKING SYMBOL",
			added_in: "6.0",
			shortName: "no_smoking",
			shortNames: [
				"no_smoking"
			],
			category: 7
		},
		{
			emoji: "🚮",
			name: "PUT LITTER IN ITS PLACE SYMBOL",
			added_in: "6.0",
			shortName: "put_litter_in_its_place",
			shortNames: [
				"put_litter_in_its_place"
			],
			category: 7
		},
		{
			emoji: "🚯",
			name: "DO NOT LITTER SYMBOL",
			added_in: "6.0",
			shortName: "do_not_litter",
			shortNames: [
				"do_not_litter"
			],
			category: 7
		},
		{
			emoji: "🚰",
			name: "POTABLE WATER SYMBOL",
			added_in: "6.0",
			shortName: "potable_water",
			shortNames: [
				"potable_water"
			],
			category: 7
		},
		{
			emoji: "🚱",
			name: "NON-POTABLE WATER SYMBOL",
			added_in: "6.0",
			shortName: "non-potable_water",
			shortNames: [
				"non-potable_water"
			],
			category: 7
		},
		{
			emoji: "🚳",
			name: "NO BICYCLES",
			added_in: "6.0",
			shortName: "no_bicycles",
			shortNames: [
				"no_bicycles"
			],
			category: 7
		},
		{
			emoji: "🚷",
			name: "NO PEDESTRIANS",
			added_in: "6.0",
			shortName: "no_pedestrians",
			shortNames: [
				"no_pedestrians"
			],
			category: 7
		},
		{
			emoji: "🚸",
			name: "CHILDREN CROSSING",
			added_in: "6.0",
			shortName: "children_crossing",
			shortNames: [
				"children_crossing"
			],
			category: 7
		},
		{
			emoji: "🚹",
			name: "MENS SYMBOL",
			added_in: "6.0",
			shortName: "mens",
			shortNames: [
				"mens"
			],
			category: 7
		},
		{
			emoji: "🚺",
			name: "WOMENS SYMBOL",
			added_in: "6.0",
			shortName: "womens",
			shortNames: [
				"womens"
			],
			category: 7
		},
		{
			emoji: "🚻",
			name: "RESTROOM",
			added_in: "6.0",
			shortName: "restroom",
			shortNames: [
				"restroom"
			],
			category: 7
		},
		{
			emoji: "🚾",
			name: "WATER CLOSET",
			added_in: "6.0",
			shortName: "wc",
			shortNames: [
				"wc"
			],
			category: 7
		},
		{
			emoji: "🛂",
			name: "PASSPORT CONTROL",
			added_in: "6.0",
			shortName: "passport_control",
			shortNames: [
				"passport_control"
			],
			category: 7
		},
		{
			emoji: "🛃",
			name: "CUSTOMS",
			added_in: "6.0",
			shortName: "customs",
			shortNames: [
				"customs"
			],
			category: 7
		},
		{
			emoji: "🛄",
			name: "BAGGAGE CLAIM",
			added_in: "6.0",
			shortName: "baggage_claim",
			shortNames: [
				"baggage_claim"
			],
			category: 7
		},
		{
			emoji: "🛅",
			name: "LEFT LUGGAGE",
			added_in: "6.0",
			shortName: "left_luggage",
			shortNames: [
				"left_luggage"
			],
			category: 7
		},
		{
			emoji: "‼️",
			name: "DOUBLE EXCLAMATION MARK",
			added_in: "1.1",
			shortName: "bangbang",
			shortNames: [
				"bangbang"
			],
			category: 7
		},
		{
			emoji: "⁉️",
			name: "EXCLAMATION QUESTION MARK",
			added_in: "3.0",
			shortName: "interrobang",
			shortNames: [
				"interrobang"
			],
			category: 7
		},
		{
			emoji: "™️",
			name: "TRADE MARK SIGN",
			added_in: "1.1",
			shortName: "tm",
			shortNames: [
				"tm"
			],
			category: 7
		},
		{
			emoji: "ℹ️",
			name: "INFORMATION SOURCE",
			added_in: "3.0",
			shortName: "information_source",
			shortNames: [
				"information_source"
			],
			category: 7
		},
		{
			emoji: "↔️",
			name: "LEFT RIGHT ARROW",
			added_in: "1.1",
			shortName: "left_right_arrow",
			shortNames: [
				"left_right_arrow"
			],
			category: 7
		},
		{
			emoji: "↕️",
			name: "UP DOWN ARROW",
			added_in: "1.1",
			shortName: "arrow_up_down",
			shortNames: [
				"arrow_up_down"
			],
			category: 7
		},
		{
			emoji: "↖️",
			name: "NORTH WEST ARROW",
			added_in: "1.1",
			shortName: "arrow_upper_left",
			shortNames: [
				"arrow_upper_left"
			],
			category: 7
		},
		{
			emoji: "↗️",
			name: "NORTH EAST ARROW",
			added_in: "1.1",
			shortName: "arrow_upper_right",
			shortNames: [
				"arrow_upper_right"
			],
			category: 7
		},
		{
			emoji: "↘️",
			name: "SOUTH EAST ARROW",
			added_in: "1.1",
			shortName: "arrow_lower_right",
			shortNames: [
				"arrow_lower_right"
			],
			category: 7
		},
		{
			emoji: "↙️",
			name: "SOUTH WEST ARROW",
			added_in: "1.1",
			shortName: "arrow_lower_left",
			shortNames: [
				"arrow_lower_left"
			],
			category: 7
		},
		{
			emoji: "↩️",
			name: "LEFTWARDS ARROW WITH HOOK",
			added_in: "1.1",
			shortName: "leftwards_arrow_with_hook",
			shortNames: [
				"leftwards_arrow_with_hook"
			],
			category: 7
		},
		{
			emoji: "↪️",
			name: "RIGHTWARDS ARROW WITH HOOK",
			added_in: "1.1",
			shortName: "arrow_right_hook",
			shortNames: [
				"arrow_right_hook"
			],
			category: 7
		},
		{
			emoji: "⏩",
			name: "BLACK RIGHT-POINTING DOUBLE TRIANGLE",
			added_in: "6.0",
			shortName: "fast_forward",
			shortNames: [
				"fast_forward"
			],
			category: 7
		},
		{
			emoji: "⏪",
			name: "BLACK LEFT-POINTING DOUBLE TRIANGLE",
			added_in: "6.0",
			shortName: "rewind",
			shortNames: [
				"rewind"
			],
			category: 7
		},
		{
			emoji: "⏫",
			name: "BLACK UP-POINTING DOUBLE TRIANGLE",
			added_in: "6.0",
			shortName: "arrow_double_up",
			shortNames: [
				"arrow_double_up"
			],
			category: 7
		},
		{
			emoji: "⏬",
			name: "BLACK DOWN-POINTING DOUBLE TRIANGLE",
			added_in: "6.0",
			shortName: "arrow_double_down",
			shortNames: [
				"arrow_double_down"
			],
			category: 7
		},
		{
			emoji: "Ⓜ️",
			name: "CIRCLED LATIN CAPITAL LETTER M",
			added_in: "1.1",
			shortName: "m",
			shortNames: [
				"m"
			],
			category: 7
		},
		{
			emoji: "▪️",
			name: "BLACK SMALL SQUARE",
			added_in: "1.1",
			shortName: "black_small_square",
			shortNames: [
				"black_small_square"
			],
			category: 7
		},
		{
			emoji: "▫️",
			name: "WHITE SMALL SQUARE",
			added_in: "1.1",
			shortName: "white_small_square",
			shortNames: [
				"white_small_square"
			],
			category: 7
		},
		{
			emoji: "▶️",
			name: "BLACK RIGHT-POINTING TRIANGLE",
			added_in: "1.1",
			shortName: "arrow_forward",
			shortNames: [
				"arrow_forward"
			],
			category: 7
		},
		{
			emoji: "◀️",
			name: "BLACK LEFT-POINTING TRIANGLE",
			added_in: "1.1",
			shortName: "arrow_backward",
			shortNames: [
				"arrow_backward"
			],
			category: 7
		},
		{
			emoji: "◻️",
			name: "WHITE MEDIUM SQUARE",
			added_in: "3.2",
			shortName: "white_medium_square",
			shortNames: [
				"white_medium_square"
			],
			category: 7
		},
		{
			emoji: "◼️",
			name: "BLACK MEDIUM SQUARE",
			added_in: "3.2",
			shortName: "black_medium_square",
			shortNames: [
				"black_medium_square"
			],
			category: 7
		},
		{
			emoji: "◽",
			name: "WHITE MEDIUM SMALL SQUARE",
			added_in: "3.2",
			shortName: "white_medium_small_square",
			shortNames: [
				"white_medium_small_square"
			],
			category: 7
		},
		{
			emoji: "◾",
			name: "BLACK MEDIUM SMALL SQUARE",
			added_in: "3.2",
			shortName: "black_medium_small_square",
			shortNames: [
				"black_medium_small_square"
			],
			category: 7
		},
		{
			emoji: "☑️",
			name: "BALLOT BOX WITH CHECK",
			added_in: "1.1",
			shortName: "ballot_box_with_check",
			shortNames: [
				"ballot_box_with_check"
			],
			category: 7
		},
		{
			emoji: "♈",
			name: "ARIES",
			added_in: "1.1",
			shortName: "aries",
			shortNames: [
				"aries"
			],
			category: 7
		},
		{
			emoji: "♉",
			name: "TAURUS",
			added_in: "1.1",
			shortName: "taurus",
			shortNames: [
				"taurus"
			],
			category: 7
		},
		{
			emoji: "♊",
			name: "GEMINI",
			added_in: "1.1",
			shortName: "gemini",
			shortNames: [
				"gemini"
			],
			category: 7
		},
		{
			emoji: "♋",
			name: "CANCER",
			added_in: "1.1",
			shortName: "cancer",
			shortNames: [
				"cancer"
			],
			category: 7
		},
		{
			emoji: "♌",
			name: "LEO",
			added_in: "1.1",
			shortName: "leo",
			shortNames: [
				"leo"
			],
			category: 7
		},
		{
			emoji: "♍",
			name: "VIRGO",
			added_in: "1.1",
			shortName: "virgo",
			shortNames: [
				"virgo"
			],
			category: 7
		},
		{
			emoji: "♎",
			name: "LIBRA",
			added_in: "1.1",
			shortName: "libra",
			shortNames: [
				"libra"
			],
			category: 7
		},
		{
			emoji: "♏",
			name: "SCORPIUS",
			added_in: "1.1",
			shortName: "scorpius",
			shortNames: [
				"scorpius"
			],
			category: 7
		},
		{
			emoji: "♐",
			name: "SAGITTARIUS",
			added_in: "1.1",
			shortName: "sagittarius",
			shortNames: [
				"sagittarius"
			],
			category: 7
		},
		{
			emoji: "♑",
			name: "CAPRICORN",
			added_in: "1.1",
			shortName: "capricorn",
			shortNames: [
				"capricorn"
			],
			category: 7
		},
		{
			emoji: "♒",
			name: "AQUARIUS",
			added_in: "1.1",
			shortName: "aquarius",
			shortNames: [
				"aquarius"
			],
			category: 7
		},
		{
			emoji: "♓",
			name: "PISCES",
			added_in: "1.1",
			shortName: "pisces",
			shortNames: [
				"pisces"
			],
			category: 7
		},
		{
			emoji: "♻️",
			name: "BLACK UNIVERSAL RECYCLING SYMBOL",
			added_in: "3.2",
			shortName: "recycle",
			shortNames: [
				"recycle"
			],
			category: 7
		},
		{
			emoji: "♿",
			name: "WHEELCHAIR SYMBOL",
			added_in: "4.1",
			shortName: "wheelchair",
			shortNames: [
				"wheelchair"
			],
			category: 7
		},
		{
			emoji: "⚠️",
			name: "WARNING SIGN",
			added_in: "4.0",
			shortName: "warning",
			shortNames: [
				"warning"
			],
			category: 7
		},
		{
			emoji: "⚪",
			name: "MEDIUM WHITE CIRCLE",
			added_in: "4.1",
			shortName: "white_circle",
			shortNames: [
				"white_circle"
			],
			category: 7
		},
		{
			emoji: "⚫",
			name: "MEDIUM BLACK CIRCLE",
			added_in: "4.1",
			shortName: "black_circle",
			shortNames: [
				"black_circle"
			],
			category: 7
		},
		{
			emoji: "⛎",
			name: "OPHIUCHUS",
			added_in: "6.0",
			shortName: "ophiuchus",
			shortNames: [
				"ophiuchus"
			],
			category: 7
		},
		{
			emoji: "⛔",
			name: "NO ENTRY",
			added_in: "5.2",
			shortName: "no_entry",
			shortNames: [
				"no_entry"
			],
			category: 7
		},
		{
			emoji: "✅",
			name: "WHITE HEAVY CHECK MARK",
			added_in: "6.0",
			shortName: "white_check_mark",
			shortNames: [
				"white_check_mark"
			],
			category: 7
		},
		{
			emoji: "✔️",
			name: "HEAVY CHECK MARK",
			added_in: "1.1",
			shortName: "heavy_check_mark",
			shortNames: [
				"heavy_check_mark"
			],
			category: 7
		},
		{
			emoji: "✖️",
			name: "HEAVY MULTIPLICATION X",
			added_in: "1.1",
			shortName: "heavy_multiplication_x",
			shortNames: [
				"heavy_multiplication_x"
			],
			category: 7
		},
		{
			emoji: "✳️",
			name: "EIGHT SPOKED ASTERISK",
			added_in: "1.1",
			shortName: "eight_spoked_asterisk",
			shortNames: [
				"eight_spoked_asterisk"
			],
			category: 7
		},
		{
			emoji: "✴️",
			name: "EIGHT POINTED BLACK STAR",
			added_in: "1.1",
			shortName: "eight_pointed_black_star",
			shortNames: [
				"eight_pointed_black_star"
			],
			category: 7
		},
		{
			emoji: "❇️",
			name: "SPARKLE",
			added_in: "1.1",
			shortName: "sparkle",
			shortNames: [
				"sparkle"
			],
			category: 7
		},
		{
			emoji: "❌",
			name: "CROSS MARK",
			added_in: "6.0",
			shortName: "x",
			shortNames: [
				"x"
			],
			category: 7
		},
		{
			emoji: "❎",
			name: "NEGATIVE SQUARED CROSS MARK",
			added_in: "6.0",
			shortName: "negative_squared_cross_mark",
			shortNames: [
				"negative_squared_cross_mark"
			],
			category: 7
		},
		{
			emoji: "❓",
			name: "BLACK QUESTION MARK ORNAMENT",
			added_in: "6.0",
			shortName: "question",
			shortNames: [
				"question"
			],
			category: 7
		},
		{
			emoji: "❔",
			name: "WHITE QUESTION MARK ORNAMENT",
			added_in: "6.0",
			shortName: "grey_question",
			shortNames: [
				"grey_question"
			],
			category: 7
		},
		{
			emoji: "❕",
			name: "WHITE EXCLAMATION MARK ORNAMENT",
			added_in: "6.0",
			shortName: "grey_exclamation",
			shortNames: [
				"grey_exclamation"
			],
			category: 7
		},
		{
			emoji: "❗",
			name: "HEAVY EXCLAMATION MARK SYMBOL",
			added_in: "5.2",
			shortName: "exclamation",
			shortNames: [
				"exclamation",
				"heavy_exclamation_mark"
			],
			category: 7
		},
		{
			emoji: "➕",
			name: "HEAVY PLUS SIGN",
			added_in: "6.0",
			shortName: "heavy_plus_sign",
			shortNames: [
				"heavy_plus_sign"
			],
			category: 7
		},
		{
			emoji: "➖",
			name: "HEAVY MINUS SIGN",
			added_in: "6.0",
			shortName: "heavy_minus_sign",
			shortNames: [
				"heavy_minus_sign"
			],
			category: 7
		},
		{
			emoji: "➗",
			name: "HEAVY DIVISION SIGN",
			added_in: "6.0",
			shortName: "heavy_division_sign",
			shortNames: [
				"heavy_division_sign"
			],
			category: 7
		},
		{
			emoji: "➡️",
			name: "BLACK RIGHTWARDS ARROW",
			added_in: "1.1",
			shortName: "arrow_right",
			shortNames: [
				"arrow_right"
			],
			category: 7
		},
		{
			emoji: "➰",
			name: "CURLY LOOP",
			added_in: "6.0",
			shortName: "curly_loop",
			shortNames: [
				"curly_loop"
			],
			category: 7
		},
		{
			emoji: "➿",
			name: "DOUBLE CURLY LOOP",
			added_in: "6.0",
			shortName: "loop",
			shortNames: [
				"loop"
			],
			category: 7
		},
		{
			emoji: "⤴️",
			name: "ARROW POINTING RIGHTWARDS THEN CURVING UPWARDS",
			added_in: "3.2",
			shortName: "arrow_heading_up",
			shortNames: [
				"arrow_heading_up"
			],
			category: 7
		},
		{
			emoji: "⤵️",
			name: "ARROW POINTING RIGHTWARDS THEN CURVING DOWNWARDS",
			added_in: "3.2",
			shortName: "arrow_heading_down",
			shortNames: [
				"arrow_heading_down"
			],
			category: 7
		},
		{
			emoji: "⬅️",
			name: "LEFTWARDS BLACK ARROW",
			added_in: "4.0",
			shortName: "arrow_left",
			shortNames: [
				"arrow_left"
			],
			category: 7
		},
		{
			emoji: "⬆️",
			name: "UPWARDS BLACK ARROW",
			added_in: "4.0",
			shortName: "arrow_up",
			shortNames: [
				"arrow_up"
			],
			category: 7
		},
		{
			emoji: "⬇️",
			name: "DOWNWARDS BLACK ARROW",
			added_in: "4.0",
			shortName: "arrow_down",
			shortNames: [
				"arrow_down"
			],
			category: 7
		},
		{
			emoji: "⬛",
			name: "BLACK LARGE SQUARE",
			added_in: "5.1",
			shortName: "black_large_square",
			shortNames: [
				"black_large_square"
			],
			category: 7
		},
		{
			emoji: "⬜",
			name: "WHITE LARGE SQUARE",
			added_in: "5.1",
			shortName: "white_large_square",
			shortNames: [
				"white_large_square"
			],
			category: 7
		},
		{
			emoji: "⭕",
			name: "HEAVY LARGE CIRCLE",
			added_in: "5.2",
			shortName: "o",
			shortNames: [
				"o"
			],
			category: 7
		},
		{
			emoji: "〰️",
			name: "WAVY DASH",
			added_in: "1.1",
			shortName: "wavy_dash",
			shortNames: [
				"wavy_dash"
			],
			category: 7
		},
		{
			emoji: "〽️",
			name: "PART ALTERNATION MARK",
			added_in: "3.2",
			shortName: "part_alternation_mark",
			shortNames: [
				"part_alternation_mark"
			],
			category: 7
		},
		{
			emoji: "㊗️",
			name: "CIRCLED IDEOGRAPH CONGRATULATION",
			added_in: "1.1",
			shortName: "congratulations",
			shortNames: [
				"congratulations"
			],
			category: 7
		},
		{
			emoji: "㊙️",
			name: "CIRCLED IDEOGRAPH SECRET",
			added_in: "1.1",
			shortName: "secret",
			shortNames: [
				"secret"
			],
			category: 7
		}
	],
	[
		{
			emoji: "🇩🇪",
			name: "Germany Flag",
			added_in: "6.0",
			shortName: "de",
			shortNames: [
				"de",
				"flag-de"
			],
			category: 8
		},
		{
			emoji: "🇮🇲",
			name: "Isle of Man Flag",
			added_in: "6.0",
			shortName: "flag-im",
			shortNames: [
				"flag-im"
			],
			category: 8
		},
		{
			emoji: "🇰🇾",
			name: "Cayman Islands Flag",
			added_in: "6.0",
			shortName: "flag-ky",
			shortNames: [
				"flag-ky"
			],
			category: 8
		},
		{
			emoji: "🇴🇲",
			name: "Oman Flag",
			added_in: "6.0",
			shortName: "flag-om",
			shortNames: [
				"flag-om"
			],
			category: 8
		},
		{
			emoji: "🇷🇴",
			name: "Romania Flag",
			added_in: "6.0",
			shortName: "flag-ro",
			shortNames: [
				"flag-ro"
			],
			category: 8
		},
		{
			emoji: "🇦🇨",
			name: "Ascension Island Flag",
			added_in: "6.0",
			shortName: "flag-ac",
			shortNames: [
				"flag-ac"
			],
			category: 8
		},
		{
			emoji: "🇦🇩",
			name: "Andorra Flag",
			added_in: "6.0",
			shortName: "flag-ad",
			shortNames: [
				"flag-ad"
			],
			category: 8
		},
		{
			emoji: "🇦🇪",
			name: "United Arab Emirates Flag",
			added_in: "6.0",
			shortName: "flag-ae",
			shortNames: [
				"flag-ae"
			],
			category: 8
		},
		{
			emoji: "🇦🇫",
			name: "Afghanistan Flag",
			added_in: "6.0",
			shortName: "flag-af",
			shortNames: [
				"flag-af"
			],
			category: 8
		},
		{
			emoji: "🇦🇬",
			name: "Antigua & Barbuda Flag",
			added_in: "6.0",
			shortName: "flag-ag",
			shortNames: [
				"flag-ag"
			],
			category: 8
		},
		{
			emoji: "🇦🇮",
			name: "Anguilla Flag",
			added_in: "6.0",
			shortName: "flag-ai",
			shortNames: [
				"flag-ai"
			],
			category: 8
		},
		{
			emoji: "🇦🇱",
			name: "Albania Flag",
			added_in: "6.0",
			shortName: "flag-al",
			shortNames: [
				"flag-al"
			],
			category: 8
		},
		{
			emoji: "🇦🇲",
			name: "Armenia Flag",
			added_in: "6.0",
			shortName: "flag-am",
			shortNames: [
				"flag-am"
			],
			category: 8
		},
		{
			emoji: "🇦🇴",
			name: "Angola Flag",
			added_in: "6.0",
			shortName: "flag-ao",
			shortNames: [
				"flag-ao"
			],
			category: 8
		},
		{
			emoji: "🇦🇶",
			name: "Antarctica Flag",
			added_in: "6.0",
			shortName: "flag-aq",
			shortNames: [
				"flag-aq"
			],
			category: 8
		},
		{
			emoji: "🇦🇷",
			name: "Argentina Flag",
			added_in: "6.0",
			shortName: "flag-ar",
			shortNames: [
				"flag-ar"
			],
			category: 8
		},
		{
			emoji: "🇦🇸",
			name: "American Samoa Flag",
			added_in: "6.0",
			shortName: "flag-as",
			shortNames: [
				"flag-as"
			],
			category: 8
		},
		{
			emoji: "🇦🇹",
			name: "Austria Flag",
			added_in: "6.0",
			shortName: "flag-at",
			shortNames: [
				"flag-at"
			],
			category: 8
		},
		{
			emoji: "🇦🇺",
			name: "Australia Flag",
			added_in: "6.0",
			shortName: "flag-au",
			shortNames: [
				"flag-au"
			],
			category: 8
		},
		{
			emoji: "🇦🇼",
			name: "Aruba Flag",
			added_in: "6.0",
			shortName: "flag-aw",
			shortNames: [
				"flag-aw"
			],
			category: 8
		},
		{
			emoji: "🇦🇽",
			name: "Åland Islands Flag",
			added_in: "6.0",
			shortName: "flag-ax",
			shortNames: [
				"flag-ax"
			],
			category: 8
		},
		{
			emoji: "🇦🇿",
			name: "Azerbaijan Flag",
			added_in: "6.0",
			shortName: "flag-az",
			shortNames: [
				"flag-az"
			],
			category: 8
		},
		{
			emoji: "🇧🇧",
			name: "Barbados Flag",
			added_in: "6.0",
			shortName: "flag-bb",
			shortNames: [
				"flag-bb"
			],
			category: 8
		},
		{
			emoji: "🇧🇩",
			name: "Bangladesh Flag",
			added_in: "6.0",
			shortName: "flag-bd",
			shortNames: [
				"flag-bd"
			],
			category: 8
		},
		{
			emoji: "🇧🇪",
			name: "Belgium Flag",
			added_in: "6.0",
			shortName: "flag-be",
			shortNames: [
				"flag-be"
			],
			category: 8
		},
		{
			emoji: "🇧🇫",
			name: "Burkina Faso Flag",
			added_in: "6.0",
			shortName: "flag-bf",
			shortNames: [
				"flag-bf"
			],
			category: 8
		},
		{
			emoji: "🇧🇬",
			name: "Bulgaria Flag",
			added_in: "6.0",
			shortName: "flag-bg",
			shortNames: [
				"flag-bg"
			],
			category: 8
		},
		{
			emoji: "🇧🇭",
			name: "Bahrain Flag",
			added_in: "6.0",
			shortName: "flag-bh",
			shortNames: [
				"flag-bh"
			],
			category: 8
		},
		{
			emoji: "🇧🇮",
			name: "Burundi Flag",
			added_in: "6.0",
			shortName: "flag-bi",
			shortNames: [
				"flag-bi"
			],
			category: 8
		},
		{
			emoji: "🇧🇯",
			name: "Benin Flag",
			added_in: "6.0",
			shortName: "flag-bj",
			shortNames: [
				"flag-bj"
			],
			category: 8
		},
		{
			emoji: "🇧🇲",
			name: "Bermuda Flag",
			added_in: "6.0",
			shortName: "flag-bm",
			shortNames: [
				"flag-bm"
			],
			category: 8
		},
		{
			emoji: "🇧🇴",
			name: "Bolivia Flag",
			added_in: "6.0",
			shortName: "flag-bo",
			shortNames: [
				"flag-bo"
			],
			category: 8
		},
		{
			emoji: "🇧🇷",
			name: "Brazil Flag",
			added_in: "6.0",
			shortName: "flag-br",
			shortNames: [
				"flag-br"
			],
			category: 8
		},
		{
			emoji: "🇧🇸",
			name: "Bahamas Flag",
			added_in: "6.0",
			shortName: "flag-bs",
			shortNames: [
				"flag-bs"
			],
			category: 8
		},
		{
			emoji: "🇧🇹",
			name: "Bhutan Flag",
			added_in: "6.0",
			shortName: "flag-bt",
			shortNames: [
				"flag-bt"
			],
			category: 8
		},
		{
			emoji: "🇧🇻",
			name: "Bouvet Island Flag",
			added_in: "6.0",
			shortName: "flag-bv",
			shortNames: [
				"flag-bv"
			],
			category: 8
		},
		{
			emoji: "🇧🇼",
			name: "Botswana Flag",
			added_in: "6.0",
			shortName: "flag-bw",
			shortNames: [
				"flag-bw"
			],
			category: 8
		},
		{
			emoji: "🇧🇾",
			name: "Belarus Flag",
			added_in: "6.0",
			shortName: "flag-by",
			shortNames: [
				"flag-by"
			],
			category: 8
		},
		{
			emoji: "🇧🇿",
			name: "Belize Flag",
			added_in: "6.0",
			shortName: "flag-bz",
			shortNames: [
				"flag-bz"
			],
			category: 8
		},
		{
			emoji: "🇨🇦",
			name: "Canada Flag",
			added_in: "6.0",
			shortName: "flag-ca",
			shortNames: [
				"flag-ca"
			],
			category: 8
		},
		{
			emoji: "🇨🇨",
			name: "Cocos (Keeling) Islands Flag",
			added_in: "6.0",
			shortName: "flag-cc",
			shortNames: [
				"flag-cc"
			],
			category: 8
		},
		{
			emoji: "🇨🇩",
			name: "Congo - Kinshasa Flag",
			added_in: "6.0",
			shortName: "flag-cd",
			shortNames: [
				"flag-cd"
			],
			category: 8
		},
		{
			emoji: "🇨🇫",
			name: "Central African Republic Flag",
			added_in: "6.0",
			shortName: "flag-cf",
			shortNames: [
				"flag-cf"
			],
			category: 8
		},
		{
			emoji: "🇨🇬",
			name: "Congo - Brazzaville Flag",
			added_in: "6.0",
			shortName: "flag-cg",
			shortNames: [
				"flag-cg"
			],
			category: 8
		},
		{
			emoji: "🇨🇭",
			name: "Switzerland Flag",
			added_in: "6.0",
			shortName: "flag-ch",
			shortNames: [
				"flag-ch"
			],
			category: 8
		},
		{
			emoji: "🇨🇮",
			name: "Côte d’Ivoire Flag",
			added_in: "6.0",
			shortName: "flag-ci",
			shortNames: [
				"flag-ci"
			],
			category: 8
		},
		{
			emoji: "🇨🇰",
			name: "Cook Islands Flag",
			added_in: "6.0",
			shortName: "flag-ck",
			shortNames: [
				"flag-ck"
			],
			category: 8
		},
		{
			emoji: "🇨🇱",
			name: "Chile Flag",
			added_in: "6.0",
			shortName: "flag-cl",
			shortNames: [
				"flag-cl"
			],
			category: 8
		},
		{
			emoji: "🇨🇲",
			name: "Cameroon Flag",
			added_in: "6.0",
			shortName: "flag-cm",
			shortNames: [
				"flag-cm"
			],
			category: 8
		},
		{
			emoji: "🇨🇳",
			name: "China Flag",
			added_in: "6.0",
			shortName: "cn",
			shortNames: [
				"cn",
				"flag-cn"
			],
			category: 8
		},
		{
			emoji: "🇨🇴",
			name: "Colombia Flag",
			added_in: "6.0",
			shortName: "flag-co",
			shortNames: [
				"flag-co"
			],
			category: 8
		},
		{
			emoji: "🇨🇷",
			name: "Costa Rica Flag",
			added_in: "6.0",
			shortName: "flag-cr",
			shortNames: [
				"flag-cr"
			],
			category: 8
		},
		{
			emoji: "🇨🇺",
			name: "Cuba Flag",
			added_in: "6.0",
			shortName: "flag-cu",
			shortNames: [
				"flag-cu"
			],
			category: 8
		},
		{
			emoji: "🇨🇻",
			name: "Cape Verde Flag",
			added_in: "6.0",
			shortName: "flag-cv",
			shortNames: [
				"flag-cv"
			],
			category: 8
		},
		{
			emoji: "🇨🇼",
			name: "Curaçao Flag",
			added_in: "6.0",
			shortName: "flag-cw",
			shortNames: [
				"flag-cw"
			],
			category: 8
		},
		{
			emoji: "🇨🇽",
			name: "Christmas Island Flag",
			added_in: "6.0",
			shortName: "flag-cx",
			shortNames: [
				"flag-cx"
			],
			category: 8
		},
		{
			emoji: "🇨🇾",
			name: "Cyprus Flag",
			added_in: "6.0",
			shortName: "flag-cy",
			shortNames: [
				"flag-cy"
			],
			category: 8
		},
		{
			emoji: "🇨🇿",
			name: "Czechia Flag",
			added_in: "6.0",
			shortName: "flag-cz",
			shortNames: [
				"flag-cz"
			],
			category: 8
		},
		{
			emoji: "🇩🇯",
			name: "Djibouti Flag",
			added_in: "6.0",
			shortName: "flag-dj",
			shortNames: [
				"flag-dj"
			],
			category: 8
		},
		{
			emoji: "🇩🇰",
			name: "Denmark Flag",
			added_in: "6.0",
			shortName: "flag-dk",
			shortNames: [
				"flag-dk"
			],
			category: 8
		},
		{
			emoji: "🇩🇲",
			name: "Dominica Flag",
			added_in: "6.0",
			shortName: "flag-dm",
			shortNames: [
				"flag-dm"
			],
			category: 8
		},
		{
			emoji: "🇩🇴",
			name: "Dominican Republic Flag",
			added_in: "6.0",
			shortName: "flag-do",
			shortNames: [
				"flag-do"
			],
			category: 8
		},
		{
			emoji: "🇩🇿",
			name: "Algeria Flag",
			added_in: "6.0",
			shortName: "flag-dz",
			shortNames: [
				"flag-dz"
			],
			category: 8
		},
		{
			emoji: "🇪🇨",
			name: "Ecuador Flag",
			added_in: "6.0",
			shortName: "flag-ec",
			shortNames: [
				"flag-ec"
			],
			category: 8
		},
		{
			emoji: "🇪🇪",
			name: "Estonia Flag",
			added_in: "6.0",
			shortName: "flag-ee",
			shortNames: [
				"flag-ee"
			],
			category: 8
		},
		{
			emoji: "🇪🇬",
			name: "Egypt Flag",
			added_in: "6.0",
			shortName: "flag-eg",
			shortNames: [
				"flag-eg"
			],
			category: 8
		},
		{
			emoji: "🇪🇷",
			name: "Eritrea Flag",
			added_in: "6.0",
			shortName: "flag-er",
			shortNames: [
				"flag-er"
			],
			category: 8
		},
		{
			emoji: "🇪🇸",
			name: "Spain Flag",
			added_in: "6.0",
			shortName: "es",
			shortNames: [
				"es",
				"flag-es"
			],
			category: 8
		},
		{
			emoji: "🇪🇹",
			name: "Ethiopia Flag",
			added_in: "6.0",
			shortName: "flag-et",
			shortNames: [
				"flag-et"
			],
			category: 8
		},
		{
			emoji: "🇪🇺",
			name: "European Union Flag",
			added_in: "6.0",
			shortName: "flag-eu",
			shortNames: [
				"flag-eu"
			],
			category: 8
		},
		{
			emoji: "🇫🇮",
			name: "Finland Flag",
			added_in: "6.0",
			shortName: "flag-fi",
			shortNames: [
				"flag-fi"
			],
			category: 8
		},
		{
			emoji: "🇫🇯",
			name: "Fiji Flag",
			added_in: "6.0",
			shortName: "flag-fj",
			shortNames: [
				"flag-fj"
			],
			category: 8
		},
		{
			emoji: "🇫🇲",
			name: "Micronesia Flag",
			added_in: "6.0",
			shortName: "flag-fm",
			shortNames: [
				"flag-fm"
			],
			category: 8
		},
		{
			emoji: "🇫🇴",
			name: "Faroe Islands Flag",
			added_in: "6.0",
			shortName: "flag-fo",
			shortNames: [
				"flag-fo"
			],
			category: 8
		},
		{
			emoji: "🇫🇷",
			name: "France Flag",
			added_in: "6.0",
			shortName: "fr",
			shortNames: [
				"fr",
				"flag-fr"
			],
			category: 8
		},
		{
			emoji: "🇬🇦",
			name: "Gabon Flag",
			added_in: "6.0",
			shortName: "flag-ga",
			shortNames: [
				"flag-ga"
			],
			category: 8
		},
		{
			emoji: "🇬🇧",
			name: "United Kingdom Flag",
			added_in: "6.0",
			shortName: "gb",
			shortNames: [
				"gb",
				"uk",
				"flag-gb"
			],
			category: 8
		},
		{
			emoji: "🇬🇩",
			name: "Grenada Flag",
			added_in: "6.0",
			shortName: "flag-gd",
			shortNames: [
				"flag-gd"
			],
			category: 8
		},
		{
			emoji: "🇬🇪",
			name: "Georgia Flag",
			added_in: "6.0",
			shortName: "flag-ge",
			shortNames: [
				"flag-ge"
			],
			category: 8
		},
		{
			emoji: "🇬🇬",
			name: "Guernsey Flag",
			added_in: "6.0",
			shortName: "flag-gg",
			shortNames: [
				"flag-gg"
			],
			category: 8
		},
		{
			emoji: "🇬🇭",
			name: "Ghana Flag",
			added_in: "6.0",
			shortName: "flag-gh",
			shortNames: [
				"flag-gh"
			],
			category: 8
		},
		{
			emoji: "🇬🇮",
			name: "Gibraltar Flag",
			added_in: "6.0",
			shortName: "flag-gi",
			shortNames: [
				"flag-gi"
			],
			category: 8
		},
		{
			emoji: "🇬🇱",
			name: "Greenland Flag",
			added_in: "6.0",
			shortName: "flag-gl",
			shortNames: [
				"flag-gl"
			],
			category: 8
		},
		{
			emoji: "🇬🇲",
			name: "Gambia Flag",
			added_in: "6.0",
			shortName: "flag-gm",
			shortNames: [
				"flag-gm"
			],
			category: 8
		},
		{
			emoji: "🇬🇳",
			name: "Guinea Flag",
			added_in: "6.0",
			shortName: "flag-gn",
			shortNames: [
				"flag-gn"
			],
			category: 8
		},
		{
			emoji: "🇬🇶",
			name: "Equatorial Guinea Flag",
			added_in: "6.0",
			shortName: "flag-gq",
			shortNames: [
				"flag-gq"
			],
			category: 8
		},
		{
			emoji: "🇬🇷",
			name: "Greece Flag",
			added_in: "6.0",
			shortName: "flag-gr",
			shortNames: [
				"flag-gr"
			],
			category: 8
		},
		{
			emoji: "🇬🇹",
			name: "Guatemala Flag",
			added_in: "6.0",
			shortName: "flag-gt",
			shortNames: [
				"flag-gt"
			],
			category: 8
		},
		{
			emoji: "🇬🇺",
			name: "Guam Flag",
			added_in: "6.0",
			shortName: "flag-gu",
			shortNames: [
				"flag-gu"
			],
			category: 8
		},
		{
			emoji: "🇬🇼",
			name: "Guinea-Bissau Flag",
			added_in: "6.0",
			shortName: "flag-gw",
			shortNames: [
				"flag-gw"
			],
			category: 8
		},
		{
			emoji: "🇬🇾",
			name: "Guyana Flag",
			added_in: "6.0",
			shortName: "flag-gy",
			shortNames: [
				"flag-gy"
			],
			category: 8
		},
		{
			emoji: "🇭🇰",
			name: "Hong Kong SAR China Flag",
			added_in: "6.0",
			shortName: "flag-hk",
			shortNames: [
				"flag-hk"
			],
			category: 8
		},
		{
			emoji: "🇭🇲",
			name: "Heard & McDonald Islands Flag",
			added_in: "6.0",
			shortName: "flag-hm",
			shortNames: [
				"flag-hm"
			],
			category: 8
		},
		{
			emoji: "🇭🇳",
			name: "Honduras Flag",
			added_in: "6.0",
			shortName: "flag-hn",
			shortNames: [
				"flag-hn"
			],
			category: 8
		},
		{
			emoji: "🇭🇷",
			name: "Croatia Flag",
			added_in: "6.0",
			shortName: "flag-hr",
			shortNames: [
				"flag-hr"
			],
			category: 8
		},
		{
			emoji: "🇭🇹",
			name: "Haiti Flag",
			added_in: "6.0",
			shortName: "flag-ht",
			shortNames: [
				"flag-ht"
			],
			category: 8
		},
		{
			emoji: "🇭🇺",
			name: "Hungary Flag",
			added_in: "6.0",
			shortName: "flag-hu",
			shortNames: [
				"flag-hu"
			],
			category: 8
		},
		{
			emoji: "🇮🇨",
			name: "Canary Islands Flag",
			added_in: "6.0",
			shortName: "flag-ic",
			shortNames: [
				"flag-ic"
			],
			category: 8
		},
		{
			emoji: "🇮🇩",
			name: "Indonesia Flag",
			added_in: "6.0",
			shortName: "flag-id",
			shortNames: [
				"flag-id"
			],
			category: 8
		},
		{
			emoji: "🇮🇪",
			name: "Ireland Flag",
			added_in: "6.0",
			shortName: "flag-ie",
			shortNames: [
				"flag-ie"
			],
			category: 8
		},
		{
			emoji: "🇮🇱",
			name: "Israel Flag",
			added_in: "6.0",
			shortName: "flag-il",
			shortNames: [
				"flag-il"
			],
			category: 8
		},
		{
			emoji: "🇮🇳",
			name: "India Flag",
			added_in: "6.0",
			shortName: "flag-in",
			shortNames: [
				"flag-in"
			],
			category: 8
		},
		{
			emoji: "🇮🇴",
			name: "British Indian Ocean Territory Flag",
			added_in: "6.0",
			shortName: "flag-io",
			shortNames: [
				"flag-io"
			],
			category: 8
		},
		{
			emoji: "🇮🇶",
			name: "Iraq Flag",
			added_in: "6.0",
			shortName: "flag-iq",
			shortNames: [
				"flag-iq"
			],
			category: 8
		},
		{
			emoji: "🇮🇷",
			name: "Iran Flag",
			added_in: "6.0",
			shortName: "flag-ir",
			shortNames: [
				"flag-ir"
			],
			category: 8
		},
		{
			emoji: "🇮🇸",
			name: "Iceland Flag",
			added_in: "6.0",
			shortName: "flag-is",
			shortNames: [
				"flag-is"
			],
			category: 8
		},
		{
			emoji: "🇮🇹",
			name: "Italy Flag",
			added_in: "6.0",
			shortName: "it",
			shortNames: [
				"it",
				"flag-it"
			],
			category: 8
		},
		{
			emoji: "🇯🇪",
			name: "Jersey Flag",
			added_in: "6.0",
			shortName: "flag-je",
			shortNames: [
				"flag-je"
			],
			category: 8
		},
		{
			emoji: "🇯🇲",
			name: "Jamaica Flag",
			added_in: "6.0",
			shortName: "flag-jm",
			shortNames: [
				"flag-jm"
			],
			category: 8
		},
		{
			emoji: "🇯🇴",
			name: "Jordan Flag",
			added_in: "6.0",
			shortName: "flag-jo",
			shortNames: [
				"flag-jo"
			],
			category: 8
		},
		{
			emoji: "🇯🇵",
			name: "Japan Flag",
			added_in: "6.0",
			shortName: "jp",
			shortNames: [
				"jp",
				"flag-jp"
			],
			category: 8
		},
		{
			emoji: "🇰🇪",
			name: "Kenya Flag",
			added_in: "6.0",
			shortName: "flag-ke",
			shortNames: [
				"flag-ke"
			],
			category: 8
		},
		{
			emoji: "🇰🇬",
			name: "Kyrgyzstan Flag",
			added_in: "6.0",
			shortName: "flag-kg",
			shortNames: [
				"flag-kg"
			],
			category: 8
		},
		{
			emoji: "🇰🇭",
			name: "Cambodia Flag",
			added_in: "6.0",
			shortName: "flag-kh",
			shortNames: [
				"flag-kh"
			],
			category: 8
		},
		{
			emoji: "🇰🇮",
			name: "Kiribati Flag",
			added_in: "6.0",
			shortName: "flag-ki",
			shortNames: [
				"flag-ki"
			],
			category: 8
		},
		{
			emoji: "🇰🇲",
			name: "Comoros Flag",
			added_in: "6.0",
			shortName: "flag-km",
			shortNames: [
				"flag-km"
			],
			category: 8
		},
		{
			emoji: "🇰🇳",
			name: "St. Kitts & Nevis Flag",
			added_in: "6.0",
			shortName: "flag-kn",
			shortNames: [
				"flag-kn"
			],
			category: 8
		},
		{
			emoji: "🇰🇵",
			name: "North Korea Flag",
			added_in: "6.0",
			shortName: "flag-kp",
			shortNames: [
				"flag-kp"
			],
			category: 8
		},
		{
			emoji: "🇰🇷",
			name: "South Korea Flag",
			added_in: "6.0",
			shortName: "kr",
			shortNames: [
				"kr",
				"flag-kr"
			],
			category: 8
		},
		{
			emoji: "🇰🇼",
			name: "Kuwait Flag",
			added_in: "6.0",
			shortName: "flag-kw",
			shortNames: [
				"flag-kw"
			],
			category: 8
		},
		{
			emoji: "🇰🇿",
			name: "Kazakhstan Flag",
			added_in: "6.0",
			shortName: "flag-kz",
			shortNames: [
				"flag-kz"
			],
			category: 8
		},
		{
			emoji: "🇱🇦",
			name: "Laos Flag",
			added_in: "6.0",
			shortName: "flag-la",
			shortNames: [
				"flag-la"
			],
			category: 8
		},
		{
			emoji: "🇱🇧",
			name: "Lebanon Flag",
			added_in: "6.0",
			shortName: "flag-lb",
			shortNames: [
				"flag-lb"
			],
			category: 8
		},
		{
			emoji: "🇱🇨",
			name: "St. Lucia Flag",
			added_in: "6.0",
			shortName: "flag-lc",
			shortNames: [
				"flag-lc"
			],
			category: 8
		},
		{
			emoji: "🇱🇮",
			name: "Liechtenstein Flag",
			added_in: "6.0",
			shortName: "flag-li",
			shortNames: [
				"flag-li"
			],
			category: 8
		},
		{
			emoji: "🇱🇰",
			name: "Sri Lanka Flag",
			added_in: "6.0",
			shortName: "flag-lk",
			shortNames: [
				"flag-lk"
			],
			category: 8
		},
		{
			emoji: "🇱🇷",
			name: "Liberia Flag",
			added_in: "6.0",
			shortName: "flag-lr",
			shortNames: [
				"flag-lr"
			],
			category: 8
		},
		{
			emoji: "🇱🇸",
			name: "Lesotho Flag",
			added_in: "6.0",
			shortName: "flag-ls",
			shortNames: [
				"flag-ls"
			],
			category: 8
		},
		{
			emoji: "🇱🇹",
			name: "Lithuania Flag",
			added_in: "6.0",
			shortName: "flag-lt",
			shortNames: [
				"flag-lt"
			],
			category: 8
		},
		{
			emoji: "🇱🇺",
			name: "Luxembourg Flag",
			added_in: "6.0",
			shortName: "flag-lu",
			shortNames: [
				"flag-lu"
			],
			category: 8
		},
		{
			emoji: "🇱🇻",
			name: "Latvia Flag",
			added_in: "6.0",
			shortName: "flag-lv",
			shortNames: [
				"flag-lv"
			],
			category: 8
		},
		{
			emoji: "🇱🇾",
			name: "Libya Flag",
			added_in: "6.0",
			shortName: "flag-ly",
			shortNames: [
				"flag-ly"
			],
			category: 8
		},
		{
			emoji: "🇲🇦",
			name: "Morocco Flag",
			added_in: "6.0",
			shortName: "flag-ma",
			shortNames: [
				"flag-ma"
			],
			category: 8
		},
		{
			emoji: "🇲🇨",
			name: "Monaco Flag",
			added_in: "6.0",
			shortName: "flag-mc",
			shortNames: [
				"flag-mc"
			],
			category: 8
		},
		{
			emoji: "🇲🇩",
			name: "Moldova Flag",
			added_in: "6.0",
			shortName: "flag-md",
			shortNames: [
				"flag-md"
			],
			category: 8
		},
		{
			emoji: "🇲🇪",
			name: "Montenegro Flag",
			added_in: "6.0",
			shortName: "flag-me",
			shortNames: [
				"flag-me"
			],
			category: 8
		},
		{
			emoji: "🇲🇬",
			name: "Madagascar Flag",
			added_in: "6.0",
			shortName: "flag-mg",
			shortNames: [
				"flag-mg"
			],
			category: 8
		},
		{
			emoji: "🇲🇭",
			name: "Marshall Islands Flag",
			added_in: "6.0",
			shortName: "flag-mh",
			shortNames: [
				"flag-mh"
			],
			category: 8
		},
		{
			emoji: "🇲🇰",
			name: "Macedonia Flag",
			added_in: "6.0",
			shortName: "flag-mk",
			shortNames: [
				"flag-mk"
			],
			category: 8
		},
		{
			emoji: "🇲🇱",
			name: "Mali Flag",
			added_in: "6.0",
			shortName: "flag-ml",
			shortNames: [
				"flag-ml"
			],
			category: 8
		},
		{
			emoji: "🇲🇲",
			name: "Myanmar (Burma) Flag",
			added_in: "6.0",
			shortName: "flag-mm",
			shortNames: [
				"flag-mm"
			],
			category: 8
		},
		{
			emoji: "🇲🇳",
			name: "Mongolia Flag",
			added_in: "6.0",
			shortName: "flag-mn",
			shortNames: [
				"flag-mn"
			],
			category: 8
		},
		{
			emoji: "🇲🇴",
			name: "Macau SAR China Flag",
			added_in: "6.0",
			shortName: "flag-mo",
			shortNames: [
				"flag-mo"
			],
			category: 8
		},
		{
			emoji: "🇲🇵",
			name: "Northern Mariana Islands Flag",
			added_in: "6.0",
			shortName: "flag-mp",
			shortNames: [
				"flag-mp"
			],
			category: 8
		},
		{
			emoji: "🇲🇷",
			name: "Mauritania Flag",
			added_in: "6.0",
			shortName: "flag-mr",
			shortNames: [
				"flag-mr"
			],
			category: 8
		},
		{
			emoji: "🇲🇸",
			name: "Montserrat Flag",
			added_in: "6.0",
			shortName: "flag-ms",
			shortNames: [
				"flag-ms"
			],
			category: 8
		},
		{
			emoji: "🇲🇹",
			name: "Malta Flag",
			added_in: "6.0",
			shortName: "flag-mt",
			shortNames: [
				"flag-mt"
			],
			category: 8
		},
		{
			emoji: "🇲🇺",
			name: "Mauritius Flag",
			added_in: "6.0",
			shortName: "flag-mu",
			shortNames: [
				"flag-mu"
			],
			category: 8
		},
		{
			emoji: "🇲🇻",
			name: "Maldives Flag",
			added_in: "6.0",
			shortName: "flag-mv",
			shortNames: [
				"flag-mv"
			],
			category: 8
		},
		{
			emoji: "🇲🇼",
			name: "Malawi Flag",
			added_in: "6.0",
			shortName: "flag-mw",
			shortNames: [
				"flag-mw"
			],
			category: 8
		},
		{
			emoji: "🇲🇽",
			name: "Mexico Flag",
			added_in: "6.0",
			shortName: "flag-mx",
			shortNames: [
				"flag-mx"
			],
			category: 8
		},
		{
			emoji: "🇲🇾",
			name: "Malaysia Flag",
			added_in: "6.0",
			shortName: "flag-my",
			shortNames: [
				"flag-my"
			],
			category: 8
		},
		{
			emoji: "🇲🇿",
			name: "Mozambique Flag",
			added_in: "6.0",
			shortName: "flag-mz",
			shortNames: [
				"flag-mz"
			],
			category: 8
		},
		{
			emoji: "🇳🇦",
			name: "Namibia Flag",
			added_in: "6.0",
			shortName: "flag-na",
			shortNames: [
				"flag-na"
			],
			category: 8
		},
		{
			emoji: "🇳🇪",
			name: "Niger Flag",
			added_in: "6.0",
			shortName: "flag-ne",
			shortNames: [
				"flag-ne"
			],
			category: 8
		},
		{
			emoji: "🇳🇫",
			name: "Norfolk Island Flag",
			added_in: "6.0",
			shortName: "flag-nf",
			shortNames: [
				"flag-nf"
			],
			category: 8
		},
		{
			emoji: "🇳🇬",
			name: "Nigeria Flag",
			added_in: "6.0",
			shortName: "flag-ng",
			shortNames: [
				"flag-ng"
			],
			category: 8
		},
		{
			emoji: "🇳🇮",
			name: "Nicaragua Flag",
			added_in: "6.0",
			shortName: "flag-ni",
			shortNames: [
				"flag-ni"
			],
			category: 8
		},
		{
			emoji: "🇳🇱",
			name: "Netherlands Flag",
			added_in: "6.0",
			shortName: "flag-nl",
			shortNames: [
				"flag-nl"
			],
			category: 8
		},
		{
			emoji: "🇳🇴",
			name: "Norway Flag",
			added_in: "6.0",
			shortName: "flag-no",
			shortNames: [
				"flag-no"
			],
			category: 8
		},
		{
			emoji: "🇳🇵",
			name: "Nepal Flag",
			added_in: "6.0",
			shortName: "flag-np",
			shortNames: [
				"flag-np"
			],
			category: 8
		},
		{
			emoji: "🇳🇷",
			name: "Nauru Flag",
			added_in: "6.0",
			shortName: "flag-nr",
			shortNames: [
				"flag-nr"
			],
			category: 8
		},
		{
			emoji: "🇳🇺",
			name: "Niue Flag",
			added_in: "6.0",
			shortName: "flag-nu",
			shortNames: [
				"flag-nu"
			],
			category: 8
		},
		{
			emoji: "🇳🇿",
			name: "New Zealand Flag",
			added_in: "6.0",
			shortName: "flag-nz",
			shortNames: [
				"flag-nz"
			],
			category: 8
		},
		{
			emoji: "🇵🇦",
			name: "Panama Flag",
			added_in: "6.0",
			shortName: "flag-pa",
			shortNames: [
				"flag-pa"
			],
			category: 8
		},
		{
			emoji: "🇵🇪",
			name: "Peru Flag",
			added_in: "6.0",
			shortName: "flag-pe",
			shortNames: [
				"flag-pe"
			],
			category: 8
		},
		{
			emoji: "🇵🇫",
			name: "French Polynesia Flag",
			added_in: "6.0",
			shortName: "flag-pf",
			shortNames: [
				"flag-pf"
			],
			category: 8
		},
		{
			emoji: "🇵🇬",
			name: "Papua New Guinea Flag",
			added_in: "6.0",
			shortName: "flag-pg",
			shortNames: [
				"flag-pg"
			],
			category: 8
		},
		{
			emoji: "🇵🇭",
			name: "Philippines Flag",
			added_in: "6.0",
			shortName: "flag-ph",
			shortNames: [
				"flag-ph"
			],
			category: 8
		},
		{
			emoji: "🇵🇰",
			name: "Pakistan Flag",
			added_in: "6.0",
			shortName: "flag-pk",
			shortNames: [
				"flag-pk"
			],
			category: 8
		},
		{
			emoji: "🇵🇱",
			name: "Poland Flag",
			added_in: "6.0",
			shortName: "flag-pl",
			shortNames: [
				"flag-pl"
			],
			category: 8
		},
		{
			emoji: "🇵🇳",
			name: "Pitcairn Islands Flag",
			added_in: "6.0",
			shortName: "flag-pn",
			shortNames: [
				"flag-pn"
			],
			category: 8
		},
		{
			emoji: "🇵🇷",
			name: "Puerto Rico Flag",
			added_in: "6.0",
			shortName: "flag-pr",
			shortNames: [
				"flag-pr"
			],
			category: 8
		},
		{
			emoji: "🇵🇸",
			name: "Palestinian Territories Flag",
			added_in: "6.0",
			shortName: "flag-ps",
			shortNames: [
				"flag-ps"
			],
			category: 8
		},
		{
			emoji: "🇵🇹",
			name: "Portugal Flag",
			added_in: "6.0",
			shortName: "flag-pt",
			shortNames: [
				"flag-pt"
			],
			category: 8
		},
		{
			emoji: "🇵🇼",
			name: "Palau Flag",
			added_in: "6.0",
			shortName: "flag-pw",
			shortNames: [
				"flag-pw"
			],
			category: 8
		},
		{
			emoji: "🇵🇾",
			name: "Paraguay Flag",
			added_in: "6.0",
			shortName: "flag-py",
			shortNames: [
				"flag-py"
			],
			category: 8
		},
		{
			emoji: "🇶🇦",
			name: "Qatar Flag",
			added_in: "6.0",
			shortName: "flag-qa",
			shortNames: [
				"flag-qa"
			],
			category: 8
		},
		{
			emoji: "🇷🇸",
			name: "Serbia Flag",
			added_in: "6.0",
			shortName: "flag-rs",
			shortNames: [
				"flag-rs"
			],
			category: 8
		},
		{
			emoji: "🇷🇺",
			name: "Russia Flag",
			added_in: "6.0",
			shortName: "ru",
			shortNames: [
				"ru",
				"flag-ru"
			],
			category: 8
		},
		{
			emoji: "🇷🇼",
			name: "Rwanda Flag",
			added_in: "6.0",
			shortName: "flag-rw",
			shortNames: [
				"flag-rw"
			],
			category: 8
		},
		{
			emoji: "🇸🇦",
			name: "Saudi Arabia Flag",
			added_in: "6.0",
			shortName: "flag-sa",
			shortNames: [
				"flag-sa"
			],
			category: 8
		},
		{
			emoji: "🇸🇧",
			name: "Solomon Islands Flag",
			added_in: "6.0",
			shortName: "flag-sb",
			shortNames: [
				"flag-sb"
			],
			category: 8
		},
		{
			emoji: "🇸🇨",
			name: "Seychelles Flag",
			added_in: "6.0",
			shortName: "flag-sc",
			shortNames: [
				"flag-sc"
			],
			category: 8
		},
		{
			emoji: "🇸🇩",
			name: "Sudan Flag",
			added_in: "6.0",
			shortName: "flag-sd",
			shortNames: [
				"flag-sd"
			],
			category: 8
		},
		{
			emoji: "🇸🇪",
			name: "Sweden Flag",
			added_in: "6.0",
			shortName: "flag-se",
			shortNames: [
				"flag-se"
			],
			category: 8
		},
		{
			emoji: "🇸🇬",
			name: "Singapore Flag",
			added_in: "6.0",
			shortName: "flag-sg",
			shortNames: [
				"flag-sg"
			],
			category: 8
		},
		{
			emoji: "🇸🇭",
			name: "St. Helena Flag",
			added_in: "6.0",
			shortName: "flag-sh",
			shortNames: [
				"flag-sh"
			],
			category: 8
		},
		{
			emoji: "🇸🇮",
			name: "Slovenia Flag",
			added_in: "6.0",
			shortName: "flag-si",
			shortNames: [
				"flag-si"
			],
			category: 8
		},
		{
			emoji: "🇸🇯",
			name: "Svalbard & Jan Mayen Flag",
			added_in: "6.0",
			shortName: "flag-sj",
			shortNames: [
				"flag-sj"
			],
			category: 8
		},
		{
			emoji: "🇸🇰",
			name: "Slovakia Flag",
			added_in: "6.0",
			shortName: "flag-sk",
			shortNames: [
				"flag-sk"
			],
			category: 8
		},
		{
			emoji: "🇸🇱",
			name: "Sierra Leone Flag",
			added_in: "6.0",
			shortName: "flag-sl",
			shortNames: [
				"flag-sl"
			],
			category: 8
		},
		{
			emoji: "🇸🇲",
			name: "San Marino Flag",
			added_in: "6.0",
			shortName: "flag-sm",
			shortNames: [
				"flag-sm"
			],
			category: 8
		},
		{
			emoji: "🇸🇳",
			name: "Senegal Flag",
			added_in: "6.0",
			shortName: "flag-sn",
			shortNames: [
				"flag-sn"
			],
			category: 8
		},
		{
			emoji: "🇸🇴",
			name: "Somalia Flag",
			added_in: "6.0",
			shortName: "flag-so",
			shortNames: [
				"flag-so"
			],
			category: 8
		},
		{
			emoji: "🇸🇷",
			name: "Suriname Flag",
			added_in: "6.0",
			shortName: "flag-sr",
			shortNames: [
				"flag-sr"
			],
			category: 8
		},
		{
			emoji: "🇸🇸",
			name: "South Sudan Flag",
			added_in: "6.0",
			shortName: "flag-ss",
			shortNames: [
				"flag-ss"
			],
			category: 8
		},
		{
			emoji: "🇸🇹",
			name: "São Tomé & Príncipe Flag",
			added_in: "6.0",
			shortName: "flag-st",
			shortNames: [
				"flag-st"
			],
			category: 8
		},
		{
			emoji: "🇸🇻",
			name: "El Salvador Flag",
			added_in: "6.0",
			shortName: "flag-sv",
			shortNames: [
				"flag-sv"
			],
			category: 8
		},
		{
			emoji: "🇸🇽",
			name: "Sint Maarten Flag",
			added_in: "6.0",
			shortName: "flag-sx",
			shortNames: [
				"flag-sx"
			],
			category: 8
		},
		{
			emoji: "🇸🇾",
			name: "Syria Flag",
			added_in: "6.0",
			shortName: "flag-sy",
			shortNames: [
				"flag-sy"
			],
			category: 8
		},
		{
			emoji: "🇸🇿",
			name: "Swaziland Flag",
			added_in: "6.0",
			shortName: "flag-sz",
			shortNames: [
				"flag-sz"
			],
			category: 8
		},
		{
			emoji: "🇹🇦",
			name: "Tristan da Cunha Flag",
			added_in: "6.0",
			shortName: "flag-ta",
			shortNames: [
				"flag-ta"
			],
			category: 8
		},
		{
			emoji: "🇹🇨",
			name: "Turks & Caicos Islands Flag",
			added_in: "6.0",
			shortName: "flag-tc",
			shortNames: [
				"flag-tc"
			],
			category: 8
		},
		{
			emoji: "🇹🇩",
			name: "Chad Flag",
			added_in: "6.0",
			shortName: "flag-td",
			shortNames: [
				"flag-td"
			],
			category: 8
		},
		{
			emoji: "🇹🇬",
			name: "Togo Flag",
			added_in: "6.0",
			shortName: "flag-tg",
			shortNames: [
				"flag-tg"
			],
			category: 8
		},
		{
			emoji: "🇹🇭",
			name: "Thailand Flag",
			added_in: "6.0",
			shortName: "flag-th",
			shortNames: [
				"flag-th"
			],
			category: 8
		},
		{
			emoji: "🇹🇯",
			name: "Tajikistan Flag",
			added_in: "6.0",
			shortName: "flag-tj",
			shortNames: [
				"flag-tj"
			],
			category: 8
		},
		{
			emoji: "🇹🇰",
			name: "Tokelau Flag",
			added_in: "6.0",
			shortName: "flag-tk",
			shortNames: [
				"flag-tk"
			],
			category: 8
		},
		{
			emoji: "🇹🇱",
			name: "Timor-Leste Flag",
			added_in: "6.0",
			shortName: "flag-tl",
			shortNames: [
				"flag-tl"
			],
			category: 8
		},
		{
			emoji: "🇹🇲",
			name: "Turkmenistan Flag",
			added_in: "6.0",
			shortName: "flag-tm",
			shortNames: [
				"flag-tm"
			],
			category: 8
		},
		{
			emoji: "🇹🇳",
			name: "Tunisia Flag",
			added_in: "6.0",
			shortName: "flag-tn",
			shortNames: [
				"flag-tn"
			],
			category: 8
		},
		{
			emoji: "🇹🇴",
			name: "Tonga Flag",
			added_in: "6.0",
			shortName: "flag-to",
			shortNames: [
				"flag-to"
			],
			category: 8
		},
		{
			emoji: "🇹🇷",
			name: "Turkey Flag",
			added_in: "6.0",
			shortName: "flag-tr",
			shortNames: [
				"flag-tr"
			],
			category: 8
		},
		{
			emoji: "🇹🇹",
			name: "Trinidad & Tobago Flag",
			added_in: "6.0",
			shortName: "flag-tt",
			shortNames: [
				"flag-tt"
			],
			category: 8
		},
		{
			emoji: "🇹🇻",
			name: "Tuvalu Flag",
			added_in: "6.0",
			shortName: "flag-tv",
			shortNames: [
				"flag-tv"
			],
			category: 8
		},
		{
			emoji: "🇹🇼",
			name: "Taiwan Flag",
			added_in: "6.0",
			shortName: "flag-tw",
			shortNames: [
				"flag-tw"
			],
			category: 8
		},
		{
			emoji: "🇹🇿",
			name: "Tanzania Flag",
			added_in: "6.0",
			shortName: "flag-tz",
			shortNames: [
				"flag-tz"
			],
			category: 8
		},
		{
			emoji: "🇺🇦",
			name: "Ukraine Flag",
			added_in: "6.0",
			shortName: "flag-ua",
			shortNames: [
				"flag-ua"
			],
			category: 8
		},
		{
			emoji: "🇺🇬",
			name: "Uganda Flag",
			added_in: "6.0",
			shortName: "flag-ug",
			shortNames: [
				"flag-ug"
			],
			category: 8
		},
		{
			emoji: "🇺🇲",
			name: "U.S. Outlying Islands Flag",
			added_in: "6.0",
			shortName: "flag-um",
			shortNames: [
				"flag-um"
			],
			category: 8
		},
		{
			emoji: "🇺🇸",
			name: "United States Flag",
			added_in: "6.0",
			shortName: "us",
			shortNames: [
				"us",
				"flag-us"
			],
			category: 8
		},
		{
			emoji: "🇺🇾",
			name: "Uruguay Flag",
			added_in: "6.0",
			shortName: "flag-uy",
			shortNames: [
				"flag-uy"
			],
			category: 8
		},
		{
			emoji: "🇺🇿",
			name: "Uzbekistan Flag",
			added_in: "6.0",
			shortName: "flag-uz",
			shortNames: [
				"flag-uz"
			],
			category: 8
		},
		{
			emoji: "🇻🇦",
			name: "Vatican City Flag",
			added_in: "6.0",
			shortName: "flag-va",
			shortNames: [
				"flag-va"
			],
			category: 8
		},
		{
			emoji: "🇻🇨",
			name: "St. Vincent & Grenadines Flag",
			added_in: "6.0",
			shortName: "flag-vc",
			shortNames: [
				"flag-vc"
			],
			category: 8
		},
		{
			emoji: "🇻🇪",
			name: "Venezuela Flag",
			added_in: "6.0",
			shortName: "flag-ve",
			shortNames: [
				"flag-ve"
			],
			category: 8
		},
		{
			emoji: "🇻🇬",
			name: "British Virgin Islands Flag",
			added_in: "6.0",
			shortName: "flag-vg",
			shortNames: [
				"flag-vg"
			],
			category: 8
		},
		{
			emoji: "🇻🇮",
			name: "U.S. Virgin Islands Flag",
			added_in: "6.0",
			shortName: "flag-vi",
			shortNames: [
				"flag-vi"
			],
			category: 8
		},
		{
			emoji: "🇻🇳",
			name: "Vietnam Flag",
			added_in: "6.0",
			shortName: "flag-vn",
			shortNames: [
				"flag-vn"
			],
			category: 8
		},
		{
			emoji: "🇻🇺",
			name: "Vanuatu Flag",
			added_in: "6.0",
			shortName: "flag-vu",
			shortNames: [
				"flag-vu"
			],
			category: 8
		},
		{
			emoji: "🇼🇸",
			name: "Samoa Flag",
			added_in: "6.0",
			shortName: "flag-ws",
			shortNames: [
				"flag-ws"
			],
			category: 8
		},
		{
			emoji: "🇾🇪",
			name: "Yemen Flag",
			added_in: "6.0",
			shortName: "flag-ye",
			shortNames: [
				"flag-ye"
			],
			category: 8
		},
		{
			emoji: "🇿🇦",
			name: "South Africa Flag",
			added_in: "6.0",
			shortName: "flag-za",
			shortNames: [
				"flag-za"
			],
			category: 8
		},
		{
			emoji: "🇿🇲",
			name: "Zambia Flag",
			added_in: "6.0",
			shortName: "flag-zm",
			shortNames: [
				"flag-zm"
			],
			category: 8
		},
		{
			emoji: "🇿🇼",
			name: "Zimbabwe Flag",
			added_in: "6.0",
			shortName: "flag-zw",
			shortNames: [
				"flag-zw"
			],
			category: 8
		},
		{
			emoji: "🎌",
			name: "CROSSED FLAGS",
			added_in: "6.0",
			shortName: "crossed_flags",
			shortNames: [
				"crossed_flags"
			],
			category: 8
		},
		{
			emoji: "🏁",
			name: "CHEQUERED FLAG",
			added_in: "6.0",
			shortName: "checkered_flag",
			shortNames: [
				"checkered_flag"
			],
			category: 8
		},
		{
			emoji: "🏳️‍🌈",
			name: null,
			added_in: "7.0",
			shortName: "rainbow-flag",
			shortNames: [
				"rainbow-flag"
			],
			category: 8
		},
		{
			emoji: "🚩",
			name: "TRIANGULAR FLAG ON POST",
			added_in: "6.0",
			shortName: "triangular_flag_on_post",
			shortNames: [
				"triangular_flag_on_post"
			],
			category: 8
		}
	]
];
var emojis$1 = {
	categories: categories,
	emojis: emojis
};

var categories$1 = emojis$1.categories;
var STORAGE_KEY_FREQUENTLY = 'emoji.frequently'; // eslint-disable-next-line react/no-multi-comp

var EmojiPicker =
/** @class */
function (_super) {
  __extends(EmojiPicker, _super);

  function EmojiPicker(props) {
    var _this = _super.call(this, props) || this;

    _this.updateDistances = function () {
      if (_this.emojiGridRef && _this.emojiGridRef.current) {
        var grid_1 = _this.emojiGridRef.current;
        var gridRect_1 = grid_1.getBoundingClientRect();
        _this.distances = [];

        _this.sectionRefs.forEach(function (sectionRef) {
          var section = sectionRef.current;

          if (section) {
            var sectionRect = section.getBoundingClientRect();
            var sectionScrollOffset = sectionRect.top - gridRect_1.top - 1 + grid_1.scrollTop;

            _this.distances.push(sectionScrollOffset);
          }
        });
      }
    };

    _this.onScroll = function () {
      if (_this.emojiGridRef.current) {
        var scrollTop = _this.emojiGridRef.current.scrollTop;
        var activeCategory = _this.state.activeCategory;
        var prevDistance = 0;

        for (var index = 0; index < _this.distances.length; index += 1) {
          var distance = _this.distances[index];
          var nextDistance = _this.distances[index + 1];

          if (scrollTop >= prevDistance && (nextDistance && scrollTop < nextDistance || !nextDistance)) {
            if (activeCategory !== index) {
              _this.updateDistances(); // update in case container shifted


              _this.setState({
                activeCategory: index
              });
            }

            break;
          }

          prevDistance = distance;
        }
      }
    };

    _this.gotoCategory = function (categoryKey) {
      if (_this.emojiGridRef.current) {
        _this.emojiGridRef.current.scrollTop = _this.distances[categoryKey];
      }
    };

    _this.onSelect = function (emoji) {
      var onSelect = _this.props.onSelect;
      var frequentlyUsed = _this.state.frequentlyUsed;

      if (emoji) {
        frequentlyUsed[emoji] = frequentlyUsed[emoji] + 1 || 1;
      }

      localStorage.setItem(STORAGE_KEY_FREQUENTLY, JSON.stringify(frequentlyUsed));

      _this.setState({
        frequentlyUsed: frequentlyUsed
      });

      onSelect(emoji);
    };

    _this.emojiGridRef = /*#__PURE__*/React.createRef();
    _this.sectionRefs = categories$1.map(function () {
      return /*#__PURE__*/React.createRef();
    });
    _this.distances = [];
    var frequentlyUsed = {};

    try {
      var data = localStorage.getItem(STORAGE_KEY_FREQUENTLY) || '';
      frequentlyUsed = JSON.parse(data);
    } catch (error) {// do nothing
    }

    _this.state = {
      activeCategory: 0,
      frequentlyUsed: frequentlyUsed
    };
    return _this;
  }

  EmojiPicker.prototype.componentDidMount = function () {
    this.updateDistances();
  };

  EmojiPicker.prototype.componentDidUpdate = function () {
    this.updateDistances();
  };

  EmojiPicker.prototype.getFrequentlyUsed = function () {
    var frequentlyUsed = this.state.frequentlyUsed;
    var emojis = Object.keys(frequentlyUsed);
    var sortable = [];

    for (var index = 0; index < emojis.length; index += 1) {
      var emoji = emojis[index];
      sortable.push({
        emoji: emoji,
        count: frequentlyUsed[emoji] || 1
      });
    }

    var sorted = sortBy(sortable, ['count']).reverse().splice(0, 22);
    var allEmojis = [].concat.apply([], emojis$1.emojis);
    return sorted.map(function (o) {
      return find(allEmojis, ['emoji', o.emoji]);
    });
  };

  EmojiPicker.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        className = _b.className,
        onSelect = _b.onSelect,
        otherProps = __rest(_b, ["className", "onSelect"]);

    var activeCategory = this.state.activeCategory;
    var rootClass = classnames((_a = {}, _a[styles$13.root] = true, _a), className);
    var frequentlyUsed = this.getFrequentlyUsed();
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$13.categories
    }, categories$1.map(function (category) {
      return /*#__PURE__*/React.createElement(EmojiCategory, {
        key: category.key,
        category: category,
        active: category.key === activeCategory,
        gotoCategory: _this.gotoCategory
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$13.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$13.grid,
      ref: this.emojiGridRef,
      onScroll: this.onScroll
    }, categories$1.map(function (category) {
      return /*#__PURE__*/React.createElement(EmojiSection, {
        sectionRef: _this.sectionRefs[category.key],
        key: category.key,
        category: category,
        emojis: category.key === 0 ? frequentlyUsed : emojis$1.emojis[category.key],
        onSelect: _this.onSelect
      });
    }))));
  };

  return EmojiPicker;
}(Component);

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  EmojiPicker: EmojiPicker,
  EMOJIS: emojis$1
});

var css_248z$1f = "@-webkit-keyframes empty--empty__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes empty--empty__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes empty--empty__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes empty--empty__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.empty--empty__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.empty--empty__image {\n  width: 183px; }\n  .empty--empty__emptyBig .empty--empty__image {\n    width: 310px; }\n\n.empty--empty__headline {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 5px; }\n\n.empty--empty__description {\n  margin-bottom: 25px;\n  font-size: 14px; }\n\n.empty--empty__textWrapper {\n  text-align: center;\n  width: 308px;\n  color: #5a5a5a; }\n  .empty--empty__emptyBig .empty--empty__textWrapper {\n    width: 500px; }\n";
var styles$16 = {"empty":"empty--empty__empty","image":"empty--empty__image","emptyBig":"empty--empty__emptyBig","headline":"empty--empty__headline","description":"empty--empty__description","textWrapper":"empty--empty__textWrapper","wiggle":"empty--empty__wiggle","spin":"empty--empty__spin"};
styleInject(css_248z$1f);

var Empty =
/** @class */
function (_super) {
  __extends(Empty, _super);

  function Empty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Empty.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        image = _b.image,
        headline = _b.headline,
        buttonClick = _b.buttonClick,
        buttonText = _b.buttonText,
        outlined = _b.outlined,
        description = _b.description,
        big = _b.big,
        otherProps = __rest(_b, ["className", "image", "headline", "buttonClick", "buttonText", "outlined", "description", "big"]);

    var rootClass = classnames((_a = {}, _a[styles$16.empty] = true, _a[styles$16.emptyBig] = big, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, /*#__PURE__*/React.createElement(Image, {
      src: image,
      alt: "",
      className: styles$16.image
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$16.textWrapper
    }, /*#__PURE__*/React.createElement("h4", {
      className: styles$16.headline
    }, headline), /*#__PURE__*/React.createElement("div", {
      className: styles$16.description
    }, description)), buttonText && /*#__PURE__*/React.createElement(Button$2, {
      outlined: outlined,
      onClick: buttonClick
    }, buttonText)));
  };

  return Empty;
}(PureComponent);

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f$1 = 1; f$1 < 20; f$1++) {
  CODES['f' + f$1] = 111 + f$1;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

var _default$4 = isHotkey;

var isElement$2 = function isElement(node) {
  return isElement$3(node);
};
var isBlockLevel = function isBlockLevel(element, windowObj) {
  if (windowObj === void 0) {
    windowObj = window;
  }

  return windowObj.getComputedStyle(element).display === 'block';
};

var css_248z$1g = "@-webkit-keyframes toolbarButton--toolbarButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes toolbarButton--toolbarButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes toolbarButton--toolbarButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes toolbarButton--toolbarButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.toolbarButton--toolbarButton__root {\n  background: none;\n  border: 0;\n  width: 26px;\n  padding: 0;\n  color: #617598;\n  align-items: center;\n  justify-content: center;\n  position: relative; }\n  .toolbarButton--toolbarButton__root::after {\n    position: absolute;\n    content: '';\n    height: 4px;\n    border-radius: 2px;\n    background: #d7dfea;\n    bottom: 0;\n    left: 4px;\n    right: 4px;\n    opacity: 0; }\n  .toolbarButton--toolbarButton__root:hover:not(.toolbarButton--toolbarButton__rootDisabled)::after, .toolbarButton--toolbarButton__rootActive::after {\n    opacity: 1; }\n  .toolbarButton--toolbarButton__rootActive {\n    color: #3f329d; }\n    .toolbarButton--toolbarButton__rootActive::after {\n      background: rgba(86, 68, 216, 0.5); }\n  .toolbarButton--toolbarButton__rootDisabled {\n    opacity: 0.4; }\n  .toolbarButton--toolbarButton__rootWithBadge::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    display: block;\n    background: #d8484d;\n    border-radius: 4px;\n    right: 2px;\n    bottom: 5px;\n    z-index: 1;\n    position: absolute; }\n  .toolbarButton--toolbarButton__rootNarrow {\n    width: 21px; }\n";
var styles$17 = {"root":"toolbarButton--toolbarButton__root","rootDisabled":"toolbarButton--toolbarButton__rootDisabled","rootActive":"toolbarButton--toolbarButton__rootActive","rootWithBadge":"toolbarButton--toolbarButton__rootWithBadge","rootNarrow":"toolbarButton--toolbarButton__rootNarrow","wiggle":"toolbarButton--toolbarButton__wiggle","spin":"toolbarButton--toolbarButton__spin"};
styleInject(css_248z$1g);

var ToolbarButton =
/** @class */
function (_super) {
  __extends(ToolbarButton, _super);

  function ToolbarButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ToolbarButton.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        isActive = _b.isActive,
        icon = _b.icon,
        disabled = _b.disabled,
        showBadge = _b.showBadge,
        narrow = _b.narrow,
        otherProps = __rest(_b, ["className", "isActive", "icon", "disabled", "showBadge", "narrow"]);

    var rootClass = classnames((_a = {}, _a[styles$17.root] = styles$17.root, _a[styles$17.rootActive] = isActive, _a[styles$17.rootDisabled] = disabled, _a[styles$17.rootWithBadge] = showBadge, _a[styles$17.rootNarrow] = narrow, _a), className);
    return /*#__PURE__*/React.createElement("button", __assign({
      tabIndex: -1,
      type: "button"
    }, otherProps, {
      className: rootClass,
      disabled: disabled
    }), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: icon
    }));
  };

  return ToolbarButton;
}(React.PureComponent);

var css_248z$1h = "@-webkit-keyframes attachmentButton--attachmentButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes attachmentButton--attachmentButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes attachmentButton--attachmentButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes attachmentButton--attachmentButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.attachmentButton--attachmentButton__dropzone {\n  padding: 24px 20px;\n  background-color: #f1f2f4;\n  font-size: 14px;\n  border-radius: 3px;\n  color: #5a5a5a;\n  margin: 6px;\n  line-height: 32px;\n  cursor: pointer; }\n\n.attachmentButton--attachmentButton__fileInput {\n  position: absolute;\n  opacity: 0;\n  left: -9999px; }\n\n.attachmentButton--attachmentButton__dropdown {\n  width: 250px; }\n\n.attachmentButton--attachmentButton__dropzoneIcon {\n  font-size: 30px;\n  color: #afb5c0;\n  margin: 0;\n  display: block;\n  text-align: center; }\n";
var styles$18 = {"dropzone":"attachmentButton--attachmentButton__dropzone","fileInput":"attachmentButton--attachmentButton__fileInput","dropdown":"attachmentButton--attachmentButton__dropdown","dropzoneIcon":"attachmentButton--attachmentButton__dropzoneIcon","wiggle":"attachmentButton--attachmentButton__wiggle","spin":"attachmentButton--attachmentButton__spin"};
styleInject(css_248z$1h);

var Dropzone =
/** @class */
function (_super) {
  __extends(Dropzone, _super);

  function Dropzone(props) {
    var _this = _super.call(this, props) || this;

    _this.handleDragEnter = function (e) {
      e.preventDefault();
      var allowAttachments = _this.props.allowAttachments;
      if (!allowAttachments) return;

      _this.setState({
        fileHover: true
      });
    };

    _this.handleDragLeave = function (e) {
      e.preventDefault();

      _this.setState({
        fileHover: false
      });
    };

    _this.handleAttachmentDrop = function (e) {
      e.preventDefault();
      var onAddAttachment = _this.props.onAddAttachment;

      if (e.dataTransfer) {
        onAddAttachment(e.dataTransfer.files);
      }

      _this.setState({
        fileHover: false
      });
    };

    _this.state = {
      fileHover: false
    };
    return _this;
  }

  Dropzone.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        isAttachmentsUploading = _a.isAttachmentsUploading,
        allowAttachments = _a.allowAttachments,
        allowInline = _a.allowInline,
        onAddAttachment = _a.onAddAttachment,
        otherProps = __rest(_a, ["className", "children", "isAttachmentsUploading", "allowAttachments", "allowInline", "onAddAttachment"]);

    var fileHover = this.state.fileHover;
    var rootClass = classnames(className);
    var showDropText = fileHover || isAttachmentsUploading;
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      onDragEnter: this.handleDragEnter,
      onDragOver: this.handleDragEnter,
      onDragLeave: this.handleDragLeave,
      onDrop: this.handleAttachmentDrop
    }), children, showDropText && /*#__PURE__*/React.createElement(React.Fragment, null, isAttachmentsUploading ? 'Uploading...' : 'Drop to add an attachment'), !showDropText && 'Drop the file or click to upload');
  };

  Dropzone.displayName = 'AttachmentButtonDropzone';
  return Dropzone;
}(React.PureComponent);

var AttachmentButton =
/** @class */
function (_super) {
  __extends(AttachmentButton, _super);

  function AttachmentButton(props) {
    var _this = _super.call(this, props) || this;

    _this.openFileBrowser = function (e) {
      e.preventDefault();
      var current = _this.fileInputRef.current;
      if (current) current.click();
    };

    _this.handleFileChanged = function (e) {
      var _a = _this.props,
          onAttachFiles = _a.onAttachFiles,
          editorWindow = _a.editorWindow;
      var fileInput = e.target;

      if (fileInput !== null && fileInput instanceof editorWindow.HTMLInputElement // any, because for unknown reason ts complains
      ) {
          // window.HTMLInputElement !== editorWindow.HTMLInputElement in a Portal Popup
          onAttachFiles(fileInput.files);
          fileInput.value = '';
        }
    };

    _this.preventDefault = function (e) {
      e.preventDefault();
    };

    _this.fileInputRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  AttachmentButton.prototype.renderDropdown = function () {
    var _a = this.props,
        isAttachmentsUploading = _a.isAttachmentsUploading,
        attachments = _a.attachments,
        onAttachFiles = _a.onAttachFiles,
        children = _a.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$18.dropdown
    }, /*#__PURE__*/React.createElement("input", {
      ref: this.fileInputRef,
      type: "file",
      className: styles$18.fileInput,
      onChange: this.handleFileChanged,
      multiple: true
    }), /*#__PURE__*/React.createElement(Dropzone, {
      className: styles$18.dropzone,
      onAddAttachment: onAttachFiles,
      attachments: attachments,
      isAttachmentsUploading: isAttachmentsUploading,
      allowInline: false,
      onClick: this.openFileBrowser,
      allowAttachments: true
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "paperclip",
      className: styles$18.dropzoneIcon
    })), children);
  };

  AttachmentButton.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        attachments = _a.attachments,
        onAttachFiles = _a.onAttachFiles,
        onDetachFile = _a.onDetachFile,
        isAttachmentsUploading = _a.isAttachmentsUploading,
        dropdownRef = _a.dropdownRef,
        editorWindow = _a.editorWindow,
        otherProps = __rest(_a, ["className", "attachments", "onAttachFiles", "onDetachFile", "isAttachmentsUploading", "dropdownRef", "editorWindow"]);

    return /*#__PURE__*/React.createElement(DropdownButton, __assign({}, otherProps, {
      className: className,
      noStyle: true,
      ref: dropdownRef,
      dropdown: this.renderDropdown()
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      onMouseDown: this.preventDefault,
      icon: "paperclip",
      showBadge: attachments.length > 0
    }));
  };

  return AttachmentButton;
}(React.PureComponent);

var css_248z$1i = "@-webkit-keyframes dropzone--dropzone__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes dropzone--dropzone__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes dropzone--dropzone__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dropzone--dropzone__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.dropzone--dropzone__root {\n  position: relative;\n  z-index: 2; }\n\n.dropzone--dropzone__inlineDropzone,\n.dropzone--dropzone__attachmentDropzone {\n  background: #f1f2f4;\n  border-radius: 3px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: -32px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  flex-direction: column;\n  font-size: 14px;\n  line-height: 32px;\n  color: #5a5a5a; }\n\n.dropzone--dropzone__rootDual .dropzone--dropzone__inlineDropzone {\n  width: calc(50% - 8px);\n  right: auto; }\n\n.dropzone--dropzone__rootDual .dropzone--dropzone__attachmentDropzone {\n  width: calc(50% - 8px);\n  left: auto; }\n\n.dropzone--dropzone__icon {\n  font-size: 30px;\n  color: #afb5c0;\n  margin: 0; }\n";
var styles$19 = {"root":"dropzone--dropzone__root","inlineDropzone":"dropzone--dropzone__inlineDropzone","attachmentDropzone":"dropzone--dropzone__attachmentDropzone","rootDual":"dropzone--dropzone__rootDual","icon":"dropzone--dropzone__icon","wiggle":"dropzone--dropzone__wiggle","spin":"dropzone--dropzone__spin"};
styleInject(css_248z$1i);

var Dropzone$1 =
/** @class */
function (_super) {
  __extends(Dropzone, _super);

  function Dropzone(props) {
    var _this = _super.call(this, props) || this;

    _this.handleDragEnter = function (e) {
      e.preventDefault();
      var _a = _this.props,
          allowInlineAttachments = _a.allowInlineAttachments,
          allowAttachments = _a.allowAttachments;
      if (!allowInlineAttachments && !allowAttachments) return;

      _this.setState({
        fileHover: true
      });
    };

    _this.handleDragLeave = function (e) {
      e.preventDefault();

      _this.setState({
        fileHover: false
      });
    };

    _this.handleEnterDropzone = function (e) {
      e.preventDefault();

      _this.setState({
        overDropzone: true
      });
    };

    _this.handleLeaveDropzone = function (e) {
      e.preventDefault();

      _this.setState({
        overDropzone: false
      });
    };

    _this.handleInlineDrop = function (e) {
      e.preventDefault();
      var onAddInline = _this.props.onAddInline;

      if (e.dataTransfer && typeof onAddInline === 'function') {
        onAddInline(e.dataTransfer.files);
      }

      _this.setState({
        overDropzone: false,
        fileHover: false
      });
    };

    _this.handleAttachmentDrop = function (e) {
      e.preventDefault();
      var onAddAttachment = _this.props.onAddAttachment;

      if (e.dataTransfer && typeof onAddAttachment === 'function') {
        onAddAttachment(e.dataTransfer.files);
      }

      _this.setState({
        overDropzone: false,
        fileHover: false
      });
    };

    _this.state = {
      fileHover: false,
      overDropzone: false
    };
    return _this;
  }

  Dropzone.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        allowInlineAttachments = _b.allowInlineAttachments,
        allowAttachments = _b.allowAttachments,
        onAddInline = _b.onAddInline,
        onMouseDown = _b.onMouseDown,
        attachments = _b.attachments,
        onAddAttachment = _b.onAddAttachment,
        otherProps = __rest(_b, ["className", "children", "allowInlineAttachments", "allowAttachments", "onAddInline", "onMouseDown", "attachments", "onAddAttachment"]);

    var _c = this.state,
        fileHover = _c.fileHover,
        overDropzone = _c.overDropzone;
    var rootClass = classnames((_a = {}, _a[styles$19.root] = true, _a[styles$19.rootDual] = allowInlineAttachments && allowAttachments, _a), className);
    var supportsDrop = allowInlineAttachments || allowAttachments;
    var handleEvents = {};

    if (onMouseDown) {
      handleEvents.onClick = onMouseDown;
    }

    if (supportsDrop) {
      handleEvents.onDragEnter = this.handleDragEnter;
      handleEvents.onDragOver = this.handleDragEnter;
      handleEvents.onDragLeave = this.handleDragLeave;
    }

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      tabIndex: -1,
      className: rootClass
    }, handleEvents), children, (fileHover || overDropzone) && /*#__PURE__*/React.createElement(React.Fragment, null, allowInlineAttachments && /*#__PURE__*/React.createElement("div", {
      onDragEnter: this.handleEnterDropzone,
      onDragLeave: this.handleLeaveDropzone,
      onDrop: this.handleInlineDrop,
      className: styles$19.inlineDropzone
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "upload",
      size: 24,
      className: styles$19.icon
    }), "Drop to add inline"), allowAttachments && /*#__PURE__*/React.createElement("div", {
      onDragEnter: this.handleEnterDropzone,
      onDragLeave: this.handleLeaveDropzone,
      onDrop: this.handleAttachmentDrop,
      className: styles$19.attachmentDropzone
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "paperclip",
      size: 24,
      className: styles$19.icon
    }), "Drop to add an attachment")));
  };

  Dropzone.displayName = 'FieldEditorDropzone';
  return Dropzone;
}(React.PureComponent);

/**
 * For a string `original` wrap all substrings that match `highlight` (case
 * insensitive) in <span>s
 */

var highlightWithSpan = function highlightWithSpan(original, highlight) {
  return original.split(new RegExp("(" + escapeRegExp(highlight) + ")", 'gi')).map(function (substr, i) {
    return substr.toLowerCase() === highlight.toLowerCase() ? /*#__PURE__*/React.createElement("span", {
      key: i
    }, substr) : substr;
  });
};

var css_248z$1j = "@-webkit-keyframes emoji--emoji__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes emoji--emoji__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes emoji--emoji__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes emoji--emoji__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.emoji--emoji__root {\n  display: inline-block; }\n\n.emoji--emoji__decorator {\n  position: relative;\n  top: 1px; }\n\n.emoji--emoji__suggestion {\n  padding: 4px 8px;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  border: 0;\n  width: 100%;\n  background: none;\n  text-align: left; }\n  .emoji--emoji__suggestion + .emoji--emoji__suggestion {\n    border-top: 1px solid #eee; }\n  .emoji--emoji__suggestion:hover, .emoji--emoji__suggestion:focus {\n    background-color: #f5f5fa; }\n  .emoji--emoji__suggestionActive {\n    background-color: #f5f5fa;\n    box-shadow: inset 0 0 0 1px rgba(86, 68, 216, 0.6);\n    z-index: 2; }\n\n.emoji--emoji__suggestionName {\n  margin-left: 4px; }\n  .emoji--emoji__suggestionName::before, .emoji--emoji__suggestionName::after {\n    content: ':'; }\n";
var styles$1a = {"root":"emoji--emoji__root","decorator":"emoji--emoji__decorator","suggestion":"emoji--emoji__suggestion","suggestionActive":"emoji--emoji__suggestionActive","suggestionName":"emoji--emoji__suggestionName","wiggle":"emoji--emoji__wiggle","spin":"emoji--emoji__spin"};
styleInject(css_248z$1j);

var EmojiPicker$1 = /*#__PURE__*/lazy(function () {
  return Promise.resolve().then(function () { return index; }).then(function (module) {
    return {
      default: module.EmojiPicker
    };
  });
});
var EMOJIS = {};
emojis$1.emojis.forEach(function (emojiCategory) {
  emojiCategory.forEach(function (emoji) {
    if (emoji.shortNames) {
      emoji.shortNames.forEach(function (shortName) {
        EMOJIS[shortName.replace(/:/g, '')] = emoji.emoji;
      });
    }
  });
});

var EmojiSuggestion = function EmojiSuggestion(props) {
  var _a;

  var active = props.active,
      item = props.item,
      match = props.match,
      onSelect = props.onSelect;
  var nameWithHighlight = match ? highlightWithSpan(item, match) : item;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSelect(item);
    },
    type: "button",
    className: classnames(styles$1a.suggestion, (_a = {}, _a[styles$1a.suggestionActive] = active, _a))
  }, EMOJIS[item], /*#__PURE__*/React.createElement("span", {
    className: styles$1a.suggestionName
  }, nameWithHighlight));
};

var Emoji =
/** @class */
function (_super) {
  __extends(Emoji, _super);

  function Emoji() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getContent = function (name) {
      return Promise.resolve(EMOJIS[name]);
    };

    _this.getSuggestions = function (q) {
      var shortCodes = Object.keys(EMOJIS);
      return shortCodes.filter(function (o) {
        return o.indexOf(q) !== -1;
      });
    }; // eslint-disable-next-line no-undef


    _this.preventDefault = function (e) {
      e.preventDefault();
    };

    _this.renderDropdown = function () {
      var insertContent = _this.props.insertContent;
      return /*#__PURE__*/React.createElement(Suspense$1, {
        fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
      }, /*#__PURE__*/React.createElement(DropdownButtonContext.Consumer, null, function (_a) {
        var toggleDropdown = _a.toggleDropdown;
        return /*#__PURE__*/React.createElement(EmojiPicker$1, {
          onSelect: function onSelect(emoji) {
            insertContent(emoji, {
              decoratorClass: styles$1a.decorator,
              decoratorDisallowEdit: false
            });
            toggleDropdown();
          }
        });
      }));
    };

    return _this;
  }

  Emoji.prototype.componentDidMount = function () {
    var editor = this.props.editor;
    editor.triggers.add({
      trigger: ':',
      minChars: 2,
      allowSpaces: false,
      decoratorClass: styles$1a.decorator,
      decoratorDisallowEdit: false,
      getSuggestions: this.getSuggestions,
      getContent: this.getContent,
      suggestionComponent: EmojiSuggestion
    }); // A lot of changes are required in order to remove `any`
  };

  Emoji.prototype.render = function () {
    var _a;

    var className = this.props.className;
    var rootClass = classnames((_a = {}, _a[styles$1a.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, /*#__PURE__*/React.createElement(DropdownButton, {
      icon: "smile",
      dropdown: this.renderDropdown(),
      noStyle: true
    }, /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "smile",
      onMouseDown: this.preventDefault
    })));
  };

  return Emoji;
}(React.PureComponent);

var css_248z$1k = "@-webkit-keyframes fieldEditor--fieldEditor__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldEditor--fieldEditor__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldEditor--fieldEditor__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldEditor--fieldEditor__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldEditor--fieldEditor__root {\n  height: 100%;\n  position: relative; }\n\n.fieldEditor--fieldEditor__toolbar {\n  display: flex;\n  margin-top: 8px; }\n\n.fieldEditor--fieldEditor__editorWrap {\n  position: relative;\n  height: calc(100% - 32px);\n  box-sizing: border-box; }\n  .fieldEditor--fieldEditor__rootFileHover .fieldEditor--fieldEditor__editorWrap::after {\n    content: '';\n    display: block;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    background: rgba(86, 68, 216, 0.2); }\n\n.fieldEditor--fieldEditor__placeholder {\n  font-size: 14px;\n  line-height: 16px;\n  color: #bbb;\n  position: absolute;\n  top: 0;\n  pointer-events: none; }\n\n@-webkit-keyframes fieldEditor--fieldEditor__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n@keyframes fieldEditor--fieldEditor__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n.fieldEditor--fieldEditor__editor {\n  overflow: hidden;\n  overflow-y: auto;\n  overflow-x: auto;\n  overflow-y: auto;\n  outline: none;\n  position: relative;\n  font-size: 14px;\n  line-height: 16px;\n  height: 100%;\n  color: #393939;\n  box-sizing: border-box; }\n  .fieldEditor--fieldEditor__editor::-webkit-scrollbar {\n    width: 7px;\n    height: 7px; }\n  .fieldEditor--fieldEditor__editor::-webkit-scrollbar-track {\n    background-color: #fff; }\n  .fieldEditor--fieldEditor__editor::-webkit-scrollbar-thumb {\n    background-color: #dcdcdc;\n    border-radius: 5px; }\n  .fieldEditor--fieldEditor__editor table,\n  .fieldEditor--fieldEditor__editor th,\n  .fieldEditor--fieldEditor__editor td {\n    border: 1px solid #eee;\n    text-align: left;\n    padding: 8px; }\n  .fieldEditor--fieldEditor__editor img {\n    transition: opacity 0.2s ease-out; }\n  .fieldEditor--fieldEditor__editor pre {\n    background: #f1f2f4;\n    border: 1px solid #e3e4e6;\n    padding: 8px;\n    border-radius: 3px; }\n  .fieldEditor--fieldEditor__editor li + li {\n    margin-top: 8px; }\n  .fieldEditor--fieldEditor__editor h1,\n  .fieldEditor--fieldEditor__editor h2,\n  .fieldEditor--fieldEditor__editor h3,\n  .fieldEditor--fieldEditor__editor h4,\n  .fieldEditor--fieldEditor__editor h5 {\n    font-weight: 500;\n    color: inherit;\n    margin: 0; }\n  .fieldEditor--fieldEditor__editor h1 {\n    font-size: 36px;\n    line-height: 40px;\n    margin-bottom: 16px; }\n  .fieldEditor--fieldEditor__editor * + h1 {\n    margin-top: 16px; }\n  .fieldEditor--fieldEditor__editor h2 {\n    font-size: 30px;\n    line-height: 32px;\n    margin-bottom: 8px; }\n  .fieldEditor--fieldEditor__editor * + h2 {\n    margin-top: 16px; }\n  .fieldEditor--fieldEditor__editor h3 {\n    font-size: 24px;\n    line-height: 24px; }\n  .fieldEditor--fieldEditor__editor h4 {\n    font-size: 18px;\n    line-height: 24px; }\n  .fieldEditor--fieldEditor__editor h5 {\n    font-size: 14px;\n    line-height: 24px; }\n  .fieldEditor--fieldEditor__editor blockquote:not([dir=rtl]) {\n    margin-left: 0;\n    border-left: 5px solid #e3e4e6;\n    padding-left: 16px; }\n  .fieldEditor--fieldEditor__editor blockquote[dir=rtl] {\n    margin-right: 0;\n    border-right: 5px solid #e3e4e6;\n    padding-right: 16px; }\n  .fieldEditor--fieldEditor__editor .async-loading {\n    -webkit-animation: fieldEditor--fieldEditor__pulse 3.5s infinite ease-in-out;\n            animation: fieldEditor--fieldEditor__pulse 3.5s infinite ease-in-out; }\n  .fieldEditor--fieldEditor__editor .async-failed {\n    outline: 3px solid red; }\n\n.fieldEditor--fieldEditor__toolbarGap {\n  margin-left: 16px; }\n\n.fieldEditor--fieldEditor__toolbarGapSmall {\n  margin-left: 12px; }\n\n.fieldEditor--fieldEditor__fileInput {\n  position: absolute;\n  opacity: 0;\n  left: -9999px; }\n";
var styles$1b = {"root":"fieldEditor--fieldEditor__root","toolbar":"fieldEditor--fieldEditor__toolbar","editorWrap":"fieldEditor--fieldEditor__editorWrap","rootFileHover":"fieldEditor--fieldEditor__rootFileHover","placeholder":"fieldEditor--fieldEditor__placeholder","editor":"fieldEditor--fieldEditor__editor","pulse":"fieldEditor--fieldEditor__pulse","toolbarGap":"fieldEditor--fieldEditor__toolbarGap","toolbarGapSmall":"fieldEditor--fieldEditor__toolbarGapSmall","fileInput":"fieldEditor--fieldEditor__fileInput","wiggle":"fieldEditor--fieldEditor__wiggle","spin":"fieldEditor--fieldEditor__spin"};
styleInject(css_248z$1k);

var css_248z$1l = "@-webkit-keyframes linkButton--linkButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes linkButton--linkButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes linkButton--linkButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes linkButton--linkButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.linkButton--linkButton__linkOpener {\n  position: absolute;\n  z-index: 2;\n  background: #fff;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate(-1px, 1px);\n  border-radius: 4px;\n  color: #5644d8;\n  font-size: 16px;\n  padding-left: 1px;\n  text-decoration: none; }\n";
var styles$1c = {"linkOpener":"linkButton--linkButton__linkOpener","wiggle":"linkButton--linkButton__wiggle","spin":"linkButton--linkButton__spin"};
styleInject(css_248z$1l);

var css_248z$1m = ".linkButton--linkMenu__root {\n  width: 200px;\n  padding: 8px; }\n\n.linkButton--linkMenu__field {\n  margin-bottom: 8px; }\n";
var styles$1d = {"root":"linkButton--linkMenu__root","field":"linkButton--linkMenu__field"};
styleInject(css_248z$1m);

var LinkMenu =
/** @class */
function (_super) {
  __extends(LinkMenu, _super);

  function LinkMenu(props) {
    var _this = _super.call(this, props) || this;

    _this.handleTextChange = function (e) {
      if (e.target instanceof HTMLInputElement) {
        _this.setState({
          textValue: e.target.value
        });
      }
    };

    _this.handleUrlChange = function (e) {
      if (e.target instanceof HTMLInputElement) {
        _this.setState({
          urlValue: e.target.value
        });
      }
    };

    _this.handleAddLink = function (e) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      var _a = _this.props,
          onAddLink = _a.onAddLink,
          toggleDropdown = _a.toggleDropdown;
      var _b = _this.state,
          textValue = _b.textValue,
          urlValue = _b.urlValue;
      onAddLink(textValue, urlValue);
      toggleDropdown();
    };

    _this.handleUnlink = function (e) {
      e.preventDefault();
      var _a = _this.props,
          onUnlink = _a.onUnlink,
          toggleDropdown = _a.toggleDropdown;
      onUnlink();
      toggleDropdown();
    };

    _this.handleKeyDown = function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();

        _this.handleAddLink();
      }
    };

    var initialText = props.initialText,
        initialUrl = props.initialUrl;
    _this.state = {
      textValue: initialText,
      urlValue: initialUrl
    };
    return _this;
  }

  LinkMenu.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        initialText = _a.initialText,
        initialUrl = _a.initialUrl;

    if (initialText !== prevProps.initialText || initialUrl !== prevProps.initialUrl) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        textValue: initialText,
        urlValue: initialUrl
      });
    }
  };

  LinkMenu.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        initialText = _b.initialText,
        initialUrl = _b.initialUrl,
        onAddLink = _b.onAddLink,
        toggleDropdown = _b.toggleDropdown,
        onUnlink = _b.onUnlink,
        otherProps = __rest(_b, ["className", "initialText", "initialUrl", "onAddLink", "toggleDropdown", "onUnlink"]);

    var _c = this.state,
        textValue = _c.textValue,
        urlValue = _c.urlValue;
    var rootClass = classnames((_a = {}, _a[styles$1d.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(FieldText, {
      label: "Link title",
      small: true,
      className: styles$1d.field,
      input: {
        value: textValue,
        name: 'pleasedontautofillthis',
        onChange: this.handleTextChange,
        onKeyDown: this.handleKeyDown
      }
    }), /*#__PURE__*/React.createElement(FieldText, {
      label: "Link URL",
      small: true,
      className: styles$1d.field,
      input: {
        value: urlValue,
        name: 'link_url',
        onChange: this.handleUrlChange,
        onKeyDown: this.handleKeyDown
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button$2, {
      size: "small",
      onClick: this.handleAddLink
    }, "Add"), !!urlValue && /*#__PURE__*/React.createElement(Button$2, {
      size: "small",
      transparent: true,
      onClick: this.handleUnlink
    }, "Remove link")));
  };

  return LinkMenu;
}(React.PureComponent);

var LinkButton =
/** @class */
function (_super) {
  __extends(LinkButton, _super);

  function LinkButton(props) {
    var _this = _super.call(this, props) || this;

    _this.preventDefault = function (e) {
      e.preventDefault();
    };

    _this.state = {
      selectedLink: '',
      selectedText: '',
      hoverLinkHref: null,
      hoverLinkBounds: null
    };
    _this.handleAddLink = _this.handleAddLink.bind(_this);
    _this.handleUnlink = _this.handleUnlink.bind(_this);
    return _this;
  }

  LinkButton.prototype.componentDidMount = function () {
    var _this = this;

    var editor = this.props.editor;
    editor.events.onMouseOver(function (e) {
      _this.showLinkButtons(e);
    });
    editor.selection.onUpdate(function () {
      _this.updateSelectedText();
    });
  };

  LinkButton.prototype.updateSelectedText = function () {
    var _a;

    var editorWindow = this.props.editorWindow;
    var selection = editorWindow.getSelection();

    if (!selection) {
      return;
    }

    var anchorNode = selection.anchorNode,
        focusNode = selection.focusNode;

    if (anchorNode && focusNode === anchorNode && ((_a = anchorNode.parentElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'A') {
      var _b = anchorNode.parentElement,
          href = _b.href,
          innerText = _b.innerText;
      this.setState({
        selectedLink: href,
        selectedText: innerText
      });
    } else {
      this.setState({
        selectedLink: '',
        selectedText: selection.toString()
      });
    }
  };

  LinkButton.prototype.showLinkButtons = function (e) {
    var target = e.target;
    var editor = this.props.editor;
    var current = editor.ref.current;

    if (current && target && target instanceof HTMLAnchorElement) {
      var editorBounds = current.getBoundingClientRect();
      var targetBounds = target.getBoundingClientRect();
      this.setState({
        hoverLinkHref: target.getAttribute('href'),
        hoverLinkBounds: {
          top: targetBounds.top - editorBounds.top,
          left: targetBounds.left - editorBounds.left,
          width: targetBounds.width
        }
      });
    } else {
      this.setState({
        hoverLinkHref: null,
        hoverLinkBounds: null
      });
    }
  };

  LinkButton.prototype.handleAddLink = function (text, url) {
    if (url) {
      var editor = this.props.editor;
      this.selectParentLink();
      editor.command.run('insertHTML', "<a href=\"" + url + "\">" + (text || url) + "</a>");
      this.forceUpdate();
    }
  };

  LinkButton.prototype.handleUnlink = function () {
    var editor = this.props.editor;
    this.selectParentLink();
    editor.command.run('unlink');
  };

  LinkButton.prototype.selectParentLink = function () {
    var _a;

    var _b = this.props,
        editor = _b.editor,
        editorWindow = _b.editorWindow;
    editor.selection.recreate();
    var selection = editorWindow.getSelection();

    if (!selection) {
      return;
    }

    var anchorNode = selection.anchorNode,
        focusNode = selection.focusNode; // Update the selection to wrap link if we're in "edit mode"

    if (anchorNode && anchorNode === focusNode && ((_a = anchorNode.parentElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'A') {
      var range = document.createRange();
      range.selectNodeContents(anchorNode.parentElement);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  LinkButton.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        editor = _a.editor,
        editorWindow = _a.editorWindow,
        otherProps = __rest(_a, ["className", "editor", "editorWindow"]);

    var _b = this.state,
        hoverLinkBounds = _b.hoverLinkBounds,
        hoverLinkHref = _b.hoverLinkHref,
        selectedText = _b.selectedText,
        selectedLink = _b.selectedLink;
    var rootClass = classnames({}, className);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownButton, __assign({
      className: rootClass
    }, otherProps, {
      dropdown: /*#__PURE__*/React.createElement(DropdownButtonContext.Consumer, null, function (_a) {
        var toggleDropdown = _a.toggleDropdown;
        return /*#__PURE__*/React.createElement(LinkMenu, {
          onAddLink: _this.handleAddLink,
          toggleDropdown: toggleDropdown,
          initialUrl: selectedLink,
          initialText: selectedText,
          onUnlink: _this.handleUnlink
        });
      }),
      noStyle: true
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      isActive: !!selectedLink,
      icon: "link",
      onMouseDown: this.preventDefault
    })), !!hoverLinkBounds && !!hoverLinkHref && /*#__PURE__*/React.createElement("a", {
      className: styles$1c.linkOpener,
      href: hoverLinkHref,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        top: hoverLinkBounds.top + "px",
        left: hoverLinkBounds.left + hoverLinkBounds.width + "px"
      }
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: "icon-vertical-fix",
      name: "external-link"
    })));
  };

  return LinkButton;
}(React.PureComponent);

var css_248z$1n = "@-webkit-keyframes tabs--tabs__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes tabs--tabs__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes tabs--tabs__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes tabs--tabs__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tabs--tabs__root {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.tabs--tabs__tabs {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap; }\n  .tabs--tabs__tabsTop, .tabs--tabs__tabsBottom {\n    height: 48px; }\n\n.tabs--tabs__tab {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 12px;\n  padding: 16px 0;\n  max-height: 48px;\n  color: #8193b0;\n  transition: 0.2s ease-out;\n  outline: none;\n  box-sizing: border-box; }\n  .tabs--tabs__tabTop {\n    justify-content: center;\n    margin-right: 22px;\n    border-top: 2px solid transparent;\n    border-bottom: 2px solid transparent;\n    transition-property: border-top, border-bottom, color; }\n    .tabs--tabs__tabTop:hover, .tabs--tabs__tabTop:focus {\n      border-bottom: 2px solid #b5c1d4; }\n    .tabs--tabs__tabTopActive {\n      border-color: #b5c1d4;\n      color: #45587c; }\n    .tabs--tabs__tabTopSelected {\n      border-bottom: 2px solid #45587c;\n      color: #45587c; }\n      .tabs--tabs__tabTopSelected:hover, .tabs--tabs__tabTopSelected:focus {\n        border-bottom: 2px solid #45587c; }\n    .tabs--tabs__tabTop:last-child {\n      margin-right: 0; }\n  .tabs--tabs__tabLeft {\n    justify-content: flex-start;\n    flex: 0 0 100%;\n    padding-left: 16px;\n    border-left: 2px solid transparent;\n    border-right: 2px solid transparent;\n    transition-property: border-left, border-right, color; }\n    .tabs--tabs__tabLeft:hover, .tabs--tabs__tabLeft:focus {\n      border-right: 2px solid #b5c1d4; }\n    .tabs--tabs__tabLeftActive {\n      border-color: #b5c1d4;\n      color: #45587c; }\n    .tabs--tabs__tabLeftSelected {\n      border-right: 2px solid #45587c;\n      color: #45587c; }\n      .tabs--tabs__tabLeftSelected:hover, .tabs--tabs__tabLeftSelected:focus {\n        border-right: 2px solid #45587c; }\n  .tabs--tabs__tabBottom {\n    justify-content: center;\n    margin-right: 22px;\n    border-bottom: 2px solid transparent;\n    border-top: 2px solid transparent;\n    transition-property: border-bottom, border-top, color; }\n    .tabs--tabs__tabBottom:hover, .tabs--tabs__tabBottom:focus {\n      border-top: 2px solid #b5c1d4; }\n    .tabs--tabs__tabBottomActive {\n      border-color: #b5c1d4;\n      color: #45587c; }\n    .tabs--tabs__tabBottomSelected {\n      border-top: 2px solid #45587c;\n      color: #45587c; }\n      .tabs--tabs__tabBottomSelected:hover, .tabs--tabs__tabBottomSelected:focus {\n        border-top: 2px solid #45587c; }\n    .tabs--tabs__tabBottom:last-child {\n      margin-right: 0; }\n  .tabs--tabs__tabRight {\n    justify-content: flex-end;\n    flex: 0 0 100%;\n    padding-right: 16px;\n    border-right: 2px solid transparent;\n    border-left: 2px solid transparent;\n    transition-property: border-right, border-left, color; }\n    .tabs--tabs__tabRight:hover, .tabs--tabs__tabRight:focus {\n      border-left: 2px solid #b5c1d4; }\n    .tabs--tabs__tabRightActive {\n      border-color: #b5c1d4;\n      color: #45587c; }\n    .tabs--tabs__tabRightSelected {\n      border-left: 2px solid #45587c;\n      color: #45587c; }\n      .tabs--tabs__tabRightSelected:hover, .tabs--tabs__tabRightSelected:focus {\n        border-left: 2px solid #45587c; }\n  .tabs--tabs__tabDisabled {\n    opacity: 0.5;\n    cursor: not-allowed; }\n    .tabs--tabs__tabDisabled:active, .tabs--tabs__tabDisabled:focus {\n      pointer-events: none;\n      border-color: transparent; }\n  .tabs--tabs__tab:not(.tabs--tabs__tabDisabled):hover {\n    color: #45587c;\n    cursor: pointer; }\n\n.tabs--tabs__labelIcon {\n  margin-right: 8px; }\n";
var styles$1e = {"root":"tabs--tabs__root","tabs":"tabs--tabs__tabs","tabsTop":"tabs--tabs__tabsTop","tabsBottom":"tabs--tabs__tabsBottom","tab":"tabs--tabs__tab","tabTop":"tabs--tabs__tabTop","tabTopActive":"tabs--tabs__tabTopActive","tabTopSelected":"tabs--tabs__tabTopSelected","tabLeft":"tabs--tabs__tabLeft","tabLeftActive":"tabs--tabs__tabLeftActive","tabLeftSelected":"tabs--tabs__tabLeftSelected","tabBottom":"tabs--tabs__tabBottom","tabBottomActive":"tabs--tabs__tabBottomActive","tabBottomSelected":"tabs--tabs__tabBottomSelected","tabRight":"tabs--tabs__tabRight","tabRightActive":"tabs--tabs__tabRightActive","tabRightSelected":"tabs--tabs__tabRightSelected","tabDisabled":"tabs--tabs__tabDisabled","labelIcon":"tabs--tabs__labelIcon","wiggle":"tabs--tabs__wiggle","spin":"tabs--tabs__spin"};
styleInject(css_248z$1n);

var ENTER_KEY_CODE = 13;

var Tab =
/** @class */
function (_super) {
  __extends(Tab, _super);

  function Tab(props) {
    var _this = _super.call(this, props) || this;

    _this.handleOnClick = _this.handleOnClick.bind(_this);
    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
    return _this;
  }

  Tab.prototype.handleOnClick = function () {
    var _a = this.props,
        id = _a.id,
        onChange = _a.onChange,
        disabled = _a.disabled;

    if (disabled) {
      return;
    }

    onChange(id);
  };

  Tab.prototype.handleOnKeyDown = function (evt) {
    if (evt.keyCode === ENTER_KEY_CODE) {
      this.handleOnClick();
    }
  };

  Tab.prototype.getClassName = function () {
    var _a, _b;

    var _c = this.props,
        selected = _c.selected,
        placement = _c.placement,
        className = _c.className,
        disabled = _c.disabled,
        active = _c.active,
        selectedClassName = _c.selectedClassName;
    var classNames = classnames(styles$1e.tab, className, (_a = {}, _a[styles$1e.tabDisabled] = disabled, _a[styles$1e.tabTop] = placement === 'top', _a[styles$1e.tabRight] = placement === 'right', _a[styles$1e.tabLeft] = placement === 'left', _a[styles$1e.tabBottom] = placement === 'bottom', _a[styles$1e.tabTopSelected] = placement === 'top' && selected, _a[styles$1e.tabRightSelected] = placement === 'right' && selected, _a[styles$1e.tabLeftSelected] = placement === 'left' && selected, _a[styles$1e.tabBottomSelected] = placement === 'bottom' && selected, _a[styles$1e.tabTopActive] = placement === 'top' && active, _a[styles$1e.tabRightActive] = placement === 'right' && active, _a[styles$1e.tabLeftActive] = placement === 'left' && active, _a[styles$1e.tabBottomActive] = placement === 'bottom' && active, _a));

    if (selectedClassName) {
      classNames = classnames(classNames, (_b = {}, _b[selectedClassName] = selected, _b));
    }

    return classNames;
  };

  Tab.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        label = _a.label,
        icon = _a.icon,
        disabled = _a.disabled;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      role: "tab",
      className: this.getClassName(),
      onClick: this.handleOnClick,
      onKeyDown: this.handleOnKeyDown,
      tabIndex: disabled ? -1 : 0
    }, !!icon && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: icon,
      className: classnames('icon-vertical-fix', styles$1e.labelIcon)
    }), label);
  };

  return Tab;
}(PureComponent);

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.containerRef = /*#__PURE__*/createRef();
    _this.renderTab = _this.renderTab.bind(_this);
    _this.renderTabs = _this.renderTabs.bind(_this);
    return _this;
  }

  Tabs.prototype.renderTab = function (_a) {
    var id = _a.id,
        label = _a.label,
        icon = _a.icon,
        disabled = _a.disabled;
    var _b = this.props,
        selectedId = _b.selectedId,
        activeId = _b.activeId,
        onChange = _b.onChange,
        tabsPlacement = _b.tabsPlacement,
        tabClassName = _b.tabClassName,
        tabSelectedClassName = _b.tabSelectedClassName;
    return /*#__PURE__*/React.createElement(Tab, {
      key: id,
      selected: id === selectedId,
      className: tabClassName,
      selectedClassName: tabSelectedClassName,
      id: id,
      label: label,
      icon: icon,
      onChange: onChange,
      placement: tabsPlacement,
      disabled: disabled,
      active: id === activeId
    });
  };

  Tabs.prototype.renderTabs = function () {
    var tabs = this.props.tabs;
    return tabs.map(this.renderTab);
  };

  Tabs.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        tabClassName = _a.tabClassName,
        tabSelectedClassName = _a.tabSelectedClassName,
        tabs = _a.tabs,
        selectedId = _a.selectedId,
        onChange = _a.onChange,
        tabsPlacement = _a.tabsPlacement,
        activeId = _a.activeId,
        otherProps = __rest(_a, ["className", "tabClassName", "tabSelectedClassName", "tabs", "selectedId", "onChange", "tabsPlacement", "activeId"]);

    var rootClass = classnames(styles$1e.root, className);
    return /*#__PURE__*/React.createElement("div", __assign({
      ref: this.containerRef
    }, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$1e.tabs
    }, this.renderTabs()));
  };

  Tabs.defaultProps = {
    tabsPlacement: 'top'
  };
  return Tabs;
}(PureComponent);
var TabsWithErrorBoundary = withErrorBoundary(Tabs, {
  fallback: null
});

var commandActive = function commandActive(editorWindow, command) {
  return editorWindow.document.queryCommandState(command);
};
var getCurrentFormat = function getCurrentFormat(editorWindow) {
  return editorWindow.document.queryCommandValue('formatBlock');
};
var isImage = function isImage(file) {
  return file.type.indexOf('image/') === 0;
};
var createImage = function createImage(editorWindow, // `any` to suppress `URL` and `webkitURL` error
file, index) {
  var uid = file.name + new Date().getTime() + "-" + index;
  var URLObj = editorWindow.URL || editorWindow.webkitURL;
  var src = URLObj.createObjectURL(file);
  return {
    src: src,
    uid: uid
  };
};
var createFileUid = function createFileUid(file, index) {
  return file.name + new Date().getTime() + "-" + index;
};
var addBorderStyleToTables = function addBorderStyleToTables(div) {
  if (div) {
    div.querySelectorAll('td').forEach(function (td) {
      td.style.border = '1px solid currentColor';
    });
  }
};

var adjustDirectionOfElement = function adjustDirectionOfElement(elem) {
  elem.setAttribute('dir', 'auto');
  var dir = window.getComputedStyle(elem).direction;
  elem.setAttribute('dir', dir);
};

var calcDirectionOfElements = function calcDirectionOfElements(elem) {
  if (!elem) {
    return;
  }

  elem.childNodes.forEach(function (child) {
    if (child.nodeType !== Node.ELEMENT_NODE && child.nodeType !== Node.TEXT_NODE) {
      return;
    }

    if (isElement$2(child) && isBlockLevel(child)) {
      adjustDirectionOfElement(child);
    }
  });
};
var getDirectionFormattedHtml = function getDirectionFormattedHtml(html, isRootElement) {
  if (isRootElement === void 0) {
    isRootElement = true;
  }

  var elem = document.createElement('div');
  elem.style.display = 'none';
  elem.innerHTML = html;
  document.body.appendChild(elem); // we need this in order to get the computed property

  elem.childNodes.forEach(function (child) {
    if (child.nodeType !== Node.ELEMENT_NODE && child.nodeType !== Node.TEXT_NODE) {
      return;
    }

    if (isElement$2(child) && isBlockLevel(child)) {
      child.innerHTML = getDirectionFormattedHtml(child.innerHTML, false);
      adjustDirectionOfElement(child);
    } else if (isRootElement) {
      var div = document.createElement('div');
      div.appendChild(child.cloneNode(true));
      child.replaceWith(div);
      adjustDirectionOfElement(div);
    }
  });
  document.body.removeChild(elem);
  return elem.innerHTML;
};

var makeSpaceAroundLineNonBreaking = function makeSpaceAroundLineNonBreaking(line) {
  var arr = line.split('');
  var space = ' ';
  var nonBreakingSpace = '&nbsp;';
  var i = 0;
  var j = arr.length - 1;

  while (arr[i] === space) {
    arr[i++] = nonBreakingSpace;
  }

  while (arr[j] === space) {
    arr[j--] = nonBreakingSpace;
  }

  return arr.join('');
};

var convertPlainToHtml = function convertPlainToHtml(text) {
  return text.split(/\r\n|\r|\n/g).map(function (line) {
    if (!line) {
      return "<br />";
    }

    return "<div>" + makeSpaceAroundLineNonBreaking(line) + "</div>";
  }).join('');
};

var css_248z$1o = "@-webkit-keyframes quickResponseSelector--quickResponseItem__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes quickResponseSelector--quickResponseItem__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes quickResponseSelector--quickResponseItem__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes quickResponseSelector--quickResponseItem__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.quickResponseSelector--quickResponseItem__root {\n  list-style-type: none;\n  display: block;\n  position: relative;\n  font-size: 14px;\n  line-height: 32px;\n  height: 48px;\n  border: 0;\n  width: 100%;\n  text-align: left;\n  padding: 0 8px;\n  outline: 0;\n  background-color: transparent;\n  border-top: 1px solid #e7ecf3; }\n  .quickResponseSelector--quickResponseItem__root:hover, .quickResponseSelector--quickResponseItem__root:focus {\n    background-color: #f5f5fa; }\n  .quickResponseSelector--quickResponseItem__rootActive {\n    background-color: #f5f5fa;\n    box-shadow: inset 0 0 0 1px rgba(86, 68, 216, 0.6);\n    z-index: 2; }\n\n.quickResponseSelector--quickResponseItem__name {\n  line-height: 16px;\n  font-weight: 600;\n  color: #393939;\n  font-size: 14px;\n  height: 32px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden; }\n  .quickResponseSelector--quickResponseItem__name span {\n    background: rgba(86, 68, 216, 0.2); }\n\n.quickResponseSelector--quickResponseItem__excerpt {\n  overflow: hidden;\n  height: 16px;\n  display: block;\n  line-height: 16px;\n  font-size: 12px;\n  color: #bbb;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 280px; }\n";
var styles$1f = {"root":"quickResponseSelector--quickResponseItem__root","rootActive":"quickResponseSelector--quickResponseItem__rootActive","name":"quickResponseSelector--quickResponseItem__name","excerpt":"quickResponseSelector--quickResponseItem__excerpt","wiggle":"quickResponseSelector--quickResponseItem__wiggle","spin":"quickResponseSelector--quickResponseItem__spin"};
styleInject(css_248z$1o);

var QuickResponseItem =
/** @class */
function (_super) {
  __extends(QuickResponseItem, _super);

  function QuickResponseItem(props) {
    var _this = _super.call(this, props) || this;

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  QuickResponseItem.prototype.handleSelect = function () {
    var _a = this.props,
        isLoading = _a.isLoading,
        onSelect = _a.onSelect,
        item = _a.item;

    if (isLoading) {
      return;
    }

    onSelect(item);
  };

  QuickResponseItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        item = _b.item,
        isLoading = _b.isLoading,
        onSelect = _b.onSelect,
        active = _b.active,
        searchValue = _b.searchValue,
        clearSearch = _b.clearSearch,
        otherProps = __rest(_b, ["className", "item", "isLoading", "onSelect", "active", "searchValue", "clearSearch"]);

    var _c = !isLoading && item ? item : {
      name: 'Loading...',
      content: '',
      matched: ''
    },
        name = _c.name,
        content = _c.content,
        matched = _c.matched;

    var rootClass = classnames((_a = {}, _a[styles$1f.root] = styles$1f.root, _a[styles$1f.rootActive] = active, _a), className);
    var nameWithHighlight = matched ? highlightWithSpan(name, matched) : name;
    return /*#__PURE__*/React.createElement("button", __assign({
      type: "button"
    }, otherProps, {
      className: rootClass,
      onClick: this.handleSelect
    }), /*#__PURE__*/React.createElement("strong", {
      className: styles$1f.name
    }, nameWithHighlight), /*#__PURE__*/React.createElement("span", {
      className: styles$1f.excerpt
    }, content));
  };

  return QuickResponseItem;
}(React.PureComponent);

var css_248z$1p = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.quickResponseSelector--quickResponseSelector__container {\n  min-width: 250px; }\n\n.quickResponseSelector--quickResponseSelector__dropdownButtonContainer {\n  position: relative; }\n\n.quickResponseSelector--quickResponseSelector__tabbedDropdown {\n  display: flex;\n  height: 352px;\n  width: 400px; }\n  .quickResponseSelector--quickResponseSelector__tabbedDropdownTabs {\n    flex: 0 0 160px;\n    overflow: auto; }\n  .quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent {\n    flex: 1; }\n\n.quickResponseSelector--quickResponseSelector__noItemFound {\n  padding: 16px; }\n";
var styles$1g = {"container":"quickResponseSelector--quickResponseSelector__container","dropdownButtonContainer":"quickResponseSelector--quickResponseSelector__dropdownButtonContainer","tabbedDropdown":"quickResponseSelector--quickResponseSelector__tabbedDropdown","tabbedDropdownTabs":"quickResponseSelector--quickResponseSelector__tabbedDropdownTabs","tabbedDropdownTabsContent":"quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent","noItemFound":"quickResponseSelector--quickResponseSelector__noItemFound"};
styleInject(css_248z$1p);

var fixNewLines = function fixNewLines(content) {
  return content.replace(/\n\n/g, '<div><br></div>').replace(/\n/g, '<br>');
};

var QuickResponseSelector =
/** @class */
function (_super) {
  __extends(QuickResponseSelector, _super);

  function QuickResponseSelector(props) {
    var _a;

    var _this = _super.call(this, props) || this;

    _this.getContentForQuickResponse = function (item) {
      var _a = _this.props,
          renderQuickResponse = _a.renderQuickResponse,
          sanitize = _a.sanitize;
      return new Promise(function (resolve) {
        renderQuickResponse(item).then(function (rendered) {
          resolve(fixNewLines(sanitize(rendered)));
        });
      });
    };

    _this.preventDefault = function (e) {
      e.preventDefault();
    };

    _this.handleSelect = function (item, triggerClose) {
      var _a;

      (_a = _this.insertContent(item)) === null || _a === void 0 ? void 0 : _a.then(function () {
        if (triggerClose) {
          triggerClose();
        }
      });
    };

    _this.insertContent = function (item, trigger, extendSelection) {
      if (trigger === void 0) {
        trigger = '';
      }

      if (extendSelection === void 0) {
        extendSelection = null;
      }

      var _a = _this.props,
          editorWindow = _a.editorWindow,
          editor = _a.editor,
          renderQuickResponse = _a.renderQuickResponse,
          sanitize = _a.sanitize,
          lastSelection = _a.lastSelection;
      var selection = editorWindow.getSelection();
      if (!selection) return;
      return renderQuickResponse(item).then(function (content) {
        var _a, _b;

        if (!editor.selection.isSelectionWithinEditor(selection)) {
          // re-focus on the Editor, if focus is moved out (by clicking on the menu button).
          if (lastSelection) {
            selection.removeAllRanges();
            selection.addRange(lastSelection);
          } else {
            (_a = editor.ref.current) === null || _a === void 0 ? void 0 : _a.focus();
          }
        }

        var anchorNode = selection.anchorNode;

        if (!anchorNode) {
          return;
        }

        if (extendSelection !== null) {
          // Used by suggestion.tsx
          selection.extend(anchorNode, extendSelection);
        }

        var range = selection.getRangeAt(0);
        var template;

        if (((_b = anchorNode.textContent) === null || _b === void 0 ? void 0 : _b.trim()) == trigger) {
          // Adjust each lines direction if it's been added to a new line
          template = getDirectionFormattedHtml(convertPlainToHtml(sanitize(content)));
        } else {
          // concatenate to the end of the current line without changing direction
          template = fixNewLines(sanitize(content));
        }

        range.deleteContents();
        range.insertNode(range.createContextualFragment(template));
        selection.collapseToEnd();
      });
    };

    _this.state = {
      searchTerm: '',
      selectedTab: (_a = props.languages[0]) === null || _a === void 0 ? void 0 : _a.code
    };
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleNextPage = _this.handleNextPage.bind(_this);
    _this.getPagination = _this.getPagination.bind(_this);
    _this.normalizeSuggestion = _this.normalizeSuggestion.bind(_this);
    _this.handleSearchChange = _this.handleSearchChange.bind(_this);
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    _this.handleTabbedSearchChange = _this.handleTabbedSearchChange.bind(_this);
    _this.getTabDefinitions = _this.getTabDefinitions.bind(_this);
    return _this;
  }

  QuickResponseSelector.prototype.componentDidMount = function () {
    var editor = this.props.editor;
    editor.triggers.add({
      trigger: '=',
      minChars: 0,
      allowSpaces: true,
      decoratorDisallowEdit: false,
      getSuggestions: this.handleSearchChange,
      getContent: this.getContentForQuickResponse,
      suggestionComponent: QuickResponseItem,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }; // Performance: Do not re-render on `lastSelection` prop change.


  QuickResponseSelector.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    if (!isEqual(this.state, nextState)) {
      return true;
    }

    var _a = this.props,
        lastSelection = _a.lastSelection,
        restProps = __rest(_a, ["lastSelection"]);

    var nextLastSelection = nextProps.lastSelection,
        restNextProps = __rest(nextProps, ["lastSelection"]);

    return !isEqual(restProps, restNextProps);
  };

  QuickResponseSelector.prototype.normalizeSuggestion = function (item) {
    var _a;

    var quickResponsesApi = this.props.quickResponsesApi;
    return __assign({
      id: item.name,
      matched: (_a = quickResponsesApi.params.search) !== null && _a !== void 0 ? _a : ''
    }, item);
  };

  QuickResponseSelector.prototype.getTabDefinitions = function () {
    var languages = this.props.languages;
    return languages.map(function (language) {
      return {
        id: language.code,
        label: language.label
      };
    });
  };

  QuickResponseSelector.prototype.handleNextPage = function () {
    var _this = this;

    var quickResponsesApi = this.props.quickResponsesApi;
    return new Promise(function (resolve) {
      if (quickResponsesApi.getItemsAsyncStatus === 'loading') {
        return resolve(quickResponsesApi.items.map(_this.normalizeSuggestion)); // normalize, suggestions.tsx uses this response
      }

      return resolve(quickResponsesApi.nextPage().then(function (items) {
        return items.map(_this.normalizeSuggestion);
      }) // normalize, suggestions.tsx uses this response
      .catch(function (err) {
        console.error(err);
      }));
    });
  };

  QuickResponseSelector.prototype.handleToggle = function (isOpen) {
    var _this = this;

    var _a, _b;

    var _c = this.props,
        quickResponsesApi = _c.quickResponsesApi,
        languages = _c.languages; // we need to reset search, because it might be changed in Suggestions component

    if (isOpen && (quickResponsesApi.params.search !== '' || quickResponsesApi.params.locale !== ((_a = languages[0]) === null || _a === void 0 ? void 0 : _a.code))) {
      this.setState({
        searchTerm: '',
        selectedTab: (_b = languages[0]) === null || _b === void 0 ? void 0 : _b.code
      }, function () {
        var _a = _this.state,
            searchTerm = _a.searchTerm,
            selectedTab = _a.selectedTab;

        _this.handleSearchChange(searchTerm, selectedTab, 0);
      });
    }
  };

  QuickResponseSelector.prototype.getPagination = function () {
    var quickResponsesApi = this.props.quickResponsesApi;
    return {
      nextEnable: quickResponsesApi.hasNextPage,
      previousEnable: false,
      infinite: true,
      onNext: this.handleNextPage
    };
  };

  QuickResponseSelector.prototype.handleSearchChange = function (search, locale, fetchThrottle) {
    var _this = this;

    var quickResponsesApi = this.props.quickResponsesApi;
    return quickResponsesApi.paramsChange({
      search: search,
      locale: locale
    }, fetchThrottle).then(function (items) {
      return items.map(_this.normalizeSuggestion);
    }); // normalize, because suggestions component needs them
  };

  QuickResponseSelector.prototype.handleTabbedSearchChange = function (searchTerm) {
    var _this = this;

    this.setState({
      searchTerm: searchTerm
    }, function () {
      var _a = _this.state,
          searchTerm = _a.searchTerm,
          selectedTab = _a.selectedTab;

      _this.handleSearchChange(searchTerm, selectedTab);
    });
  };

  QuickResponseSelector.prototype.handleTabChange = function (selectedTab) {
    var _this = this;

    this.setState({
      selectedTab: selectedTab
    }, function () {
      var _a = _this.state,
          searchTerm = _a.searchTerm,
          selectedTab = _a.selectedTab;

      _this.handleSearchChange(searchTerm, selectedTab, 0);
    });
  };

  QuickResponseSelector.prototype.renderIcon = function () {
    return /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "bolt",
      onMouseDown: this.preventDefault
    });
  };

  QuickResponseSelector.prototype.renderItemsWithoutTabs = function () {
    var _a = this.props,
        className = _a.className,
        quickResponsesApi = _a.quickResponsesApi;
    return /*#__PURE__*/React.createElement(DropdownSelect, {
      className: className,
      containerProps: {
        className: styles$1g.container
      },
      items: quickResponsesApi.items.map(this.normalizeSuggestion),
      pagination: this.getPagination(),
      itemComponent: QuickResponseItem,
      hasSearch: true,
      noStyle: true,
      onSearch: this.handleSearchChange,
      onSelect: this.handleSelect,
      onToggle: this.handleToggle,
      emptyMessage: quickResponsesApi.getItemsAsyncStatus === 'loading' ? 'Loading...' : undefined
    }, this.renderIcon());
  };

  QuickResponseSelector.prototype.renderItemsWithTabs = function () {
    var className = this.props.className;
    var selectedTab = this.state.selectedTab;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$1g.dropdownButtonContainer
    }, /*#__PURE__*/React.createElement(DropdownButton, {
      className: className,
      noStyle: true,
      onToggle: this.handleToggle,
      dropdown: /*#__PURE__*/React.createElement("div", {
        className: styles$1g.tabbedDropdown
      }, /*#__PURE__*/React.createElement(Tabs, {
        className: styles$1g.tabbedDropdownTabs,
        tabs: this.getTabDefinitions(),
        tabsPlacement: "left",
        selectedId: selectedTab,
        onChange: this.handleTabChange
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$1g.tabbedDropdownTabsContent
      }, this.renderTabItems()))
    }, this.renderIcon()));
  };

  QuickResponseSelector.prototype.renderTabItems = function () {
    var _this = this;

    var quickResponsesApi = this.props.quickResponsesApi;
    return /*#__PURE__*/React.createElement(DropdownButtonContext.Consumer, null, function (_a) {
      var dropdownOpen = _a.dropdownOpen,
          toggleDropdown = _a.toggleDropdown;
      return /*#__PURE__*/React.createElement(DropdownSelectContainer, {
        dropdownOpen: dropdownOpen,
        triggerClose: toggleDropdown,
        hasSearch: true,
        pagination: _this.getPagination(),
        items: quickResponsesApi.items.map(_this.normalizeSuggestion),
        itemComponent: QuickResponseItem,
        onSearch: _this.handleTabbedSearchChange,
        onSelect: function onSelect(item) {
          return _this.handleSelect(item, toggleDropdown);
        },
        emptyComponent: EmptySelectItem,
        emptyMessage: quickResponsesApi.getItemsAsyncStatus === 'loading' ? 'Loading...' : 'No items found.'
      });
    });
  };

  QuickResponseSelector.prototype.render = function () {
    var languages = this.props.languages;

    if (!(languages === null || languages === void 0 ? void 0 : languages.length)) {
      return this.renderItemsWithoutTabs();
    } else {
      return this.renderItemsWithTabs();
    }
  };

  return QuickResponseSelector;
}(React.Component);

var SANITIZE_PROFILE_WIDGETCHAT = {
  allowedTags: ['b', 'i', 'strong', 'em', 'a', 'ul', 'ol', 'li', 'br', 'code', 'div', 'p', 'img', 'pre', 'placeholderp', 'h1', 'h2', 'h3', 'h4', 'h5', 'blockquote', 'span'],
  allowedAttributes: {
    '*': ['dir'],
    a: ['href'],
    img: ['src', 'alt']
  },
  transformTags: {
    p: 'placeholderp'
  }
};

var SANITIZE_PROFILE_DEFAULT = {
  allowedAttributes: __assign(__assign({}, sanitizeHtml.defaults.allowedAttributes), {
    a: __spreadArrays(sanitizeHtml.defaults.allowedAttributes.a, ['rel']),
    '*': ['dir']
  })
};

var SANITIZE_PROFILE_EMAIL = {
  allowedTags: ['a', 'abbr', 'acronym', 'address', 'area', 'b', 'bdo', 'big', 'blockquote', 'br', 'button', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'dd', 'del', 'dfn', 'dir', 'div', 'dl', 'dt', 'em', 'fieldset', 'font', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'map', 'mark', 'menu', 'ol', 'optgroup', 'option', 'p', 'pre', 'q', 's', 'samp', 'select', 'small', 'span', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'tr', 'tt', 'u', 'ul', 'var'],
  allowedAttributes: {
    '*': ['style', 'width', 'height', 'id', 'class', 'lang', 'tabindex', 'title', 'dir', 'color', 'align', 'bgcolor'],
    area: ['shape', 'coords', 'href', 'target', 'alt', 'download'],
    bdo: ['fir'],
    blockquote: ['cite'],
    del: ['cite', 'datetime'],
    fieldset: ['disabled', 'form', 'name'],
    hr: ['color', 'noshade', 'size'],
    input: ['type', 'disabled', 'alt', 'checked', 'max', 'min', 'placeholder', 'inputmode', 'readonly', 'required', 'value', 'pattern'],
    ins: ['cite', 'datetime'],
    label: ['for', 'form'],
    li: ['value', 'type'],
    map: ['name'],
    menu: ['label', 'type'],
    ol: ['reversed', 'start', 'type'],
    optgroup: ['label', 'disabled'],
    option: ['value', 'label', 'selected'],
    q: ['cite'],
    select: ['disabled', 'name', 'required', 'size', 'multiple'],
    table: ['border', 'cellpadding', 'cellspacing', 'frame', 'rules', 'summary'],
    tbody: ['char', 'charoff', 'valign'],
    td: ['abbr', 'axis', 'char', 'charoff', 'colspan', 'headers', 'rowspan', 'scope', 'valign'],
    textarea: ['autocapitalize', 'cols', 'disabled', 'maxlength', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'rows', 'spellcheck', 'wrap'],
    tfoot: ['char', 'charoff', 'valign'],
    th: ['abbr', 'axis', 'char', 'charoff', 'valign', 'colspan', 'headers', 'rowspan', 'scope', 'valign'],
    thead: ['char', 'charoff', 'valign'],
    tr: ['char', 'charoff', 'valign'],
    ul: ['compact', 'type'],
    a: ['href', 'download', 'rel', 'hreflang', 'target'],
    img: ['src', 'alt', 'usemap']
  },
  allowedSchemes: ['http', 'https', 'mailto']
};

var SANITIZE_PROFILE_MESSAGING = {
  allowedTags: ['br', 'placeholderp'],
  transformTags: {
    p: 'placeholderp'
  },
  allowedAttributes: {
    '*': ['dir']
  }
};

var css_248z$1q = "@-webkit-keyframes formatSelector--formatSelector__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes formatSelector--formatSelector__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes formatSelector--formatSelector__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes formatSelector--formatSelector__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.formatSelector--formatSelector__root {\n  display: flex;\n  align-items: center;\n  margin-right: 8px; }\n\n.formatSelector--formatSelector__list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0; }\n\n.formatSelector--formatSelector__selector {\n  font-size: 12px;\n  padding-left: 8px;\n  width: 84px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  color: #5a5a5a;\n  cursor: pointer; }\n\n.formatSelector--formatSelector__option {\n  color: #7a7a7a; }\n  .formatSelector--formatSelector__option + .formatSelector--formatSelector__option {\n    border-top: 1px solid #e3e4e6; }\n  .formatSelector--formatSelector__optionActive {\n    font-weight: 600; }\n\n.formatSelector--formatSelector__button {\n  border: 0;\n  background: none;\n  text-align: left;\n  min-width: 150px;\n  padding: 0 8px;\n  line-height: 32px;\n  font-size: 12px; }\n";
var styles$1h = {"root":"formatSelector--formatSelector__root","list":"formatSelector--formatSelector__list","selector":"formatSelector--formatSelector__selector","option":"formatSelector--formatSelector__option","optionActive":"formatSelector--formatSelector__optionActive","button":"formatSelector--formatSelector__button","wiggle":"formatSelector--formatSelector__wiggle","spin":"formatSelector--formatSelector__spin"};
styleInject(css_248z$1q);

var SUPPORTED_FORMATS = [{
  tag: 'div',
  name: 'Normal',
  default: true
}, {
  tag: '<H1>',
  name: 'Headline 1'
}, {
  tag: '<H2>',
  name: 'Headline 2'
}, {
  tag: '<H3>',
  name: 'Headline 3'
}, {
  tag: '<H4>',
  name: 'Headline 4'
}, {
  tag: '<H5>',
  name: 'Headline 5'
}, {
  tag: '<BLOCKQUOTE>',
  name: 'Block quote'
}];

var FormatSelector =
/** @class */
function (_super) {
  __extends(FormatSelector, _super);

  function FormatSelector() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.preventDefault = function (e) {
      e.preventDefault();
    };

    return _this;
  }

  FormatSelector.prototype.renderDropdown = function () {
    var _this = this;

    var onUpdateFormat = this.props.onUpdateFormat;
    return /*#__PURE__*/React.createElement(DropdownButtonContext.Consumer, null, function (_a) {
      var toggleDropdown = _a.toggleDropdown;
      return /*#__PURE__*/React.createElement("ul", {
        className: styles$1h.list
      }, SUPPORTED_FORMATS.map(function (format) {
        var _a;

        return /*#__PURE__*/React.createElement("li", {
          key: format.tag,
          className: classnames(styles$1h.option, (_a = {}, _a[styles$1h.optionActive] = _this.isActiveFormat(format), _a))
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: styles$1h.button,
          onClick: function onClick() {
            onUpdateFormat(format.tag);
            toggleDropdown();
          }
        }, format.name));
      }));
    });
  };

  FormatSelector.prototype.isActiveFormat = function (format) {
    var formatBlock = this.props.formatBlock;
    if (!formatBlock && format.default) return true;
    if (format.tag === formatBlock || format.tag === "<" + formatBlock.toUpperCase() + ">") return true;
    return false;
  };

  FormatSelector.prototype.getCurrentFormatName = function () {
    for (var i = 0; i < SUPPORTED_FORMATS.length; i += 1) {
      var format = SUPPORTED_FORMATS[i];
      if (this.isActiveFormat(format)) return format.name;
    }

    return 'Normal';
  };

  FormatSelector.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        onUpdateFormat = _a.onUpdateFormat,
        formatBlock = _a.formatBlock,
        otherProps = __rest(_a, ["className", "onUpdateFormat", "formatBlock"]);

    var rootClass = classnames(styles$1h.root, className);
    return /*#__PURE__*/React.createElement(DropdownButton, __assign({
      className: rootClass
    }, otherProps, {
      dropdown: this.renderDropdown(),
      noStyle: true
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$1h.selector
    }, this.getCurrentFormatName(), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: "icon-vertical-fix",
      name: "angle-down"
    })));
  };

  return FormatSelector;
}(React.PureComponent);

var css_248z$1r = ".stylingMenu--stylingMenu__menu {\n  position: absolute;\n  transform: translate(-5px, -130%);\n  display: flex;\n  border: 1px solid #f1f2f4;\n  box-sizing: border-box;\n  border-radius: 6px;\n  height: 32px;\n  align-items: center;\n  filter: drop-shadow(0 3px 4px rgba(15, 31, 66, 0.08));\n  background: #fff;\n  z-index: 2; }\n  .stylingMenu--stylingMenu__menu::before {\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 8px solid #fff;\n    position: absolute;\n    filter: drop-shadow(0 1px 0 #f1f2f4);\n    top: 98%;\n    left: 8px; }\n\n.stylingMenu--stylingMenu__stylingMenuButton {\n  transform: translateY(2px);\n  font-size: 16px; }\n";
var styles$1i = {"menu":"stylingMenu--stylingMenu__menu","stylingMenuButton":"stylingMenu--stylingMenu__stylingMenuButton"};
styleInject(css_248z$1r);

var StylingMenu =
/** @class */
function (_super) {
  __extends(StylingMenu, _super);

  function StylingMenu(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClickOutside = function (e) {
      var current = _this.domRef.current;

      if (current && e.target instanceof Element && e.target !== current && !current.contains(e.target)) {
        _this.setState({
          isOpen: false
        });
      }
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });
    };

    _this.state = {
      isOpen: false,
      currentFormat: ''
    };
    _this.domRef = /*#__PURE__*/React.createRef();
    _this.handleUpdateFormat = _this.handleUpdateFormat.bind(_this);
    _this.handleToolbarButtonClick = _this.handleToolbarButtonClick.bind(_this);
    return _this;
  }

  StylingMenu.prototype.componentDidMount = function () {
    var _this = this;

    var editor = this.props.editor; // Add hotkeys for bold and italic

    editor.hotkeys.add([{
      hotkey: 'mod+b',
      callback: function callback() {
        return editor.allowFormatting && editor.command.run('bold');
      }
    }, {
      hotkey: 'mod+i',
      callback: function callback() {
        return editor.allowFormatting && editor.command.run('italic');
      }
    }]);
    editor.selection.onUpdate(function () {
      _this.updateCurrentFormat();
    });
  };

  StylingMenu.prototype.componentDidUpdate = function (prevProps, prevState) {
    var isOpen = this.state.isOpen;
    var editorWindow = this.props.editorWindow;

    if (isOpen !== prevState.isOpen) {
      editorWindow[isOpen ? 'addEventListener' : 'removeEventListener']('click', this.handleClickOutside, true);
    }
  };

  StylingMenu.prototype.componentWillUnmount = function () {
    var isOpen = this.state.isOpen;
    var editorWindow = this.props.editorWindow;

    if (isOpen) {
      editorWindow.removeEventListener('click', this.handleClickOutside, true);
    }
  };

  StylingMenu.prototype.updateCurrentFormat = function () {
    var editorWindow = this.props.editorWindow;
    this.setState({
      currentFormat: getCurrentFormat(editorWindow)
    });
  };

  StylingMenu.prototype.handleUpdateFormat = function (tag) {
    var editor = this.props.editor;
    editor.command.run('formatBlock', tag);
  };

  StylingMenu.prototype.handleToolbarButtonClick = function (event) {
    var editor = this.props.editor;
    event.preventDefault();

    if (event.currentTarget instanceof Element) {
      var command = event.currentTarget.getAttribute('data-command');

      if (command) {
        editor.command.run(command);
        this.forceUpdate();
      }
    }
  };

  StylingMenu.prototype.styleActive = function (style) {
    var editor = this.props.editor;
    return editor.command.active(style);
  };

  StylingMenu.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        isActive = _a.isActive,
        editor = _a.editor,
        editorWindow = _a.editorWindow,
        otherProps = __rest(_a, ["className", "isActive", "editor", "editorWindow"]);

    var _b = this.state,
        isOpen = _b.isOpen,
        currentFormat = _b.currentFormat;
    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      ref: this.domRef
    }), isOpen && /*#__PURE__*/React.createElement("div", {
      className: styles$1i.menu
    }, /*#__PURE__*/React.createElement(FormatSelector, {
      onUpdateFormat: this.handleUpdateFormat,
      formatBlock: currentFormat
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1i.stylingMenuButton,
      isActive: this.styleActive('bold'),
      onMouseDown: this.handleToolbarButtonClick,
      "data-command": "bold",
      icon: "bold",
      narrow: true
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1i.stylingMenuButton,
      isActive: this.styleActive('italic'),
      onMouseDown: this.handleToolbarButtonClick,
      "data-command": "italic",
      icon: "italic",
      narrow: true
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1i.stylingMenuButton,
      isActive: this.styleActive('insertUnorderedList'),
      onMouseDown: this.handleToolbarButtonClick,
      "data-command": "insertUnorderedList",
      icon: "list-ul"
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1i.stylingMenuButton,
      isActive: this.styleActive('insertOrderedList'),
      onMouseDown: this.handleToolbarButtonClick,
      "data-command": "insertOrderedList",
      icon: "list-ol"
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1i.stylingMenuButton,
      onMouseDown: this.handleToolbarButtonClick,
      "data-command": "removeFormat",
      icon: "pen-slash",
      style: {
        fontSize: '15px'
      }
    })), /*#__PURE__*/React.createElement(ToolbarButton, {
      isActive: isActive,
      icon: "format",
      onMouseDown: this.handleClick
    }));
  };

  return StylingMenu;
}(React.PureComponent);

var css_248z$1s = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.suggestions--suggestions__dropdown {\n  height: 288px; }\n  .suggestions--suggestions__dropdownWithTabs {\n    display: flex;\n    width: 400px; }\n  .suggestions--suggestions__dropdownWithoutTabs {\n    width: 240px; }\n  .suggestions--suggestions__dropdownTabs {\n    flex: 0 0 160px;\n    overflow: auto; }\n  .suggestions--suggestions__dropdownTabsContent {\n    flex: 1; }\n";
var styles$1j = {"dropdown":"suggestions--suggestions__dropdown","dropdownWithTabs":"suggestions--suggestions__dropdownWithTabs","dropdownWithoutTabs":"suggestions--suggestions__dropdownWithoutTabs","dropdownTabs":"suggestions--suggestions__dropdownTabs","dropdownTabsContent":"suggestions--suggestions__dropdownTabsContent"};
styleInject(css_248z$1s);

function getPrevChar(editorWindow) {
  var selection = editorWindow.getSelection();
  var focusOffset = selection.focusOffset,
      anchorOffset = selection.anchorOffset,
      anchorNode = selection.anchorNode;

  if (focusOffset === anchorOffset && anchorNode && anchorNode.nodeName === '#text') {
    return anchorNode.textContent.slice(0, focusOffset);
  }

  return null;
}

var Suggestions =
/** @class */
function (_super) {
  __extends(Suggestions, _super);

  function Suggestions(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      listenForSelectionChange: true,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: '',
      selectedTab: null,
      selectionMode: 'suggestion',
      tabIndex: 0
    };
    _this.dropdownRef = /*#__PURE__*/React.createRef();
    _this.tabsRef = /*#__PURE__*/React.createRef();
    _this.handleSuggestionClick = _this.handleSuggestionClick.bind(_this);
    _this.handleSelectionChange = _this.handleSelectionChange.bind(_this);
    _this.getPagination = _this.getPagination.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    return _this;
  }

  Suggestions.prototype.componentDidMount = function () {
    var _this = this;

    var editor = this.props.editor; // Add selection change handler

    editor.selection.onUpdate(this.handleSelectionChange);
    editor.events.onBlur(this.handleBlur); // Add key handlers

    editor.hotkeys.add([{
      hotkey: 'ArrowUp',
      condition: function condition() {
        return _this.shouldHandleKey();
      },
      callback: function callback() {
        return _this.handleArrowKey(-1);
      }
    }, {
      hotkey: 'ArrowDown',
      condition: function condition() {
        return _this.shouldHandleKey();
      },
      callback: function callback() {
        return _this.handleArrowKey(1);
      }
    }, {
      hotkey: 'Escape',
      condition: function condition() {
        return _this.hasSuggestions() || _this.hasTabs();
      },
      callback: function callback() {
        return _this.handleEscapeKey();
      }
    }, {
      hotkey: 'Enter',
      condition: function condition() {
        return _this.shouldHandleKey();
      },
      callback: function callback() {
        return _this.handleEnterKey();
      }
    }]);
  };

  Suggestions.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.state,
        suggestionIndex = _a.suggestionIndex,
        tabIndex = _a.tabIndex;

    if (suggestionIndex !== prevState.suggestionIndex) {
      this.updateSuggestionScroll();
    }

    if (tabIndex !== prevState.tabIndex) {
      this.updateTabScroll();
    }
  };

  Suggestions.prototype.shouldHandleKey = function () {
    var selectionMode = this.state.selectionMode;
    return selectionMode === 'suggestion' && this.hasSuggestions() || selectionMode === 'tab' && this.hasTabs();
  };

  Suggestions.prototype.handleArrowKey = function (dir) {
    var selectionMode = this.state.selectionMode;

    if (selectionMode === 'suggestion' && this.hasSuggestions()) {
      this.suggestionsNavigate(dir);
    } else if (selectionMode === 'tab' && this.hasTabs()) {
      this.tabsNavigate(dir);
    }
  };

  Suggestions.prototype.handleEscapeKey = function () {
    var selectionMode = this.state.selectionMode;

    if (selectionMode === 'suggestion' && this.hasTabs()) {
      this.setState({
        selectionMode: 'tab',
        tabIndex: this.getSelectedTabIndex()
      });
    } else {
      this.clearSuggestions();
    }
  };

  Suggestions.prototype.handleEnterKey = function () {
    var _a;

    var _b = this.state,
        selectionMode = _b.selectionMode,
        tabIndex = _b.tabIndex,
        suggestionTrigger = _b.suggestionTrigger;

    if (selectionMode === 'suggestion' && this.hasSuggestions()) {
      this.expandSuggestion();
    } else if (selectionMode === 'tab' && this.hasTabs()) {
      var tab = (_a = suggestionTrigger === null || suggestionTrigger === void 0 ? void 0 : suggestionTrigger.getTabs) === null || _a === void 0 ? void 0 : _a.call(suggestionTrigger)[tabIndex];

      if (tab) {
        this.handleTabChange(tab.id);
      }
    }
  };

  Suggestions.prototype.handleBlur = function (e) {
    var relatedTarget = e.nativeEvent.relatedTarget;

    if (relatedTarget === null) {
      this.clearSuggestions();
    }
  };

  Suggestions.prototype.hasSuggestions = function () {
    var suggestions = this.state.suggestions;
    return !!(suggestions === null || suggestions === undefined ? undefined : suggestions.length);
  };

  Suggestions.prototype.hasTabs = function () {
    var _a, _b;

    return !!((_b = (_a = this.state.suggestionTrigger) === null || _a === void 0 ? void 0 : _a.getTabs) === null || _b === void 0 ? void 0 : _b.call(_a).length);
  };

  Suggestions.prototype.getSelectedTabIndex = function () {
    var _a;

    var _b = this.state,
        suggestionTrigger = _b.suggestionTrigger,
        selectedTab = _b.selectedTab;

    if (!this.hasTabs()) {
      return -1;
    }

    return (_a = suggestionTrigger === null || suggestionTrigger === void 0 ? void 0 : suggestionTrigger.getTabs) === null || _a === void 0 ? void 0 : _a.call(suggestionTrigger).findIndex(function (tab) {
      return tab.id === selectedTab;
    }); // because of `hasTabs` we know the type is number
  };

  Suggestions.prototype.clearSuggestions = function () {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: 'suggestion'
    });
  };

  Suggestions.prototype.suggestionsNavigate = function (dir) {
    this.setState(function (_a) {
      var suggestionIndex = _a.suggestionIndex,
          suggestions = _a.suggestions;

      if (suggestions && suggestions.length) {
        var newIndex = void 0;
        if (dir < 0) newIndex = suggestionIndex > 0 ? suggestionIndex - 1 : suggestions.length - 1;else newIndex = (suggestionIndex + 1) % suggestions.length;
        return {
          suggestionIndex: newIndex
        };
      }

      return null;
    });
  };

  Suggestions.prototype.tabsNavigate = function (dir) {
    this.setState(function (_a) {
      var _b;

      var tabIndex = _a.tabIndex,
          suggestionTrigger = _a.suggestionTrigger;
      var tabs = (_b = suggestionTrigger === null || suggestionTrigger === void 0 ? void 0 : suggestionTrigger.getTabs) === null || _b === void 0 ? void 0 : _b.call(suggestionTrigger);

      if (tabs === null || tabs === void 0 ? void 0 : tabs.length) {
        var newIndex = void 0;
        if (dir < 0) newIndex = tabIndex > 0 ? tabIndex - 1 : tabs.length - 1;else newIndex = (tabIndex + 1) % tabs.length;
        return {
          tabIndex: newIndex
        };
      }

      return null;
    });
  };

  Suggestions.prototype.lookForTriggers = function (selectedTab, delay) {
    var _this = this;

    var _a;

    var _b = this.props,
        editorWindow = _b.editorWindow,
        editor = _b.editor;
    var _c = this.state,
        stateSelectedTab = _c.selectedTab,
        stateSelectionMode = _c.selectionMode;
    var prevChar = getPrevChar(editorWindow);

    if (prevChar) {
      var triggerResult = editor.triggers.test(prevChar);

      if (triggerResult) {
        var match_1 = triggerResult.match,
            suggestionTrigger_1 = triggerResult.suggestionTrigger;
        var tabs = (_a = suggestionTrigger_1 === null || suggestionTrigger_1 === void 0 ? void 0 : suggestionTrigger_1.getTabs) === null || _a === void 0 ? void 0 : _a.call(suggestionTrigger_1);

        if (tabs === null || tabs === void 0 ? void 0 : tabs.length) {
          var newState = null;

          if (selectedTab) {
            newState = {
              selectionMode: 'suggestion',
              selectedTab: selectedTab,
              tabIndex: -1
            };
          } else if (stateSelectedTab) {
            selectedTab = stateSelectedTab;
          } else {
            newState = {
              selectionMode: 'tab',
              selectedTab: tabs[0].id,
              tabIndex: 0
            };
          }

          if (newState) {
            this.setState(newState, function () {
              if (!selectedTab) {
                // if tab is not selected, re-run this function after setting the state
                _this.lookForTriggers();
              }
            });
          }

          if (!selectedTab) {
            // if there are tabs, but no selected tab, do not continue because the function re-runs after setState
            return;
          }
        } else if (stateSelectionMode !== 'suggestion') {
          this.setState({
            selectionMode: 'suggestion'
          });
        }

        var suggestionsPromise = Promise.resolve(suggestionTrigger_1.getSuggestions(match_1[1], selectedTab, delay));
        suggestionsPromise.then(function (suggestions) {
          _this.updateSuggestions(match_1, suggestionTrigger_1, suggestions);
        }); // Return so state doesn't get cleared

        return;
      }
    } // If the function doesn't return with suggestions default by clearing suggestions


    this.clearSuggestions();
  };

  Suggestions.prototype.findTriggerPosition = function (triggerLength, callback) {
    var _this = this;

    this.setState({
      listenForSelectionChange: false
    }, function () {
      var editorWindow = _this.props.editorWindow;
      var selection = editorWindow.getSelection();

      if (selection) {
        var focusOffset = selection.focusOffset,
            anchorNode = selection.anchorNode;

        if (anchorNode) {
          if (focusOffset - triggerLength >= 0) {
            selection.extend(anchorNode, focusOffset - triggerLength);
          }

          var pos_1 = selection.getRangeAt(0).getBoundingClientRect();
          selection.collapseToEnd();
          setTimeout(function () {
            callback(pos_1);

            _this.setState({
              listenForSelectionChange: true
            });
          });
        }
      }
    });
  };

  Suggestions.prototype.updateSuggestions = function (match, suggestionTrigger, suggestions) {
    var _this = this;

    var editorWindow = this.props.editorWindow;
    this.findTriggerPosition(match[0].length, function (pos) {
      var selection = editorWindow.getSelection();

      if (!selection) {
        return;
      }

      var focusOffset = selection.focusOffset;

      _this.setState({
        suggestions: suggestions,
        suggestionTrigger: suggestionTrigger,
        suggestionPosition: pos,
        suggestionIndex: 0,
        suggestionMatchedString: match[1],
        suggestionExtendBy: focusOffset - match[0].length,
        listenForSelectionChange: true
      });
    });
  };

  Suggestions.prototype.updateSuggestionScroll = function () {
    var suggestionIndex = this.state.suggestionIndex;
    var dropdown = this.dropdownRef.current;

    if (!dropdown) {
      return;
    }

    if (dropdown.infiniteListRef.current) {
      // list with pagination (infinite)
      dropdown.infiniteListRef.current.scrollToItem(suggestionIndex);
    } else if (dropdown.listRef.current) {
      // list without pagination
      var parent_1 = dropdown.listRef.current;
      var child = dropdown.listRef.current.children[suggestionIndex];
      var childBounds = child.getBoundingClientRect();
      var parentBounds = parent_1.getBoundingClientRect();

      if (parentBounds.bottom < childBounds.bottom) {
        parent_1.scrollTop += childBounds.bottom - parentBounds.bottom;
      } else if (parentBounds.top > childBounds.top) {
        parent_1.scrollTop -= parentBounds.top - childBounds.top;
      }
    }
  };

  Suggestions.prototype.updateTabScroll = function () {
    var tabIndex = this.state.tabIndex;
    var tabs = this.tabsRef.current;

    if (tabIndex < 0 || !tabs) {
      return;
    }

    if (tabs.containerRef.current) {
      var parent_2 = tabs.containerRef.current;
      var child = tabs.containerRef.current.children[0].children[tabIndex];
      var childBounds = child.getBoundingClientRect();
      var parentBounds = parent_2.getBoundingClientRect();

      if (parentBounds.bottom < childBounds.bottom) {
        parent_2.scrollTop += childBounds.bottom - parentBounds.bottom;
      } else if (parentBounds.top > childBounds.top) {
        parent_2.scrollTop -= parentBounds.top - childBounds.top;
      }
    }
  };

  Suggestions.prototype.expandSuggestion = function () {
    var _a = this.state,
        suggestions = _a.suggestions,
        suggestionIndex = _a.suggestionIndex,
        suggestionExtendBy = _a.suggestionExtendBy,
        suggestionTrigger = _a.suggestionTrigger;

    if (!suggestions || !suggestions[suggestionIndex] || !suggestionTrigger) {
      return;
    }

    if (suggestionTrigger.insertContent) {
      return suggestionTrigger.insertContent(suggestions[suggestionIndex], suggestionTrigger.trigger, suggestionExtendBy);
    }

    var _b = this.props,
        editorWindow = _b.editorWindow,
        editor = _b.editor;
    var selection = editorWindow.getSelection();
    if (!selection) return;
    var anchorNode = selection.anchorNode;
    suggestionTrigger.getContent(suggestions[suggestionIndex]).then(function (content) {
      if (!selection || !anchorNode) return;
      if (!editor.selection.isSelectionWithinEditor(selection)) return;
      selection.extend(anchorNode, suggestionExtendBy);
      var range = selection.getRangeAt(0);
      range.deleteContents();
      var template = document.createElement('span');

      if (suggestionTrigger.decoratorDisallowEdit) {
        template.setAttribute('contenteditable', 'false');
      }

      if (suggestionTrigger.decoratorClass) {
        template.classList.add(suggestionTrigger.decoratorClass);
      }

      template.innerHTML = content.replace(/\n/g, '<br />');
      range.insertNode(template);
      selection.collapseToEnd();
    });
  };

  Suggestions.prototype.handleSelectionChange = function () {
    var listenForSelectionChange = this.state.listenForSelectionChange;

    if (listenForSelectionChange) {
      this.lookForTriggers();
    }
  };

  Suggestions.prototype.handleSuggestionClick = function (item) {
    var _this = this;

    this.setState(function (state) {
      return {
        suggestionIndex: state.suggestions ? state.suggestions.indexOf(item) : 0
      };
    }, function () {
      _this.expandSuggestion();
    });
  };

  Suggestions.prototype.calculateSuggestionBoxPosition = function () {
    var suggestionPosition = this.state.suggestionPosition;
    var editor = this.props.editor;

    if (editor.ref.current && suggestionPosition) {
      var editorBounds = editor.ref.current.getBoundingClientRect();
      return {
        bottom: editorBounds.bottom - suggestionPosition.bottom + suggestionPosition.height,
        left: suggestionPosition.x - editorBounds.x + suggestionPosition.width
      };
    }

    return {};
  };

  Suggestions.prototype.suggestionBoxStyle = function () {
    var suggestionPosition = this.state.suggestionPosition;
    var editor = this.props.editor;

    if (editor.ref.current && suggestionPosition) {
      var editorBounds = editor.ref.current.getBoundingClientRect();
      return {
        left: suggestionPosition.x - editorBounds.x + "px",
        top: suggestionPosition.y - editorBounds.y + suggestionPosition.height / 2 + "px",
        height: 1,
        width: suggestionPosition.width,
        position: 'absolute'
      };
    }

    return {};
  };

  Suggestions.prototype.getPagination = function () {
    var _this = this;

    var suggestionTrigger = this.state.suggestionTrigger;

    if (!suggestionTrigger || !suggestionTrigger.getPagination) {
      return false;
    }

    var pagination = suggestionTrigger.getPagination();

    if (!pagination || !pagination.onNext) {
      return false;
    }

    return __assign(__assign({}, pagination), {
      onNext: function onNext() {
        var _a, _b;

        return (_b = (_a = pagination.onNext) === null || _a === void 0 ? void 0 : _a.call(pagination).then(function (suggestions) {
          _this.setState({
            suggestions: suggestions
          });
        })) !== null && _b !== void 0 ? _b : Promise.resolve(undefined);
      }
    });
  };

  Suggestions.prototype.handleTabChange = function (selectedTab) {
    this.lookForTriggers(selectedTab, 0);
  };

  Suggestions.prototype.renderEmptyState = function () {
    return /*#__PURE__*/React.createElement(EmptySelectItem, {
      label: "No suggestions found"
    });
  };

  Suggestions.prototype.renderTabs = function () {
    var _a, _b, _c;

    var _d = this.state,
        suggestions = _d.suggestions,
        suggestionTrigger = _d.suggestionTrigger,
        selectedTab = _d.selectedTab,
        tabIndex = _d.tabIndex;
    var tabs = (_b = (_a = suggestionTrigger === null || suggestionTrigger === void 0 ? void 0 : suggestionTrigger.getTabs) === null || _a === void 0 ? void 0 : _a.call(suggestionTrigger)) !== null && _b !== void 0 ? _b : [];
    var hasSuggestions = !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
      ref: this.tabsRef,
      className: styles$1j.dropdownTabs,
      tabs: tabs,
      tabsPlacement: "left",
      selectedId: selectedTab,
      activeId: (_c = tabs === null || tabs === void 0 ? void 0 : tabs[tabIndex]) === null || _c === void 0 ? void 0 : _c.id,
      onChange: this.handleTabChange
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$1j.dropdownTabsContent
    }, hasSuggestions ? this.renderItems() : this.renderEmptyState()));
  };

  Suggestions.prototype.renderItems = function () {
    var _a = this.state,
        suggestions = _a.suggestions,
        suggestionIndex = _a.suggestionIndex,
        suggestionTrigger = _a.suggestionTrigger,
        selectionMode = _a.selectionMode;
    var SuggestionComponent = suggestionTrigger ? suggestionTrigger.suggestionComponent : null;
    return /*#__PURE__*/React.createElement(DropdownInfinite, {
      ref: this.dropdownRef,
      pagination: this.getPagination(),
      items: suggestions || undefined,
      onSelect: this.handleSuggestionClick,
      itemComponent: SuggestionComponent,
      activeItem: selectionMode === 'suggestion' ? suggestions === null || suggestions === void 0 ? void 0 : suggestions[suggestionIndex] : undefined
    });
  };

  Suggestions.prototype.render = function () {
    var _a;

    var _b = this.props,
        editorWindow = _b.editorWindow,
        editor = _b.editor,
        otherProps = __rest(_b, ["editorWindow", "editor"]);

    var _c = this.state,
        suggestionPosition = _c.suggestionPosition,
        selectedTab = _c.selectedTab,
        suggestions = _c.suggestions;

    if (!suggestionPosition) {
      return null;
    }

    if (!this.hasTabs() && !(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length)) {
      return null;
    }

    if (this.hasTabs() && !selectedTab) {
      return null;
    }

    var dropdownClassName = classnames(styles$1j.dropdown, (_a = {}, _a[styles$1j.dropdownWithTabs] = this.hasTabs(), _a[styles$1j.dropdownWithoutTabs] = !this.hasTabs(), _a));
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps), /*#__PURE__*/React.createElement("div", {
      style: this.suggestionBoxStyle()
    }, /*#__PURE__*/React.createElement(Dropdown, {
      className: dropdownClassName,
      isOpen: true
    }, this.hasTabs() ? this.renderTabs() : this.renderItems())));
  };

  return Suggestions;
}(React.PureComponent);

var EditorTriggers =
/** @class */
function () {
  function EditorTriggers() {
    this.suggestionTriggers = [];
  }

  Object.defineProperty(EditorTriggers.prototype, "excludeTriggersRegex", {
    get: function get() {
      return this.suggestionTriggers.map(function (suggestionTrigger) {
        return "(?!" + suggestionTrigger.trigger + ")";
      }).join('');
    },
    enumerable: false,
    configurable: true
  });

  EditorTriggers.prototype.add = function (trigger) {
    this.suggestionTriggers.push(trigger);
  };

  EditorTriggers.prototype.test = function (text) {
    var match;

    for (var i = 0; i < this.suggestionTriggers.length; i += 1) {
      var suggestionTrigger = this.suggestionTriggers[i];
      var trigger = suggestionTrigger.trigger,
          allowSpaces = suggestionTrigger.allowSpaces,
          minChars = suggestionTrigger.minChars; // Build the regex.
      // Example: (current trigger: `=`) (all triggers: `=` and `:`) (allowSpaces: true)
      // Result: `=((?:(?!:)(?!=).)*)$`

      var regex = new RegExp(trigger + "((?:" + this.excludeTriggersRegex + (allowSpaces ? '.' : '\\S') + ")*)$", 'g');
      match = regex.exec(text); // If we have a match, check that the number of characters after the trigger (match[1])
      // satisfies the min chars requirement (if any)

      if (match && (!minChars || match[1].length >= minChars)) {
        return {
          match: match,
          suggestionTrigger: suggestionTrigger
        };
      }
    }

    return null;
  };

  return EditorTriggers;
}();

/**
 * @NOTE:
 * These sanitizer profiles should alway sync up with what we have in the backend.
 * https://github.com/dixahq/libtext/blob/master/src/main/scala/com/dixa/text/HtmlSanitizer.scala
 */

var SANITIZE_PROFILE = {
  email: SANITIZE_PROFILE_EMAIL,
  widgetchat: SANITIZE_PROFILE_WIDGETCHAT,
  messaging: SANITIZE_PROFILE_MESSAGING,
  default: SANITIZE_PROFILE_DEFAULT
};

function removePlaceholderParagraphs(text) {
  var sanitized = text.replace(/<\/placeholderp>\n*<placeholderp/g, '</div><br /><div');
  sanitized = sanitized.replace(/<placeholderp/g, '<div');
  sanitized = sanitized.replace(/<\/placeholderp>/g, '</div>');
  return sanitized;
}

var URL_REG = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i;

var FieldEditor =
/** @class */
function (_super) {
  __extends(FieldEditor, _super);

  function FieldEditor(props) {
    var _this = _super.call(this, props) || this;
    /**
     * The core update function, that triggers every time the selection is changed,
     * which will also trigger when the contents change.
     *
     * This method handles calling onChange in the input prop.
     *
     * @todo Test if onInput would be a better way of triggering onChange
     *
     * @return {void} [description]
     */


    _this.handleSelectionChange = function () {
      var _a = _this.props,
          onChange = _a.input.onChange,
          onSelectionChange = _a.onSelectionChange;
      var _b = _this.state,
          htmlOld = _b.htmlOld,
          selectionUpdateListeners = _b.selectionUpdateListeners;
      var current = _this.editorRef.current; // Check if the contents have changed and trigger onChange if so

      if (current) {
        _this.forceUpdate();

        var htmlNew = current.innerHTML;

        if (htmlNew !== htmlOld) {
          _this.setState({
            htmlOld: htmlNew
          });

          onChange(htmlNew);
        }
      } // Run the selection change listeners from modules


      selectionUpdateListeners.forEach(function (listener) {
        listener();
      }); // Call the parent component's selection change callback (if any)

      if (onSelectionChange) onSelectionChange();
    };
    /**
     * Handle any mouse over events on the editor
     */


    _this.handleMouseOver = function (e) {
      var mouseOverListeners = _this.state.mouseOverListeners; // Call the mouse over listeners (if any)

      mouseOverListeners.forEach(function (listener) {
        listener(e);
      });
    };
    /**
     * Handle blur events on the editor
     */


    _this.handleBlurListeners = function (e) {
      var blurListeners = _this.state.blurListeners; // Call the blur listeners (if any)

      blurListeners.forEach(function (listener) {
        listener(e);
      });
    };

    _this.handleKeyDown = function (e) {
      var _a;

      var keyCommands = _this.state.keyCommands;
      var sendOnEnter = _this.props.sendOnEnter;
      var current = _this.editorRef.current; // Prevent deleting the initial div

      if (e.key === 'Backspace' && current && !((_a = current === null || current === void 0 ? void 0 : current.textContent) === null || _a === void 0 ? void 0 : _a.length) && !_this.hasContent(current.innerHTML)) {
        // editorRef *should* always have an empty div when blank,
        // but just in case it's a completely empty string; insert an empty div
        if (!current.innerHTML) {
          current.innerHTML = '<div><br></div>';
        }

        e.preventDefault();
      }

      for (var i = 0; i < keyCommands.length; i += 1) {
        var _b = keyCommands[i],
            condition = _b.condition,
            callback = _b.callback;
        var extraCondition = condition && typeof condition === 'function' ? condition() : true;

        if (_default$4(keyCommands[i].hotkey, e) && extraCondition) {
          if (callback && typeof callback === 'function') {
            callback();
          }

          return _this.setKeyDownHandled(e);
        }
      }

      if (e.key === 'Enter' && sendOnEnter && !e.shiftKey) {
        var onTriggerSend = _this.props.onTriggerSend;

        _this.setKeyDownHandled(e);

        onTriggerSend();
      }

      if (_default$4('mod+enter', e)) {
        var onTriggerSend = _this.props.onTriggerSend;

        _this.setKeyDownHandled(e);

        onTriggerSend();
      }

      return null;
    };

    _this.getBlockLevelParent = function (elem) {
      var _a = _this.props.editorWindow,
          editorWindow = _a === void 0 ? window : _a;
      var parentElement = isElement$2(elem) ? elem : elem.parentElement;

      while (!isBlockLevel(parentElement, editorWindow)) {
        parentElement = parentElement.parentElement;
      }

      return parentElement;
    }; // Insert actual text direction into the html


    _this.onInput = function (e) {
      var _a;

      var current = _this.editorRef.current; // React doesn't have an InputEvent type

      var nativeEvent = e === null || e === void 0 ? void 0 : e.nativeEvent;

      if (!nativeEvent) {
        return;
      }

      var inputType = nativeEvent.inputType; // Only want to do this on a paste event, however the inputType for
      // execCommand('insertHTML') is always empty string (used when pasting html)

      if (inputType === 'insertFromPaste' || !inputType) {
        calcDirectionOfElements(current);
        addBorderStyleToTables(current);
        return;
      }

      var selection = document.getSelection();
      var anchorNode = selection === null || selection === void 0 ? void 0 : selection.anchorNode; // Only checking the text direction for the first char in a line

      if (inputType === 'insertText' && anchorNode && ((_a = anchorNode.textContent) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        var parentElement = _this.getBlockLevelParent(anchorNode);

        if ( // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (parentElement.tagName === 'UL' || parentElement.tagName === 'OL') && parentElement.hasAttribute('dir')) {
          return;
        } else {
          // otherwise set the dir to 'auto' and apply the computed direction
          parentElement.setAttribute('dir', 'auto');
          var dir = window.getComputedStyle(parentElement).direction;
          parentElement.setAttribute('dir', dir);
        } // sometimes browser adds `style="text-align: right;"` when when switching to ltr


        parentElement.style.textAlign = '';
      }
    };

    _this.handleKeyUp = function () {
      var keyDownHandled = _this.state.keyDownHandled;

      if (!keyDownHandled) {
        _this.handleSelectionChange();
      }

      _this.setState({
        keyDownHandled: false
      });
    };

    _this.setKeyDownHandled = function (e) {
      e.preventDefault();

      _this.setState({
        keyDownHandled: true
      });
    };

    _this.addKeyCommands = function (commands) {
      _this.setState(function (_a) {
        var keyCommands = _a.keyCommands;
        return {
          keyCommands: __spreadArrays(keyCommands, commands)
        };
      });
    };

    _this.handlePaste = function (e) {
      var _a = _this.props,
          onFileDropped = _a.onFileDropped,
          allowInlineAttachments = _a.allowInlineAttachments,
          _b = _a.editorWindow,
          editorWindow = _b === void 0 ? window : _b;
      var clipboardData = e.clipboardData;
      if (!clipboardData) return;
      var html = clipboardData.getData('text/html');
      var plain = clipboardData.getData('text/plain');

      if (html) {
        e.preventDefault();

        _this.commandRun('insertHTML', _this.sanitize(html));

        return;
      } // Since Chrome 85 URL from Chrome address bar is pasted as a plain/text.
      // Hence use regexp to verify if URL and paste as `a` tag link.


      if (plain && URL_REG.test(plain)) {
        e.preventDefault();
        html = "<a href=\"" + plain + "\">" + plain + "</a>";

        _this.commandRun('insertHTML', html);

        return;
      }

      if (!onFileDropped) {
        return;
      }

      var items = clipboardData.items;

      if (items !== undefined) {
        // Don't allow file paste on plain text
        if (!allowInlineAttachments) {
          e.preventDefault();
          return;
        }

        for (var i = 0; i < items.length; i += 1) {
          var file = items[i].getAsFile();

          if (file) {
            e.preventDefault();

            var _c = createImage(editorWindow, file, i),
                src = _c.src,
                uid = _c.uid;

            _this.insertImageLoader(src, uid);

            onFileDropped(file, uid);
            return;
          }
        }
      }
    };

    _this.sanitize = function (text, overrideSanitizationProfile) {
      if (overrideSanitizationProfile === void 0) {
        overrideSanitizationProfile = false;
      }

      var _a = _this.props,
          featureFlags = _a.featureFlags,
          sanitizationProfile = _a.sanitizationProfile;
      var profile = overrideSanitizationProfile || SANITIZE_PROFILE[sanitizationProfile === 'email' ? featureFlags && featureFlags.hasFFWriteHTMLEmail ? 'email' : 'widgetchat' : sanitizationProfile];
      var inline = sanitizationProfile !== 'email' ? function (identity) {
        return identity;
      } : juiceClient;
      return removePlaceholderParagraphs(sanitizeHtml(inline(text), profile));
    };

    _this.getText = function () {
      var current = _this.editorRef.current; // innerHTML of <div></div> should count as empty

      return current && _this.hasContent(current.innerHTML) ? current.innerHTML : '';
    };

    _this.getSanitizedHtml = function () {
      return _this.sanitize(_this.getText());
    };

    _this.getPlainText = function () {
      var current = _this.editorRef.current;
      var text = // innerHTML of <div></div> should count as empty
      current && _this.hasContent(current.innerHTML) ? current.innerText : ''; // HACK: Innertext makes way to many line breaks. Half them

      return text ? text.replace(/\n\n/g, '\n') : '';
    };

    _this.handleInlineUpload = function (files) {
      if (files === null) return;
      var _a = _this.props,
          onFileDropped = _a.onFileDropped,
          _b = _a.editorWindow,
          editorWindow = _b === void 0 ? window : _b;

      if (files && onFileDropped) {
        var filesArray = Array.from(files);
        filesArray.forEach(function (file, index) {
          if (isImage(file)) {
            var _a = createImage(editorWindow, file, index),
                src = _a.src,
                uid = _a.uid;

            _this.insertImageLoader(src, uid);

            onFileDropped(file, uid);
          } else {
            var uid = createFileUid(file, index);

            _this.insertFileLoader(file.name, uid);

            onFileDropped(file, uid);
          }
        });
      }
    };

    _this.handleAttachmentUpload = function (files) {
      var onAttachmentsFile = _this.props.onAttachmentsFile;
      var current = _this.attachmentDropdownButtonRef.current;

      if (current) {
        current.open();
      }

      if (files && typeof onAttachmentsFile === 'function') {
        var filesArray = Array.from(files);
        filesArray.forEach(function (file, index) {
          var uid = createFileUid(file, index);
          onAttachmentsFile(file, uid);
        });
      }
    };

    _this.handleDetachAttachmentFile = function (index) {
      var onDetachAttacmentFile = _this.props.onDetachAttacmentFile;

      if (typeof onDetachAttacmentFile === 'function') {
        onDetachAttacmentFile(index);
      }
    };

    _this.handleFileSelect = function (e) {
      var fileInput = e.target;

      if (fileInput instanceof HTMLInputElement) {
        _this.handleInlineUpload(fileInput.files);

        fileInput.value = '';
      }
    };

    _this.openFileBrowser = function (e) {
      e.preventDefault();
      var current = _this.fileInputRef.current;
      if (current) current.click();
    };

    _this.handleToggleSendOnEnter = function (e) {
      e.preventDefault();
      var onToggleSendOnEnter = _this.props.onToggleSendOnEnter;
      onToggleSendOnEnter();
    };

    _this.insertContent = function (content, options) {
      var current = _this.editorRef.current;
      var _a = _this.state,
          hasFocus = _a.hasFocus,
          lastSelection = _a.lastSelection;
      var _b = _this.props.editorWindow,
          editorWindow = _b === void 0 ? window : _b;
      var selection = editorWindow.getSelection();
      if (!selection) return;

      if (current && content) {
        if (!hasFocus) {
          if (lastSelection) {
            selection.removeAllRanges();
            selection.addRange(lastSelection);
          } else {
            _this.focus();
          }
        }

        if (!_this.isSelectionWithinEditor(selection)) return;

        if (options) {
          var range = selection.getRangeAt(0);
          range.deleteContents();
          var template = editorWindow.document.createElement('span');

          if (options.decoratorDisallowEdit) {
            template.setAttribute('contenteditable', 'false');
          }

          if (options.decoratorClass) {
            template.classList.add(options.decoratorClass);
          }

          template.innerHTML = content.replace(/\n/g, '<br />');
          range.insertNode(template);
          selection.collapseToEnd();
        } else {
          editorWindow.document.execCommand('insertHTML', false, content);
        }

        _this.handleSelectionChange();
      }
    };

    _this.handleFocus = function () {
      var _a = _this.props.editorWindow,
          editorWindow = _a === void 0 ? window : _a;

      _this.setState({
        hasFocus: true
      });

      editorWindow.document.addEventListener('selectionchange', _this.handleSelectionChange);
    };

    _this.handleBlur = function (e) {
      var _a = _this.props.editorWindow,
          editorWindow = _a === void 0 ? window : _a;
      var selection = editorWindow.getSelection();

      _this.setState({
        lastSelection: selection ? selection.getRangeAt(0) : null,
        hasFocus: false
      });

      editorWindow.document.removeEventListener('selectionchange', _this.handleSelectionChange);

      _this.handleBlurListeners(e);
    };

    _this.focus = function () {
      var current = _this.editorRef.current;
      var hasFocus = _this.state.hasFocus;

      if (current) {
        if (!hasFocus) current.focus();
      }
    };

    _this.editorRef = /*#__PURE__*/React.createRef();
    _this.currentSuggestionRef = /*#__PURE__*/React.createRef();
    _this.fileInputRef = /*#__PURE__*/React.createRef();
    _this.attachmentDropdownButtonRef = /*#__PURE__*/React.createRef();
    _this.state = {
      keyDownHandled: false,
      keyCommands: [],
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: '',
      lastSelection: null,
      hasFocus: false,
      selectedText: '',
      selectedLink: ''
    };
    _this.editor = {
      command: {
        run: _this.commandRun.bind(_this),
        active: _this.commandActive.bind(_this)
      },
      hotkeys: {
        add: _this.addKeyCommands.bind(_this)
      },
      selection: {
        onUpdate: _this.addSelectionUpdateListener.bind(_this),
        recreate: _this.recreateSelection.bind(_this),
        isSelectionWithinEditor: _this.isSelectionWithinEditor.bind(_this)
      },
      events: {
        onMouseOver: _this.addMouseOverListener.bind(_this),
        onBlur: _this.addBlurListener.bind(_this)
      },
      allowFormatting: props.allowFormatting,
      triggers: new EditorTriggers(),
      ref: _this.editorRef
    };
    return _this;
  }

  FieldEditor.prototype.componentDidMount = function () {
    // Set the default separator to div, so we get single line breaks
    var _a = this.props,
        _b = _a.editorWindow,
        editorWindow = _b === void 0 ? window : _b,
        onMount = _a.onMount;
    editorWindow.document.execCommand('defaultParagraphSeparator', false, 'div');
    var value = this.props.input.value; // Update the html in the editor with the value,
    // This will also add the initial '<div><br></div>'

    this.setHtml(value);
    onMount();
  };

  FieldEditor.prototype.componentDidUpdate = function (prevProps) {
    var _this = this;

    var fileUploadStatuses = this.props.fileUploadStatuses;
    var current = this.editorRef.current; // Update status of inline files updating (if any)

    if (fileUploadStatuses && fileUploadStatuses !== prevProps.fileUploadStatuses && current) {
      Object.keys(fileUploadStatuses).forEach(function (key) {
        _this.updateFileLoader(key, fileUploadStatuses[key]);
      }); // Trigger a selection change (to trigger redraw and onChange events)

      this.handleSelectionChange();
    }
  };

  FieldEditor.prototype.componentWillUnmount = function () {
    var onUnmount = this.props.onUnmount;
    onUnmount(this.getSanitizedHtml());
  };

  FieldEditor.prototype.addSelectionUpdateListener = function (listener) {
    this.setState(function (_a) {
      var selectionUpdateListeners = _a.selectionUpdateListeners;
      return {
        selectionUpdateListeners: __spreadArrays(selectionUpdateListeners, [listener])
      };
    });
  };

  FieldEditor.prototype.addMouseOverListener = function (listener) {
    this.setState(function (_a) {
      var mouseOverListeners = _a.mouseOverListeners;
      return {
        mouseOverListeners: __spreadArrays(mouseOverListeners, [listener])
      };
    });
  };

  FieldEditor.prototype.addBlurListener = function (listener) {
    this.setState(function (_a) {
      var blurListeners = _a.blurListeners;
      return {
        blurListeners: __spreadArrays(blurListeners, [listener])
      };
    });
  };

  FieldEditor.prototype.commandRun = function (command, value) {
    var _this = this;

    if (value === void 0) {
      value = null;
    } // We run this in a timeout so we're sure that any changes to focus state
    // has been run


    setTimeout(function () {
      var hasFocus = _this.state.hasFocus;
      var current = _this.editorRef.current;
      var _a = _this.props.editorWindow,
          editorWindow = _a === void 0 ? window : _a;

      if (current) {
        if (!hasFocus) _this.recreateSelection();
        editorWindow.document.execCommand(command, false, // execCommand 3rd expects string | null, TS thinks it needs string | undefined
        value);
      }
    });
  };

  FieldEditor.prototype.commandActive = function (command) {
    var hasFocus = this.state.hasFocus;
    var _a = this.props.editorWindow,
        editorWindow = _a === void 0 ? window : _a;
    return !!(hasFocus && commandActive(editorWindow, command));
  };

  FieldEditor.prototype.setHtml = function (html) {
    var current = this.editorRef.current;
    var sanitizedHtml = this.sanitize(html);

    if (current) {
      // wrapped in a <div> so that we can calculate the dir prop (rtl or ltr)
      // the <br> is so that cursor focuses inside the <div> (doesn't seem to be a visible linebreak)
      current.innerHTML = "<div>" + (sanitizedHtml || '') + "<br></div>";
      calcDirectionOfElements(current);
    }

    this.setState({
      htmlOld: sanitizedHtml
    });
  };

  FieldEditor.prototype.insertImageLoader = function (src, uid) {
    this.insertContent("<img src=\"" + src + "\" class=\"async-loading\" data-uid=\"" + uid + "\" />");
  };

  FieldEditor.prototype.insertFileLoader = function (name, uid) {
    this.insertContent("<a href=\"#\" class=\"async-loading\" data-uid=\"" + uid + "\">" + name + "</a>");
  };

  FieldEditor.prototype.updateFileLoader = function (uid, _a) {
    var link = _a.link,
        status = _a.status;
    var current = this.editorRef.current;

    if (current) {
      var fileElem = current.querySelector("[data-uid=\"" + uid + "\"]");

      if (fileElem) {
        if (status === 'failed' && fileElem.parentElement) {
          fileElem.parentElement.removeChild(fileElem);
        } else {
          fileElem.classList.remove('async-loading', 'async-succeeded', 'async-failed');
          fileElem.classList.add("async-" + status);

          if (link && fileElem instanceof HTMLImageElement) {
            fileElem.src = link;
          }

          if (link && fileElem instanceof HTMLAnchorElement) {
            fileElem.href = link;
          }
        }
      }
    }
  };

  FieldEditor.prototype.isSelectionWithinEditor = function (selection) {
    var anchorNode = selection.anchorNode;
    var _a = (anchorNode || {}).parentElement,
        parentElement = _a === void 0 ? null : _a;
    var select = "." + styles$1b.editor;
    var selectionIsWithinEditor = anchorNode !== null && anchorNode.nodeType === Node.ELEMENT_NODE ? anchorNode.matches(select) : false;

    while (!selectionIsWithinEditor && parentElement !== null) {
      if (parentElement.matches(select)) {
        selectionIsWithinEditor = true;
        break;
      }

      parentElement = parentElement.parentElement;
    }

    return selectionIsWithinEditor;
  };

  FieldEditor.prototype.recreateSelection = function () {
    var current = this.editorRef.current;
    var _a = this.state,
        hasFocus = _a.hasFocus,
        lastSelection = _a.lastSelection;
    var _b = this.props.editorWindow,
        editorWindow = _b === void 0 ? window : _b;

    if (current) {
      if (!hasFocus) {
        current.focus();

        if (lastSelection) {
          var selection = editorWindow.getSelection();

          if (selection) {
            selection.removeAllRanges();
            selection.addRange(lastSelection);
          }
        }
      }
    }
  };

  FieldEditor.prototype.hasContent = function (html) {
    // does not have content if: empty string, '<div></div>', '<div><br></div>'
    // the check includes whether the divs have props
    return (html === null || html === void 0 ? void 0 : html.length) ? !html.match(/^<[A-z\s="0-9]*>\s*(<br>\s*)?<\/[A-z\s="0-9]*>$/) : false;
  };

  FieldEditor.prototype.isStylingActive = function () {
    return this.commandActive('bold') || this.commandActive('italic') || this.commandActive('insertUnorderedList') || this.commandActive('insertOrderedList');
  };

  FieldEditor.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        renderQuickResponse = _b.renderQuickResponse,
        quickResponsesApi = _b.quickResponsesApi,
        sendOnEnter = _b.sendOnEnter,
        placeholder = _b.placeholder,
        allowInlineAttachments = _b.allowInlineAttachments,
        allowAttachments = _b.allowAttachments,
        attachmentsFields = _b.attachmentsFields,
        allowFormatting = _b.allowFormatting,
        attachments = _b.attachments,
        isAttachmentsUploading = _b.isAttachmentsUploading,
        hideSendOnEnterToggle = _b.hideSendOnEnterToggle,
        _c = _b.editorWindow,
        editorWindow = _c === void 0 ? window : _c,
        languages = _b.languages;
    var _d = this.state,
        lastSelection = _d.lastSelection,
        htmlOld = _d.htmlOld;
    var rootClass = classnames((_a = {}, _a[styles$1b.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, /*#__PURE__*/React.createElement(Dropzone$1, {
      className: styles$1b.editorWrap,
      onAddInline: this.handleInlineUpload,
      onAddAttachment: this.handleAttachmentUpload,
      attachments: Array.isArray(attachments) ? attachments : [],
      allowInlineAttachments: allowInlineAttachments,
      allowAttachments: allowAttachments
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.editorRef,
      onPaste: this.handlePaste,
      onKeyDown: this.handleKeyDown,
      onInput: this.onInput,
      onKeyUp: this.handleKeyUp,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onMouseOver: this.handleMouseOver,
      className: styles$1b.editor,
      contentEditable: true
    }), !this.hasContent(htmlOld) && !!placeholder && /*#__PURE__*/React.createElement("span", {
      className: styles$1b.placeholder
    }, placeholder)), /*#__PURE__*/React.createElement("div", {
      className: styles$1b.toolbar
    }, allowFormatting && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StylingMenu, {
      isActive: this.isStylingActive(),
      editor: this.editor,
      editorWindow: editorWindow
    }), /*#__PURE__*/React.createElement(LinkButton, {
      editor: this.editor,
      editorWindow: editorWindow
    })), allowInlineAttachments && /*#__PURE__*/React.createElement(ToolbarButton, {
      className: allowFormatting ? styles$1b.toolbarGap : '',
      icon: "upload",
      onMouseDown: this.openFileBrowser
    }), allowAttachments && /*#__PURE__*/React.createElement(AttachmentButton, {
      className: allowFormatting && !allowInlineAttachments ? styles$1b.toolbarGap : '',
      dropdownRef: this.attachmentDropdownButtonRef,
      onAttachFiles: this.handleAttachmentUpload,
      attachments: Array.isArray(attachments) ? attachments : [],
      isAttachmentsUploading: isAttachmentsUploading,
      onDetachFile: this.handleDetachAttachmentFile,
      editorWindow: editorWindow
    }, attachmentsFields), /*#__PURE__*/React.createElement(Emoji, {
      className: allowAttachments || allowInlineAttachments || allowFormatting ? styles$1b.toolbarGap : '',
      "data-tip": "Emojis",
      insertContent: this.insertContent,
      editor: this.editor
    }), !!quickResponsesApi && !!renderQuickResponse && /*#__PURE__*/React.createElement(QuickResponseSelector, {
      languages: languages,
      renderQuickResponse: renderQuickResponse,
      quickResponsesApi: quickResponsesApi,
      editor: this.editor,
      insertContent: this.insertContent,
      editorWindow: editorWindow,
      sanitize: this.sanitize,
      lastSelection: lastSelection
    }), !hideSendOnEnterToggle && /*#__PURE__*/React.createElement(ToolbarButton, {
      className: styles$1b.toolbarGap,
      isActive: sendOnEnter,
      onMouseDown: this.handleToggleSendOnEnter,
      icon: "enter"
    })), /*#__PURE__*/React.createElement("input", {
      tabIndex: -1,
      ref: this.fileInputRef,
      type: "file",
      className: styles$1b.fileInput,
      onChange: this.handleFileSelect,
      multiple: true
    }), /*#__PURE__*/React.createElement(Suggestions, {
      editor: this.editor,
      editorWindow: editorWindow
    }));
  };

  FieldEditor.defaultProps = {
    languages: [],
    onTriggerSend: function onTriggerSend() {
      // eslint-disable-next-line no-console
      console.warn('FieldEditor: onTriggerSend callback missing in props');
    },
    onToggleSendOnEnter: noop$1,
    sendOnEnter: false,
    editorWindow: window,
    onMount: noop$1,
    onUnmount: noop$1
  };
  return FieldEditor;
}(React.PureComponent);

var css_248z$1t = "@-webkit-keyframes fieldRichText--fieldRichText__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldRichText--fieldRichText__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldRichText--fieldRichText__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldRichText--fieldRichText__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldRichText--fieldRichText__editorContainer {\n  width: 100%;\n  height: 150px;\n  border: 1px solid #e3e4e6;\n  border-radius: 6px;\n  padding: 8px; }\n\n.fieldRichText--fieldRichText__editor {\n  width: inherit;\n  height: inherit;\n  margin: 0; }\n";
var styles$1k = {"editorContainer":"fieldRichText--fieldRichText__editorContainer","editor":"fieldRichText--fieldRichText__editor","wiggle":"fieldRichText--fieldRichText__wiggle","spin":"fieldRichText--fieldRichText__spin"};
styleInject(css_248z$1t);

var FieldRichText =
/** @class */
function (_super) {
  __extends(FieldRichText, _super);

  function FieldRichText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldRichText.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  FieldRichText.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  FieldRichText.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        label = _a.label,
        meta = _a.meta,
        placeholder = _a.placeholder,
        required = _a.required,
        disabled = _a.disabled,
        editorProps = _a.editorProps,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        otherProps = __rest(_a, ["className", "input", "label", "meta", "placeholder", "required", "disabled", "editorProps", "helpIconText", "helpIconTitle"]);

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: className
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      required: required,
      fieldId: input.name,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1k.editorContainer
    }, /*#__PURE__*/React.createElement(FieldEditor, __assign({
      className: styles$1k.editor,
      allowFormatting: true,
      hideSendOnEnterToggle: true,
      meta: meta,
      input: input,
      onTriggerSend: function onTriggerSend() {
        /* do nothing */
      }
    }, editorProps)))));
  };

  return FieldRichText;
}(React.PureComponent);

var css_248z$1u = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldAlert--fieldAlert__root {\n  display: flex;\n  height: 16px;\n  line-height: 16px;\n  white-space: nowrap; }\n\n.fieldAlert--fieldAlert__alert {\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.fieldAlert--fieldAlert__icon {\n  min-width: 16px;\n  margin-right: 8px; }\n";
var styles$1l = {"root":"fieldAlert--fieldAlert__root","alert":"fieldAlert--fieldAlert__alert","icon":"fieldAlert--fieldAlert__icon"};
styleInject(css_248z$1u);

var STATUS_ICONS_MAPPING = {
  error: 'exclamation-circle-filled',
  warning: 'exclamation-triangle-filled',
  success: 'check-circle-filled',
  title: null
};

var FieldAlert =
/** @class */
function (_super) {
  __extends(FieldAlert, _super);

  function FieldAlert() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldAlert.prototype.renderIcon = function () {
    var variant = this.props.variant;
    var iconName = STATUS_ICONS_MAPPING[variant];

    if (!iconName) {
      return null;
    }

    return /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$1l.icon,
      name: iconName
    });
  };

  FieldAlert.prototype.renderChildren = function () {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$1l.alert
    }, children);
  };

  FieldAlert.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        otherProps = __rest(_a, ["children", "className"]);

    var rootClass = classnames(styles$1l.root, className);
    return /*#__PURE__*/React.createElement(Text.Input, __assign({}, otherProps, {
      className: rootClass
    }), this.renderIcon(), this.renderChildren());
  };

  FieldAlert.defaultProps = {
    variant: 'title'
  };
  return FieldAlert;
}(PureComponent);

var css_248z$1v = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n@-webkit-keyframes fieldLabel--fieldLabel__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n@keyframes fieldLabel--fieldLabel__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldLabel--fieldLabel__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldLabel--fieldLabel__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldLabel--fieldLabel__root {\n  display: flex;\n  height: 16px;\n  justify-content: space-between;\n  justify-self: center;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #46597C;\n  letter-spacing: -0.08px; }\n\n.fieldLabel--fieldLabel__label {\n  display: flex;\n  align-items: center; }\n\n.fieldLabel--fieldLabel__optional {\n  display: flex;\n  align-items: center;\n  font-weight: 400; }\n\n.fieldLabel--fieldLabel__helpIcon {\n  margin-left: 8px;\n  padding: 0;\n  color: #46597C; }\n";
var styles$1m = {"root":"fieldLabel--fieldLabel__root","label":"fieldLabel--fieldLabel__label","optional":"fieldLabel--fieldLabel__optional","helpIcon":"fieldLabel--fieldLabel__helpIcon","wiggle":"fieldLabel--fieldLabel__wiggle","spin":"fieldLabel--fieldLabel__spin"};
styleInject(css_248z$1v);

var fieldLabelTestId = 'fieldLabel';

var FieldLabel =
/** @class */
function (_super) {
  __extends(FieldLabel, _super);

  function FieldLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldLabel.prototype.render = function () {
    var _a = this.props,
        optional = _a.optional,
        optionalText = _a.optionalText,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        className = _a.className,
        children = _a.children,
        otherProps = __rest(_a, ["optional", "optionalText", "helpIconText", "helpIconTitle", "className", "children"]);

    var rootClass = classnames(styles$1m.root, className);
    return /*#__PURE__*/React.createElement("label", __assign({
      className: rootClass
    }, otherProps, {
      "data-testid": fieldLabelTestId
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$1m.label
    }, children, !!helpIconText && /*#__PURE__*/React.createElement(HelpIcon, {
      text: helpIconText,
      title: helpIconTitle,
      className: styles$1m.helpIcon
    })), optional && /*#__PURE__*/React.createElement("span", {
      className: styles$1m.optional
    }, optionalText));
  };

  FieldLabel.defaultProps = {
    optionalText: 'Optional'
  };
  return FieldLabel;
}(PureComponent);

var css_248z$1w = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldWrapper--fieldWrapper__rootDisabled {\n  pointer-events: none; }\n\n.fieldWrapper--fieldWrapper__label {\n  margin-bottom: 8px; }\n  .fieldWrapper--fieldWrapper__rootDisabled .fieldWrapper--fieldWrapper__label {\n    opacity: 0.5; }\n\n.fieldWrapper--fieldWrapper__alert {\n  margin-top: 4px; }\n  .fieldWrapper--fieldWrapper__rootDisabled .fieldWrapper--fieldWrapper__alert {\n    opacity: 0.5; }\n";
var styles$1n = {"rootDisabled":"fieldWrapper--fieldWrapper__rootDisabled","label":"fieldWrapper--fieldWrapper__label","alert":"fieldWrapper--fieldWrapper__alert"};
styleInject(css_248z$1w);

var fieldWrapperTestId = 'fieldWrapper';

var FieldWrapper =
/** @class */
function (_super) {
  __extends(FieldWrapper, _super);

  function FieldWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldWrapper.hasStatus = function (meta, status) {
    if (meta === null || meta === void 0 ? void 0 : meta[status]) {
      return (meta === null || meta === void 0 ? void 0 : meta.touched) === undefined || meta.touched === true;
    }

    return false;
  };

  FieldWrapper.getStatusMessage = function (meta, status) {
    if (this.hasStatus(meta, status)) {
      return meta === null || meta === void 0 ? void 0 : meta[status];
    }

    return undefined;
  };

  FieldWrapper.getStatus = function (meta) {
    return FieldWrapper.hasStatus(meta, 'error') ? 'error' : FieldWrapper.hasStatus(meta, 'warning') ? 'warning' : FieldWrapper.hasStatus(meta, 'success') ? 'success' : undefined;
  };

  FieldWrapper.prototype.renderAlerts = function () {
    var _a = this.props,
        meta = _a.meta,
        description = _a.description;
    var message = description;
    var variant;

    if (FieldWrapper.hasStatus(meta, 'error')) {
      message = FieldWrapper.getStatusMessage(meta, 'error');
      variant = 'error';
    } else if (FieldWrapper.hasStatus(meta, 'warning')) {
      message = FieldWrapper.getStatusMessage(meta, 'warning');
      variant = 'warning';
    } else if (FieldWrapper.hasStatus(meta, 'success')) {
      message = FieldWrapper.getStatusMessage(meta, 'success');
      variant = 'success';
    }

    return /*#__PURE__*/React.createElement(FieldAlert, {
      variant: variant,
      className: styles$1n.alert
    }, message);
  };

  FieldWrapper.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        labelFor = _b.labelFor,
        label = _b.label,
        meta = _b.meta,
        required = _b.required,
        disabled = _b.disabled,
        helpIconText = _b.helpIconText,
        helpIconTitle = _b.helpIconTitle,
        children = _b.children,
        otherProps = __rest(_b, ["className", "labelFor", "label", "meta", "required", "disabled", "helpIconText", "helpIconTitle", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$1n.rootDisabled] = disabled, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({
      "data-testid": fieldWrapperTestId
    }, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(FieldLabel, {
      optional: !required,
      htmlFor: labelFor,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle,
      className: styles$1n.label
    }, label), children, this.renderAlerts());
  };

  return FieldWrapper;
}(PureComponent);

var FieldSelect =
/** @class */
function (_super) {
  __extends(FieldSelect, _super);

  function FieldSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    return _this;
  }

  FieldSelect.prototype.getSelectedItems = function () {
    var _a = this.props,
        value = _a.input.value,
        items = _a.items;
    var isValidValue = value !== null && value !== undefined && (items === null || items === void 0 ? void 0 : items.some(function (item) {
      return item.id === value;
    }));
    return isValidValue ? [value] : [];
  };

  FieldSelect.prototype.handleSelect = function (value) {
    var onChange = this.props.input.onChange;

    if (typeof onChange === 'function') {
      onChange(value === null ? '' : value.id.toString());
    }
  };

  FieldSelect.prototype.handleClear = function () {
    this.handleSelect(null);
  };

  FieldSelect.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        meta = _a.meta,
        label = _a.label,
        required = _a.required,
        disabled = _a.disabled,
        description = _a.description,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        selectProps = __rest(_a, ["className", "input", "meta", "label", "required", "disabled", "description", "helpIconText", "helpIconTitle"]);

    return /*#__PURE__*/React.createElement(FieldWrapper, {
      className: className,
      label: label,
      labelFor: input.name,
      meta: meta,
      required: required,
      disabled: disabled,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle,
      description: description
    }, /*#__PURE__*/React.createElement(Select, __assign({}, selectProps, {
      id: input.name,
      disabled: disabled,
      selectedItems: this.getSelectedItems(),
      onSelect: this.handleSelect,
      onClear: this.handleClear,
      status: FieldWrapper.getStatus(meta)
    })));
  };

  return FieldSelect;
}(React.PureComponent);

var css_248z$1x = ".fieldSelectNew--fieldSelectNew__select {\n  width: 100%;\n  display: flex; }\n";
var styles$1o = {"select":"fieldSelectNew--fieldSelectNew__select"};
styleInject(css_248z$1x);

var FieldSelectNew =
/** @class */
function (_super) {
  __extends(FieldSelectNew, _super);

  function FieldSelectNew(props) {
    var _this = _super.call(this, props) || this;

    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    return _this;
  }

  FieldSelectNew.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  FieldSelectNew.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta.error;
    }

    return undefined;
  };

  FieldSelectNew.prototype.getSelectedItems = function () {
    var _a = this.props,
        value = _a.input.value,
        items = _a.items;
    var isValidValue = value !== null && value !== undefined && (items === null || items === void 0 ? void 0 : items.some(function (item) {
      return item.id === value;
    }));
    return isValidValue ? [value] : [];
  };

  FieldSelectNew.prototype.handleSelect = function (value) {
    var onChange = this.props.input.onChange;

    if (typeof onChange === 'function') {
      onChange(value === null ? '' : value.id.toString());
    }
  };

  FieldSelectNew.prototype.handleClear = function () {
    this.handleSelect(null);
  };

  FieldSelectNew.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        meta = _a.meta,
        label = _a.label,
        required = _a.required,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        selectProps = __rest(_a, ["className", "input", "meta", "label", "required", "helpIconText", "helpIconTitle"]);

    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", {
      className: rootClass
    }, /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      required: required,
      fieldId: input.name,
      errorMessage: this.getErrorMessage(),
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, /*#__PURE__*/React.createElement(Select, __assign({}, selectProps, {
      id: input.name,
      selectedItems: this.getSelectedItems(),
      onSelect: this.handleSelect,
      onClear: this.handleClear,
      className: styles$1o.select
    }))));
  };

  return FieldSelectNew;
}(React.PureComponent);

/**
 * Do not edit directly
 * Generated on Wed, 02 Dec 2020 11:29:56 GMT
 */
const COLOR_PURPLE_500 = "#5644d8";
const COLOR_NEUTRAL_200 = "#e7ecf3";

var css_248z$1y = "@-webkit-keyframes fieldSlider--fieldSlider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldSlider--fieldSlider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldSlider--fieldSlider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldSlider--fieldSlider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldSlider--fieldSlider__root {\n  box-sizing: border-box; }\n\n.fieldSlider--fieldSlider__rangeInput {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 100%;\n  height: 4px;\n  padding: 0;\n  border-radius: 4px;\n  background-color: #d7dfea;\n  outline: none;\n  cursor: pointer; }\n\n/*Chrome thumb*/\n.fieldSlider--fieldSlider__rangeInput::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-border-radius: 50%;\n  /*16x16px adjusted to be same as 12x12px on moz*/\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background: #5644d8; }\n\n.fieldSlider--fieldSlider__rangeInput:focus::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n\n/*Mozilla thumb*/\n.fieldSlider--fieldSlider__rangeInput::-moz-range-thumb {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -moz-border-radius: 50%;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #5644d8; }\n\n.fieldSlider--fieldSlider__rangeIndicator,\n.fieldSlider--fieldSlider__valueIndicator {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px; }\n\n.fieldSlider--fieldSlider__rangeIndicator {\n  color: #bbb; }\n\n.fieldSlider--fieldSlider__valueIndicator {\n  margin: 8px 0 0 8px; }\n";
var styles$1p = {"root":"fieldSlider--fieldSlider__root","rangeInput":"fieldSlider--fieldSlider__rangeInput","rangeIndicator":"fieldSlider--fieldSlider__rangeIndicator","valueIndicator":"fieldSlider--fieldSlider__valueIndicator","wiggle":"fieldSlider--fieldSlider__wiggle","spin":"fieldSlider--fieldSlider__spin"};
styleInject(css_248z$1y);

function getValueRatio(value, min, max) {
  return ((value - min) / (max - min)).toFixed(2);
}

function getLinearGradientCSS(ratio, leftColor, rightColor) {
  return ['-webkit-gradient(', 'linear, ', 'left top, ', 'right top, ', 'color-stop(' + ratio + ', ' + leftColor + '), ', 'color-stop(' + ratio + ', ' + rightColor + ')', ')'].join('');
}

function updateSliderEl(sliderEl) {
  var ratio = getValueRatio(sliderEl.value, sliderEl.min, sliderEl.max);
  sliderEl.style.backgroundImage = getLinearGradientCSS(ratio, COLOR_PURPLE_500, COLOR_NEUTRAL_200);
}

var FieldSlider =
/** @class */
function (_super) {
  __extends(FieldSlider, _super);

  function FieldSlider(props) {
    var _this = _super.call(this, props) || this;

    _this.sliderRef = /*#__PURE__*/React.createRef();
    _this.initSliderEl = _this.initSliderEl.bind(_this);
    return _this;
  }

  FieldSlider.prototype.componentDidMount = function () {
    this.initSliderEl();
  };

  FieldSlider.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  FieldSlider.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  FieldSlider.prototype.initSliderEl = function () {
    var sliderEl = this.sliderRef.current;

    if (sliderEl) {
      updateSliderEl(sliderEl);
      sliderEl.addEventListener('input', function (e) {
        updateSliderEl(e.target);
      });
    }
  };

  FieldSlider.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        label = _a.label,
        required = _a.required,
        disabled = _a.disabled,
        min = _a.min,
        max = _a.max,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        valuePrefix = _a.valuePrefix,
        valueSuffix = _a.valueSuffix,
        otherProps = __rest(_a, ["className", "input", "label", "required", "disabled", "min", "max", "helpIconText", "helpIconTitle", "valuePrefix", "valueSuffix"]);

    var rootClass = classnames(styles$1p.root, className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      required: required,
      fieldId: input.name,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, /*#__PURE__*/React.createElement(FlexBox, {
      justifyContent: "space-between",
      alignItems: "top",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement("input", __assign({
      type: "range"
    }, input, {
      id: input.name,
      min: min,
      max: max,
      className: styles$1p.rangeInput,
      ref: this.sliderRef
    })), /*#__PURE__*/React.createElement(FlexBox, {
      width: "100%",
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$1p.rangeIndicator
    }, valuePrefix, min, valueSuffix), /*#__PURE__*/React.createElement("span", {
      className: styles$1p.rangeIndicator
    }, valuePrefix, max, valueSuffix))), /*#__PURE__*/React.createElement("div", {
      className: styles$1p.valueIndicator
    }, valuePrefix, input.value, valueSuffix))));
  };

  FieldSlider.defaultProps = {
    min: 0,
    max: 100,
    valuePrefix: '',
    valueSuffix: ''
  };
  return FieldSlider;
}(PureComponent);

var css_248z$1z = "@-webkit-keyframes switch--switch__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes switch--switch__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes switch--switch__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes switch--switch__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.switch--switch__input {\n  position: absolute;\n  opacity: 0;\n  left: -99999px; }\n\n.switch--switch__inner {\n  display: flex;\n  background: #d7dfea;\n  height: 16px;\n  max-height: 16px;\n  width: 32px;\n  max-width: 32px;\n  border-radius: 18px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.2s ease-out;\n  transition-delay: 0.1s; }\n  .switch--switch__inner:hover {\n    background-color: #b5c1d4; }\n  .switch--switch__inner .switch--switch__input:focus, .switch--switch__input:focus-within + .switch--switch__inner {\n    box-shadow: 0 0 0 2px #c1b9f8; }\n  .switch--switch__input:disabled + .switch--switch__inner {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none; }\n  .switch--switch__input:checked + .switch--switch__inner {\n    background-color: #5644d8; }\n    .switch--switch__input:checked + .switch--switch__inner::before {\n      transform: translate3d(16px, 0, 0); }\n  .switch--switch__input:checked + .switch--switch__inner:hover,\n  .switch--switch__input:checked:disabled + .switch--switch__inner {\n    background-color: #392aa7; }\n  .switch--switch__inner::before {\n    content: '';\n    position: absolute;\n    display: block;\n    top: 2px;\n    left: 2px;\n    width: 12px;\n    height: 12px;\n    background: #ffffff;\n    transition: transform 0.2s cubic-bezier(1, -0.27, 0.51, 1.16);\n    will-change: transform;\n    transform-origin: left center;\n    box-shadow: 0px 8px 16px rgba(97, 118, 152, 0.1), 0px 4px 8px rgba(97, 118, 152, 0.04);\n    border-radius: 50%; }\n";
var styles$1q = {"input":"switch--switch__input","inner":"switch--switch__inner","wiggle":"switch--switch__wiggle","spin":"switch--switch__spin"};
styleInject(css_248z$1z);

var testIds = {
  input: 'Switch-input',
  label: 'Switch-label'
};

var Switch =
/** @class */
function (_super) {
  __extends(Switch, _super);

  function Switch() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Switch.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        className = _a.className,
        otherProps = __rest(_a, ["id", "className"]);

    var fieldId = id || "switch_" + Math.random();
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("input", __assign({}, otherProps, {
      id: fieldId,
      type: "checkbox",
      className: styles$1q.input,
      "data-testid": testIds.input
    })), /*#__PURE__*/React.createElement("label", {
      htmlFor: fieldId,
      className: styles$1q.inner,
      "data-testid": testIds.label
    }));
  };

  return Switch;
}(PureComponent);

var FieldSwitch =
/** @class */
function (_super) {
  __extends(FieldSwitch, _super);

  function FieldSwitch() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldSwitch.prototype.render = function () {
    var _a = this.props,
        input = _a.input,
        restOfProps = __rest(_a, ["input"]);

    var ref = input.ref,
        inputProps = __rest(input, ["ref"]);

    return /*#__PURE__*/React.createElement(Switch, __assign({}, inputProps, restOfProps));
  };

  return FieldSwitch;
}(PureComponent);

var getValueAsNumber = function getValueAsNumber(value, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = 0;
  }

  if (!value) {
    return defaultValue;
  }

  if (typeof value === 'number') {
    return value;
  }

  var number = parseFloat(value);

  if (isNaN(number)) {
    return defaultValue;
  }

  return number;
};

var css_248z$1A = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.inputNumberArrows--inputNumberArrows__root {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 3px;\n  width: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n\n.inputNumberArrows--inputNumberArrows__button {\n  display: flex;\n  padding: 0;\n  border: none;\n  outline: none;\n  height: 16px;\n  width: 16px;\n  background-color: #f5f7fa;\n  color: #45587c; }\n  .inputNumberArrows--inputNumberArrows__button:active {\n    background-color: #e7ecf3; }\n  .inputNumberArrows--inputNumberArrows__buttonUp {\n    border-radius: 2px 2px 0 0; }\n  .inputNumberArrows--inputNumberArrows__buttonDown {\n    border-radius: 0 0 2px 2px; }\n\n.inputNumberArrows--inputNumberArrows__spacer {\n  flex: 0 0 1px; }\n";
var styles$1r = {"root":"inputNumberArrows--inputNumberArrows__root","button":"inputNumberArrows--inputNumberArrows__button","buttonUp":"inputNumberArrows--inputNumberArrows__buttonUp","buttonDown":"inputNumberArrows--inputNumberArrows__buttonDown","spacer":"inputNumberArrows--inputNumberArrows__spacer"};
styleInject(css_248z$1A);

var INPUT_NUMBER_CHANGE_INTERVAL = 50;
var INPUT_NUMBER_CHANGE_STARTER_TIMEOUT = 300;
var inputNumberArrowsTestId = 'inputNumberArrowsTestId';

var InputNumberArrows =
/** @class */
function (_super) {
  __extends(InputNumberArrows, _super);

  function InputNumberArrows(props) {
    var _this = _super.call(this, props) || this;

    _this.intervalId = null;
    _this.timeoutId = null;
    _this.increaseValue = _this.increaseValue.bind(_this);
    _this.decreaseValue = _this.decreaseValue.bind(_this);
    _this.startIncreaseValue = _this.startIncreaseValue.bind(_this);
    _this.startDecreaseValue = _this.startDecreaseValue.bind(_this);
    _this.stopChangeValue = _this.stopChangeValue.bind(_this);
    return _this;
  }

  InputNumberArrows.prototype.componentDidMount = function () {
    window.addEventListener('mouseup', this.stopChangeValue);
  };

  InputNumberArrows.prototype.componentWillUnmount = function () {
    window.removeEventListener('mouseup', this.stopChangeValue);
  };

  InputNumberArrows.prototype.getNewValue = function (changeType) {
    var _a = this.props,
        step = _a.step,
        min = _a.min,
        max = _a.max,
        current = _a.inputRef.current;

    if (!current) {
      return 0;
    }

    var currentValue = getValueAsNumber(current.value);
    var stepValue = getValueAsNumber(step, 1);
    var minValue = getValueAsNumber(min, Number.MIN_SAFE_INTEGER);
    var maxValue = getValueAsNumber(max, Number.MAX_SAFE_INTEGER);

    if (changeType == 'decrease') {
      return Math.max(currentValue - stepValue, minValue);
    }

    return Math.min(currentValue + stepValue, maxValue);
  };

  InputNumberArrows.prototype.startIncreaseValue = function () {
    var _this = this;

    this.timeoutId = setTimeout(function () {
      return _this.startChangeValue('increase');
    }, INPUT_NUMBER_CHANGE_STARTER_TIMEOUT);
  };

  InputNumberArrows.prototype.startDecreaseValue = function () {
    var _this = this;

    this.timeoutId = setTimeout(function () {
      return _this.startChangeValue('decrease');
    }, INPUT_NUMBER_CHANGE_STARTER_TIMEOUT);
  };

  InputNumberArrows.prototype.startChangeValue = function (changeType) {
    var _this = this;

    if (!this.intervalId) {
      this.intervalId = setInterval(function () {
        return _this.triggerInputChange(changeType);
      }, INPUT_NUMBER_CHANGE_INTERVAL);
    }
  };

  InputNumberArrows.prototype.stopChangeValue = function () {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  };

  InputNumberArrows.prototype.increaseValue = function () {
    this.triggerInputChange('increase');
  };

  InputNumberArrows.prototype.decreaseValue = function () {
    this.triggerInputChange('decrease');
  };

  InputNumberArrows.prototype.triggerInputChange = function (changeType) {
    var _a;

    var _b = this.props,
        current = _b.inputRef.current,
        readOnly = _b.readOnly;

    if (!current || readOnly) {
      return;
    }

    var value = this.getNewValue(changeType);
    var event = new Event('input', {
      bubbles: true
    });
    var prototype = Object.getPrototypeOf(current);
    var prototypeValueSetter = (_a = Object.getOwnPropertyDescriptor(prototype, 'value')) === null || _a === void 0 ? void 0 : _a.set;
    prototypeValueSetter === null || prototypeValueSetter === void 0 ? void 0 : prototypeValueSetter.call(current, value);
    current.dispatchEvent(event);
    current.focus();
  };

  InputNumberArrows.prototype.render = function () {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$1r.root,
      "data-testid": inputNumberArrowsTestId
    }, /*#__PURE__*/React.createElement("button", {
      className: classnames(styles$1r.button, styles$1r.buttonUp),
      tabIndex: -1,
      onClick: this.increaseValue,
      onMouseDown: this.startIncreaseValue
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-up"
    })), /*#__PURE__*/React.createElement("span", {
      className: styles$1r.spacer
    }), /*#__PURE__*/React.createElement("button", {
      className: classnames(styles$1r.button, styles$1r.buttonDown),
      tabIndex: -1,
      onClick: this.decreaseValue,
      onMouseDown: this.startDecreaseValue
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "angle-down"
    })));
  };

  return InputNumberArrows;
}(PureComponent);

var css_248z$1B = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.inputText--inputText__rootReadOnly {\n  background-color: #f5f7fa; }\n\n.inputText--inputText__container {\n  position: relative;\n  height: 100%;\n  border-radius: inherit;\n  background-color: inherit; }\n  .inputText--inputText__rootHasIcon .inputText--inputText__container {\n    margin-right: 16px; }\n  .inputText--inputText__rootHasIcon.inputText--inputText__rootTypeNumber .inputText--inputText__container {\n    margin-right: 32px; }\n\n.inputText--inputText__input {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  outline: none;\n  box-sizing: border-box;\n  border: 0;\n  border-radius: inherit;\n  color: #132243;\n  padding: 12px 16px;\n  font-family: Open Sans, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.16px;\n  background-color: inherit;\n  /* hide number arrows Chrome, Safari, Edge, Opera */ }\n  .inputText--inputText__input::-webkit-outer-spin-button, .inputText--inputText__input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0; }\n  .inputText--inputText__input[type=number] {\n    padding-right: 20px;\n    /* hide number arrows Firefox */\n    -moz-appearance: textfield; }\n  .inputText--inputText__input::-moz-placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .inputText--inputText__input:-ms-input-placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .inputText--inputText__input::placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .inputText--inputText__input:disabled {\n    background-color: #ffffff; }\n";
var styles$1s = {"rootReadOnly":"inputText--inputText__rootReadOnly","container":"inputText--inputText__container","rootHasIcon":"inputText--inputText__rootHasIcon","rootTypeNumber":"inputText--inputText__rootTypeNumber","input":"inputText--inputText__input"};
styleInject(css_248z$1B);

var inputTextTestId = 'inputText';

var InputText =
/** @class */
function (_super) {
  __extends(InputText, _super);

  function InputText(props) {
    var _this = _super.call(this, props) || this;

    _this.inputRef = /*#__PURE__*/createRef();
    return _this;
  }

  InputText.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        disabled = _b.disabled,
        readOnly = _b.readOnly,
        type = _b.type,
        name = _b.name,
        prefix = _b.prefix,
        suffix = _b.suffix,
        icon = _b.icon,
        status = _b.status,
        min = _b.min,
        max = _b.max,
        step = _b.step,
        inputProps = __rest(_b, ["className", "disabled", "readOnly", "type", "name", "prefix", "suffix", "icon", "status", "min", "max", "step"]);

    var rootClass = classnames(className, (_a = {}, _a[styles$1s.rootTypeNumber] = type === 'number', _a[styles$1s.rootHasIcon] = !!icon, _a[styles$1s.rootReadOnly] = readOnly, _a));
    return /*#__PURE__*/React.createElement(InputWrapper, {
      className: rootClass,
      status: status,
      disabled: disabled,
      prefix: prefix,
      suffix: suffix,
      icon: icon
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1s.container
    }, /*#__PURE__*/React.createElement("input", __assign({
      "data-testid": inputTextTestId,
      dir: "auto",
      id: name,
      name: name,
      ref: this.inputRef
    }, inputProps, {
      min: min,
      max: max,
      step: step,
      type: type,
      disabled: disabled,
      readOnly: readOnly,
      className: styles$1s.input
    })), type === 'number' && /*#__PURE__*/React.createElement(InputNumberArrows, {
      min: min,
      max: max,
      step: step,
      inputRef: this.inputRef,
      readOnly: readOnly
    })));
  };

  InputText.defaultProps = {
    type: 'text'
  };
  return InputText;
}(PureComponent);

var FieldTextV2 =
/** @class */
function (_super) {
  __extends(FieldTextV2, _super);

  function FieldTextV2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldTextV2.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        label = _a.label,
        meta = _a.meta,
        required = _a.required,
        disabled = _a.disabled,
        type = _a.type,
        prefix = _a.prefix,
        suffix = _a.suffix,
        icon = _a.icon,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        otherProps = __rest(_a, ["className", "input", "label", "meta", "required", "disabled", "type", "prefix", "suffix", "icon", "helpIconText", "helpIconTitle"]);

    return /*#__PURE__*/React.createElement(FieldWrapper, __assign({
      className: className,
      label: label,
      labelFor: input.name,
      meta: meta,
      required: required,
      disabled: disabled,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, otherProps), /*#__PURE__*/React.createElement(InputText, __assign({
      prefix: prefix,
      suffix: suffix,
      icon: icon,
      status: FieldWrapper.getStatus(meta)
    }, input, {
      type: type,
      disabled: disabled,
      required: required
    })));
  };

  return FieldTextV2;
}(PureComponent);

var FieldInteger =
/** @class */
function (_super) {
  __extends(FieldInteger, _super);

  function FieldInteger(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  FieldInteger.prototype.handleChange = function (e) {
    this.props.input.onChange(this.removeForbiddenChars(e.target.value));
  };

  FieldInteger.prototype.removeForbiddenChars = function (value) {
    var result = '';

    for (var index = 0; index < value.length; index++) {
      if (this.charIsAllowed(value[index], index)) {
        result += value[index];
      }
    }

    return result;
  };

  FieldInteger.prototype.charIsAllowed = function (char, index) {
    var digitRegex = /[0-9]/g;
    var digitOrDashRegex = /-|[0-9]/g;

    if (this.props.allowNegativeNumbers) {
      if (index === 0) {
        return digitOrDashRegex.test(char);
      } else {
        return digitRegex.test(char);
      }
    } else {
      return digitRegex.test(char);
    }
  };

  FieldInteger.prototype.render = function () {
    var _a = this.props,
        allowNegativeNumbers = _a.allowNegativeNumbers,
        fieldTextProps = __rest(_a, ["allowNegativeNumbers"]);

    var props = __assign(__assign({}, fieldTextProps), {
      input: __assign(__assign({}, fieldTextProps.input), {
        onChange: this.handleChange
      })
    });

    return /*#__PURE__*/React.createElement(FieldText, __assign({}, props));
  };

  FieldInteger.defaultProps = {
    allowNegativeNumbers: true
  };
  return FieldInteger;
}(React.PureComponent);

var css_248z$1C = "@-webkit-keyframes fieldTextarea--fieldTextarea__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldTextarea--fieldTextarea__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldTextarea--fieldTextarea__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldTextarea--fieldTextarea__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldTextarea--fieldTextarea__input {\n  border: 1px solid #e3e4e6;\n  border-radius: 6px;\n  padding: 8px;\n  box-sizing: border-box;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  display: block;\n  width: 100%;\n  outline: none;\n  transition: all 0.15s ease-out;\n  resize: none;\n  height: 160px; }\n  .fieldTextarea--fieldTextarea__input::-moz-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldTextarea--fieldTextarea__input:-ms-input-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldTextarea--fieldTextarea__input::placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldTextarea--fieldTextarea__input::-ms-input-placeholder {\n    color: #bbb; }\n  .fieldTextarea--fieldTextarea__input:focus {\n    border-color: #5644d8;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n  .fieldTextarea--fieldTextarea__rootHasError .fieldTextarea--fieldTextarea__input {\n    border-color: #d8484d; }\n    .fieldTextarea--fieldTextarea__rootHasError .fieldTextarea--fieldTextarea__input:focus {\n      border-color: #d8484d;\n      box-shadow: 0 0 0 3px rgba(216, 72, 77, 0.3); }\n";
var styles$1t = {"input":"fieldTextarea--fieldTextarea__input","rootHasError":"fieldTextarea--fieldTextarea__rootHasError","wiggle":"fieldTextarea--fieldTextarea__wiggle","spin":"fieldTextarea--fieldTextarea__spin"};
styleInject(css_248z$1C);

var FieldTextarea =
/** @class */
function (_super) {
  __extends(FieldTextarea, _super);

  function FieldTextarea() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldTextarea.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  FieldTextarea.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  FieldTextarea.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        input = _b.input,
        label = _b.label,
        meta = _b.meta,
        placeholder = _b.placeholder,
        required = _b.required,
        disabled = _b.disabled,
        otherProps = __rest(_b, ["className", "input", "label", "meta", "placeholder", "required", "disabled"]);

    var rootClass = classnames((_a = {}, _a[styles$1t.rootHasError] = this.hasError(), _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      required: required,
      fieldId: input.name
    }, /*#__PURE__*/React.createElement("textarea", __assign({
      className: styles$1t.input
    }, input, {
      id: input.name,
      placeholder: placeholder,
      disabled: disabled
    }))));
  };

  return FieldTextarea;
}(PureComponent);

var css_248z$1D = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.textarea--textarea__inputWrapper {\n  min-height: 40px;\n  height: auto; }\n\n.textarea--textarea__input {\n  display: block;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  height: 140px;\n  min-height: 40px;\n  resize: none;\n  outline: none;\n  box-sizing: border-box;\n  border: 0;\n  border-radius: inherit;\n  color: #132243;\n  padding: 12px 16px;\n  font-family: Open Sans, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.16px;\n  background-color: inherit; }\n  .textarea--textarea__input::-moz-placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .textarea--textarea__input:-ms-input-placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .textarea--textarea__input::placeholder {\n    color: #8193b0;\n    opacity: 1; }\n  .textarea--textarea__input:disabled {\n    background-color: #ffffff; }\n  .textarea--textarea__input:-moz-read-only {\n    background-color: #f5f7fa; }\n  .textarea--textarea__input:read-only {\n    background-color: #f5f7fa; }\n";
var styles$1u = {"inputWrapper":"textarea--textarea__inputWrapper","input":"textarea--textarea__input"};
styleInject(css_248z$1D);

var textareaTestId = 'textarea';

var Textarea =
/** @class */
function (_super) {
  __extends(Textarea, _super);

  function Textarea() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Textarea.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        disabled = _a.disabled,
        readOnly = _a.readOnly,
        name = _a.name,
        prefix = _a.prefix,
        suffix = _a.suffix,
        icon = _a.icon,
        status = _a.status,
        height = _a.height,
        style = _a.style,
        textareaProps = __rest(_a, ["className", "disabled", "readOnly", "name", "prefix", "suffix", "icon", "status", "height", "style"]);

    var styleWithHeight = __assign(__assign({}, style), {
      height: height
    });

    return /*#__PURE__*/React.createElement(InputWrapper, {
      className: styles$1u.inputWrapper,
      status: status,
      disabled: disabled,
      prefix: prefix,
      suffix: suffix,
      icon: icon
    }, /*#__PURE__*/React.createElement("textarea", __assign({
      "data-testid": textareaTestId,
      className: styles$1u.input,
      dir: "auto",
      id: name
    }, textareaProps, {
      style: styleWithHeight,
      name: name,
      disabled: disabled,
      readOnly: readOnly
    })));
  };

  return Textarea;
}(PureComponent);

var FieldTextareaV2 =
/** @class */
function (_super) {
  __extends(FieldTextareaV2, _super);

  function FieldTextareaV2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldTextareaV2.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        input = _a.input,
        label = _a.label,
        meta = _a.meta,
        required = _a.required,
        disabled = _a.disabled,
        prefix = _a.prefix,
        suffix = _a.suffix,
        icon = _a.icon,
        helpIconText = _a.helpIconText,
        helpIconTitle = _a.helpIconTitle,
        otherProps = __rest(_a, ["className", "input", "label", "meta", "required", "disabled", "prefix", "suffix", "icon", "helpIconText", "helpIconTitle"]);

    return /*#__PURE__*/React.createElement(FieldWrapper, __assign({
      className: className,
      label: label,
      labelFor: input.name,
      meta: meta,
      required: required,
      disabled: disabled,
      helpIconText: helpIconText,
      helpIconTitle: helpIconTitle
    }, otherProps), /*#__PURE__*/React.createElement(Textarea, __assign({
      prefix: prefix,
      suffix: suffix,
      icon: icon,
      status: FieldWrapper.getStatus(meta)
    }, input, {
      disabled: disabled,
      required: required
    })));
  };

  return FieldTextareaV2;
}(PureComponent);

var css_248z$1E = "@-webkit-keyframes variableSelector--variableSelectorItem__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes variableSelector--variableSelectorItem__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes variableSelector--variableSelectorItem__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes variableSelector--variableSelectorItem__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.variableSelector--variableSelectorItem__root {\n  min-width: 300px;\n  border: 0;\n  background: none;\n  text-align: left;\n  line-height: 40px;\n  padding: 0 8px;\n  font-size: 14px;\n  border-top: 1px solid #e3e4e6;\n  color: #5a5a5a;\n  font-weight: 400;\n  outline: 0; }\n  .variableSelector--variableSelectorItem__root:hover, .variableSelector--variableSelectorItem__root:focus {\n    background-color: #f5f5fa; }\n\n.variableSelector--variableSelectorItem__label {\n  background: #f7f7f7;\n  color: #7a7a7a;\n  font-size: 12px;\n  padding: 0 8px;\n  font-weight: 600;\n  line-height: 32px;\n  border-top: 1px solid #e3e4e6; }\n";
var styles$1v = {"root":"variableSelector--variableSelectorItem__root","label":"variableSelector--variableSelectorItem__label","wiggle":"variableSelector--variableSelectorItem__wiggle","spin":"variableSelector--variableSelectorItem__spin"};
styleInject(css_248z$1E);

var VariableSelectorItem =
/** @class */
function (_super) {
  __extends(VariableSelectorItem, _super);

  function VariableSelectorItem(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  VariableSelectorItem.prototype.handleClick = function () {
    var _a = this.props,
        onSelect = _a.onSelect,
        item = _a.item;
    onSelect(item);
  };

  VariableSelectorItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        item = _b.item;

    if ('label' in item) {
      var label = item.label;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$1v.label
      }, label);
    }

    if ('content' in item) {
      var content = item.content;
      var rootClass = classnames((_a = {}, _a[styles$1v.root] = true, _a), className);
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: rootClass,
        onClick: this.handleClick
      }, content);
    }

    return null;
  };

  return VariableSelectorItem;
}(PureComponent);

var VariableSelector =
/** @class */
function (_super) {
  __extends(VariableSelector, _super);

  function VariableSelector(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      search: ''
    };
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    return _this;
  }

  VariableSelector.prototype.getFilteredVariables = function () {
    var variables = this.props.variables;
    var search = this.state.search;
    var items = [];
    variables.forEach(function (group) {
      var filteredItems = group.items.filter(function (variable) {
        if (typeof variable.name === 'string') {
          return variable.name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
        }

        return true;
      }).map(function (variable) {
        return __assign(__assign({
          id: typeof variable.name === 'string' ? variable.name : uuid()
        }, variable), {
          matched: search
        });
      });

      if (filteredItems.length > 0) {
        items.push({
          id: group.label,
          label: group.label,
          name: group.label
        });
        items.push.apply(items, filteredItems);
      }
    });
    return items;
  };

  VariableSelector.prototype.handleSelect = function (variable) {
    var onSelect = this.props.onSelect;

    if ('content' in variable) {
      onSelect(variable.name, variable.content);
    }
  };

  VariableSelector.prototype.handleSearch = function (search) {
    if (search === void 0) {
      search = '';
    }

    this.setState({
      search: search
    });
  };

  VariableSelector.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        variables = _a.variables,
        children = _a.children,
        onSelect = _a.onSelect,
        otherProps = __rest(_a, ["className", "variables", "children", "onSelect"]);

    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(DropdownSelect, {
      itemComponent: VariableSelectorItem,
      items: this.getFilteredVariables(),
      noStyle: true,
      hasSearch: true,
      onSearch: this.handleSearch,
      onSelect: this.handleSelect,
      fixed: true,
      containerProps: {
        style: {
          width: '300px'
        }
      }
    }, children));
  };

  return VariableSelector;
}(PureComponent);

var css_248z$1F = "@-webkit-keyframes fieldToken--fieldToken__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes fieldToken--fieldToken__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes fieldToken--fieldToken__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes fieldToken--fieldToken__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.fieldToken--fieldToken__root {\n  /*! keep */ }\n\n.fieldToken--fieldToken__wrap {\n  width: 100%;\n  display: flex;\n  position: relative; }\n\n.fieldToken--fieldToken__input, .fieldToken--fieldToken__variableContainer {\n  border: 1px solid #e3e4e6;\n  border-radius: 6px;\n  background-color: #fff;\n  height: 40px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  min-width: 0;\n  outline: none;\n  transition: all 0.15s ease-out;\n  vertical-align: bottom; }\n\n.fieldToken--fieldToken__input {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px; }\n  .fieldToken--fieldToken__input::-moz-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldToken--fieldToken__input:-ms-input-placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldToken--fieldToken__input::placeholder {\n    color: #bbb;\n    opacity: 1; }\n  .fieldToken--fieldToken__input::-ms-input-placeholder {\n    color: #bbb; }\n\n.fieldToken--fieldToken__variableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative; }\n\n.fieldToken--fieldToken__variablePill {\n  background-color: #5644d8;\n  border: 0;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  height: 24px;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  transition: background-color 80ms ease-in; }\n  .fieldToken--fieldToken__variablePill:focus {\n    background-color: #897ce3; }\n\n.fieldToken--fieldToken__variableInput {\n  border: 0;\n  outline: 0;\n  margin-left: 2px;\n  width: 100%;\n  flex: 1 1 10px; }\n\n.fieldToken--fieldToken__selection {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  border-radius: 6px;\n  box-sizing: border-box; }\n  .fieldToken--fieldToken__input:focus + .fieldToken--fieldToken__selection,\n  .fieldToken--fieldToken__variablePill:focus ~ .fieldToken--fieldToken__selection,\n  .fieldToken--fieldToken__variableInput:focus ~ .fieldToken--fieldToken__selection {\n    border: 1px solid #5644d8;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n    .fieldToken--fieldToken__rootHasError .fieldToken--fieldToken__input:focus + .fieldToken--fieldToken__selection, .fieldToken--fieldToken__rootHasError\n    .fieldToken--fieldToken__variablePill:focus ~ .fieldToken--fieldToken__selection, .fieldToken--fieldToken__rootHasError\n    .fieldToken--fieldToken__variableInput:focus ~ .fieldToken--fieldToken__selection {\n      border-color: #d8484d;\n      box-shadow: 0 0 0 3px rgba(216, 72, 77, 0.3); }\n\n.fieldToken--fieldToken__icon {\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  font-size: 14px;\n  color: #000; }\n\n.fieldToken--fieldToken__addButton {\n  position: absolute;\n  top: -16px;\n  right: 0;\n  height: 38px;\n  line-height: 40px;\n  width: 32px;\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  outline: 0; }\n  .fieldToken--fieldToken__rootAllowFreetext .fieldToken--fieldToken__addButton {\n    border-left: 1px solid #e3e4e6; }\n";
var styles$1w = {"root":"fieldToken--fieldToken__root","wrap":"fieldToken--fieldToken__wrap","input":"fieldToken--fieldToken__input","variableContainer":"fieldToken--fieldToken__variableContainer","variablePill":"fieldToken--fieldToken__variablePill","variableInput":"fieldToken--fieldToken__variableInput","selection":"fieldToken--fieldToken__selection","rootHasError":"fieldToken--fieldToken__rootHasError","icon":"fieldToken--fieldToken__icon","addButton":"fieldToken--fieldToken__addButton","rootAllowFreetext":"fieldToken--fieldToken__rootAllowFreetext","wiggle":"fieldToken--fieldToken__wiggle","spin":"fieldToken--fieldToken__spin"};
styleInject(css_248z$1F);

var FieldToken =
/** @class */
function (_super) {
  __extends(FieldToken, _super);

  function FieldToken(props) {
    var _this = _super.call(this, props) || this;

    _this.tokenInputRef = /*#__PURE__*/React.createRef();
    _this.tokenButtonRef = /*#__PURE__*/React.createRef();
    _this.addTokenButtonRef = /*#__PURE__*/React.createRef();
    _this.selectToken = _this.selectToken.bind(_this);
    _this.handleOnKeyUp = _this.handleOnKeyUp.bind(_this);
    _this.onTextChange = _this.onTextChange.bind(_this);
    _this.focusVariableInput = _this.focusVariableInput.bind(_this);
    _this.inputKeyDown = _this.inputKeyDown.bind(_this);
    _this.inputClick = _this.inputClick.bind(_this);
    return _this;
  }

  FieldToken.preventDefault = function (event) {
    var key = event.key;

    if (key !== 'Tab') {
      event.preventDefault();
    }
  };

  FieldToken.prototype.componentDidUpdate = function (prevProps) {
    var input = this.props.input;
    var prevIsVariable = this.parseInputValue(prevProps.input.value).isVariable;
    var isVariable = this.parseInputValue(input.value).isVariable;

    if (prevIsVariable && !isVariable && this.tokenInputRef.current !== null) {
      this.tokenInputRef.current.focus();
    }
  };

  FieldToken.prototype.parseInputValue = function (value) {
    var regex = /{{(([^:]*:)?([^}]+))}}/.exec(value);
    var _a = this.props,
        variables = _a.variables,
        allowFreetext = _a.allowFreetext;
    var variablesWithoutCategory = variables.reduce(function (prev, category) {
      return prev.concat(category.items);
    }, []);
    var foundVariable = regex !== null && variablesWithoutCategory.find(function (variable) {
      return variable.name === regex[1];
    });
    var isVariable = !!foundVariable;
    var textValue = allowFreetext && !isVariable || isVariable ? value : '';
    var text = isVariable && regex !== null ? regex[1] : textValue;
    var variableType = isVariable && regex !== null ? regex[2] : null;
    var variableName = isVariable && regex !== null ? regex[3] : null;
    var variableContent = foundVariable ? foundVariable.content : null;
    return {
      isVariable: isVariable,
      text: text,
      variableType: variableType,
      variableName: variableName,
      variableContent: variableContent
    };
  };

  FieldToken.prototype.inputKeyDown = function (event) {
    var allowFreetext = this.props.allowFreetext;

    if (!allowFreetext) {
      event.preventDefault();
      this.inputClick();
    }
  };

  FieldToken.prototype.inputClick = function () {
    var allowFreetext = this.props.allowFreetext;

    if (!allowFreetext && this.addTokenButtonRef && this.addTokenButtonRef.current !== null) {
      this.addTokenButtonRef.current.click();
    }
  };

  FieldToken.prototype.selectToken = function (name) {
    var onChange = this.props.input.onChange;

    if (typeof onChange === 'function') {
      onChange("{{" + name + "}}");
    }
  };

  FieldToken.prototype.handleOnKeyUp = function (event) {
    var key = event.key;

    if (key === 'Backspace') {
      this.removeToken();
    }

    if (key === 'ArrowLeft' && this.tokenButtonRef.current !== null) {
      this.tokenButtonRef.current.focus();
    }

    if (key === 'ArrowRight' && this.tokenInputRef.current !== null) {
      this.tokenInputRef.current.focus();
    }
  };

  FieldToken.prototype.removeToken = function () {
    var onChange = this.props.input.onChange;

    if (typeof onChange === 'function') {
      onChange('');
    }
  };

  FieldToken.prototype.onTextChange = function (event) {
    var _a = this.props.input,
        inputValue = _a.value,
        onChange = _a.onChange;

    if (typeof onChange === 'function' && event.target instanceof HTMLInputElement && event.target.value !== inputValue) {
      if (typeof onChange === 'function') {
        onChange(event.target.value);
      }
    }
  };

  FieldToken.prototype.focusVariableInput = function () {
    if (this.tokenInputRef && this.tokenInputRef.current !== null) {
      this.tokenInputRef.current.focus();
    }
  };

  FieldToken.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  FieldToken.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  FieldToken.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        input = _b.input,
        label = _b.label,
        meta = _b.meta,
        placeholder = _b.placeholder,
        required = _b.required,
        disabled = _b.disabled,
        type = _b.type,
        variables = _b.variables,
        allowFreetext = _b.allowFreetext,
        otherProps = __rest(_b, ["className", "input", "label", "meta", "placeholder", "required", "disabled", "type", "variables", "allowFreetext"]);

    var _c = this.parseInputValue(input.value),
        isVariable = _c.isVariable,
        text = _c.text,
        variableName = _c.variableName,
        variableContent = _c.variableContent;

    var rootClass = classnames((_a = {}, _a[styles$1w.root] = true, _a[styles$1w.rootHasError] = this.hasError(), _a[styles$1w.rootAllowFreetext] = allowFreetext, _a), className);
    var icon = allowFreetext ? 'dropdown-list' : 'angle-down';
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      required: required,
      fieldId: input.name
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1w.wrap
    }, !isVariable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", __assign({
      className: styles$1w.input,
      type: "text",
      ref: this.tokenInputRef
    }, input, {
      value: text,
      onChange: this.onTextChange,
      onKeyDown: this.inputKeyDown,
      onClick: this.inputClick,
      id: input.name,
      placeholder: placeholder,
      disabled: isVariable,
      autoComplete: "off"
    })), /*#__PURE__*/React.createElement("span", {
      className: styles$1w.selection
    })), isVariable && /*#__PURE__*/React.createElement("div", {
      className: styles$1w.variableContainer,
      onClick: this.focusVariableInput
    }, /*#__PURE__*/React.createElement("button", {
      className: styles$1w.variablePill,
      type: "button",
      tabIndex: 0,
      ref: this.tokenButtonRef,
      onKeyUp: this.handleOnKeyUp
    }, variableContent || variableName), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: styles$1w.variableInput,
      ref: this.tokenInputRef,
      onKeyUp: this.handleOnKeyUp,
      onKeyDown: FieldToken.preventDefault,
      autoComplete: "off"
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$1w.selection
    })), /*#__PURE__*/React.createElement(VariableSelector, {
      onSelect: this.selectToken,
      variables: variables
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: styles$1w.addButton,
      ref: this.addTokenButtonRef
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: icon,
      className: "icon-vertical-fix"
    }))))));
  };

  return FieldToken;
}(React.PureComponent);
FieldToken.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  variables: [],
  allowFreetext: false
};

var css_248z$1G = "@-webkit-keyframes infoList--infoList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes infoList--infoList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes infoList--infoList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes infoList--infoList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.infoList--infoList__infoList {\n  margin: 0;\n  max-width: 500px; }\n\n.infoList--infoList__label {\n  padding: 8px 15px 0;\n  font-size: 12px;\n  color: #7a7a7a;\n  white-space: nowrap; }\n\n.infoList--infoList__value {\n  margin: 0;\n  padding: 0 15px 11px;\n  font-size: 14px;\n  color: #393939;\n  overflow-wrap: break-word;\n  white-space: normal;\n  max-width: 400px; }\n  .infoList--infoList__value + .infoList--infoList__label {\n    border-top: 1px solid #e3e4e6; }\n";
var styles$1x = {"infoList":"infoList--infoList__infoList","label":"infoList--infoList__label","value":"infoList--infoList__value","wiggle":"infoList--infoList__wiggle","spin":"infoList--infoList__spin"};
styleInject(css_248z$1G);

/**
 * @deprecated Use the the `<List.KeyValue>` instead.
 */

var InfoList =
/** @class */
function (_super) {
  __extends(InfoList, _super);

  function InfoList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InfoList.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        lines = _b.lines,
        otherProps = __rest(_b, ["className", "lines"]);

    var rootClass = classnames((_a = {}, _a[styles$1x.infoList] = true, _a), className);
    return /*#__PURE__*/React.createElement("dl", __assign({}, otherProps, {
      className: rootClass
    }), lines.map(function (line, index) {
      return line.value ?
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("dt", {
        className: styles$1x.label
      }, line.key), /*#__PURE__*/React.createElement("dd", {
        className: styles$1x.value
      }, line.value)) : null;
    }));
  };

  return InfoList;
}(PureComponent);

var css_248z$1H = "@-webkit-keyframes modal--modal__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes modal--modal__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes modal--modal__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes modal--modal__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.modal--modal__modal {\n  display: none;\n  position: fixed;\n  overflow: auto;\n  overflow-x: hidden;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10500; }\n  .modal--modal__modalDisplayed {\n    display: block; }\n\n.modal--modal__blurry {\n  background-color: rgba(19, 34, 68, 0.2);\n  opacity: 0;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  transition: opacity 0.4s ease; }\n  .modal--modal__modalOpened .modal--modal__blurry {\n    opacity: 1; }\n\n.modal--modal__content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  min-width: 100vw;\n  position: relative;\n  z-index: 2;\n  overflow: visible;\n  opacity: 0;\n  pointer-events: none; }\n  .modal--modal__modalOpened .modal--modal__content {\n    opacity: 1; }\n\n.modal--modal__contentInner {\n  margin: 30px;\n  max-width: 90vw;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 0 1px 0 rgba(15, 31, 66, 0.08), 0 8px 10px 0 rgba(15, 31, 66, 0.1);\n  pointer-events: all; }\n";
var styles$1y = {"modal":"modal--modal__modal","modalDisplayed":"modal--modal__modalDisplayed","blurry":"modal--modal__blurry","modalOpened":"modal--modal__modalOpened","content":"modal--modal__content","contentInner":"modal--modal__contentInner","wiggle":"modal--modal__wiggle","spin":"modal--modal__spin"};
styleInject(css_248z$1H);

var Modal =
/** @class */
function (_super) {
  __extends(Modal, _super);

  function Modal(props) {
    var _this = _super.call(this, props) || this;

    _this.removeKeyDownEventListener = function () {
      window.removeEventListener('keydown', _this.handleKey, true);
      _this.haskeydownEventListner = false;
    };

    _this.rootRef = /*#__PURE__*/React.createRef();
    _this.closeTimer = null;
    _this.state = {
      opened: false,
      displayed: false
    };
    _this.haskeydownEventListner = false;
    _this.animateOpening = _this.animateOpening.bind(_this);
    _this.animateClosing = _this.animateClosing.bind(_this);
    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
    _this.handleKey = _this.handleKey.bind(_this);
    return _this;
  }

  Modal.prototype.componentDidMount = function () {
    var isOpen = this.props.isOpen;

    if (isOpen) {
      this.animateOpening();
    }
  };

  Modal.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        isOpen = _a.isOpen,
        allowEscClose = _a.allowEscClose;
    var prevIsOpen = prevProps.isOpen;

    if (allowEscClose && !this.haskeydownEventListner) {
      window.addEventListener('keydown', this.handleKey, true);
      this.haskeydownEventListner = true;
    }

    if (isOpen !== prevIsOpen) {
      if (isOpen) {
        this.animateOpening();
      } else {
        this.animateClosing();
      }
    }
  };

  Modal.prototype.componentWillUnmount = function () {
    this.removeKeyDownEventListener();
  };

  Modal.prototype.handleKey = function (e) {
    var onClose = this.props.onClose;
    e.preventDefault();

    if (e.key === 'Escape') {
      this.animateClosing();

      if (typeof onClose === 'function') {
        onClose(e);
      }
    }
  };

  Modal.prototype.animateOpening = function () {
    var _this = this;

    this.setState({
      displayed: true
    });
    setTimeout(function () {
      return _this.setState({
        opened: true
      });
    });
  };

  Modal.prototype.animateClosing = function () {
    if (this.rootRef.current) {
      this.rootRef.current.addEventListener('transitionend', this.onTransitionEnd);
    }

    this.removeKeyDownEventListener();
    this.setState({
      opened: false
    });
    this.closeIfNoTransitionOccurred();
  };

  Modal.prototype.closeIfNoTransitionOccurred = function () {
    var _this = this;

    this.closeTimer = setTimeout(function () {
      if (_this.closeTimer) {
        _this.onTransitionEnd();
      }
    }, 400);
  };

  Modal.prototype.onTransitionEnd = function () {
    this.setState({
      displayed: false
    });

    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    if (this.rootRef.current) {
      this.rootRef.current.removeEventListener('transitionend', this.onTransitionEnd);
    }
  };

  Modal.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        isOpen = _b.isOpen,
        children = _b.children,
        onClose = _b.onClose,
        allowClickOutside = _b.allowClickOutside,
        allowEscClose = _b.allowEscClose,
        otherProps = __rest(_b, ["className", "isOpen", "children", "onClose", "allowClickOutside", "allowEscClose"]);

    var _c = this.state,
        displayed = _c.displayed,
        opened = _c.opened;
    var rootClass = classnames((_a = {}, _a[styles$1y.modal] = true, _a[styles$1y.modalDisplayed] = displayed, _a[styles$1y.modalOpened] = opened, _a), className);
    var onClickBlurry = allowClickOutside ? buttonize(onClose) : null;
    return /*#__PURE__*/React.createElement("div", __assign({
      className: rootClass,
      ref: this.rootRef
    }, otherProps), /*#__PURE__*/React.createElement("div", __assign({
      className: styles$1y.blurry
    }, onClickBlurry)), opened &&
    /*#__PURE__*/
    // fixes an issue with child-components that need to measure boundingClientRect
    React.createElement("div", {
      className: styles$1y.content
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1y.contentInner
    }, children)));
  };

  return Modal;
}(PureComponent);

var css_248z$1I = "@-webkit-keyframes roundButton--roundButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes roundButton--roundButton__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes roundButton--roundButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes roundButton--roundButton__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.roundButton--roundButton__root {\n  height: 30px;\n  text-decoration: none;\n  box-shadow: 0 3px 4px rgba(15, 31, 66, 0.08);\n  border-radius: 20px;\n  width: 30px;\n  padding: 0;\n  border: 0;\n  display: inline-block; }\n  .roundButton--roundButton__root:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n\n.roundButton--roundButton__iconContainer {\n  background: #f1f2f4;\n  height: 30px;\n  border: 1px solid #5644d8;\n  line-height: 28px;\n  color: #5644d8;\n  border-radius: 20px;\n  margin-right: 0;\n  margin-left: 0;\n  box-sizing: border-box;\n  width: 30px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  cursor: pointer; }\n";
var styles$1z = {"root":"roundButton--roundButton__root","iconContainer":"roundButton--roundButton__iconContainer","wiggle":"roundButton--roundButton__wiggle","spin":"roundButton--roundButton__spin"};
styleInject(css_248z$1I);

var isAnchor = function isAnchor(props) {
  return 'href' in props;
};

function RoundButton(props) {
  var _a;

  var className = props.className,
      icon = props.icon,
      type = props.type,
      href = props.href,
      otherProps = __rest(props, ["className", "icon", "type", "href"]);

  var rootClass = classnames((_a = {}, _a[styles$1z.root] = true, _a), className);
  var content = /*#__PURE__*/React.createElement("span", {
    className: classnames(styles$1z.iconContainer)
  }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
    name: icon,
    className: classnames('icon-vertical-fix')
  }));

  if (isAnchor(props)) {
    return /*#__PURE__*/React.createElement("a", __assign({
      className: rootClass,
      href: href
    }, otherProps), content);
  }

  return /*#__PURE__*/React.createElement("button", __assign({
    className: rootClass,
    type: type
  }, otherProps), content);
}

var css_248z$1J = "@-webkit-keyframes lightbox--lightbox__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes lightbox--lightbox__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes lightbox--lightbox__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes lightbox--lightbox__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.lightbox--lightbox__lightSource {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  padding: 20px;\n  background: #f1f2f4;\n  min-width: 50vw;\n  min-height: 50vh;\n  max-width: inherit;\n  max-height: inherit; }\n\n.lightbox--lightbox__closeButton {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: #f1f2f4;\n  box-shadow: 0 3px 4px rgba(15, 31, 66, 0.08);\n  border-radius: 100px; }\n\n.lightbox--lightbox__downloadButton {\n  position: absolute;\n  bottom: 16px;\n  right: 16px; }\n\n.lightbox--lightbox__image {\n  width: 100%;\n  -o-object-fit: scale-down;\n     object-fit: scale-down; }\n";
var styles$1A = {"lightSource":"lightbox--lightbox__lightSource","closeButton":"lightbox--lightbox__closeButton","downloadButton":"lightbox--lightbox__downloadButton","image":"lightbox--lightbox__image","wiggle":"lightbox--lightbox__wiggle","spin":"lightbox--lightbox__spin"};
styleInject(css_248z$1J);

var Lightbox =
/** @class */
function (_super) {
  __extends(Lightbox, _super);

  function Lightbox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Lightbox.prototype.render = function () {
    var _a = this.props,
        rootClass = _a.className,
        src = _a.src,
        alt = _a.alt,
        onClose = _a.onClose;
    return /*#__PURE__*/React.createElement(Modal, {
      className: rootClass,
      isOpen: !!src,
      allowClickOutside: true,
      allowEscClose: true,
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1A.lightSource
    }, src && /*#__PURE__*/React.createElement(Image, {
      className: styles$1A.image,
      alt: alt,
      src: src
    }), onClose && /*#__PURE__*/React.createElement(Button$2, {
      onClick: onClose,
      icon: "close",
      outlined: true,
      className: styles$1A.closeButton
    }), src && typeof src === 'string' && /*#__PURE__*/React.createElement(RoundButton, {
      href: src,
      target: "_blank",
      download: true,
      className: styles$1A.downloadButton,
      icon: "cloud-download"
    })));
  };

  return Lightbox;
}(React.PureComponent);

var css_248z$1K = "@-webkit-keyframes linkList--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes linkList--divider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes linkList--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes linkList--divider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.linkList--divider__root {\n  display: block;\n  padding: 4px; }\n\n.linkList--divider__divider {\n  background-color: #e7ecf3; }\n";
var styles$1B = {"root":"linkList--divider__root","divider":"linkList--divider__divider","wiggle":"linkList--divider__wiggle","spin":"linkList--divider__spin"};
styleInject(css_248z$1K);

var Divider$2 =
/** @class */
function (_super) {
  __extends(Divider$1, _super);

  function Divider$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Divider$1.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        otherProps = __rest(_a, ["children", "className"]);

    var rootClass = classnames(styles$1B.root, className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(Divider, {
      className: styles$1B.divider,
      size: "xSmall"
    }));
  };

  return Divider$1;
}(PureComponent);

var css_248z$1L = "@-webkit-keyframes linkList--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes linkList--header__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes linkList--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes linkList--header__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n@-webkit-keyframes linkList--header__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n@keyframes linkList--header__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n.linkList--header__header {\n  display: block;\n  text-align: center;\n  font-style: normal;\n  font-weight: 600;\n  padding: 8px;\n  cursor: default;\n  background-color: #f1f2f4;\n  font-size: 12px;\n  color: #7a7a7a;\n  position: relative;\n  white-space: nowrap;\n  border-radius: 3px; }\n";
var styles$1C = {"header":"linkList--header__header","wiggle":"linkList--header__wiggle","spin":"linkList--header__spin","pulse":"linkList--header__pulse"};
styleInject(css_248z$1L);

var Header$2 =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Header.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        className = _b.className,
        otherProps = __rest(_b, ["children", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$1C.header] = true, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return Header;
}(PureComponent);

var css_248z$1M = "@-webkit-keyframes linkList--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes linkList--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes linkList--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes linkList--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.linkList--item__item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  min-width: 224px;\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer; }\n  .linkList--item__item:hover {\n    background: #f5f7fa; }\n  .linkList--item__item > a {\n    padding: 0;\n    color: inherit;\n    text-decoration: none; }\n    .linkList--item__item > a::before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0; }\n  .linkList--item__itemLoading {\n    pointer-events: none;\n    cursor: not-allowed;\n    -webkit-animation: linkList--item__pulse 1.6s infinite ease-in-out;\n            animation: linkList--item__pulse 1.6s infinite ease-in-out; }\n  .linkList--item__itemDisabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.5; }\n  .linkList--item__itemIconPlaceholder {\n    padding-left: 49px; }\n\n.linkList--item__icon {\n  display: flex;\n  align-items: center;\n  margin-right: 16px; }\n\n@-webkit-keyframes linkList--item__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n\n@keyframes linkList--item__pulse {\n  0% {\n    opacity: 0.3; }\n  50% {\n    opacity: 0.65; }\n  100% {\n    opacity: 0.3; } }\n";
var styles$1D = {"item":"linkList--item__item","itemLoading":"linkList--item__itemLoading","pulse":"linkList--item__pulse","itemDisabled":"linkList--item__itemDisabled","itemIconPlaceholder":"linkList--item__itemIconPlaceholder","icon":"linkList--item__icon","wiggle":"linkList--item__wiggle","spin":"linkList--item__spin"};
styleInject(css_248z$1M);

var Item$1 =
/** @class */
function (_super) {
  __extends(Item, _super);

  function Item() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Item.prototype.render = function () {
    var _a;

    var _b = this.props,
        icon = _b.icon,
        children = _b.children,
        className = _b.className,
        isLoading = _b.isLoading,
        isDisabled = _b.isDisabled,
        iconPlaceholder = _b.iconPlaceholder,
        otherProps = __rest(_b, ["icon", "children", "className", "isLoading", "isDisabled", "iconPlaceholder"]);

    var rootClass = classnames(styles$1D.item, (_a = {}, _a[styles$1D.itemLoading] = isLoading, _a[styles$1D.itemDisabled] = isDisabled, _a[styles$1D.itemIconPlaceholder] = iconPlaceholder, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({}, otherProps, {
      className: rootClass
    }), icon && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$1D.icon,
      name: icon
    }), /*#__PURE__*/React.createElement(Text.Paragraph, {
      variant: "2"
    }, children));
  };

  return Item;
}(PureComponent);

var css_248z$1N = "@-webkit-keyframes linkList--linkList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes linkList--linkList__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes linkList--linkList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes linkList--linkList__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.linkList--linkList__linkList {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  background: #ffffff; }\n\n.linkList--linkList__inner {\n  margin: 0;\n  padding: 0; }\n";
var styles$1E = {"linkList":"linkList--linkList__linkList","inner":"linkList--linkList__inner","wiggle":"linkList--linkList__wiggle","spin":"linkList--linkList__spin"};
styleInject(css_248z$1N);

var LinkList =
/** @class */
function (_super) {
  __extends(LinkList, _super);

  function LinkList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(LinkList, "Item", {
    get: function get() {
      return Item$1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LinkList, "Header", {
    get: function get() {
      return Header$2;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LinkList, "Divider", {
    get: function get() {
      return Divider$2;
    },
    enumerable: false,
    configurable: true
  });

  LinkList.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        otherProps = __rest(_a, ["children", "className"]);

    var rootClass = classnames(styles$1E.linkList, className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("ul", {
      className: styles$1E.inner
    }, children));
  };

  return LinkList;
}(PureComponent);

var css_248z$1O = "@-webkit-keyframes items--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes items--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes items--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes items--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.items--item__root {\n  list-style-type: none;\n  margin: 0;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center; }\n  .items--item__root + .items--item__root {\n    border-top: 1px solid #e3e4e6; }\n\n.items--item__contentLeft {\n  margin-right: 16px;\n  line-height: 16px; }\n\n.items--item__contentRight {\n  line-height: 16px; }\n\n.items--item__titles {\n  margin-right: auto;\n  padding-right: 16px; }\n\n.items--item__title,\n.items--item__titleSecondary {\n  display: block; }\n\n.items--item__title {\n  font-size: 14px;\n  line-height: 16px;\n  color: #000; }\n\n.items--item__titleSecondary {\n  font-size: 12px;\n  line-height: 16px;\n  color: #7a7a7a; }\n\n.items--item__link {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  text-decoration: none; }\n\n.items--item__arrow {\n  color: #5a5a5a;\n  margin-right: -9px; }\n";
var styles$1F = {"root":"items--item__root","contentLeft":"items--item__contentLeft","contentRight":"items--item__contentRight","titles":"items--item__titles","title":"items--item__title","titleSecondary":"items--item__titleSecondary","link":"items--item__link","arrow":"items--item__arrow","wiggle":"items--item__wiggle","spin":"items--item__spin"};
styleInject(css_248z$1O);

var ListItem =
/** @class */
function (_super) {
  __extends(ListItem, _super);

  function ListItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListItem.prototype.renderContent = function () {
    var _a = this.props,
        contentLeft = _a.contentLeft,
        contentRight = _a.contentRight,
        title = _a.title,
        titleSecondary = _a.titleSecondary,
        url = _a.url,
        isLink = _a.isLink;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!contentLeft && /*#__PURE__*/React.createElement("div", {
      className: styles$1F.contentLeft
    }, contentLeft), (!!title || !!titleSecondary) && /*#__PURE__*/React.createElement("div", {
      className: styles$1F.titles
    }, !!titleSecondary && /*#__PURE__*/React.createElement("span", {
      className: styles$1F.titleSecondary
    }, titleSecondary), !!title && /*#__PURE__*/React.createElement("span", {
      className: styles$1F.title
    }, title)), !!contentRight && /*#__PURE__*/React.createElement("div", {
      className: styles$1F.contentRight
    }, contentRight), (!!url || isLink) && !contentRight && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: classnames(styles$1F.arrow, 'icon-vertical-fix'),
      name: "angle-right",
      size: 24
    }));
  };

  ListItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        contentLeft = _b.contentLeft,
        contentRight = _b.contentRight,
        title = _b.title,
        titleSecondary = _b.titleSecondary,
        secondaryTitleBelow = _b.secondaryTitleBelow,
        url = _b.url,
        isLink = _b.isLink,
        onClick = _b.onClick,
        otherProps = __rest(_b, ["className", "children", "contentLeft", "contentRight", "title", "titleSecondary", "secondaryTitleBelow", "url", "isLink", "onClick"]);

    var rootClass = classnames((_a = {}, _a[styles$1F.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("li", __assign({
      onClick: onClick
    }, otherProps, {
      className: rootClass
    }), !!url && /*#__PURE__*/React.createElement(Link, {
      className: styles$1F.link,
      to: url
    }, !!children && children, !children && this.renderContent()), !url && /*#__PURE__*/React.createElement(React.Fragment, null, !!children && children, !children && this.renderContent()));
  };

  return ListItem;
}(PureComponent);

var css_248z$1P = ".items--text__root {\n  max-height: 100px;\n  display: block;\n  font-size: 14px;\n  color: #393939;\n  text-overflow: ellipsis;\n  margin: 8px 0;\n  white-space: pre-wrap;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  /* stylelint-disable */\n  display: -webkit-box;\n  /* stylelint-enable */\n  word-break: break-word; }\n";
var styles$1G = {"root":"items--text__root"};
styleInject(css_248z$1P);

var ListText =
/** @class */
function (_super) {
  __extends(ListText, _super);

  function ListText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListText.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        otherProps = __rest(_b, ["className"]);

    var rootClass = classnames((_a = {}, _a[styles$1G.root] = true, _a), className);
    return /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    })));
  };

  return ListText;
}(PureComponent);

var css_248z$1Q = ".items--user__avatarWrap {\n  width: 32px; }\n";
var styles$1H = {"avatarWrap":"items--user__avatarWrap"};
styleInject(css_248z$1Q);

var ListUser =
/** @class */
function (_super) {
  __extends(ListUser, _super);

  function ListUser() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListUser.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        user = _a.user,
        otherProps = __rest(_a, ["className", "user"]);

    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement(ListItem, __assign({
      className: rootClass,
      contentLeft: /*#__PURE__*/React.createElement("div", {
        className: styles$1H.avatarWrap
      }, /*#__PURE__*/React.createElement(AvatarWithErrorBoundary, {
        user: user
      }))
    }, otherProps));
  };

  return ListUser;
}(PureComponent);

var css_248z$1R = "@-webkit-keyframes list--list__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes list--list__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes list--list__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes list--list__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.list--list__root {\n  margin: 0;\n  padding: 0; }\n\n.list--list__listItem {\n  list-style-type: none;\n  margin: 0;\n  padding: 15px 10px; }\n  .list--list__listItem + .list--list__listItem {\n    border-top: 1px solid #e3e4e6; }\n\n.list--list__listText {\n  max-height: 100px;\n  display: block;\n  font-size: 14px;\n  color: #393939;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  white-space: pre-wrap;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  /* stylelint-disable */\n  display: -webkit-box;\n  /* stylelint-enable */\n  word-break: break-word; }\n";
var styles$1I = {"root":"list--list__root","listItem":"list--list__listItem","listText":"list--list__listText","wiggle":"list--list__wiggle","spin":"list--list__spin"};
styleInject(css_248z$1R);

var List =
/** @class */
function (_super) {
  __extends(List, _super);

  function List() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(List, "Item", {
    get: function get() {
      return ListItem;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(List, "Text", {
    get: function get() {
      return ListText;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(List, "User", {
    get: function get() {
      return ListUser;
    },
    enumerable: false,
    configurable: true
  });

  List.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        otherProps = __rest(_a, ["className", "children"]);

    var rootClass = classnames(styles$1I.root, className);
    return /*#__PURE__*/React.createElement("ul", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return List;
}(PureComponent);

var css_248z$1S = "@-webkit-keyframes items--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes items--item__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes items--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes items--item__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.items--item__root {\n  list-style-type: none;\n  margin: 0;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center; }\n  .items--item__rootWithHoverEffect:hover {\n    background-color: #f5f7fa; }\n  .items--item__rootDense {\n    padding: 8px 12px; }\n  .items--item__rootLarge {\n    padding: 16px; }\n    .items--item__rootLarge + .items--item__rootLarge {\n      border-top: 1px solid #e7ecf3; }\n\n.items--item__contentLeft {\n  margin-right: 12px;\n  line-height: 16px; }\n\n.items--item__contentRight {\n  line-height: 16px; }\n\n.items--item__titles {\n  margin-right: auto;\n  padding-right: 16px; }\n\n.items--item__title,\n.items--item__titleSecondary {\n  display: block; }\n\n.items--item__link {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  text-decoration: none; }\n\n.items--item__arrow {\n  color: #b5c1d4;\n  margin-right: -8px; }\n";
var styles$1J = {"root":"items--item__root","rootWithHoverEffect":"items--item__rootWithHoverEffect","rootDense":"items--item__rootDense","rootLarge":"items--item__rootLarge","contentLeft":"items--item__contentLeft","contentRight":"items--item__contentRight","titles":"items--item__titles","title":"items--item__title","titleSecondary":"items--item__titleSecondary","link":"items--item__link","arrow":"items--item__arrow","wiggle":"items--item__wiggle","spin":"items--item__spin"};
styleInject(css_248z$1S);

var ListItem$1 =
/** @class */
function (_super) {
  __extends(ListItem, _super);

  function ListItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListItem.prototype.renderTitle = function () {
    var _a = this.props,
        title = _a.title,
        titleSecondary = _a.titleSecondary;

    if (!!title || !!titleSecondary) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$1J.titles
      }, !!title && /*#__PURE__*/React.createElement(Text.Paragraph, {
        variant: "2",
        className: styles$1J.title
      }, title), !!titleSecondary && /*#__PURE__*/React.createElement(Text.Paragraph, {
        variant: "4",
        subdued: true,
        className: styles$1J.titleSecondary
      }, titleSecondary));
    }

    return null;
  };

  ListItem.prototype.renderContentLeft = function () {
    var contentLeft = this.props.contentLeft;

    if (!contentLeft) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$1J.contentLeft
    }, contentLeft);
  };

  ListItem.prototype.renderContentRight = function () {
    var contentRight = this.props.contentRight;

    if (!contentRight) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$1J.contentRight
    }, contentRight);
  };

  ListItem.prototype.renderIcon = function () {
    var _a = this.props,
        url = _a.url,
        isLink = _a.isLink,
        contentRight = _a.contentRight;

    if ((!!url || isLink) && !contentRight) {
      return /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
        className: classnames(styles$1J.arrow, 'icon-vertical-fix'),
        name: "angle-right",
        size: 24
      });
    }

    return null;
  };

  ListItem.prototype.renderContent = function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderContentLeft(), this.renderTitle(), this.renderContentRight(), this.renderIcon());
  };

  ListItem.prototype.getChildrenWithFallback = function () {
    var _a;

    return (_a = this.props.children) !== null && _a !== void 0 ? _a : this.renderContent();
  };

  ListItem.prototype.getChildrenAsLink = function () {
    return /*#__PURE__*/React.createElement(Link, {
      className: styles$1J.link,
      to: this.props.url
    }, this.getChildrenWithFallback());
  };

  ListItem.prototype.shouldRenderChildrenAsLink = function () {
    return Boolean(this.props.url);
  };

  ListItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        contentLeft = _b.contentLeft,
        contentRight = _b.contentRight,
        title = _b.title,
        titleSecondary = _b.titleSecondary,
        secondaryTitleBelow = _b.secondaryTitleBelow,
        url = _b.url,
        isLink = _b.isLink,
        variant = _b.variant,
        withHoverEffect = _b.withHoverEffect,
        listItemHtmlElementProps = __rest(_b, ["className", "children", "contentLeft", "contentRight", "title", "titleSecondary", "secondaryTitleBelow", "url", "isLink", "variant", "withHoverEffect"]);

    var classNames = classnames(styles$1J.root, className, (_a = {}, _a[styles$1J.rootDense] = variant === 'dense', _a[styles$1J.rootLarge] = variant === 'large', _a[styles$1J.rootWithHoverEffect] = withHoverEffect, _a));
    return /*#__PURE__*/React.createElement("li", __assign({}, listItemHtmlElementProps, {
      className: classNames
    }), this.shouldRenderChildrenAsLink() ? this.getChildrenAsLink() : this.getChildrenWithFallback());
  };

  ListItem.defaultProps = {
    variant: 'dense',
    withHoverEffect: true
  };
  return ListItem;
}(PureComponent);

var css_248z$1T = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.items--keyValue__root {\n  margin: 0; }\n\n.items--keyValue__label {\n  white-space: nowrap; }\n\n.items--keyValue__value {\n  margin: 0;\n  overflow-wrap: break-word;\n  white-space: normal;\n  max-width: 100%; }\n  .items--keyValue__value + .items--keyValue__label {\n    border-top: 1px solid #d7dfea; }\n";
var styles$1K = {"root":"items--keyValue__root","label":"items--keyValue__label","value":"items--keyValue__value"};
styleInject(css_248z$1T);

var ListKeyValuePair =
/** @class */
function (_super) {
  __extends(ListKeyValuePair, _super);

  function ListKeyValuePair() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListKeyValuePair.prototype.isValueEmpty = function () {
    return !this.props.pair.value;
  };

  ListKeyValuePair.prototype.render = function () {
    var _a = this.props,
        hideIfValueIsEmpty = _a.hideIfValueIsEmpty,
        className = _a.className,
        pair = _a.pair,
        otherProps = __rest(_a, ["hideIfValueIsEmpty", "className", "pair"]);

    var rootClass = classnames(styles$1K.root, className);

    if (hideIfValueIsEmpty && this.isValueEmpty()) {
      return null;
    }

    return /*#__PURE__*/React.createElement(ListItem$1, __assign({}, otherProps, {
      className: rootClass,
      title: /*#__PURE__*/React.createElement(Text.Paragraph, {
        as: "span",
        variant: "4",
        subdued: true
      }, pair.key),
      titleSecondary: /*#__PURE__*/React.createElement(Text.Paragraph, {
        as: "span",
        variant: "2"
      }, pair.value),
      "data-testid": "<List.KeyValue>"
    }));
  };

  ListKeyValuePair.defaultProps = {
    hideIfValueIsEmpty: true
  };
  return ListKeyValuePair;
}(PureComponent);

var css_248z$1U = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.items--text__root {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  overflow: hidden;\n  word-break: break-word; }\n";
var styles$1L = {"root":"items--text__root"};
styleInject(css_248z$1U);

var ListText$1 =
/** @class */
function (_super) {
  __extends(ListText, _super);

  function ListText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListText.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        listItemProps = __rest(_a, ["children", "className"]);

    var rootClass = classnames(styles$1L.root, className);
    return /*#__PURE__*/React.createElement(ListItem$1, __assign({}, listItemProps, {
      className: rootClass,
      "data-testid": "<List.Text>"
    }), /*#__PURE__*/React.createElement(Text.Paragraph, {
      variant: "2"
    }, children));
  };

  return ListText;
}(PureComponent);

var css_248z$1V = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.items--user__root {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.items--user__avatarWrapper {\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n  min-height: 32px; }\n";
var styles$1M = {"root":"items--user__root","avatarWrapper":"items--user__avatarWrapper"};
styleInject(css_248z$1V);

var ListUser$1 =
/** @class */
function (_super) {
  __extends(ListUser, _super);

  function ListUser() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListUser.prototype.getTitle = function () {
    var _a = this.props,
        user = _a.user,
        title = _a.title;
    return title || user.display_name || user.name || user.phone_number || user.id;
  };

  ListUser.prototype.getSubTitle = function () {
    var _a = this.props,
        user = _a.user,
        titleSecondary = _a.titleSecondary;
    return titleSecondary || user.email;
  };

  ListUser.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        user = _a.user,
        title = _a.title,
        titleSecondary = _a.titleSecondary,
        otherProps = __rest(_a, ["className", "user", "title", "titleSecondary"]);

    var rootClass = classnames(className, styles$1M.root);
    return /*#__PURE__*/React.createElement(ListItem$1, __assign({
      className: rootClass,
      contentLeft: /*#__PURE__*/React.createElement("div", {
        className: styles$1M.avatarWrapper
      }, /*#__PURE__*/React.createElement(AvatarWithErrorBoundary, {
        user: user
      })),
      title: this.getTitle(),
      titleSecondary: this.getSubTitle(),
      "data-testid": "<List.User>"
    }, otherProps));
  };

  return ListUser;
}(PureComponent);

var css_248z$1W = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.listV2--list__root {\n  margin: 0;\n  padding: 4px;\n  background-color: #ffffff;\n  min-width: 160px; }\n";
var styles$1N = {"root":"listV2--list__root"};
styleInject(css_248z$1W);

var List$1 =
/** @class */
function (_super) {
  __extends(List, _super);

  function List() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  List.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        props = __rest(_a, ["className"]);

    return /*#__PURE__*/React.createElement("ul", __assign({}, props, {
      className: classnames(styles$1N.root, className)
    }));
  };

  List.Item = ListItem$1;
  List.Text = ListText$1;
  List.User = ListUser$1;
  List.KeyValue = ListKeyValuePair;
  return List;
}(PureComponent);
var ListWithErrorBoundary = withErrorBoundary(List$1, {
  fallback: null
});

var FileSaver_min = createCommonjsModule(function (module, exports) {
(function(a,b){b();})(commonjsGlobal,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d);},e.onerror=function(){console.error("could not download file");},e.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null;},j.readAsDataURL(a);}else {var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l);},4E4);}});f.saveAs=a.saveAs=a,(module.exports=a);});


});

var closeFullscreen = function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
};
var openFullscreen = function openFullscreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) {
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
  }
};
var isFullscreenOpen = function isFullscreenOpen(elem) {
  return document.fullscreenElement === elem;
};

var NetworkError = /*#__PURE__*/function (_Error) {
  _inherits(NetworkError, _Error);

  var _super = _createSuper(NetworkError);

  function NetworkError(response) {
    var _this;

    _classCallCheck(this, NetworkError);

    _this = _super.call(this, "NetworkError ".concat(response.status, " ").concat(response.url));
    _this.status = response.status;
    _this.url = response.url;
    _this.response = response;
    return _this;
  }

  return NetworkError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var http = {
  fetch: function (_fetch) {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    fetch.toString = function () {
      return _fetch.toString();
    };

    return fetch;
  }(function () {
    return fetch.apply(void 0, arguments).then(function (response) {
      if (!(response.status >= 200 && response.status < 300)) {
        throw new NetworkError(response);
      }

      return response;
    });
  })
};

var css_248z$1X = "@-webkit-keyframes rangeSlider--rangeSlider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes rangeSlider--rangeSlider__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes rangeSlider--rangeSlider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes rangeSlider--rangeSlider__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.rangeSlider--rangeSlider__root {\n  height: 14px;\n  position: relative;\n  padding: 4px 0;\n  box-sizing: border-box; }\n  .rangeSlider--rangeSlider__root::before {\n    content: '';\n    background: rgba(86, 68, 216, 0.2);\n    height: 6px;\n    display: block;\n    border-radius: 3px; }\n  .rangeSlider--rangeSlider__rootDark::before {\n    background: #191919; }\n\n.rangeSlider--rangeSlider__handle {\n  position: absolute;\n  top: 0;\n  background: #5644d8;\n  width: 14px;\n  height: 14px;\n  border-radius: 7px;\n  transform: translateX(-50%);\n  outline: none;\n  border: 1px solid #f1f2f4;\n  box-sizing: border-box;\n  z-index: 3;\n  padding: 0; }\n  .rangeSlider--rangeSlider__handle:focus {\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n  .rangeSlider--rangeSlider__rootDark .rangeSlider--rangeSlider__handle {\n    border-color: #191919; }\n\n.rangeSlider--rangeSlider__trackWrap {\n  border-radius: 3px;\n  overflow: hidden;\n  width: 100%;\n  position: absolute;\n  height: 6px;\n  top: 4px; }\n\n.rangeSlider--rangeSlider__track {\n  height: 6px;\n  position: absolute;\n  background: #5644d8;\n  z-index: 2; }\n\n.rangeSlider--rangeSlider__highlight {\n  height: 6px;\n  position: absolute;\n  background: rgba(86, 68, 216, 0.15); }\n";
var styles$1O = {"root":"rangeSlider--rangeSlider__root","rootDark":"rangeSlider--rangeSlider__rootDark","handle":"rangeSlider--rangeSlider__handle","trackWrap":"rangeSlider--rangeSlider__trackWrap","track":"rangeSlider--rangeSlider__track","highlight":"rangeSlider--rangeSlider__highlight","wiggle":"rangeSlider--rangeSlider__wiggle","spin":"rangeSlider--rangeSlider__spin"};
styleInject(css_248z$1X);

var preventDefault = function preventDefault(e) {
  e.preventDefault();
};

var RangeSlider =
/** @class */
function (_super) {
  __extends(RangeSlider, _super);

  function RangeSlider(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    };
    _this.sliderRef = /*#__PURE__*/React.createRef();
    _this.handleHandleGrab = _this.handleHandleGrab.bind(_this);
    _this.handleHandleMove = _this.handleHandleMove.bind(_this);
    _this.handleHandleDrop = _this.handleHandleDrop.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleSliderMouseDown = _this.handleSliderMouseDown.bind(_this);
    return _this;
  }

  RangeSlider.prototype.isInterval = function (value) {
    return Array.isArray(value);
  };

  RangeSlider.prototype.handleHandleMove = function (event) {
    event.preventDefault();
    var _a = this.state,
        startVal = _a.startVal,
        startX = _a.startX,
        sliderWidth = _a.sliderWidth,
        currentIndex = _a.currentIndex;
    var onChange = this.props.input.onChange;
    var p = startVal + (event.clientX - startX) / sliderWidth;
    onChange(this.getNewValue(p, currentIndex));
  };

  RangeSlider.prototype.handleHandleDrop = function () {
    window.removeEventListener('mousemove', this.handleHandleMove);
    window.removeEventListener('mouseup', this.handleHandleDrop);
    this.setState({
      currentIndex: null
    });
  };

  RangeSlider.prototype.handleKeyDown = function (event) {
    var _a = this.props,
        step = _a.step,
        value = _a.input.value;
    var intervalIndex = this.isInterval(value) && event.target instanceof Element ? parseInt(event.target.getAttribute('data-index') || '', 10) : null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowUp':
        this.increment(step || 0.01, intervalIndex, event);
        break;

      case 'ArrowLeft':
      case 'ArrowDown':
        this.increment(step ? -step : -0.01, intervalIndex, event);
        break;
    }
  };
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */


  RangeSlider.prototype.handleSliderMouseDown = function (event) {
    if (this.sliderRef.current) {
      var _a = this.props.input,
          value = _a.value,
          onChange = _a.onChange;
      var currentIndex = this.state.currentIndex;
      var bounds = this.sliderRef.current.getBoundingClientRect();
      var p = (event.clientX - bounds.left) / bounds.width;
      this.setState({
        startX: event.clientX,
        startVal: p,
        sliderWidth: bounds.width
      });
      var newVal = void 0;

      if (this.isInterval(value)) {
        var intervalIndex = currentIndex;

        if (intervalIndex === null) {
          // Figure out which handle to grab if we didn't click directly on a handle
          if (p > value[1] && p > value[0]) intervalIndex = 1;else if (p < value[1] && p < value[0]) intervalIndex = 0;else intervalIndex = Math.abs(value[0] - p) > Math.abs(value[1] - p) ? 1 : 0;
          this.setState({
            currentIndex: intervalIndex
          });
        }

        newVal = this.getNewValue(p, intervalIndex);
      } else {
        newVal = this.getNewValue(p);
      }

      onChange(newVal);
      window.addEventListener('mousemove', this.handleHandleMove);
      window.addEventListener('mouseup', this.handleHandleDrop);
    }
  };
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */


  RangeSlider.prototype.handleHandleGrab = function (event) {
    if (event.target instanceof Element) {
      this.setState({
        currentIndex: parseInt(event.target.getAttribute('data-index') || '', 10)
      });
    }
  };

  RangeSlider.prototype.getNewValue = function (p, intervalIndex) {
    var _a = this.props,
        value = _a.input.value,
        step = _a.step;
    var newVal = p; // Make sure the newVal is between 0 and 1

    if (newVal < 0) newVal = 0;else if (newVal > 1) newVal = 1; // Move to closest step if this is a stepped slider

    if (step) {
      newVal = Math.round(newVal / step) * step;
    }

    if (this.isInterval(value)) {
      /*
        Make sure that the handles don't cross each other, so if the first (left) handle's
        new value is greater than the second (right) handle, set the first handle's new value
        to the value of the second (and vice versa)
      */
      var lowValue = value[0],
          highValue = value[1];
      var temp = newVal;
      if (intervalIndex === 0 && temp > highValue) temp = highValue;else if (intervalIndex === 1 && temp < lowValue) temp = lowValue; // Change the newVal to be an array

      newVal = [lowValue, highValue];

      if (typeof intervalIndex === 'number') {
        newVal[intervalIndex] = temp;
      }
    }

    return newVal;
  };

  RangeSlider.prototype.increment = function (incrementBy, intervalIndex, event) {
    var _a = this.props.input,
        value = _a.value,
        onChange = _a.onChange;
    var newVal;

    if (this.isInterval(value)) {
      newVal = this.getNewValue(value[intervalIndex !== null && intervalIndex !== void 0 ? intervalIndex : 0] + incrementBy, intervalIndex);
    } else {
      newVal = this.getNewValue(value + incrementBy);
    }

    onChange(newVal);
  };

  RangeSlider.prototype.getTrackStyles = function () {
    var value = this.props.input.value;
    var width = this.isInterval(value) ? value[1] - value[0] : value;
    var left = this.isInterval(value) ? value[0] * 100 : 0;
    return {
      width: width * 100 + "%",
      left: left + "%"
    };
  };

  RangeSlider.prototype.getHandleStyles = function (handleIndex) {
    var value = this.props.input.value;
    var left = this.isInterval(value) ? value[handleIndex !== null && handleIndex !== void 0 ? handleIndex : 0] : value;
    return {
      left: left * 100 + "%"
    };
  };

  RangeSlider.prototype.getHighlightStyles = function () {
    var highlightRange = this.props.highlightRange;
    if (!highlightRange) return {};
    var start = highlightRange[0],
        end = highlightRange[1];
    return {
      left: start * 100 + "%",
      width: (end - start) * 100 + "%"
    };
  };

  RangeSlider.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        value = _b.input.value,
        step = _b.step,
        dark = _b.dark,
        highlightRange = _b.highlightRange,
        otherProps = __rest(_b, ["className", "input", "step", "dark", "highlightRange"]);

    var rootClass = classnames((_a = {}, _a[styles$1O.root] = true, _a[styles$1O.rootDark] = dark, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      ref: this.sliderRef,
      onMouseDown: this.handleSliderMouseDown
    }), !this.isInterval(value) && /*#__PURE__*/React.createElement("button", {
      role: "slider",
      "aria-valuemin": 0,
      "aria-valuemax": 1,
      "aria-valuenow": value,
      className: styles$1O.handle,
      onClick: preventDefault,
      onKeyDown: this.handleKeyDown,
      style: this.getHandleStyles()
    }), this.isInterval(value) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      "data-index": "0",
      className: styles$1O.handle,
      onKeyDown: this.handleKeyDown,
      style: this.getHandleStyles(0),
      onMouseDown: this.handleHandleGrab
    }), /*#__PURE__*/React.createElement("button", {
      "data-index": "1",
      className: styles$1O.handle,
      onKeyDown: this.handleKeyDown,
      style: this.getHandleStyles(1),
      onMouseDown: this.handleHandleGrab
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$1O.trackWrap
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1O.track,
      style: this.getTrackStyles()
    }), !!highlightRange && /*#__PURE__*/React.createElement("div", {
      className: styles$1O.highlight,
      style: this.getHighlightStyles()
    })));
  };

  return RangeSlider;
}(PureComponent);

var css_248z$1Y = "@-webkit-keyframes mediaPlayer--mediaPlayer__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes mediaPlayer--mediaPlayer__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes mediaPlayer--mediaPlayer__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes mediaPlayer--mediaPlayer__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n.mediaPlayer--mediaPlayer__rootWaiting .mediaPlayer--mediaPlayer__videoWrap::before {\n  background-image: url(\"data:image/gif;base64,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\");\n  background-repeat: no-repeat;\n  background-position: center; }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.mediaPlayer--mediaPlayer__root {\n  display: block; }\n\n.mediaPlayer--mediaPlayer__controls {\n  padding: 8px;\n  border-radius: 0 0 6px 6px;\n  background: #f1f2f4;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box; }\n  .mediaPlayer--mediaPlayer__rootFullScreen .mediaPlayer--mediaPlayer__controls {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    transition: opacity 0.15s ease-out;\n    background: #393939; }\n  .mediaPlayer--mediaPlayer__rootFullScreen.mediaPlayer--mediaPlayer__rootHideControls .mediaPlayer--mediaPlayer__controls {\n    opacity: 0; }\n    .mediaPlayer--mediaPlayer__rootFullScreen.mediaPlayer--mediaPlayer__rootHideControls .mediaPlayer--mediaPlayer__controls:hover {\n      opacity: 1; }\n\n.mediaPlayer--mediaPlayer__control {\n  min-width: 0; }\n  .mediaPlayer--mediaPlayer__control + .mediaPlayer--mediaPlayer__control {\n    margin-left: 8px; }\n\n.mediaPlayer--mediaPlayer__progress {\n  flex: 1;\n  margin: 0 16px 0 16px;\n  display: flex;\n  align-items: center; }\n\n.mediaPlayer--mediaPlayer__slider {\n  flex: 1;\n  margin: 0 12px;\n  min-width: 32px; }\n\n.mediaPlayer--mediaPlayer__timestamp {\n  color: #7a7a7a;\n  font-size: 12px;\n  font-weight: 600; }\n  .mediaPlayer--mediaPlayer__rootFullScreen .mediaPlayer--mediaPlayer__timestamp {\n    color: #dad5e7; }\n\n.mediaPlayer--mediaPlayer__videoWrap {\n  padding-top: 56.25%;\n  background: #393939;\n  border-radius: 6px 6px 0 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .mediaPlayer--mediaPlayer__rootFullScreen .mediaPlayer--mediaPlayer__videoWrap {\n    height: 100%;\n    padding: 0;\n    background: #000; }\n  .mediaPlayer--mediaPlayer__rootWaiting .mediaPlayer--mediaPlayer__videoWrap::before {\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n  .mediaPlayer--mediaPlayer__rootAudio .mediaPlayer--mediaPlayer__videoWrap {\n    height: 0;\n    visibility: hidden;\n    padding-top: 0; }\n\n.mediaPlayer--mediaPlayer__video {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0; }\n\n.mediaPlayer--mediaPlayer__volume {\n  display: flex;\n  flex: 0.1;\n  align-items: center; }\n";
var styles$1P = {"rootWaiting":"mediaPlayer--mediaPlayer__rootWaiting","videoWrap":"mediaPlayer--mediaPlayer__videoWrap","root":"mediaPlayer--mediaPlayer__root","controls":"mediaPlayer--mediaPlayer__controls","rootFullScreen":"mediaPlayer--mediaPlayer__rootFullScreen","rootHideControls":"mediaPlayer--mediaPlayer__rootHideControls","control":"mediaPlayer--mediaPlayer__control","progress":"mediaPlayer--mediaPlayer__progress","slider":"mediaPlayer--mediaPlayer__slider","timestamp":"mediaPlayer--mediaPlayer__timestamp","rootAudio":"mediaPlayer--mediaPlayer__rootAudio","video":"mediaPlayer--mediaPlayer__video","volume":"mediaPlayer--mediaPlayer__volume","wiggle":"mediaPlayer--mediaPlayer__wiggle","spin":"mediaPlayer--mediaPlayer__spin"};
styleInject(css_248z$1Y);

function generateTimeStamp(duration) {
  var stampLength = duration >= 3600 ? 8 : 5;
  if (Number.isNaN(duration) || !Number.isFinite(duration)) return '00:00';
  return new Date(duration * 1000).toISOString().substr(19 - stampLength, stampLength);
}

var MediaPlayer =
/** @class */
function (_super) {
  __extends(MediaPlayer, _super);

  function MediaPlayer(props) {
    var _this = _super.call(this, props) || this;

    _this.handleVolume = function (volume) {
      var current = _this.videoRef.current;

      if (!current || typeof volume === 'undefined' || !Number.isFinite(volume)) {
        return;
      }

      current.volume = volume;

      _this.setState({
        volume: volume
      });
    };

    _this.state = {
      src: undefined,
      playing: false,
      actuallyPlaying: false,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 1,
      isFullScreen: false,
      hideControls: false,
      isWaiting: false,
      buffer: null,
      asyncStatus: null
    };
    _this.hideControlsTimeout = undefined;
    _this.videoRef = /*#__PURE__*/React.createRef();
    _this.playerRef = /*#__PURE__*/React.createRef();
    _this.controller = new AbortController();
    _this.updateBuffer = _this.updateBuffer.bind(_this);
    _this.updateProgress = _this.updateProgress.bind(_this);
    _this.handleMute = _this.handleMute.bind(_this);
    _this.handlePlaying = _this.handlePlaying.bind(_this);
    _this.handleWaiting = _this.handleWaiting.bind(_this);
    _this.handleEnded = _this.handleEnded.bind(_this);
    _this.seek = _this.seek.bind(_this);
    _this.handleTogglePlayClick = _this.handleTogglePlayClick.bind(_this);
    _this.handleFullscreenToggle = _this.handleFullscreenToggle.bind(_this);
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind(_this);
    _this.startHideControlCountdown = _this.startHideControlCountdown.bind(_this);
    return _this;
  }

  MediaPlayer.prototype.componentDidMount = function () {
    var player = this.playerRef.current;

    if (player) {
      player.addEventListener('fullscreenchange', this.handleFullscreenChange);
    }

    this.loadSrc();
  };

  MediaPlayer.prototype.componentDidUpdate = function (prevProps, prevState) {
    var prevSrc = prevProps.mediaFile.src;
    var src = this.props.mediaFile.src;

    if (prevSrc !== src) {
      this.loadSrc();
    }

    this.tryReloadPlayer(prevState);
  };

  MediaPlayer.prototype.componentWillUnmount = function () {
    var player = this.playerRef.current;

    if (player) {
      player.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    }

    window.removeEventListener('mousemove', this.startHideControlCountdown);

    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    }

    this.controller.abort(); // Cancel a request.
  };

  MediaPlayer.prototype.loadSrc = function () {
    var _a = this.props,
        src = _a.mediaFile.src,
        isPrivateFile = _a.isPrivateFile;
    this.tryStopPlayer();

    if (isPrivateFile) {
      this.fetchFile();
    } else {
      this.setSrc(src);
    }
  };

  MediaPlayer.prototype.setSrc = function (src) {
    this.setState({
      src: src
    });
  };

  MediaPlayer.prototype.tryStopPlayer = function () {
    var player = this.videoRef.current;

    if (!player) {
      return;
    }

    player.currentTime = 0;
    var _a = this.state,
        playing = _a.playing,
        actuallyPlaying = _a.actuallyPlaying;

    if (playing && actuallyPlaying) {
      player.pause();
      this.setState({
        playing: false,
        actuallyPlaying: false
      });
    }
  };

  MediaPlayer.prototype.tryReloadPlayer = function (prevState) {
    var player = this.videoRef.current;

    if (!player) {
      return;
    }

    var src = this.state.src;

    if (src !== prevState.src) {
      player.load();
    }
  };

  MediaPlayer.prototype.fetchFile = function (isForDownload) {
    var _this = this;

    var _a = this.props,
        src = _a.mediaFile.src,
        headersProp = _a.headers,
        filename = _a.filename;
    this.setState({
      asyncStatus: 'loading'
    });
    var headers = new Headers(headersProp);
    http.fetch(src, {
      headers: headers,
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      signal: this.controller.signal
    }).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      var blobUrl = window.URL.createObjectURL(blob);

      if (isForDownload) {
        FileSaver_min.saveAs(blob, filename || decodeURIComponent(src.split('/').pop()));
      } else {
        _this.setSrc(blobUrl);
      }

      _this.setState({
        asyncStatus: 'succeeded'
      });
    }).catch(function (error) {
      // Aborting a request results in error.
      // Make sure to prevent calling `setState` if request was cancelled on unmount.
      if (error && error.name === 'AbortError') {
        return;
      } // eslint-disable-next-line no-console


      console.error('[MediaPlayer] fetchFile', error);

      _this.setState({
        asyncStatus: 'failed'
      });
    });
  };

  MediaPlayer.prototype.updateProgress = function () {
    var current = this.videoRef.current;

    if (current) {
      this.setState({
        time: current.currentTime,
        duration: current.duration
      });
    }
  };

  MediaPlayer.prototype.updateBuffer = function () {
    var current = this.videoRef.current;
    var _a = this.state,
        time = _a.time,
        duration = _a.duration;

    if (current) {
      var theBufferWereLookingFor = null;
      var buffers = current.buffered;

      for (var i = 0; i < buffers.length; i += 1) {
        var start = buffers.start(i);
        var end = buffers.end(i);

        if (start <= time && time <= end) {
          theBufferWereLookingFor = [start / duration, end / duration];
        }
      }

      this.setState({
        buffer: theBufferWereLookingFor
      });
    }
  };

  MediaPlayer.prototype.handleWaiting = function () {
    this.setState({
      isWaiting: true
    });
  };

  MediaPlayer.prototype.handlePlaying = function () {
    this.setState({
      isWaiting: false
    });
  };

  MediaPlayer.prototype.handleTogglePlayClick = function () {
    var _this = this;

    var _a = this.state,
        playing = _a.playing,
        actuallyPlaying = _a.actuallyPlaying;
    var current = this.videoRef.current;

    if (current) {
      if (playing && actuallyPlaying) {
        current.pause();
        this.setState({
          isWaiting: false,
          playing: false,
          actuallyPlaying: false
        });
      } else if (!playing) {
        this.setState({
          isWaiting: true,
          playing: true,
          actuallyPlaying: false
        });
        current.play().then(function () {
          _this.setState({
            actuallyPlaying: true
          });
        });
      }
    }
  };

  MediaPlayer.prototype.startHideControlCountdown = function () {
    var _this = this;

    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    }

    this.setState({
      hideControls: false
    });
    this.hideControlsTimeout = setTimeout(function () {
      _this.setState({
        hideControls: true
      });
    }, 2000);
  };

  MediaPlayer.prototype.handleFullscreenChange = function () {
    var current = this.playerRef.current;
    var isFullScreen = isFullscreenOpen(current);
    this.setState({
      isFullScreen: isFullScreen
    });

    if (isFullScreen) {
      this.startHideControlCountdown();
      window.addEventListener('mousemove', this.startHideControlCountdown);
    } else {
      if (this.hideControlsTimeout) {
        clearTimeout(this.hideControlsTimeout);
      }

      window.removeEventListener('mousemove', this.startHideControlCountdown);
    }
  };

  MediaPlayer.prototype.handleFullscreenToggle = function () {
    var current = this.playerRef.current;
    var isFullScreen = this.state.isFullScreen;
    if (!current) return;

    if (isFullScreen) {
      closeFullscreen();
    } else {
      openFullscreen(current);
    }
  };

  MediaPlayer.prototype.handleEnded = function () {
    this.setState({
      playing: false
    });
  };

  MediaPlayer.prototype.seek = function (progress) {
    var current = this.videoRef.current;
    var duration = this.state.duration;

    if (current && progress && !Number.isNaN(progress)) {
      current.currentTime = duration * progress;
    }
  };

  MediaPlayer.prototype.handleMute = function () {
    var current = this.videoRef.current;

    if (!current) {
      return;
    }

    var _a = this.state,
        currentVolume = _a.volume,
        prevVolume = _a.prevVolume;
    var isMuted = currentVolume === 0;
    var volume = isMuted ? prevVolume : 0;
    current.volume = volume;
    this.setState({
      volume: volume,
      prevVolume: isMuted ? prevVolume : currentVolume
    });
  };

  MediaPlayer.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        className = _b.className,
        type = _b.mediaFile.type,
        headers = _b.headers,
        isPrivateFile = _b.isPrivateFile,
        width = _b.width,
        otherProps = __rest(_b, ["className", "mediaFile", "headers", "isPrivateFile", "width"]);

    var _c = this.state,
        src = _c.src,
        playing = _c.playing,
        duration = _c.duration,
        time = _c.time,
        volume = _c.volume,
        hideControls = _c.hideControls,
        isFullScreen = _c.isFullScreen,
        isWaiting = _c.isWaiting,
        buffer = _c.buffer,
        asyncStatus = _c.asyncStatus;
    var isAudio = typeof type === 'string' && type.startsWith('audio');
    var rootClass = classnames((_a = {}, _a[styles$1P.root] = true, _a[styles$1P.rootFullScreen] = isFullScreen, _a[styles$1P.rootHideControls] = hideControls, _a[styles$1P.rootWaiting] = playing && isWaiting, _a[styles$1P.rootAudio] = isAudio, _a), className);
    var propsForNotFullScreen = {};

    if (!isFullScreen) {
      propsForNotFullScreen.outlined = true;
      propsForNotFullScreen.transparent = true;
    }

    var isDisabled = !src || asyncStatus === 'loading';
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass,
      ref: this.playerRef,
      style: {
        width: width
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$1P.videoWrap
    }, !!src && /*#__PURE__*/React.createElement("video", {
      className: styles$1P.video,
      ref: this.videoRef,
      onDurationChange: this.updateProgress,
      onTimeUpdate: this.updateProgress,
      onWaiting: this.handleWaiting,
      onPlaying: this.handlePlaying,
      onProgress: this.updateBuffer,
      onEnded: this.handleEnded
    }, /*#__PURE__*/React.createElement("source", {
      src: src
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$1P.controls
    }, /*#__PURE__*/React.createElement(Button$2, __assign({
      onClick: this.handleTogglePlayClick,
      className: styles$1P.control,
      disabled: isDisabled,
      icon: playing ? 'pause' : 'play'
    }, propsForNotFullScreen)), /*#__PURE__*/React.createElement(Button$2, __assign({
      className: styles$1P.control,
      icon: "cloud-download",
      disabled: isDisabled,
      onClick: function onClick() {
        return _this.fetchFile(true);
      },
      component: isPrivateFile ? undefined : /*#__PURE__*/React.createElement("a", {
        href: src,
        download: true,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
        name: "cloud-download"
      }))
    }, propsForNotFullScreen)), /*#__PURE__*/React.createElement("div", {
      className: styles$1P.progress
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$1P.timestamp
    }, generateTimeStamp(time)), /*#__PURE__*/React.createElement(RangeSlider, {
      className: styles$1P.slider,
      input: {
        name: 'progress',
        value: time / duration,
        onChange: function onChange(value) {
          return _this.seek(value);
        }
      },
      dark: isFullScreen,
      highlightRange: buffer
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$1P.timestamp
    }, generateTimeStamp(duration))), /*#__PURE__*/React.createElement("div", {
      className: styles$1P.volume
    }, /*#__PURE__*/React.createElement(Button$2, {
      icon: volume === 0 ? 'i-volume-off' : 'i-volume-up',
      transparent: true,
      onClick: this.handleMute
    }), /*#__PURE__*/React.createElement(RangeSlider, {
      className: styles$1P.slider,
      input: {
        name: 'volume',
        value: volume,
        onChange: function onChange(value) {
          return _this.handleVolume(value);
        }
      },
      dark: isFullScreen
    })), !isAudio && /*#__PURE__*/React.createElement(Button$2, __assign({
      onClick: this.handleFullscreenToggle,
      className: styles$1P.control,
      icon: "full-screen"
    }, propsForNotFullScreen))));
  };

  return MediaPlayer;
}(React.PureComponent);
MediaPlayer.defaultProps = {
  headers: {}
};

var css_248z$1Z = ".modalBody--modalBody__root {\n  margin: 32px; }\n";
var styles$1Q = {"root":"modalBody--modalBody__root"};
styleInject(css_248z$1Z);

var ModalBody =
/** @class */
function (_super) {
  __extends(ModalBody, _super);

  function ModalBody() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ModalBody.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        children = _b.children,
        otherProps = __rest(_b, ["className", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$1Q.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), children);
  };

  return ModalBody;
}(PureComponent);

var css_248z$1_ = ".modalFoot--modalFoot__root {\n  display: flex;\n  margin: 32px;\n  justify-content: flex-end; }\n\n.modalFoot--modalFoot__confirm:not(:first-child) {\n  margin-left: 16px; }\n\n.modalFoot--modalFoot__confirmSecondary:not(:first-child) {\n  margin-left: 16px; }\n\n.modalFoot--modalFoot__cancel:not(:first-child) {\n  margin-left: 16px; }\n";
var styles$1R = {"root":"modalFoot--modalFoot__root","confirm":"modalFoot--modalFoot__confirm","confirmSecondary":"modalFoot--modalFoot__confirmSecondary","cancel":"modalFoot--modalFoot__cancel"};
styleInject(css_248z$1_);

var ModalFoot =
/** @class */
function (_super) {
  __extends(ModalFoot, _super);

  function ModalFoot() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ModalFoot.prototype.render = function () {
    var _a, _b, _c, _d;

    var _e = this.props,
        className = _e.className,
        confirmOnClick = _e.confirmOnClick,
        confirmSecondaryOnClick = _e.confirmSecondaryOnClick,
        cancelOnClick = _e.cancelOnClick,
        confirmName = _e.confirmName,
        confirmSecondaryName = _e.confirmSecondaryName,
        cancelName = _e.cancelName,
        confirmProps = _e.confirmProps,
        confirmSecondaryProps = _e.confirmSecondaryProps,
        cancelProps = _e.cancelProps,
        children = _e.children,
        otherProps = __rest(_e, ["className", "confirmOnClick", "confirmSecondaryOnClick", "cancelOnClick", "confirmName", "confirmSecondaryName", "cancelName", "confirmProps", "confirmSecondaryProps", "cancelProps", "children"]);

    var rootClass = classnames((_a = {}, _a[styles$1R.root] = true, _a), className);
    var cancelClassName = classnames((_b = {}, _b[styles$1R.cancel] = true, _b), cancelProps === null || cancelProps === void 0 ? void 0 : cancelProps.className);
    var confirmClassName = classnames((_c = {}, _c[styles$1R.confirm] = true, _c), confirmProps === null || confirmProps === void 0 ? void 0 : confirmProps.className);
    var confirmSecondaryClassName = classnames((_d = {}, _d[styles$1R.confirmSecondary] = true, _d), confirmSecondaryProps === null || confirmSecondaryProps === void 0 ? void 0 : confirmSecondaryProps.className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), children, confirmSecondaryOnClick && /*#__PURE__*/React.createElement(Button$2, __assign({
      variant: "secondary"
    }, confirmSecondaryProps, {
      className: confirmSecondaryClassName,
      onClick: confirmSecondaryOnClick
    }), confirmSecondaryName), cancelOnClick && /*#__PURE__*/React.createElement(Button$2, __assign({
      variant: "tertiary"
    }, cancelProps, {
      className: cancelClassName,
      onClick: cancelOnClick
    }), cancelName), confirmOnClick && /*#__PURE__*/React.createElement(Button$2, __assign({
      variant: "primary"
    }, confirmProps, {
      className: confirmClassName,
      onClick: confirmOnClick
    }), confirmName));
  };

  return ModalFoot;
}(React.PureComponent);
ModalFoot.defaultProps = {
  confirmName: 'Save',
  cancelName: 'Cancel',
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};

var css_248z$1$ = "/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.modalHead--modalHead__root {\n  position: relative;\n  margin: 32px;\n  font-family: Open Sans, Arial, sans-serif; }\n\n.modalHead--modalHead__top {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: absolute;\n  top: -8px;\n  right: -4px; }\n\n.modalHead--modalHead__caption {\n  display: inline-block;\n  margin: 0;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  margin-top: 8px;\n  width: 100%; }\n\n.modalHead--modalHead__icon {\n  display: inline-block;\n  margin-right: 10px;\n  color: #8294B0; }\n";
var styles$1S = {"root":"modalHead--modalHead__root","top":"modalHead--modalHead__top","caption":"modalHead--modalHead__caption","icon":"modalHead--modalHead__icon"};
styleInject(css_248z$1$);

var ModalHead =
/** @class */
function (_super) {
  __extends(ModalHead, _super);

  function ModalHead() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ModalHead.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        title = _b.title,
        children = _b.children,
        onClose = _b.onClose,
        secondaryButton = _b.secondaryButton,
        otherProps = __rest(_b, ["className", "title", "children", "onClose", "secondaryButton"]);

    var rootClass = classnames((_a = {}, _a[styles$1S.root] = true, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(Text.Heading, null, title), !!children && /*#__PURE__*/React.createElement("div", {
      className: styles$1S.caption
    }, children), /*#__PURE__*/React.createElement("div", {
      className: styles$1S.top
    }, typeof (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.onClick) === 'function' && /*#__PURE__*/React.createElement(Tooltip, {
      content: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.tooltipContent,
      dark: true
    }, /*#__PURE__*/React.createElement(IconButton$1, {
      icon: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.icon,
      variant: "tertiary",
      onClick: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.onClick
    })), typeof onClose === 'function' && /*#__PURE__*/React.createElement(IconButton$1, {
      icon: "close",
      variant: "tertiary",
      onClick: onClose
    })));
  };

  return ModalHead;
}(PureComponent);

var css_248z$20 = "@-webkit-keyframes radio--radio__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes radio--radio__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes radio--radio__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes radio--radio__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.radio--radio__radio {\n  display: inline-block;\n  position: relative;\n  box-sizing: border-box;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: 16px;\n  max-height: 16px;\n  border: 2px solid #d7dfea;\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: #ffffff;\n  transition: all 0.15s ease-in-out; }\n  .radio--radio__radio::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    min-width: 8px;\n    min-height: 8px;\n    max-width: 8px;\n    max-height: 8px;\n    margin: calc(4px / 2);\n    position: absolute;\n    background: #5644d8;\n    display: block;\n    border-radius: 50%;\n    transform-origin: center;\n    transform: scale(0);\n    transition: all 0.15s ease-in-out; }\n  .radio--radio__radio:focus, .radio--radio__radio:focus-within {\n    border-color: #c1b9f8; }\n  .radio--radio__radio:hover {\n    background-color: #f5f7fa; }\n  .radio--radio__radioDisabled {\n    opacity: 0.5;\n    pointer-events: none; }\n  .radio--radio__radioChecked {\n    border-color: #5644d8; }\n    .radio--radio__radioChecked::before {\n      transform: scale(1); }\n    .radio--radio__radioChecked:hover {\n      background-color: #ffffff;\n      border-color: #392aa7; }\n      .radio--radio__radioChecked:hover::before {\n        background-color: #392aa7; }\n    .radio--radio__radioChecked:focus, .radio--radio__radioChecked:focus-within {\n      background-color: #ffffff;\n      border-color: #392aa7;\n      box-shadow: 0 0 0 2px #c1b9f8; }\n      .radio--radio__radioChecked:focus::before, .radio--radio__radioChecked:focus-within::before {\n        background-color: #392aa7; }\n\n.radio--radio__input {\n  position: absolute;\n  opacity: 0;\n  left: -9999px; }\n";
var styles$1T = {"radio":"radio--radio__radio","radioDisabled":"radio--radio__radioDisabled","radioChecked":"radio--radio__radioChecked","input":"radio--radio__input","wiggle":"radio--radio__wiggle","spin":"radio--radio__spin"};
styleInject(css_248z$20);

var Radio =
/** @class */
function (_super) {
  __extends(Radio, _super);

  function Radio() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Radio.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        id = _c.id,
        checked = _c.checked,
        disabled = _c.disabled,
        className = _c.className,
        labelProps = _c.labelProps,
        inputProps = __rest(_c, ["id", "checked", "disabled", "className", "labelProps"]);

    var rootClass = classnames(styles$1T.radio, (_a = {}, _a[styles$1T.radioChecked] = checked, _a), (_b = {}, _b[styles$1T.radioDisabled] = disabled, _b), className);
    var fieldId = id || "radio_" + Math.random();
    return /*#__PURE__*/React.createElement("label", __assign({}, labelProps, {
      className: rootClass,
      htmlFor: fieldId,
      "data-testid": "radio"
    }), /*#__PURE__*/React.createElement("input", __assign({}, inputProps, {
      id: fieldId,
      checked: checked,
      disabled: disabled,
      type: "radio",
      className: styles$1T.input,
      "data-testid": "input"
    })));
  };

  return Radio;
}(PureComponent);

var css_248z$21 = "@-webkit-keyframes removableCard--removableCard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes removableCard--removableCard__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes removableCard--removableCard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes removableCard--removableCard__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.removableCard--removableCard__root {\n  position: relative; }\n  .removableCard--removableCard__root + .removableCard--removableCard__root {\n    margin-top: 24px; }\n\n.removableCard--removableCard__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 16px;\n  background: none;\n  border: none;\n  padding: 0;\n  outline: 0; }\n\n.removableCard--removableCard__title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px; }\n  .removableCard--removableCard__titleIcon {\n    margin-right: 8px;\n    font-size: 16px; }\n";
var styles$1U = {"root":"removableCard--removableCard__root","close":"removableCard--removableCard__close","title":"removableCard--removableCard__title","titleIcon":"removableCard--removableCard__titleIcon","wiggle":"removableCard--removableCard__wiggle","spin":"removableCard--removableCard__spin"};
styleInject(css_248z$21);

var RemovableCard =
/** @class */
function (_super) {
  __extends(RemovableCard, _super);

  function RemovableCard() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RemovableCard.prototype.render = function () {
    var _a;

    var _b = this.props,
        icon = _b.icon,
        title = _b.title,
        children = _b.children,
        onRemove = _b.onRemove,
        className = _b.className,
        otherProps = __rest(_b, ["icon", "title", "children", "onRemove", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$1U.root] = styles$1U.root, _a), className);
    return /*#__PURE__*/React.createElement(Box, __assign({
      padding: "300",
      background: "neutral.100",
      borderRadius: true
    }, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(Box, {
      as: "button",
      "aria-label": "Remove",
      className: styles$1U.close,
      onClick: onRemove
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "close"
    })), /*#__PURE__*/React.createElement(FlexBox, {
      alignItems: "flex-start",
      justifyContent: "flex-start",
      className: styles$1U.title
    }, icon && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: icon,
      className: styles$1U.titleIcon
    }), title), /*#__PURE__*/React.createElement(Box, {
      margin: "300 0 0 0"
    }), children);
  };

  return RemovableCard;
}(PureComponent);

var helper = "<script>\n  (function() {\n    var lastHeight = null;\n    var measureHeight = function() {\n      var currentHeight = document.body.offsetHeight;\n      if (currentHeight === lastHeight) return;\n      lastHeight = currentHeight;\n      window.parent.postMessage(\n        {\n          event: 'heightChange',\n          value: currentHeight,\n        },\n        '*',\n      );\n    };\n\n    document.body.style.padding = '0px';\n    document.body.style.margin = '0px';\n    document.body.style.display = 'inline-block';\n    document.body.style.width = '100%';\n    document.addEventListener('click', measureHeight);\n\n    document.querySelectorAll('a').forEach(link => {\n      link.setAttribute('target', '_blank');\n      link.setAttribute('rel', 'noopener noreferrer');\n    });\n\n    document.addEventListener('load', measureHeight, true);\n    document.addEventListener('transitionend', measureHeight, true);\n\n    new ResizeObserver(measureHeight).observe(document.body);\n\n    measureHeight();\n  })();\n</script>";

var css_248z$22 = ".sandboxIframe--sandboxIframe__frame {\n  width: 100%;\n  margin: none; }\n";
var styles$1V = {"frame":"sandboxIframe--sandboxIframe__frame"};
styleInject(css_248z$22);

var SandboxIframe =
/** @class */
function (_super) {
  __extends(SandboxIframe, _super);

  function SandboxIframe(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      iframeHeight: 0
    };
    _this.frameRef = /*#__PURE__*/React.createRef();
    _this.handlePostMessage = _this.handlePostMessage.bind(_this);
    return _this;
  }

  SandboxIframe.prototype.componentDidMount = function () {
    this.buildSandbox();
    window.addEventListener('message', this.handlePostMessage);
  };

  SandboxIframe.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        content = _a.content,
        headContent = _a.headContent;

    if (prevProps.content !== content || prevProps.headContent !== headContent) {
      this.buildSandbox();
    }
  };

  SandboxIframe.prototype.componentWillUnmount = function () {
    window.removeEventListener('message', this.handlePostMessage);
  };

  SandboxIframe.prototype.buildSandbox = function () {
    var _a = this.props,
        content = _a.content,
        _b = _a.headContent,
        headContent = _b === void 0 ? '' : _b;
    var current = this.frameRef.current;

    if (current) {
      var markup = '';

      if (content.indexOf('</body>') !== -1) {
        markup = content.replace('</body>', helper + "</body>");
      } else {
        markup = "<html><head><meta charset=\"utf-8\" /><base target=\"_parent\" />" + headContent + "</head><body>" + content + helper + "</body></html>";
      }

      current.src = "data:text/html;base64," + window.btoa(unescape(encodeURIComponent(markup)));
    }
  };

  SandboxIframe.prototype.handlePostMessage = function (event) {
    var current = this.frameRef.current;

    if (current && event.source === current.contentWindow) {
      var data = event.data;

      if (_typeof(data) === 'object' && data !== null && data.event === 'heightChange' && typeof data.value === 'number') {
        this.setState({
          iframeHeight: data.value
        });
      }
    }
  };

  SandboxIframe.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        content = _a.content,
        headContent = _a.headContent,
        sandbox = _a.sandbox,
        otherProps = __rest(_a, ["className", "content", "headContent", "sandbox"]);

    var iframeHeight = this.state.iframeHeight;
    var rootClass = classnames({}, className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("iframe", {
      title: "message",
      sandbox: sandbox !== null && sandbox !== void 0 ? sandbox : SandboxIframe.defaultSandboxParams,
      scrolling: "no",
      frameBorder: "no",
      style: {
        height: iframeHeight + "px"
      },
      className: styles$1V.frame,
      ref: this.frameRef
    }));
  };

  SandboxIframe.defaultSandboxParams = 'allow-scripts allow-popups allow-forms';
  return SandboxIframe;
}(React.PureComponent);

var css_248z$23 = "@-webkit-keyframes scrollbar--scrollbar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes scrollbar--scrollbar__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes scrollbar--scrollbar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes scrollbar--scrollbar__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.scrollbar--scrollbar__track {\n  min-width: 10px;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  position: relative;\n  border-radius: 2px 0 0 2px; }\n\n.scrollbar--scrollbar__handle {\n  width: 100%;\n  background: #e7ecf3;\n  border-radius: 4px;\n  position: absolute;\n  box-sizing: border-box; }\n";
var styles$1W = {"track":"scrollbar--scrollbar__track","handle":"scrollbar--scrollbar__handle","wiggle":"scrollbar--scrollbar__wiggle","spin":"scrollbar--scrollbar__spin"};
styleInject(css_248z$23);

var Scrollbar =
/** @class */
function (_super) {
  __extends(Scrollbar, _super);

  function Scrollbar(props) {
    var _this = _super.call(this, props) || this;

    _this.updateSize = function () {
      var container = _this.props.container;

      if (container.current) {
        var current = container.current;

        _this.setState({
          size: current.offsetHeight / current.scrollHeight,
          progress: current.scrollTop / current.scrollHeight
        });
      }
    };

    _this.state = {
      size: 0,
      progress: 0,
      offset: 0
    };
    _this.handleTrackClick = _this.handleTrackClick.bind(_this);
    _this.handleHandleClick = _this.handleHandleClick.bind(_this);
    _this.handleDrag = _this.handleDrag.bind(_this);
    _this.handleDrop = _this.handleDrop.bind(_this);
    return _this;
  }

  Scrollbar.prototype.componentDidMount = function () {
    var container = this.props.container;

    if (container.current) {
      container.current.addEventListener('scroll', this.updateSize);
    }

    window.addEventListener('resize', this.updateSize);
    this.updateSize();
  };

  Scrollbar.prototype.componentWillUnmount = function () {
    var container = this.props.container;

    if (container.current) {
      container.current.removeEventListener('scroll', this.updateSize);
    }

    window.removeEventListener('resize', this.updateSize);
  };

  Scrollbar.prototype.handleTrackClick = function (e) {
    var container = this.props.container;
    var size = this.state.size;
    this.setState({
      offset: size / 2
    });

    if (container.current) {
      var bounds = container.current.getBoundingClientRect();
      var newProgress = (e.clientY - bounds.top) / container.current.offsetHeight - size / 2;
      if (newProgress < 0) newProgress = 0;
      if (newProgress + size > 1) newProgress = 1 - size;
      container.current.scrollTop = newProgress * container.current.scrollHeight;
      window.addEventListener('mousemove', this.handleDrag);
      window.addEventListener('mouseup', this.handleDrop);
    }
  };

  Scrollbar.prototype.handleHandleClick = function (e) {
    var size = this.state.size;
    e.stopPropagation(); // Make sure the target supports getBoundingClientRect

    if (!(e.target instanceof Element)) return;
    var bounds = e.target.getBoundingClientRect();
    this.setState({
      offset: (e.clientY - bounds.top) / bounds.height * size
    });
    window.addEventListener('mousemove', this.handleDrag);
    window.addEventListener('mouseup', this.handleDrop);
  };

  Scrollbar.prototype.handleDrag = function (e) {
    e.preventDefault();
    var container = this.props.container;
    var _a = this.state,
        size = _a.size,
        offset = _a.offset;

    if (container.current) {
      var bounds = container.current.getBoundingClientRect();
      var newProgress = (e.clientY - bounds.top) / container.current.offsetHeight - offset;
      if (newProgress < 0) newProgress = 0;
      if (newProgress + size > 1) newProgress = 1 - size;
      container.current.scrollTop = newProgress * container.current.scrollHeight;
    }
  };

  Scrollbar.prototype.handleDrop = function () {
    window.removeEventListener('mousemove', this.handleDrag);
    window.removeEventListener('mouseup', this.handleDrop);
  };

  Scrollbar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        thumbClassName = _a.thumbClassName,
        trackClassName = _a.trackClassName,
        otherProps = __rest(_a, ["className", "thumbClassName", "trackClassName"]);

    var _b = this.state,
        size = _b.size,
        progress = _b.progress;
    var rootClass = classnames(className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$1W.track, trackClassName),
      onMouseDown: this.handleTrackClick
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$1W.handle, thumbClassName),
      onMouseDown: this.handleHandleClick,
      style: {
        height: size * 100 + "%",
        top: progress * 100 + "%"
      }
    })));
  };

  return Scrollbar;
}(PureComponent);

var css_248z$24 = "@-webkit-keyframes starToggle--starToggle__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes starToggle--starToggle__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes starToggle--starToggle__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes starToggle--starToggle__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.starToggle--starToggle__starToggle {\n  font-size: 14px;\n  position: relative;\n  top: 2px; }\n\n.starToggle--starToggle__favoriteIcon {\n  color: #e3e4e6; }\n  .starToggle--starToggle__favoriteIcon:hover,\n  .starToggle--starToggle__starToggleChecked .starToggle--starToggle__favoriteIcon {\n    color: #eac435; }\n";
var styles$1X = {"starToggle":"starToggle--starToggle__starToggle","favoriteIcon":"starToggle--starToggle__favoriteIcon","starToggleChecked":"starToggle--starToggle__starToggleChecked","wiggle":"starToggle--starToggle__wiggle","spin":"starToggle--starToggle__spin"};
styleInject(css_248z$24);

var StarToggle =
/** @class */
function (_super) {
  __extends(StarToggle, _super);

  function StarToggle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StarToggle.prototype.render = function () {
    var _a;

    var _b = this.props,
        checked = _b.checked,
        className = _b.className,
        onToggle = _b.onToggle,
        otherProps = __rest(_b, ["checked", "className", "onToggle"]);

    var rootClass = classnames((_a = {}, _a[styles$1X.starToggle] = true, _a[styles$1X.starToggleChecked] = checked, _a), className);
    var iconFavorited = checked ? 'star-full' : 'star';
    return /*#__PURE__*/React.createElement(Button$2, __assign({}, otherProps, {
      className: rootClass,
      transparent: true,
      onClick: onToggle
    }), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$1X.favoriteIcon,
      name: iconFavorited
    }));
  };

  return StarToggle;
}(PureComponent);

var css_248z$25 = ".tabsWithContent--tabsWithContent__container {\n  display: flex;\n  flex-wrap: wrap; }\n  .tabsWithContent--tabsWithContent__containerTop {\n    flex-direction: column; }\n  .tabsWithContent--tabsWithContent__containerLeft {\n    flex-direction: row; }\n  .tabsWithContent--tabsWithContent__containerRight {\n    flex-direction: row-reverse; }\n  .tabsWithContent--tabsWithContent__containerBottom {\n    flex-direction: column-reverse; }\n\n.tabsWithContent--tabsWithContent__childrenContainer {\n  flex: 1; }\n";
var styles$1Y = {"container":"tabsWithContent--tabsWithContent__container","containerTop":"tabsWithContent--tabsWithContent__containerTop","containerLeft":"tabsWithContent--tabsWithContent__containerLeft","containerRight":"tabsWithContent--tabsWithContent__containerRight","containerBottom":"tabsWithContent--tabsWithContent__containerBottom","childrenContainer":"tabsWithContent--tabsWithContent__childrenContainer"};
styleInject(css_248z$25);

var TabsWithContent =
/** @class */
function (_super) {
  __extends(TabsWithContent, _super);

  function TabsWithContent(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      activeTab: props.initiallySelectedTabId
    };
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    return _this;
  }

  TabsWithContent.prototype.handleTabChange = function (newActiveTab) {
    if (this.ensureTabIsValid(newActiveTab)) {
      this.setState({
        activeTab: newActiveTab
      });
    }
  };

  TabsWithContent.prototype.ensureTabIsValid = function (tabId) {
    return this.props.tabs.some(function (tab) {
      return tab.id === tabId;
    });
  };

  TabsWithContent.prototype.getActiveChildIndex = function () {
    var _this = this;

    return this.props.tabs.findIndex(function (_a) {
      var id = _a.id;
      return id === _this.state.activeTab;
    });
  };

  TabsWithContent.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        tabsClassName = _b.tabsClassName,
        tabClassName = _b.tabClassName,
        tabSelectedClassName = _b.tabSelectedClassName,
        childrenWrapperClassName = _b.childrenWrapperClassName,
        tabs = _b.tabs,
        children = _b.children,
        tabsPlacement = _b.tabsPlacement;
    var activeTab = this.state.activeTab;
    var childrenArray = React.Children.toArray(children);

    if (childrenArray.length !== tabs.length) {
      var warning = TabsWithContent.name + ": Number of tabs don't match the number of children.";
      console.warn(warning);
    }

    var activeChildIndex = this.getActiveChildIndex();

    if (activeChildIndex === -1) {
      var warning = TabsWithContent.name + ": The selected tab does not exist in tabs array!";
      console.warn(warning);
    }

    var containerClassName = classnames(className, styles$1Y.container, (_a = {}, _a[styles$1Y.containerTop] = tabsPlacement === 'top', _a[styles$1Y.containerLeft] = tabsPlacement === 'left', _a[styles$1Y.containerBottom] = tabsPlacement === 'bottom', _a[styles$1Y.containerRight] = tabsPlacement === 'right', _a));
    var childrenContainerClassName = classnames(childrenWrapperClassName, styles$1Y.childrenContainer);
    return /*#__PURE__*/React.createElement("section", {
      className: containerClassName
    }, /*#__PURE__*/React.createElement(TabsWithErrorBoundary, {
      className: tabsClassName,
      tabClassName: tabClassName,
      tabSelectedClassName: tabSelectedClassName,
      tabs: tabs,
      onChange: this.handleTabChange,
      selectedId: activeTab,
      tabsPlacement: tabsPlacement
    }), /*#__PURE__*/React.createElement("div", {
      className: childrenContainerClassName
    }, childrenArray[activeChildIndex]));
  };

  TabsWithContent.defaultProps = {
    tabsPlacement: 'top'
  };
  return TabsWithContent;
}(Component);

function fromNowOrNow(date) {
  if (Math.abs(date.diff(moment$1())) < 25000) {
    // 25 seconds before or after now
    return 'just now';
  }

  return date.fromNow();
}

var css_248z$26 = ".timestamp--timestamp__timestamp {\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  display: inline;\n  cursor: default; }\n";
var styles$1Z = {"timestamp":"timestamp--timestamp__timestamp"};
styleInject(css_248z$26);

var REFRESH_RATE = 10000;

var Timestamp =
/** @class */
function (_super) {
  __extends(Timestamp, _super);

  function Timestamp(props) {
    var _this = _super.call(this, props) || this;

    var relative = props.relative,
        counter = props.counter;
    var format = 'absolute';

    if (relative) {
      format = 'ago';
    } else if (counter) {
      format = 'counter';
    }

    _this.state = {
      format: format,
      pristine: true
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.interval = null;
    return _this;
  }

  Timestamp.prototype.componentDidMount = function () {
    var format = this.state.format;

    if (format === 'ago' || format === 'counter') {
      this.startTicker();
    }
  };

  Timestamp.prototype.componentDidUpdate = function (prevProps) {
    var relative = this.props.relative;
    var pristine = this.state.pristine;

    if (relative !== prevProps.relative && pristine) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        format: relative ? 'ago' : 'absolute'
      });
    }
  };

  Timestamp.prototype.componentWillUnmount = function () {
    this.stopTicker();
  };

  Timestamp.prototype.startTicker = function () {
    var _this = this;

    var _a;

    this.interval = setInterval(function () {
      _this.forceUpdate();
    }, (_a = this.props.refreshRate) !== null && _a !== void 0 ? _a : 0);
  };

  Timestamp.prototype.stopTicker = function () {
    if (this.interval) {
      clearInterval(this.interval);
    }
  };

  Timestamp.prototype.handleClick = function () {
    var format = this.state.format;
    this.setState({
      pristine: false
    });

    if (format === 'ago') {
      this.setState({
        format: 'full'
      });
      this.stopTicker();
    } else if (format === 'full') {
      this.setState({
        format: 'absolute'
      });
    } else if (format === 'absolute') {
      this.setState({
        format: 'ago'
      });
      this.startTicker();
    }
  };

  Timestamp.prototype.getTimeString = function () {
    var _a, _b, _c;

    var time = this.props.time;
    var _d = this.props,
        isSecondsDisplayed = _d.isSecondsDisplayed,
        customFormatters = _d.customFormatters;
    var format = this.state.format;
    var timeString = '';

    if (typeof time === 'number') {
      var date = new Date();
      date.setTime(time * 1000);
      time = date;
    }

    if (format === 'counter') {
      var start = moment$1(time).utc();
      var end = moment$1().utc();
      var diff = end.diff(start) / 1000;
      var diffHours = Math.floor(diff / (60 * 60));
      var diffDays = Math.floor(diffHours / 24);
      var diffHoursRemaining = diffHours % 24;
      var diffHoursInSeconds = diffHours * 60 * 60;
      var diffMinutes = Math.floor((diff - diffHoursInSeconds) / 60);
      var diffMinutesInSeconds = diffMinutes * 60;
      var diffSeconds = Math.floor(diff - diffHoursInSeconds - diffMinutesInSeconds);
      timeString = [diffHoursRemaining.toString().padStart(2, '0'), diffMinutes.toString().padStart(2, '0'), diffSeconds.toString().padStart(2, '0')].join(':');

      if (diffDays > 0) {
        timeString = diffDays + " " + (diffDays === 1 ? 'DAY' : 'DAYS') + " " + timeString;
      }
    } else if (format === 'full') {
      var utcMomentTime = moment$1(time).utc();
      var formatString = (_a = customFormatters === null || customFormatters === void 0 ? void 0 : customFormatters.full) !== null && _a !== void 0 ? _a : isSecondsDisplayed ? 'MMM Do YYYY, h:mm:ss A' : 'lll';
      timeString = utcMomentTime.local().format(formatString);
    } else if (format === 'absolute') {
      if (moment$1().diff(moment$1(time), 'hours') > 12) {
        var utcMomentTime = moment$1(time).utc();
        var formatString = (_b = customFormatters === null || customFormatters === void 0 ? void 0 : customFormatters.absolute) !== null && _b !== void 0 ? _b : "D MMMM LT" + (isSecondsDisplayed ? 'S' : '');
        timeString = utcMomentTime.local().format(formatString);
      } else {
        var formatString = (_c = customFormatters === null || customFormatters === void 0 ? void 0 : customFormatters.absolute) !== null && _c !== void 0 ? _c : "LT" + (isSecondsDisplayed ? 'S' : '');
        timeString = moment$1(time).utc().local().format(formatString);
      }
    } else {
      timeString = fromNowOrNow(moment$1(time));
    }

    return timeString;
  };

  Timestamp.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        relative = _b.relative,
        time = _b.time,
        refreshRate = _b.refreshRate,
        otherProps = __rest(_b, ["className", "relative", "time", "refreshRate"]);

    var rootClass = classnames((_a = {}, _a[styles$1Z.timestamp] = true, _a), className);
    return /*#__PURE__*/React.createElement("span", __assign({}, otherProps, buttonize(this.handleClick), {
      className: rootClass
    }), this.getTimeString());
  };

  Timestamp.defaultProps = {
    refreshRate: REFRESH_RATE
  };
  return Timestamp;
}(Component);

var css_248z$27 = "@-webkit-keyframes token--token__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes token--token__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes token--token__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes token--token__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.token--token__root {\n  position: relative;\n  display: inline-flex; }\n\n.token--token__select {\n  position: absolute;\n  width: 100%;\n  margin: 0;\n  left: 0;\n  height: 100%;\n  outline: none;\n  opacity: 0; }\n\n.token--token__label {\n  height: 22px;\n  display: flex;\n  border-radius: 5px;\n  background: #f7f7f7;\n  padding-left: 8px;\n  color: #9b9b9b;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 22px;\n  align-items: center; }\n  .token--token__rootReadonly .token--token__label {\n    padding-right: 8px; }\n  .token--token__rootPrimary .token--token__label {\n    color: #9a8ee8;\n    background: rgba(86, 68, 216, 0.3); }\n  .token--token__rootWithError .token--token__label {\n    color: #ffffff;\n    background: #c83c3c; }\n\n.token--token__value {\n  font-weight: 600;\n  color: #393939;\n  margin-left: 5px; }\n  .token--token__rootPrimary .token--token__value {\n    color: #3f329d; }\n  .token--token__rootWithError .token--token__value {\n    color: #ffffff; }\n\n.token--token__icon {\n  display: flex;\n  align-items: center; }\n";
var styles$1_ = {"root":"token--token__root","select":"token--token__select","label":"token--token__label","rootReadonly":"token--token__rootReadonly","rootPrimary":"token--token__rootPrimary","rootWithError":"token--token__rootWithError","value":"token--token__value","icon":"token--token__icon","wiggle":"token--token__wiggle","spin":"token--token__spin"};
styleInject(css_248z$27);

var Token =
/** @class */
function (_super) {
  __extends(Token, _super);

  function Token() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Token.prototype.render = function () {
    var _a;

    var _b = this.props,
        onDelete = _b.onDelete,
        id = _b.id,
        label = _b.label,
        options = _b.options,
        valueLabel = _b.valueLabel,
        primary = _b.primary,
        input = _b.input,
        meta = _b.meta,
        defaultOption = _b.defaultOption,
        className = _b.className,
        otherProps = __rest(_b, ["onDelete", "id", "label", "options", "valueLabel", "primary", "input", "meta", "defaultOption", "className"]);

    var rootClass = classnames((_a = {}, _a[styles$1_.root] = true, _a[styles$1_.rootPrimary] = primary, _a[styles$1_.rootWithError] = meta === null || meta === void 0 ? void 0 : meta.error, _a[styles$1_.rootReadonly] = !options && !onDelete, _a), className);
    var currentLabel = valueLabel;

    if (!currentLabel && input && options && options.length) {
      var match = options.filter(function (_a) {
        var value = _a.value;
        return input.value === value;
      });

      if (match.length) {
        currentLabel = match[0].label;
      }
    }

    if (!currentLabel && defaultOption) {
      currentLabel = defaultOption;
    }

    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), !!options && /*#__PURE__*/React.createElement("select", __assign({}, input, {
      className: styles$1_.select,
      id: id
    }), !!defaultOption && /*#__PURE__*/React.createElement("option", {
      disabled: true,
      hidden: true,
      value: ""
    }, defaultOption), options.map(function (option) {
      var _a;

      return /*#__PURE__*/React.createElement("option", {
        key: (_a = option.value) === null || _a === void 0 ? void 0 : _a.toString(),
        value: option.value
      }, option.label);
    })), /*#__PURE__*/React.createElement("label", {
      className: styles$1_.label,
      htmlFor: id
    }, label, /*#__PURE__*/React.createElement("span", {
      className: styles$1_.value
    }, currentLabel), !!options && /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$1_.icon,
      name: "angle-down"
    }), !!onDelete && /*#__PURE__*/React.createElement("span", __assign({}, buttonize(onDelete)), /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      className: styles$1_.icon,
      name: "close",
      onClick: onDelete
    }))));
  };

  return Token;
}(PureComponent);

var css_248z$28 = "@-webkit-keyframes tokenInput--tokenInput__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes tokenInput--tokenInput__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes tokenInput--tokenInput__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes tokenInput--tokenInput__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.tokenInput--tokenInput__root {\n  /*! keep */ }\n  .tokenInput--tokenInput__rootInput {\n    /*! keep */ }\n\n.tokenInput--tokenInput__wrapper {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: 6px;\n  width: 100%; }\n  .tokenInput--tokenInput__rootFocus .tokenInput--tokenInput__wrapper {\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3); }\n\n.tokenInput--tokenInput__input {\n  flex: 1;\n  border: 1px solid #e3e4e6;\n  background-color: #fff;\n  font-size: 14px;\n  line-height: 36px;\n  border-radius: 6px 0 0 6px;\n  height: 40px;\n  padding: 0 8px;\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative; }\n  .tokenInput--tokenInput__rootFocus .tokenInput--tokenInput__input {\n    border-color: #5644d8 #e3e4e6 #5644d8 #5644d8; }\n  .tokenInput--tokenInput__rootTextarea .tokenInput--tokenInput__input {\n    border-radius: 6px;\n    height: 220px;\n    line-height: 28px;\n    padding-right: 24px; }\n\n.tokenInput--tokenInput__inputInner {\n  white-space: nowrap;\n  overflow-y: hidden;\n  overflow-x: scroll;\n  height: 40px;\n  padding-bottom: 17px;\n  box-sizing: content-box;\n  width: 100%;\n  outline: none; }\n  .tokenInput--tokenInput__rootTextarea .tokenInput--tokenInput__inputInner {\n    height: 220px;\n    padding-bottom: 0;\n    white-space: pre; }\n\n.tokenInput--tokenInput__placeholder {\n  position: absolute;\n  left: 8px;\n  top: 0;\n  pointer-events: none;\n  color: #bbb;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.tokenInput--tokenInput__token {\n  font-size: 11px;\n  font-weight: bold;\n  color: #fff;\n  background: #5644d8;\n  border-radius: 6px;\n  line-height: 24px;\n  display: inline-block;\n  padding: 0 8px;\n  margin: 0 1px; }\n\n.tokenInput--tokenInput__rootTextarea .tokenInput--tokenInput__dropdownSelect {\n  position: absolute;\n  top: 1px;\n  right: 1px; }\n\n.tokenInput--tokenInput__addButton {\n  border: 1px solid #e3e4e6;\n  border-left: 0;\n  border-radius: 0 6px 6px 0;\n  width: 32px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #5a5a5a; }\n  .tokenInput--tokenInput__addButton:focus {\n    border-color: #5644d8;\n    box-shadow: 0 0 0 3px rgba(86, 68, 216, 0.3);\n    outline: none; }\n  .tokenInput--tokenInput__rootFocus .tokenInput--tokenInput__addButton {\n    border-color: #5644d8 #5644d8 #5644d8 #e3e4e6; }\n  .tokenInput--tokenInput__rootTextarea .tokenInput--tokenInput__addButton {\n    border: none;\n    border-radius: 0 6px 0 6px;\n    width: 33px;\n    padding-left: 8px;\n    background-color: transparent; }\n  .tokenInput--tokenInput__rootTextarea .tokenInput--tokenInput__addButton:focus {\n    border-color: none;\n    box-shadow: none;\n    outline: none; }\n";
var styles$1$ = {"root":"tokenInput--tokenInput__root","rootInput":"tokenInput--tokenInput__rootInput","wrapper":"tokenInput--tokenInput__wrapper","rootFocus":"tokenInput--tokenInput__rootFocus","input":"tokenInput--tokenInput__input","rootTextarea":"tokenInput--tokenInput__rootTextarea","inputInner":"tokenInput--tokenInput__inputInner","placeholder":"tokenInput--tokenInput__placeholder","token":"tokenInput--tokenInput__token","dropdownSelect":"tokenInput--tokenInput__dropdownSelect","addButton":"tokenInput--tokenInput__addButton","wiggle":"tokenInput--tokenInput__wiggle","spin":"tokenInput--tokenInput__spin"};
styleInject(css_248z$28);

function handlePaste(e) {
  e.preventDefault();
  var clipboardData = e.clipboardData;
  if (!clipboardData) return;
  var text = clipboardData.getData('text/plain');
  document.execCommand('insertHTML', false, text);
}

var TokenInput =
/** @class */
function (_super) {
  __extends(TokenInput, _super);

  function TokenInput(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      hasFocus: false,
      lastSelection: null,
      isEmpty: props.input.value.length === 0
    };
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.handleInput = _this.handleInput.bind(_this);
    _this.addToken = _this.addToken.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  TokenInput.prototype.componentDidMount = function () {
    var _a = this.props,
        value = _a.input.value,
        variables = _a.variables;
    var current = this.inputRef.current;

    if (current) {
      var flattenedVariableNames_1 = variables.reduce(function (prev, category) {
        return prev.concat(category.items.map(function (item) {
          return {
            name: item.name,
            prettyName: item.content
          };
        }));
      }, []);
      current.innerHTML = value.replace(/{{([^:]*:)?([^}]+)}}/g, function (group, scope, variableName) {
        if (scope === void 0) {
          scope = '';
        }

        if (variableName === void 0) {
          variableName = '';
        }

        var completeMatch = scope + variableName;
        var nameMatch = flattenedVariableNames_1.find(function (vName) {
          return vName.name === completeMatch;
        });

        if (nameMatch) {
          return "<span class=\"" + styles$1$.token + "\" data-token=\"" + completeMatch + "\" contenteditable=\"false\">" + nameMatch.prettyName + "</span>";
        }

        return group;
      });
    }
  };

  TokenInput.prototype.addToken = function (name, label) {
    var _a = this.state,
        hasFocus = _a.hasFocus,
        lastSelection = _a.lastSelection;

    if (!hasFocus) {
      var current = this.inputRef.current;

      if (current) {
        if (lastSelection) {
          var selection = window.getSelection();
          if (selection === null) return;
          selection.removeAllRanges();
          selection.addRange(lastSelection);
        } else {
          current.focus();
        }
      }
    }

    document.execCommand('insertHTML', false, "<span class=\"" + styles$1$.token + "\" data-token=\"" + name + "\" contenteditable=\"false\">" + label + "</span>");
  };

  TokenInput.prototype.handleFocus = function () {
    this.setState({
      hasFocus: true
    });
  };

  TokenInput.prototype.handleBlur = function () {
    var selection = window.getSelection();
    this.setState({
      hasFocus: false,
      lastSelection: selection ? selection.getRangeAt(0) : null
    });
  };

  TokenInput.prototype.handleKeyDown = function (e) {
    var mode = this.props.mode;

    if (_default$4('mod+b', e) || _default$4('mod+i', e)) {
      e.preventDefault();
    } else if (e.key === 'Enter') {
      e.preventDefault();

      if (mode === 'textarea') {
        document.execCommand('insertHTML', false, '<br data-token-br />');
      }
    }
  };

  TokenInput.prototype.renderNodeToString = function (root) {
    var _this = this;

    var text = '';
    root.childNodes.forEach(function (node) {
      if (node instanceof HTMLElement && node.hasAttribute('data-token')) {
        var tokenName = node.getAttribute('data-token');
        text += "{{" + (tokenName || '') + "}}";
      } else if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLBRElement) {
        text += '\n';
      } else if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
        if (!(node instanceof HTMLSpanElement)) {
          text += '\n';
        }

        text += _this.renderNodeToString(node);
      } else {
        text += node.nodeValue;
      }
    });
    return text;
  };

  TokenInput.prototype.fixHTML = function (root) {
    /*
      Chrome execCommand on Chrome insert an extra span,
      with className styles resolved to inline styles,
      we don't want that element to appear, so we remove it
    */
    root.querySelectorAll('[style]').forEach(function (el) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
  };

  TokenInput.prototype.handleInput = function () {
    var onChange = this.props.input.onChange;
    var text = '';
    var current = this.inputRef.current;

    if (current) {
      this.fixHTML(current);
      text = this.renderNodeToString(current).replace(/<br data-token-br \/>/g, '\n');
      onChange(text);
      this.setState({
        isEmpty: text.length === 0
      });
    }
  };

  TokenInput.prototype.hasError = function () {
    var meta = this.props.meta;

    if (meta === null || meta === void 0 ? void 0 : meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }

    return false;
  };

  TokenInput.prototype.getErrorMessage = function () {
    if (this.hasError()) {
      var meta = this.props.meta;
      return meta === null || meta === void 0 ? void 0 : meta.error;
    }

    return undefined;
  };

  TokenInput.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        variables = _b.variables,
        placeholder = _b.placeholder,
        label = _b.label,
        input = _b.input,
        meta = _b.meta,
        inputClassName = _b.inputClassName,
        inputStyle = _b.inputStyle,
        mode = _b.mode,
        otherProps = __rest(_b, ["className", "variables", "placeholder", "label", "input", "meta", "inputClassName", "inputStyle", "mode"]);

    var _c = this.state,
        hasFocus = _c.hasFocus,
        isEmpty = _c.isEmpty;
    var rootClass = classnames((_a = {}, _a[styles$1$.root] = true, _a[styles$1$.rootFocus] = hasFocus, _a[styles$1$.rootInput] = mode === 'input', _a[styles$1$.rootTextarea] = mode === 'textarea', _a), className);
    var inputInnerClassName = classnames(styles$1$.inputInner, inputClassName);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), /*#__PURE__*/React.createElement(HelperField, {
      label: label,
      errorMessage: this.getErrorMessage(),
      fieldId: input.name
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1$.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1$.input
    }, /*#__PURE__*/React.createElement("div", {
      style: inputStyle,
      id: "input",
      className: inputInnerClassName,
      contentEditable: true,
      onKeyDown: this.handleKeyDown,
      onInput: this.handleInput,
      onPaste: handlePaste,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      ref: this.inputRef,
      role: "textbox",
      tabIndex: 0
    }), isEmpty && !!placeholder && /*#__PURE__*/React.createElement("span", {
      className: styles$1$.placeholder
    }, placeholder)), /*#__PURE__*/React.createElement(VariableSelector, {
      onSelect: this.addToken,
      variables: variables,
      className: styles$1$.dropdownSelect
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: styles$1$.addButton
    }, /*#__PURE__*/React.createElement(IconWithErrorBoundary, {
      name: "dropdown-list",
      className: "icon-vertical-fix"
    }))))));
  };

  TokenInput.defaultProps = {
    mode: 'input'
  };
  return TokenInput;
}(PureComponent);

var css_248z$29 = "@-webkit-keyframes variableToken--variableToken__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes variableToken--variableToken__wiggle {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0); }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes variableToken--variableToken__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes variableToken--variableToken__spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n/*\n  Do not edit directly\n  Generated on Wed, 02 Dec 2020 11:29:56 GMT\n*/\n.variableToken--variableToken__root {\n  background-color: #5644d8;\n  border: 0;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 24px;\n  border-radius: 6px;\n  height: 24px;\n  padding: 0 8px;\n  display: inline-block;\n  outline: 0;\n  transition: background-color 80ms ease-in; }\n  .variableToken--variableToken__rootInactive {\n    background-color: #7a7a7a; }\n";
var styles$20 = {"root":"variableToken--variableToken__root","rootInactive":"variableToken--variableToken__rootInactive","wiggle":"variableToken--variableToken__wiggle","spin":"variableToken--variableToken__spin"};
styleInject(css_248z$29);

var VariableTokenColor;

(function (VariableTokenColor) {
  VariableTokenColor["DEFAULT"] = "DEFAULT";
  VariableTokenColor["INACTIVE"] = "INACTIVE";
})(VariableTokenColor || (VariableTokenColor = {}));

var VariableToken =
/** @class */
function (_super) {
  __extends(VariableToken, _super);

  function VariableToken() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  VariableToken.prototype.render = function () {
    var _a;

    var _b = this.props,
        text = _b.text,
        className = _b.className,
        color = _b.color,
        otherProps = __rest(_b, ["text", "className", "color"]);

    var rootClass = classnames((_a = {}, _a[styles$20.root] = styles$20.root, _a[styles$20.rootInactive] = color === VariableTokenColor.INACTIVE, _a), className);
    return /*#__PURE__*/React.createElement("div", __assign({}, otherProps, {
      className: rootClass
    }), text);
  };

  return VariableToken;
}(React.PureComponent);
VariableToken.defaultProps = {
  color: VariableTokenColor.DEFAULT
};

export { Address, Attachment, AvatarWithErrorBoundary as Avatar, AvatarSelectItem, Badge, BodyPortal, Box, Button$2 as Button, ButtonGroup, ButtonList, CheckableAvatarSelectItem, CheckableBaseItem, CheckableSelectItem, CheckableTagSelectItem, Checkbox, CollapseCardWithErrorBoundary as CollapseCard, Collapsible, CopyToClipboard, DataTable, DataTableIcon, DataTableTimestamp, DatePicker, DateRangePicker, DeselectItem, Dialer, Divider, DonutChart, Dropdown, DropdownButton, DropdownButtonContext, DropdownInfinite, DropdownItem, DropdownSelect, DropdownSelectContainer, DropdownSelectMultiple, emojis$1 as EMOJIS, EmojiPicker, Empty, EmptySelectItem, ErrorBoundary, ErrorBoundaryContext, FieldEditor, FieldInteger, FieldRichText, FieldSelect, FieldSelectNew, FieldSlider, FieldSwitch, FieldText, FieldTextV2, FieldTextarea, FieldTextareaV2, FieldToken, FlexBox, HelpIcon, HelperField, IconWithErrorBoundary as Icon, IconButton$1 as IconButton, Image, InfoList, InputText, Lightbox, LinkList, List, ListWithErrorBoundary as ListV2, MediaPlayer, Modal, ModalBody, ModalFoot, ModalHead, Radio, RangeSlider, RemovableCard, RoundButton, SANITIZE_PROFILE, SandboxIframe, Scrollbar, SelectWithErrorBoundary as Select, SelectItem, Spinner, StarToggle, Switch, Table, TabsWithErrorBoundary as Tabs, TabsWithContent, Tag, TagDeselectItem, TagSelectItem, TagSelectSuggestion, Text, Textarea, Timestamp, Token, TokenInput, Tooltip, VariableSelector, VariableToken, VariableTokenColor, addSvgIconsToDocument, datepickerDisableWeekends, withErrorBoundary };
//# sourceMappingURL=index.es.js.map
